
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("hJ95b", function(module, exports) {
$parcel$export(module.exports, "PortalAutoformattingProvider", () => $c57255a68278d5c3$export$616fb7ca02d84650);

var $kUtMt = parcelRequire("kUtMt");

var $9uL9A = parcelRequire("9uL9A");
class $c57255a68278d5c3$export$616fb7ca02d84650 {
    getRules() {
        return Promise.resolve({
            '([A-Z][A-Z0-9_]+-\\d+)': async (match)=>{
                const issueKey = match[1];
                const canViewRequestInPortal = await (0, $kUtMt.canViewRequest)(issueKey);
                if (canViewRequestInPortal) return {
                    type: 'inlineCard',
                    attrs: {
                        url: (0, $9uL9A.getSmartCardUrl)(issueKey)
                    }
                };
                return {
                    type: 'text',
                    text: issueKey
                };
            }
        });
    }
}

});
parcelRegister("9uL9A", function(module, exports) {
$parcel$export(module.exports, "getSmartCardUrl", () => $5aeec18bf88007e7$export$cd8f14895d45bc97);
$parcel$export(module.exports, "PortalCardProviderNew", () => $5aeec18bf88007e7$export$60741e4944d9eec0);

var $hQsq7 = parcelRequire("hQsq7");

var $gYDJY = parcelRequire("gYDJY");

var $oORS9 = parcelRequire("oORS9");

var $kUtMt = parcelRequire("kUtMt");
const $5aeec18bf88007e7$export$cd8f14895d45bc97 = (issueKey)=>{
    return `${(0, $gYDJY.origin)()}/browse/${issueKey}`;
};
class $5aeec18bf88007e7$export$60741e4944d9eec0 extends (0, $hQsq7.EditorCardProvider) {
    async resolve(url, appearance) {
        const issueKey = (0, $oORS9.parseIssueKeyFromUrl)(url);
        if (issueKey === null) return super.resolve(url, appearance, false);
        return (0, $kUtMt.canViewRequest)(issueKey).then((canViewRequestInPortal)=>{
            if (canViewRequestInPortal) return super.resolve($5aeec18bf88007e7$export$cd8f14895d45bc97(issueKey), appearance, false);
            return Promise.reject();
        });
    }
}

});


parcelRegister("e82zF", function(module, exports) {
$parcel$export(module.exports, "MediaWrapper", () => $18122a35b004b964$export$542000db99cecf28);

var $bSJIT = parcelRequire("bSJIT");

var $35T7J = parcelRequire("35T7J");
const $18122a35b004b964$export$542000db99cecf28 = ({ children: children, mediaOptions: mediaOptions })=>{
    const [mediaConfig, setMediaConfig] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState();
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        if (mediaOptions !== null && mediaOptions !== void 0 && mediaOptions.provider) // eslint-disable-next-line @typescript-eslint/no-empty-function
        mediaOptions.provider.then(setMediaConfig).catch(()=>{});
    }, [
        mediaOptions
    ]);
    if (!mediaConfig) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $35T7J.MediaClientProvider), {
        clientConfig: {
            ...mediaConfig,
            authProvider: mediaConfig.viewMediaClientConfig.authProvider
        }
    }, children);
};

});

parcelRegister("aKY64", function(module, exports) {
$parcel$export(module.exports, "default", () => $569c0b1a79a038cb$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $b2855 = parcelRequire("b2855");

var $fXvT2 = parcelRequire("fXvT2");

var $l7wiA = parcelRequire("l7wiA");
function $569c0b1a79a038cb$export$2e2bcd8739ae039({ props: props, initialPluginConfiguration: initialPluginConfiguration }) {
    const previousEditorProps = (0, $b2855.default)(props);
    const [preset, setPreset] = (0, $bSJIT.useState)(()=>(0, $fXvT2.createUniversalPreset)({
            props: props,
            prevProps: previousEditorProps,
            initialPluginConfiguration: initialPluginConfiguration
        }));
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (!previousEditorProps) return;
        const recreate = (0, $l7wiA.shouldRecreatePreset)(previousEditorProps, props);
        if (!recreate) return;
        // we are not comparing the previous initialPluginConfiguration to the new one assuming that it never changes
        setPreset((0, $fXvT2.createUniversalPreset)({
            props: props,
            prevProps: previousEditorProps,
            initialPluginConfiguration: initialPluginConfiguration
        }));
    }, [
        props,
        previousEditorProps,
        initialPluginConfiguration
    ]);
    return preset;
}

});
parcelRegister("fXvT2", function(module, exports) {
$parcel$export(module.exports, "createUniversalPreset", () => $cbebdd1d0a5ab9fd$export$28b0115d03e9c7ad);

var $lgWKS = parcelRequire("lgWKS");

var $8dHy3 = parcelRequire("8dHy3");

var $aKiAv = parcelRequire("aKiAv");
function $cbebdd1d0a5ab9fd$export$28b0115d03e9c7ad({ props: props, prevProps: prevProps, initialPluginConfiguration: initialPluginConfiguration }) {
    return (0, $lgWKS.default)({
        appearance: props.appearance,
        props: (0, $aKiAv.getDefaultPresetOptionsFromEditorProps)(props),
        initialPluginConfiguration: initialPluginConfiguration,
        featureFlags: (0, $8dHy3.createFeatureFlagsFromProps)(props.featureFlags),
        prevAppearance: prevProps === null || prevProps === void 0 ? void 0 : prevProps.appearance
    });
}

});
parcelRegister("lgWKS", function(module, exports) {
$parcel$export(module.exports, "default", () => $692eb609aa624563$export$2e2bcd8739ae039);

var $ahwoz = parcelRequire("ahwoz");

var $i1MIo = parcelRequire("i1MIo");

var $fY1MC = parcelRequire("fY1MC");

var $8Vhvu = parcelRequire("8Vhvu");

var $94lAC = parcelRequire("94lAC");

var $cFpoi = parcelRequire("cFpoi");

var $5aFsj = parcelRequire("5aFsj");

var $Pnwhj = parcelRequire("Pnwhj");

var $kC031 = parcelRequire("kC031");

var $4JZqr = parcelRequire("4JZqr");

var $cqHz4 = parcelRequire("cqHz4");

var $7kMXC = parcelRequire("7kMXC");

var $5dk2T = parcelRequire("5dk2T");

var $fjZzq = parcelRequire("fjZzq");

var $4waKk = parcelRequire("4waKk");

var $3qzLE = parcelRequire("3qzLE");

var $aKIKQ = parcelRequire("aKIKQ");

var $eDSd4 = parcelRequire("eDSd4");

var $8JT0u = parcelRequire("8JT0u");

var $6qDmb = parcelRequire("6qDmb");

var $d2wYX = parcelRequire("d2wYX");

var $9cRNW = parcelRequire("9cRNW");

var $55DT5 = parcelRequire("55DT5");

var $xmbbY = parcelRequire("xmbbY");

var $fKhmN = parcelRequire("fKhmN");

var $f0BVc = parcelRequire("f0BVc");

var $6UqI6 = parcelRequire("6UqI6");

var $6HB5K = parcelRequire("6HB5K");

var $9QU20 = parcelRequire("9QU20");

var $b4WtV = parcelRequire("b4WtV");

var $7grHk = parcelRequire("7grHk");

var $dBFcf = parcelRequire("dBFcf");

var $7vpIc = parcelRequire("7vpIc");

var $jYlNA = parcelRequire("jYlNA");

var $k8aAi = parcelRequire("k8aAi");

var $ehQm8 = parcelRequire("ehQm8");

var $48IYX = parcelRequire("48IYX");

var $cgJ2k = parcelRequire("cgJ2k");

var $MnZIx = parcelRequire("MnZIx");

var $eN2ur = parcelRequire("eN2ur");

var $ibifS = parcelRequire("ibifS");

var $bvogh = parcelRequire("bvogh");

var $dlEm0 = parcelRequire("dlEm0");

var $4qdNU = parcelRequire("4qdNU");

var $cr77I = parcelRequire("cr77I");

var $laPqb = parcelRequire("laPqb");

var $aRfwQ = parcelRequire("aRfwQ");

var $jvVVo = parcelRequire("jvVVo");

var $k9QlD = parcelRequire("k9QlD");

var $5oN7k = parcelRequire("5oN7k");

var $5CCIk = parcelRequire("5CCIk");

var $8f72W = parcelRequire("8f72W");
function $692eb609aa624563$export$2e2bcd8739ae039({ appearance: appearance, props: props, featureFlags: featureFlags, initialPluginConfiguration: initialPluginConfiguration, prevAppearance: prevAppearance, createAnalyticsEvent: createAnalyticsEvent }) {
    var _initialPluginConfigu, _initialPluginConfigu2, _initialPluginConfigu3, _initialPluginConfigu4, _initialPluginConfigu5, _initialPluginConfigu6, _initialPluginConfigu7, _initialPluginConfigu8, _props$media, _props$media2, _props$media3, _props$media4, _props$media5, _props$media6, _props$media7, _props$mention, _props$mention2, _props$mention3, _props$mention4, _props$collabEdit, _props$linking, _props$linking2, _props$linking3, _props$primaryToolbar;
    const isComment = appearance === 'comment';
    const isChromeless = appearance === 'chromeless';
    const isFullPage = (0, $5oN7k.isFullPage)(appearance);
    const getEditorFeatureFlags = ()=>featureFlags;
    const defaultPreset = (0, $8f72W.createDefaultPreset)({
        ...props,
        blockType: {
            ...props.blockType,
            ...initialPluginConfiguration === null || initialPluginConfiguration === void 0 ? void 0 : initialPluginConfiguration.blockTypePlugin
        },
        blockMenu: {
            enabled: (initialPluginConfiguration === null || initialPluginConfiguration === void 0 || (_initialPluginConfigu = initialPluginConfiguration.blockMenuPlugin) === null || _initialPluginConfigu === void 0 ? void 0 : _initialPluginConfigu.enabled) ?? false,
            useStandardNodeWidth: (initialPluginConfiguration === null || initialPluginConfiguration === void 0 || (_initialPluginConfigu2 = initialPluginConfiguration.blockMenuPlugin) === null || _initialPluginConfigu2 === void 0 ? void 0 : _initialPluginConfigu2.useStandardNodeWidth) ?? false,
            blockLinkHashPrefix: initialPluginConfiguration === null || initialPluginConfiguration === void 0 || (_initialPluginConfigu3 = initialPluginConfiguration.blockMenuPlugin) === null || _initialPluginConfigu3 === void 0 ? void 0 : _initialPluginConfigu3.blockLinkHashPrefix,
            getLinkPath: initialPluginConfiguration === null || initialPluginConfiguration === void 0 || (_initialPluginConfigu4 = initialPluginConfiguration.blockMenuPlugin) === null || _initialPluginConfigu4 === void 0 ? void 0 : _initialPluginConfigu4.getLinkPath,
            enableCopyLinkToSelection: initialPluginConfiguration === null || initialPluginConfiguration === void 0 || (_initialPluginConfigu5 = initialPluginConfiguration.blockMenuPlugin) === null || _initialPluginConfigu5 === void 0 ? void 0 : _initialPluginConfigu5.enableCopyLinkToSelection
        },
        appearance: appearance,
        createAnalyticsEvent: createAnalyticsEvent,
        hyperlinkOptions: {
            lpLinkPicker: featureFlags.lpLinkPicker ?? false,
            ...props.hyperlinkOptions
        },
        __livePage: props.__livePage,
        quickInsert: {
            ...props.quickInsert,
            ...initialPluginConfiguration === null || initialPluginConfiguration === void 0 ? void 0 : initialPluginConfiguration.quickInsertPlugin
        },
        toolbar: initialPluginConfiguration === null || initialPluginConfiguration === void 0 ? void 0 : initialPluginConfiguration.toolbarPlugin
    });
    const statusMenuDisabled = !props.allowStatus ? true : typeof props.allowStatus === 'object' ? Boolean(props.allowStatus.menuDisabled) : false;
    const hasBeforePrimaryToolbar = (components)=>{
        if (components && 'before' in components) return !!components.before;
        return false;
    };
    const finalPreset = defaultPreset.add((0, $k9QlD.ufoPlugin)).add((0, $aKIKQ.dataConsumerPlugin)).add((0, $i1MIo.accessibilityUtilsPlugin)).add((0, $fjZzq.contentInsertionPlugin)).add((0, $cFpoi.batchAttributeUpdatesPlugin)).maybeAdd([
        (0, $Pnwhj.blockControlsPlugin),
        {
            ...(initialPluginConfiguration === null || initialPluginConfiguration === void 0 || (_initialPluginConfigu6 = initialPluginConfiguration.blockControlsPlugin) === null || _initialPluginConfigu6 === void 0 ? void 0 : _initialPluginConfigu6.quickInsertButtonEnabled) !== undefined ? {
                quickInsertButtonEnabled: initialPluginConfiguration.blockControlsPlugin.quickInsertButtonEnabled
            } : {},
            rightSideControlsEnabled: (initialPluginConfiguration === null || initialPluginConfiguration === void 0 || (_initialPluginConfigu7 = initialPluginConfiguration.blockControlsPlugin) === null || _initialPluginConfigu7 === void 0 ? void 0 : _initialPluginConfigu7.rightSideControlsEnabled) ?? false
        }
    ], Boolean((initialPluginConfiguration === null || initialPluginConfiguration === void 0 || (_initialPluginConfigu8 = initialPluginConfiguration.blockControlsPlugin) === null || _initialPluginConfigu8 === void 0 ? void 0 : _initialPluginConfigu8.enabled) ?? false)).maybeAdd([
        (0, $4JZqr.breakoutPlugin),
        {
            allowBreakoutButton: appearance === 'full-page',
            appearance: appearance
        }
    ], Boolean(props.allowBreakout && (isFullPage || appearance === 'max'))).maybeAdd((0, $fY1MC.alignmentPlugin), Boolean(props.allowTextAlignment)).maybeAdd([
        (0, $aRfwQ.textColorPlugin),
        props.allowTextColor
    ], Boolean(props.allowTextColor)).add((0, $dBFcf.listPlugin)).maybeAdd((0, $eN2ur.rulePlugin), Boolean(props.allowRule)).maybeAdd([
        (0, $6qDmb.expandPlugin),
        {
            allowInsertion: $692eb609aa624563$export$a9b5e68d7107c3df(props),
            useLongPressSelection: false,
            appearance: appearance,
            allowInteractiveExpand: typeof props.allowExpand === 'boolean' ? props.allowExpand : Boolean(props.allowExpand && props.allowExpand.allowInteractiveExpand !== false),
            __livePage: props.__livePage
        }
    ], Boolean(props.allowExpand)).maybeAdd((0, $f0BVc.guidelinePlugin), Boolean(!isComment && !isChromeless && (props.media || props.allowTables) || props.allowExpand || props.allowLayouts || props.codeBlock)).maybeAdd([
        (0, $fKhmN.gridPlugin),
        {
            shouldCalcBreakoutGridLines: isFullPage
        }
    ], Boolean(props.media)).maybeAdd([
        (0, $8Vhvu.annotationPlugin),
        props.annotationProviders
    ], Boolean(props.annotationProviders)).maybeAdd([
        (0, $jYlNA.mediaPlugin),
        {
            ...props.media,
            allowLazyLoading: true,
            allowBreakoutSnapPoints: isFullPage,
            allowAdvancedToolBarOptions: typeof ((_props$media = props.media) === null || _props$media === void 0 ? void 0 : _props$media.allowAdvancedToolBarOptions) !== 'undefined' ? (_props$media2 = props.media) === null || _props$media2 === void 0 ? void 0 : _props$media2.allowAdvancedToolBarOptions : isFullPage || isComment,
            allowCommentsOnMedia: isFullPage && Boolean(props.annotationProviders),
            allowDropzoneDropLine: isFullPage,
            allowMediaSingleEditable: true,
            allowRemoteDimensionsFetch: true,
            allowMarkingUploadsAsIncomplete: false,
            allowImagePreview: typeof ((_props$media3 = props.media) === null || _props$media3 === void 0 ? void 0 : _props$media3.allowImagePreview) !== 'undefined' ? (_props$media4 = props.media) === null || _props$media4 === void 0 ? void 0 : _props$media4.allowImagePreview : isFullPage,
            fullWidthEnabled: appearance === 'full-width',
            editorAppearance: appearance,
            uploadErrorHandler: props.uploadErrorHandler,
            waitForMediaUpload: props.waitForMediaUpload,
            isCopyPasteEnabled: true,
            alignLeftOnInsert: typeof ((_props$media5 = props.media) === null || _props$media5 === void 0 ? void 0 : _props$media5.alignLeftOnInsert) !== 'undefined' ? (_props$media6 = props.media) === null || _props$media6 === void 0 ? void 0 : _props$media6.alignLeftOnInsert : isComment,
            getEditorFeatureFlags: getEditorFeatureFlags
        }
    ], Boolean(props.media)).maybeAdd((0, $k8aAi.mediaInsertPlugin), Boolean(props.media)).maybeAdd((0, $cqHz4.default), Boolean((_props$media7 = props.media) === null || _props$media7 === void 0 ? void 0 : _props$media7.allowCaptions)).maybeAdd([
        (0, $ehQm8.mentionsPlugin),
        {
            sanitizePrivateContent: props.sanitizePrivateContent,
            insertDisplayName: ((_props$mention = props.mention) === null || _props$mention === void 0 ? void 0 : _props$mention.insertDisplayName) ?? props.mentionInsertDisplayName,
            allowZeroWidthSpaceAfter: true,
            HighlightComponent: (_props$mention2 = props.mention) === null || _props$mention2 === void 0 ? void 0 : _props$mention2.HighlightComponent,
            profilecardProvider: (_props$mention3 = props.mention) === null || _props$mention3 === void 0 ? void 0 : _props$mention3.profilecardProvider,
            mentionNodeDataProvider: (_props$mention4 = props.mention) === null || _props$mention4 === void 0 ? void 0 : _props$mention4.mentionNodeDataProvider,
            mentionProvider: props.mentionProvider,
            ...initialPluginConfiguration === null || initialPluginConfiguration === void 0 ? void 0 : initialPluginConfiguration.mentionsPlugin
        }
    ], Boolean(props.mentionProvider)).maybeAdd([
        (0, $8JT0u.emojiPlugin),
        {
            emojiProvider: props.emojiProvider,
            ...initialPluginConfiguration === null || initialPluginConfiguration === void 0 ? void 0 : initialPluginConfiguration.emojiPlugin
        }
    ], Boolean(props.emojiProvider)).maybeAdd([
        (0, $cr77I.default),
        {
            tableOptions: !props.allowTables || typeof props.allowTables === 'boolean' ? {} : props.allowTables,
            isTableScalingEnabled: isFullPage || isComment,
            allowContextualMenu: true,
            fullWidthEnabled: appearance === 'full-width',
            wasFullWidthEnabled: prevAppearance && prevAppearance === 'full-width',
            getEditorFeatureFlags: getEditorFeatureFlags,
            isCommentEditor: isComment,
            isChromelessEditor: isChromeless,
            allowFixedColumnWidthOption: props.allowTables && typeof props.allowTables !== 'boolean' && props.allowTables.allowFixedColumnWidthOption,
            __livePage: props.__livePage
        }
    ], Boolean(props.allowTables)).maybeAdd([
        (0, $laPqb.tasksAndDecisionsPlugin),
        {
            allowNestedTasks: props.allowNestedTasks,
            consumeTabs: isFullPage,
            useLongPressSelection: false,
            taskDecisionProvider: props.taskDecisionProvider,
            ...initialPluginConfiguration === null || initialPluginConfiguration === void 0 ? void 0 : initialPluginConfiguration.tasksAndDecisionsPlugin
        }
    ], Boolean(props.allowTasksAndDecisions || props.taskDecisionProvider)).maybeAdd([
        (0, $9cRNW.feedbackDialogPlugin),
        {
            coreVersion: $5CCIk.version,
            ...props.feedbackInfo
        }
    ], Boolean(props.feedbackInfo)).maybeAdd([
        (0, $6UqI6.helpDialogPlugin),
        !!props.legacyImageUploadProvider
    ], Boolean(props.allowHelpDialog)).maybeAdd([
        (0, $ibifS.saveOnEnterPlugin),
        props.onSave
    ], Boolean(props.saveOnEnter && props.onSave)).maybeAdd((0, $6HB5K.imageUploadPlugin), Boolean(props.legacyImageUploadProvider)).maybeAdd(// duplicate plugin exists because first one if media is enabled
    // second one when “media is disabled, and legacyMediaProvider is enabled
    // @ts-expect-error
    [
        (0, $jYlNA.mediaPlugin),
        {
            allowMediaSingle: {
                disableLayout: true
            },
            allowMediaGroup: false,
            isCopyPasteEnabled: true
        }
    ], Boolean(props.legacyImageUploadProvider && !props.media)).maybeAdd([
        (0, $5dk2T.collabEditPlugin),
        {
            ...props.collabEdit,
            sanitizePrivateContent: props.sanitizePrivateContent,
            EXPERIMENTAL_allowInternalErrorAnalytics: ((_props$collabEdit = props.collabEdit) === null || _props$collabEdit === void 0 ? void 0 : _props$collabEdit.EXPERIMENTAL_allowInternalErrorAnalytics) ?? (0, $ahwoz.shouldForceTracking)()
        }
    ], Boolean(props.collabEdit || props.collabEditProvider)).maybeAdd([
        (0, $7vpIc.default),
        props.maxContentSize
    ], Boolean(props.maxContentSize)).maybeAdd([
        (0, $48IYX.default),
        {
            useLongPressSelection: false,
            allowCustomPanel: typeof props.allowPanel === 'object' ? props.allowPanel.allowCustomPanel : false,
            allowCustomPanelEdit: typeof props.allowPanel === 'object' ? props.allowPanel.allowCustomPanelEdit : false
        }
    ], Boolean(props.allowPanel)).maybeAdd((0, $4waKk.contextPanelPlugin), Boolean(isFullPage)).maybeAdd([
        (0, $d2wYX.extensionPlugin),
        {
            breakoutEnabled: appearance === 'full-page' && (typeof props.allowExtension === 'object' ? props.allowExtension.allowBreakout : true) !== false,
            extensionHandlers: props.extensionHandlers,
            useLongPressSelection: false,
            appearance: appearance,
            ...initialPluginConfiguration === null || initialPluginConfiguration === void 0 ? void 0 : initialPluginConfiguration.extensionPlugin
        }
    ], Boolean(props.allowExtension)).maybeAdd(// we are ignoring a duplicate plugin error here
    // this error exists because we have two annotation plugins being added
    // one with annotationProviders and one with allowConfluenceInlineComment
    // long term this and media should be consolidated into adding both only once
    // @ts-expect-error
    [
        (0, $8Vhvu.annotationPlugin),
        undefined
    ], Boolean(!props.annotationProviders && props.allowConfluenceInlineComment)).maybeAdd([
        (0, $eDSd4.default),
        {
            weekStartDay: typeof props.allowDate === 'object' ? props.allowDate.weekStartDay : undefined
        }
    ], Boolean(props.allowDate)).maybeAdd([
        (0, $MnZIx.default),
        // @ts-expect-error 2322: Type 'false | PlaceholderTextOptions | undefined'
        props.allowTemplatePlaceholders !== true ? props.allowTemplatePlaceholders : {}
    ], Boolean(props.allowTemplatePlaceholders)).maybeAdd([
        (0, $7grHk.layoutPlugin),
        {
            ...typeof props.allowLayouts === 'object' ? props.allowLayouts : {},
            useLongPressSelection: false,
            UNSAFE_allowSingleColumnLayout: typeof props.allowLayouts === 'object' ? props.allowLayouts.UNSAFE_allowSingleColumnLayout : undefined,
            editorAppearance: appearance
        }
    ], Boolean(props.allowLayouts)).maybeAdd([
        (0, $7kMXC.cardPlugin),
        {
            ...props.UNSAFE_cards,
            ...props.smartLinks,
            ...(_props$linking = props.linking) === null || _props$linking === void 0 ? void 0 : _props$linking.smartLinks,
            fullWidthMode: appearance === 'full-width',
            linkPicker: (_props$linking2 = props.linking) === null || _props$linking2 === void 0 ? void 0 : _props$linking2.linkPicker,
            lpLinkPicker: featureFlags.lpLinkPicker ?? false,
            editorAppearance: appearance,
            // @ts-ignore Temporary solution to check for Live Page editor.
            __livePage: props.__livePage
        }
    ], Boolean(((_props$linking3 = props.linking) === null || _props$linking3 === void 0 ? void 0 : _props$linking3.smartLinks) || props.smartLinks || props.UNSAFE_cards)).maybeAdd([
        (0, $3qzLE.customAutoformatPlugin),
        {
            autoformattingProvider: props.autoformattingProvider
        }
    ], Boolean(props.autoformattingProvider)).maybeAdd([
        (0, $dlEm0.statusPlugin),
        {
            menuDisabled: statusMenuDisabled,
            allowZeroWidthSpaceAfter: true
        }
    ], Boolean(props.allowStatus)).maybeAdd([
        (0, $4qdNU.syncedBlockPlugin),
        props.syncBlock
    ], Boolean(props.syncBlock)).maybeAdd((0, $9QU20.indentationPlugin), Boolean(props.allowIndentation)).maybeAdd((0, $bvogh.scrollIntoViewPlugin), Boolean(props.autoScrollIntoView !== false)).add([
        (0, $jvVVo.toolbarListsIndentationPlugin),
        {
            showIndentationButtons: !!props.showIndentationButtons,
            allowHeadingAndParagraphIndentation: !!props.allowIndentation
        }
    ]).add([
        (0, $b4WtV.insertBlockPlugin),
        {
            allowTables: !!props.allowTables,
            allowExpand: $692eb609aa624563$export$a9b5e68d7107c3df(props),
            insertMenuItems: props.insertMenuItems,
            horizontalRuleEnabled: props.allowRule,
            tableSelectorSupported: (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.tableSelector) && isFullPage,
            nativeStatusSupported: !statusMenuDisabled,
            showElementBrowserLink: props.elementBrowser && props.elementBrowser.showModal || false,
            appearance: appearance,
            ...initialPluginConfiguration === null || initialPluginConfiguration === void 0 ? void 0 : initialPluginConfiguration.insertBlockPlugin
        }
    ]).maybeAdd([
        (0, $5aFsj.beforePrimaryToolbarPlugin),
        {
            beforePrimaryToolbarComponents: (_props$primaryToolbar = props.primaryToolbarComponents) === null || _props$primaryToolbar === void 0 ? void 0 : _props$primaryToolbar.before
        }
    ], Boolean(hasBeforePrimaryToolbar(props.primaryToolbarComponents) && !featureFlags.twoLineEditorToolbar)).add([
        (0, $94lAC.avatarGroupPlugin),
        {
            // Avatars are moved to Confluence codebase for Edit in Context
            // When Edit in Context is enabled primaryToolbarComponents is undefined
            // For more details please check
            // https://hello.atlassian.net/wiki/spaces/PCG/pages/2851572180/Editor+toolbar+for+live+pages+and+edit+in+context+projects
            collabEdit: props.collabEdit,
            takeFullWidth: !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
            showAvatarGroup: featureFlags.showAvatarGroupAsPlugin === true && !featureFlags.twoLineEditorToolbar
        }
    ]).maybeAdd([
        (0, $55DT5.findReplacePlugin),
        {
            takeFullWidth: !!featureFlags.showAvatarGroupAsPlugin === false && !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
            twoLineEditorToolbar: !!props.primaryToolbarComponents && !!featureFlags.twoLineEditorToolbar
        }
    ], Boolean(props.allowFindReplace)).maybeAdd((0, $kC031.borderPlugin), Boolean(props.allowBorderMark)).maybeAdd((0, $xmbbY.fragmentPlugin), Boolean(props.allowFragmentMark)).add((0, $cgJ2k.pasteOptionsToolbarPlugin));
    return finalPreset;
}
function $692eb609aa624563$export$a9b5e68d7107c3df({ allowExpand: allowExpand }) {
    if (allowExpand === true) return true;
    if (allowExpand && typeof allowExpand === 'object') return !!allowExpand.allowInsertion;
    return false;
}

});
parcelRegister("5aFsj", function(module, exports) {
$parcel$export(module.exports, "beforePrimaryToolbarPlugin", () => $5073b915f3c9774d$export$66dff0ee14673555);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $130KC = parcelRequire("130KC");
const $5073b915f3c9774d$export$66dff0ee14673555 = ({ api: api, config: props })=>{
    var _api$primaryToolbar;
    const primaryToolbarComponent = ()=>{
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $130KC.BeforePrimaryToolbarWrapper), {
            beforePrimaryToolbarComponents: props === null || props === void 0 ? void 0 : props.beforePrimaryToolbarComponents
        });
    };
    api === null || api === void 0 || (_api$primaryToolbar = api.primaryToolbar) === null || _api$primaryToolbar === void 0 || _api$primaryToolbar.actions.registerComponent({
        name: 'beforePrimaryToolbar',
        component: primaryToolbarComponent
    });
    return {
        name: 'beforePrimaryToolbar',
        primaryToolbarComponent: !(api !== null && api !== void 0 && api.primaryToolbar) ? primaryToolbarComponent : undefined
    };
};

});
parcelRegister("130KC", function(module, exports) {
$parcel$export(module.exports, "BeforePrimaryToolbarWrapper", () => $655c40a27edeff19$export$b41281e8d2acb8ab);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $9dQre = parcelRequire("9dQre");
function $655c40a27edeff19$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $655c40a27edeff19$var$beforePrimaryToolbarPluginWrapperStyles = {
    name: "4jjuk5",
    styles: "display:flex;margin-right:var(--ds-space-100, 8px);flex-grow:1;justify-content:flex-end;align-items:center"
};
const $655c40a27edeff19$export$b41281e8d2acb8ab = (props)=>/*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $655c40a27edeff19$var$beforePrimaryToolbarPluginWrapperStyles,
        "data-testid": 'before-primary-toolbar-components-plugin'
    }, props.beforePrimaryToolbarComponents);

});


parcelRegister("5dk2T", function(module, exports) {
$parcel$export(module.exports, "collabEditPlugin", () => $ab3cb675d70d85e0$export$7b59344e4e475116);

var $g6Qq4 = parcelRequire("g6Qq4");

var $55o0j = parcelRequire("55o0j");

var $c6WhP = parcelRequire("c6WhP");

var $3DNV7 = parcelRequire("3DNV7");

var $gdUUy = parcelRequire("gdUUy");

var $bJsI4 = parcelRequire("bJsI4");

var $4MvqL = parcelRequire("4MvqL");

var $bDVYO = parcelRequire("bDVYO");

var $aJDC0 = parcelRequire("aJDC0");

var $3SPuD = parcelRequire("3SPuD");

var $d106T = parcelRequire("d106T");

var $2vktY = parcelRequire("2vktY");

var $vhR4H = parcelRequire("vhR4H");

var $i6EP1 = parcelRequire("i6EP1");

var $hMKzB = parcelRequire("hMKzB");

var $9bYLV = parcelRequire("9bYLV");

var $koQIy = parcelRequire("koQIy");

var $3S6Lb = parcelRequire("3S6Lb");

var $1kArI = parcelRequire("1kArI");

var $bkyQf = parcelRequire("bkyQf");

var $2kimw = parcelRequire("2kimw");
const $ab3cb675d70d85e0$var$providerBuilder = (collabEditProviderPromise)=>async (codeToExecute, onError)=>{
        try {
            const provider = await collabEditProviderPromise;
            if (provider) return codeToExecute(provider);
        } catch (err) {
            if (onError) onError(err);
            else // eslint-disable-next-line no-console
            console.error(err);
        }
    };
const $ab3cb675d70d85e0$var$createAddInlineCommentMark = (providerPromise)=>({ from: from, to: to, mark: mark })=>{
        providerPromise.then((provider)=>{
            var _provider$api;
            const commentMark = new (0, $3DNV7.AddMarkStep)(Math.min(from, to), Math.max(from, to), mark);
            // @ts-expect-error 2339: Property 'api' does not exist on type 'CollabEditProvider<CollabEvents>'.
            (_provider$api = provider.api) === null || _provider$api === void 0 || _provider$api.addComment([
                commentMark
            ]);
        });
        return false;
    };
const $ab3cb675d70d85e0$var$createAddInlineCommentNodeMark = (providerPromise)=>({ pos: pos, mark: mark })=>{
        providerPromise.then((provider)=>{
            var _provider$api2;
            const commentMark = new (0, $3DNV7.AddNodeMarkStep)(pos, mark);
            // @ts-expect-error 2339: Property 'api' does not exist on type 'CollabEditProvider<CollabEvents>'.
            (_provider$api2 = provider.api) === null || _provider$api2 === void 0 || _provider$api2.addComment([
                commentMark
            ]);
        });
        return false;
    };
const $ab3cb675d70d85e0$export$7b59344e4e475116 = ({ config: options, api: api })=>{
    var _api$featureFlags;
    const featureFlags = (api === null || api === void 0 || (_api$featureFlags = api.featureFlags) === null || _api$featureFlags === void 0 ? void 0 : _api$featureFlags.sharedState.currentState()) || {};
    let providerResolver = ()=>{};
    const editorViewRef = {
        current: null
    };
    const collabEditProviderPromise = new Promise((_providerResolver)=>{
        providerResolver = _providerResolver;
    });
    const executeProviderCode = $ab3cb675d70d85e0$var$providerBuilder(collabEditProviderPromise);
    // Spans transactions: a streaming producer holds the flush across many state updates, not just
    // the ones it dispatches itself. See `createCollabSendHold`.
    const sendHold = (0, $bDVYO.createCollabSendHold)();
    return {
        name: 'collabEdit',
        getSharedState (state) {
            if (!state) return {
                initialised: {
                    ...(0, $gdUUy.fg)('confluence_ncs_step_diffing_version_history') && {
                        localHumanBodyChangeCount: 0
                    },
                    collabInitialisedAt: null,
                    firstChangeAfterInitAt: null,
                    firstContentBodyChangeAfterInitAt: null,
                    lastLocalOrganicChangeAt: null,
                    lastRemoteOrganicChangeAt: null,
                    lastLocalOrganicBodyChangeAt: null,
                    lastRemoteOrganicBodyChangeAt: null
                },
                activeParticipants: undefined,
                sessionId: undefined,
                lastReconnectionConflictMetadata: undefined
            };
            const collabPluginState = (0, $vhR4H.pluginKey).getState(state);
            const metadata = (0, $1kArI.trackNCSInitializationPluginKey).getState(state);
            const lastOrganicChangeState = (0, $3S6Lb.trackLastOrganicChangePluginKey).getState(state);
            const lastRemoteConflict = (0, $bkyQf.trackLastRemoteConflictPluginKey).getState(state);
            return {
                activeParticipants: collabPluginState === null || collabPluginState === void 0 ? void 0 : collabPluginState.activeParticipants,
                sessionId: collabPluginState === null || collabPluginState === void 0 ? void 0 : collabPluginState.sessionId,
                initialised: {
                    ...(0, $gdUUy.fg)('confluence_ncs_step_diffing_version_history') && {
                        localHumanBodyChangeCount: (lastOrganicChangeState === null || lastOrganicChangeState === void 0 ? void 0 : lastOrganicChangeState.localHumanBodyChangeCount) ?? 0
                    },
                    collabInitialisedAt: (metadata === null || metadata === void 0 ? void 0 : metadata.collabInitialisedAt) || null,
                    firstChangeAfterInitAt: (metadata === null || metadata === void 0 ? void 0 : metadata.firstChangeAfterInitAt) || null,
                    firstContentBodyChangeAfterInitAt: (metadata === null || metadata === void 0 ? void 0 : metadata.firstContentBodyChangeAfterInitAt) || null,
                    lastLocalOrganicChangeAt: (lastOrganicChangeState === null || lastOrganicChangeState === void 0 ? void 0 : lastOrganicChangeState.lastLocalOrganicChangeAt) || null,
                    lastRemoteOrganicChangeAt: (lastOrganicChangeState === null || lastOrganicChangeState === void 0 ? void 0 : lastOrganicChangeState.lastRemoteOrganicChangeAt) || null,
                    lastLocalOrganicBodyChangeAt: (lastOrganicChangeState === null || lastOrganicChangeState === void 0 ? void 0 : lastOrganicChangeState.lastLocalOrganicBodyChangeAt) || null,
                    lastRemoteOrganicBodyChangeAt: (lastOrganicChangeState === null || lastOrganicChangeState === void 0 ? void 0 : lastOrganicChangeState.lastRemoteOrganicBodyChangeAt) || null
                },
                lastReconnectionConflictMetadata: lastRemoteConflict
            };
        },
        actions: {
            getAvatarColor: $2kimw.getAvatarColor,
            addInlineCommentMark: $ab3cb675d70d85e0$var$createAddInlineCommentMark(collabEditProviderPromise),
            addInlineCommentNodeMark: $ab3cb675d70d85e0$var$createAddInlineCommentNodeMark(collabEditProviderPromise),
            isRemoteReplaceDocumentTransaction: (tr)=>tr.getMeta('isRemote') && tr.getMeta('replaceDocument'),
            getCurrentCollabState: ()=>{
                var _getCollabState;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const adfDocument = new (0, $c6WhP.JSONTransformer)().encode(editorViewRef.current.state.doc);
                return {
                    content: adfDocument,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    version: ((_getCollabState = (0, $bJsI4.getCollabState)(editorViewRef.current.state)) === null || _getCollabState === void 0 ? void 0 : _getCollabState.version) || 0,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    sendableSteps: (0, $bJsI4.sendableSteps)(editorViewRef.current.state)
                };
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            validatePMJSONDocument: (doc)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const content = (doc.content || []).map((child)=>// Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    editorViewRef.current.state.schema.nodeFromJSON(child));
                return content.every((node)=>{
                    try {
                        node.check(); // this will throw an error if the node is invalid
                    } catch  {
                        return false;
                    }
                    return true;
                });
            }
        },
        pmPlugins () {
            const { useNativePlugin: useNativePlugin = false, userId: userId = null } = options || {};
            const transformUnconfirmed = (steps)=>{
                // Analytics steps are filtered first so they cannot break up an otherwise adjacent
                // run of streaming frames.
                const filtered = (0, $d106T.filterAnalyticsSteps)(steps);
                const transformed = (0, $gdUUy.fg)('platform_editor_ai_collapse_streaming_steps') ? (0, $aJDC0.collapseStreamingSteps)(filtered) : filtered;
                return (0, $i6EP1.mergeUnconfirmedSteps)(transformed, api);
            };
            const plugins = [
                ...useNativePlugin ? [
                    {
                        name: 'pmCollab',
                        plugin: ()=>(0, $bJsI4.collab)({
                                clientID: userId,
                                transformUnconfirmed: transformUnconfirmed
                            })
                    },
                    {
                        name: 'nativeCollabProviderPlugin',
                        plugin: ()=>(0, $9bYLV.nativeCollabProviderPlugin)({
                                providerPromise: collabEditProviderPromise
                            })
                    }
                ] : [],
                {
                    name: 'collab',
                    plugin: ({ dispatch: dispatch, providerFactory: providerFactory })=>{
                        return (0, $2vktY.createPlugin)(dispatch, providerFactory, providerResolver, executeProviderCode, options, featureFlags, api);
                    }
                },
                {
                    name: 'collabTrackNCSInitializationPlugin',
                    plugin: (0, $1kArI.createPlugin)
                }
            ];
            plugins.push({
                name: 'trackAndFilterSpammingSteps',
                plugin: ()=>(0, $koQIy.createPlugin)((tr)=>{
                        var _api$analytics;
                        const sanitizedSteps = tr.steps.map((step)=>(0, $koQIy.sanitizeFilteredStep)(step));
                        api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.fireAnalyticsEvent({
                            action: (0, $g6Qq4.ACTION).STEPS_FILTERED,
                            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).COLLAB,
                            attributes: {
                                steps: sanitizedSteps
                            },
                            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
                        });
                    })
            });
            plugins.push({
                name: 'collabTrackLastOrganicChangePlugin',
                plugin: (0, $3S6Lb.createPlugin)
            });
            plugins.push({
                name: 'trackLastRemoteConflictPlugin',
                plugin: (0, $bkyQf.createPlugin)
            });
            return plugins;
        },
        onEditorViewStateUpdated (props) {
            var _api$analytics2, _api$editorViewMode;
            // `props.transactions` is what `applyTransaction` produced: the dispatched transaction
            // followed by everything `appendTransaction` added. Streaming frames are built in an
            // appendTransaction, so their hold metadata is never on `originalTransaction`.
            // Evaluated once and used for both the observation and the send decision. If the gate
            // is turned off mid-stream, an already-active hold must stop applying immediately
            // rather than persisting until the backstop expires and blocking every send.
            const collapseStreamingStepsEnabled = (0, $gdUUy.fg)('platform_editor_ai_collapse_streaming_steps');
            if (collapseStreamingStepsEnabled) props.transactions.forEach((transaction)=>sendHold.observe(transaction));
            const addErrorAnalytics = (0, $4MvqL.addSynchronyErrorAnalytics)(props.newEditorState, props.newEditorState.tr, featureFlags, api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions);
            const isEmptyDoc = (0, $55o0j.isEmptyDocument)(props.newEditorState.doc);
            const viewMode = api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode;
            executeProviderCode((0, $3SPuD.sendTransaction)({
                originalTransaction: props.originalTransaction,
                transactions: props.transactions,
                oldEditorState: props.oldEditorState,
                newEditorState: props.newEditorState,
                useNativePlugin: options.useNativePlugin ?? false,
                hideTelecursorOnLoad: !isEmptyDoc && (options.hideTelecursorOnLoad ?? false),
                viewMode: viewMode,
                isSendHeld: collapseStreamingStepsEnabled && sendHold.isHeld()
            }), addErrorAnalytics);
            if ((0, $gdUUy.fg)('platform_editor_collab_organic_change_reporting')) (0, $hMKzB.monitorOrganic)({
                api: api,
                ...props,
                onDataProcessed: (data)=>{
                    var _api$analytics3;
                    api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 || (_api$analytics3 = _api$analytics3.actions) === null || _api$analytics3 === void 0 || _api$analytics3.fireAnalyticsEvent({
                        action: (0, $g6Qq4.ACTION).ORGANIC_CHANGES_TRACKED,
                        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).COLLAB,
                        attributes: {
                            organicChanges: data
                        },
                        eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
                    });
                }
            });
        },
        commands: {
            nudgeTelepointer: (sessionId)=>({ tr: tr })=>{
                    tr.setMeta('nudgeTelepointer', {
                        sessionId: sessionId
                    });
                    return tr;
                }
        }
    };
};

});
parcelRegister("bJsI4", function(module, exports) {
$parcel$export(module.exports, "Rebaseable", () => $b97b0d13275e1119$export$c6d36d70c8e9d8cd);
$parcel$export(module.exports, "collab", () => $b97b0d13275e1119$export$995d9de96d1b2e26);
$parcel$export(module.exports, "receiveTransaction", () => $b97b0d13275e1119$export$7581d8ca0d559ec6);
$parcel$export(module.exports, "sendableSteps", () => $b97b0d13275e1119$export$4da2109e7644e6c2);
$parcel$export(module.exports, "getCollabState", () => $b97b0d13275e1119$export$971539697c176258);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $7RHfd = parcelRequire("7RHfd");

var $cw0wu = parcelRequire("cw0wu");

var $kTKoM = parcelRequire("kTKoM");
class $b97b0d13275e1119$export$c6d36d70c8e9d8cd {
    constructor(step, inverted, origin){
        this.step = step;
        this.inverted = inverted;
        this.origin = origin;
    }
}
function $b97b0d13275e1119$export$bced9e015fcf3afa(steps, over, transform) {
    for(let i = steps.length - 1; i >= 0; i--)transform.step(steps[i].inverted);
    for(let i = 0; i < over.length; i++)transform.step(over[i]);
    const result = [];
    for(let i = 0, mapFrom = steps.length; i < steps.length; i++){
        const mapped = steps[i].step.map(transform.mapping.slice(mapFrom));
        const movedStep = (0, $kTKoM.mapStep)(steps, transform, i, mapped);
        mapFrom--;
        if (mapped && !transform.maybeStep(mapped).failed) {
            // Open ticket for setMirror https://github.com/ProseMirror/prosemirror/issues/869
            // @ts-expect-error
            transform.mapping.setMirror(mapFrom, transform.steps.length - 1);
            result.push(new $b97b0d13275e1119$export$c6d36d70c8e9d8cd(mapped, mapped.invert(transform.docs[transform.docs.length - 1]), steps[i].origin));
        }
        // If the step is a "move" step - apply the additional step
        if (movedStep && !transform.maybeStep(movedStep).failed) result.push(new $b97b0d13275e1119$export$c6d36d70c8e9d8cd(movedStep, movedStep.invert(transform.docs[transform.docs.length - 1]), transform));
    }
    return result;
}
// This state field accumulates changes that have to be sent to the
// central authority in the collaborating group and makes it possible
// to integrate changes made by peers into our local document. It is
// defined by the plugin, and will be available as the `collab` field
// in the resulting editor state.
class $b97b0d13275e1119$var$CollabState {
    constructor(// The version number of the last update received from the central
    // authority. Starts at 0 or the value of the `version` property
    // in the option object, for the editor's value when the option
    // was enabled.
    version, // The local steps that havent been successfully sent to the
    // server yet.
    unconfirmed){
        this.version = version;
        this.unconfirmed = unconfirmed;
    }
}
function $b97b0d13275e1119$var$unconfirmedFrom(transform) {
    const result = [];
    for(let i = 0; i < transform.steps.length; i++)result.push(new $b97b0d13275e1119$export$c6d36d70c8e9d8cd(transform.steps[i], transform.steps[i].invert(transform.docs[i]), transform));
    return result;
}
const $b97b0d13275e1119$var$collabKey = new (0, $cw0wu.PluginKey)('collab');
function $b97b0d13275e1119$export$995d9de96d1b2e26(config = {}) {
    const conf = {
        version: config.version || 0,
        clientID: // eslint-disable-next-line eqeqeq
        // generate a temporary id as clientId when it is null or undefined
        // prefix temp-pc- indicates prosemirror-collab
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        config.clientID == null || !config.clientID ? `temp-pc-${(0, $7RHfd.default)()}` : config.clientID
    };
    const transformUnconfirmed = config.transformUnconfirmed ?? ((steps)=>steps);
    return new (0, $cw0wu.Plugin)({
        key: $b97b0d13275e1119$var$collabKey,
        state: {
            init: ()=>new $b97b0d13275e1119$var$CollabState(conf.version, []),
            apply (tr, collab) {
                const newState = tr.getMeta($b97b0d13275e1119$var$collabKey);
                if (newState) return new $b97b0d13275e1119$var$CollabState(newState.version, transformUnconfirmed(newState.unconfirmed));
                if (tr.docChanged) return new $b97b0d13275e1119$var$CollabState(collab.version, transformUnconfirmed(collab.unconfirmed.concat($b97b0d13275e1119$var$unconfirmedFrom(tr))));
                return collab;
            }
        },
        config: conf,
        // This is used to notify the history plugin to not merge steps,
        // so that the history can be rebased.
        historyPreserveItems: true
    });
}
function $b97b0d13275e1119$export$5af1c9a2797f6d8e(state) {
    const tr = state.tr;
    const { version: version, unconfirmed: unconfirmed } = $b97b0d13275e1119$var$collabKey.getState(state) ?? {};
    if (version === undefined || !unconfirmed) return tr.doc;
    // undo unconfirmed steps
    for(let i = unconfirmed.length - 1; i >= 0; i--)tr.step(unconfirmed[i].inverted);
    return tr.doc;
}
function $b97b0d13275e1119$export$852bd88de4de2d35(state, version, // eslint-disable-next-line @typescript-eslint/no-explicit-any
docJSON, unconfirmedSteps) {
    const tr = state.tr;
    const doc = state.schema.nodeFromJSON(docJSON);
    const { from: from, to: to } = tr.selection;
    tr.replaceWith(0, state.doc.content.size, doc);
    // apply new unconfirmed steps to doc
    for(let i = 0; i < unconfirmedSteps.length; i++)tr.step(unconfirmedSteps[i]);
    const offset = 1; // offset by 1 to account for the initial replace step
    const newUnconfirmed = tr.steps.slice(offset).map((step, i)=>{
        const index = i + offset;
        const doc = tr.docs[index];
        return new $b97b0d13275e1119$export$c6d36d70c8e9d8cd(step, step.invert(doc), tr);
    });
    // Because we are replacing the entire document from 0 to end, the selection mapping is incorrect.
    // For now, the best we can do is set the selection to the original positions. Otherwise, it will move to the end of the doc on every change.
    tr.setSelection((0, $cw0wu.TextSelection).create(tr.doc, Math.min(from, tr.doc.content.size), Math.min(to, tr.doc.content.size)));
    return tr.setMeta('addToHistory', false).setMeta($b97b0d13275e1119$var$collabKey, new $b97b0d13275e1119$var$CollabState(version, newUnconfirmed));
}
function $b97b0d13275e1119$export$7581d8ca0d559ec6(state, steps, clientIDs, options = {}) {
    // Pushes a set of steps (received from the central authority) into
    // the editor state (which should have the collab plugin enabled).
    // Will recognize its own changes, and confirm unconfirmed steps as
    // appropriate. Remaining unconfirmed steps will be rebased over
    // remote steps.
    const collabState = $b97b0d13275e1119$var$collabKey.getState(state);
    const version = ((collabState === null || collabState === void 0 ? void 0 : collabState.version) || 0) + steps.length;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion,  @typescript-eslint/no-explicit-any
    const ourID = $b97b0d13275e1119$var$collabKey.get(state).spec.config.clientID;
    // Find out which prefix of the steps originated with us
    let ours = 0;
    // eslint-disable-next-line eqeqeq
    while(ours < clientIDs.length && clientIDs[ours] == ourID)++ours;
    let unconfirmed = (collabState === null || collabState === void 0 ? void 0 : collabState.unconfirmed.slice(ours)) || [];
    steps = ours ? steps.slice(ours) : steps;
    // If all steps originated with us, we're done.
    if (!steps.length) return state.tr.setMeta($b97b0d13275e1119$var$collabKey, new $b97b0d13275e1119$var$CollabState(version, unconfirmed));
    const nUnconfirmed = unconfirmed.length;
    const tr = state.tr;
    if (nUnconfirmed) unconfirmed = $b97b0d13275e1119$export$bced9e015fcf3afa(unconfirmed, steps, tr);
    else {
        for(let i = 0; i < steps.length; i++)tr.step(steps[i]);
        unconfirmed = [];
    }
    const newCollabState = new $b97b0d13275e1119$var$CollabState(version, unconfirmed);
    if (options && options.mapSelectionBackward && state.selection instanceof (0, $cw0wu.TextSelection)) {
        tr.setSelection(new (0, $cw0wu.TextSelection)(tr.doc.resolve(tr.mapping.map(state.selection.anchor, -1)), tr.doc.resolve(tr.mapping.map(state.selection.head, -1))));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        tr.updated &= -2;
    }
    return tr.setMeta('rebased', nUnconfirmed).setMeta('rebasedData', {
        unconfirmedSteps: (collabState === null || collabState === void 0 ? void 0 : collabState.unconfirmed.slice(ours)) || [],
        remoteSteps: steps,
        stepsAfterRebase: unconfirmed,
        versionBefore: version
    }).setMeta('addToHistory', false).setMeta($b97b0d13275e1119$var$collabKey, newCollabState);
}
function $b97b0d13275e1119$export$4da2109e7644e6c2(state) {
    const collabState = $b97b0d13275e1119$var$collabKey.getState(state);
    if (!collabState) return null;
    // eslint-disable-next-line eqeqeq
    if (collabState.unconfirmed.length == 0) return null;
    return {
        version: collabState.version,
        steps: collabState.unconfirmed.map((s)=>s.step),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
        clientID: $b97b0d13275e1119$var$collabKey.get(state).spec.config.clientID,
        get origins () {
            return(// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins || (// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins = collabState === null || collabState === void 0 ? void 0 : collabState.unconfirmed.map((s)=>s.origin)));
        }
    };
}
function $b97b0d13275e1119$export$971539697c176258(state) {
    return $b97b0d13275e1119$var$collabKey.getState(state);
}

});
parcelRegister("kTKoM", function(module, exports) {
$parcel$export(module.exports, "mapStep", () => $664866919718b177$export$798cdecdcbbf9755);

var $7ozbX = parcelRequire("7ozbX");

var $kW8qW = parcelRequire("kW8qW");

var $3DNV7 = parcelRequire("3DNV7");
// Iterate from the specified starting index down to 0
const $664866919718b177$var$findPreviousStepInverseIndex = (steps, startIndex = steps.length - 1)=>{
    for(let i = startIndex; i >= 0; i--){
        if (!(steps[i] instanceof (0, $7ozbX.AnalyticsStep))) return i;
    }
};
const $664866919718b177$export$798cdecdcbbf9755 = (steps, transform, index, mapped)=>{
    if (index < 1) return undefined;
    const previousRebaseableStepIndex = $664866919718b177$var$findPreviousStepInverseIndex(steps.map((s)=>s.step), index - 1);
    // This checks the local steps are a "move" sequence
    if (previousRebaseableStepIndex !== undefined && $664866919718b177$export$17bbdbb89ac2acbd(steps[previousRebaseableStepIndex], steps[index].step)) {
        const previousStepInverseIndex = $664866919718b177$var$findPreviousStepInverseIndex(transform.steps);
        // Creates a new step based on the "current" steps (partially through the rebase)
        if (previousStepInverseIndex !== undefined) return $664866919718b177$export$ad07b298545ed98d(mapped, transform.steps[previousStepInverseIndex], transform, previousStepInverseIndex);
    }
};
// Only consider ReplaceStep (ReplaceAroundStep do not occur for moves)
const $664866919718b177$var$isReplaceTypeStep = (step)=>step instanceof (0, $3DNV7.ReplaceStep);
const $664866919718b177$export$17bbdbb89ac2acbd = (previousRebaseableStep, currentStep)=>{
    if (// The both steps are replace
    $664866919718b177$var$isReplaceTypeStep(previousRebaseableStep.step) && $664866919718b177$var$isReplaceTypeStep(currentStep) && // The current step is a deletion
    previousRebaseableStep.step.slice.size === 0 && // The following step is an insertion with the same length that was deleted by the current step
    Math.abs(previousRebaseableStep.step.to - previousRebaseableStep.step.from) === currentStep.slice.size) {
        // Ensure we're getting the doc before our step changes so we can compare node contents
        const originStepIndex = previousRebaseableStep.origin.steps.findIndex((s)=>s === previousRebaseableStep.step);
        if (originStepIndex === -1) return false;
        const originalDoc = previousRebaseableStep.origin.docs[originStepIndex];
        if (!originalDoc) return false;
        const currentSlice = originalDoc.slice(previousRebaseableStep.step.from, previousRebaseableStep.step.to);
        // The content from the deleted + inserted slice is exactly the same (cut + paste or drag + drop)
        if (currentSlice.eq(currentStep.slice)) return true;
    }
    return false;
};
const $664866919718b177$export$ad07b298545ed98d = (mapped, previousStep, transform, previousStepIndex)=>{
    if (!$664866919718b177$var$isReplaceTypeStep(previousStep) || mapped && !$664866919718b177$var$isReplaceTypeStep(mapped) || !mapped || // Ensure previous step index is valid
    !(previousStepIndex >= 0 && previousStepIndex < transform.docs.length && typeof (previousStep === null || previousStep === void 0 ? void 0 : previousStep.from) === 'number')) return undefined;
    const newSlice = transform.docs[previousStepIndex].slice(previousStep === null || previousStep === void 0 ? void 0 : previousStep.from, previousStep === null || previousStep === void 0 ? void 0 : previousStep.to);
    const diff = $664866919718b177$var$getDiffRange(mapped.slice.content, newSlice.content);
    if (diff === undefined) return undefined;
    const start = mapped.from + diff.start;
    const offset = newSlice.content.size - mapped.slice.content.size === 0 ? diff.end - diff.start : 0;
    // If the new slice is smaller then we're doing a deletion of content - this needs
    // to be a replace step with empty content to delete content
    if (newSlice.content.size - mapped.slice.content.size < 0) return new (0, $3DNV7.ReplaceStep)(start, start + mapped.slice.content.size - newSlice.content.size, (0, $kW8qW.Slice).empty);
    // Replace the diff range with the latest content in the document (at the old position)
    return new (0, $3DNV7.ReplaceStep)(start, start + offset, transform.docs[previousStepIndex].slice((previousStep === null || previousStep === void 0 ? void 0 : previousStep.from) + diff.start, (previousStep === null || previousStep === void 0 ? void 0 : previousStep.from) + diff.end));
};
/**
 * Get start and end diff position values for two fragments (old, new).
 * @param {Fragment} before - content that is planned to move
 * @param {Fragment} after - content that was in paragraph being deleted (updated content)
 * @returns {object} - { start, end }
 */ function $664866919718b177$var$getDiffRange(before, after) {
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffStart
    const start = before.findDiffStart(after);
    // Important: diffEnd value is {a,b} object since end pos will differ.
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffEnd
    const diffEnd = before.findDiffEnd(after);
    if (start === null || diffEnd === null) return undefined;
    // WARNING: diffEnd may be lower than diffStart.
    // If so, add overlap to get correct range.
    // https://discuss.prosemirror.net/t/overlap-handling-of-finddiffstart-and-finddiffend/2856
    const overlap = start - Math.min(diffEnd.a, diffEnd.b);
    let end = diffEnd.b;
    if (overlap > 0) end += overlap;
    return {
        start: start,
        end: end
    };
}

});


parcelRegister("4MvqL", function(module, exports) {
$parcel$export(module.exports, "addSynchronyErrorAnalytics", () => $9d4d83c00649e3ca$export$8c408a1f4e12c948);
$parcel$export(module.exports, "getAgentEditShimmerNotShownPayload", () => $9d4d83c00649e3ca$export$6f3f7a1f93aa6704);
$parcel$export(module.exports, "addSynchronyEntityAnalytics", () => $9d4d83c00649e3ca$export$31cf0e3f119813a1);

var $g6Qq4 = parcelRequire("g6Qq4");

var $ilGNx = parcelRequire("ilGNx");

var $avkEM = parcelRequire("avkEM");
const $9d4d83c00649e3ca$export$8c408a1f4e12c948 = (state, tr, featureFlags, editorAnalyticsApi)=>{
    return (error)=>{
        const browserExtensions = (0, $avkEM.sniffUserBrowserExtensions)({
            extensions: [
                'grammarly'
            ]
        });
        const payload = {
            action: (0, $g6Qq4.ACTION).SYNCHRONY_ERROR,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                browserExtensions: browserExtensions
            }
        };
        if (featureFlags.synchronyErrorDocStructure) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        payload.attributes.docStructure = (0, $ilGNx.getDocStructure)(state.doc, {
            compact: true
        });
        editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent(payload)(tr);
        return tr;
    };
};
const $9d4d83c00649e3ca$export$6f3f7a1f93aa6704 = (reason, agentType, error)=>({
        action: (0, $g6Qq4.ACTION).AGENT_EDIT_SHIMMER_NOT_SHOWN,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).COLLAB,
        eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
        attributes: {
            reason: reason,
            // Spread conditionally so absent context isn't emitted as `undefined` (the teardown path has no
            // single agent, and non-throw reasons have no error).
            ...agentType ? {
                agentType: agentType
            } : {},
            ...error ? {
                error: `${error.name}: ${error.message}`
            } : {}
        }
    });
const $9d4d83c00649e3ca$export$31cf0e3f119813a1 = (state, tr)=>{
    return (type, editorAnalyticsApi)=>{
        editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
            action: type === 'error' ? (0, $g6Qq4.ACTION).SYNCHRONY_ENTITY_ERROR : (0, $g6Qq4.ACTION).SYNCHRONY_DISCONNECTED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                // https://developer.mozilla.org/en-US/docs/Web/API/NavigatorOnLine/onLine
                onLine: navigator.onLine,
                visibilityState: document.visibilityState
            }
        })(tr);
        return tr;
    };
};

});

parcelRegister("bDVYO", function(module, exports) {
$parcel$export(module.exports, "createCollabSendHold", () => $3c990110a888f1ae$export$5063c4b37b4fcc3d);

var $2Ldvm = parcelRequire("2Ldvm");
const $3c990110a888f1ae$export$d4d5cc2beff73292 = 2000;
const $3c990110a888f1ae$export$5063c4b37b4fcc3d = ()=>{
    let heldSince;
    return {
        observe: (transaction, now = Date.now())=>{
            const meta = transaction.getMeta((0, $2Ldvm.DEFER_COLLAB_SEND));
            if (meta === true) {
                // Only start a window, never extend one, so a continuous stream of held frames
                // still reaches the bound. See the note on this type about why.
                if (heldSince === undefined) heldSince = now;
                return;
            }
            if (meta === false) heldSince = undefined;
        },
        isHeld: (now = Date.now())=>{
            if (heldSince === undefined) return false;
            if (now - heldSince >= $3c990110a888f1ae$export$d4d5cc2beff73292) {
                // Clear as well as report, so the next held frame opens a fresh window instead of
                // being judged against the expired one.
                heldSince = undefined;
                return false;
            }
            return true;
        }
    };
};

});
parcelRegister("2Ldvm", function(module, exports) {
$parcel$export(module.exports, "DEFER_COLLAB_SEND", () => $cd6ae327111b9ff3$export$acc2ff5470dfbf77);
/**
 * Neutral transaction metadata used by streaming producers to tell the collab layer not to flush
 * the unconfirmed queue for this transaction.
 *
 * The transaction is still applied to the local document immediately; only the network send is
 * held back. The steps stay in the collab plugin's unconfirmed queue, which is where sending is
 * deferred from — `sendableSteps` returns the whole queue, so the next unheld transaction sends
 * everything that accumulated.
 *
 * Holding the send is what gives `collapseStreamingSteps` a window to work in: `send()` stamps
 * `mergeIsLocked` on every origin it flushes, and locked steps can no longer be composed.
 *
 * Producers must bound how long they hold. Held steps are content the collab service has not seen,
 * so they are lost if the tab closes, and a peer editing the same region while steps are held will
 * rebase against a document that is missing them.
 *
 * @example
 * ```ts
 * tr.setMeta(DEFER_COLLAB_SEND, true);
 * ```
 */ const $cd6ae327111b9ff3$export$acc2ff5470dfbf77 = 'deferCollabSend';

});


parcelRegister("aJDC0", function(module, exports) {
$parcel$export(module.exports, "collapseStreamingSteps", () => $41886b51fcc752c8$export$8c0256ed99f97765);

var $8zxsX = parcelRequire("8zxsX");

var $cw0wu = parcelRequire("cw0wu");

var $bJsI4 = parcelRequire("bJsI4");

var $ic7xN = parcelRequire("ic7xN");
/**
 * Is this step an intermediate frame that its producer has marked as collapsible, and is it still
 * free to be composed?
 */ const $41886b51fcc752c8$var$isCollapsibleFrame = (rebaseable)=>{
    const { origin: origin } = rebaseable;
    if (!(origin instanceof (0, $cw0wu.Transaction)) || origin.getMeta((0, $8zxsX.STREAMING_COLLAPSIBLE_STEPS)) !== true) return false;
    // Already sent to (or queued for) the collab service — composing it now would change a step the
    // backend has already seen. Mirrors the `mergeIsLocked` contract in `mergeUnconfirmedSteps`.
    return !origin.getMeta('mergeIsLocked');
};
/**
 * Starting document of each composed step this module has produced.
 *
 * A composed step is synthesised rather than taken from a transaction, so it cannot be found in
 * `origin.steps` and its starting document cannot be recovered the way an original frame's can.
 * `transformUnconfirmed` runs once per transaction and is handed back the steps it returned last
 * time, so the composed step needs to carry its document forward to keep composing against later
 * frames.
 *
 * Keyed on the step rather than its Rebaseable wrapper. `mergeUnconfirmedSteps` runs immediately
 * after this module in `transformUnconfirmed` and rebuilds every wrapper it is given — merging
 * enabled or not — so a wrapper-keyed entry would be unreachable by the very next pass. The step
 * survives that rebuild untouched, and is still replaced whenever the association genuinely
 * becomes stale: `rebaseSteps` maps steps into new objects, and a real merge composes a new one.
 */ const $41886b51fcc752c8$var$composedStepDocs = new WeakMap();
/**
 * The document this step was applied to.
 *
 * `transformUnconfirmed` is handed steps and nothing else, but a Rebaseable keeps a reference to
 * the transaction that produced it, and a transaction records the document before each of its
 * steps. That is enough for `mergeOverlappingSteps` to resolve merges it cannot derive from the
 * steps alone — notably a frame that replaces more than just what the previous frame inserted.
 *
 * Rebasing maps a step into a new object while keeping the original transaction, so a rebased step
 * is not found in `origin.steps` and correctly yields no document. `mergeOverlappingSteps` then
 * falls back to the merges it can prove without one.
 */ const $41886b51fcc752c8$var$docBeforeStep = (rebaseable)=>{
    const { origin: origin, step: step } = rebaseable;
    const composed = $41886b51fcc752c8$var$composedStepDocs.get(step);
    if (composed) return composed;
    const index = origin.steps.indexOf(step);
    return index >= 0 ? origin.docs[index] : undefined;
};
function $41886b51fcc752c8$export$8c0256ed99f97765(steps) {
    // Fast path: nothing to do unless at least two frames could possibly compose.
    if (steps.length < 2) return steps;
    const collapsed = [];
    // The document the run currently at the tail of `collapsed` started from. A composed step
    // still applies to the document its first frame applied to, so this survives each merge.
    let runDocBefore;
    for (const rebaseable of steps){
        const previous = collapsed[collapsed.length - 1];
        if (!previous || !$41886b51fcc752c8$var$isCollapsibleFrame(previous) || !$41886b51fcc752c8$var$isCollapsibleFrame(rebaseable)) {
            collapsed.push(rebaseable);
            runDocBefore = $41886b51fcc752c8$var$docBeforeStep(rebaseable);
            continue;
        }
        const merged = (0, $ic7xN.mergeOverlappingSteps)(previous, rebaseable, runDocBefore);
        if (!merged) {
            collapsed.push(rebaseable);
            runDocBefore = $41886b51fcc752c8$var$docBeforeStep(rebaseable);
            continue;
        }
        // Keep the earliest origin, matching `mergeUnconfirmedSteps`. `commitUnconfirmedSteps` in
        // the collab provider tracks completion by origin identity, so keeping the earliest means
        // the composed step is not considered confirmed until the whole run has been acknowledged.
        const composed = new (0, $bJsI4.Rebaseable)(merged.step, merged.inverted, previous.origin);
        if (runDocBefore) $41886b51fcc752c8$var$composedStepDocs.set(composed.step, runDocBefore);
        collapsed[collapsed.length - 1] = composed;
    }
    return collapsed;
}

});
parcelRegister("8zxsX", function(module, exports) {
$parcel$export(module.exports, "STREAMING_COLLAPSIBLE_STEPS", () => $d6ae345be9558cdb$export$198e2173395dca0c);
/**
 * Neutral transaction metadata used by streaming producers (for example editor-plugin-ai's
 * in-editor direct streaming) to tell the collab layer that this transaction's steps are an
 * intermediate frame of a single logical edit.
 *
 * Streaming producers re-render the whole in-progress region on every chunk, which means each
 * frame is a full replace of the region the previous frame inserted. Every frame is applied to the
 * local document immediately (so the user sees the content stream in), but only the *composition*
 * of the frames needs to reach the collab service.
 *
 * Stamping a transaction with this meta does NOT stop its steps from being sent — it only makes
 * them eligible to be composed with adjacent frames while they are still unconfirmed. See
 * `collapseStreamingSteps` in `@atlaskit/editor-plugin-collab-edit`.
 *
 * @example
 * ```ts
 * tr.setMeta(STREAMING_COLLAPSIBLE_STEPS, true);
 * ```
 */ const $d6ae345be9558cdb$export$198e2173395dca0c = 'streamingCollapsibleSteps';

});

parcelRegister("ic7xN", function(module, exports) {
$parcel$export(module.exports, "mergeOverlappingSteps", () => $e2d9265cdc2823bc$export$422daa1dfed9a8b8);

var $3DNV7 = parcelRequire("3DNV7");
/**
 * `structure` is `@internal` on ReplaceStep but is part of the serialised form, so this is the
 * supported way to read it. Structural replaces exist to stop rebased steps from overwriting
 * content they should not, so they are never merged.
 */ const $e2d9265cdc2823bc$var$isStructural = (step)=>step.toJSON().structure === true;
const $e2d9265cdc2823bc$var$asPlainReplaceStep = (step)=>// Deliberately excludes ReplaceAroundStep — the position arithmetic below is only sound for a
    // plain range replace.
    step instanceof (0, $3DNV7.ReplaceStep) && !$e2d9265cdc2823bc$var$isStructural(step) ? step : undefined;
/**
 * Do the two steps touch the same region of the document?
 *
 * `second` is expressed in the coordinate space *after* `first` has been applied, so `first`'s
 * footprint there is the range its slice occupies: `[from, from + slice.size]`.
 */ const $e2d9265cdc2823bc$var$overlaps = (first, second)=>{
    const firstInsertedEnd = first.from + first.slice.size;
    return second.from <= firstInsertedEnd && second.to >= first.from;
};
/**
 * Merge using ProseMirror's own step merging, which handles adjacent insertions and adjacent
 * deletions. Both the steps and their inverses have to merge for the result to be usable as a
 * rebase buffer entry — inverses compose in reverse order.
 */ const $e2d9265cdc2823bc$var$mergeNatively = (first, second)=>{
    const step = first.step.merge(second.step);
    if (!step) return null;
    const inverted = second.inverted.merge(first.inverted);
    if (!inverted) return null;
    return {
        step: step,
        inverted: inverted
    };
};
/**
 * Merge any two overlapping steps by applying both to the document and describing the net change
 * as a single minimal replacement.
 *
 * This is the general case: it copes with `second` reaching past `first` on either side, with
 * partial overlaps, and with slices whose open depths differ — none of which can be resolved from
 * the steps alone, because the composed slice has to be cut out of a real document.
 */ const $e2d9265cdc2823bc$var$mergeViaDocument = (first, second, docBefore)=>{
    let docAfter;
    try {
        const transform = new (0, $3DNV7.Transform)(docBefore);
        transform.step(first.step);
        transform.step(second.step);
        docAfter = transform.doc;
    } catch  {
        // `docBefore` did not match the steps (for example the steps have since been rebased).
        return null;
    }
    const start = docBefore.content.findDiffStart(docAfter.content);
    if (start === null) // The steps cancel each other out. There is no single step representing "no change", so
    // leave the pair alone rather than inventing one.
    return null;
    const diffEnd = docBefore.content.findDiffEnd(docAfter.content);
    if (!diffEnd) return null;
    // findDiffStart and findDiffEnd can overshoot each other when the same text appears on both
    // sides of the change; push the end out so the range stays well formed.
    let { a: endBefore, b: endAfter } = diffEnd;
    const overshoot = start - Math.min(endBefore, endAfter);
    if (overshoot > 0) {
        endBefore += overshoot;
        endAfter += overshoot;
    }
    const step = new (0, $3DNV7.ReplaceStep)(start, endBefore, docAfter.slice(start, endAfter));
    // Cheap guarantee that the composition is exact. If it is not, keep the original pair.
    const applied = step.apply(docBefore);
    if (applied.failed !== null || !applied.doc || !applied.doc.eq(docAfter)) return null;
    return {
        step: step,
        inverted: step.invert(docBefore)
    };
};
function $e2d9265cdc2823bc$export$422daa1dfed9a8b8(first, second, docBefore) {
    const firstStep = $e2d9265cdc2823bc$var$asPlainReplaceStep(first.step);
    const secondStep = $e2d9265cdc2823bc$var$asPlainReplaceStep(second.step);
    // Non-plain replaces are only ever merged by ProseMirror itself, which knows the rules for them.
    if (!firstStep || !secondStep) return $e2d9265cdc2823bc$var$mergeNatively(first, second);
    if (!$e2d9265cdc2823bc$var$overlaps(firstStep, secondStep)) return null;
    // Try the O(1) strategy before the one that has to replay both steps against a document.
    // `transformUnconfirmed` runs on every transaction, and adjacent insertions — which is what
    // consecutive streaming frames often are — are exactly what ProseMirror merges natively.
    const natively = $e2d9265cdc2823bc$var$mergeNatively(first, second);
    if (natively) return natively;
    // Anything else needs the document to cut the composed slice out of, so without one there is
    // no merge that can be proven exact.
    return docBefore ? $e2d9265cdc2823bc$var$mergeViaDocument(first, second, docBefore) : null;
}

});


parcelRegister("3SPuD", function(module, exports) {
$parcel$export(module.exports, "sendTransaction", () => $e497b37839b7256e$export$8e0e7ffc78696d30);

var $7ozbX = parcelRequire("7ozbX");

var $xt8ea = parcelRequire("xt8ea");

var $vhR4H = parcelRequire("vhR4H");
const $e497b37839b7256e$export$8e0e7ffc78696d30 = ({ originalTransaction: originalTransaction, transactions: transactions, oldEditorState: oldEditorState, newEditorState: newEditorState, useNativePlugin: useNativePlugin, viewMode: viewMode, hideTelecursorOnLoad: hideTelecursorOnLoad, isSendHeld: isSendHeld = false })=>(provider)=>{
        const docChangedTransaction = transactions.find((tr)=>tr.docChanged);
        const currentPluginState = (0, $vhR4H.pluginKey).getState(newEditorState);
        const trNoAnalytics = oldEditorState.tr;
        docChangedTransaction === null || docChangedTransaction === void 0 || docChangedTransaction.steps.forEach((step)=>{
            if (!(step instanceof (0, $7ozbX.AnalyticsStep))) trNoAnalytics.step(step);
        });
        if (!(currentPluginState !== null && currentPluginState !== void 0 && currentPluginState.isReady)) return;
        const shouldSendStepForSynchronyCollabProvider = !originalTransaction.getMeta('isRemote') && // TODO: ED-8995 - We need to do this check to reduce the number of race conditions when working with tables.
        // This metadata is coming from the scaleTable command in table-resizing plugin
        !originalTransaction.getMeta('scaleTable') && trNoAnalytics.docChanged;
        // A streaming producer can hold the flush back so several of its frames accumulate in the
        // unconfirmed queue and collapse into one step before being sent. The steps are not
        // dropped: `sendableSteps` returns the whole queue, so the first unheld state update sends
        // everything that accumulated. Skipping `send` also skips `lockStepOrigins`, which is what
        // keeps the accumulated frames composable.
        //
        // Telepointer messages below are intentionally left alone — holding them would freeze
        // other participants' cursors for the length of the hold, and they carry no steps.
        if (!isSendHeld && (useNativePlugin || shouldSendStepForSynchronyCollabProvider)) provider.send(trNoAnalytics, oldEditorState, newEditorState);
        const prevPluginState = (0, $vhR4H.pluginKey).getState(oldEditorState);
        const { activeParticipants: prevActiveParticipants } = prevPluginState || {};
        const { activeParticipants: activeParticipants, sessionId: sessionId } = currentPluginState;
        const selectionChanged = !oldEditorState.selection.eq(newEditorState.selection);
        const participantsChanged = prevActiveParticipants && !prevActiveParticipants.eq(activeParticipants);
        if (!sessionId || viewMode !== 'edit') return;
        // uiEvent is standard metdata (docs: https://prosemirror.net/docs/ref/#state.Transaction)
        const isPaste = (docChangedTransaction === null || docChangedTransaction === void 0 ? void 0 : docChangedTransaction.getMeta('uiEvent')) === 'paste';
        // If this metadata is truthy then it means a selection bookmark might be declared as the meta value OR the transaction
        // doesn't want the tr.selection to be sent to remote users at all.
        const remoteSelectionBookmark = originalTransaction.getMeta('useSelectionBookmarkForRemote');
        if (!!remoteSelectionBookmark) {
            if (remoteSelectionBookmark !== true && 'resolve' in remoteSelectionBookmark) {
                const selection = remoteSelectionBookmark.resolve(newEditorState.doc);
                const message = {
                    type: 'telepointer',
                    selection: (0, $xt8ea.getSendableSelection)(selection),
                    sessionId: sessionId
                };
                provider.sendMessage(message);
            }
        } else if (// Broadcast the position if the selection has changed, and the doc hasn't changed (it is mapped
        // by the receiver).
        // If we're pasting content though make an exception (as doc has changed)
        // as on a ranged selection it results in not clearing the ranged selection after the paste
        selectionChanged && (!docChangedTransaction || isPaste) || participantsChanged && !hideTelecursorOnLoad) {
            const selection = (0, $xt8ea.getSendableSelection)(newEditorState.selection);
            const message = {
                type: 'telepointer',
                selection: selection,
                sessionId: sessionId
            };
            provider.sendMessage(message);
        }
    };

});
parcelRegister("xt8ea", function(module, exports) {
$parcel$export(module.exports, "handleInit", () => $071c600da8dd96d5$export$a04a448cc866246);
$parcel$export(module.exports, "handleConnection", () => $071c600da8dd96d5$export$cf9a0dcadb173615);
$parcel$export(module.exports, "handlePresence", () => $071c600da8dd96d5$export$f9db5387b510d6c);
$parcel$export(module.exports, "applyRemoteData", () => $071c600da8dd96d5$export$c6643a6a2625d22c);
$parcel$export(module.exports, "handleTelePointer", () => $071c600da8dd96d5$export$abfa80d838a68fd6);
$parcel$export(module.exports, "getSendableSelection", () => $071c600da8dd96d5$export$b95b91cb8577b1db);
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $eFqO0 = parcelRequire("eFqO0");

var $eAqkd = parcelRequire("eAqkd");

var $4367K = parcelRequire("4367K");

var $4Jl0B = parcelRequire("4Jl0B");

var $ggAu1 = parcelRequire("ggAu1");

var $cw0wu = parcelRequire("cw0wu");

var $bUbIU = parcelRequire("bUbIU");

var $9Mjpq = parcelRequire("9Mjpq");

var $3y2s4 = parcelRequire("3y2s4");

var $bJsI4 = parcelRequire("bJsI4");

var $5N1Y4 = parcelRequire("5N1Y4");

var $4MvqL = parcelRequire("4MvqL");

var $lsRdH = parcelRequire("lsRdH");

var $3IvaM = parcelRequire("3IvaM");

var $8gaSy = parcelRequire("8gaSy");

var $1w5gT = parcelRequire("1w5gT");

var $kue9R = parcelRequire("kue9R");

var $2kimw = parcelRequire("2kimw");
const $071c600da8dd96d5$export$d970973925859b8e = ()=>{
    Object.entries($eAqkd).forEach(()=>{});
    Object.entries($eFqO0).forEach(()=>{});
};
const $071c600da8dd96d5$export$a04a448cc866246 = (initData, view, options, editorAnalyticsApi)=>{
    const { doc: doc, json: json, version: version, reserveCursor: reserveCursor } = initData;
    if (doc) {
        const { state: state } = view;
        const tr = (0, $2kimw.replaceDocument)(doc, state, version, options, reserveCursor, editorAnalyticsApi);
        tr.setMeta('isRemote', true);
        view.dispatch(tr);
    } else if (json) $071c600da8dd96d5$export$ff4f2767b9e99aa9(json, view, undefined, options, editorAnalyticsApi);
};
const $071c600da8dd96d5$export$cf9a0dcadb173615 = (connectionData, view)=>{
    const { state: { tr: tr } } = view;
    view.dispatch(tr.setMeta('sessionId', connectionData));
};
const $071c600da8dd96d5$export$f9db5387b510d6c = (presenceData, view)=>{
    const { state: { tr: tr } } = view;
    view.dispatch(tr.setMeta('presence', presenceData));
};
const $071c600da8dd96d5$export$c6643a6a2625d22c = (remoteData, view, options, editorAnalyticsApi)=>{
    const { json: json, userIds: userIds = [] } = remoteData;
    if (json) $071c600da8dd96d5$export$ff4f2767b9e99aa9(json, view, userIds, options, editorAnalyticsApi);
};
const $071c600da8dd96d5$export$ff4f2767b9e99aa9 = (json, view, userIds, options, editorAnalyticsApi)=>{
    if (!json || !json.length) return;
    const { state: state, state: { schema: schema } } = view;
    const steps = json.map((step)=>(0, $bUbIU.Step).fromJSON(schema, step));
    let tr;
    if (options && options.useNativePlugin && userIds) tr = (0, $bJsI4.receiveTransaction)(state, steps, userIds, {
        mapSelectionBackward: true
    });
    else {
        tr = state.tr;
        steps.forEach((step)=>tr.step(step));
    }
    if (tr) {
        const agentEditRequester = (0, $lsRdH.getAgentEditRequester)(json, view);
        const shouldRecordAgentEditInHistory = (agentEditRequester === null || agentEditRequester === void 0 ? void 0 : agentEditRequester.isLocalUserRequester) === true;
        tr.setMeta('addToHistory', shouldRecordAgentEditInHistory);
        tr.setMeta('isRemote', true);
        // Agent edit shimmer: mark the ranges agent steps just wrote so the plugin reveals them with the
        // skeleton loader, then (optionally) a purple "just edited" highlight. Gated as a whole so no
        // experiment reads run off-experiment; off-path leaves `agentShimmers` empty and everything below
        // is a no-op.
        let shimmerDurationMs = 0;
        let highlightDurationMs = 0;
        let agentShimmers = [];
        let visualJson = json;
        let visualSteps = steps;
        if (options !== null && options !== void 0 && options.useNativePlugin && userIds && ((0, $3y2s4.isExperimentEnabled)('platform_editor_ai_streaming_ux_experience_m1') || (0, $3y2s4.isExperimentEnabled)('platform_editor_agent_be_streaming'))) {
            var _sendableSteps;
            // Read the client ID before applying the acknowledgement, while the local steps
            // are still unconfirmed. receiveTransaction removes this same local prefix.
            // Exclude it from visuals too: the originating FE stream already owns its UI.
            const localClientId = (_sendableSteps = (0, $bJsI4.sendableSteps)(state)) === null || _sendableSteps === void 0 ? void 0 : _sendableSteps.clientID;
            let acknowledgedSteps = 0;
            if (localClientId != null) while(userIds[acknowledgedSteps] != null && String(userIds[acknowledgedSteps]) === String(localClientId))acknowledgedSteps++;
            // Keep both remote inputs aligned after removing the acknowledged prefix.
            // Unified chrome accounts for local rollback steps in the applied transaction;
            // the full batch still participates in collaboration, presence and attribution.
            visualJson = json.slice(acknowledgedSteps);
            visualSteps = steps.slice(acknowledgedSteps);
        }
        const isM1StreamingEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_ai_streaming_ux_experience_m1');
        const isUnifiedPostApplyChromeEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_ai_unified_post_apply_chrome');
        if (isUnifiedPostApplyChromeEnabled && (isM1StreamingEnabled || (0, $3y2s4.isExperimentEnabled)('platform_editor_agent_be_streaming'))) {
            const ranges = (0, $1w5gT.getAgentEditChromeRanges)(visualJson, visualSteps, tr, view, (reason, agentType, error)=>editorAnalyticsApi === null || editorAnalyticsApi === void 0 ? void 0 : editorAnalyticsApi.attachAnalyticsEvent((0, $4MvqL.getAgentEditShimmerNotShownPayload)(reason, agentType, error))(tr));
            const requester = (0, $lsRdH.getAgentEditRequester)(visualJson, view);
            if (ranges.length && requester) {
                // Collab supplies a machine agent type, not a display name; preserve the legacy
                // uppercase telepointer label as the fallback for observers that cannot resolve a
                // redesigned presentation from the forwarded identity.
                const telepointerLabel = requester.agentType.trim().toUpperCase();
                tr.setMeta((0, $4Jl0B.AGENT_EDIT_CHROME_DATA), {
                    ...!isM1StreamingEnabled ? (0, $4Jl0B.getAgentEditChromeDynamicConfig)() : {},
                    ...(0, $kue9R.getRemoteAgentChromeIdentity)(requester),
                    ...telepointerLabel ? {
                        telepointerLabel: telepointerLabel
                    } : {},
                    ranges: ranges
                });
            }
        }
        if (!isUnifiedPostApplyChromeEnabled && (0, $5N1Y4.expValEquals)('platform_editor_agent_be_streaming', 'isEnabled', true)) {
            // The skeleton and purple-highlight phases toggle independently. `shimmerDurationMs` is the
            // skeleton lifetime; `0` skips the skeleton (an edit can still get the purple highlight).
            shimmerDurationMs = (0, $9Mjpq.expVal)('platform_editor_agent_be_streaming', 'shimmerDurationMs', (0, $8gaSy.AGENT_SHIMMER_DEFAULT_DURATION_MS));
            // `highlightDurationMs` is the purple "just edited" highlight lifetime; `0` skips the highlight
            // (the skeleton still shows). `0` on both shows nothing.
            highlightDurationMs = (0, $9Mjpq.expVal)('platform_editor_agent_be_streaming', 'highlightDurationMs', (0, $8gaSy.AGENT_EDIT_HIGHLIGHT_DEFAULT_DURATION_MS));
            // Telepointer shown by default; `telepointerDisabled` hides it (inverted because `expVal`
            // only permits `false` as a boolean default).
            const telepointerEnabled = !(0, $9Mjpq.expVal)('platform_editor_agent_be_streaming', 'telepointerDisabled', false);
            agentShimmers = (0, $1w5gT.getAgentShimmerRanges)(visualJson, visualSteps, tr, view, shimmerDurationMs, highlightDurationMs, telepointerEnabled, // An agent edit that applied without the shimmer fires the operational event on the same
            // transaction, so success stays event-free and only degrades are reported.
            (reason, agentType, error)=>editorAnalyticsApi === null || editorAnalyticsApi === void 0 ? void 0 : editorAnalyticsApi.attachAnalyticsEvent((0, $4MvqL.getAgentEditShimmerNotShownPayload)(reason, agentType, error))(tr));
            if (agentShimmers.length) tr.setMeta((0, $8gaSy.ADD_AGENT_SHIMMER_META), agentShimmers);
        }
        // Record the agent's edit (original + new slice per change) onto this
        // transaction; `editor-plugin-ai` consumes the meta to open the BE Review moment.
        // Same eligibility as FE Review moment: xstate AND the M1 streaming UX
        // experiment. `getAgentEditSegments` self-gates (returns null for non-agent
        // edits, never throws), so this is a no-op for ordinary collaborator edits.
        if ((0, $4367K.isAiXstateMigrationEnabled)() && (0, $3y2s4.isExperimentEnabled)('platform_editor_ai_streaming_ux_experience_m1')) {
            const reviewData = (0, $3IvaM.getAgentEditSegments)(json, steps, tr, view);
            if (reviewData) tr.setMeta((0, $ggAu1.AGENT_REMOTE_EDIT_REVIEW_DATA), reviewData);
        }
        /*
     * Persist marks across transactions. Fixes an issue where
     * marks are lost if remote transactions are dispatched
     * between a user creating the mark and typing.
     */ if (state.tr.storedMarks) tr.setStoredMarks(state.tr.storedMarks);
        view.dispatch(tr);
        // Schedule each shimmer's phase changes. `dispatchMeta` is guarded so a timer firing after
        // teardown is a harmless no-op. Only reached when the gated block above produced ranges, so this
        // whole path is off-experiment-safe.
        if (agentShimmers.length) {
            let tornDownReported = false;
            const dispatchMeta = (metaKey, value)=>{
                try {
                    view.dispatch(view.state.tr.setMeta(metaKey, value));
                } catch  {
                    // View torn down before the timer fired — nothing to clean up. Report once (not once
                    // per shimmer) so we can see how often shimmers are interrupted by teardown.
                    if (!tornDownReported) {
                        tornDownReported = true;
                        editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.fireAnalyticsEvent((0, $4MvqL.getAgentEditShimmerNotShownPayload)('tornDownMidAnimation'));
                    }
                }
            };
            agentShimmers.forEach(({ shimmerId: shimmerId })=>{
                if (shimmerDurationMs > 0) // Skeleton first. When it clears, show the purple highlight (if enabled) then remove;
                // otherwise remove straight away.
                setTimeout(()=>{
                    if (highlightDurationMs > 0) {
                        dispatchMeta((0, $8gaSy.HIGHLIGHT_AGENT_SHIMMER_META), shimmerId);
                        setTimeout(()=>{
                            dispatchMeta((0, $8gaSy.REMOVE_AGENT_SHIMMER_META), shimmerId);
                        }, highlightDurationMs);
                    } else dispatchMeta((0, $8gaSy.REMOVE_AGENT_SHIMMER_META), shimmerId);
                }, shimmerDurationMs);
                else // Skeleton disabled: the range already starts in the highlight phase, so just time its
                // removal. (Reached only when `highlightDurationMs > 0`, else no ranges were produced.)
                setTimeout(()=>{
                    dispatchMeta((0, $8gaSy.REMOVE_AGENT_SHIMMER_META), shimmerId);
                }, highlightDurationMs);
            });
        }
    }
};
const $071c600da8dd96d5$export$abfa80d838a68fd6 = (telepointerData, view)=>{
    const { state: { tr: tr } } = view;
    view.dispatch(tr.setMeta('telepointer', telepointerData));
};
function $071c600da8dd96d5$var$isAllSelection(selection) {
    return selection instanceof (0, $cw0wu.AllSelection);
}
function $071c600da8dd96d5$var$isNodeSelection(selection) {
    return selection instanceof (0, $cw0wu.NodeSelection);
}
const $071c600da8dd96d5$export$b95b91cb8577b1db = (selection)=>{
    /**
   * <kbd>CMD + A</kbd> triggers a AllSelection
   * <kbd>escape</kbd> triggers a NodeSelection
   */ return {
        type: 'textSelection',
        anchor: selection.anchor,
        head: $071c600da8dd96d5$var$isAllSelection(selection) || $071c600da8dd96d5$var$isNodeSelection(selection) ? selection.head - 1 : selection.head
    };
};

});
parcelRegister("eFqO0", function(module, exports) {
$parcel$export(module.exports, "InsertTypeAheadStages", () => (parcelRequire("5sUZ8")).InsertTypeAheadStages);
$parcel$export(module.exports, "InsertTypeAheadStep", () => (parcelRequire("5sUZ8")).InsertTypeAheadStep);
$parcel$export(module.exports, "SetAttrsStep", () => (parcelRequire("4eNaz")).SetAttrsStep);
$parcel$export(module.exports, "AnalyticsStep", () => (parcelRequire("7ozbX")).AnalyticsStep);
$parcel$export(module.exports, "LinkMetaStep", () => (parcelRequire("jsWoI")).LinkMetaStep);
$parcel$export(module.exports, "OverrideDocumentStep", () => (parcelRequire("bgw29")).OverrideDocumentStep);
$parcel$export(module.exports, "BatchAttrsStep", () => (parcelRequire("48ZJc")).BatchAttrsStep);
/* eslint-disable @atlaskit/editor/no-re-export */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-re-exports -- Public compatibility re-export.

var $5sUZ8 = parcelRequire("5sUZ8");

var $4eNaz = parcelRequire("4eNaz");

var $7ozbX = parcelRequire("7ozbX");

var $jsWoI = parcelRequire("jsWoI");

var $bgw29 = parcelRequire("bgw29");

var $48ZJc = parcelRequire("48ZJc");

});
parcelRegister("bgw29", function(module, exports) {
$parcel$export(module.exports, "OverrideDocumentStep", () => $768dc733948754b3$export$d790696cf3da3aa0);

var $3DNV7 = parcelRequire("3DNV7");

var $bUbIU = parcelRequire("bUbIU");
const $768dc733948754b3$export$28ee9acdd4691fa9 = 'override-document';
class $768dc733948754b3$export$d790696cf3da3aa0 extends (0, $bUbIU.Step) {
    constructor(opts){
        super(), this.inverted = false, this.oldDocumentSize = 0;
        const { inverted: inverted, nextDocument: nextDocument } = opts;
        if (nextDocument.type.name !== 'doc') throw new Error('nextDocument should be the entire prosemirror doc node and not only its content.');
        this.nextDocument = nextDocument;
        this.inverted = Boolean(inverted);
    }
    apply(doc) {
        this.oldDocumentSize = doc.content.size;
        return (0, $3DNV7.StepResult).ok(this.nextDocument);
    }
    map() {
        return new $768dc733948754b3$export$d790696cf3da3aa0({
            nextDocument: this.nextDocument,
            inverted: this.inverted
        });
    }
    getMap() {
        if (!this.nextDocument || !this.oldDocumentSize) return new (0, $3DNV7.StepMap)([
            0,
            0,
            0
        ]);
        const oldSize = this.oldDocumentSize;
        const nextDocumentSize = this.nextDocument.content.size;
        return new (0, $3DNV7.StepMap)([
            0,
            oldSize,
            nextDocumentSize
        ]);
    }
    invert(doc) {
        return new $768dc733948754b3$export$d790696cf3da3aa0({
            nextDocument: doc,
            inverted: true
        });
    }
    toJSON() {
        return {
            stepType: $768dc733948754b3$export$28ee9acdd4691fa9,
            inverted: this.inverted,
            nextDocument: this.nextDocument.toJSON()
        };
    }
    static fromJSON(schema, json) {
        if (!json || json.stepType !== $768dc733948754b3$export$28ee9acdd4691fa9) throw new RangeError('Invalid overrideDocument step OverrideDocumentStep.fromJSON');
        return new $768dc733948754b3$export$d790696cf3da3aa0({
            inverted: json.inverted,
            nextDocument: schema.nodeFromJSON(json.nextDocument)
        });
    }
}
(0, $bUbIU.Step).jsonID($768dc733948754b3$export$28ee9acdd4691fa9, $768dc733948754b3$export$d790696cf3da3aa0);

});


parcelRegister("eAqkd", function(module, exports) {
$parcel$export(module.exports, "TableSortOrder", () => (parcelRequire("iJEtT")).SortOrder);
$parcel$export(module.exports, "TableSortStep", () => (parcelRequire("lDdgh")).TableSortStep);
$parcel$export(module.exports, "AddColumnStep", () => (parcelRequire("1hciC")).AddColumnStep);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $iJEtT = parcelRequire("iJEtT");

var $lDdgh = parcelRequire("lDdgh");

var $1hciC = parcelRequire("1hciC");

});

parcelRegister("4367K", function(module, exports) {
$parcel$export(module.exports, "isAiXstateMigrationEnabled", () => $9d53a76300c60e55$export$a306aa2b8fa250a5);

var $3y2s4 = parcelRequire("3y2s4");

var $5N1Y4 = parcelRequire("5N1Y4");
const $9d53a76300c60e55$export$a306aa2b8fa250a5 = ()=>(0, $5N1Y4.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true) || (0, $3y2s4.isExperimentEnabled)('platform_editor_ai_xstate_migration_jira');

});

parcelRegister("4Jl0B", function(module, exports) {
$parcel$export(module.exports, "AGENT_EDIT_CHROME_DATA", () => $788941cf2288b934$export$4a5bff77b793bc98);
$parcel$export(module.exports, "getAgentEditChromeDynamicConfig", () => $788941cf2288b934$export$c622006374915603);

var $9Mjpq = parcelRequire("9Mjpq");
const $788941cf2288b934$export$4a5bff77b793bc98 = 'agentEditChromeData';
const $788941cf2288b934$export$7de800288c4c9af3 = 2000;
const $788941cf2288b934$export$f5234c7b620d4724 = true;
const $788941cf2288b934$export$c622006374915603 = ()=>({
        autoDismissAfterMs: (0, $9Mjpq.expVal)('platform_editor_agent_be_streaming', 'highlightDurationMs', $788941cf2288b934$export$7de800288c4c9af3),
        telepointerEnabled: !(0, $9Mjpq.expVal)('platform_editor_agent_be_streaming', 'telepointerDisabled', !$788941cf2288b934$export$f5234c7b620d4724)
    });

});

parcelRegister("ggAu1", function(module, exports) {
$parcel$export(module.exports, "AGENT_REMOTE_EDIT_REVIEW_DATA", () => $713a9acee31c4e23$export$566f0440891acc8e);
const $713a9acee31c4e23$export$566f0440891acc8e = 'agentRemoteEditReviewData';

});

parcelRegister("lsRdH", function(module, exports) {
$parcel$export(module.exports, "isStepFromAgentEdit", () => $01c7d88713ab5267$export$f03bcbe4a8e9a968);
$parcel$export(module.exports, "getAgentEditRequester", () => $01c7d88713ab5267$export$2f1374fb6d9abffc);

var $vhR4H = parcelRequire("vhR4H");
const $01c7d88713ab5267$var$isAgentRemoteStep = (step)=>typeof step === 'object' && step !== null && typeof step.agentType === 'string';
const $01c7d88713ab5267$var$asString = (value)=>typeof value === 'string' ? value : undefined;
const $01c7d88713ab5267$export$f03bcbe4a8e9a968 = (step, requester)=>{
    if (!$01c7d88713ab5267$var$isAgentRemoteStep(step)) return false;
    return step.agentType === requester.agentType && $01c7d88713ab5267$var$asString(step.agentId) === requester.agentId && $01c7d88713ab5267$var$asString(step.agentSourceId) === requester.agentSourceId && $01c7d88713ab5267$var$asString(step.agentNamedId) === requester.agentNamedId && $01c7d88713ab5267$var$asString(step.userId) === requester.actorUserId && $01c7d88713ab5267$var$asString(step.invocationId) === requester.invocationId;
};
const $01c7d88713ab5267$export$2f1374fb6d9abffc = (json, view)=>{
    var _collabPluginState$ac;
    const agentStep = json.find($01c7d88713ab5267$var$isAgentRemoteStep);
    if (!agentStep) return null;
    const actorUserId = $01c7d88713ab5267$var$asString(agentStep.userId);
    const collabPluginState = (0, $vhR4H.pluginKey).getState(view.state);
    const localSessionId = collabPluginState === null || collabPluginState === void 0 ? void 0 : collabPluginState.sessionId;
    const localUserId = localSessionId ? collabPluginState === null || collabPluginState === void 0 || (_collabPluginState$ac = collabPluginState.activeParticipants) === null || _collabPluginState$ac === void 0 || (_collabPluginState$ac = _collabPluginState$ac.get(localSessionId)) === null || _collabPluginState$ac === void 0 ? void 0 : _collabPluginState$ac.userId : undefined;
    return {
        agentId: $01c7d88713ab5267$var$asString(agentStep.agentId),
        agentName: $01c7d88713ab5267$var$asString(agentStep.agentName),
        agentNamedId: $01c7d88713ab5267$var$asString(agentStep.agentNamedId),
        agentSourceId: $01c7d88713ab5267$var$asString(agentStep.agentSourceId),
        agentType: agentStep.agentType,
        actorUserId: actorUserId,
        invocationId: $01c7d88713ab5267$var$asString(agentStep.invocationId),
        isThirdPartyAgent: typeof agentStep.isThirdPartyAgent === 'boolean' ? agentStep.isThirdPartyAgent : undefined,
        isLocalUserRequester: actorUserId !== undefined && localUserId !== undefined && actorUserId === localUserId
    };
};

});
parcelRegister("vhR4H", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $66fa1551790a7526$export$18d4026d1ea86bb1);

var $cw0wu = parcelRequire("cw0wu");
const $66fa1551790a7526$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('collabEditPlugin');

});


parcelRegister("3IvaM", function(module, exports) {
$parcel$export(module.exports, "getAgentEditSegments", () => $920ef66e67a5c2ba$export$72163675ef60f4e3);

var $emSP1 = parcelRequire("emSP1");

var $j2Y9J = parcelRequire("j2Y9J");

var $9Mjpq = parcelRequire("9Mjpq");

var $bJsI4 = parcelRequire("bJsI4");

var $lsRdH = parcelRequire("lsRdH");

var $1w5gT = parcelRequire("1w5gT");
const $920ef66e67a5c2ba$export$7c03da4a40433b = 'platform_editor_backend_review_moment_agent_types';
// [CCI-17994] Post Stream Review ("Review moment") recording for BE streaming.
//
// Sibling to `getAgentShimmerRanges`, but for a different consumer: the shimmer
// only needs the NEW extent of added content, whereas the Review moment needs, per
// contiguous change, BOTH the pre-edit slice (for undo) and the new slice (for
// redo), and must keep deletions. The output is a neutral
// `AgentRemoteEditReviewData`; `editor-plugin-ai` turns each segment into a coarse
// `aiContentPositions` entry and reuses the entire FE Review moment pipeline.
//
// That pipeline requires every coarse entry to be a CLOSED, whole-node slice
// occupying exactly `[startPos, endPos]`. If a slice is left OPEN (a partial node,
// e.g. "…\nD") it drops the node wrapper on reconstruction — losing content on undo
// (data-loss bug) and bleeding highlights into neighbouring nodes. So we expand
// every change to whole-node outer boundaries and only emit self-consistent
// entries (see the group loop below).
const $920ef66e67a5c2ba$var$clampToDoc = (doc, pos)=>Math.min(Math.max(pos, 1), doc.content.size);
const $920ef66e67a5c2ba$var$topLevelBlockIndexAt = (doc, pos)=>doc.resolve($920ef66e67a5c2ba$var$clampToDoc(doc, pos)).index(0);
// Outer boundaries (before/after tokens) of the top-level node containing `pos`.
// Slicing between these includes each node's own wrapper tokens, so the slice is
// CLOSED (`openStart === openEnd === 0`) and preserves node type on reconstruction
// (a `heading` stays a heading). `depth === 0` means `pos` sits between top-level
// nodes, so it is already a node boundary.
// Whether `pos` sits INSIDE a top-level node (depth > 0) vs exactly on a node
// boundary (depth 0). Unlike `clampToDoc`, this clamps to `[0, size]` (allowing 0)
// so the doc-start boundary is correctly reported as a boundary, not forced into
// the first node. Used to tell a structural add/remove (zero-width span at a node
// boundary) from a text-only insert/delete inside a surviving node.
const $920ef66e67a5c2ba$var$isInsideNode = (doc, pos)=>doc.resolve(Math.min(Math.max(pos, 0), doc.content.size)).depth > 0;
const $920ef66e67a5c2ba$var$topLevelNodeStart = (doc, pos)=>{
    const $pos = doc.resolve($920ef66e67a5c2ba$var$clampToDoc(doc, pos));
    return $pos.depth === 0 ? $pos.pos : $pos.before(1);
};
const $920ef66e67a5c2ba$var$topLevelNodeEnd = (doc, pos)=>{
    const $pos = doc.resolve($920ef66e67a5c2ba$var$clampToDoc(doc, pos));
    return $pos.depth === 0 ? $pos.pos : $pos.after(1);
};
// Map a position in doc_{i+1} forward through the remaining steps to final-doc
// coords. Mirrors the shimmer's `mapToFinalDoc` — a later step's own inserted
// content starts at its `from`; only subsequent steps shift it.
const $920ef66e67a5c2ba$var$mapToFinalDoc = (steps, pos, stepIndex, bias)=>{
    let p = pos;
    for(let j = stepIndex + 1; j < steps.length; j++)p = steps[j].getMap().map(p, bias);
    return p;
};
// Map a step's `old` coord (valid in doc_i, this step's input) back to pre-batch
// (`tr.before`) coords by inverting the PRECEDING steps' maps in reverse. Needed to
// recover a deletion's original span: its new extent is zero-width, so it cannot be
// found by inverse-mapping the collapsed new point.
const $920ef66e67a5c2ba$var$mapToBeforeDoc = (steps, pos, stepIndex, bias)=>{
    let p = pos;
    for(let j = stepIndex - 1; j >= 0; j--)p = steps[j].getMap().invert().map(p, bias);
    return p;
};
const $920ef66e67a5c2ba$export$72163675ef60f4e3 = (json, steps, tr, view)=>{
    const agentEditRequester = (0, $lsRdH.getAgentEditRequester)(json, view);
    if (!agentEditRequester) return null;
    const { actorUserId: actorUserId, agentId: agentId, agentType: agentType, isLocalUserRequester: isLocalUserRequester } = agentEditRequester;
    // Only record Review Moment for agentTypes allowlisted in Statsig. Default `[]` fails
    // closed until the config is populated (CCI-18607).
    const allowedAgentTypes = (0, $9Mjpq.expVal)($920ef66e67a5c2ba$export$7c03da4a40433b, 'value', []);
    if (!allowedAgentTypes.includes(agentType)) return null;
    // Hybrid end-of-edit seam: if the BE/NCS flags a batch as the terminal one, carry
    // it so the AI plugin can open review immediately instead of waiting for the
    // debounce. Additive marker; absent for streaming (non-final) batches.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const complete = json.some((step)=>(step === null || step === void 0 ? void 0 : step.agentEditComplete) === true);
    // Same rebase guard as the shimmer: index-based range math is only valid if any
    // rebased-over local steps shifted no positions. Degrade to no recording otherwise.
    if (Number(tr.getMeta('rebased')) > 0) {
        var _getCollabState;
        const unconfirmed = ((_getCollabState = (0, $bJsI4.getCollabState)(view.state)) === null || _getCollabState === void 0 ? void 0 : _getCollabState.unconfirmed) ?? [];
        if (unconfirmed.some((entry)=>!(0, $1w5gT.isPositionNeutralStep)(entry.step))) return null;
    }
    try {
        // Each agent step's changed extent in FINAL-doc coords, taken from its StepMap
        // (the canonical, step-type-agnostic source). Unlike the shimmer we KEEP
        // zero-width new extents — a pure deletion has `newEnd === newStart` but is a
        // reviewable `remove`.
        const ranges = [];
        json.forEach((rawStep, index)=>{
            if (typeof (rawStep === null || rawStep === void 0 ? void 0 : rawStep.agentType) !== 'string') return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const pmStep = steps[index];
            if (typeof (pmStep === null || pmStep === void 0 ? void 0 : pmStep.getMap) !== 'function') return;
            // Mark-only steps have an empty StepMap, so the getMap().forEach below never fires for them.
            // Derive their range from step.from/.to so a formatting-only agent edit still becomes a segment.
            const markRange = (0, $1w5gT.getMarkStepRange)(steps[index]);
            if (markRange) {
                const mappedFrom = $920ef66e67a5c2ba$var$mapToFinalDoc(steps, markRange.from, index, -1);
                const mappedTo = $920ef66e67a5c2ba$var$mapToFinalDoc(steps, markRange.to, index, 1);
                const mappedOrigFrom = $920ef66e67a5c2ba$var$mapToBeforeDoc(steps, markRange.from, index, -1);
                const mappedOrigTo = $920ef66e67a5c2ba$var$mapToBeforeDoc(steps, markRange.to, index, 1);
                if (mappedTo > mappedFrom) try {
                    const before = tr.before.slice(mappedOrigFrom, mappedOrigTo);
                    const after = tr.doc.slice(mappedFrom, mappedTo);
                    if (!before.content.eq(after.content)) ranges.push({
                        from: mappedFrom,
                        to: mappedTo,
                        origFrom: mappedOrigFrom,
                        origTo: mappedOrigTo
                    });
                } catch (error) {
                    // Degrade gracefully (skip this step's range) but track the error so a silent
                    // fall-through does not hide a systemic slicing problem.
                    (0, $j2Y9J.logException)(error, {
                        location: 'editor-plugin-collab-edit/agent-review-segments/markStepSlice'
                    });
                }
                return;
            }
            pmStep.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
                const mappedFrom = $920ef66e67a5c2ba$var$mapToFinalDoc(steps, newStart, index, -1);
                const mappedTo = $920ef66e67a5c2ba$var$mapToFinalDoc(steps, newEnd, index, 1);
                // The same change in pre-batch coords, so a deletion (zero-width new
                // extent) still carries its original span.
                const mappedOrigFrom = $920ef66e67a5c2ba$var$mapToBeforeDoc(steps, oldStart, index, -1);
                const mappedOrigTo = $920ef66e67a5c2ba$var$mapToBeforeDoc(steps, oldEnd, index, 1);
                // Skip position-neutral phantom touches: the collab apply stamps same-size
                // re-writes on unrelated nodes (e.g. `localId` on panels). Drop them only
                // when byte-identical, so a real same-size replacement is preserved.
                if (oldEnd - oldStart === newEnd - newStart) try {
                    const before = tr.before.slice(oldStart, oldEnd);
                    const after = tr.doc.slice(mappedFrom, mappedTo);
                    if (before.content.eq(after.content)) return;
                } catch  {
                // Comparison unsafe: keep the range; whole-block expansion + the
                // later identical-content skip still guard against phantoms.
                }
                ranges.push({
                    from: mappedFrom,
                    to: mappedTo,
                    origFrom: mappedOrigFrom,
                    origTo: mappedOrigTo
                });
            });
        });
        if (!ranges.length) return null;
        // Coalesce fragments in the same/adjacent top-level block into one region (a
        // single agent edit arrives as many small replace fragments); an untouched block
        // between them splits the run so far-apart edits stay separate. Each region
        // becomes one coarse segment; the AI plugin refines it further.
        const sorted = [
            ...ranges
        ].sort((a, b)=>a.from - b.from || a.to - b.to);
        const groups = [];
        sorted.forEach((range)=>{
            const block = $920ef66e67a5c2ba$var$topLevelBlockIndexAt(tr.doc, range.from);
            const current = groups[groups.length - 1];
            // Coalesce changes in the same or directly-adjacent top-level block (index n /
            // n+1) into one region, exactly like the shimmer — a single agent edit arrives
            // as many small fragments. A genuinely untouched block in between (index gap
            // > 1) splits the run, keeping far-apart edits separate. The original span is
            // unioned in parallel so a deletion's removed content is preserved.
            if (current && block <= current.maxBlock + 1) {
                current.to = Math.max(current.to, range.to);
                current.maxBlock = Math.max(current.maxBlock, block);
                current.origFrom = Math.min(current.origFrom, range.origFrom);
                current.origTo = Math.max(current.origTo, range.origTo);
            } else groups.push({
                from: range.from,
                to: range.to,
                maxBlock: block,
                origFrom: range.origFrom,
                origTo: range.origTo
            });
        });
        const segments = [];
        groups.forEach((group)=>{
            try {
                // Expand the NEW extent to whole-node outer boundaries → a CLOSED slice.
                // A zero-width new extent at a top-level node boundary is a structural
                // deletion: leave it empty (do NOT whole-node expand, or it would grab the
                // unchanged neighbour node that now sits at that point and be discarded as an
                // identical phantom). A zero-width new extent INSIDE a node is a text-only
                // deletion from a surviving node, so expand to the whole node (an `update`).
                const newIsStructuralRemove = group.from === group.to && !$920ef66e67a5c2ba$var$isInsideNode(tr.doc, group.from);
                const newFrom = $920ef66e67a5c2ba$var$topLevelNodeStart(tr.doc, Math.min(group.from, group.to));
                const newTo = newIsStructuralRemove ? newFrom : $920ef66e67a5c2ba$var$topLevelNodeEnd(tr.doc, Math.max(group.from, group.to));
                const newSlice = tr.doc.slice(newFrom, newTo);
                // Build the ORIGINAL slice from the carried pre-batch span, expanded to whole
                // nodes → a CLOSED slice. Using the carried `origFrom/origTo` (from the
                // StepMap `old` coords) rather than inverse-mapping the new bounds is what
                // lets a deletion recover its removed content.
                //
                // A zero-width original span is only a true structural ADD when it sits at a
                // top-level node boundary (inserting a whole new node). A zero-width span
                // INSIDE a node is a text insertion into that node, so expand to the whole
                // node (an `update`) — matching how an in-place edit reviews.
                const origIsStructuralAdd = group.origFrom === group.origTo && !$920ef66e67a5c2ba$var$isInsideNode(tr.before, group.origFrom);
                const origFrom = $920ef66e67a5c2ba$var$topLevelNodeStart(tr.before, Math.min(group.origFrom, group.origTo));
                const origTo = origIsStructuralAdd ? origFrom : $920ef66e67a5c2ba$var$topLevelNodeEnd(tr.before, Math.max(group.origFrom, group.origTo));
                const originalSlice = tr.before.slice(origFrom, origTo);
                const originalEmpty = originalSlice.content.size === 0;
                const newEmpty = newSlice.content.size === 0;
                // A truly empty-to-empty region is not a change — skip it.
                if (originalEmpty && newEmpty) return;
                // Skip phantom artifacts: a same-size StepMap "touch" at an unrelated node
                // (e.g. a `localId` stamp on a panel during collab apply) expands to a
                // segment whose original and new content are identical — not a real change.
                // Layout-only marks (`breakout`) and `localId`s are ignored so a
                // breakout-width-only change is not recorded as a coarse segment: the FE
                // Review filter drops it anyway, so recording it here would anchor the modal
                // to a node with no visible diff.
                if ((0, $emSP1.slicesEqualIgnoringLocalId)(originalSlice, newSlice)) return;
                const kind = originalEmpty ? 'add' : newEmpty ? 'remove' : 'update';
                segments.push({
                    startPos: newFrom,
                    endPos: newTo,
                    originalSlice: originalSlice,
                    newSlice: newSlice,
                    kind: kind
                });
            } catch  {
            // One bad group must not drop the others.
            }
        });
        if (!segments.length) return null;
        return {
            actorUserId: actorUserId,
            agentId: agentId,
            agentType: agentType,
            complete: complete,
            isLocalUserRequester: isLocalUserRequester,
            segments: segments
        };
    } catch  {
        // Never throw into the shared remote-step handler; degrade to no recording.
        return null;
    }
};

});
parcelRegister("emSP1", function(module, exports) {
$parcel$export(module.exports, "slicesEqualIgnoringLocalId", () => $575de395f5b05dfd$export$aaa518e03f140665);
/**
 * ADF mark types ignored when deciding whether agent-edited content changed:
 *
 *   - `breakout` — a layout-width mark (`mode: wide | full-width`) that a
 *     whole-node/whole-doc replace (e.g. `replaceDoc`) can drop, re-add or
 *     re-value without the reviewable *content* changing.
 *
 * Module-private (not exported) so this file has a single public runtime export
 * (Volt strict-mode rule), and so callers cannot diverge from the one comparison
 * definition below.
 */ const $575de395f5b05dfd$var$IGNORED_MARK_TYPES = new Set([
    'breakout'
]);
/**
 * Deep-normalise ADF JSON for change comparison so two structures that differ
 * ONLY by ignorable metadata compare equal. Specifically it:
 *
 *   - strips every `localId` (at any nesting): an ephemeral, per-node identity
 *     stamp that lives both as a node attribute (`attrs.localId`) and as a
 *     `fragment` mark attribute. A whole-node/whole-doc replace (e.g.
 *     `replaceDoc`) re-emits content with FRESH localIds, so content that is
 *     otherwise identical legitimately carries different localIds.
 *   - drops ignorable marks (`IGNORED_MARK_TYPES`, e.g. `breakout`) from every
 *     `marks` array, and removes a `marks` key that becomes empty so `marks: []`
 *     and an absent `marks` compare equal.
 *
 * Removing these regardless of nesting handles all carriers without needing to
 * know the schema.
 */ const $575de395f5b05dfd$var$normaliseForChangeCompare = (value)=>{
    if (Array.isArray(value)) return value.map($575de395f5b05dfd$var$normaliseForChangeCompare);
    if (value && typeof value === 'object') {
        const result = {};
        for (const [key, child] of Object.entries(value)){
            if (key === 'localId') continue;
            if (key === 'marks' && Array.isArray(child)) {
                const kept = child.filter((mark)=>!(mark && typeof mark === 'object' && $575de395f5b05dfd$var$IGNORED_MARK_TYPES.has(mark.type)));
                // Drop an empty `marks` array so `marks: []` == absent `marks`.
                if (kept.length > 0) result[key] = kept.map($575de395f5b05dfd$var$normaliseForChangeCompare);
                continue;
            }
            result[key] = $575de395f5b05dfd$var$normaliseForChangeCompare(child);
        }
        return result;
    }
    return value;
};
const $575de395f5b05dfd$export$aaa518e03f140665 = (a, b)=>{
    if (a === b) return true;
    if (a.openStart !== b.openStart || a.openEnd !== b.openEnd) return false;
    // `Fragment.toJSON()` returns `null` for empty content; normalise so two
    // empty slices (whatever their provenance) still compare equal.
    const aContent = $575de395f5b05dfd$var$normaliseForChangeCompare(a.content.toJSON() ?? null);
    const bContent = $575de395f5b05dfd$var$normaliseForChangeCompare(b.content.toJSON() ?? null);
    return JSON.stringify(aContent) === JSON.stringify(bContent);
};

});

parcelRegister("1w5gT", function(module, exports) {
$parcel$export(module.exports, "isPositionNeutralStep", () => $5b531db30ba5e789$export$6e1942fa8b890756);
$parcel$export(module.exports, "getMarkStepRange", () => $5b531db30ba5e789$export$c78340582aaebc79);
$parcel$export(module.exports, "getAgentShimmerRanges", () => $5b531db30ba5e789$export$f64f53873128087b);
$parcel$export(module.exports, "getAgentEditChromeRanges", () => $5b531db30ba5e789$export$e3e1a593a0c5d01c);

var $dbqrR = parcelRequire("dbqrR");

var $emSP1 = parcelRequire("emSP1");

var $j2Y9J = parcelRequire("j2Y9J");

var $3DNV7 = parcelRequire("3DNV7");

var $3y2s4 = parcelRequire("3y2s4");

var $bJsI4 = parcelRequire("bJsI4");

var $5N1Y4 = parcelRequire("5N1Y4");

var $lsRdH = parcelRequire("lsRdH");
// When an agent step lands we cover the top-level block(s) it wrote with a skeleton-loader shimmer
// (plus a Rovo agent telepointer at the end of the range), then remove it on a timer to reveal the
// content. Gated behind the `platform_editor_agent_be_streaming` experiment. `shimmerDurationMs` and
// `highlightDurationMs` size the skeleton and purple-highlight phases and toggle independently: `0` on
// either skips that phase, `0` on both shows nothing.
let $5b531db30ba5e789$var$agentShimmerIdCounter = 0;
const $5b531db30ba5e789$export$6e1942fa8b890756 = (step)=>{
    let neutral = true;
    step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
        if (oldEnd - oldStart !== newEnd - newStart) neutral = false;
    });
    return neutral;
};
const $5b531db30ba5e789$export$c78340582aaebc79 = (step)=>{
    if (step instanceof (0, $3DNV7.AddMarkStep) || step instanceof (0, $3DNV7.RemoveMarkStep)) return {
        from: step.from,
        to: step.to
    };
    return null;
};
// Top-level block/position helpers over a doc. Kept at module scope (rather than re-created as
// closures on every call) so they are defined once, reusable, and unit-testable. Each clamps into
// valid document coordinates before resolving.
const $5b531db30ba5e789$var$clampToDoc = (doc, pos)=>Math.min(Math.max(pos, 1), doc.content.size);
const $5b531db30ba5e789$var$topLevelBlockIndexAt = (doc, pos)=>doc.resolve($5b531db30ba5e789$var$clampToDoc(doc, pos)).index(0);
// Start of the content of the top-level block containing `pos`, so the whole block is covered.
const $5b531db30ba5e789$var$topLevelBlockContentStart = (doc, pos)=>{
    const $pos = doc.resolve($5b531db30ba5e789$var$clampToDoc(doc, pos));
    return $pos.depth >= 1 ? $pos.start(1) : pos;
};
// End of the content of the top-level block containing `pos`, so the whole block is covered.
const $5b531db30ba5e789$var$topLevelBlockContentEnd = (doc, pos)=>{
    const $pos = doc.resolve($5b531db30ba5e789$var$clampToDoc(doc, pos));
    return $pos.depth >= 1 ? $pos.end(1) : pos;
};
/**
 * Derive the shimmer ranges for the agent-authored steps in a received batch, in final-doc
 * coordinates. `agentType` present ⇒ agent-authored (per the NCS↔Editor steps contract). Each
 * emitted range is expanded to the whole top-level block(s) the agent touched, which the plugin
 * covers with the skeleton shimmer. Ranges with no new content (pure deletions) are dropped.
 *
 * Steps whose new content is in the same or directly-adjacent top-level block are coalesced into one
 * range, so an edit that arrives as several steps in a region shimmers as a single unit. Edits
 * separated by an untouched block stay independent.
 *
 * Correctness: the range math assumes `tr` is a linear 1:1 apply of `steps`. Under the native collab
 * plugin, `receiveTransaction` rebases incoming steps over unconfirmed local steps when they exist;
 * that only invalidates our positions if a local step shifted positions, so we skip solely when a
 * rebased local step changed sizes (a rare, safe degrade). Any unexpected error also degrades to no
 * shimmer, so this never throws into the shared remote-step handler.
 */ const $5b531db30ba5e789$var$deriveAgentShimmerRanges = (json, steps, tr, view, shimmerDurationMs, highlightDurationMs, telepointerEnabled, onNotShown)=>{
    var _json$find;
    // The two phases toggle independently: `shimmerDurationMs` sizes the skeleton, `highlightDurationMs`
    // sizes the purple highlight, and `0` on either skips just that phase. Nothing to reveal only when
    // both are off.
    if (shimmerDurationMs <= 0 && highlightDurationMs <= 0) return [];
    // Start in the skeleton phase when it's enabled, otherwise straight into the purple highlight phase
    // (skeleton toggled off, highlight on).
    const initialPhase = shimmerDurationMs > 0 ? 'skeleton' : 'highlight';
    // Telepointer label = the agent's type upper-cased (e.g. `mcp` → "MCP"), falling back to a generic
    // "Agent"; `undefined` when the telepointer is disabled, so the plugin skips it. `agentType` is the
    // same on every step of an agent batch, so read it from the first agent-authored step.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const agentType = (_json$find = json.find((step)=>typeof (step === null || step === void 0 ? void 0 : step.agentType) === 'string')) === null || _json$find === void 0 ? void 0 : _json$find.agentType;
    // No agent-authored steps in this batch — nothing to shimmer, and not a "not shown" case.
    if (agentType === undefined) return [];
    const telepointerLabel = telepointerEnabled ? agentType.toUpperCase() || 'Agent' : undefined;
    // When the batch was rebased over local unconfirmed steps, our index-based range math is only
    // valid if those local steps shifted no positions. Attribute-only steps (e.g. `localId`) and
    // same-size replacements are position-neutral, so the shimmer stays correct. Skip only when a
    // local step actually changed sizes (a genuine concurrent content edit).
    if (Number(tr.getMeta('rebased')) > 0) {
        var _getCollabState;
        const unconfirmed = ((_getCollabState = (0, $bJsI4.getCollabState)(view.state)) === null || _getCollabState === void 0 ? void 0 : _getCollabState.unconfirmed) ?? [];
        if (unconfirmed.some((entry)=>!$5b531db30ba5e789$export$6e1942fa8b890756(entry.step))) {
            onNotShown === null || onNotShown === void 0 || onNotShown('rebasedConcurrentEdit', agentType);
            return [];
        }
    }
    try {
        // Map an inserted range in doc_{i+1} forward through the remaining steps to final-doc coords.
        // (A later step's own inserted content starts at its `from`; only subsequent steps shift it.)
        const mapToFinalDoc = (pos, stepIndex, bias)=>{
            let p = pos;
            for(let j = stepIndex + 1; j < steps.length; j++)p = steps[j].getMap().map(p, bias);
            return p;
        };
        const infos = [];
        json.forEach((rawStep, index)=>{
            if (typeof (rawStep === null || rawStep === void 0 ? void 0 : rawStep.agentType) !== 'string') return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const pmStep = steps[index];
            if (typeof (pmStep === null || pmStep === void 0 ? void 0 : pmStep.getMap) !== 'function') return;
            // Mark-only steps have an empty StepMap, so the getMap().forEach below never fires for them.
            // Derive their range from step.from/.to instead so formatting-only agent edits still shimmer.
            const markRange = $5b531db30ba5e789$export$c78340582aaebc79(steps[index]);
            if (markRange) {
                const beforeDocForMark = tr.docs[index] ?? tr.before;
                const from = mapToFinalDoc(markRange.from, index, -1);
                const to = mapToFinalDoc(markRange.to, index, 1);
                if (to > from) try {
                    const before = beforeDocForMark.slice(markRange.from, markRange.to);
                    const after = tr.doc.slice(from, to);
                    if (!(0, $emSP1.slicesEqualIgnoringLocalId)(before, after)) infos.push({
                        from: from,
                        to: to
                    });
                } catch (error) {
                    // Degrade gracefully (no shimmer for this step) but track the error so a silent
                    // fall-through does not hide a systemic slicing problem.
                    (0, $j2Y9J.logException)(error, {
                        location: 'editor-plugin-collab-edit/agent-shimmer-ranges/markStepSlice'
                    });
                }
                return;
            }
            // The doc this step was applied to (its `old` coords resolve here). `tr.docs[index]` is the
            // document state before step `index`; fall back to the batch's before-doc for the first step.
            const beforeDoc = tr.docs[index] ?? tr.before;
            pmStep.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
                if (newEnd <= newStart) return; // pure deletion / attribute-only — no new content to highlight
                const from = mapToFinalDoc(newStart, index, -1);
                const to = mapToFinalDoc(newEnd, index, 1);
                // Skip phantom same-size re-writes (e.g. a `localId`/breakout re-stamp on an untouched
                // panel): their StepMap reports new content but nothing visibly changed. Drop only when
                // before/after are equal ignoring `localId` and layout marks, so real same-size edits
                // still shimmer. Mirrors the Review-moment segment producer's guard.
                if (oldEnd - oldStart === newEnd - newStart) try {
                    const before = beforeDoc.slice(oldStart, oldEnd);
                    const after = tr.doc.slice(from, to);
                    if ((0, $emSP1.slicesEqualIgnoringLocalId)(before, after)) return;
                } catch  {
                // Comparison unsafe: keep the range; whole-block expansion still renders it.
                }
                infos.push({
                    from: from,
                    to: to
                });
            });
        });
        if (!infos.length) {
            onNotShown === null || onNotShown === void 0 || onNotShown('nothingToShow', agentType);
            return [];
        }
        // Group the changed ranges by the TOP-LEVEL block they landed in, then highlight each touched
        // block IN FULL. NCS emits a single agent edit as many small replace fragments and often keeps a
        // common prefix/suffix untouched, so the changed sub-ranges cover only part of a block (e.g. half
        // a rewritten heading). Expanding to the whole block's content makes the entire heading/paragraph
        // shimmer as one unit rather than leaving the unchanged half undecorated. Directly-adjacent
        // touched blocks (index n and n+1) merge into one group so a multi-block rewrite reveals together;
        // a genuinely untouched block in between (index gap > 1) splits the run, so far-apart edits stay
        // independent.
        const sorted = [
            ...infos
        ].sort((a, b)=>a.from - b.from || a.to - b.to);
        const groups = [];
        sorted.forEach((info)=>{
            const block = $5b531db30ba5e789$var$topLevelBlockIndexAt(tr.doc, info.from);
            const current = groups[groups.length - 1];
            if (current && block <= current.maxBlock + 1) {
                current.to = Math.max(current.to, info.to);
                current.maxBlock = Math.max(current.maxBlock, block);
            } else groups.push({
                from: info.from,
                to: info.to,
                maxBlock: block
            });
        });
        return groups.map((group)=>({
                shimmerId: `agent-shimmer-${$5b531db30ba5e789$var$agentShimmerIdCounter++}`,
                from: $5b531db30ba5e789$var$topLevelBlockContentStart(tr.doc, group.from),
                to: $5b531db30ba5e789$var$topLevelBlockContentEnd(tr.doc, group.to),
                telepointerLabel: telepointerLabel,
                phase: initialPhase,
                highlightDurationMs: highlightDurationMs
            }));
    } catch (err) {
        // Never let shimmer range derivation throw into the shared remote-step handler; degrade to no
        // shimmer.
        onNotShown === null || onNotShown === void 0 || onNotShown('captureThrew', agentType, err);
        return [];
    }
};
const $5b531db30ba5e789$export$f64f53873128087b = (json, steps, tr, view, shimmerDurationMs, highlightDurationMs, telepointerEnabled, onNotShown)=>{
    if (!(0, $5N1Y4.expValEquals)('platform_editor_agent_be_streaming', 'isEnabled', true)) return [];
    return $5b531db30ba5e789$var$deriveAgentShimmerRanges(json, steps, tr, view, shimmerDurationMs, highlightDurationMs, telepointerEnabled, onNotShown);
};
const $5b531db30ba5e789$export$e3e1a593a0c5d01c = (json, steps, tr, view, onNotShown)=>{
    var _json$find2;
    const agentType = (_json$find2 = json.find((step)=>typeof (step === null || step === void 0 ? void 0 : step.agentType) === 'string')) === null || _json$find2 === void 0 ? void 0 : _json$find2.agentType;
    if (agentType === undefined) return [];
    const rebasedSteps = Number(tr.getMeta('rebased')) || 0;
    if (rebasedSteps > 0) {
        var _getCollabState2;
        const unconfirmed = ((_getCollabState2 = (0, $bJsI4.getCollabState)(view.state)) === null || _getCollabState2 === void 0 ? void 0 : _getCollabState2.unconfirmed) ?? [];
        if (unconfirmed.some((entry)=>!$5b531db30ba5e789$export$6e1942fa8b890756(entry.step))) {
            onNotShown === null || onNotShown === void 0 || onNotShown('rebasedConcurrentEdit', agentType);
            return [];
        }
    }
    try {
        // The caller removes the acknowledged local prefix. receiveTransaction then
        // rolls back unconfirmed local steps before applying these remote steps, and
        // replays the local steps afterwards. Select the actual applied remote indexes;
        // the shared extractor maps them through every later step into tr.doc.
        const m1Enabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_ai_streaming_ux_experience_m1');
        const requester = m1Enabled ? (0, $lsRdH.getAgentEditRequester)(json, view) : null;
        const includedStepIndexes = [];
        json.forEach((rawStep, index)=>{
            const belongsToSelectedAgent = !requester || (0, $lsRdH.isStepFromAgentEdit)(rawStep, requester);
            if (typeof (rawStep === null || rawStep === void 0 ? void 0 : rawStep.agentType) === 'string' && steps[index] && belongsToSelectedAgent) includedStepIndexes.push(rebasedSteps + index);
        });
        const ranges = (0, $dbqrR.getAgentEditChangedRanges)(tr, includedStepIndexes, {
            requireUniqueSourceIds: m1Enabled
        });
        if (!ranges.length) onNotShown === null || onNotShown === void 0 || onNotShown('nothingToShow', agentType);
        return ranges;
    } catch (error) {
        onNotShown === null || onNotShown === void 0 || onNotShown('captureThrew', agentType, error);
        return [];
    }
};

});
parcelRegister("dbqrR", function(module, exports) {
$parcel$export(module.exports, "getAgentEditChangedRanges", () => $4523a543d66daf5e$export$7d69a93c86ead54f);

var $hkuUA = parcelRequire("hkuUA");
function $4523a543d66daf5e$export$7d69a93c86ead54f(tr, includedStepIndexes, options) {
    return (0, $hkuUA.agentEditRangeMapping).getChangedRanges(tr, includedStepIndexes, (options === null || options === void 0 ? void 0 : options.requireUniqueSourceIds) ?? false);
}

});
parcelRegister("hkuUA", function(module, exports) {
$parcel$export(module.exports, "agentEditRangeMapping", () => $dd6bd42dd0b963fe$export$c43a947daf0cb617);

var $dMMwa = parcelRequire("dMMwa");
// localId is identity metadata: regenerating it alone should not create activity.
const $dd6bd42dd0b963fe$var$sameAttrs = (left, right)=>{
    const keys = Object.keys(left).filter((key)=>key !== 'localId');
    return keys.length === Object.keys(right).filter((key)=>key !== 'localId').length && keys.every((key)=>(0, (/*@__PURE__*/$parcel$interopDefault($dMMwa)))(left[key], right[key]));
};
// Compare the node's own type, attributes and marks, without comparing its children.
const $dd6bd42dd0b963fe$var$sameMarkup = (left, right)=>left.type === right.type && $dd6bd42dd0b963fe$var$sameAttrs(left.attrs, right.attrs) && left.marks.length === right.marks.length && left.marks.every((mark, index)=>mark.type === right.marks[index].type && $dd6bd42dd0b963fe$var$sameAttrs(mark.attrs, right.marks[index].attrs));
const $dd6bd42dd0b963fe$var$sameNode = (left, right)=>{
    if (left === right) return true;
    if (!$dd6bd42dd0b963fe$var$sameMarkup(left, right) || left.text !== right.text || left.childCount !== right.childCount) return false;
    for(let index = 0; index < left.childCount; index++){
        if (!$dd6bd42dd0b963fe$var$sameNode(left.child(index), right.child(index))) return false;
    }
    return true;
};
const $dd6bd42dd0b963fe$var$getSnapshotIndex = (doc, indexes)=>{
    const cached = indexes.get(doc);
    if (cached) return cached;
    const snapshot = {
        byId: new Map(),
        byPosition: new Map(),
        nodes: [],
        textblocks: []
    };
    const parents = [
        {
            node: doc,
            pos: -1,
            index: 0
        }
    ];
    doc.descendants((node, pos, _parent, index)=>{
        // Track ancestry by position because one immutable node can occupy several slots.
        while(parents.length > 1 && pos >= parents[parents.length - 1].pos + parents[parents.length - 1].node.nodeSize - 1)parents.pop();
        const positioned = {
            node: node,
            pos: pos,
            parent: parents[parents.length - 1],
            index: index
        };
        snapshot.byPosition.set(pos, positioned);
        snapshot.nodes.push(positioned);
        if (node.isTextblock) snapshot.textblocks.push(positioned);
        const id = node.attrs.localId;
        if (typeof id === 'string' && id) snapshot.byId.set(id, snapshot.byId.has(id) ? null : positioned);
        if (!node.isLeaf) parents.push(positioned);
    });
    indexes.set(doc, snapshot);
    return snapshot;
};
const $dd6bd42dd0b963fe$var$indexedNodeAt = (doc, pos, indexes)=>{
    const snapshot = $dd6bd42dd0b963fe$var$getSnapshotIndex(doc, indexes);
    const exact = snapshot.byPosition.get(pos);
    if (exact) return exact.node;
    // nodeAt also returns a text node when the position is inside its text.
    let low = 0;
    let high = snapshot.nodes.length;
    while(low < high){
        const middle = low + high >>> 1;
        if (snapshot.nodes[middle].pos <= pos) low = middle + 1;
        else high = middle;
    }
    const previous = snapshot.nodes[low - 1];
    return previous !== null && previous !== void 0 && previous.node.isText && pos < previous.pos + previous.node.nodeSize ? previous.node : undefined;
};
const $dd6bd42dd0b963fe$var$collectChanges = (before, after, map, ranges)=>{
    const { node: node, pos: pos } = after;
    if (before && $dd6bd42dd0b963fe$var$sameNode(before.node, node)) return;
    // Text edits belong to their textblock. A node's own markup change instead
    // owns its full content, so we stop here rather than adding child ranges too.
    const markupChanged = !!before && node.isBlock && !$dd6bd42dd0b963fe$var$sameMarkup(before.node, node);
    if (node.isTextblock || markupChanged) {
        if (node.content.size > 0) ranges.push({
            from: pos,
            to: pos + node.nodeSize,
            markupChanged: markupChanged
        });
        return;
    }
    const byPosition = new Map();
    const byId = new Map();
    const oldChildren = [];
    before === null || before === void 0 || before.node.forEach((child, offset)=>{
        // forEach offsets start inside the parent. Skip its opening boundary (+1)
        // to convert this child offset into an absolute document position.
        const previous = {
            node: child,
            pos: before.pos + 1 + offset
        };
        oldChildren.push(previous);
        // This 1 is a mapping bias, not an added offset: follow the right side
        // of an insertion at the child's start, keeping the original child after it.
        const mapped = map.mapResult(previous.pos, 1);
        if (!mapped.deleted) byPosition.set(mapped.pos, previous);
        const id = child.attrs.localId;
        if (typeof id === 'string' && id) // Duplicate IDs cannot identify a unique old child.
        byId.set(id, byId.has(id) ? null : previous);
    });
    const nextChildren = [];
    node.forEach((child, offset)=>nextChildren.push({
            node: child,
            pos: pos + 1 + offset
        }));
    // Narrow edits usually preserve mapped positions. Whole-container replacements
    // may erase those positions, so stable child IDs provide a second way to match.
    const preferred = nextChildren.map((next)=>byPosition.get(next.pos) ?? byId.get(next.node.attrs.localId) ?? undefined);
    const claims = new Map();
    for (const match of preferred)if (match) claims.set(match, (claims.get(match) ?? 0) + 1);
    nextChildren.forEach((next, index)=>{
        const match = preferred[index];
        // Same-index fallback supports replacements that regenerate IDs but keep
        // the child structure. Different child counts make that correspondence unsafe.
        const aligned = oldChildren.length === node.childCount ? oldChildren[index] : undefined;
        // Reserve every position/ID match before fallback, including later siblings.
        // Reusing one old sibling can otherwise disguise an equal-text insertion.
        const previous = match && claims.get(match) === 1 ? match : aligned && !claims.has(aligned) ? aligned : undefined;
        $dd6bd42dd0b963fe$var$collectChanges(previous, next, map, ranges);
    });
};
const $dd6bd42dd0b963fe$var$findPreservedNode = (before, doc, previous, markupChanged, indexes)=>{
    const id = previous.attrs.localId;
    if (typeof id !== 'string' || !id) return;
    // When source uniqueness is required, removing a duplicate must not transfer
    // its activity to the remaining equal-content sibling.
    if (before && !$dd6bd42dd0b963fe$var$getSnapshotIndex(before, indexes).byId.get(id)) return;
    const match = $dd6bd42dd0b963fe$var$getSnapshotIndex(doc, indexes).byId.get(id);
    // Attribute/mark activity belongs to the node even when its children are edited.
    // Content-only activity still requires the entire candidate to survive unchanged.
    const isPreserved = markupChanged ? $dd6bd42dd0b963fe$var$sameMarkup : $dd6bd42dd0b963fe$var$sameNode;
    return match && isPreserved(previous, match.node) ? match : undefined;
};
const $dd6bd42dd0b963fe$var$findAlignedTextblock = (before, after, pos, offsets, indexes)=>{
    let original = $dd6bd42dd0b963fe$var$getSnapshotIndex(before, indexes).byPosition.get(pos);
    const path = [];
    while((_original = original) !== null && _original !== void 0 && _original.parent){
        var _original;
        path.push(original);
        original = original.parent;
    }
    let parent = after;
    let parentPos = -1;
    for (const child of path.reverse()){
        var _child$parent;
        const originalParent = (_child$parent = child.parent) === null || _child$parent === void 0 ? void 0 : _child$parent.node;
        if (!originalParent) return;
        if (parent.type !== originalParent.type || parent.childCount !== originalParent.childCount) return;
        const index = child.index;
        if (index >= parent.childCount) return;
        let childOffsets = offsets.get(parent);
        if (!childOffsets) {
            const computedOffsets = [];
            parent.forEach((_child, offset)=>computedOffsets.push(offset));
            childOffsets = computedOffsets;
            offsets.set(parent, childOffsets);
        }
        parentPos += 1 + childOffsets[index];
        parent = parent.child(index);
    }
    return parent.isTextblock ? {
        node: parent,
        pos: parentPos
    } : undefined;
};
const $dd6bd42dd0b963fe$var$mapToFinalBlocks = (tr, index, range, indexes, options)=>{
    const { alignedOffsets: alignedOffsets, requireUniqueSourceIds: requireUniqueSourceIds } = options;
    // Carried ranges can cover every block in a document. Repeated nodeAt calls
    // scan preceding siblings, so reuse one positioned index per snapshot instead.
    const nodeAt = (doc, pos)=>alignedOffsets ? $dd6bd42dd0b963fe$var$indexedNodeAt(doc, pos, indexes) : doc.nodeAt(pos);
    let { from: from, to: to } = range;
    // Track inner content separately from outer node bounds: +1 skips the opening
    // boundary and -1 excludes the closing boundary (see paragraph example above).
    let contentFrom = from + 1;
    let contentTo = to - 1;
    // docs[i] is the document BEFORE step i, so docs[i + 1] is its result.
    // The last step has no next snapshot; tr.doc is its result instead.
    let node = nodeAt(tr.docs[index + 1] ?? tr.doc, from);
    if (!node) return [];
    // Later non-AI steps also shift/delete existing activity, even though they
    // cannot create new activity themselves. Process every intermediate document.
    for(let next = index + 1; next < tr.steps.length; next++){
        const map = tr.mapping.maps[next];
        const after = tr.docs[next + 1] ?? tr.doc;
        // Mapping biases +1 (right) and -1 (left) keep boundary insertions outside
        // the tracked content. These arguments do not add/subtract document positions.
        const start = map.mapResult(contentFrom, 1);
        const end = map.mapResult(contentTo, -1);
        if (start.deleted && end.deleted || end.pos <= start.pos) {
            var _indexes$get, _indexes$get2;
            // A cumulative replacement can preserve the candidate content or owned markup.
            // Check every intermediate doc so deletion then reinsertion never resurrects it.
            let preserved = $dd6bd42dd0b963fe$var$findPreservedNode(requireUniqueSourceIds ? tr.docs[next] : undefined, after, node, range.markupChanged, indexes);
            const id = node.attrs.localId;
            const sourceMatch = typeof id === 'string' && id ? (_indexes$get = indexes.get(tr.docs[next])) === null || _indexes$get === void 0 ? void 0 : _indexes$get.byId.get(id) : undefined;
            const idMatch = typeof id === 'string' && id ? (_indexes$get2 = indexes.get(after)) === null || _indexes$get2 === void 0 ? void 0 : _indexes$get2.byId.get(id) : undefined;
            if (!preserved && alignedOffsets && sourceMatch !== null && idMatch === undefined) {
                // Inline replacements can keep a block's opening boundary while
                // recreating its content and adding later blocks to the same chunk.
                const mapped = map.mapResult(from, 1);
                const mappedNode = !mapped.deleted ? nodeAt(after, mapped.pos) : undefined;
                if (mappedNode !== null && mappedNode !== void 0 && mappedNode.isTextblock && $dd6bd42dd0b963fe$var$sameNode(node, mappedNode)) preserved = {
                    node: mappedNode,
                    pos: mapped.pos
                };
                else {
                    // Whole-block replacements may recreate unchanged blocks without IDs.
                    // Match their slot only while every parent keeps its shape.
                    const aligned = $dd6bd42dd0b963fe$var$findAlignedTextblock(tr.docs[next], after, from, alignedOffsets, indexes);
                    if (aligned && $dd6bd42dd0b963fe$var$sameNode(node, aligned.node)) preserved = aligned;
                }
            }
            if (!preserved) return [];
            from = preserved.pos;
            to = from + preserved.node.nodeSize;
            contentFrom = from + 1;
            contentTo = to - 1;
            node = preserved.node;
        } else {
            // Apply the same inward biases to the outer node bounds.
            from = map.map(from, 1);
            to = map.map(to, -1);
            contentFrom = start.pos;
            contentTo = end.pos;
            const current = nodeAt(after, from);
            if (current && current.nodeSize === to - from) node = current;
        }
    }
    if (from < 0 || to > tr.doc.content.size || contentTo <= contentFrom) return [];
    const finalNode = nodeAt(tr.doc, from);
    if (finalNode !== null && finalNode !== void 0 && finalNode.isBlock && finalNode.nodeSize === to - from) return [
        {
            from: from,
            to: to
        }
    ];
    // Joins/splits can leave mapped boundaries inside the final textblock.
    const blocks = [];
    if (alignedOffsets) {
        const textblocks = $dd6bd42dd0b963fe$var$getSnapshotIndex(tr.doc, indexes).textblocks;
        let low = 0;
        let high = textblocks.length;
        while(low < high){
            const middle = low + high >>> 1;
            const candidate = textblocks[middle];
            if (candidate.pos + candidate.node.nodeSize <= contentFrom) low = middle + 1;
            else high = middle;
        }
        for(let index = low; index < textblocks.length && textblocks[index].pos < contentTo; index++){
            const { node: node, pos: pos } = textblocks[index];
            blocks.push({
                from: pos,
                to: pos + node.nodeSize
            });
        }
        return blocks;
    }
    tr.doc.nodesBetween(contentFrom, contentTo, (child, pos)=>{
        if (child.isTextblock) {
            blocks.push({
                from: pos,
                to: pos + child.nodeSize
            });
            return false;
        }
    });
    return blocks;
};
/**
 * Maps existing textblock activity through each applied step into tr.doc coordinates.
 * Replaced content is dropped unless an unchanged block survives with a unique ID
 * or in the same structural slot. Newly changed blocks belong to the producer.
 */ function $dd6bd42dd0b963fe$var$mapAgentEditChromeRanges(tr, ranges) {
    const indexes = new WeakMap();
    const alignedOffsets = new WeakMap();
    const options = {
        alignedOffsets: alignedOffsets,
        requireUniqueSourceIds: true
    };
    const validRanges = [];
    for (const { from: from, to: to } of ranges){
        if (!Number.isFinite(from) || !Number.isFinite(to) || to <= from) continue;
        const start = Math.max(0, Math.min(from, tr.before.content.size));
        const end = Math.max(start, Math.min(to, tr.before.content.size));
        if (start === end) continue;
        validRanges.push({
            from: start,
            to: end
        });
    }
    if (!validRanges.length) return [];
    validRanges.sort((left, right)=>left.from - right.from);
    const blocks = [];
    let rangeIndex = 0;
    for (const { node: node, pos: pos } of $dd6bd42dd0b963fe$var$getSnapshotIndex(tr.before, indexes).textblocks){
        while(rangeIndex < validRanges.length && validRanges[rangeIndex].to <= pos)rangeIndex++;
        if (rangeIndex === validRanges.length) break;
        if (node.content.size && validRanges[rangeIndex].from < pos + node.nodeSize) blocks.push({
            from: pos,
            to: pos + node.nodeSize,
            markupChanged: false
        });
    }
    // Index -1 starts from docs[0], before the first step, instead of a step result.
    return blocks.flatMap((range)=>$dd6bd42dd0b963fe$var$mapToFinalBlocks(tr, -1, range, indexes, options));
}
/**
 * Returns whole content-block ranges for selected applied steps, in tr.doc coordinates.
 * Callers select actual AI writes (excluding restores, acknowledgments and preparation)
 * and own experiment/lifecycle decisions. This helper does not dispatch or render.
 *
 * Comparing each step's snapshots also handles attribute/mark steps with empty maps.
 * Shared unchanged subtrees are skipped by reference. Only localId changes are ignored;
 * meaningful attributes and marks retain the affected node's full content scope.
 */ function $dd6bd42dd0b963fe$var$getAgentEditChangedRanges(tr, includedStepIndexes, requireUniqueSourceIds) {
    // Positions belong to each intermediate document, not just tr.doc. Keep the
    // lazy indexes local to this call so deletion/reinsertion checks stay intact
    // and no cache is retained between transactions or streaming chunks.
    const indexes = new WeakMap();
    const options = {
        requireUniqueSourceIds: requireUniqueSourceIds
    };
    const ranges = [];
    for (const index of new Set(includedStepIndexes)){
        if (!Number.isInteger(index) || index < 0 || index >= tr.steps.length) continue;
        const changed = [];
        // The root document has no opening boundary. Using -1 makes the recursive
        // parent.pos + 1 + offset formula place its first child at position 0.
        $dd6bd42dd0b963fe$var$collectChanges({
            node: tr.docs[index],
            pos: -1
        }, {
            node: tr.docs[index + 1] ?? tr.doc,
            pos: -1
        }, tr.steps[index].getMap(), changed);
        for (const range of changed)ranges.push(...$dd6bd42dd0b963fe$var$mapToFinalBlocks(tr, index, range, indexes, options));
    }
    // Return only the surviving final-document ranges, never intermediate step states.
    // Sort outer ranges before their children, then discard duplicates/contained ranges.
    // Separate ranges stay separate; this must not highlight the untouched gaps.
    const unique = [];
    for (const range of ranges.sort((left, right)=>left.from - right.from || right.to - left.to)){
        const previous = unique[unique.length - 1];
        if (!previous || range.to > previous.to) unique.push(range);
    }
    return unique;
}
const $dd6bd42dd0b963fe$export$c43a947daf0cb617 = {
    getChangedRanges: $dd6bd42dd0b963fe$var$getAgentEditChangedRanges,
    mapChromeRanges: $dd6bd42dd0b963fe$var$mapAgentEditChromeRanges
};

});




parcelRegister("8gaSy", function(module, exports) {
$parcel$export(module.exports, "AGENT_SHIMMER_DEFAULT_DURATION_MS", () => $1d68c7833a9cb670$export$aa0937b45953b3db);
$parcel$export(module.exports, "AGENT_EDIT_HIGHLIGHT_DEFAULT_DURATION_MS", () => $1d68c7833a9cb670$export$f8af4b416532a528);
$parcel$export(module.exports, "ADD_AGENT_SHIMMER_META", () => $1d68c7833a9cb670$export$e48683d1c200d637);
$parcel$export(module.exports, "HIGHLIGHT_AGENT_SHIMMER_META", () => $1d68c7833a9cb670$export$736faf53f1a48861);
$parcel$export(module.exports, "REMOVE_AGENT_SHIMMER_META", () => $1d68c7833a9cb670$export$4cd536a39e6c2c4f);
$parcel$export(module.exports, "reduceAgentShimmers", () => $1d68c7833a9cb670$export$caaa5661d99996f1);
$parcel$export(module.exports, "buildAgentShimmerDecorations", () => $1d68c7833a9cb670$export$6039627ad3fe2215);

var $a3b9P = parcelRequire("a3b9P");
const $1d68c7833a9cb670$export$aa0937b45953b3db = 3000;
const $1d68c7833a9cb670$export$f8af4b416532a528 = 2000;
const $1d68c7833a9cb670$export$63ca995375149bdc = 'collab-agent-shimmer';
const $1d68c7833a9cb670$export$222eb4184643a9 = 'collab-agent-edit-highlight';
const $1d68c7833a9cb670$export$6c825ce2d4ad5f26 = 'ai-in-editor-telepointer';
const $1d68c7833a9cb670$export$1aa6da0fcc4baa6e = 'ai-in-editor-telepointer-label';
const $1d68c7833a9cb670$export$e48683d1c200d637 = 'addAgentShimmer'; // register the shimmer decorations
const $1d68c7833a9cb670$export$736faf53f1a48861 = 'highlightAgentShimmer'; // skeleton → purple highlight phase
const $1d68c7833a9cb670$export$4cd536a39e6c2c4f = 'removeAgentShimmer'; // remove them once the shimmer ends
// Rovo AI in-editor telepointer/cursor shown at the end of an agent-authored range (same DOM/style
// pattern as editor-plugin-ai's in-editor direct-streaming telepointer).
const $1d68c7833a9cb670$var$createRovoAgentTelepointer = (label)=>{
    const element = document.createElement('span');
    element.setAttribute('data-testid', 'ai-in-editor-telepointer-widget');
    element.className = $1d68c7833a9cb670$export$6c825ce2d4ad5f26;
    const labelElement = document.createElement('span');
    labelElement.setAttribute('data-testid', 'ai-in-editor-telepointer-widget-label');
    labelElement.className = $1d68c7833a9cb670$export$1aa6da0fcc4baa6e;
    labelElement.append(label);
    element.appendChild(labelElement);
    return element;
};
const $1d68c7833a9cb670$export$caaa5661d99996f1 = (current, tr, added, removedShimmerId, highlightShimmerId)=>{
    let next = current;
    let changed = false;
    // Ranges added in THIS transaction are already in post-change coords, so map the pre-existing
    // ones BEFORE replacing with any new batch.
    if (tr.docChanged && next.length) {
        next = next.map((shimmer)=>({
                ...shimmer,
                from: tr.mapping.map(shimmer.from, -1),
                to: tr.mapping.map(shimmer.to, 1)
            }));
        changed = true;
    }
    if (added !== null && added !== void 0 && added.length) {
        next = added.map((shimmer)=>({
                ...shimmer
            }));
        changed = true;
    }
    // Transition a shimmer from the skeleton phase to the purple highlight phase (skeleton timer fired).
    // Guard on an actual match so a timer firing after the shimmer was already removed (superseded by a
    // new batch, or cleared) doesn't rebuild the array and trigger a pointless decoration rebuild.
    if (highlightShimmerId && next.some((shimmer)=>shimmer.shimmerId === highlightShimmerId)) {
        next = next.map((shimmer)=>shimmer.shimmerId === highlightShimmerId ? {
                ...shimmer,
                phase: 'highlight'
            } : shimmer);
        changed = true;
    }
    if (removedShimmerId) {
        next = next.filter((shimmer)=>shimmer.shimmerId !== removedShimmerId);
        changed = true;
    }
    return {
        changed: changed,
        next: next
    };
};
const $1d68c7833a9cb670$export$6039627ad3fe2215 = (tr, shimmers, getValidPos, onError)=>{
    const decorations = [];
    shimmers.forEach(({ shimmerId: shimmerId, from: from, to: to, telepointerLabel: telepointerLabel, phase: phase, highlightDurationMs: highlightDurationMs })=>{
        try {
            // `getValidPos` already clamps to the last valid position, so only the lower bound needs
            // guarding here (a raw `from < 1` would throw in `doc.resolve`).
            const validFrom = getValidPos(tr, Math.max(from, 1));
            const validTo = getValidPos(tr, to);
            if (validTo <= validFrom) return;
            // Inline decoration over the whole range: the grey skeleton loader, or (once revealed) the
            // purple "just edited" highlight. The highlight eases in and out over its lifetime via a CSS
            // animation whose duration is set inline so it matches the removal timer.
            const isHighlight = phase === 'highlight';
            const inlineAttrs = {
                class: isHighlight ? $1d68c7833a9cb670$export$222eb4184643a9 : $1d68c7833a9cb670$export$63ca995375149bdc
            };
            if (isHighlight && highlightDurationMs > 0) inlineAttrs.style = `animation-duration: ${highlightDurationMs}ms`;
            decorations.push((0, $a3b9P.Decoration).inline(validFrom, validTo, inlineAttrs, {
                isAgentShimmer: true,
                shimmerId: shimmerId
            }));
            // Rovo AI telepointer/cursor (labelled with the agent's type) at the end of the range, shown
            // through BOTH the skeleton and purple-highlight phases so the agent's cursor stays put until
            // the edit is fully revealed.
            if (telepointerLabel) decorations.push((0, $a3b9P.Decoration).widget(validTo, $1d68c7833a9cb670$var$createRovoAgentTelepointer(telepointerLabel), {
                isAgentShimmer: true,
                shimmerId: shimmerId,
                class: $1d68c7833a9cb670$export$6c825ce2d4ad5f26,
                key: `agent-telepointer-${shimmerId}`,
                side: 1
            }));
        } catch (err) {
            // One bad range must not kill the others.
            onError(err);
        }
    });
    return decorations;
};

});

parcelRegister("kue9R", function(module, exports) {
$parcel$export(module.exports, "getRemoteAgentChromeIdentity", () => $1fd1e9dc3c52320b$export$d9734f7a3bd83e30);
const $1fd1e9dc3c52320b$export$d9734f7a3bd83e30 = (requester)=>{
    var _requester$agentSourc, _requester$agentId, _requester$agentName, _requester$agentNamed;
    return {
        actorUserId: requester.actorUserId,
        invocationId: requester.invocationId,
        agentId: ((_requester$agentSourc = requester.agentSourceId) === null || _requester$agentSourc === void 0 ? void 0 : _requester$agentSourc.trim()) || undefined,
        agentIdentityAccountId: ((_requester$agentId = requester.agentId) === null || _requester$agentId === void 0 ? void 0 : _requester$agentId.trim()) || undefined,
        agentName: ((_requester$agentName = requester.agentName) === null || _requester$agentName === void 0 ? void 0 : _requester$agentName.trim()) || undefined,
        agentNamedId: ((_requester$agentNamed = requester.agentNamedId) === null || _requester$agentNamed === void 0 ? void 0 : _requester$agentNamed.trim()) || undefined,
        agentType: requester.agentType.trim() || undefined,
        isThirdParty: requester.isThirdPartyAgent
    };
};

});

parcelRegister("2kimw", function(module, exports) {
$parcel$export(module.exports, "findPointers", () => $c46458f88e1ccff9$export$cc7116c03c331d66);
$parcel$export(module.exports, "getAvatarColor", () => $c46458f88e1ccff9$export$90c6ee000c44ff4a);
$parcel$export(module.exports, "createTelepointers", () => $c46458f88e1ccff9$export$8f868fb36fe42fe8);
$parcel$export(module.exports, "replaceDocument", () => $c46458f88e1ccff9$export$fe10d6bdd551e45e);
$parcel$export(module.exports, "getPositionOfTelepointer", () => $c46458f88e1ccff9$export$4d66b240d6166074);
$parcel$export(module.exports, "isReplaceStep", () => $c46458f88e1ccff9$export$94600c572c12bcd6);
$parcel$export(module.exports, "originalTransactionHasMeta", () => $c46458f88e1ccff9$export$b8c92cc7dad49da);
$parcel$export(module.exports, "isOrganicChange", () => $c46458f88e1ccff9$export$227edb0398ff0ff6);
$parcel$export(module.exports, "hasExistingNudge", () => $c46458f88e1ccff9$export$6a7a563833bcd8);

var $7ozbX = parcelRequire("7ozbX");

var $48ZJc = parcelRequire("48ZJc");

var $4eNaz = parcelRequire("4eNaz");

var $g6Qq4 = parcelRequire("g6Qq4");

var $gZj5p = parcelRequire("gZj5p");

var $fcrbf = parcelRequire("fcrbf");

var $kuD5k = parcelRequire("kuD5k");

var $cw0wu = parcelRequire("cw0wu");

var $3DNV7 = parcelRequire("3DNV7");

var $a3b9P = parcelRequire("a3b9P");

var $7jCBn = parcelRequire("7jCBn");

var $gdUUy = parcelRequire("gdUUy");

var $dt0iM = parcelRequire("dt0iM");
const $c46458f88e1ccff9$export$cc7116c03c331d66 = (id, decorations)=>decorations.find().reduce(// `pointer` is absent on non-telepointer decorations (e.g. the agent-shimmer
    // sweep decorations), so guard against it to avoid crashing this shared helper.
    (arr, deco)=>{
        var _deco$spec$pointer;
        return ((_deco$spec$pointer = deco.spec.pointer) === null || _deco$spec$pointer === void 0 ? void 0 : _deco$spec$pointer.presenceId) === id ? arr.concat(deco) : arr;
    }, []);
function $c46458f88e1ccff9$var$style(options) {
    const color = options && options.color || "var(--ds-border, #0B120E24)";
    const borderWidth = "var(--ds-border-width-focused, 2px)";
    return `border-right: ${borderWidth} solid ${color}; margin-right: calc(-1 * ${borderWidth}); z-index: 1`;
}
function $c46458f88e1ccff9$export$90c6ee000c44ff4a(str, agentType) {
    const participantColor = (0, $7jCBn.getParticipantColor)(str, (0, $gdUUy.fg)('confluence_ncs_step_diffing_version_history') ? agentType : undefined);
    return {
        index: participantColor.index,
        backgroundColor: participantColor.color.backgroundColor,
        textColor: participantColor.color.textColor
    };
}
const $c46458f88e1ccff9$export$8f868fb36fe42fe8 = (from, to, sessionId, isSelection, initial, presenceId, fullName, isNudged, agentType)=>{
    const decorations = [];
    const avatarColor = $c46458f88e1ccff9$export$90c6ee000c44ff4a(presenceId, agentType);
    const color = avatarColor.index.toString();
    if (isSelection) {
        const className = `telepointer color-${color} telepointer-selection`;
        decorations.push((0, $a3b9P.Decoration).inline(from, to, {
            class: className
        }, {
            pointer: {
                sessionId: sessionId,
                presenceId: presenceId
            }
        }));
    }
    const spaceJoinerBefore = document.createElement('span');
    spaceJoinerBefore.textContent = (0, $kuD5k.ZERO_WIDTH_JOINER);
    const spaceJoinerAfter = document.createElement('span');
    spaceJoinerAfter.textContent = (0, $kuD5k.ZERO_WIDTH_JOINER);
    const cursor = document.createElement('span');
    cursor.textContent = (0, $kuD5k.ZERO_WIDTH_JOINER);
    cursor.className = `telepointer color-${color} telepointer-selection-badge`;
    cursor.style.cssText = `${$c46458f88e1ccff9$var$style({
        color: avatarColor.backgroundColor
    })};`;
    cursor.setAttribute('aria-label', `${fullName} cursor position`);
    cursor.setAttribute('role', 'button');
    cursor.setAttribute((0, $gZj5p.TELEPOINTER_DATA_SESSION_ID_ATTR), sessionId);
    // If there is an ongoing expand animation, we'll keep the telepointer expanded
    // until the keyframe animation is complete. Please note that this will restart the anim timer
    // from 0 everytime it's re-added.
    if (isNudged) cursor.classList.add((0, $gZj5p.TELEPOINTER_PULSE_DURING_TR_CLASS));
    const fullNameEl = document.createElement('span');
    fullNameEl.textContent = fullName;
    fullNameEl.className = 'telepointer-fullname';
    fullNameEl.style.backgroundColor = avatarColor.backgroundColor;
    fullNameEl.style.color = avatarColor.textColor;
    fullNameEl.setAttribute('aria-hidden', 'true');
    cursor.appendChild(fullNameEl);
    const initialEl = document.createElement('span');
    initialEl.textContent = initial;
    initialEl.className = 'telepointer-initial';
    initialEl.style.backgroundColor = avatarColor.backgroundColor;
    initialEl.style.color = avatarColor.textColor;
    initialEl.setAttribute('aria-hidden', 'true');
    cursor.appendChild(initialEl);
    return decorations.concat((0, $a3b9P.Decoration).widget(to, spaceJoinerAfter, {
        pointer: {
            sessionId: sessionId,
            presenceId: presenceId
        },
        key: `telepointer-${sessionId}-zero`
    })).concat((0, $a3b9P.Decoration).widget(to, cursor, {
        pointer: {
            sessionId: sessionId,
            presenceId: presenceId
        },
        key: `telepointer-${sessionId}`
    })).concat((0, $a3b9P.Decoration).widget(to, spaceJoinerBefore, {
        pointer: {
            sessionId: sessionId,
            presenceId: presenceId
        },
        key: `telepointer-${sessionId}-zero`
    }));
};
const $c46458f88e1ccff9$export$fe10d6bdd551e45e = (doc, state, version, options, reserveCursor, editorAnalyticsAPI)=>{
    const { schema: schema, tr: tr } = state;
    const parsedDoc = (0, $fcrbf.processRawValueWithoutValidation)(schema, doc, editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 ? void 0 : editorAnalyticsAPI.fireAnalyticsEvent);
    const hasContent = !!(parsedDoc !== null && parsedDoc !== void 0 && parsedDoc.childCount);
    const content = parsedDoc === null || parsedDoc === void 0 ? void 0 : parsedDoc.content;
    if (hasContent && content) {
        const preservedContent = (0, $dt0iM.preserveNodeIdentity)(state.doc.content, content);
        // If the entire content is identical, skip the replaceWith entirely
        // and just update collab metadata. This avoids triggering a full
        // document reconciliation for no-op replacements.
        if (preservedContent === state.doc.content) {
            tr.setMeta('addToHistory', false);
            if (version !== undefined && options && options.useNativePlugin) {
                const collabState = {
                    version: version,
                    unconfirmed: []
                };
                tr.setMeta('collab$', collabState);
            }
            return tr;
        }
        // Use the preserved fragment (reuses old node references for unchanged nodes)
        // rather than the raw parsed content, so ProseMirror's view reconciliation
        // can fast-match unchanged subtrees via referential identity (===).
        tr.setMeta('addToHistory', false);
        tr.replaceWith(0, state.doc.nodeSize - 2, preservedContent);
        const selection = state.selection;
        if (reserveCursor) {
            if (selection.to < tr.doc.content.size - 2) {
                const $from = tr.doc.resolve(selection.from);
                const $to = tr.doc.resolve(selection.to);
                const newselection = new (0, $cw0wu.TextSelection)($from, $to);
                tr.setSelection(newselection);
            }
        } else tr.setSelection((0, $cw0wu.Selection).atStart(tr.doc));
        tr.setMeta('replaceDocument', true);
        if (version !== undefined && options && options.useNativePlugin) {
            const collabState = {
                version: version,
                unconfirmed: []
            };
            tr.setMeta('collab$', collabState);
        }
    } else if (hasContent) {
        tr.setMeta('addToHistory', false);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        tr.replaceWith(0, state.doc.nodeSize - 2, content);
        const selection = state.selection;
        if (reserveCursor) // If the cursor is still in the range of the new document,
        // keep where it was.
        {
            if (selection.to < tr.doc.content.size - 2) {
                const $from = tr.doc.resolve(selection.from);
                const $to = tr.doc.resolve(selection.to);
                const newselection = new (0, $cw0wu.TextSelection)($from, $to);
                tr.setSelection(newselection);
            }
        } else tr.setSelection((0, $cw0wu.Selection).atStart(tr.doc));
        tr.setMeta('replaceDocument', true);
        if (options && options.useNativePlugin) {
            const collabState = {
                version: version,
                unconfirmed: []
            };
            tr.setMeta('collab$', collabState);
        }
    }
    return tr;
};
const $c46458f88e1ccff9$export$82e6f13680c85057 = (editorView, participants, sessionId, index, editorAnalyticsAPI)=>{
    const selectedUser = participants[index];
    if (selectedUser && selectedUser.cursorPos !== undefined && selectedUser.sessionId !== sessionId) {
        const { state: state } = editorView;
        const tr = state.tr;
        const analyticsPayload = {
            action: (0, $g6Qq4.ACTION).MATCHED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SELECTION,
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
        };
        tr.setSelection((0, $cw0wu.Selection).near(tr.doc.resolve(selectedUser.cursorPos)));
        editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(analyticsPayload)(tr);
        tr.scrollIntoView();
        editorView.dispatch(tr);
        if (!editorView.hasFocus()) editorView.focus();
    }
};
const $c46458f88e1ccff9$export$4d66b240d6166074 = (sessionId, decorationSet)=>{
    let scrollPosition;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    decorationSet.find().forEach((deco)=>{
        if (deco.type.spec.pointer.sessionId === sessionId) scrollPosition = deco.from;
    });
    return scrollPosition;
};
const $c46458f88e1ccff9$export$94600c572c12bcd6 = (step)=>step instanceof (0, $3DNV7.ReplaceStep);
const $c46458f88e1ccff9$export$b8c92cc7dad49da = (transaction, metaTag)=>{
    const hasMetaTag = Boolean(transaction.getMeta(metaTag));
    if (hasMetaTag) return true;
    const appendedTransaction = transaction.getMeta('appendedTransaction');
    if (appendedTransaction instanceof (0, $cw0wu.Transaction)) return $c46458f88e1ccff9$export$b8c92cc7dad49da(appendedTransaction, metaTag);
    return false;
};
/**
 * This list contains step attributes that do not result from a user action.
 * All steps that contain ONLY the blocked attribute are considered automated steps
 * and should not be recognised as organic change.
 *
 * `attr_colwidth` is an exception to above explanation. Resizing the column
 * currently creates too many steps and is therefore also on this list.
 *
 * Steps analycs dashboard: https://atlassian-discover.cloud.databricks.com/dashboardsv3/01ef4d3c8aa916c8b0cb5332a9f37caf/published?o=4482001201517624
 */ const $c46458f88e1ccff9$var$blockedAttrsList = [
    '__contextId',
    'localId',
    '__autoSize',
    'attr_colwidth',
    'originalHeight',
    'originalWidth'
];
const $c46458f88e1ccff9$export$227edb0398ff0ff6 = (tr)=>{
    // If document has not been marked as `docChanged` by PM, skip the rest of the logic
    if (!tr.docChanged) return false;
    return tr.steps.some((step)=>{
        // If a step is an instance of AnalyticsStep, it is not considered organic
        if (step instanceof (0, $7ozbX.AnalyticsStep)) return false;
        // editor-plugin-local-id uses AttrStep to set the localId attribute
        if (step instanceof (0, $3DNV7.AttrStep) && step.attr === 'localId') return false;
        // editor-plugin-local-id uses BatchAttrStep to set the localId attribute
        if (step instanceof (0, $48ZJc.BatchAttrsStep)) {
            const allAttributes = step.data.map((data)=>Object.keys(data.attrs)).flat();
            return allAttributes.some((attr)=>!$c46458f88e1ccff9$var$blockedAttrsList.includes(attr)) && !tr.doc.eq(tr.before);
        }
        // If a step is not an instance of SetAttrsStep, it is considered organic
        if (!(step instanceof (0, $4eNaz.SetAttrsStep))) return true;
        const allAttributes = Object.keys(step.attrs);
        // If a step is an instance of SetAttrsStep, it checks if the attributes in the step
        // are not in the `blockedAttributes`. If one of the attributes not on the list, it considers the change
        // organic but only if the entire document is not equal to the previous state.
        return allAttributes.some((attr)=>!$c46458f88e1ccff9$var$blockedAttrsList.includes(attr)) && !tr.doc.eq(tr.before);
    });
};
const $c46458f88e1ccff9$export$6a7a563833bcd8 = (sessionId, nudgeAnimations)=>{
    const nudgeAnimStartTime = nudgeAnimations.get(sessionId);
    let hasExistingNudge = false;
    if (nudgeAnimStartTime) {
        const timeElapsed = Date.now() - nudgeAnimStartTime;
        hasExistingNudge = timeElapsed < (0, $gZj5p.TELEPOINTER_PULSE_DURING_TR_DURATION_MS);
    }
    return hasExistingNudge;
};

});
parcelRegister("7jCBn", function(module, exports) {
$parcel$export(module.exports, "getParticipantColor", () => $bc73d0a62871b98a$export$60ba61eca4eb64f2);

var $9ztIk = parcelRequire("9ztIk");

var $bQn1T = parcelRequire("bQn1T");

var $gdUUy = parcelRequire("gdUUy");

var $5bbjm = parcelRequire("5bbjm");
/**
 * Fixed telepointer palette slot for each `@atlaskit/agent-color` brand this editor recognises by
 * a reserved identity colour rather than a hashed one. Positions also back the telepointer CSS
 * classes, so preserve them when editing the palette.
 */ const $bc73d0a62871b98a$var$BRAND_PARTICIPANT_COLOR_INDEX = {
    'agent-brand-claude': 7,
    'agent-brand-rovo': 4,
    'agent-brand-chatgpt': 9,
    'agent-brand-figma': 9,
    'agent-brand-lovable': 9,
    'agent-brand-replit': 9,
    'agent-brand-amplitude': 9,
    'agent-brand-cortex': 9,
    'agent-brand-databricks': 9,
    'agent-brand-gemini': 9,
    'agent-brand-manus': 9,
    'agent-brand-slack': 9,
    'agent-brand-antigravity': 9,
    'agent-brand-copilot': 9
};
/** Brands whose registered `bold`/`boldText` values take precedence over their palette slot. */ const $bc73d0a62871b98a$var$BRAND_EXACT_COLOR_SCHEMES = new Set([
    'agent-brand-chatgpt',
    'agent-brand-rovo',
    'agent-brand-figma',
    'agent-brand-lovable',
    'agent-brand-replit',
    'agent-brand-amplitude',
    'agent-brand-cortex',
    'agent-brand-databricks',
    'agent-brand-gemini',
    'agent-brand-manus',
    'agent-brand-slack',
    'agent-brand-antigravity',
    'agent-brand-copilot'
]);
/** Maps Agent Studio's semantic palette to the established telepointer palette slots. */ const $bc73d0a62871b98a$var$AGENT_COLOR_TO_PARTICIPANT_COLOR_INDEX = {
    yellow: 3,
    purple: 4,
    lime: 8,
    blue: 1
};
/** The two red palette slots. Red reads as "deleted", so it never identifies a participant. */ const $bc73d0a62871b98a$var$RESERVED_PARTICIPANT_COLOR_INDEXES = new Set([
    0,
    11
]);
/** Advances past a reserved slot, wrapping around the palette. */ const $bc73d0a62871b98a$var$getAssignableIndex = (index)=>{
    for(let offset = 0; offset < (0, $5bbjm.participantColors).length; offset++){
        const candidate = (index + offset) % (0, $5bbjm.participantColors).length;
        if (!$bc73d0a62871b98a$var$RESERVED_PARTICIPANT_COLOR_INDEXES.has(candidate)) return candidate;
    }
    return index;
};
function $bc73d0a62871b98a$export$c14f61804029af13(str) {
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        /* eslint-disable no-bitwise */ hash = (hash << 5) - hash + str.charCodeAt(i);
        hash = (hash & hash) >>> 0;
    /* eslint-enable no-bitwise */ }
    return hash;
}
function $bc73d0a62871b98a$export$60ba61eca4eb64f2(str, agentType) {
    // `agentType` may be a named id (e.g. `mcp_lovable_agent`) or a display name (e.g. `lovable`).
    const brand = agentType ? (0, $bQn1T.getThirdPartyAgentColor)({
        agentNamedId: agentType,
        agentName: agentType
    }) : undefined;
    if (brand) {
        const fixedIndex = $bc73d0a62871b98a$var$BRAND_PARTICIPANT_COLOR_INDEX[brand.scheme];
        if (fixedIndex !== undefined) {
            const color = $bc73d0a62871b98a$var$BRAND_EXACT_COLOR_SCHEMES.has(brand.scheme) ? {
                backgroundColor: brand.bold,
                svgBackgroundColor: brand.bold,
                textColor: brand.boldText
            } : (0, $5bbjm.participantColors)[fixedIndex];
            return {
                index: fixedIndex,
                color: color,
                isFixed: true
            };
        }
    }
    const agentColor = agentType ? (0, $9ztIk.getAgentColor)({
        agentId: str
    }) : undefined;
    const preferredIndex = agentColor ? $bc73d0a62871b98a$var$AGENT_COLOR_TO_PARTICIPANT_COLOR_INDEX[agentColor] : $bc73d0a62871b98a$export$c14f61804029af13(str) % (0, $5bbjm.participantColors).length;
    const index = (0, $gdUUy.fg)('confluence_ncs_step_diffing_version_history') ? $bc73d0a62871b98a$var$getAssignableIndex(preferredIndex) : preferredIndex;
    return {
        index: index,
        color: (0, $5bbjm.participantColors)[index]
    };
}

});
parcelRegister("9ztIk", function(module, exports) {
$parcel$export(module.exports, "getAgentColor", () => $16adc096b0383660$export$8ff4e76da970e804);
const $16adc096b0383660$var$AGENT_COLOR_ORDER = [
    'yellow',
    'purple',
    'lime',
    'blue'
];
const $16adc096b0383660$var$NAMED_AGENT_COLORS = {
    autodev_template_unit_test_creator: 'lime',
    autodev_template_migration_config_changer_agent: 'lime',
    autodev_template_vulnerable_dependency_updater_agent: 'lime',
    autodev_template_code_standardizer_agent: 'lime',
    autodev_template_code_observer_agent: 'lime',
    autodev_template_code_accessibility_checker_agent: 'lime',
    autodev_code_documentation_writer_agent: 'lime',
    autodev_feature_flag_cleaner_agent: 'lime',
    decision_director_agent: 'lime',
    planner_agent: 'purple',
    tech_writer_agent: 'blue',
    user_manual_writer_agent: 'yellow',
    product_requirements_expert_agent: 'yellow',
    issue_organizer_agent: 'lime',
    ops_guide_agent: 'yellow',
    discovery_and_feedback_agent: 'lime',
    jira_workflow_builder_agent: 'blue',
    itops_rca_agent: 'yellow',
    jira_trial_guide_agent: 'blue',
    daily_brief_agent: 'yellow',
    jira_admin_agent: 'blue',
    jsm_rovo_service_agent: 'yellow',
    mcp_amplitude_agent: 'blue',
    mcp_box_agent: 'blue',
    mcp_canva_agent: 'blue',
    mcp_figma_agent: 'blue',
    mcp_hubspot_agent: 'blue',
    mcp_intercom_agent: 'blue',
    mcp_gamma_agent: 'blue',
    mcp_lovable_agent: 'blue',
    mcp_replit_agent: 'blue',
    rovo_agent: 'blue',
    content_reviewer_agent: 'blue',
    jira_work_agent: 'blue',
    jira_intelligent_triage_agent: 'blue',
    jira_coding_agent: 'blue'
};
const $16adc096b0383660$export$8ff4e76da970e804 = ({ agentId: agentId, agentNamedId: agentNamedId, agentIdentityAccountId: agentIdentityAccountId })=>{
    const namedAgentColor = agentNamedId ? $16adc096b0383660$var$NAMED_AGENT_COLORS[agentNamedId] : undefined;
    if (namedAgentColor) return namedAgentColor;
    const id = agentIdentityAccountId || agentId;
    const parsedId = Number.parseInt((id === null || id === void 0 ? void 0 : id.slice(-8).replace(/[-:]/gu, '')) ?? '', 16);
    const stableAgentId = Number.isNaN(parsedId) ? 0 : parsedId;
    return $16adc096b0383660$var$AGENT_COLOR_ORDER[stableAgentId % $16adc096b0383660$var$AGENT_COLOR_ORDER.length] ?? 'yellow';
};

});

parcelRegister("bQn1T", function(module, exports) {
$parcel$export(module.exports, "getThirdPartyAgentColor", () => $3f19a4418c75fd75$export$6a8569a6e7f99156);

var $fQN71 = parcelRequire("fQN71");
const $3f19a4418c75fd75$var$namedBrands = {
    mcp_amplitude_agent: 'agent-brand-amplitude',
    mcp_figma_agent: 'agent-brand-figma',
    mcp_lovable_agent: 'agent-brand-lovable',
    mcp_replit_agent: 'agent-brand-replit'
};
/** Every alias a brand is identified by, normalised (trimmed, lowercased) before matching. */ const $3f19a4418c75fd75$var$displayNameBrands = {
    amplitude: 'agent-brand-amplitude',
    antigravity: 'agent-brand-antigravity',
    chatgpt: 'agent-brand-chatgpt',
    claude: 'agent-brand-claude',
    copilot: 'agent-brand-copilot',
    cortex: 'agent-brand-cortex',
    databricks: 'agent-brand-databricks',
    figma: 'agent-brand-figma',
    gemini: 'agent-brand-gemini',
    lovable: 'agent-brand-lovable',
    loveable: 'agent-brand-lovable',
    manus: 'agent-brand-manus',
    replit: 'agent-brand-replit',
    rovo: 'agent-brand-rovo',
    rovo_chat: 'agent-brand-rovo',
    slack: 'agent-brand-slack'
};
/** Canonical display name for each brand, so callers stop maintaining their own copy. */ const $3f19a4418c75fd75$var$brandDisplayNames = {
    'agent-brand-amplitude': 'Amplitude',
    'agent-brand-antigravity': 'Antigravity',
    'agent-brand-chatgpt': 'ChatGPT',
    'agent-brand-claude': 'Claude',
    'agent-brand-copilot': 'Copilot',
    'agent-brand-cortex': 'Cortex',
    'agent-brand-databricks': 'Databricks',
    'agent-brand-figma': 'Figma',
    'agent-brand-gemini': 'Gemini',
    'agent-brand-lovable': 'Lovable',
    'agent-brand-manus': 'Manus',
    'agent-brand-replit': 'Replit',
    'agent-brand-rovo': 'Rovo',
    'agent-brand-slack': 'Slack'
};
const $3f19a4418c75fd75$export$6a8569a6e7f99156 = ({ agentNamedId: agentNamedId, agentName: agentName })=>{
    const namedId = agentNamedId ?? '';
    const displayName = (agentName === null || agentName === void 0 ? void 0 : agentName.trim().toLowerCase()) ?? '';
    const namedScheme = Object.prototype.hasOwnProperty.call($3f19a4418c75fd75$var$namedBrands, namedId) ? $3f19a4418c75fd75$var$namedBrands[namedId] : undefined;
    const displayScheme = Object.prototype.hasOwnProperty.call($3f19a4418c75fd75$var$displayNameBrands, displayName) ? $3f19a4418c75fd75$var$displayNameBrands[displayName] : undefined;
    const scheme = namedScheme ?? displayScheme;
    return scheme ? {
        ...(0, $fQN71.agentBrandColorSchemes)[scheme],
        name: $3f19a4418c75fd75$var$brandDisplayNames[scheme],
        scheme: scheme
    } : undefined;
};

});
parcelRegister("fQN71", function(module, exports) {
$parcel$export(module.exports, "agentBrandColorSchemes", () => $0866c446f81fc052$export$6dbdccb358142509);
const $0866c446f81fc052$var$themed = (light, dark)=>`light-dark(${light}, ${dark})`;
const $0866c446f81fc052$var$monochrome = {
    accentText: $0866c446f81fc052$var$themed('#000000', '#E8E8EA'),
    background: $0866c446f81fc052$var$themed('#E5E5E5', '#333335'),
    bold: $0866c446f81fc052$var$themed('#000000', '#E8E8EA'),
    boldText: $0866c446f81fc052$var$themed('#FFFFFF', '#292A2E'),
    border: $0866c446f81fc052$var$themed('#BEB9B9', '#656567'),
    text: $0866c446f81fc052$var$themed('#292A2E', '#E8E8EA')
};
/** Brand values use the product's CSS colour scheme, so existing decorations follow theme changes. */ const $0866c446f81fc052$var$brandColors = {
    'agent-brand-replit': {
        accentText: $0866c446f81fc052$var$themed('#000000', '#E8E8EA'),
        background: $0866c446f81fc052$var$themed('#E5E5E5', '#333335'),
        bold: $0866c446f81fc052$var$themed('#000000', '#E8E8EA'),
        boldText: $0866c446f81fc052$var$themed('#FFFFFF', '#000000'),
        border: $0866c446f81fc052$var$themed('#BEB9B9', '#656567'),
        text: $0866c446f81fc052$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-lovable': {
        accentText: $0866c446f81fc052$var$themed('#000000', '#E8E8EA'),
        background: $0866c446f81fc052$var$themed('#E5E5E5', '#333335'),
        bold: $0866c446f81fc052$var$themed('#000000', '#E8E8EA'),
        boldText: $0866c446f81fc052$var$themed('#FFFFFF', '#000000'),
        border: $0866c446f81fc052$var$themed('#BEB9B9', '#656567'),
        text: $0866c446f81fc052$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-figma': {
        accentText: $0866c446f81fc052$var$themed('#000000', '#E8E8EA'),
        background: $0866c446f81fc052$var$themed('#E5E5E5', '#333335'),
        bold: $0866c446f81fc052$var$themed('#000000', '#E8E8EA'),
        boldText: $0866c446f81fc052$var$themed('#FFFFFF', '#000000'),
        border: $0866c446f81fc052$var$themed('#BEB9B9', '#656567'),
        emphasisBackground: $0866c446f81fc052$var$themed('#E5E5E5', '#333335'),
        text: $0866c446f81fc052$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-databricks': {
        accentText: $0866c446f81fc052$var$themed('#B52113', '#FF8C80'),
        background: $0866c446f81fc052$var$themed('#FFEBE9', '#352525'),
        bold: $0866c446f81fc052$var$themed('#FF3621', '#FF5F4D'),
        boldText: $0866c446f81fc052$var$themed('#FFFFFF', '#292A2E'),
        border: $0866c446f81fc052$var$themed('#FFBBB4', '#6D3530'),
        text: $0866c446f81fc052$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-amplitude': {
        accentText: $0866c446f81fc052$var$themed('#0052F2', '#8FB9FF'),
        background: $0866c446f81fc052$var$themed('#E5EEFE', '#242A37'),
        bold: $0866c446f81fc052$var$themed('#0052F2', '#4C8DFF'),
        boldText: $0866c446f81fc052$var$themed('#FFFFFF', '#000000'),
        border: $0866c446f81fc052$var$themed('#B9D1FC', '#2F466F'),
        text: $0866c446f81fc052$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-slack': {
        accentText: $0866c446f81fc052$var$themed('#611F69', '#E8E8EA'),
        background: $0866c446f81fc052$var$themed('#EFE9F0', '#333335'),
        bold: $0866c446f81fc052$var$themed('#611F69', '#E8E8EA'),
        boldText: $0866c446f81fc052$var$themed('#FFFFFF', '#292A2E'),
        border: $0866c446f81fc052$var$themed('#C892D1', '#656567'),
        text: $0866c446f81fc052$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-copilot': $0866c446f81fc052$var$monochrome,
    'agent-brand-cortex': {
        accentText: $0866c446f81fc052$var$themed('#25074D', '#AA8AD4'),
        background: $0866c446f81fc052$var$themed('#E9E6ED', '#2D2A33'),
        bold: $0866c446f81fc052$var$themed('#25074D', '#AA8AD4'),
        boldText: $0866c446f81fc052$var$themed('#FFFFFF', '#292A2E'),
        border: $0866c446f81fc052$var$themed('#AA8AD4', '#504460'),
        text: $0866c446f81fc052$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-manus': {
        accentText: $0866c446f81fc052$var$themed('#34322D', '#C7C1B5'),
        background: $0866c446f81fc052$var$themed('#EBEAEA', '#302F30'),
        bold: $0866c446f81fc052$var$themed('#34322D', '#C7C1B5'),
        boldText: $0866c446f81fc052$var$themed('#FFFFFF', '#292A2E'),
        border: $0866c446f81fc052$var$themed('#B5AFAF', '#5A5855'),
        text: $0866c446f81fc052$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-gemini': $0866c446f81fc052$var$monochrome,
    'agent-brand-antigravity': $0866c446f81fc052$var$monochrome,
    /** ADS orange, the fixed telepointer/attribution slot Claude has always used. */ 'agent-brand-claude': {
        accentText: "var(--ds-text-accent-orange, #9E4C00)",
        background: "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
        bold: "var(--ds-background-accent-orange-bolder, #BD5B00)",
        boldText: "var(--ds-text-inverse, #FFFFFF)",
        border: "var(--ds-border-accent-orange, #E06C00)",
        text: "var(--ds-text, #292A2E)"
    },
    /** ADS purple, the fixed telepointer/attribution slot Rovo has always used. */ 'agent-brand-rovo': {
        accentText: "var(--ds-text-accent-purple, #803FA5)",
        background: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
        bold: "var(--ds-background-accent-purple-bolder, #964AC0)",
        boldText: "var(--ds-text-inverse, #FFFFFF)",
        border: "var(--ds-border-accent-purple, #AF59E1)",
        text: "var(--ds-text, #292A2E)"
    },
    'agent-brand-chatgpt': {
        accentText: $0866c446f81fc052$var$themed('#000000', '#E8E8EA'),
        background: $0866c446f81fc052$var$themed('#E5E5E5', '#333335'),
        bold: $0866c446f81fc052$var$themed('#000000', '#E8E8EA'),
        boldText: $0866c446f81fc052$var$themed('#FFFFFF', '#000000'),
        border: $0866c446f81fc052$var$themed('#BEB9B9', '#656567'),
        text: $0866c446f81fc052$var$themed('#292A2E', '#E8E8EA')
    }
};
const $0866c446f81fc052$export$6dbdccb358142509 = Object.fromEntries(Object.entries($0866c446f81fc052$var$brandColors).map(([scheme, colors])=>[
        scheme,
        Object.fromEntries(Object.entries(colors).map(([role, value])=>[
                role,
                `var(--${scheme}-${role}, ${value})`
            ]))
    ]));

});



parcelRegister("dt0iM", function(module, exports) {
$parcel$export(module.exports, "preserveNodeIdentity", () => $02f9ba050a8ef57e$export$e0776a297562f4e0);

var $kW8qW = parcelRequire("kW8qW");
function $02f9ba050a8ef57e$export$e0776a297562f4e0(oldFragment, newFragment) {
    // Fast path: referentially identical — nothing to do
    if (oldFragment === newFragment) return oldFragment;
    // Fast path: structurally equal — reuse old fragment entirely.
    // This covers the common SSR case where collab init sends the same doc.
    if (oldFragment.eq(newFragment)) return oldFragment;
    // Walk children position-by-position and preserve what we can
    const oldCount = oldFragment.childCount;
    const newCount = newFragment.childCount;
    let changed = false;
    const children = [];
    for(let i = 0; i < newCount; i++){
        const newChild = newFragment.child(i);
        if (i < oldCount) {
            const oldChild = oldFragment.child(i);
            if (oldChild === newChild) // Already referentially identical
            children.push(newChild);
            else if (oldChild.eq(newChild)) // Structurally equal — reuse old reference (THE KEY OPERATION)
            children.push(oldChild);
            else if (oldChild.type === newChild.type && oldChild.sameMarkup(newChild) && oldChild.content.childCount > 0 && newChild.content.childCount > 0) {
                // Same type and markup but different content — recurse into children
                const preservedContent = $02f9ba050a8ef57e$export$e0776a297562f4e0(oldChild.content, newChild.content);
                if (preservedContent === oldChild.content) // All content was preserved — reuse old node entirely
                children.push(oldChild);
                else {
                    // Partially changed — create node with preserved content
                    children.push(oldChild.copy(preservedContent));
                    changed = true;
                }
            } else {
                // Completely different node — use new
                children.push(newChild);
                changed = true;
            }
        } else {
            // New child beyond old count — use as-is (insertion)
            children.push(newChild);
            changed = true;
        }
    }
    // If nothing changed and counts match, return old fragment directly
    // (avoids creating a new Fragment object)
    if (!changed && oldCount === newCount) return oldFragment;
    return (0, $kW8qW.Fragment).from(children);
}

});




parcelRegister("d106T", function(module, exports) {
$parcel$export(module.exports, "filterAnalyticsSteps", () => $b390177d2cbbe8a8$export$75962d04b28eb982);

var $7ozbX = parcelRequire("7ozbX");

var $bJsI4 = parcelRequire("bJsI4");
function $b390177d2cbbe8a8$export$75962d04b28eb982(steps) {
    const filteredSteps = steps.reduce((acc, rebaseable)=>{
        if (!(rebaseable.step instanceof (0, $7ozbX.AnalyticsStep))) acc.push(new (0, $bJsI4.Rebaseable)(rebaseable.step, rebaseable.inverted, rebaseable.origin));
        return acc;
    }, []);
    return filteredSteps;
}

});

parcelRegister("2vktY", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $1dd3df9afc75f29b$export$ae829ec7b2625219);
// It is important to get all steps in that package
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $eFqO0 = parcelRequire("eFqO0");

var $eAqkd = parcelRequire("eAqkd");

var $bTWXs = parcelRequire("bTWXs");

var $g6Qq4 = parcelRequire("g6Qq4");

var $f7Kk4 = parcelRequire("f7Kk4");

var $bUbIU = parcelRequire("bUbIU");

var $4MvqL = parcelRequire("4MvqL");

var $efTON = parcelRequire("efTON");

var $vhR4H = parcelRequire("vhR4H");

var $iRgz5 = parcelRequire("iRgz5");
const $1dd3df9afc75f29b$var$enforceCustomStepRegisters = ()=>{
    const tryToRegisterStep = (obj)=>{
        for (const customStep of Object.values(obj)){
            var _customStep$prototype;
            // I know this seems awful
            // But unfortunate ProseMirror does not expose the jsonID property p
            // @ts-expect-error
            const id = customStep === null || customStep === void 0 || (_customStep$prototype = customStep.prototype) === null || _customStep$prototype === void 0 ? void 0 : _customStep$prototype.jsonID;
            if (typeof id === 'string') try {
                // We are trying to re-register the steps here
                // in the normal flow, those custom step should be already registred
                // So, it should throw an expeception
                // @ts-expect-error
                (0, $bUbIU.Step).jsonID(id, customStep);
            } catch (e) {
            // This mean the step was already registred.
            // It is ok to ignore this exception.
            }
        }
    };
    // @ts-expect-error
    tryToRegisterStep($eAqkd);
    // @ts-expect-error
    tryToRegisterStep($eFqO0);
};
const $1dd3df9afc75f29b$export$ae829ec7b2625219 = (dispatch, providerFactory, providerResolver, collabProviderCallback, options, featureFlags, pluginInjectionApi)=>{
    $1dd3df9afc75f29b$var$enforceCustomStepRegisters();
    return new (0, $f7Kk4.SafePlugin)({
        key: (0, $vhR4H.pluginKey),
        state: {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            init (config) {
                return (0, $iRgz5.PluginState).init(config);
            },
            apply (transaction, prevPluginState, _oldEditorState, _newEditorState) {
                const pluginState = prevPluginState.apply(transaction);
                dispatch((0, $vhR4H.pluginKey), pluginState);
                return pluginState;
            }
        },
        props: {
            decorations (state) {
                var _pluginKey$getState;
                return (_pluginKey$getState = (0, $vhR4H.pluginKey).getState(state)) === null || _pluginKey$getState === void 0 ? void 0 : _pluginKey$getState.decorations;
            },
            handleDOMEvents: {
                click (view, event) {
                    var _pluginKey$getState2, _pluginInjectionApi$a;
                    if (!(event.target instanceof HTMLElement)) return false;
                    if (!view.state.selection.empty) return false;
                    const { pos: pos } = view.state.tr.selection.$from;
                    if (!pos) return false;
                    // check if the pos is the same pos as a telepointer decoration
                    const decorations = (_pluginKey$getState2 = (0, $vhR4H.pluginKey).getState(view.state)) === null || _pluginKey$getState2 === void 0 || (_pluginKey$getState2 = _pluginKey$getState2.decorations) === null || _pluginKey$getState2 === void 0 ? void 0 : _pluginKey$getState2.find(pos, pos);
                    if (!(decorations !== null && decorations !== void 0 && decorations.length)) return false;
                    // analytics to track telepointer clicks as they sometimes cause broken selections
                    const fireAnalyticsCallback = (0, $bTWXs.fireAnalyticsEvent)((pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 || (_pluginInjectionApi$a = _pluginInjectionApi$a.sharedState.currentState()) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.createAnalyticsEvent) ?? undefined);
                    fireAnalyticsCallback({
                        payload: {
                            action: (0, $g6Qq4.ACTION).CLICKED,
                            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TELEPOINTER,
                            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).TELEPOINTER,
                            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
                        }
                    });
                }
            }
        },
        filterTransaction (tr, state) {
            const pluginState = (0, $vhR4H.pluginKey).getState(state);
            const collabInitialiseTr = tr.getMeta('collabInitialised');
            // Don't allow transactions that modifies the document before
            // collab-plugin is ready.
            if (collabInitialiseTr) return true;
            if (!(pluginState !== null && pluginState !== void 0 && pluginState.isReady) && tr.docChanged) return false;
            return true;
        },
        view (view) {
            var _pluginInjectionApi$a2, _pluginInjectionApi$a4;
            const addErrorAnalytics = (0, $4MvqL.addSynchronyErrorAnalytics)(view.state, view.state.tr, featureFlags, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a2 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a2 === void 0 ? void 0 : _pluginInjectionApi$a2.actions);
            const onSyncUpError = (attributes)=>{
                var _pluginInjectionApi$a3;
                const fireAnalyticsCallback = (0, $bTWXs.fireAnalyticsEvent)((pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a3 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a3 === void 0 || (_pluginInjectionApi$a3 = _pluginInjectionApi$a3.sharedState.currentState()) === null || _pluginInjectionApi$a3 === void 0 ? void 0 : _pluginInjectionApi$a3.createAnalyticsEvent) ?? undefined);
                fireAnalyticsCallback({
                    payload: {
                        action: (0, $g6Qq4.ACTION).NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS,
                        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                        eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
                        attributes: attributes
                    }
                });
            };
            options.onSyncUpError = onSyncUpError;
            const cleanup = collabProviderCallback((0, $efTON.initialize)({
                view: view,
                options: options,
                providerFactory: providerFactory,
                featureFlags: featureFlags,
                pluginInjectionApi: pluginInjectionApi,
                editorAnalyticsApi: pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a4 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a4 === void 0 ? void 0 : _pluginInjectionApi$a4.actions
            }), addErrorAnalytics);
            providerFactory && providerFactory.subscribe('collabEditProvider', (_name, providerPromise)=>{
                if (providerPromise) providerPromise.then((provider)=>providerResolver(provider));
            });
            return {
                destroy () {
                    providerFactory.unsubscribeAll('collabEditProvider');
                    if (cleanup) cleanup.then((unsubscribe)=>{
                        if (unsubscribe) unsubscribe();
                    });
                }
            };
        }
    });
};

});
parcelRegister("efTON", function(module, exports) {
$parcel$export(module.exports, "initialize", () => $9977f3342b8ce321$export$2a47f398eeff8b01);

var $57l7A = parcelRequire("57l7A");

var $bUbIU = parcelRequire("bUbIU");

var $vhR4H = parcelRequire("vhR4H");

var $bVuW8 = parcelRequire("bVuW8");
const $9977f3342b8ce321$var$initCollab = (collabEditProvider, view)=>{
    if (collabEditProvider.initialize) collabEditProvider.initialize(()=>view.state, (json)=>(0, $bUbIU.Step).fromJSON(view.state.schema, json));
};
const $9977f3342b8ce321$var$initNewCollab = (collabEditProvider, view, editorApi, onSyncUpError)=>{
    collabEditProvider.setup({
        getState: ()=>view.state,
        editorApi: editorApi,
        onSyncUpError: onSyncUpError
    });
};
const $9977f3342b8ce321$var$initCollabMemo = (0, $57l7A.default)($9977f3342b8ce321$var$initCollab);
const $9977f3342b8ce321$export$2a47f398eeff8b01 = ({ options: options, providerFactory: providerFactory, view: view, featureFlags: featureFlags, editorAnalyticsApi: editorAnalyticsApi, pluginInjectionApi: pluginInjectionApi })=>(provider)=>{
        // eslint-disable-next-line prefer-const
        let cleanup;
        const pluginState = (0, $vhR4H.pluginKey).getState(view.state);
        if (pluginState !== null && pluginState !== void 0 && pluginState.isReady && cleanup) cleanup();
        cleanup = (0, $bVuW8.subscribe)(view, provider, options, featureFlags, providerFactory, editorAnalyticsApi);
        // Initialize provider
        if (options.useNativePlugin) // ED-13912 For NCS we don't want to use memoizeOne because it causes
        // infinite text while changing page-width
        $9977f3342b8ce321$var$initNewCollab(provider, view, pluginInjectionApi, options.onSyncUpError);
        else /**
     * We only want to initialise once, if we reload/reconfigure this plugin
     * We dont want to re-init collab, it would break existing sessions
     */ $9977f3342b8ce321$var$initCollabMemo(provider, view);
        return cleanup;
    };

});
parcelRegister("bVuW8", function(module, exports) {
$parcel$export(module.exports, "subscribe", () => $8df671f4a1a606fb$export$ec068583843480e7);

var $xt8ea = parcelRequire("xt8ea");

var $4MvqL = parcelRequire("4MvqL");

var $bkyQf = parcelRequire("bkyQf");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8df671f4a1a606fb$var$effect = (fn, eq)=>{
    let previousDeps;
    let cleanup;
    return (...currentDeps)=>{
        if (cleanup && eq(previousDeps, currentDeps)) return cleanup;
        cleanup = fn(...currentDeps);
        previousDeps = currentDeps;
        return cleanup;
    };
};
const $8df671f4a1a606fb$export$ec068583843480e7 = $8df671f4a1a606fb$var$effect((view, provider, options, featureFlags, _providerFactory, editorAnalyticsApi)=>{
    let entityRef;
    const entityHandlers = {
        disconnectedHandler: ()=>{
            (0, $4MvqL.addSynchronyEntityAnalytics)(view.state, view.state.tr)('disconnected', editorAnalyticsApi);
        },
        errorHandler: ()=>{
            (0, $4MvqL.addSynchronyEntityAnalytics)(view.state, view.state.tr)('error', editorAnalyticsApi);
        }
    };
    const unsubscribeSynchronyEntity = ()=>{
        if (entityRef) {
            entityRef.off('disconnected', entityHandlers.disconnectedHandler);
            entityRef.off('error', entityHandlers.errorHandler);
        }
    };
    const handlers = {
        initHandler: (data)=>{
            view.dispatch(view.state.tr.setMeta('collabInitialised', true));
            (0, $xt8ea.handleInit)(data, view, options, editorAnalyticsApi);
        },
        connectedHandler: (data)=>(0, $xt8ea.handleConnection)(data, view),
        dataHandler: (data)=>(0, $xt8ea.applyRemoteData)(data, view, options, editorAnalyticsApi),
        presenceHandler: (data)=>(0, $xt8ea.handlePresence)(data, view),
        telepointerHandler: (data)=>(0, $xt8ea.handleTelePointer)(data, view),
        localStepsHandler: (data)=>{
            const { steps: steps } = data;
            const { state: state } = view;
            const { tr: tr } = state;
            steps.forEach((step)=>tr.step(step));
            view.dispatch(tr);
        },
        errorHandler: (error)=>{
            (0, $4MvqL.addSynchronyErrorAnalytics)(view.state, view.state.tr, featureFlags, editorAnalyticsApi)(error);
        },
        entityHandler: ({ entity: entity })=>{
            unsubscribeSynchronyEntity();
            if (options.EXPERIMENTAL_allowInternalErrorAnalytics) {
                entity.on('disconnected', entityHandlers.disconnectedHandler);
                entity.on('error', entityHandlers.errorHandler);
                entityRef = entity;
            }
        },
        dataConflictHandler: (data)=>{
            view.dispatch(view.state.tr.setMeta((0, $bkyQf.trackLastRemoteConflictPluginKey), data));
        }
    };
    provider.on('init', handlers.initHandler).on('connected', handlers.connectedHandler).on('data', handlers.dataHandler).on('presence', handlers.presenceHandler).on('telepointer', handlers.telepointerHandler).on('local-steps', handlers.localStepsHandler).on('error', handlers.errorHandler).on('entity', handlers.entityHandler).on('data:conflict', handlers.dataConflictHandler);
    return ()=>{
        unsubscribeSynchronyEntity();
        provider.off('init', handlers.initHandler).off('connected', handlers.connectedHandler).off('data', handlers.dataHandler).off('presence', handlers.presenceHandler).off('telepointer', handlers.telepointerHandler).off('local-steps', handlers.localStepsHandler).off('error', handlers.errorHandler).off('entity', handlers.entityHandler).off('data:conflict', handlers.dataConflictHandler);
    };
}, (previousDeps, currentDeps)=>currentDeps && currentDeps.every((dep, i)=>dep === previousDeps[i]));

});
parcelRegister("bkyQf", function(module, exports) {
$parcel$export(module.exports, "trackLastRemoteConflictPluginKey", () => $a615a7524df7adc9$export$1fa2affd5117a057);
$parcel$export(module.exports, "createPlugin", () => $a615a7524df7adc9$export$ae829ec7b2625219);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");
const $a615a7524df7adc9$export$1fa2affd5117a057 = new (0, $cw0wu.PluginKey)('trackLastRemoteConflict');
const $a615a7524df7adc9$export$ae829ec7b2625219 = ()=>{
    return new (0, $f7Kk4.SafePlugin)({
        key: $a615a7524df7adc9$export$1fa2affd5117a057,
        state: {
            init () {
                return undefined;
            },
            apply (transaction, prevPluginState) {
                const metadata = transaction.getMeta($a615a7524df7adc9$export$1fa2affd5117a057);
                if (metadata) return metadata;
                return prevPluginState;
            }
        }
    });
};

});



parcelRegister("iRgz5", function(module, exports) {
$parcel$export(module.exports, "PluginState", () => $65dc689a1afa9001$export$d8e4bc17e84598c5);

var $jxkn6 = parcelRequire("jxkn6");

var $gZj5p = parcelRequire("gZj5p");

var $cw0wu = parcelRequire("cw0wu");

var $a3b9P = parcelRequire("a3b9P");

var $fmU5O = parcelRequire("fmU5O");

var $2kimw = parcelRequire("2kimw");

var $8gaSy = parcelRequire("8gaSy");
const $65dc689a1afa9001$export$1e860daa85a829a5 = (tr, pos)=>{
    const endOfDocPos = tr.doc.nodeSize - 2;
    if (pos <= endOfDocPos) {
        const resolvedPos = tr.doc.resolve(pos);
        const backwardSelection = (0, $cw0wu.Selection).findFrom(resolvedPos, -1, true);
        // if there's no correct cursor position before the `pos`, we try to find it after the `pos`
        const forwardSelection = (0, $cw0wu.Selection).findFrom(resolvedPos, 1, true);
        return backwardSelection ? backwardSelection.from : forwardSelection ? forwardSelection.from : pos;
    }
    return endOfDocPos;
};
class $65dc689a1afa9001$export$d8e4bc17e84598c5 {
    get decorations() {
        return this.decorationSet;
    }
    get activeParticipants() {
        return this.participants;
    }
    get sessionId() {
        return this.sid;
    }
    constructor(decorations, participants, sessionId, collabInitalised = false, onError, nudgeAnimations = new Map(), agentShimmers = []){
        // eslint-disable-next-line no-console
        this.onError = (error)=>console.error(error);
        this.decorationSet = decorations;
        this.participants = participants;
        this.sid = sessionId;
        this.isReady = collabInitalised;
        this.onError = onError || this.onError;
        this.nudgeAnimations = nudgeAnimations;
        this.agentShimmers = agentShimmers;
    }
    getFullName(sessionId) {
        const participant = this.participants.get(sessionId);
        return participant ? participant.name : 'X';
    }
    getInitial(sessionId) {
        return this.getFullName(sessionId).substring(0, 1).toUpperCase();
    }
    getPresenceId(sessionId) {
        const participant = this.participants.get(sessionId);
        return (participant === null || participant === void 0 ? void 0 : participant.presenceId) ?? sessionId;
    }
    apply(tr) {
        // Ignored via go/ees005
        // eslint-disable-next-line prefer-const
        let { participants: participants, sid: sid, isReady: isReady } = this;
        const presenceData = tr.getMeta('presence');
        const telepointerData = tr.getMeta('telepointer');
        const nudgeTelepointerData = tr.getMeta('nudgeTelepointer');
        const agentShimmerData = tr.getMeta((0, $8gaSy.ADD_AGENT_SHIMMER_META));
        const removeAgentShimmerId = tr.getMeta((0, $8gaSy.REMOVE_AGENT_SHIMMER_META));
        const highlightAgentShimmerId = tr.getMeta((0, $8gaSy.HIGHLIGHT_AGENT_SHIMMER_META));
        const sessionIdData = tr.getMeta('sessionId');
        let collabInitialised = tr.getMeta('collabInitialised');
        if (typeof collabInitialised !== 'boolean') collabInitialised = isReady;
        if (sessionIdData) sid = sessionIdData.sid;
        let add = [];
        let remove = [];
        if (presenceData) {
            const { joined: joined = [], left: left = [] } = presenceData;
            participants = participants.remove(left.map((i)=>i.sessionId));
            participants = participants.add(joined);
            // Remove telepointers for users that left
            left.forEach((i)=>{
                const pointers = (0, $2kimw.findPointers)(this.getPresenceId(i.sessionId), this.decorationSet);
                if (pointers) remove = remove.concat(pointers);
            });
        }
        if (telepointerData) {
            const { sessionId: sessionId } = telepointerData;
            if (participants.get(sessionId) && sessionId !== sid) {
                var _participants$get;
                const oldPointers = (0, $2kimw.findPointers)(this.getPresenceId(sessionId), this.decorationSet);
                if (oldPointers) remove = remove.concat(oldPointers);
                const endOfDocPos = tr.doc.nodeSize - 2;
                const anchor = telepointerData.selection.anchor;
                const head = telepointerData.selection.head;
                let rawFrom = anchor < head ? anchor : head;
                let rawTo = anchor >= head ? anchor : head;
                if (rawFrom > endOfDocPos) rawFrom = endOfDocPos;
                if (rawTo > endOfDocPos) rawTo = endOfDocPos;
                const isSelection = rawTo - rawFrom > 0;
                let from = 1;
                let to = 1;
                try {
                    from = $65dc689a1afa9001$export$1e860daa85a829a5(tr, isSelection ? Math.max(rawFrom, 0) : rawFrom);
                    to = isSelection ? $65dc689a1afa9001$export$1e860daa85a829a5(tr, rawTo) : from;
                } catch (err) {
                    this.onError(err);
                }
                add = add.concat((0, $2kimw.createTelepointers)(from, to, sessionId, isSelection, this.getInitial(sessionId), this.getPresenceId(sessionId), this.getFullName(sessionId), (0, $2kimw.hasExistingNudge)(sessionId, this.nudgeAnimations), (_participants$get = participants.get(sessionId)) === null || _participants$get === void 0 ? void 0 : _participants$get.agentType));
            }
        }
        if (tr.docChanged) // Adjust decoration positions to changes made by the transaction
        try {
            this.decorationSet = this.decorationSet.map(tr.mapping, tr.doc, {
                // Reapplies decorators those got removed by the state change
                onRemove: (spec)=>{
                    if (spec.pointer && spec.pointer.sessionId && spec.key === `telepointer-${spec.pointer.sessionId}`) {
                        const step = tr.steps.filter((0, $2kimw.isReplaceStep))[0];
                        if (step) {
                            var _participants$get2;
                            const { sessionId: sessionId, presenceId: presenceId } = spec.pointer;
                            const { slice: { content: { size: size } }, from: from } = step;
                            const pos = $65dc689a1afa9001$export$1e860daa85a829a5(tr, size ? Math.min(from + size, tr.doc.nodeSize - 3) : Math.max(from, 1));
                            add = add.concat((0, $2kimw.createTelepointers)(pos, pos, sessionId, false, this.getInitial(sessionId), presenceId, this.getFullName(sessionId), (0, $2kimw.hasExistingNudge)(sessionId, this.nudgeAnimations), (_participants$get2 = participants.get(sessionId)) === null || _participants$get2 === void 0 ? void 0 : _participants$get2.agentType));
                        }
                    }
                }
            });
        } catch (err) {
            this.onError(err);
        }
        const { selection: selection } = tr;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.decorationSet.find().forEach((deco)=>{
            var _deco$spec;
            // Never let telepointer dim/side logic touch agent-shimmer decorations.
            if ((_deco$spec = deco.spec) !== null && _deco$spec !== void 0 && _deco$spec.isAgentShimmer) return;
            if (deco.type.toDOM) {
                const hasTelepointerDimClass = deco.type.toDOM.classList.contains((0, $gZj5p.TELEPOINTER_DIM_CLASS));
                const browser = (0, $jxkn6.getBrowserInfo)();
                if (deco.from === selection.from && deco.to === selection.to) {
                    if (!hasTelepointerDimClass) deco.type.toDOM.classList.add((0, $gZj5p.TELEPOINTER_DIM_CLASS));
                    // Browser condition here to fix ED-14722 where telepointer
                    // decorations with side -1 in Firefox causes backspace issues.
                    // This is likely caused by contenteditable quirks in Firefox
                    if (!browser.gecko) deco.type.side = -1;
                } else {
                    if (hasTelepointerDimClass) deco.type.toDOM.classList.remove((0, $gZj5p.TELEPOINTER_DIM_CLASS));
                    deco.type.side = 0;
                }
            }
        });
        if (nudgeTelepointerData) {
            const nudgeSessionId = nudgeTelepointerData === null || nudgeTelepointerData === void 0 ? void 0 : nudgeTelepointerData.sessionId;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.decorationSet.find().forEach((deco)=>{
                var _deco$spec2, _deco$spec3, _deco$spec4;
                // Never let telepointer nudge logic touch agent-shimmer decorations.
                if ((_deco$spec2 = deco.spec) !== null && _deco$spec2 !== void 0 && _deco$spec2.isAgentShimmer) return;
                if (deco.type.toDOM && participants.get(nudgeSessionId) && ((_deco$spec3 = deco.spec) === null || _deco$spec3 === void 0 || (_deco$spec3 = _deco$spec3.pointer) === null || _deco$spec3 === void 0 ? void 0 : _deco$spec3.sessionId) === nudgeSessionId && ((_deco$spec4 = deco.spec) === null || _deco$spec4 === void 0 ? void 0 : _deco$spec4.key) === `telepointer-${nudgeSessionId}`) {
                    // Restart animation by removing and re-adding the class
                    deco.type.toDOM.classList.remove((0, $gZj5p.TELEPOINTER_PULSE_DURING_TR_CLASS));
                    deco.type.toDOM.classList.remove((0, $gZj5p.TELEPOINTER_PULSE_CLASS));
                    deco.type.toDOM.offsetWidth; // Force reflow
                    deco.type.toDOM.classList.add((0, $gZj5p.TELEPOINTER_PULSE_CLASS));
                    this.nudgeAnimations.set(nudgeSessionId, Date.now());
                }
            });
        }
        // Register / keep-aligned / remove the agent-edit purple highlight
        // decorations. Fully fault-isolated — it works on local copies and only merges into the shared
        // `add`/`remove` (and commits `this.agentShimmers`) after the whole block succeeds, so a fault
        // here can never corrupt telepointer decorations or the shared decoration set. Never mutates
        // shimmer entries in place: each change produces a fresh array of fresh objects.
        try {
            const { changed: changed, next: next } = (0, $8gaSy.reduceAgentShimmers)(this.agentShimmers, tr, agentShimmerData, removeAgentShimmerId, highlightAgentShimmerId);
            if (changed) {
                // Build into local arrays; only merge into the shared add/remove once the block succeeds.
                const agentRemove = this.decorationSet.find(undefined, undefined, (spec)=>spec.isAgentShimmer);
                const agentAdd = (0, $8gaSy.buildAgentShimmerDecorations)(tr, next, $65dc689a1afa9001$export$1e860daa85a829a5, this.onError);
                // Commit only after the whole block succeeded.
                remove = remove.concat(agentRemove);
                add = add.concat(agentAdd);
                this.agentShimmers = next;
            }
        } catch (err) {
            this.onError(err);
            // Degrade to no shimmer without corrupting telepointer decorations: drop all agent
            // decorations and clear agent state, leaving the telepointer `add`/`remove` untouched.
            this.agentShimmers = [];
            try {
                remove = remove.concat(this.decorationSet.find(undefined, undefined, (spec)=>spec.isAgentShimmer));
            } catch  {
            // Teardown must not re-throw.
            }
        }
        if (remove.length) this.decorationSet = this.decorationSet.remove(remove);
        if (add.length) this.decorationSet = this.decorationSet.add(tr.doc, add);
        // This piece needs to be after the decorationSet adjustments,
        // otherwise it's always one step behind where the cursor is
        if (telepointerData) {
            const { sessionId: sessionId } = telepointerData;
            if (participants.get(sessionId)) {
                const positionForScroll = (0, $2kimw.getPositionOfTelepointer)(sessionId, this.decorationSet);
                if (positionForScroll) participants = participants.updateCursorPos(sessionId, positionForScroll);
            }
        }
        const nextState = new $65dc689a1afa9001$export$d8e4bc17e84598c5(this.decorationSet, participants, sid, collabInitialised, this.onError, this.nudgeAnimations, this.agentShimmers);
        return $65dc689a1afa9001$export$d8e4bc17e84598c5.eq(nextState, this) ? this : nextState;
    }
    static eq(a, b) {
        return a.participants === b.participants && a.sessionId === b.sessionId && a.isReady === b.isReady;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static init(config) {
        const { doc: doc, onError: onError } = config;
        return new $65dc689a1afa9001$export$d8e4bc17e84598c5((0, $a3b9P.DecorationSet).create(doc, []), new (0, $fmU5O.Participants)(), undefined, undefined, onError);
    }
}

});
parcelRegister("fmU5O", function(module, exports) {
$parcel$export(module.exports, "Participants", () => $478a488bfe99e4f3$export$3ebbcd8e174d58e4);
class $478a488bfe99e4f3$export$3ebbcd8e174d58e4 {
    constructor(participants = new Map()){
        this.participants = participants;
    }
    add(data) {
        const newSet = new Map(this.participants);
        data.forEach((participant)=>{
            newSet.set(participant.sessionId, participant);
        });
        return new $478a488bfe99e4f3$export$3ebbcd8e174d58e4(newSet);
    }
    remove(sessionIds) {
        const newSet = new Map(this.participants);
        sessionIds.forEach((sessionId)=>{
            newSet.delete(sessionId);
        });
        return new $478a488bfe99e4f3$export$3ebbcd8e174d58e4(newSet);
    }
    update(sessionId, lastActive) {
        const newSet = new Map(this.participants);
        const data = newSet.get(sessionId);
        if (!data) return this;
        newSet.set(sessionId, {
            ...data,
            lastActive: lastActive
        });
        return new $478a488bfe99e4f3$export$3ebbcd8e174d58e4(newSet);
    }
    updateCursorPos(sessionId, cursorPos) {
        const newSet = new Map(this.participants);
        const data = newSet.get(sessionId);
        if (!data) return this;
        newSet.set(sessionId, {
            ...data,
            cursorPos: cursorPos
        });
        return new $478a488bfe99e4f3$export$3ebbcd8e174d58e4(newSet);
    }
    toArray() {
        return Array.from(this.participants.values());
    }
    get(sessionId) {
        return this.participants.get(sessionId);
    }
    size() {
        return this.participants.size;
    }
    eq(other) {
        const left = this.toArray().map((p)=>p.sessionId).sort((a, b)=>a > b ? -1 : 1).join('');
        const right = other.toArray().map((p)=>p.sessionId).sort((a, b)=>a > b ? -1 : 1).join('');
        return left === right;
    }
}

});



parcelRegister("i6EP1", function(module, exports) {
$parcel$export(module.exports, "mergeUnconfirmedSteps", () => $dc65a77558a14617$export$8e3092acded15d5d);

var $hVGJk = parcelRequire("hVGJk");

var $cw0wu = parcelRequire("cw0wu");

var $bJsI4 = parcelRequire("bJsI4");
const $dc65a77558a14617$var$isLocked = (step)=>{
    if (step.origin instanceof (0, $cw0wu.Transaction)) return step.origin.getMeta('mergeIsLocked');
    return false;
};
function $dc65a77558a14617$export$8e3092acded15d5d(steps, api) {
    const mergedSteps = steps.reduce((acc, rebaseable)=>{
        var _api$connectivity;
        const lastStep = acc[acc.length - 1];
        const isOffline = (0, $hVGJk.isOfflineMode)(api === null || api === void 0 || (_api$connectivity = api.connectivity) === null || _api$connectivity === void 0 || (_api$connectivity = _api$connectivity.sharedState.currentState()) === null || _api$connectivity === void 0 ? void 0 : _api$connectivity.mode);
        if (lastStep && !$dc65a77558a14617$var$isLocked(lastStep) && !$dc65a77558a14617$var$isLocked(rebaseable)) {
            const mergedStep = lastStep.step.merge(rebaseable.step);
            const inverted = rebaseable.inverted.merge(lastStep.inverted);
            // Always take the origin of the new step.
            // We use this in packages/editor/collab-provider/src/document/document-service.ts:commitUnconfirmedSteps
            // to confirm that the last transaction has been sent. Since we're taking the latest this still works as expected
            // As we want to wait until all the transactions have been pushed through
            const origin = lastStep.origin;
            if (mergedStep && inverted) {
                acc[acc.length - 1] = new (0, $bJsI4.Rebaseable)(mergedStep, inverted, origin instanceof (0, $cw0wu.Transaction) ? origin.setMeta('isOffline', origin.getMeta('isOffline') === true || isOffline) : origin);
                return acc;
            }
        }
        acc.push(new (0, $bJsI4.Rebaseable)(rebaseable.step, rebaseable.inverted, rebaseable.origin instanceof (0, $cw0wu.Transaction) ? rebaseable.origin.setMeta('isOffline', rebaseable.origin.getMeta('isOffline') === true || isOffline) : rebaseable.origin));
        return acc;
    }, []);
    return mergedSteps;
}

});

parcelRegister("hMKzB", function(module, exports) {
$parcel$export(module.exports, "monitorOrganic", () => $993dda3e26c95918$export$41ae48ec4a268424);

var $7ozbX = parcelRequire("7ozbX");

var $3S6Lb = parcelRequire("3S6Lb");

var $6uFJn = parcelRequire("6uFJn");
// This is essentially a queue of cached events. When the background task runs to send these items then this queue is flushed.
const $993dda3e26c95918$var$organicReportingCache = [];
// Every ten seconds we will try to process the step data.
const $993dda3e26c95918$var$LOW_PRIORITY_DELAY = 10000;
const $993dda3e26c95918$export$5cff7ac265db316a = (obj)=>{
    if (!obj) return null;
    if ('scheduler' in obj) return obj.scheduler;
    return null;
};
/**
 * Processes the steps metadata from the cache and calls the callback function with the processed data.
 *
 * @param {OrganicCacheType} cache - A cache containing steps metadata.
 * @param {(data: OrganicMetadataAnalytics[]) => void} onDataProcessed - Callback function to be called with the processed data.
 */ const $993dda3e26c95918$var$task = (cache, onDataProcessed)=>{
    const data = [];
    for (const item of cache){
        const { steps: steps, ...rest } = item;
        // We'll use the same grouping and sanitize logic from the track-steps util
        const stepTypesAmount = (0, $6uFJn.groupSteps)(steps.map((0, $6uFJn.sanitizeStep)));
        data.push({
            ...rest,
            stepTypesAmount: stepTypesAmount
        });
    }
    // clear the cache.
    cache.length = 0;
    if (data.length > 0) onDataProcessed(data);
};
const $993dda3e26c95918$export$41ae48ec4a268424 = ({ newEditorState: newEditorState, oldEditorState: oldEditorState, transactions: transactions, onDataProcessed: onDataProcessed })=>{
    // We can exclude analytic steps since they should never trigger an organic change.
    const newSteps = transactions.flatMap((t)=>t.steps).filter((step)=>!(step instanceof (0, $7ozbX.AnalyticsStep)));
    const scheduler = $993dda3e26c95918$export$5cff7ac265db316a(window);
    if (!newSteps.length || !scheduler) return;
    // We know that an organic change during startup will trigger a draft sync which will;
    // fire editor edited event ->  confluence/next/packages/editor-features/src/hooks/useDraftSync/useDraftSync.tsx
    // and call triggerUpdate() notifying the BE that user edited the page -> confluence/next/packages/editor-features/src/hooks/useDraftSync/useEditorDraftSyncAction.tsx
    // This can cause a problem with statsig metrics if organic changes are being incorrectly reported, ie an automated change
    // occurs which contributes the user towards editing a page when in fact they didn't edit the page.
    //
    const oldPluginState = (0, $3S6Lb.trackLastOrganicChangePluginKey).getState(oldEditorState);
    const newPluginState = (0, $3S6Lb.trackLastOrganicChangePluginKey).getState(newEditorState);
    if (newSteps.length && (oldPluginState === null || oldPluginState === void 0 ? void 0 : oldPluginState.lastLocalOrganicBodyChangeAt) !== (newPluginState === null || newPluginState === void 0 ? void 0 : newPluginState.lastLocalOrganicBodyChangeAt)) {
        const now = Date.now();
        const isFirstChange = !(oldPluginState !== null && oldPluginState !== void 0 && oldPluginState.lastLocalOrganicBodyChangeAt);
        // Check if we should compact with the previous entry (within 2 seconds) this means with a possible 10sec delay
        // due to the postTask we could have a potential 5 grouped organic changes listed.
        const shouldCompact = $993dda3e26c95918$var$organicReportingCache.length > 0 && now - $993dda3e26c95918$var$organicReportingCache[$993dda3e26c95918$var$organicReportingCache.length - 1].startedAt < 2000;
        if (shouldCompact) {
            // Compact with previous entry
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const prev = $993dda3e26c95918$var$organicReportingCache.pop(); // We know it exists due to shouldCompact check
            // tr.docChanged
            $993dda3e26c95918$var$organicReportingCache.push({
                transactions: prev.transactions + 1,
                startedAt: prev.startedAt,
                endedAt: now,
                isFirstChange: prev.isFirstChange || isFirstChange,
                steps: prev.steps.concat(newSteps)
            });
        } else // Add new entry
        $993dda3e26c95918$var$organicReportingCache.push({
            transactions: 1,
            startedAt: now,
            endedAt: now,
            isFirstChange: isFirstChange,
            steps: newSteps
        });
        if ($993dda3e26c95918$var$organicReportingCache.length === 1) scheduler.postTask(()=>{
            $993dda3e26c95918$var$task($993dda3e26c95918$var$organicReportingCache, onDataProcessed);
        }, {
            priority: 'background',
            delay: $993dda3e26c95918$var$LOW_PRIORITY_DELAY
        });
    }
};

});
parcelRegister("3S6Lb", function(module, exports) {
$parcel$export(module.exports, "trackLastOrganicChangePluginKey", () => $b1a83a93d3b25cb4$export$e968e014d3efd8b6);
$parcel$export(module.exports, "createPlugin", () => $b1a83a93d3b25cb4$export$ae829ec7b2625219);

var $gZj5p = parcelRequire("gZj5p");

var $f7Kk4 = parcelRequire("f7Kk4");

var $1z9eI = parcelRequire("1z9eI");

var $cw0wu = parcelRequire("cw0wu");

var $3DNV7 = parcelRequire("3DNV7");

var $gdUUy = parcelRequire("gdUUy");

var $2kimw = parcelRequire("2kimw");
const $b1a83a93d3b25cb4$export$e968e014d3efd8b6 = new (0, $cw0wu.PluginKey)('collabTrackLastOrganicChangePlugin');
const $b1a83a93d3b25cb4$export$ae829ec7b2625219 = ()=>{
    return new (0, $f7Kk4.SafePlugin)({
        key: $b1a83a93d3b25cb4$export$e968e014d3efd8b6,
        state: {
            init () {
                return {
                    ...(0, $gdUUy.fg)('confluence_ncs_step_diffing_version_history') && {
                        localHumanBodyChangeCount: 0
                    },
                    lastLocalOrganicChangeAt: null,
                    lastRemoteOrganicChangeAt: null,
                    lastLocalOrganicBodyChangeAt: null,
                    lastRemoteOrganicBodyChangeAt: null
                };
            },
            apply (transaction, prevPluginState) {
                if (Boolean(transaction.getMeta('appendedTransaction'))) return prevPluginState;
                const isRemote = Boolean(transaction.getMeta('isRemote'));
                const isDocumentReplaceFromRemote = isRemote && Boolean(transaction.getMeta('replaceDocument'));
                // Inline comment annotations are not considered as edits to the document body
                const isAnnotationStep = !!transaction.steps.find((step)=>{
                    var _step$mark;
                    return (step instanceof (0, $3DNV7.AddMarkStep) || step instanceof (0, $3DNV7.RemoveMarkStep)) && ((_step$mark = step.mark) === null || _step$mark === void 0 || (_step$mark = _step$mark.type) === null || _step$mark === void 0 ? void 0 : _step$mark.name) === 'annotation';
                });
                if (isDocumentReplaceFromRemote) return prevPluginState;
                if ((0, $gZj5p.isDirtyTransaction)(transaction)) return prevPluginState;
                if ((0, $2kimw.isOrganicChange)(transaction)) {
                    if (isRemote) return {
                        ...(0, $gdUUy.fg)('confluence_ncs_step_diffing_version_history') && {
                            localHumanBodyChangeCount: prevPluginState.localHumanBodyChangeCount
                        },
                        lastLocalOrganicChangeAt: prevPluginState.lastLocalOrganicChangeAt,
                        lastRemoteOrganicChangeAt: Date.now(),
                        lastLocalOrganicBodyChangeAt: prevPluginState.lastLocalOrganicBodyChangeAt,
                        lastRemoteOrganicBodyChangeAt: isAnnotationStep ? prevPluginState.lastRemoteOrganicBodyChangeAt : Date.now()
                    };
                    // Agent transactions can be local (frontend streaming) or remote (NCS).
                    // Keep organic-change tracking intact for saving, but track human attribution separately.
                    const isAgentChange = (0, $gdUUy.fg)('confluence_ncs_step_diffing_version_history') && Boolean(transaction.getMeta((0, $1z9eI.AGENT_ATTRIBUTION_META)));
                    return {
                        ...(0, $gdUUy.fg)('confluence_ncs_step_diffing_version_history') && {
                            localHumanBodyChangeCount: (prevPluginState.localHumanBodyChangeCount ?? 0) + (isAnnotationStep || isAgentChange ? 0 : 1)
                        },
                        lastLocalOrganicChangeAt: Date.now(),
                        lastRemoteOrganicChangeAt: prevPluginState.lastRemoteOrganicChangeAt,
                        lastLocalOrganicBodyChangeAt: isAnnotationStep ? prevPluginState.lastLocalOrganicBodyChangeAt : Date.now(),
                        lastRemoteOrganicBodyChangeAt: prevPluginState.lastRemoteOrganicBodyChangeAt
                    };
                }
                return prevPluginState;
            }
        }
    });
};

});
parcelRegister("1z9eI", function(module, exports) {
$parcel$export(module.exports, "AGENT_ATTRIBUTION_META", () => $22bf8c5c48c374df$export$bb32337aa23b35fb);
/** Transaction metadata used to attribute an editor change to an agent. */ const $22bf8c5c48c374df$export$bb32337aa23b35fb = 'agentAttribution';

});


parcelRegister("6uFJn", function(module, exports) {
$parcel$export(module.exports, "sanitizeStep", () => $f871272d32790fb2$export$685b976035d234a6);
$parcel$export(module.exports, "groupSteps", () => $f871272d32790fb2$export$cb21deee7d469afa);

var $48ZJc = parcelRequire("48ZJc");

var $4eNaz = parcelRequire("4eNaz");

var $3DNV7 = parcelRequire("3DNV7");
function $f871272d32790fb2$var$groupBy(array, keyGetter) {
    // Check group by exists, and that it's a function. If so, use the native browser code
    if ('groupBy' in Object && typeof Object.groupBy === 'function') return Object.groupBy(array, keyGetter);
    // Fallback to custom implementation
    const map = {};
    array.forEach((item)=>{
        const key = keyGetter(item);
        if (!map[key]) map[key] = [];
        map[key].push(item);
    });
    return map;
}
const $f871272d32790fb2$export$685b976035d234a6 = (step)=>{
    const serializedStep = step.toJSON();
    const sanitizedStep = {
        stepType: serializedStep.stepType
    };
    if (step instanceof (0, $3DNV7.AttrStep) || step instanceof (0, $3DNV7.DocAttrStep)) sanitizedStep.attr = step.attr;
    else if (step instanceof (0, $4eNaz.SetAttrsStep)) // Combines all attrs keys separated by _ to one single string
    sanitizedStep.attr = Object.keys(step.attrs).sort().join('_');
    else if (step instanceof (0, $3DNV7.AddMarkStep) || step instanceof (0, $3DNV7.RemoveMarkStep) || step instanceof (0, $3DNV7.RemoveNodeMarkStep) || step instanceof (0, $3DNV7.AddNodeMarkStep)) sanitizedStep.markType = step.mark.type.name;
    else if (step instanceof (0, $48ZJc.BatchAttrsStep)) {
        const batched = step.data.map(({ nodeType: nodeType, attrs: attrs })=>`${nodeType}_${Object.keys(attrs).sort().join('_')}`);
        sanitizedStep.attr = batched.sort().join('_');
    }
    return sanitizedStep;
};
const $f871272d32790fb2$export$cb21deee7d469afa = (sanitizedSteps)=>{
    const grouped = $f871272d32790fb2$var$groupBy(sanitizedSteps, (e)=>Object.values(e).join('_'));
    return Object.entries(grouped).reduce((acc, [key, value])=>{
        acc[key] = Array.isArray(value) ? value.length : 0;
        return acc;
    }, {});
};

});


parcelRegister("9bYLV", function(module, exports) {
$parcel$export(module.exports, "nativeCollabProviderPlugin", () => $e444df24d1df6b43$export$ad653665b59b3ffd);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");
const $e444df24d1df6b43$var$nativeCollabProviderPluginKey = new (0, $cw0wu.PluginKey)('nativeCollabProviderPlugin');
const $e444df24d1df6b43$export$ad653665b59b3ffd = ({ providerPromise: providerPromise })=>{
    return new (0, $f7Kk4.SafePlugin)({
        key: $e444df24d1df6b43$var$nativeCollabProviderPluginKey,
        state: {
            init: ()=>null,
            apply: (tr, currentPluginState)=>{
                const provider = tr.getMeta($e444df24d1df6b43$var$nativeCollabProviderPluginKey);
                return provider ? provider : currentPluginState;
            }
        },
        view: (editorView)=>{
            providerPromise.then((provider)=>{
                const { dispatch: dispatch, state: state } = editorView;
                const tr = state.tr;
                tr.setMeta($e444df24d1df6b43$var$nativeCollabProviderPluginKey, provider);
                dispatch(tr);
            });
            return {};
        }
    });
};
const $e444df24d1df6b43$export$82feb779db31f396 = (editorState)=>{
    return $e444df24d1df6b43$var$nativeCollabProviderPluginKey.getState(editorState);
};

});

parcelRegister("koQIy", function(module, exports) {
$parcel$export(module.exports, "sanitizeFilteredStep", () => $38760427244e4994$export$2d791416d1075a3b);
$parcel$export(module.exports, "createPlugin", () => $38760427244e4994$export$ae829ec7b2625219);

var $7ozbX = parcelRequire("7ozbX");

var $jsWoI = parcelRequire("jsWoI");

var $4eNaz = parcelRequire("4eNaz");

var $5sUZ8 = parcelRequire("5sUZ8");

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $3DNV7 = parcelRequire("3DNV7");
const $38760427244e4994$var$THRESHOLD = 50; // 50 milliseconds
const $38760427244e4994$export$2d791416d1075a3b = (step)=>{
    const serializedStep = step.toJSON();
    const sanitizedStep = {
        stepType: serializedStep.stepType,
        stepInstance: 'unknown'
    };
    if (step instanceof (0, $3DNV7.AttrStep)) {
        sanitizedStep.attr = step.attr;
        sanitizedStep.stepInstance = 'AttrStep';
    } else if (step instanceof (0, $3DNV7.DocAttrStep)) {
        sanitizedStep.attr = step.attr;
        sanitizedStep.stepInstance = 'DocAttrStep';
    } else if (step instanceof (0, $4eNaz.SetAttrsStep)) {
        // Combines all attrs keys separated by _ to one single string
        sanitizedStep.attr = Object.keys(step.attrs).sort().join('_');
        sanitizedStep.stepInstance = 'SetAttrsStep';
    } else if (step instanceof (0, $3DNV7.AddMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'AddMarkStep';
    } else if (step instanceof (0, $3DNV7.RemoveMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'RemoveMarkStep';
    } else if (step instanceof (0, $3DNV7.RemoveNodeMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'RemoveNodeMarkStep';
    } else if (step instanceof (0, $3DNV7.AddNodeMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'AddNodeMarkStep';
    } else if (step instanceof (0, $3DNV7.ReplaceStep)) sanitizedStep.stepInstance = 'ReplaceStep';
    else if (step instanceof (0, $3DNV7.ReplaceAroundStep)) sanitizedStep.stepInstance = 'ReplaceAroundStep';
    else if (step instanceof (0, $7ozbX.AnalyticsStep)) sanitizedStep.stepInstance = 'AnalyticsStep';
    else if (step instanceof (0, $5sUZ8.InsertTypeAheadStep)) sanitizedStep.stepInstance = 'InsertTypeAheadStep';
    else if (step instanceof (0, $jsWoI.LinkMetaStep)) sanitizedStep.stepInstance = 'LinkMetaStep';
    return sanitizedStep;
};
const $38760427244e4994$export$4bff6ad17bbfeba7 = (recentTransactionsTimestamps, trackFilteredTransaction)=>{
    return (tr)=>{
        if (Boolean(tr.getMeta('appendTransaction'))) return true;
        const isRemote = Boolean(tr.getMeta('isRemote'));
        if (isRemote) return true;
        const containsExcludedSteps = tr.steps.some((step)=>{
            return step instanceof (0, $7ozbX.AnalyticsStep) || step instanceof (0, $3DNV7.ReplaceStep) || step instanceof (0, $3DNV7.ReplaceAroundStep) || step instanceof (0, $jsWoI.LinkMetaStep);
        });
        if (containsExcludedSteps) return true;
        if (tr.docChanged && tr.doc.eq(tr.before)) {
            const transactionKey = $38760427244e4994$export$16b712be60324104(tr);
            if (!transactionKey) return true;
            //Clean up tracked transactions when time over threshold
            recentTransactionsTimestamps.forEach((value, key)=>{
                if (tr.time - value.timestamp > $38760427244e4994$var$THRESHOLD) // Delete tracked transaction when over threshold
                recentTransactionsTimestamps.delete(key);
            });
            const lastTransactionEntry = recentTransactionsTimestamps.get(transactionKey);
            if (!lastTransactionEntry) {
                // If no timestamp exists for the given transaction, allow transaction and add an entry
                recentTransactionsTimestamps.set(transactionKey, {
                    timestamp: tr.time,
                    steps: tr.steps
                });
                return true;
            }
            // Track analytics for the filtered transaction
            trackFilteredTransaction(tr);
            // Filter transaction
            return false;
        }
        return true; // Allow the transaction
    };
};
function $38760427244e4994$export$16b712be60324104(tr) {
    const stepPositions = tr.steps.map((step)=>{
        if (step instanceof (0, $3DNV7.RemoveNodeMarkStep) || step instanceof (0, $3DNV7.AddNodeMarkStep) || step instanceof (0, $4eNaz.SetAttrsStep) || step instanceof (0, $3DNV7.AttrStep)) {
            if (step.pos !== undefined) return `${step.pos}`;
        } else if (step instanceof (0, $3DNV7.AddMarkStep) || step instanceof (0, $3DNV7.RemoveMarkStep)) return `from_${step.from}_to_${step.to}`;
        else if (step instanceof (0, $5sUZ8.InsertTypeAheadStep)) return `insertTypeAheadStep`;
        return '';
    });
    if (stepPositions.some((step)=>Boolean(step))) return stepPositions.join('_');
    return '';
}
const $38760427244e4994$export$ea2d2436326e1247 = new (0, $cw0wu.PluginKey)('trackAndFilterSpammingStepsPluginKey');
const $38760427244e4994$export$ae829ec7b2625219 = (trackFilteredTransaction)=>{
    const recentTransactionsTimestamps = new Map();
    return new (0, $f7Kk4.SafePlugin)({
        key: $38760427244e4994$export$ea2d2436326e1247,
        filterTransaction: $38760427244e4994$export$4bff6ad17bbfeba7(recentTransactionsTimestamps, trackFilteredTransaction)
    });
};

});

parcelRegister("1kArI", function(module, exports) {
$parcel$export(module.exports, "trackNCSInitializationPluginKey", () => $52cb4da5f0629ead$export$a79cdfb4b852386b);
$parcel$export(module.exports, "createPlugin", () => $52cb4da5f0629ead$export$ae829ec7b2625219);

var $gZj5p = parcelRequire("gZj5p");

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $3DNV7 = parcelRequire("3DNV7");

var $2kimw = parcelRequire("2kimw");
const $52cb4da5f0629ead$export$a79cdfb4b852386b = new (0, $cw0wu.PluginKey)('collabTrackNCSInitializationPlugin');
const $52cb4da5f0629ead$export$ae829ec7b2625219 = ()=>{
    return new (0, $f7Kk4.SafePlugin)({
        key: $52cb4da5f0629ead$export$a79cdfb4b852386b,
        state: {
            init () {
                return {
                    collabInitialisedAt: null,
                    firstChangeAfterInitAt: null,
                    firstContentBodyChangeAfterInitAt: null
                };
            },
            apply (transaction, prevPluginState, oldState) {
                if (Boolean(transaction.getMeta('collabInitialised'))) return {
                    collabInitialisedAt: Date.now(),
                    firstChangeAfterInitAt: null,
                    firstContentBodyChangeAfterInitAt: null
                };
                const shouldCheckDocument = prevPluginState.collabInitialisedAt && !prevPluginState.firstContentBodyChangeAfterInitAt;
                if (!shouldCheckDocument) return prevPluginState;
                const isRemote = (0, $2kimw.originalTransactionHasMeta)(transaction, 'isRemote');
                const isDocumentReplaceFromRemote = isRemote && (0, $2kimw.originalTransactionHasMeta)(transaction, 'replaceDocument');
                if (isDocumentReplaceFromRemote) return prevPluginState;
                if ((0, $gZj5p.isDirtyTransaction)(transaction)) return prevPluginState;
                if (transaction.docChanged && !transaction.doc.eq(oldState.doc)) {
                    // For analytics purposes, inline comment annotations are not considered as edits to the document body
                    // Transaction may contain other steps, but we know that they won't be user-generated (non synthetic) steps
                    // Additionally, for analytics purposes we do not want to trigger on other participants' changes (i.e. remote changes)
                    const isAnnotationStep = !!transaction.steps.find((step)=>{
                        var _step$mark;
                        return step instanceof (0, $3DNV7.AddMarkStep) && ((_step$mark = step.mark) === null || _step$mark === void 0 || (_step$mark = _step$mark.type) === null || _step$mark === void 0 ? void 0 : _step$mark.name) === 'annotation';
                    });
                    return {
                        collabInitialisedAt: prevPluginState.collabInitialisedAt,
                        firstChangeAfterInitAt: Date.now(),
                        firstContentBodyChangeAfterInitAt: isAnnotationStep || isRemote ? prevPluginState.firstContentBodyChangeAfterInitAt : Date.now()
                    };
                }
                return prevPluginState;
            }
        },
        props: {
            attributes (editorState) {
                const trackPluginState = $52cb4da5f0629ead$export$a79cdfb4b852386b.getState(editorState);
                return {
                    ['data-has-collab-initialised']: `${Boolean(trackPluginState === null || trackPluginState === void 0 ? void 0 : trackPluginState.collabInitialisedAt)}`
                };
            }
        }
    });
};

});


parcelRegister("9cRNW", function(module, exports) {
$parcel$export(module.exports, "feedbackDialogPlugin", () => $bd8d60a03d6306cb$export$1b6ac82b29dcc009);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5BUNL = parcelRequire("5BUNL");

var $cW1gB = parcelRequire("cW1gB");

var $1hyMp = parcelRequire("1hyMp");
let $bd8d60a03d6306cb$var$showJiraCollectorDialog;
let $bd8d60a03d6306cb$var$feedbackInfoHash;
let $bd8d60a03d6306cb$var$defaultFeedbackInfo;
const $bd8d60a03d6306cb$var$hashFeedbackInfo = (feedbackInfo)=>{
    const { product: product, packageName: packageName, packageVersion: packageVersion, labels: labels } = feedbackInfo;
    return [
        product,
        packageName,
        packageVersion,
        ...labels || []
    ].join('|');
};
const $bd8d60a03d6306cb$export$432e2d318c18feaa = async (feedbackInfo)=>// eslint-disable-next-line no-async-promise-executor
    new Promise(async (resolve, reject)=>{
        const combinedFeedbackInfo = {
            product: 'n/a',
            labels: [],
            packageName: '',
            packageVersion: '',
            coreVersion: '',
            sessionId: '',
            contentId: '',
            tabId: '',
            ...$bd8d60a03d6306cb$var$defaultFeedbackInfo,
            ...feedbackInfo
        };
        const newFeedbackInfoHash = $bd8d60a03d6306cb$var$hashFeedbackInfo(combinedFeedbackInfo);
        if (!$bd8d60a03d6306cb$var$showJiraCollectorDialog || $bd8d60a03d6306cb$var$feedbackInfoHash !== newFeedbackInfoHash) try {
            $bd8d60a03d6306cb$var$showJiraCollectorDialog = await (0, $1hyMp.default)([
                combinedFeedbackInfo.product,
                ...combinedFeedbackInfo.labels
            ], combinedFeedbackInfo.packageName, combinedFeedbackInfo.coreVersion, combinedFeedbackInfo.packageVersion, combinedFeedbackInfo.sessionId, combinedFeedbackInfo.contentId, combinedFeedbackInfo.tabId);
            $bd8d60a03d6306cb$var$feedbackInfoHash = newFeedbackInfoHash;
        } catch (err) {
            reject(err);
        }
        const timeoutId = window.setTimeout($bd8d60a03d6306cb$var$showJiraCollectorDialog, 0);
        // Return the timoutId for consumers to call clearTimeout if they need to.
        resolve(timeoutId);
    });
const $bd8d60a03d6306cb$export$1b6ac82b29dcc009 = ({ config: feedbackInfo, api: api })=>{
    $bd8d60a03d6306cb$var$defaultFeedbackInfo = feedbackInfo ?? {};
    return {
        name: 'feedbackDialog',
        actions: {
            openFeedbackDialog: $bd8d60a03d6306cb$export$432e2d318c18feaa
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'feedbackdialog',
                        title: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).feedbackDialog),
                        description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).feedbackDialogDescription),
                        priority: 400,
                        keywords: [
                            'bug'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5BUNL.IconFeedback), {}),
                        action (insert, state) {
                            var _api$analytics;
                            const tr = insert('');
                            $bd8d60a03d6306cb$export$432e2d318c18feaa(feedbackInfo);
                            api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.attachAnalyticsEvent({
                                action: (0, $g6Qq4.ACTION).OPENED,
                                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).FEEDBACK_DIALOG,
                                attributes: {
                                    inputMethod: (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $g6Qq4.EVENT_TYPE).UI
                            })(tr);
                            return tr;
                        }
                    }
                ]
        }
    };
};

});
parcelRegister("1hyMp", function(module, exports) {
$parcel$export(module.exports, "default", () => $062dcdc02e8121c4$export$2e2bcd8739ae039);

var $f6IJD = parcelRequire("f6IJD");

var $ZI3AG = parcelRequire("ZI3AG");
const $062dcdc02e8121c4$var$JIRA_ISSUE_COLLECTOR_URL = 'https://product-fabric.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/-w0bwo4/b/14/e73395c53c3b10fde2303f4bf74ffbf6/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs.js?locale=en-US&collectorId=98644b9c';
const $062dcdc02e8121c4$var$loadJiraCollectorDialogScript = (labels, packageName, coreVersion, packageVersion, sessionId, contentId, tabId)=>{
    // eslint-disable-next-line no-async-promise-executor, require-await
    return new Promise(async (resolve, reject)=>{
        if (window.jQuery) {
            window.ATL_JQ_PAGE_PROPS = {
                triggerFunction: (showCollectorDialog)=>{
                    if (typeof showCollectorDialog === 'function') resolve(showCollectorDialog);
                    else reject('Failed to initialize showCollectorDialog');
                },
                fieldValues: {
                    description: `Please describe the problem you're having or feature you'd like to see:\n\n\n`,
                    // 11711 is the field ID for the Feedback Labels field on Product Fabric.
                    // this is found by clicking "configure" on the field and inspecting the URL
                    customfield_11711: labels || [],
                    customfield_11712: `version: ${packageName}@${packageVersion} (${coreVersion})
              Browser: ${(0, $f6IJD.default)(navigator.userAgent)}
              OS: ${(0, $ZI3AG.default)(navigator.userAgent, navigator.appVersion)}`
                },
                environment: {
                    'Editor Package': packageName,
                    'Editor Version': packageVersion,
                    'Editor Core Version': coreVersion,
                    sessionId: sessionId,
                    contentId: contentId,
                    tabId: tabId
                },
                priority: '1',
                components: '15306' // Fix here
            };
            window.jQuery.ajax({
                url: $062dcdc02e8121c4$var$JIRA_ISSUE_COLLECTOR_URL,
                type: 'get',
                cache: true,
                dataType: 'script'
            });
        } else reject('jQuery is not defined');
    });
};
var $062dcdc02e8121c4$export$2e2bcd8739ae039 = $062dcdc02e8121c4$var$loadJiraCollectorDialogScript;

});
parcelRegister("f6IJD", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf2db6d9893bd46a$export$2e2bcd8739ae039);
/**
 * Inspired from:
 * https://stackoverflow.com/questions/11219582/how-to-detect-my-browser-version-and-operating-system-using-javascript
 */ const $bf2db6d9893bd46a$var$getBrowserInfo = (nAgt)=>{
    let browserName;
    let browserVersion;
    let nameOffset;
    let verOffset;
    let index;
    // In Opera 15+, version is after "OPR/"
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf('OPR/')) !== -1) {
        browserName = 'Opera';
        browserVersion = nAgt.substring(verOffset + 4);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
        // In older Opera, version is after "Opera" or after "Version"
        browserName = 'Opera';
        // Ignored via go/ees005
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf('Version')) !== -1) browserVersion = nAgt.substring(verOffset + 8);
        else browserVersion = nAgt.substring(verOffset + 6);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
        // In MSIE, version is after "MSIE" in userAgent
        browserName = 'Microsoft Internet Explorer';
        browserVersion = nAgt.substring(verOffset + 5);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
        // In Chrome, version is after "Chrome"
        browserName = 'Chrome';
        browserVersion = nAgt.substring(verOffset + 7);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
        // In Safari, version is after "Safari" or after "Version"
        browserName = 'Safari';
        // Ignored via go/ees005
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf('Version')) !== -1) browserVersion = nAgt.substring(verOffset + 8);
        else browserVersion = nAgt.substring(verOffset + 7);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
        // In Firefox, version is after "Firefox"
        browserName = 'Firefox';
        browserVersion = nAgt.substring(verOffset + 8);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        // In most other browsers, "name/version" is at the end of userAgent
        browserName = nAgt.substring(nameOffset, verOffset);
        browserVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() === browserName.toUpperCase()) browserName = navigator.appName;
    } else {
        browserName = navigator.appName;
        browserVersion = '' + parseFloat(navigator.appVersion);
    }
    // trim the versionStr string at semicolon/space if present
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    if ((index = browserVersion.indexOf(';')) !== -1) browserVersion = browserVersion.substring(0, index);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    if ((index = browserVersion.indexOf(' ')) !== -1) browserVersion = browserVersion.substring(0, index);
    return `${browserName} ${browserVersion}`;
};
var $bf2db6d9893bd46a$export$2e2bcd8739ae039 = $bf2db6d9893bd46a$var$getBrowserInfo;

});

parcelRegister("ZI3AG", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca3963d0384cf77f$export$2e2bcd8739ae039);
/**
 * Inspired from:
 * https://stackoverflow.com/questions/9514179/how-to-find-the-operating-system-version-using-javascript
 */ // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$WIN16_REGEX = /Win16/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$WINDOWS_95_REGEX = /(Windows 95|Win95|Windows_95)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$WINDOWS_ME_REGEX = /(Win 9x 4.90|Windows ME)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$WINDOWS_98_REGEX = /(Windows 98|Win98)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$WINDOWS_CE_REGEX = /Windows CE/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$WINDOWS_2000_REGEX = /(Windows NT 5.0|Windows 2000)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$WINDOWS_XP_REGEX = /(Windows NT 5.1|Windows XP)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$WINDOWS_SERVER_2003_REGEX = /Windows NT 5.2/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$WINDOWS_VISTA_REGEX = /Windows NT 6.0/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$WINDOWS_7_REGEX = /(Windows 7|Windows NT 6.1)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$WINDOWS_8_1_REGEX = /(Windows 8.1|Windows NT 6.3)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$WINDOWS_8_REGEX = /(Windows 8|Windows NT 6.2)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$WINDOWS_NT_4_REGEX = /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$ANDROID_REGEX = /Android/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$OPEN_BSD_REGEX = /OpenBSD/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$SUN_OS_REGEX = /SunOS/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$LINUX_REGEX = /(Linux|X11)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$IOS_REGEX = /(iPhone|iPad|iPod)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$MAC_OS_X_REGEX = /Mac OS X/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$MAC_OS_REGEX = /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$QNX_REGEX = /QNX/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$UNIX_REGEX = /UNIX/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$BEOS_REGEX = /BeOS/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$OS2_REGEX = /OS\/2/;
// Ignored via go/ees005
/* eslint-disable require-unicode-regexp */ const $ca3963d0384cf77f$var$SEARCH_BOT_REGEX = /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/;
/* eslint-enable require-unicode-regexp */ // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$WINDOWS_TEST_REGEX = /Windows/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$WINDOWS_VERSION_REGEX = /Windows (.*)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$MAC_OS_X_VERSION_REGEX = /Mac OS X (10[\.\_\d]+)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$ANDROID_VERSION_REGEX = /Android ([\.\_\d]+)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ca3963d0384cf77f$var$IOS_VERSION_REGEX = /OS (\d+)_(\d+)_?(\d+)?/;
const $ca3963d0384cf77f$var$getDeviceInfo = (nAgt, nVersion)=>{
    let os = '';
    let osVersion = '';
    const clientStrings = [
        {
            s: 'Windows 3.11',
            r: $ca3963d0384cf77f$var$WIN16_REGEX
        },
        {
            s: 'Windows 95',
            r: $ca3963d0384cf77f$var$WINDOWS_95_REGEX
        },
        {
            s: 'Windows ME',
            r: $ca3963d0384cf77f$var$WINDOWS_ME_REGEX
        },
        {
            s: 'Windows 98',
            r: $ca3963d0384cf77f$var$WINDOWS_98_REGEX
        },
        {
            s: 'Windows CE',
            r: $ca3963d0384cf77f$var$WINDOWS_CE_REGEX
        },
        {
            s: 'Windows 2000',
            r: $ca3963d0384cf77f$var$WINDOWS_2000_REGEX
        },
        {
            s: 'Windows XP',
            r: $ca3963d0384cf77f$var$WINDOWS_XP_REGEX
        },
        {
            s: 'Windows Server 2003',
            r: $ca3963d0384cf77f$var$WINDOWS_SERVER_2003_REGEX
        },
        {
            s: 'Windows Vista',
            r: $ca3963d0384cf77f$var$WINDOWS_VISTA_REGEX
        },
        {
            s: 'Windows 7',
            r: $ca3963d0384cf77f$var$WINDOWS_7_REGEX
        },
        {
            s: 'Windows 8.1',
            r: $ca3963d0384cf77f$var$WINDOWS_8_1_REGEX
        },
        {
            s: 'Windows 8',
            r: $ca3963d0384cf77f$var$WINDOWS_8_REGEX
        },
        {
            s: 'Windows NT 4.0',
            r: $ca3963d0384cf77f$var$WINDOWS_NT_4_REGEX
        },
        {
            s: 'Android',
            r: $ca3963d0384cf77f$var$ANDROID_REGEX
        },
        {
            s: 'Open BSD',
            r: $ca3963d0384cf77f$var$OPEN_BSD_REGEX
        },
        {
            s: 'Sun OS',
            r: $ca3963d0384cf77f$var$SUN_OS_REGEX
        },
        {
            s: 'Linux',
            r: $ca3963d0384cf77f$var$LINUX_REGEX
        },
        {
            s: 'iOS',
            r: $ca3963d0384cf77f$var$IOS_REGEX
        },
        {
            s: 'Mac OS X',
            r: $ca3963d0384cf77f$var$MAC_OS_X_REGEX
        },
        {
            s: 'Mac OS',
            r: $ca3963d0384cf77f$var$MAC_OS_REGEX
        },
        {
            s: 'QNX',
            r: $ca3963d0384cf77f$var$QNX_REGEX
        },
        {
            s: 'UNIX',
            r: $ca3963d0384cf77f$var$UNIX_REGEX
        },
        {
            s: 'BeOS',
            r: $ca3963d0384cf77f$var$BEOS_REGEX
        },
        {
            s: 'OS/2',
            r: $ca3963d0384cf77f$var$OS2_REGEX
        },
        {
            s: 'Search Bot',
            r: $ca3963d0384cf77f$var$SEARCH_BOT_REGEX
        }
    ];
    // eslint-disable-next-line guard-for-in
    for(const client in clientStrings){
        const clientObj = clientStrings[client];
        if (clientObj.r.test(nAgt)) {
            os = clientObj.s;
            break;
        }
    }
    let match;
    if ($ca3963d0384cf77f$var$WINDOWS_TEST_REGEX.test(os)) {
        match = $ca3963d0384cf77f$var$WINDOWS_VERSION_REGEX.exec(os);
        osVersion = match && match[1];
        os = 'Windows';
    }
    switch(os){
        case 'Mac OS X':
            match = $ca3963d0384cf77f$var$MAC_OS_X_VERSION_REGEX.exec(nAgt);
            osVersion = match && match[1];
            break;
        case 'Android':
            match = $ca3963d0384cf77f$var$ANDROID_VERSION_REGEX.exec(nAgt);
            osVersion = match && match[1];
            break;
        case 'iOS':
            match = $ca3963d0384cf77f$var$IOS_VERSION_REGEX.exec(nVersion);
            osVersion = match && match[1] + '.' + match[2] + '.' + (match[3] || 0);
    }
    return `${os} ${osVersion}`;
};
var $ca3963d0384cf77f$export$2e2bcd8739ae039 = $ca3963d0384cf77f$var$getDeviceInfo;

});



parcelRegister("6HB5K", function(module, exports) {
$parcel$export(module.exports, "imageUploadPlugin", () => $94e0dbc46fd124b4$export$e3bfb926c9700157);

var $7hTfS = parcelRequire("7hTfS");

var $6OWbT = parcelRequire("6OWbT");

var $aGV0V = parcelRequire("aGV0V");

var $lfI8T = parcelRequire("lfI8T");
const $94e0dbc46fd124b4$export$e3bfb926c9700157 = ()=>{
    const uploadHandlerReference = {
        current: null
    };
    return {
        name: 'imageUpload',
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $lfI8T.stateKey).getState(editorState);
        },
        actions: {
            startUpload: ()=>(0, $7hTfS.insertActionForToolbar)(uploadHandlerReference)
        },
        pmPlugins () {
            return [
                {
                    name: 'imageUpload',
                    plugin: (0, $aGV0V.createPlugin)(uploadHandlerReference)
                },
                {
                    name: 'imageUploadInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $6OWbT.default)(schema, featureFlags)
                }
            ];
        }
    };
};

});
parcelRegister("7hTfS", function(module, exports) {
$parcel$export(module.exports, "insertActionForToolbar", () => $64aa881544db745b$export$62f5bb5681401150);

var $csM7z = parcelRequire("csM7z");
const $64aa881544db745b$export$62f5bb5681401150 = (uploadHandlerReference)=>{
    return (state, dispatch)=>{
        if (!uploadHandlerReference.current) return false;
        uploadHandlerReference.current(undefined, (options)=>{
            (0, $csM7z.insertExternalImage)(options)(state, dispatch);
        });
        return true;
    };
};

});
parcelRegister("csM7z", function(module, exports) {
$parcel$export(module.exports, "insertExternalImage", () => $c45c30034ec1d02e$export$d978a1cf00cd351b);
$parcel$export(module.exports, "startImageUpload", () => $c45c30034ec1d02e$export$41b18c224f9e33da);

var $gab48 = parcelRequire("gab48");

var $fjT1m = parcelRequire("fjT1m");

var $4s9wZ = parcelRequire("4s9wZ");

var $lfI8T = parcelRequire("lfI8T");
const $c45c30034ec1d02e$export$d978a1cf00cd351b = (options)=>(state, dispatch)=>{
        const pluginState = (0, $lfI8T.stateKey).getState(state);
        if (!(pluginState !== null && pluginState !== void 0 && pluginState.enabled) || !options.src) return false;
        const mediaNode = (0, $fjT1m.createExternalMediaNode)(options.src, state.schema);
        if (!mediaNode) return false;
        if (dispatch) dispatch((0, $gab48.safeInsert)(mediaNode, state.selection.$to.pos)(state.tr).scrollIntoView());
        return true;
    };
const $c45c30034ec1d02e$export$41b18c224f9e33da = (event)=>(state, dispatch)=>{
        const pluginState = (0, $lfI8T.stateKey).getState(state);
        if (pluginState && !pluginState.enabled) return false;
        if (dispatch) dispatch((0, $4s9wZ.startUpload)(event)(state.tr));
        return true;
    };

});
parcelRegister("fjT1m", function(module, exports) {
$parcel$export(module.exports, "isMediaSelected", () => $267206dac137c945$export$d2ec7ab2b2a98746);
$parcel$export(module.exports, "canInsertMedia", () => $267206dac137c945$export$262e43a15b79aeb7);
$parcel$export(module.exports, "createExternalMediaNode", () => $267206dac137c945$export$4747cb76ebf8d6df);

var $cw0wu = parcelRequire("cw0wu");
const $267206dac137c945$export$d2ec7ab2b2a98746 = (state)=>{
    const { media: media } = state.schema.nodes;
    return state.selection instanceof (0, $cw0wu.NodeSelection) && state.selection.node.type === media;
};
const $267206dac137c945$export$262e43a15b79aeb7 = (state)=>{
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    const { $to: $to } = state.selection;
    if (mediaSingle) for(let d = $to.depth; d >= 0; d--){
        const index = $to.index(d);
        if ($to.node(d).canReplaceWith(index, index, mediaSingle)) return true;
    }
    return false;
};
const $267206dac137c945$export$4747cb76ebf8d6df = (url, schema)=>{
    const { media: media, mediaSingle: mediaSingle } = schema.nodes;
    if (!media || !mediaSingle) return null;
    const mediaNode = media.createChecked({
        type: 'external',
        url: url
    });
    return mediaSingle.createChecked({}, mediaNode);
};

});

parcelRegister("4s9wZ", function(module, exports) {
$parcel$export(module.exports, "startUpload", () => $edf97772b4f3ed9e$export$bacf5b3f68174df);

var $lfI8T = parcelRequire("lfI8T");
const $edf97772b4f3ed9e$var$imageUploadAction = (tr, action)=>{
    return tr.setMeta((0, $lfI8T.stateKey), action);
};
const $edf97772b4f3ed9e$export$bacf5b3f68174df = (event)=>(tr)=>$edf97772b4f3ed9e$var$imageUploadAction(tr, {
            name: 'START_UPLOAD',
            event: event
        });

});
parcelRegister("lfI8T", function(module, exports) {
$parcel$export(module.exports, "stateKey", () => $525d9cd5ca1ee7bc$export$77b371d6becc8882);

var $cw0wu = parcelRequire("cw0wu");
const $525d9cd5ca1ee7bc$export$77b371d6becc8882 = new (0, $cw0wu.PluginKey)('imageUploadPlugin');

});




parcelRegister("6OWbT", function(module, exports) {
$parcel$export(module.exports, "default", () => $690effdfd85568f3$export$2e2bcd8739ae039);

var $f7Kk4 = parcelRequire("f7Kk4");

var $33v8M = parcelRequire("33v8M");

var $8t09p = parcelRequire("8t09p");

var $fjT1m = parcelRequire("fjT1m");
// eslint-disable-next-line require-unicode-regexp
const $690effdfd85568f3$var$MARKDOWN_IMAGE_REGEX = /!\[(.*)\]\((\S+)\)$/;
function $690effdfd85568f3$export$568a7ed6897c4817(schema, featureFlags) {
    if (!schema.nodes.media || !schema.nodes.mediaSingle) return;
    // ![something](link) should convert to an image
    // eslint-disable-next-line require-unicode-regexp
    const imageRule = (0, $33v8M.createRule)($690effdfd85568f3$var$MARKDOWN_IMAGE_REGEX, (state, match, start, end)=>{
        const { schema: schema } = state;
        const attrs = {
            src: match[2],
            alt: match[1]
        };
        const node = (0, $fjT1m.createExternalMediaNode)(attrs.src, schema);
        if (node) return state.tr.replaceWith(start, end, node);
        return null;
    });
    return new (0, $f7Kk4.SafePlugin)((0, $8t09p.createPlugin)('image-upload', [
        imageRule
    ]));
}
var $690effdfd85568f3$export$2e2bcd8739ae039 = $690effdfd85568f3$export$568a7ed6897c4817;

});

parcelRegister("aGV0V", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $59f522b194100eaa$export$ae829ec7b2625219);

var $aMbh4 = parcelRequire("aMbh4");

var $f7Kk4 = parcelRequire("f7Kk4");

var $1mwwk = parcelRequire("1mwwk");

var $lx6Wu = parcelRequire("lx6Wu");

var $fjT1m = parcelRequire("fjT1m");

var $csM7z = parcelRequire("csM7z");

var $lfI8T = parcelRequire("lfI8T");
/**
 * Microsoft Office includes a screenshot image when copying text content.
 *
 * This function determines whether or not we can ignore the image if it
 * came from MS Office. We do this by checking for
 *
 * - plain text
 * - HTML text which includes the MS Office namespace
 * - the number of files and the file name/type
 *
 * It is easy to manually verify this using by using Office on Mac
 * (or Excel if on Windows) and pasting into
 * https://evercoder.github.io/clipboard-inspector/
 *
 * Note: image content in Word is stored in the `text/html` portion
 * of the clipboard, not under `files` attachment like the screenshot.
 *
 * @returns boolean True if the paste event contains a screenshot from MS Office
 */ const $59f522b194100eaa$var$hasScreenshotImageFromMSOffice = (ev)=>{
    const { clipboardData: clipboardData } = ev;
    if (!clipboardData || clipboardData.files.length !== 1) return false;
    const textPlain = !!clipboardData.getData('text/plain');
    const textHtml = clipboardData.getData('text/html');
    const isOfficeXMLNamespace = textHtml.includes('urn:schemas-microsoft-com:office:office');
    const file = clipboardData.files[0];
    const isImagePNG = file.type === 'image/png' && file.name === 'image.png';
    return isImagePNG && textPlain && isOfficeXMLNamespace;
};
const $59f522b194100eaa$var$createReferenceEventFromEvent = (event)=>{
    var _event$dataTransfer, _event$clipboardData;
    if (!(0, $lx6Wu.isDragEvent)(event) && !(0, $1mwwk.isClipboardEvent)(event)) return null;
    // Get files list and early exit if files is undefined
    const files = (0, $lx6Wu.isDragEvent)(event) ? (_event$dataTransfer = event.dataTransfer) === null || _event$dataTransfer === void 0 ? void 0 : _event$dataTransfer.files : (_event$clipboardData = event.clipboardData) === null || _event$clipboardData === void 0 ? void 0 : _event$clipboardData.files;
    if (!files) return null;
    // Convert filelist into an array
    const filesArray = Array.from(files);
    // Creating a new DataTransfer object should remove any mutation that could be possible from the original event
    const dataTransfer = filesArray.reduce((acc, value)=>{
        acc.items.add(value);
        return acc;
    }, new DataTransfer());
    return {
        type: (0, $lx6Wu.isDragEvent)(event) ? 'drop' : 'paste',
        ...(0, $lx6Wu.isDragEvent)(event) && {
            dataTransfer: dataTransfer
        },
        ...(0, $1mwwk.isClipboardEvent)(event) && {
            clipboardData: dataTransfer
        }
    };
};
const $59f522b194100eaa$var$createDOMHandler = (pred, _eventName, uploadHandlerReference)=>(view, event)=>{
        if (!pred(event)) return false;
        const shouldUpload = !$59f522b194100eaa$var$hasScreenshotImageFromMSOffice(event);
        const referenceEvent = $59f522b194100eaa$var$createReferenceEventFromEvent(event);
        if (shouldUpload && referenceEvent) {
            event.preventDefault();
            event.stopPropagation();
            // Insert external image into document
            if (uploadHandlerReference.current) uploadHandlerReference.current(referenceEvent, (options)=>{
                (0, $csM7z.insertExternalImage)(options)(view.state, view.dispatch);
            });
            // Start image upload
            (0, $csM7z.startImageUpload)(referenceEvent)(view.state, view.dispatch);
        }
        return shouldUpload;
    };
const $59f522b194100eaa$var$getNewActiveUpload = (tr, pluginState)=>{
    const meta = tr.getMeta((0, $lfI8T.stateKey));
    if (meta && meta.name === 'START_UPLOAD') return {
        event: meta.event
    };
    return pluginState.activeUpload;
};
const $59f522b194100eaa$export$ae829ec7b2625219 = (uploadHandlerReference)=>({ dispatch: dispatch, providerFactory: providerFactory })=>{
        return new (0, $f7Kk4.SafePlugin)({
            state: {
                init (_config, state) {
                    return {
                        active: false,
                        enabled: (0, $fjT1m.canInsertMedia)(state),
                        hidden: !state.schema.nodes.media || !state.schema.nodes.mediaSingle
                    };
                },
                apply (tr, pluginState, _oldState, newState) {
                    const newActive = (0, $fjT1m.isMediaSelected)(newState);
                    const newEnabled = (0, $fjT1m.canInsertMedia)(newState);
                    const newActiveUpload = $59f522b194100eaa$var$getNewActiveUpload(tr, pluginState);
                    if (newActive !== pluginState.active || newEnabled !== pluginState.enabled || newActiveUpload !== pluginState.activeUpload) {
                        const newPluginState = {
                            ...pluginState,
                            active: newActive,
                            enabled: newEnabled,
                            activeUpload: newActiveUpload
                        };
                        dispatch((0, $lfI8T.stateKey), newPluginState);
                        return newPluginState;
                    }
                    return pluginState;
                }
            },
            key: (0, $lfI8T.stateKey),
            view: ()=>{
                const handleProvider = async (name, provider)=>{
                    if (name !== 'imageUploadProvider' || !provider) return;
                    try {
                        const imageUploadProvider = await provider;
                        uploadHandlerReference.current = imageUploadProvider;
                    } catch (e) {
                        uploadHandlerReference.current = null;
                    }
                };
                providerFactory.subscribe('imageUploadProvider', handleProvider);
                return {
                    destroy () {
                        uploadHandlerReference.current = null;
                        providerFactory.unsubscribe('imageUploadProvider', handleProvider);
                    }
                };
            },
            props: {
                handleDOMEvents: {
                    drop: $59f522b194100eaa$var$createDOMHandler((0, $lx6Wu.isDroppedFile), 'atlassian.editor.image.drop', uploadHandlerReference),
                    paste: $59f522b194100eaa$var$createDOMHandler((event)=>(0, $aMbh4.isPastedFile)(event), 'atlassian.editor.image.paste', uploadHandlerReference)
                }
            }
        });
    };

});
parcelRegister("1mwwk", function(module, exports) {
$parcel$export(module.exports, "isClipboardEvent", () => $a1de1b9f21f1b69a$export$5694727fbed080b4);
// Typeguard Function
const $a1de1b9f21f1b69a$export$5694727fbed080b4 = (event)=>'clipboardData' in event;

});

parcelRegister("lx6Wu", function(module, exports) {
$parcel$export(module.exports, "isDragEvent", () => $567e994a2c206565$export$fd4eab91eb7545c8);
$parcel$export(module.exports, "isDroppedFile", () => $567e994a2c206565$export$6ca76751d014281f);
// Typeguard Function
const $567e994a2c206565$export$fd4eab91eb7545c8 = (event)=>'dataTransfer' in event;
function $567e994a2c206565$export$6ca76751d014281f(rawEvent) {
    const e = rawEvent;
    if (!e.dataTransfer) return false;
    return Array.prototype.slice.call(e.dataTransfer.types).indexOf('Files') !== -1;
}

});



parcelRegister("7vpIc", function(module, exports) {
$parcel$export(module.exports, "default", () => $85f01be10b8f8305$export$2e2bcd8739ae039);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $3y2s4 = parcelRequire("3y2s4");
const $85f01be10b8f8305$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('maxContentSizePlugin');
function $85f01be10b8f8305$export$ae829ec7b2625219(dispatch, maxContentSize) {
    if (!maxContentSize) return;
    let maxContentSizeReached = false;
    return new (0, $f7Kk4.SafePlugin)({
        state: {
            init: ()=>({
                    maxContentSizeReached: false
                }),
            apply (tr, state) {
                const result = tr.doc && tr.doc.nodeSize > maxContentSize - 1;
                return {
                    maxContentSizeReached: result
                };
            }
        },
        key: $85f01be10b8f8305$export$18d4026d1ea86bb1,
        filterTransaction (tr) {
            const result = tr.doc && tr.doc.nodeSize > maxContentSize;
            if (result || result !== maxContentSizeReached) dispatch($85f01be10b8f8305$export$18d4026d1ea86bb1, {
                maxContentSizeReached: result
            });
            maxContentSizeReached = result;
            if ((0, $3y2s4.isExperimentEnabled)('platform_editor_max_content_size_allow_delete')) // A document can load already over the limit, so only block transactions that grow it
            // further — otherwise there is no way to edit it back under the limit.
            return !result || tr.doc.nodeSize <= tr.before.nodeSize;
            return !result;
        }
    });
}
const $85f01be10b8f8305$var$maxContentSizePlugin = ({ config: maxContentSize, api: api })=>{
    return {
        name: 'maxContentSize',
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return $85f01be10b8f8305$export$18d4026d1ea86bb1.getState(editorState);
        },
        pmPlugins () {
            return [
                {
                    name: 'maxContentSize',
                    plugin: ({ dispatch: dispatch })=>$85f01be10b8f8305$export$ae829ec7b2625219(dispatch, maxContentSize)
                }
            ];
        }
    };
};
var $85f01be10b8f8305$export$2e2bcd8739ae039 = $85f01be10b8f8305$var$maxContentSizePlugin;

});

parcelRegister("ehQm8", function(module, exports) {
$parcel$export(module.exports, "mentionsPlugin", () => $c4131a0423de54db$export$280dfabe1535ae84);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $7RHfd = parcelRequire("7RHfd");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5BUNL = parcelRequire("5BUNL");

var $cW1gB = parcelRequire("cW1gB");

var $6ny6f = parcelRequire("6ny6f");

var $fRXfs = parcelRequire("fRXfs");

var $5g8DV = parcelRequire("5g8DV");

var $lyKnc = parcelRequire("lyKnc");

var $eBfRL = parcelRequire("eBfRL");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $797yE = parcelRequire("797yE");

var $5FBx9 = parcelRequire("5FBx9");

var $2PggY = parcelRequire("2PggY");

var $arila = parcelRequire("arila");

var $drktW = parcelRequire("drktW");

var $cx9k0 = parcelRequire("cx9k0");

var $bSKle = parcelRequire("bSKle");

var $cCaRC = parcelRequire("cCaRC");

var $8KGPF = parcelRequire("8KGPF");

var $dWgOU = parcelRequire("dWgOU");

var $2kTDz = parcelRequire("2kTDz");
const $c4131a0423de54db$var$processName = (name, intl)=>{
    const unknownLabel = intl.formatMessage((0, $6ny6f.mentionMessages).unknownLabel);
    if (name.status === (0, $eBfRL.MentionNameStatus).OK) return `@${name.name || unknownLabel}`;
    else return `@${unknownLabel}`;
};
/**
 * We will need to clean this up once mentionProvider is
 * put inside mention plugin.
 * See: https://product-fabric.atlassian.net/browse/ED-26011
 */ function $c4131a0423de54db$var$Component({ mentionProvider: mentionProvider, api: api }) {
    const mentionProviderMemo = (0, $bSJIT.useMemo)(()=>{
        return mentionProvider;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const intl = (0, $4vLTk.default)();
    (0, $bSJIT.useEffect)(()=>{
        mentionProviderMemo === null || mentionProviderMemo === void 0 || mentionProviderMemo.then((mentionProviderSync)=>{
            var _api$base;
            api === null || api === void 0 || (_api$base = api.base) === null || _api$base === void 0 || (_api$base = _api$base.actions) === null || _api$base === void 0 || _api$base.registerMarks(({ tr: tr, node: node, pos: pos })=>{
                const { doc: doc } = tr;
                const { schema: schema } = doc.type;
                const { mention: mentionNodeType } = schema.nodes;
                const { id: id } = node.attrs;
                if (node.type === mentionNodeType) {
                    if ((0, $lyKnc.isResolvingMentionProvider)(mentionProviderSync)) {
                        const nameDetail = mentionProviderSync === null || mentionProviderSync === void 0 ? void 0 : mentionProviderSync.resolveMentionName(id);
                        let newText;
                        if ((0, $5g8DV.isPromise)(nameDetail)) newText = `@${intl.formatMessage((0, $6ny6f.mentionMessages).unknownLabel)}`;
                        else newText = $c4131a0423de54db$var$processName(nameDetail, intl);
                        const currentPos = tr.mapping.map(pos);
                        tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
                    }
                }
            });
        });
    }, [
        mentionProviderMemo,
        api,
        intl
    ]);
    return null;
}
const $c4131a0423de54db$export$280dfabe1535ae84 = ({ config: options, api: api })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const sessionId = (0, $7RHfd.default)();
    let previousMediaProvider;
    const fireEvent = (payload, channel)=>{
        var _api$analytics;
        const fireAnalyticsEvent = api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 ? void 0 : _api$analytics.fireAnalyticsEvent;
        if (!fireAnalyticsEvent) return;
        if (payload.attributes && !payload.attributes.sessionId) payload.attributes.sessionId = sessionId;
        fireAnalyticsEvent(payload, channel);
    };
    const typeAhead = (0, $2kTDz.createTypeAheadConfig)({
        canOpenTypeAhead: options === null || options === void 0 ? void 0 : options.canOpenTypeAhead,
        sanitizePrivateContent: options === null || options === void 0 ? void 0 : options.sanitizePrivateContent,
        mentionInsertDisplayName: options === null || options === void 0 ? void 0 : options.insertDisplayName,
        HighlightComponent: options === null || options === void 0 ? void 0 : options.HighlightComponent,
        handleMentionsChanged: options === null || options === void 0 ? void 0 : options.handleMentionsChanged,
        enableAgentSectioning: options === null || options === void 0 ? void 0 : options.enableAgentSectioning,
        showAgentMentionsLabsLozenge: options === null || options === void 0 ? void 0 : options.showAgentMentionsLabsLozenge,
        profilecardProvider: options === null || options === void 0 ? void 0 : options.profilecardProvider,
        fireEvent: fireEvent,
        api: api
    });
    const canOpenMentionTypeAhead = ()=>(0, $2PggY.isMentionTypeAheadEnabled)(options === null || options === void 0 ? void 0 : options.canOpenTypeAhead);
    const isRegisteredSlashCommandEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command');
    if (isRegisteredSlashCommandEnabled) {
        var _api$uiControlRegistr;
        api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register((0, $8KGPF.getMentionQuickInsertComponents)({
            api: api,
            canOpenMentionTypeAhead: canOpenMentionTypeAhead,
            typeAhead: typeAhead
        }));
    }
    return {
        name: 'mention',
        nodes () {
            return [
                {
                    name: 'mention',
                    node: (0, $arila.mentionNodeSpec)()
                }
            ];
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'mention',
                    plugin: (pmPluginFactoryParams)=>(0, $bSKle.createMentionPlugin)({
                            pmPluginFactoryParams: pmPluginFactoryParams,
                            fireEvent: fireEvent,
                            options: options,
                            api: api
                        })
                }
            ];
            if ((0, $797yE.editorExperiment)('platform_editor_agent_mentions', true)) plugins.push({
                name: 'agentMention',
                plugin: (pmPluginFactoryParams)=>(0, $drktW.createAgentMentionPlugin)({
                        pmPluginFactoryParams: pmPluginFactoryParams,
                        options: options
                    })
            });
            return plugins;
        },
        contentComponent ({ editorView: editorView, providerFactory: providerFactory }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fRXfs.WithProviders), {
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                providers: [
                    'mentionProvider'
                ],
                providerFactory: providerFactory,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                renderNode: ({ mentionProvider: mentionProvider })=>{
                    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $dc70d.jsx)($c4131a0423de54db$var$Component, {
                                mentionProvider: mentionProvider,
                                api: api
                            }),
                            (0, $gdUUy.fg)('inline_invite_from_mentions_kill_switch') && /*#__PURE__*/ (0, $dc70d.jsx)((0, $cCaRC.InlineInvitePopupContainer), {
                                mentionProvider: mentionProvider,
                                api: api,
                                editorView: editorView
                            })
                        ]
                    });
                }
            });
        },
        secondaryToolbarComponent ({ editorView: editorView, disabled: disabled }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dWgOU.SecondaryToolbarComponent), {
                editorView: editorView,
                api: api,
                disabled: disabled,
                typeAhead: typeAhead
            });
        },
        commands: {
            insertMention: (0, $5FBx9.insertMention)({
                sanitizePrivateContent: (options === null || options === void 0 ? void 0 : options.sanitizePrivateContent) ?? false,
                mentionInsertDisplayName: (options === null || options === void 0 ? void 0 : options.insertDisplayName) ?? false,
                api: api
            })
        },
        actions: {
            openTypeAhead (inputMethod) {
                var _api$typeAhead;
                return Boolean(api === null || api === void 0 || (_api$typeAhead = api.typeAhead) === null || _api$typeAhead === void 0 || (_api$typeAhead = _api$typeAhead.actions) === null || _api$typeAhead === void 0 ? void 0 : _api$typeAhead.open({
                    triggerHandler: typeAhead,
                    inputMethod: inputMethod
                }));
            },
            announceMentionsInsertion: (mentionChanges)=>{
                if (options !== null && options !== void 0 && options.handleMentionsChanged) options.handleMentionsChanged(mentionChanges);
            },
            setAgentMentionRunStates: (runStateByLocalId)=>{
                if (!((0, $797yE.editorExperiment)('platform_editor_agent_mentions', true) && (0, $3y2s4.isExperimentEnabled)('platform_editor_agent_mention_state_anim'))) return false;
                return (api === null || api === void 0 ? void 0 : api.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $cx9k0.mentionPluginKey), {
                        action: (0, $bSKle.ACTIONS).SET_AGENT_RUN_STATES,
                        params: {
                            runStateByLocalId: runStateByLocalId
                        }
                    }))) ?? false;
            },
            updateSectionTitle: (props)=>{
                var _api$typeAhead2, _api$typeAhead2$updat;
                if (!(options !== null && options !== void 0 && options.enableAgentSectioning)) return false;
                return (api === null || api === void 0 || (_api$typeAhead2 = api.typeAhead) === null || _api$typeAhead2 === void 0 || (_api$typeAhead2 = _api$typeAhead2.actions) === null || _api$typeAhead2 === void 0 || (_api$typeAhead2$updat = _api$typeAhead2.updateSectionTitle) === null || _api$typeAhead2$updat === void 0 ? void 0 : _api$typeAhead2$updat.call(_api$typeAhead2, props)) ?? false;
            },
            setProvider: async (providerPromise)=>{
                if (!(0, $gdUUy.fg)('platform_editor_mention_provider_via_plugin_config')) return false;
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousMediaProvider === provider) return false;
                previousMediaProvider = provider;
                return (api === null || api === void 0 ? void 0 : api.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $cx9k0.mentionPluginKey), {
                        action: (0, $bSKle.ACTIONS).SET_PROVIDER,
                        params: {
                            provider: provider
                        }
                    }))) ?? false;
            }
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const mentionPluginState = (0, $cx9k0.mentionPluginKey).getState(editorState);
            const agentMentionPluginState = (0, $drktW.agentMentionPluginKey).getState(editorState);
            // Exclude pendingPastedAgentMention — it is an @internal transient field and
            // should not be part of the public shared state API. Exposing it would cause
            // unnecessary re-renders in subscribers and leak implementation details.
            const { pendingPastedAgentMention: _excluded, // Internal decoration-only state, kept out of the public shared state.
            runStateDecorations: _excludedRunState, ...publicPluginState } = mentionPluginState ?? {};
            return {
                ...publicPluginState,
                ...agentMentionPluginState ? {
                    lastAgentMentionInsertionCount: agentMentionPluginState.lastAgentMentionInsertionCount,
                    lastInsertedAgentMentionContext: agentMentionPluginState.lastInsertedAgentMentionContext,
                    lastInsertedAgentMentionId: agentMentionPluginState.lastInsertedAgentMentionId,
                    lastInsertedAgentMentionLocalId: agentMentionPluginState.lastInsertedAgentMentionLocalId,
                    lastInsertedAgentMentionName: agentMentionPluginState.lastInsertedAgentMentionName,
                    lastInsertedAgentMentionParentNodeType: agentMentionPluginState.lastInsertedAgentMentionParentNodeType,
                    lastInsertedAgentMentionPrompt: agentMentionPluginState.lastInsertedAgentMentionPrompt
                } : {},
                typeAheadHandler: typeAhead
            };
        },
        pluginsOptions: {
            quickInsert: isRegisteredSlashCommandEnabled ? undefined : ({ formatMessage: formatMessage })=>[
                    {
                        id: 'mention',
                        title: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).mention),
                        description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).mentionDescription),
                        keywords: [
                            'team',
                            'user'
                        ],
                        priority: 400,
                        keyshortcut: '@',
                        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5BUNL.IconMention), {}),
                        isHidden: ()=>{
                            var _api$mention$sharedSt;
                            return canOpenMentionTypeAhead() === false || (api === null || api === void 0 || (_api$mention$sharedSt = api.mention.sharedState.currentState()) === null || _api$mention$sharedSt === void 0 ? void 0 : _api$mention$sharedSt.canInsertMention) === false;
                        },
                        action (insert, state) {
                            var _api$typeAhead3;
                            const pluginState = (0, $cx9k0.mentionPluginKey).getState(state);
                            if (pluginState && pluginState.canInsertMention === false) return false;
                            const tr = insert(undefined);
                            const didOpen = api === null || api === void 0 || (_api$typeAhead3 = api.typeAhead) === null || _api$typeAhead3 === void 0 ? void 0 : _api$typeAhead3.actions.openAtTransaction({
                                triggerHandler: typeAhead,
                                inputMethod: (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT
                            })(tr);
                            if (didOpen === false) return false;
                            return tr;
                        }
                    }
                ],
            typeAhead: typeAhead
        }
    };
};

});
parcelRegister("5FBx9", function(module, exports) {
$parcel$export(module.exports, "createSingleMentionFragment", () => $2f4a652aab2a282d$export$c39c34a625f03dcd);
$parcel$export(module.exports, "insertMention", () => $2f4a652aab2a282d$export$8c4314a90d4c5fc1);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $7RHfd = parcelRequire("7RHfd");

var $cWyqT = parcelRequire("cWyqT");

var $kW8qW = parcelRequire("kW8qW");

var $lyKnc = parcelRequire("lyKnc");

var $ixBwV = parcelRequire("ixBwV");
const $2f4a652aab2a282d$var$isAgentUserType = (userType)=>userType === 'APP' || userType === 'AGENT';
const $2f4a652aab2a282d$export$c39c34a625f03dcd = ({ mentionInsertDisplayName: mentionInsertDisplayName, mentionProvider: mentionProvider, tr: tr, sanitizePrivateContent: sanitizePrivateContent, suppressInviteXProductUser: suppressInviteXProductUser })=>({ name: name, id: id, userType: userType, nickname: nickname, localId: localId, accessLevel: accessLevel, isXProductUser: isXProductUser })=>{
        const schema = tr.doc.type.schema;
        const trimmedNickname = nickname && nickname.startsWith('@') ? nickname.slice(1) : nickname;
        const renderName = mentionInsertDisplayName || !trimmedNickname ? name : trimmedNickname;
        if (!suppressInviteXProductUser && isXProductUser && mentionProvider !== null && mentionProvider !== void 0 && mentionProvider.inviteXProductUser) mentionProvider.inviteXProductUser(id, name);
        // Don't insert into document if document data is sanitized.
        const text = sanitizePrivateContent ? '' : `@${renderName}`;
        if (sanitizePrivateContent && (0, $lyKnc.isResolvingMentionProvider)(mentionProvider)) // Cache (locally) for later rendering
        mentionProvider.cacheMentionName(id, renderName);
        const annotationMarksForPos = (0, $cWyqT.getAnnotationMarksForPos)(tr.selection.$head);
        const mentionNode = schema.nodes.mention.createChecked({
            text: text,
            id: id,
            accessLevel: accessLevel,
            userType: userType === 'DEFAULT' ? null : userType,
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            localId: localId ?? (0, $7RHfd.default)()
        }, null, annotationMarksForPos);
        const space = schema.text(' ', annotationMarksForPos);
        return (0, $kW8qW.Fragment).from([
            mentionNode,
            space
        ]);
    };
const $2f4a652aab2a282d$export$8c4314a90d4c5fc1 = ({ sanitizePrivateContent: sanitizePrivateContent, api: api, mentionInsertDisplayName: mentionInsertDisplayName })=>({ name: name, id: id, userType: userType, localId: localId, nickname: nickname, accessLevel: accessLevel, isXProductUser: isXProductUser })=>{
        return ({ tr: tr })=>{
            var _api$mention$sharedSt;
            const mentionProvider = api === null || api === void 0 || (_api$mention$sharedSt = api.mention.sharedState.currentState()) === null || _api$mention$sharedSt === void 0 ? void 0 : _api$mention$sharedSt.mentionProvider;
            const mentionFragment = $2f4a652aab2a282d$export$c39c34a625f03dcd({
                sanitizePrivateContent: sanitizePrivateContent,
                mentionProvider: mentionProvider,
                mentionInsertDisplayName: mentionInsertDisplayName,
                tr: tr,
                suppressInviteXProductUser: (0, $ixBwV.expVal)('platform_editor_agent_mentions', 'isEnabled', false) && $2f4a652aab2a282d$var$isAgentUserType(userType)
            })({
                name: name,
                id: id,
                userType: userType,
                nickname: nickname,
                localId: localId,
                accessLevel: accessLevel,
                isXProductUser: isXProductUser
            });
            return tr.insert(tr.selection.from, mentionFragment);
        };
    };

});

parcelRegister("2PggY", function(module, exports) {
$parcel$export(module.exports, "isMentionTypeAheadEnabled", () => $6064d0189239b230$export$edcc600c5009c50e);

var $gdUUy = parcelRequire("gdUUy");
const $6064d0189239b230$export$edcc600c5009c50e = (canOpenTypeAhead)=>(canOpenTypeAhead === null || canOpenTypeAhead === void 0 ? void 0 : canOpenTypeAhead()) !== false || !(0, $gdUUy.fg)('editor-disable-feature');

});

parcelRegister("arila", function(module, exports) {
$parcel$export(module.exports, "mentionNodeSpec", () => $938e1918bad0ba96$export$a9cde69b487c37ac);

var $8nTzm = parcelRequire("8nTzm");

var $PFzWP = parcelRequire("PFzWP");

var $ixBwV = parcelRequire("ixBwV");
const $938e1918bad0ba96$var$isSSR = Boolean(undefined);
const $938e1918bad0ba96$export$a9cde69b487c37ac = ()=>{
    if ($938e1918bad0ba96$var$isSSR) return 0, $8nTzm.mention;
    return {
        ...(0, $8nTzm.mention),
        toDOM: (node)=>{
            // packages/elements/mention/src/components/Mention/index.tsx
            const mentionAttrs = {
                'aria-busy': 'true',
                contenteditable: 'false',
                'data-access-level': '',
                'data-mention-id': node.attrs.id,
                'data-prosemirror-content-type': 'node',
                'data-prosemirror-node-inline': 'true',
                'data-prosemirror-node-name': 'mention',
                'data-user-type': (0, $ixBwV.expVal)('platform_editor_agent_mentions', 'isEnabled', false) && node.attrs.userType ? node.attrs.userType : undefined,
                style: (0, $PFzWP.convertToInlineCss)({
                    display: 'inline',
                    border: `1px solid transparent`,
                    background: "var(--ds-background-neutral, #0515240F)",
                    color: "var(--ds-text-subtle, #505258)",
                    borderRadius: '20px',
                    cursor: 'pointer',
                    padding: '0 0.3em 2px 0.23em',
                    wordBreak: 'break-word'
                })
            };
            return [
                'span',
                mentionAttrs,
                node.attrs.text
            ];
        }
    };
};

});

parcelRegister("drktW", function(module, exports) {
$parcel$export(module.exports, "agentMentionPluginKey", () => $4c032300ee9d678c$export$71defd201564c5ca);
$parcel$export(module.exports, "createAgentMentionPlugin", () => $4c032300ee9d678c$export$d3e99987ee8ef959);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $a3b9P = parcelRequire("a3b9P");

var $lyKnc = parcelRequire("lyKnc");

var $eBfRL = parcelRequire("eBfRL");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $797yE = parcelRequire("797yE");

var $bPpGY = parcelRequire("bPpGY");

var $893ye = parcelRequire("893ye");

var $cx9k0 = parcelRequire("cx9k0");

var $bSKle = parcelRequire("bSKle");
const $4c032300ee9d678c$var$AGENT_USER_TYPES = new Set([
    'APP',
    'AGENT'
]);
const $4c032300ee9d678c$var$isAgentUserType = (userType)=>{
    return typeof userType === 'string' && $4c032300ee9d678c$var$AGENT_USER_TYPES.has(userType);
};
const $4c032300ee9d678c$var$getAgentMentionName = (text, fallbackName)=>{
    const trimmedFallbackName = typeof fallbackName === 'string' ? fallbackName.trim() : '';
    const normalizedFallbackName = (trimmedFallbackName.startsWith('@') ? trimmedFallbackName.slice(1).trim() : trimmedFallbackName) || null;
    if (typeof text !== 'string') return normalizedFallbackName;
    const trimmedText = text.trim();
    const displayName = trimmedText.startsWith('@') ? trimmedText.slice(1).trim() : trimmedText;
    const normalizedName = displayName || normalizedFallbackName;
    return normalizedName;
};
const $4c032300ee9d678c$var$AI_STREAMING_TRANSFORMATION_META_KEY = 'isAIStreamingTransformation';
const $4c032300ee9d678c$var$AGENT_MENTION_INACTIVITY_MS = 3000;
const $4c032300ee9d678c$var$MAX_PENDING_TYPED_AGENT_MENTION_FOCUS_DEFERS = 20;
/**
 * Returns true when a transaction represents a local user document edit that
 * should restart pending agent-mention inactivity tracking.
 *
 * Remote/collab updates, replace-document transactions, AI streaming transforms,
 * selection-only movements, and metadata-only transactions are intentionally ignored.
 */ const $4c032300ee9d678c$var$isQualifyingLocalUserDocChange = (tr)=>{
    const isAIStreaming = Boolean(tr.getMeta($4c032300ee9d678c$var$AI_STREAMING_TRANSFORMATION_META_KEY));
    return tr.docChanged && !tr.getMeta('isRemote') && !tr.getMeta('replaceDocument') && !isAIStreaming;
};
const $4c032300ee9d678c$var$isLocalSelectionChange = (tr, hasPositionChanged)=>{
    const isAIStreaming = Boolean(tr.getMeta($4c032300ee9d678c$var$AI_STREAMING_TRANSFORMATION_META_KEY));
    // Pressing Enter can move selection through a doc split without setting tr.selectionSet
    // or changing from/to numerically, so local doc changes are checked against the
    // pending mention's current parent before publishing.
    return (hasPositionChanged || tr.docChanged) && !tr.getMeta('isRemote') && !tr.getMeta('replaceDocument') && !isAIStreaming;
};
/**
 * Reads agent-mention details from a known document position without traversing
 * the document. Callers pass a matcher so mapped positions are only accepted
 * when they still point at the same pending/tracked mention.
 */ const $4c032300ee9d678c$var$getAgentMentionDetailsAtPos = (state, pos, matchesMention, fallbackName)=>{
    if (pos < 0 || pos > state.doc.content.size) return null;
    const node = state.doc.nodeAt(pos);
    const mentionSchema = state.schema.nodes.mention;
    if ((node === null || node === void 0 ? void 0 : node.type) !== mentionSchema || !$4c032300ee9d678c$var$isAgentUserType(node.attrs.userType) || !matchesMention(node.attrs) || !node.attrs.id || !node.attrs.localId) return null;
    const $mentionPos = state.doc.resolve(Math.min(pos + node.nodeSize, state.doc.content.size));
    const parentNode = $mentionPos.node($mentionPos.depth);
    const id = node.attrs.id;
    const name = $4c032300ee9d678c$var$getAgentMentionName(node.attrs.text, fallbackName);
    return {
        id: id,
        localId: node.attrs.localId,
        context: (0, $bPpGY.getAgentMentionParentContext)(parentNode, node.attrs.localId),
        name: name,
        prompt: parentNode.textContent.trim() || null,
        nodeSize: node.nodeSize,
        parentEnd: $mentionPos.end($mentionPos.depth),
        parentNodeType: parentNode.type.name ?? null,
        parentStart: $mentionPos.start($mentionPos.depth),
        pos: pos
    };
};
/**
 * Finds an agent mention that survived a document change when the changed-range
 * scan did not find one. Uses the tracked localId as the mention instance identity
 * so same-agent mentions elsewhere in the document cannot be selected as fallback.
 */ const $4c032300ee9d678c$var$getSurvivingAgentMentionDetails = (state, preferredLocalId, preferredName)=>{
    const mentionSchema = state.schema.nodes.mention;
    let result = null;
    state.doc.descendants((node, pos)=>{
        if (result) return false;
        if (node.type !== mentionSchema || !$4c032300ee9d678c$var$isAgentUserType(node.attrs.userType) || node.attrs.localId !== preferredLocalId) return true;
        result = $4c032300ee9d678c$var$getAgentMentionDetailsAtPos(state, pos, (attrs)=>attrs.localId === preferredLocalId, preferredName);
        return !result;
    });
    return result;
};
/**
 * Maps a pending typed agent mention through a document-changing transaction and
 * returns the updated pending state. If the mapped position was deleted or no
 * longer points at the same local mention, the pending mention is cleared.
 */ const $4c032300ee9d678c$var$getPendingTypedAgentMentionAfterDocChange = (state, tr, pendingTypedAgentMention, { resetTimer: resetTimer })=>{
    const mappedPos = tr.mapping.mapResult(pendingTypedAgentMention.pos, 1);
    const resetCount = resetTimer ? pendingTypedAgentMention.resetCount + 1 : pendingTypedAgentMention.resetCount;
    if (mappedPos.deleted) return null;
    const pendingMentionDetails = $4c032300ee9d678c$var$getAgentMentionDetailsAtPos(state, mappedPos.pos, (attrs)=>attrs.localId === pendingTypedAgentMention.localId, pendingTypedAgentMention.name);
    return pendingMentionDetails ? {
        id: pendingMentionDetails.id,
        localId: pendingTypedAgentMention.localId,
        name: pendingMentionDetails.name,
        nodeSize: pendingMentionDetails.nodeSize,
        parentNodeType: pendingMentionDetails.parentNodeType,
        pos: pendingMentionDetails.pos,
        resetCount: resetCount
    } : null;
};
const $4c032300ee9d678c$var$hasPendingMentionMovedToNewParent = (oldState, tr, previousPendingTypedAgentMention, pendingMentionDetails)=>{
    if (!previousPendingTypedAgentMention) return false;
    const previousMentionDetails = $4c032300ee9d678c$var$getAgentMentionDetailsAtPos(oldState, previousPendingTypedAgentMention.pos, (attrs)=>attrs.localId === previousPendingTypedAgentMention.localId);
    // Keep the previous parent boundary associated with the left side of an
    // insertion at that boundary, so typing at the start of the parent does not
    // look like the pending mention moved into a new parent.
    const mappedPreviousParentStart = previousMentionDetails && tr.mapping.map(previousMentionDetails.parentStart, -1);
    return Boolean(previousMentionDetails && mappedPreviousParentStart !== pendingMentionDetails.parentStart);
};
const $4c032300ee9d678c$var$isSelectionOutsideDirectParent = (state, pendingMentionDetails)=>{
    return state.selection.from < pendingMentionDetails.parentStart || state.selection.to > pendingMentionDetails.parentEnd;
};
/**
 * Finalises a pending typed agent mention by copying its details into the
 * public lastInserted* plugin state after the caller has already resolved the
 * pending mention from the current document.
 */ const $4c032300ee9d678c$var$commitResolvedPendingTypedAgentMention = (pluginState, pendingMentionDetails)=>{
    return {
        hasPublicPluginStateChanged: true,
        pluginState: {
            ...pluginState,
            pendingTypedAgentMention: null,
            lastInsertedAgentMentionId: pendingMentionDetails.id,
            lastInsertedAgentMentionLocalId: pendingMentionDetails.localId,
            lastInsertedAgentMentionContext: pendingMentionDetails.context,
            lastInsertedAgentMentionName: pendingMentionDetails.name,
            lastInsertedAgentMentionPrompt: pendingMentionDetails.prompt,
            lastInsertedAgentMentionParentNodeType: pendingMentionDetails.parentNodeType,
            lastAgentMentionInsertionCount: (pluginState.lastAgentMentionInsertionCount ?? 0) + 1
        }
    };
};
/**
 * Resolves and finalises a pending typed agent mention. If the tracked mention
 * no longer resolves, the stale pending state is cleared without dispatching a
 * public update.
 */ const $4c032300ee9d678c$var$commitPendingTypedAgentMention = (state, pluginState, pendingTypedAgentMention)=>{
    const pendingMentionDetails = $4c032300ee9d678c$var$getAgentMentionDetailsAtPos(state, pendingTypedAgentMention.pos, (attrs)=>attrs.localId === pendingTypedAgentMention.localId, pendingTypedAgentMention.name);
    if (!pendingMentionDetails) return {
        hasPublicPluginStateChanged: false,
        pluginState: {
            ...pluginState,
            pendingTypedAgentMention: null
        }
    };
    return $4c032300ee9d678c$var$commitResolvedPendingTypedAgentMention(pluginState, pendingMentionDetails);
};
const $4c032300ee9d678c$var$hasTrackedAgentMentionState = (pluginState)=>Boolean(pluginState.pendingTypedAgentMention) || Boolean(pluginState.pendingPastedAgentMention) && (0, $gdUUy.fg)('platform_editor_agent_mentions_drop_one_fixes') || pluginState.lastInsertedAgentMentionId != null || pluginState.lastInsertedAgentMentionLocalId != null || pluginState.lastInsertedAgentMentionContext != null || pluginState.lastInsertedAgentMentionName != null || pluginState.lastInsertedAgentMentionPrompt != null || pluginState.lastInsertedAgentMentionParentNodeType != null;
/**
 * Clears agent mention state that points at a specific document snapshot.
 * replaceDocument swaps content wholesale, so pending typed mentions and
 * lastInserted* details from the previous document must be cleared together.
 */ const $4c032300ee9d678c$var$clearTrackedAgentMentionState = (pluginState)=>{
    return {
        ...pluginState,
        pendingTypedAgentMention: null,
        ...(0, $gdUUy.fg)('platform_editor_agent_mentions_drop_one_fixes') ? {
            pendingPastedAgentMention: null
        } : {},
        lastInsertedAgentMentionId: null,
        lastInsertedAgentMentionLocalId: null,
        lastInsertedAgentMentionContext: null,
        lastInsertedAgentMentionName: null,
        lastInsertedAgentMentionPrompt: null,
        lastInsertedAgentMentionParentNodeType: null
    };
};
/**
 * Attempts to synchronously resolve an agent mention name from the mention
 * provider's cache. Falls back to undefined if the provider doesn't support
 * name resolution, the result is a Promise (async/cache miss), or the status
 * is not OK.
 */ const $4c032300ee9d678c$var$resolveCachedAgentMentionName = (mentionProvider, params, id)=>{
    if (params !== null && params !== void 0 && params.name || !(0, $lyKnc.isResolvingMentionProvider)(mentionProvider)) return (params === null || params === void 0 ? void 0 : params.name) ?? undefined;
    const result = mentionProvider.resolveMentionName(id);
    if (!(result instanceof Promise) && result.status === (0, $eBfRL.MentionNameStatus).OK) return result.name || undefined;
    return undefined;
};
const $4c032300ee9d678c$export$6bdca90f97e745df = (agentId, mentionProvider, pendingResolveMentionIds, view)=>{
    if (pendingResolveMentionIds.has(agentId)) return;
    pendingResolveMentionIds.add(agentId);
    const result = mentionProvider.resolveMentionName(agentId);
    if (result instanceof Promise) result.then((nameDetails)=>{
        pendingResolveMentionIds.delete(agentId);
        if (nameDetails.status === (0, $eBfRL.MentionNameStatus).OK && nameDetails.name) view.dispatch(view.state.tr.setMeta((0, $cx9k0.mentionPluginKey), {
            action: (0, $bSKle.ACTIONS).RESOLVE_PASTED_AGENT_MENTION_NAME,
            params: {
                id: agentId,
                name: nameDetails.name
            }
        }));
        else view.dispatch(view.state.tr.setMeta((0, $cx9k0.mentionPluginKey), {
            action: (0, $bSKle.ACTIONS).CLEAR_PENDING_PASTED_AGENT_MENTION,
            params: {
                id: agentId
            }
        }));
    }).catch(()=>{
        pendingResolveMentionIds.delete(agentId);
    });
    else if (result.status === (0, $eBfRL.MentionNameStatus).OK && result.name) {
        pendingResolveMentionIds.delete(agentId);
        view.dispatch(view.state.tr.setMeta((0, $cx9k0.mentionPluginKey), {
            action: (0, $bSKle.ACTIONS).RESOLVE_PASTED_AGENT_MENTION_NAME,
            params: {
                id: agentId,
                name: result.name
            }
        }));
    } else {
        pendingResolveMentionIds.delete(agentId);
        view.dispatch(view.state.tr.setMeta((0, $cx9k0.mentionPluginKey), {
            action: (0, $bSKle.ACTIONS).CLEAR_PENDING_PASTED_AGENT_MENTION,
            params: {
                id: agentId
            }
        }));
    }
};
const $4c032300ee9d678c$export$fbc2b13c7417208 = ({ tr: tr, pluginState: pluginState, oldState: oldState, newState: newState, getIsRovoPanelOpen: getIsRovoPanelOpen })=>{
    // mentionPluginKey intentionally remains the shared transaction action channel while
    // agentMentionPluginKey owns the extracted agent state.
    const { action: action, params: params } = tr.getMeta((0, $cx9k0.mentionPluginKey)) || {
        action: null,
        params: null
    };
    let hasPublicPluginStateChanged = false;
    let newPluginState = pluginState;
    const isAgentMentionsExperimentEnabled = (0, $797yE.editorExperiment)('platform_editor_agent_mentions', true);
    const hasPositionChanged = oldState.selection.from !== newState.selection.from || oldState.selection.to !== newState.selection.to;
    switch(action){
        case (0, $bSKle.ACTIONS).COMMIT_PENDING_TYPED_AGENT_MENTION:
            {
                const pendingTypedAgentMention = newPluginState.pendingTypedAgentMention;
                if (!isAgentMentionsExperimentEnabled || !pendingTypedAgentMention || pendingTypedAgentMention.localId !== (params === null || params === void 0 ? void 0 : params.localId) || pendingTypedAgentMention.resetCount !== (params === null || params === void 0 ? void 0 : params.resetCount)) break;
                const commitResult = $4c032300ee9d678c$var$commitPendingTypedAgentMention(newState, newPluginState, pendingTypedAgentMention);
                newPluginState = commitResult.pluginState;
                hasPublicPluginStateChanged = hasPublicPluginStateChanged || commitResult.hasPublicPluginStateChanged;
                break;
            }
        case (0, $bSKle.ACTIONS).DISCARD_PENDING_TYPED_AGENT_MENTION:
            {
                const pendingTypedAgentMentionToDiscard = newPluginState.pendingTypedAgentMention;
                if (!isAgentMentionsExperimentEnabled || !pendingTypedAgentMentionToDiscard || pendingTypedAgentMentionToDiscard.localId !== (params === null || params === void 0 ? void 0 : params.localId) || pendingTypedAgentMentionToDiscard.resetCount !== (params === null || params === void 0 ? void 0 : params.resetCount)) break;
                newPluginState = {
                    ...newPluginState,
                    pendingTypedAgentMention: null
                };
                hasPublicPluginStateChanged = true;
                break;
            }
        case (0, $bSKle.ACTIONS).SET_PROVIDER:
            newPluginState = {
                ...newPluginState,
                mentionProvider: params.provider
            };
            hasPublicPluginStateChanged = true;
            break;
        case (0, $bSKle.ACTIONS).RESOLVE_PASTED_AGENT_MENTION_NAME:
            var _newPluginState$pendi, _newPluginState$pendi2, _newPluginState$pendi3, _newPluginState$pendi4, _newPluginState$pendi5, _newPluginState$pendi6;
            if (!isAgentMentionsExperimentEnabled || !(params !== null && params !== void 0 && params.id) || !(params !== null && params !== void 0 && params.name) || ((_newPluginState$pendi = newPluginState.pendingPastedAgentMention) === null || _newPluginState$pendi === void 0 ? void 0 : _newPluginState$pendi.id) !== params.id || !(0, $gdUUy.fg)('platform_editor_agent_mentions_drop_one_fixes')) break;
            newPluginState = {
                ...newPluginState,
                pendingPastedAgentMention: null,
                lastInsertedAgentMentionId: (_newPluginState$pendi2 = newPluginState.pendingPastedAgentMention) === null || _newPluginState$pendi2 === void 0 ? void 0 : _newPluginState$pendi2.id,
                lastInsertedAgentMentionLocalId: (_newPluginState$pendi3 = newPluginState.pendingPastedAgentMention) === null || _newPluginState$pendi3 === void 0 ? void 0 : _newPluginState$pendi3.localId,
                lastInsertedAgentMentionContext: (_newPluginState$pendi4 = newPluginState.pendingPastedAgentMention) === null || _newPluginState$pendi4 === void 0 ? void 0 : _newPluginState$pendi4.context,
                lastInsertedAgentMentionName: params.name,
                lastInsertedAgentMentionPrompt: (_newPluginState$pendi5 = newPluginState.pendingPastedAgentMention) === null || _newPluginState$pendi5 === void 0 ? void 0 : _newPluginState$pendi5.prompt,
                lastInsertedAgentMentionParentNodeType: (_newPluginState$pendi6 = newPluginState.pendingPastedAgentMention) === null || _newPluginState$pendi6 === void 0 ? void 0 : _newPluginState$pendi6.parentNodeType
            };
            hasPublicPluginStateChanged = true;
            break;
        case (0, $bSKle.ACTIONS).CLEAR_PENDING_PASTED_AGENT_MENTION:
            var _newPluginState$pendi7;
            if (!isAgentMentionsExperimentEnabled || !(params !== null && params !== void 0 && params.id) || ((_newPluginState$pendi7 = newPluginState.pendingPastedAgentMention) === null || _newPluginState$pendi7 === void 0 ? void 0 : _newPluginState$pendi7.id) !== params.id || !(0, $gdUUy.fg)('platform_editor_agent_mentions_drop_one_fixes')) break;
            newPluginState = {
                ...newPluginState,
                pendingPastedAgentMention: null
            };
            break;
    }
    if (isAgentMentionsExperimentEnabled && $4c032300ee9d678c$var$isQualifyingLocalUserDocChange(tr)) {
        const mentionSchema = newState.schema.nodes.mention;
        const newDocRanges = [];
        const oldDocRanges = [];
        let stepsTouchMentions = false;
        tr.steps.forEach((step)=>{
            let found = false;
            const stepNewRanges = [];
            const stepOldRanges = [];
            step.getMap().forEach((oldFrom, oldTo, newFrom, newTo)=>{
                stepOldRanges.push([
                    oldFrom,
                    oldTo
                ]);
                stepNewRanges.push([
                    newFrom,
                    newTo
                ]);
                if (!found) {
                    const clampedNewFrom = Math.min(newFrom, newState.doc.content.size);
                    const clampedNewTo = Math.min(newTo, newState.doc.content.size);
                    if (clampedNewFrom < clampedNewTo) newState.doc.nodesBetween(clampedNewFrom, clampedNewTo, (node)=>{
                        if (node.type === mentionSchema && $4c032300ee9d678c$var$isAgentUserType(node.attrs.userType)) found = true;
                        return !found;
                    });
                    if (!found) {
                        const clampedOldFrom = Math.min(oldFrom, oldState.doc.content.size);
                        const clampedOldTo = Math.min(oldTo, oldState.doc.content.size);
                        if (clampedOldFrom < clampedOldTo) oldState.doc.nodesBetween(clampedOldFrom, clampedOldTo, (node)=>{
                            if (node.type === mentionSchema && $4c032300ee9d678c$var$AGENT_USER_TYPES.has(node.attrs.userType)) found = true;
                            return !found;
                        });
                    }
                }
            });
            if (found) {
                stepsTouchMentions = true;
                newDocRanges.push(...stepNewRanges);
                oldDocRanges.push(...stepOldRanges);
            }
        });
        const shouldResolveAgentMentionState = stepsTouchMentions || Boolean(newPluginState.lastInsertedAgentMentionLocalId);
        if (shouldResolveAgentMentionState) {
            let agentMentionId = null;
            let agentMentionLocalId = null;
            let agentMentionContext = null;
            let agentMentionName = null;
            let agentMentionPrompt = null;
            let agentMentionParentNodeType = null;
            const existingAgentMentionLocalIdsInChangedRanges = new Set();
            let pendingTypedAgentMentionDetails = null;
            if (stepsTouchMentions) {
                for (const [from, to] of newDocRanges){
                    const clampedTo = Math.min(to, newState.doc.content.size);
                    if (from >= clampedTo) continue;
                    newState.doc.nodesBetween(from, clampedTo, (node, pos)=>{
                        if (node.type !== mentionSchema || !$4c032300ee9d678c$var$isAgentUserType(node.attrs.userType)) return true;
                        if (pendingTypedAgentMentionDetails === null && action === (0, $bSKle.ACTIONS).SET_PENDING_TYPED_AGENT_MENTION && node.attrs.localId === (params === null || params === void 0 ? void 0 : params.localId)) pendingTypedAgentMentionDetails = $4c032300ee9d678c$var$getAgentMentionDetailsAtPos(newState, pos, (attrs)=>attrs.localId === params.localId, params.name);
                        if (agentMentionLocalId === null && node.attrs.localId) {
                            const cachedName = (0, $gdUUy.fg)('platform_editor_agent_mentions_drop_one_fixes') ? $4c032300ee9d678c$var$resolveCachedAgentMentionName(newPluginState.mentionProvider, params, node.attrs.id) : params === null || params === void 0 ? void 0 : params.name;
                            const agentMentionDetails = $4c032300ee9d678c$var$getAgentMentionDetailsAtPos(newState, pos, (attrs)=>attrs.localId === node.attrs.localId, cachedName);
                            if (agentMentionDetails) {
                                agentMentionId = agentMentionDetails.id;
                                agentMentionLocalId = agentMentionDetails.localId;
                                agentMentionContext = agentMentionDetails.context;
                                agentMentionName = agentMentionDetails.name;
                                agentMentionPrompt = agentMentionDetails.prompt;
                                agentMentionParentNodeType = agentMentionDetails.parentNodeType;
                            }
                        }
                        return true;
                    });
                }
                for (const [from, to] of oldDocRanges){
                    const clampedOldTo = Math.min(to, oldState.doc.content.size);
                    if (from >= clampedOldTo) continue;
                    oldState.doc.nodesBetween(from, clampedOldTo, (node)=>{
                        if (node.type !== mentionSchema || !$4c032300ee9d678c$var$isAgentUserType(node.attrs.userType)) return true;
                        if (node.attrs.localId) existingAgentMentionLocalIdsInChangedRanges.add(node.attrs.localId);
                        return true;
                    });
                }
            }
            let resolvedFromFullDocFallback = false;
            if (agentMentionId === null && newPluginState.lastInsertedAgentMentionLocalId) {
                const survivorDetails = $4c032300ee9d678c$var$getSurvivingAgentMentionDetails(newState, newPluginState.lastInsertedAgentMentionLocalId, newPluginState.lastInsertedAgentMentionName);
                if (survivorDetails) {
                    agentMentionId = survivorDetails.id;
                    agentMentionLocalId = survivorDetails.localId;
                    agentMentionContext = survivorDetails.context;
                    agentMentionName = survivorDetails.name;
                    agentMentionPrompt = survivorDetails.prompt;
                    agentMentionParentNodeType = survivorDetails.parentNodeType;
                    resolvedFromFullDocFallback = true;
                }
            }
            const trackedAgentMentionLocalId = newPluginState.lastInsertedAgentMentionLocalId ?? null;
            const changedRangeMentionIsNew = agentMentionLocalId !== null && !existingAgentMentionLocalIdsInChangedRanges.has(agentMentionLocalId);
            if (agentMentionLocalId !== null && !changedRangeMentionIsNew && agentMentionLocalId !== trackedAgentMentionLocalId) {
                const survivorDetails = trackedAgentMentionLocalId ? $4c032300ee9d678c$var$getSurvivingAgentMentionDetails(newState, trackedAgentMentionLocalId, newPluginState.lastInsertedAgentMentionName) : null;
                if (survivorDetails) {
                    agentMentionId = survivorDetails.id;
                    agentMentionLocalId = survivorDetails.localId;
                    agentMentionContext = survivorDetails.context;
                    agentMentionName = survivorDetails.name;
                    agentMentionParentNodeType = survivorDetails.parentNodeType;
                    resolvedFromFullDocFallback = true;
                } else {
                    agentMentionId = null;
                    agentMentionLocalId = null;
                    agentMentionContext = null;
                    agentMentionName = null;
                    agentMentionParentNodeType = null;
                }
            }
            const isNewInsertion = agentMentionId !== null && !resolvedFromFullDocFallback && changedRangeMentionIsNew;
            const isPendingTypedAgentMentionInsertion = isNewInsertion && action === (0, $bSKle.ACTIONS).SET_PENDING_TYPED_AGENT_MENTION && typeof (params === null || params === void 0 ? void 0 : params.localId) === 'string';
            const newInsertionCount = isNewInsertion ? (newPluginState.lastAgentMentionInsertionCount ?? 0) + 1 : undefined;
            const pendingTypedAgentMentionDetailsForState = pendingTypedAgentMentionDetails;
            if (isPendingTypedAgentMentionInsertion && pendingTypedAgentMentionDetailsForState) {
                const pendingTypedAgentMentionLocalId = params === null || params === void 0 ? void 0 : params.localId;
                newPluginState = {
                    ...newPluginState,
                    pendingTypedAgentMention: {
                        id: pendingTypedAgentMentionDetailsForState.id,
                        localId: pendingTypedAgentMentionLocalId,
                        name: pendingTypedAgentMentionDetailsForState.name,
                        nodeSize: pendingTypedAgentMentionDetailsForState.nodeSize,
                        parentNodeType: pendingTypedAgentMentionDetailsForState.parentNodeType,
                        pos: pendingTypedAgentMentionDetailsForState.pos,
                        resetCount: 1
                    }
                };
            } else if (isPendingTypedAgentMentionInsertion) {
                newPluginState = {
                    ...newPluginState,
                    pendingTypedAgentMention: null,
                    lastInsertedAgentMentionId: agentMentionId,
                    lastInsertedAgentMentionLocalId: agentMentionLocalId,
                    lastInsertedAgentMentionContext: agentMentionContext,
                    lastInsertedAgentMentionName: agentMentionName,
                    lastInsertedAgentMentionPrompt: agentMentionPrompt,
                    lastInsertedAgentMentionParentNodeType: agentMentionParentNodeType,
                    ...newInsertionCount !== undefined ? {
                        lastAgentMentionInsertionCount: newInsertionCount
                    } : {}
                };
                hasPublicPluginStateChanged = true;
            } else if (agentMentionId !== (newPluginState.lastInsertedAgentMentionId ?? null) || agentMentionLocalId !== (newPluginState.lastInsertedAgentMentionLocalId ?? null) || agentMentionName !== (newPluginState.lastInsertedAgentMentionName ?? null) || agentMentionPrompt !== (newPluginState.lastInsertedAgentMentionPrompt ?? null) || agentMentionParentNodeType !== (newPluginState.lastInsertedAgentMentionParentNodeType ?? null) || newInsertionCount !== undefined) {
                const isTaskItemMentionForPaste = agentMentionParentNodeType === 'taskItem';
                if (!isTaskItemMentionForPaste && isNewInsertion && getIsRovoPanelOpen !== null && getIsRovoPanelOpen !== void 0 && getIsRovoPanelOpen()) ;
                else if (agentMentionName === null && agentMentionId !== null && (0, $lyKnc.isResolvingMentionProvider)(newPluginState.mentionProvider) && (0, $gdUUy.fg)('platform_editor_agent_mentions_drop_one_fixes')) newPluginState = {
                    ...newPluginState,
                    pendingPastedAgentMention: {
                        id: agentMentionId,
                        localId: agentMentionLocalId,
                        context: agentMentionContext,
                        prompt: agentMentionPrompt,
                        parentNodeType: agentMentionParentNodeType
                    },
                    ...newInsertionCount !== undefined ? {
                        lastAgentMentionInsertionCount: newInsertionCount
                    } : {}
                };
                else {
                    newPluginState = {
                        ...newPluginState,
                        lastInsertedAgentMentionId: agentMentionId,
                        lastInsertedAgentMentionLocalId: agentMentionLocalId,
                        lastInsertedAgentMentionContext: agentMentionContext,
                        lastInsertedAgentMentionName: agentMentionName,
                        lastInsertedAgentMentionPrompt: agentMentionPrompt,
                        lastInsertedAgentMentionParentNodeType: agentMentionParentNodeType,
                        ...newInsertionCount !== undefined ? {
                            lastAgentMentionInsertionCount: newInsertionCount
                        } : {}
                    };
                    hasPublicPluginStateChanged = true;
                }
            }
        }
    }
    if (isAgentMentionsExperimentEnabled && tr.docChanged && tr.getMeta('replaceDocument') && $4c032300ee9d678c$var$hasTrackedAgentMentionState(newPluginState)) {
        newPluginState = $4c032300ee9d678c$var$clearTrackedAgentMentionState(newPluginState);
        hasPublicPluginStateChanged = true;
    }
    if (isAgentMentionsExperimentEnabled && newPluginState.pendingTypedAgentMention && action !== (0, $bSKle.ACTIONS).SET_PENDING_TYPED_AGENT_MENTION && action !== (0, $bSKle.ACTIONS).COMMIT_PENDING_TYPED_AGENT_MENTION && tr.docChanged) newPluginState = {
        ...newPluginState,
        pendingTypedAgentMention: $4c032300ee9d678c$var$getPendingTypedAgentMentionAfterDocChange(newState, tr, newPluginState.pendingTypedAgentMention, {
            resetTimer: $4c032300ee9d678c$var$isQualifyingLocalUserDocChange(tr)
        })
    };
    const shouldCheckPendingTypedAgentMentionParent = $4c032300ee9d678c$var$isLocalSelectionChange(tr, hasPositionChanged);
    if (isAgentMentionsExperimentEnabled && newPluginState.pendingTypedAgentMention && action !== (0, $bSKle.ACTIONS).SET_PENDING_TYPED_AGENT_MENTION && action !== (0, $bSKle.ACTIONS).COMMIT_PENDING_TYPED_AGENT_MENTION && shouldCheckPendingTypedAgentMentionParent) {
        const pendingTypedAgentMention = newPluginState.pendingTypedAgentMention;
        const pendingMentionDetails = $4c032300ee9d678c$var$getAgentMentionDetailsAtPos(newState, pendingTypedAgentMention.pos, (attrs)=>attrs.localId === pendingTypedAgentMention.localId, pendingTypedAgentMention.name);
        if (!pendingMentionDetails) newPluginState = {
            ...newPluginState,
            pendingTypedAgentMention: null
        };
        else if ($4c032300ee9d678c$var$hasPendingMentionMovedToNewParent(oldState, tr, pluginState.pendingTypedAgentMention, pendingMentionDetails) || $4c032300ee9d678c$var$isSelectionOutsideDirectParent(newState, pendingMentionDetails)) {
            if (pendingMentionDetails.parentNodeType !== 'taskItem' && getIsRovoPanelOpen !== null && getIsRovoPanelOpen !== void 0 && getIsRovoPanelOpen()) {
                newPluginState = {
                    ...newPluginState,
                    pendingTypedAgentMention: null
                };
                hasPublicPluginStateChanged = true;
            } else {
                const commitResult = $4c032300ee9d678c$var$commitResolvedPendingTypedAgentMention(newPluginState, pendingMentionDetails);
                newPluginState = commitResult.pluginState;
                hasPublicPluginStateChanged = hasPublicPluginStateChanged || commitResult.hasPublicPluginStateChanged;
            }
        }
    }
    return {
        hasPublicPluginStateChanged: hasPublicPluginStateChanged,
        pluginState: newPluginState
    };
};
const $4c032300ee9d678c$export$8dbf6ebf4887e37f = ({ editorView: editorView, getIsRovoPanelOpen: getIsRovoPanelOpen, stateKey: stateKey })=>{
    const isAgentMentionsEnabled = (0, $797yE.editorExperiment)('platform_editor_agent_mentions', true);
    let pendingTypedAgentMentionTimer;
    let pendingTypedAgentMentionTimerKey = null;
    let pendingTypedAgentMentionFocusDeferCount = 0;
    const pendingResolveMentionIds = new Set();
    const clearPendingTypedAgentMentionTimer = ({ preserveFocusDeferCount: preserveFocusDeferCount = false } = {})=>{
        if (pendingTypedAgentMentionTimer) {
            clearTimeout(pendingTypedAgentMentionTimer);
            pendingTypedAgentMentionTimer = undefined;
        }
        pendingTypedAgentMentionTimerKey = null;
        if (!preserveFocusDeferCount) pendingTypedAgentMentionFocusDeferCount = 0;
    };
    const shouldDeferPendingTypedAgentMention = ()=>typeof document !== 'undefined' && document.hasFocus() && !editorView.hasFocus();
    const schedulePendingTypedAgentMentionTimer = (mentionPluginState, { preserveFocusDeferCount: preserveFocusDeferCount = false } = {})=>{
        if (!isAgentMentionsEnabled) {
            clearPendingTypedAgentMentionTimer();
            return;
        }
        const pendingTypedAgentMention = mentionPluginState === null || mentionPluginState === void 0 ? void 0 : mentionPluginState.pendingTypedAgentMention;
        if (!pendingTypedAgentMention) {
            clearPendingTypedAgentMentionTimer();
            return;
        }
        const timerKey = `${pendingTypedAgentMention.localId}:${pendingTypedAgentMention.resetCount}`;
        if (timerKey === pendingTypedAgentMentionTimerKey) return;
        clearPendingTypedAgentMentionTimer({
            preserveFocusDeferCount: preserveFocusDeferCount
        });
        pendingTypedAgentMentionTimerKey = timerKey;
        pendingTypedAgentMentionTimer = setTimeout(()=>{
            var _stateKey$getState;
            const isTaskItemMention = pendingTypedAgentMention.parentNodeType === 'taskItem';
            if (!isTaskItemMention && getIsRovoPanelOpen !== null && getIsRovoPanelOpen !== void 0 && getIsRovoPanelOpen()) {
                // Agent actions continue to use mentionPluginKey as the shared transaction meta channel.
                editorView.dispatch(editorView.state.tr.setMeta((0, $cx9k0.mentionPluginKey), {
                    action: (0, $bSKle.ACTIONS).DISCARD_PENDING_TYPED_AGENT_MENTION,
                    params: {
                        localId: pendingTypedAgentMention.localId,
                        resetCount: pendingTypedAgentMention.resetCount
                    }
                }));
                return;
            }
            const latestPendingTypedAgentMention = (_stateKey$getState = stateKey.getState(editorView.state)) === null || _stateKey$getState === void 0 ? void 0 : _stateKey$getState.pendingTypedAgentMention;
            if (!latestPendingTypedAgentMention || latestPendingTypedAgentMention.localId !== pendingTypedAgentMention.localId || latestPendingTypedAgentMention.resetCount !== pendingTypedAgentMention.resetCount) return;
            if (shouldDeferPendingTypedAgentMention() && pendingTypedAgentMentionFocusDeferCount < $4c032300ee9d678c$var$MAX_PENDING_TYPED_AGENT_MENTION_FOCUS_DEFERS) {
                pendingTypedAgentMentionFocusDeferCount++;
                pendingTypedAgentMentionTimerKey = null;
                schedulePendingTypedAgentMentionTimer(stateKey.getState(editorView.state), {
                    preserveFocusDeferCount: true
                });
                return;
            }
            pendingTypedAgentMentionFocusDeferCount = 0;
            editorView.dispatch(editorView.state.tr.setMeta((0, $cx9k0.mentionPluginKey), {
                action: (0, $bSKle.ACTIONS).COMMIT_PENDING_TYPED_AGENT_MENTION,
                params: {
                    localId: pendingTypedAgentMention.localId,
                    resetCount: pendingTypedAgentMention.resetCount
                }
            }));
        }, $4c032300ee9d678c$var$AGENT_MENTION_INACTIVITY_MS);
    };
    return {
        update (view, prevState) {
            var _mentionPluginState$p;
            const mentionPluginState = stateKey.getState(view.state);
            if (mentionPluginState === stateKey.getState(prevState)) return;
            schedulePendingTypedAgentMentionTimer(mentionPluginState);
            if ((0, $797yE.editorExperiment)('platform_editor_agent_mentions', true) && (mentionPluginState === null || mentionPluginState === void 0 || (_mentionPluginState$p = mentionPluginState.pendingPastedAgentMention) === null || _mentionPluginState$p === void 0 ? void 0 : _mentionPluginState$p.id) != null && mentionPluginState !== null && mentionPluginState !== void 0 && mentionPluginState.mentionProvider && (0, $lyKnc.isResolvingMentionProvider)(mentionPluginState.mentionProvider) && (0, $gdUUy.fg)('platform_editor_agent_mentions_drop_one_fixes')) $4c032300ee9d678c$export$6bdca90f97e745df(mentionPluginState.pendingPastedAgentMention.id, mentionPluginState.mentionProvider, pendingResolveMentionIds, view);
        },
        destroy () {
            clearPendingTypedAgentMentionTimer();
        }
    };
};
const $4c032300ee9d678c$export$71defd201564c5ca = new (0, $cw0wu.PluginKey)('agentMention');
const $4c032300ee9d678c$export$d3e99987ee8ef959 = ({ options: options, pmPluginFactoryParams: pmPluginFactoryParams })=>{
    return new (0, $f7Kk4.SafePlugin)({
        key: $4c032300ee9d678c$export$71defd201564c5ca,
        state: {
            init () {
                return {};
            },
            apply (tr, pluginState, oldState, newState) {
                var _meta$params;
                const result = $4c032300ee9d678c$export$fbc2b13c7417208({
                    tr: tr,
                    pluginState: pluginState,
                    oldState: oldState,
                    newState: newState,
                    getIsRovoPanelOpen: options === null || options === void 0 ? void 0 : options.getIsRovoPanelOpen
                });
                let nextPluginState = result.pluginState;
                const meta = tr.getMeta((0, $cx9k0.mentionPluginKey));
                const nextDecorations = (0, $893ye.nextRunStateDecorations)(pluginState.runStateDecorations, tr, newState, (meta === null || meta === void 0 ? void 0 : meta.action) === (0, $bSKle.ACTIONS).SET_AGENT_RUN_STATES ? ((_meta$params = meta.params) === null || _meta$params === void 0 ? void 0 : _meta$params.runStateByLocalId) ?? {} : undefined);
                if (nextPluginState.runStateDecorations !== nextDecorations) nextPluginState = {
                    ...nextPluginState,
                    runStateDecorations: nextDecorations
                };
                const mentionPluginState = (0, $cx9k0.mentionPluginKey).getState(newState);
                if (result.hasPublicPluginStateChanged) pmPluginFactoryParams.dispatch((0, $cx9k0.mentionPluginKey), {
                    ...mentionPluginState,
                    ...result.pluginState
                });
                return nextPluginState;
            }
        },
        props: {
            decorations (state) {
                var _agentMentionPluginKe;
                const runStateDecorations = (_agentMentionPluginKe = $4c032300ee9d678c$export$71defd201564c5ca.getState(state)) === null || _agentMentionPluginKe === void 0 ? void 0 : _agentMentionPluginKe.runStateDecorations;
                if (!runStateDecorations || runStateDecorations === (0, $a3b9P.DecorationSet).empty) return undefined;
                if (!(0, $3y2s4.isExperimentEnabled)('platform_editor_agent_mention_state_anim')) return undefined;
                return runStateDecorations;
            }
        },
        view (editorView) {
            return $4c032300ee9d678c$export$8dbf6ebf4887e37f({
                editorView: editorView,
                getIsRovoPanelOpen: options === null || options === void 0 ? void 0 : options.getIsRovoPanelOpen,
                stateKey: $4c032300ee9d678c$export$71defd201564c5ca
            });
        }
    });
};

});
parcelRegister("bPpGY", function(module, exports) {
$parcel$export(module.exports, "getAgentMentionParentContext", () => $c9a51b145420f91f$export$edbd9e89d6e6e22c);
const $c9a51b145420f91f$var$PASS_THROUGH_PROMPT_INLINE_NODE_TYPES = new Set([
    'hardBreak',
    'inlineCard',
    'mention',
    'text'
]);
const $c9a51b145420f91f$var$isAgentMention = (node)=>{
    var _node$attrs;
    return node.type === 'mention' && ((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.userType) === 'APP';
};
const $c9a51b145420f91f$var$isAllowedAgentMention = (node, agentMentionLocalId)=>{
    var _node$attrs2;
    return !$c9a51b145420f91f$var$isAgentMention(node) || ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) === agentMentionLocalId;
};
const $c9a51b145420f91f$var$getStatusText = (node)=>{
    var _node$attrs3;
    const text = (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.text;
    return typeof text === 'string' && text ? text : null;
};
const $c9a51b145420f91f$var$getDateText = (node)=>{
    var _node$attrs4;
    const timestamp = (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.timestamp;
    if (typeof timestamp !== 'string' || !timestamp) return null;
    const date = new Date(Number(timestamp));
    if (Number.isNaN(date.getTime())) return null;
    return date.toISOString().slice(0, 10);
};
const $c9a51b145420f91f$var$toPromptInlineNode = (node, agentMentionLocalId)=>{
    if (!$c9a51b145420f91f$var$isAllowedAgentMention(node, agentMentionLocalId)) return null;
    if ($c9a51b145420f91f$var$PASS_THROUGH_PROMPT_INLINE_NODE_TYPES.has(node.type)) return node;
    if (node.type === 'status') {
        const text = $c9a51b145420f91f$var$getStatusText(node);
        return text ? {
            type: 'text',
            text: text
        } : null;
    }
    if (node.type === 'date') {
        const text = $c9a51b145420f91f$var$getDateText(node);
        return text ? {
            type: 'text',
            text: text
        } : null;
    }
    return null;
};
const $c9a51b145420f91f$export$edbd9e89d6e6e22c = (parentNode, agentMentionLocalId)=>{
    const parentAdf = parentNode.toJSON();
    const supportedInlineContent = (parentAdf.content ?? []).flatMap((node)=>{
        const promptNode = $c9a51b145420f91f$var$toPromptInlineNode(node, agentMentionLocalId);
        return promptNode ? [
            promptNode
        ] : [];
    });
    return {
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                content: supportedInlineContent
            }
        ]
    };
};

});

parcelRegister("893ye", function(module, exports) {
$parcel$export(module.exports, "nextRunStateDecorations", () => $b31efff786bf58f6$export$448d8aa3766a6865);

var $a3b9P = parcelRequire("a3b9P");
const $b31efff786bf58f6$var$AGENT_MENTION_USER_TYPES = new Set([
    'APP',
    'AGENT'
]);
const $b31efff786bf58f6$var$isAgentMentionUserType = (userType)=>typeof userType === 'string' && $b31efff786bf58f6$var$AGENT_MENTION_USER_TYPES.has(userType);
const $b31efff786bf58f6$var$AGENT_RUN_STATE_ANALYSING_CLASS = 'agent-mention-analysing-state';
/**
 * Map the bridge's run-state to a mention node visual class.
 * Currently only the "analysing" state changes the chip, applying a shimmer to the pill.
 */ const $b31efff786bf58f6$var$getRunStateClass = (runState)=>{
    switch(runState){
        case 'thinking':
        case 'working':
            return $b31efff786bf58f6$var$AGENT_RUN_STATE_ANALYSING_CLASS;
        default:
            return undefined;
    }
};
const $b31efff786bf58f6$export$2dad9aecf701e98e = (state, runStateByLocalId)=>{
    if (!runStateByLocalId || Object.keys(runStateByLocalId).length === 0) return (0, $a3b9P.DecorationSet).empty;
    const mentionNodeType = state.schema.nodes.mention;
    if (!mentionNodeType) return (0, $a3b9P.DecorationSet).empty;
    const decorations = [];
    state.doc.descendants((node, pos)=>{
        if (node.type !== mentionNodeType || !$b31efff786bf58f6$var$isAgentMentionUserType(node.attrs.userType)) return true;
        const { localId: localId } = node.attrs;
        const runState = typeof localId === 'string' ? runStateByLocalId[localId] : undefined;
        if (!runState) return true;
        const stateClass = $b31efff786bf58f6$var$getRunStateClass(runState);
        if (!stateClass) return true;
        decorations.push((0, $a3b9P.Decoration).node(pos, pos + node.nodeSize, {
            class: stateClass
        }));
        return true;
    });
    return decorations.length ? (0, $a3b9P.DecorationSet).create(state.doc, decorations) : (0, $a3b9P.DecorationSet).empty;
};
const $b31efff786bf58f6$export$448d8aa3766a6865 = (previous, tr, newState, runStateByLocalId)=>{
    if (runStateByLocalId !== undefined) return $b31efff786bf58f6$export$2dad9aecf701e98e(newState, runStateByLocalId);
    if (tr.docChanged && previous) return previous.map(tr.mapping, tr.doc);
    return previous;
};

});

parcelRegister("cx9k0", function(module, exports) {
$parcel$export(module.exports, "mentionPluginKey", () => $0546fd0e013e3bbd$export$617302757e30e37c);

var $cw0wu = parcelRequire("cw0wu");
const $0546fd0e013e3bbd$export$617302757e30e37c = new (0, $cw0wu.PluginKey)('mentionPlugin');

});

parcelRegister("bSKle", function(module, exports) {
$parcel$export(module.exports, "ACTIONS", () => $0f3b7ccff94fc3c1$export$92a1a3b7554e9387);
$parcel$export(module.exports, "createMentionPlugin", () => $0f3b7ccff94fc3c1$export$36c073f17660f60f);

var $g6Qq4 = parcelRequire("g6Qq4");

var $f7Kk4 = parcelRequire("f7Kk4");

var $ixSRH = parcelRequire("ixSRH");

var $krjTi = parcelRequire("krjTi");

var $eBfRL = parcelRequire("eBfRL");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $2PggY = parcelRequire("2PggY");

var $2HdJL = parcelRequire("2HdJL");

var $cb7To = parcelRequire("cb7To");

var $cx9k0 = parcelRequire("cx9k0");

var $a04WG = parcelRequire("a04WG");
const $0f3b7ccff94fc3c1$export$92a1a3b7554e9387 = {
    COMMIT_PENDING_TYPED_AGENT_MENTION: 'COMMIT_PENDING_TYPED_AGENT_MENTION',
    DISCARD_PENDING_TYPED_AGENT_MENTION: 'DISCARD_PENDING_TYPED_AGENT_MENTION',
    SET_PENDING_TYPED_AGENT_MENTION: 'SET_PENDING_TYPED_AGENT_MENTION',
    SET_PROVIDER: 'SET_PROVIDER',
    /**
   * Dispatched by the `setAgentMentionRunStates` action to push the product's run-state
   * map into plugin state, which drives the run-state node decorations.
   */ SET_AGENT_RUN_STATES: 'SET_AGENT_RUN_STATES',
    /**
   * Dispatched from view().update() when async resolveMentionName() resolves
   * for a pasted agent mention.
   * Updates lastInsertedAgentMentionName so the nudge shows the correct name.
   */ RESOLVE_PASTED_AGENT_MENTION_NAME: 'RESOLVE_PASTED_AGENT_MENTION_NAME',
    /**
   * Dispatched from view().update() when async resolveMentionName() resolves
   * with a non-OK status for a pasted agent mention.
   * Clears pendingPastedAgentMention so no retry loop occurs.
   */ CLEAR_PENDING_PASTED_AGENT_MENTION: 'CLEAR_PENDING_PASTED_AGENT_MENTION'
};
const $0f3b7ccff94fc3c1$var$PACKAGE_NAME = undefined;
const $0f3b7ccff94fc3c1$var$PACKAGE_VERSION = undefined;
const $0f3b7ccff94fc3c1$var$setProvider = (provider)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setMeta((0, $cx9k0.mentionPluginKey), {
            action: $0f3b7ccff94fc3c1$export$92a1a3b7554e9387.SET_PROVIDER,
            params: {
                provider: provider
            }
        }));
        return true;
    };
function $0f3b7ccff94fc3c1$export$36c073f17660f60f({ pmPluginFactoryParams: pmPluginFactoryParams, fireEvent: fireEvent, options: options, api: api }) {
    let mentionProvider;
    const isMentionInsertionEnabled = (state)=>(0, $2PggY.isMentionTypeAheadEnabled)(options === null || options === void 0 ? void 0 : options.canOpenTypeAhead) && (0, $a04WG.canMentionBeCreatedInRange)(state.selection.from, state.selection.to)(state);
    const sendAnalytics = (event, actionSubject, action, attributes)=>{
        if (event === (0, $krjTi.SLI_EVENT_TYPE) || event === (0, $krjTi.SMART_EVENT_TYPE)) fireEvent({
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                packageName: $0f3b7ccff94fc3c1$var$PACKAGE_NAME,
                packageVersion: $0f3b7ccff94fc3c1$var$PACKAGE_VERSION,
                componentName: (0, $eBfRL.ComponentNames).MENTION,
                ...attributes
            }
        }, 'fabricElements');
    };
    return new (0, $f7Kk4.SafePlugin)({
        key: (0, $cx9k0.mentionPluginKey),
        state: {
            init (_, state) {
                return {
                    canInsertMention: isMentionInsertionEnabled(state),
                    mentionProviderStatus: 'pending'
                };
            },
            apply (tr, pluginState, oldState, newState) {
                const { action: action, params: params } = tr.getMeta((0, $cx9k0.mentionPluginKey)) || {
                    action: null,
                    params: null
                };
                let hasPublicPluginStateChanged = false;
                let newPluginState = pluginState;
                const hasPositionChanged = oldState.selection.from !== newState.selection.from || oldState.selection.to !== newState.selection.to;
                if (tr.docChanged || tr.selectionSet && hasPositionChanged) {
                    newPluginState = {
                        ...pluginState,
                        canInsertMention: isMentionInsertionEnabled(newState)
                    };
                    hasPublicPluginStateChanged = true;
                }
                switch(action){
                    case $0f3b7ccff94fc3c1$export$92a1a3b7554e9387.SET_PROVIDER:
                        newPluginState = {
                            ...newPluginState,
                            mentionProvider: params.provider,
                            mentionProviderStatus: params.provider ? 'available' : 'unavailable'
                        };
                        hasPublicPluginStateChanged = true;
                        break;
                }
                if (hasPublicPluginStateChanged) pmPluginFactoryParams.dispatch((0, $cx9k0.mentionPluginKey), newPluginState);
                if (options !== null && options !== void 0 && options.handleMentionsChanged && tr.docChanged) {
                    var _insm$session, _insm$session2;
                    (_insm$session = (0, $ixSRH.insm).session) === null || _insm$session === void 0 || _insm$session.startFeature('mentionDeletionDetection');
                    const mentionSchema = newState.schema.nodes.mention;
                    const mentionsRemoved = new Map();
                    tr.steps.forEach((step, index)=>{
                        step.getMap().forEach((from, to)=>{
                            const newStart = tr.mapping.slice(index).map(from, -1);
                            const newEnd = tr.mapping.slice(index).map(to);
                            const oldStart = tr.mapping.invert().map(newStart, -1);
                            const oldEnd = tr.mapping.invert().map(newEnd);
                            const oldSlice = oldState.doc.slice(oldStart, oldEnd);
                            const newSlice = newState.doc.slice(newStart, newEnd);
                            const mentionsBefore = new Map();
                            const mentionsAfter = new Map();
                            oldSlice.content.descendants((node)=>{
                                if (node.type.name === mentionSchema.name && node.attrs.localId) mentionsBefore.set(node.attrs.localId, {
                                    id: node.attrs.id,
                                    localId: node.attrs.localId
                                });
                            });
                            newSlice.content.descendants((node)=>{
                                if (node.type.name === mentionSchema.name && node.attrs.localId) mentionsAfter.set(node.attrs.localId, {
                                    id: node.attrs.id,
                                    localId: node.attrs.localId
                                });
                            });
                            // Determine which mentions were removed in this step
                            mentionsBefore.forEach((mention, localId)=>{
                                if (!mentionsAfter.has(localId)) mentionsRemoved.set(localId, mention);
                            });
                            // Adjust mentionsRemoved by removing any that reappear
                            mentionsAfter.forEach((_, localId)=>{
                                if (mentionsRemoved.has(localId)) mentionsRemoved.delete(localId);
                            });
                        });
                    });
                    if (mentionsRemoved.size > 0) {
                        const changes = Array.from(mentionsRemoved.values()).map((mention)=>({
                                id: mention.id,
                                localId: mention.localId,
                                type: 'deleted'
                            }));
                        options.handleMentionsChanged(changes);
                    }
                    (_insm$session2 = (0, $ixSRH.insm).session) === null || _insm$session2 === void 0 || _insm$session2.endFeature('mentionDeletionDetection');
                }
                return newPluginState;
            }
        },
        props: {
            nodeViews: {
                mention: (node, view)=>{
                    return new (0, $2HdJL.MentionNodeView)(node, {
                        options: options,
                        api: api,
                        editorView: view,
                        portalProviderAPI: pmPluginFactoryParams.portalProviderAPI
                    });
                }
            }
        },
        view (editorView) {
            let destroyed = false;
            const optimistic = (0, $3y2s4.isExperimentEnabled)('platform_editor_ssr_toolbar_optimistic');
            let currentProviderPromise;
            const providerHandler = (name, providerPromise)=>{
                switch(name){
                    case 'mentionProvider':
                        currentProviderPromise = providerPromise;
                        if (!providerPromise) {
                            fireEvent({
                                action: (0, $g6Qq4.ACTION).ERRORED,
                                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MENTION,
                                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).MENTION_PROVIDER,
                                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    reason: (0, $cb7To.MENTION_PROVIDER_UNDEFINED)
                                }
                            });
                            return $0f3b7ccff94fc3c1$var$setProvider(undefined)(editorView.state, editorView.dispatch);
                        }
                        providerPromise.then((provider)=>{
                            if (optimistic && (destroyed || currentProviderPromise !== providerPromise)) return;
                            if (mentionProvider) mentionProvider.unsubscribe('mentionPlugin');
                            mentionProvider = provider;
                            $0f3b7ccff94fc3c1$var$setProvider(provider)(editorView.state, editorView.dispatch);
                            provider.subscribe('mentionPlugin', undefined, undefined, undefined, undefined, sendAnalytics);
                        }).catch(()=>{
                            if (optimistic && (destroyed || currentProviderPromise !== providerPromise)) return;
                            fireEvent({
                                action: (0, $g6Qq4.ACTION).ERRORED,
                                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MENTION,
                                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).MENTION_PROVIDER,
                                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    reason: (0, $cb7To.MENTION_PROVIDER_REJECTED)
                                }
                            });
                            return $0f3b7ccff94fc3c1$var$setProvider(undefined)(editorView.state, editorView.dispatch);
                        });
                        break;
                }
                return;
            };
            const providerViaConfig = (0, $gdUUy.fg)('platform_editor_mention_provider_via_plugin_config');
            if (providerViaConfig && options !== null && options !== void 0 && options.mentionProvider) providerHandler('mentionProvider', options === null || options === void 0 ? void 0 : options.mentionProvider);
            else {
                pmPluginFactoryParams.providerFactory.subscribe('mentionProvider', providerHandler);
                if (optimistic) // Subscribe does not notify us when no provider exists. Wait until the view
                // has finished mounting before publishing the unavailable state.
                Promise.resolve().then(()=>{
                    if (!destroyed && !pmPluginFactoryParams.providerFactory.hasProvider('mentionProvider')) $0f3b7ccff94fc3c1$var$setProvider(undefined)(editorView.state, editorView.dispatch);
                });
            }
            return {
                destroy () {
                    destroyed = true;
                    if (pmPluginFactoryParams.providerFactory) pmPluginFactoryParams.providerFactory.unsubscribe('mentionProvider', providerHandler);
                    if (mentionProvider) mentionProvider.unsubscribe('mentionPlugin');
                }
            };
        }
    });
}

});
parcelRegister("krjTi", function(module, exports) {
$parcel$export(module.exports, "SLI_EVENT_TYPE", () => $853765b7f6626be5$export$245097525aef1262);
$parcel$export(module.exports, "SMART_EVENT_TYPE", () => $853765b7f6626be5$export$c724588856bbfbcf);
const $853765b7f6626be5$export$245097525aef1262 = 'sli';
const $853765b7f6626be5$export$c724588856bbfbcf = 'smart';
const $853765b7f6626be5$export$990f5c29478a61aa = 'atlassian.fabric.mention';

});

parcelRegister("2HdJL", function(module, exports) {
$parcel$export(module.exports, "MentionNodeView", () => $996ae2c47b25f2ad$export$ed501823ec7e75de);

var $bAB3U = parcelRequire("bAB3U");

var $jxkn6 = parcelRequire("jxkn6");

var $7lseo = parcelRequire("7lseo");

var $kjMQA = parcelRequire("kjMQA");

var $kuD5k = parcelRequire("kuD5k");

var $kW8qW = parcelRequire("kW8qW");

var $67eiR = parcelRequire("67eiR");

var $lyKnc = parcelRequire("lyKnc");

var $4codo = parcelRequire("4codo");

var $eBfRL = parcelRequire("eBfRL");

var $9Mjpq = parcelRequire("9Mjpq");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $ixBwV = parcelRequire("ixBwV");

var $8yfId = parcelRequire("8yfId");

var $ekgpG = parcelRequire("ekgpG");

var $fpEWT = parcelRequire("fpEWT");
const $996ae2c47b25f2ad$var$primitiveClassName = 'editor-mention-primitive';
const $996ae2c47b25f2ad$var$primitiveWithAvatarClassName = 'editor-mention-primitive-with-avatar';
const $996ae2c47b25f2ad$var$avatarContainerClassName = 'editor-mention-avatar';
const $996ae2c47b25f2ad$var$mentionTextClassName = 'editor-mention-text';
const $996ae2c47b25f2ad$var$mentionZeroWidthSpaceClassName = 'mentionNodeViewAddZeroWidthSpace';
/** Classes applied to the disabled-reason tooltip: the shared default look, plus our own hook. */ const $996ae2c47b25f2ad$var$disabledTooltipClassNames = `${(0, $kjMQA.VANILLA_TOOLTIP_DEFAULT_CLASS)} mention-disabled-tooltip`;
const $996ae2c47b25f2ad$var$genericMentionIds = [
    'HipChat',
    'all',
    'here'
];
const $996ae2c47b25f2ad$var$unknownMentionText = `@${(0, $67eiR.UNKNOWN_USER_ID)}`;
// eslint-disable-next-line require-unicode-regexp
const $996ae2c47b25f2ad$var$AT_PREFIX_REGEX = /^@/;
const $996ae2c47b25f2ad$var$getAccessibilityLabelFromName = (name)=>name.replace($996ae2c47b25f2ad$var$AT_PREFIX_REGEX, '');
// Workaround: AI-rewritten pages may store the raw AAID (e.g. '@712020:uuid') in attrs.text for
// APP/AGENT mentions instead of the display name. Detect this so we can fall through to provider
// resolution. Pattern: '@digits:uuid' — distinct from plain-UUID human AAIDs (no numeric prefix).
const $996ae2c47b25f2ad$var$AAID_MENTION_TEXT_PATTERN = // eslint-disable-next-line require-unicode-regexp
/^@\d+:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/** Returns true if `text` looks like a raw AAID rather than a display name. */ const $996ae2c47b25f2ad$var$isMentionTextAnAaid = (text)=>$996ae2c47b25f2ad$var$AAID_MENTION_TEXT_PATTERN.test(text);
const $996ae2c47b25f2ad$var$isAgentMentionsExperimentEnabled = ()=>(0, $ixBwV.expVal)('platform_editor_agent_mentions', 'isEnabled', false);
const $996ae2c47b25f2ad$var$isAgentMentionUserType = (userType)=>userType === 'APP' || userType === 'AGENT';
// In SSR `HTMLElement` is not defined, so we need to use duck typing here, follow the same pattern used from the emoji and layout plugins.
const $996ae2c47b25f2ad$var$isHTMLElement = (node)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_mention_rovo') && (0, $7lseo.isSSR)() ? 'innerHTML' in node && 'style' in node && 'classList' in node : node instanceof HTMLElement;
/**
 * Returns true if the node is an APP/AGENT mention whose stored text is a raw
 * AAID (e.g. '@712020:uuid') rather than a resolved display name.
 * All AAID-workaround guards should go through this helper so the checks stay
 * consistent and can't drift apart.
 */ const $996ae2c47b25f2ad$var$isAgentAaidText = (node, isAgentMentionsEnabled)=>isAgentMentionsEnabled && $996ae2c47b25f2ad$var$isAgentMentionUserType(node.attrs.userType) && !!node.attrs.text && $996ae2c47b25f2ad$var$isMentionTextAnAaid(node.attrs.text);
const $996ae2c47b25f2ad$var$toDOM = (node, hasAvatarSlot)=>{
    // packages/elements/mention/src/components/Mention/index.tsx
    let mentionAttrs = {
        contenteditable: 'false',
        'data-access-level': node.attrs.accessLevel,
        'data-mention-id': node.attrs.id,
        'data-prosemirror-content-type': 'node',
        'data-prosemirror-node-inline': 'true',
        'data-prosemirror-node-name': 'mention',
        'data-prosemirror-node-view-type': 'vanilla',
        class: 'mentionView-content-wrap inlineNodeView'
    };
    if ((0, $gdUUy.fg)('platform_editor_adf_with_localid')) mentionAttrs = {
        ...mentionAttrs,
        'data-local-id': node.attrs.localId
    };
    const isAgentMentionsEnabled = $996ae2c47b25f2ad$var$isAgentMentionsExperimentEnabled();
    if (isAgentMentionsEnabled && node.attrs.userType) mentionAttrs = {
        ...mentionAttrs,
        'data-user-type': node.attrs.userType
    };
    const browser = (0, $jxkn6.getBrowserInfo)();
    const hasAgentAaidText = $996ae2c47b25f2ad$var$isAgentAaidText(node, isAgentMentionsEnabled);
    const mentionText = node.attrs.text && !hasAgentAaidText ? node.attrs.text : "@\u2026";
    const visibleMentionText = hasAvatarSlot && mentionText.startsWith('@') ? mentionText.slice(1) : mentionText;
    const mentionContentSpec = hasAvatarSlot ? [
        'span',
        {
            spellcheck: 'false',
            class: `${$996ae2c47b25f2ad$var$primitiveClassName} ${$996ae2c47b25f2ad$var$primitiveWithAvatarClassName}`
        },
        [
            'span',
            {
                class: $996ae2c47b25f2ad$var$avatarContainerClassName,
                'aria-hidden': 'true'
            }
        ],
        [
            'span',
            {
                class: $996ae2c47b25f2ad$var$mentionTextClassName
            },
            visibleMentionText
        ]
    ] : [
        'span',
        {
            spellcheck: 'false',
            class: $996ae2c47b25f2ad$var$primitiveClassName
        },
        mentionText
    ];
    const zeroWidthSpaceHelperClassName = (0, $3y2s4.isExperimentEnabled)('platform_editor_mention_zero_width_space_escape') ? $996ae2c47b25f2ad$var$mentionZeroWidthSpaceClassName : 'inlineNodeViewAddZeroWidthSpace';
    return [
        'span',
        mentionAttrs,
        [
            'span',
            {
                class: 'zeroWidthSpaceContainer'
            },
            [
                'span',
                {
                    class: zeroWidthSpaceHelperClassName
                },
                (0, $kuD5k.ZERO_WIDTH_SPACE)
            ]
        ],
        mentionContentSpec,
        browser.android ? [
            'span',
            {
                class: 'zeroWidthSpaceContainer',
                contenteditable: 'false'
            },
            [
                'span',
                {
                    class: zeroWidthSpaceHelperClassName
                },
                (0, $kuD5k.ZERO_WIDTH_SPACE)
            ]
        ] : [
            'span',
            {
                class: zeroWidthSpaceHelperClassName
            },
            (0, $kuD5k.ZERO_WIDTH_SPACE)
        ]
    ];
};
const $996ae2c47b25f2ad$var$processName = (name)=>{
    return name.status === (0, $eBfRL.MentionNameStatus).OK ? `@${name.name || ''}` : $996ae2c47b25f2ad$var$unknownMentionText;
};
const $996ae2c47b25f2ad$var$handleProviderName = async (mentionProvider, node, isAgentMentionsEnabled)=>{
    // Also resolve when text is a raw AAID — provider will return the real display name.
    const textIsAaid = $996ae2c47b25f2ad$var$isAgentAaidText(node, isAgentMentionsEnabled);
    if ((0, $lyKnc.isResolvingMentionProvider)(mentionProvider) && node.attrs.id && (!node.attrs.text || textIsAaid)) {
        const nameDetail = mentionProvider === null || mentionProvider === void 0 ? void 0 : mentionProvider.resolveMentionName(node.attrs.id);
        const resolvedNameDetail = await nameDetail;
        return $996ae2c47b25f2ad$var$processName(resolvedNameDetail);
    }
};
const $996ae2c47b25f2ad$var$getNewState = (isHighlighted, isRestricted, isDisabled)=>{
    if (isDisabled) return 'disabled';
    if (isHighlighted) return 'self';
    if (isRestricted) return 'restricted';
    return 'default';
};
class $996ae2c47b25f2ad$export$ed501823ec7e75de {
    constructor(node, config){
        this.hasAvatarSlot = false;
        this.isDestroyed = false;
        this.reportAvatarFailure = (reason)=>{
            if (!this.isDestroyed && (0, $gdUUy.fg)('platform_editor_mention_avatar_observability')) {
                var _this$config$api;
                const payload = {
                    action: 'failed',
                    actionSubject: 'mentionAvatar',
                    eventType: 'operational',
                    attributes: {
                        componentName: 'mention',
                        reason: reason,
                        surface: 'editor'
                    }
                };
                (_this$config$api = this.config.api) === null || _this$config$api === void 0 || (_this$config$api = _this$config$api.analytics) === null || _this$config$api === void 0 || _this$config$api.actions.fireAnalyticsEvent(payload, (0, $67eiR.ELEMENTS_CHANNEL));
            }
        };
        const { options: options, api: api, portalProviderAPI: portalProviderAPI, editorView: editorView } = config;
        const hasProvider = Boolean(options === null || options === void 0 ? void 0 : options.mentionNodeDataProvider);
        const canReportMissingProvider = !hasProvider && (0, $gdUUy.fg)('platform_editor_mention_avatar_observability');
        const cohort = (0, $9Mjpq.expVal)('convo_ai_entity_hover_cards_non_hello_exp', 'hover_card_cohort', 'control');
        const isAvatarEnabled = (hasProvider || canReportMissingProvider) && node.attrs.userType !== 'SPECIAL' && !$996ae2c47b25f2ad$var$genericMentionIds.includes(node.attrs.id) && (cohort === 'person' || cohort === 'all' || (0, $3y2s4.isExperimentEnabled)('platform_editor_mention_node_avatar') || (0, $3y2s4.isExperimentEnabled)('platform_editor_mention_node_graphql_provider') || $996ae2c47b25f2ad$var$isAgentMentionUserType(node.attrs.userType) && (0, $3y2s4.isExperimentEnabled)('platform_editor_drop3_hexagon_agent_avatar'));
        this.hasAvatarSlot = hasProvider && isAvatarEnabled;
        const { dom: dom, contentDOM: contentDOM } = (0, $kW8qW.DOMSerializer).renderSpec(document, $996ae2c47b25f2ad$var$toDOM(node, this.hasAvatarSlot));
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.config = config;
        this.node = node;
        if (canReportMissingProvider && isAvatarEnabled) this.reportAvatarFailure('missing_provider');
        this.domElement = $996ae2c47b25f2ad$var$isHTMLElement(dom) ? dom : undefined;
        this.mentionPrimitiveElement = this.domElement ? this.domElement.querySelector(`.${$996ae2c47b25f2ad$var$primitiveClassName}`) ?? undefined : undefined;
        this.mentionTextElement = this.mentionPrimitiveElement;
        if (this.hasAvatarSlot) {
            var _this$domElement, _this$domElement2;
            this.mentionTextElement = ((_this$domElement = this.domElement) === null || _this$domElement === void 0 ? void 0 : _this$domElement.querySelector(`.${$996ae2c47b25f2ad$var$mentionTextClassName}`)) ?? this.mentionPrimitiveElement;
            const avatarContainer = (_this$domElement2 = this.domElement) === null || _this$domElement2 === void 0 ? void 0 : _this$domElement2.querySelector(`.${$996ae2c47b25f2ad$var$avatarContainerClassName}`);
            if (avatarContainer) {
                this.mentionAvatar = (0, $ekgpG.mentionAvatarRenderer)({
                    container: avatarContainer,
                    onFailure: ()=>this.reportAvatarFailure('image_load_failed')
                });
                this.resolveMentionAvatar(options === null || options === void 0 ? void 0 : options.mentionNodeDataProvider);
            }
        }
        const { mentionProvider: mentionProvider } = (api === null || api === void 0 ? void 0 : api.mention.sharedState.currentState()) ?? {};
        if ((0, $3y2s4.isExperimentEnabled)('platform_editor_mention_rovo')) this.resolveRovoChatIdentity(mentionProvider);
        this.updateState(mentionProvider);
        this.subscribeToProviderDisabledStateChanges(mentionProvider);
        this.cleanup = api === null || api === void 0 ? void 0 : api.mention.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            if ((0, $3y2s4.isExperimentEnabled)('platform_editor_mention_rovo')) this.resolveRovoChatIdentity(nextSharedState === null || nextSharedState === void 0 ? void 0 : nextSharedState.mentionProvider);
            this.updateState(nextSharedState === null || nextSharedState === void 0 ? void 0 : nextSharedState.mentionProvider);
            this.subscribeToProviderDisabledStateChanges(nextSharedState === null || nextSharedState === void 0 ? void 0 : nextSharedState.mentionProvider);
        });
        const { destroyProfileCard: destroyProfileCard, removeProfileCard: removeProfileCard, updateNode: updateNode } = (0, $fpEWT.profileCardRenderer)({
            dom: dom,
            options: options,
            portalProviderAPI: portalProviderAPI,
            node: node,
            api: api,
            editorView: editorView
        });
        // Accessibility attributes - based on `packages/people-and-teams/profilecard/src/components/User/ProfileCardTrigger.tsx`
        if (this.domElement && options !== null && options !== void 0 && options.profilecardProvider) {
            const isAgentMentionsEnabled = $996ae2c47b25f2ad$var$isAgentMentionsExperimentEnabled();
            if (node.attrs.text && !$996ae2c47b25f2ad$var$isAgentAaidText(node, isAgentMentionsEnabled)) this.domElement.setAttribute('aria-label', $996ae2c47b25f2ad$var$getAccessibilityLabelFromName(node.attrs.text));
            this.domElement.setAttribute('aria-expanded', 'false');
            this.domElement.setAttribute('role', 'button');
            this.domElement.setAttribute('tabindex', '0');
            this.domElement.setAttribute('aria-haspopup', 'dialog');
        }
        this.destroyProfileCard = destroyProfileCard;
        this.removeProfileCard = removeProfileCard;
        this.updateProfileCardNode = updateNode;
    }
    setClassList(state, disabledTooltip) {
        var _this$mentionPrimitiv, _this$mentionPrimitiv2, _this$mentionPrimitiv3;
        (_this$mentionPrimitiv = this.mentionPrimitiveElement) === null || _this$mentionPrimitiv === void 0 || _this$mentionPrimitiv.classList.toggle('mention-self', state === 'self');
        (_this$mentionPrimitiv2 = this.mentionPrimitiveElement) === null || _this$mentionPrimitiv2 === void 0 || _this$mentionPrimitiv2.classList.toggle('mention-restricted', state === 'restricted');
        (_this$mentionPrimitiv3 = this.mentionPrimitiveElement) === null || _this$mentionPrimitiv3 === void 0 || _this$mentionPrimitiv3.classList.toggle('mention-disabled', state === 'disabled');
        // Mirror the React `<Mention>` a11y behaviour: when the chip is
        // disabled, expose `aria-disabled` so assistive tech announces it as
        // such. Also surface the tooltip text via `aria-label` so screen-reader
        // users hear *why* the chip is disabled, matching the React `<Mention>`
        // behaviour at `Mention/index.tsx` line 152.
        if (this.domElement) {
            if (state === 'disabled') {
                this.domElement.setAttribute('aria-disabled', 'true');
                if (disabledTooltip) {
                    const text = this.node.attrs.text || '@...';
                    this.domElement.setAttribute('aria-label', `${text} \u{2014} ${disabledTooltip}`);
                }
            } else {
                this.domElement.removeAttribute('aria-disabled');
                this.domElement.removeAttribute('aria-label');
            }
        }
    }
    isRovoChatFromCache() {
        var _this$config$options;
        return (0, $3y2s4.isExperimentEnabled)('platform_editor_mention_rovo') && ((_this$config$options = this.config.options) === null || _this$config$options === void 0 || (_this$config$options = _this$config$options.mentionNodeDataProvider) === null || _this$config$options === void 0 || (_this$config$options = _this$config$options.getMentionDataFromCache({
            id: this.node.attrs.id,
            userType: this.node.attrs.userType
        })) === null || _this$config$options === void 0 ? void 0 : _this$config$options.isRovoChat) === true;
    }
    async resolveRovoChatIdentity(mentionProvider) {
        // Apply cached identity immediately so SSR includes Rovo styling before the async lookup.
        if (this.isRovoChatFromCache()) {
            this.lastMentionProviderForRovoIdentity = mentionProvider;
            this.setRovoChatStyles(true);
            return;
        }
        if (this.lastMentionProviderForRovoIdentity === mentionProvider) return;
        this.lastMentionProviderForRovoIdentity = mentionProvider;
        if (!(0, $3y2s4.isExperimentEnabled)('platform_editor_mention_rovo') || !(mentionProvider !== null && mentionProvider !== void 0 && mentionProvider.getRovoChatAgentIdentityAccountId)) {
            this.setRovoChatStyles(false);
            return;
        }
        let identityAccountId;
        try {
            identityAccountId = await mentionProvider.getRovoChatAgentIdentityAccountId();
        } catch  {
        // Fall back to cached identity or ordinary mention styling if the lookup fails.
        }
        if (this.isDestroyed || this.lastMentionProviderForRovoIdentity !== mentionProvider) return;
        if ((0, $3y2s4.isExperimentEnabled)('platform_editor_mention_rovo')) {
            // Recheck after awaiting: newer cached identity must take precedence over this lookup's result.
            this.setRovoChatStyles(this.isRovoChatFromCache() || identityAccountId !== undefined && identityAccountId === this.node.attrs.id);
            return;
        }
        if (identityAccountId === undefined || identityAccountId !== this.node.attrs.id) {
            this.setRovoChatStyles(false);
            return;
        }
        this.setRovoChatStyles(true);
    }
    setRovoChatStyles(isRovoChat) {
        var _this$cleanupRovoChat, _this$mentionTextElem2;
        // Avoid resetting styles and rebinding mouse listeners when the state is unchanged.
        if (this.hasRovoChatStyles === isRovoChat) return;
        (_this$cleanupRovoChat = this.cleanupRovoChatStyles) === null || _this$cleanupRovoChat === void 0 || _this$cleanupRovoChat.call(this);
        this.cleanupRovoChatStyles = undefined;
        const primitive = this.mentionPrimitiveElement;
        if (!primitive) return;
        this.hasRovoChatStyles = isRovoChat;
        primitive.classList.toggle('mention-rovo-chat', isRovoChat);
        if (!isRovoChat) {
            var _this$mentionTextElem;
            primitive.style.removeProperty('background-color');
            primitive.style.removeProperty('color');
            (_this$mentionTextElem = this.mentionTextElement) === null || _this$mentionTextElem === void 0 || _this$mentionTextElem.style.removeProperty('color');
            return;
        }
        const baseBackground = "var(--ds-background-neutral-bold, #292A2E)";
        const hoveredBackground = "var(--ds-background-neutral-bold-hovered, #3B3D42)";
        const pressedBackground = "var(--ds-background-neutral-bold-pressed, #505258)";
        const inverseText = "var(--ds-text-inverse, #FFFFFF)";
        const setBackground = (background)=>{
            primitive.style.setProperty('background-color', background);
        };
        setBackground(baseBackground);
        primitive.style.setProperty('color', inverseText);
        (_this$mentionTextElem2 = this.mentionTextElement) === null || _this$mentionTextElem2 === void 0 || _this$mentionTextElem2.style.setProperty('color', inverseText);
        // SSR needs the styles above; mouse listeners are attached only on the client.
        if ((0, $3y2s4.isExperimentEnabled)('platform_editor_mention_rovo') && (0, $7lseo.isSSR)()) return;
        const onMouseEnter = ()=>setBackground(hoveredBackground);
        const onMouseLeave = ()=>setBackground(baseBackground);
        const onMouseDown = ()=>setBackground(pressedBackground);
        const onMouseUp = ()=>setBackground(hoveredBackground);
        const unbinders = [
            (0, $bAB3U.bind)(primitive, {
                type: 'mouseenter',
                listener: onMouseEnter
            }),
            (0, $bAB3U.bind)(primitive, {
                type: 'mouseleave',
                listener: onMouseLeave
            }),
            (0, $bAB3U.bind)(primitive, {
                type: 'mousedown',
                listener: onMouseDown
            }),
            (0, $bAB3U.bind)(primitive, {
                type: 'mouseup',
                listener: onMouseUp
            })
        ];
        this.cleanupRovoChatStyles = ()=>{
            unbinders.forEach((unbind)=>unbind());
        };
    }
    getDisabledState(mentionProvider) {
        var _mentionProvider$getM;
        const input = {
            id: this.node.attrs.id,
            userType: this.node.attrs.userType
        };
        return mentionProvider === null || mentionProvider === void 0 || (_mentionProvider$getM = mentionProvider.getMentionDisabledState) === null || _mentionProvider$getM === void 0 ? void 0 : _mentionProvider$getM.call(mentionProvider, input);
    }
    /**
   * Subscribes this NodeView to disabled-state-change notifications on the
   * supplied provider so already-rendered chips can re-evaluate themselves
   * when the consumer's predicate inputs change (e.g. the active agent
   * selection toggling in Rovo Chat). No-op for providers that don't
   * implement `subscribeToDisabledStateChanges`.
   *
   * Idempotent: re-calling with the same provider keeps the existing
   * subscription; passing a different provider tears the old subscription
   * down before attaching the new one. Safe to call from the sharedState
   * `onChange` handler when the editor swaps providers.
   */ subscribeToProviderDisabledStateChanges(mentionProvider) {
        var _this$unsubscribeFrom;
        if (this.subscribedProvider === mentionProvider) return;
        (_this$unsubscribeFrom = this.unsubscribeFromDisabledStateChanges) === null || _this$unsubscribeFrom === void 0 || _this$unsubscribeFrom.call(this);
        this.unsubscribeFromDisabledStateChanges = undefined;
        this.subscribedProvider = mentionProvider;
        if (!(mentionProvider !== null && mentionProvider !== void 0 && mentionProvider.subscribeToDisabledStateChanges)) return;
        this.unsubscribeFromDisabledStateChanges = mentionProvider.subscribeToDisabledStateChanges(()=>{
            this.updateState(this.subscribedProvider);
        });
    }
    /**
   * Bind to `this.domElement`, the node-view wrapper. `VanillaTooltip` appends the popover to
   * its trigger and listens for hover/focus there. This wrapper is also where `role`,
   * `tabindex`, and aria are set, so `aria-describedby` belongs on it — not on the inner
   * `.editor-mention-primitive` that the React tooltip still wraps.
   */ syncVanillaDisabledTooltip(tooltipText) {
        var _this$vanillaDisabled;
        const trigger = this.domElement;
        if (!trigger || tooltipText === this.vanillaDisabledTooltipText) return;
        // A changed reason rebuilds rather than re-texting, so nothing out here has to reach into
        // the element `VanillaTooltip` owns. `destroy()` takes that element with it.
        (_this$vanillaDisabled = this.vanillaDisabledTooltip) === null || _this$vanillaDisabled === void 0 || _this$vanillaDisabled.destroy();
        this.vanillaDisabledTooltip = undefined;
        this.vanillaDisabledTooltipText = tooltipText;
        if ((0, $7lseo.isSSR)() || !tooltipText) return;
        this.vanillaDisabledTooltip = new (0, $kjMQA.VanillaTooltip)(trigger, tooltipText, undefined, $996ae2c47b25f2ad$var$disabledTooltipClassNames);
    }
    syncDisabledTooltip(disabledState) {
        // Capture the tooltip text into a local so the rest of the method can
        // branch on a truthy string instead of re-asserting non-null fields
        // off of `disabledState`.
        const tooltipText = disabledState !== null && disabledState !== void 0 && disabledState.disabled ? disabledState.tooltip : undefined;
        if ((0, $3y2s4.isExperimentEnabled)('platform_editor_use_vanilla_components')) {
            this.syncVanillaDisabledTooltip(tooltipText);
            return;
        }
        const chip = this.mentionPrimitiveElement;
        const { portalProviderAPI: portalProviderAPI } = this.config;
        if (!chip || !portalProviderAPI) return;
        if (tooltipText) {
            if (!this.disabledTooltip) this.disabledTooltip = (0, $8yfId.disabledTooltipRenderer)({
                chipElement: chip,
                portalProviderAPI: portalProviderAPI
            });
            this.disabledTooltip.setTooltip(tooltipText);
        } else if (this.disabledTooltip) {
            this.disabledTooltip.destroy();
            this.disabledTooltip = undefined;
        }
    }
    setTextContent(name, isAgentMentionsEnabled) {
        // Also overwrite when text is a raw AAID so the resolved name takes precedence.
        const textIsAaid = $996ae2c47b25f2ad$var$isAgentAaidText(this.node, isAgentMentionsEnabled);
        if (name && (!this.node.attrs.text || textIsAaid) && this.mentionTextElement) this.setVisibleText(name);
    }
    setVisibleText(text) {
        if (!this.mentionTextElement) return;
        this.mentionTextElement.textContent = this.hasAvatarSlot && text.startsWith('@') && text !== $996ae2c47b25f2ad$var$unknownMentionText ? text.slice(1) : text;
    }
    resolveMentionAvatar(mentionNodeDataProvider) {
        if (!this.hasAvatarSlot || !mentionNodeDataProvider || this.node.attrs.userType === 'SPECIAL') return;
        const mention = {
            id: this.node.attrs.id,
            userType: this.node.attrs.userType
        };
        const applyData = (data)=>{
            var _this$mentionAvatar;
            if (this.isDestroyed || !(data !== null && data !== void 0 && data.avatarUrl)) return;
            (_this$mentionAvatar = this.mentionAvatar) === null || _this$mentionAvatar === void 0 || _this$mentionAvatar.render(data);
        };
        let failureReported = false;
        mentionNodeDataProvider.getMentionData(mention, (payload)=>{
            if (this.isDestroyed) return;
            if (!failureReported && (payload.error || payload.data && !payload.data.avatarUrl)) {
                failureReported = true;
                if (payload.error) this.reportAvatarFailure('provider_failed');
                else if (payload.data && !payload.data.avatarUrl) this.reportAvatarFailure('missing_avatar_url');
            }
            if (payload.data) applyData(payload.data);
        });
    }
    shouldHighlightMention(mentionProvider) {
        const { currentUserId: currentUserId } = this.config.options ?? {};
        // Check options first (immediate), then provider (async), then default to false
        if (currentUserId && this.node.attrs.id === currentUserId) return true;
        else return (mentionProvider === null || mentionProvider === void 0 ? void 0 : mentionProvider.shouldHighlightMention({
            id: this.node.attrs.id
        })) ?? false;
    }
    async updateState(mentionProvider) {
        var _this$config$options2;
        const isAgentMentionsEnabled = $996ae2c47b25f2ad$var$isAgentMentionsExperimentEnabled();
        const isHighlighted = this.shouldHighlightMention(mentionProvider);
        const disabledState = this.getDisabledState(mentionProvider);
        const isDisabled = !!(disabledState !== null && disabledState !== void 0 && disabledState.disabled);
        const newState = $996ae2c47b25f2ad$var$getNewState(isHighlighted, (0, $4codo.isRestricted)(this.node.attrs.accessLevel), isDisabled);
        const disabledTooltip = disabledState !== null && disabledState !== void 0 && disabledState.disabled ? disabledState.tooltip : undefined;
        // `setClassList` always runs so the aria-label (which depends on the
        // tooltip text) stays in sync when the tooltip reason changes while
        // the chip remains disabled. State-change-only writes would leave a
        // stale aria-label after a tooltip-text-only update.
        this.setClassList(newState, disabledTooltip);
        // Tooltip wiring runs every update (not just on state change) so that
        // the tooltip text stays in sync if the disabled reason changes while
        // the chip is already disabled.
        this.syncDisabledTooltip(disabledState);
        const name = await $996ae2c47b25f2ad$var$handleProviderName(mentionProvider, this.node, isAgentMentionsEnabled);
        this.setTextContent(name, isAgentMentionsEnabled);
        // Only overwrite the disabled-state aria-label with the name-based one
        // when the chip is NOT disabled; otherwise the disabled reason set in
        // `setClassList` would be silently clobbered, regressing a11y.
        if (this.domElement && (_this$config$options2 = this.config.options) !== null && _this$config$options2 !== void 0 && _this$config$options2.profilecardProvider && newState !== 'disabled') {
            const text = name ?? this.node.attrs.text;
            if (text && !$996ae2c47b25f2ad$var$isAgentAaidText(this.node, isAgentMentionsEnabled)) this.domElement.setAttribute('aria-label', $996ae2c47b25f2ad$var$getAccessibilityLabelFromName(text));
        }
    }
    nodeIsEqual(nextNode) {
        var _this$config$options3;
        if ((_this$config$options3 = this.config.options) !== null && _this$config$options3 !== void 0 && _this$config$options3.sanitizePrivateContent) {
            // Compare nodes but ignore the text parameter as it may be sanitized
            const nextNodeAttrs = {
                ...nextNode.attrs,
                text: this.node.attrs.text
            };
            return this.node.hasMarkup(nextNode.type, nextNodeAttrs, nextNode.marks);
        }
        return this.node.sameMarkup(nextNode);
    }
    update(node) {
        var _this$updateProfileCa;
        if (!this.nodeIsEqual(node)) return false;
        this.node = node;
        // Keep the profile card renderer's node reference in sync so that the
        // click handler always reads up-to-date attrs.
        (_this$updateProfileCa = this.updateProfileCardNode) === null || _this$updateProfileCa === void 0 || _this$updateProfileCa.call(this, node);
        return true;
    }
    destroy() {
        var _this$cleanup, _this$cleanupRovoChat2, _this$destroyProfileC, _this$mentionAvatar2, _this$disabledTooltip, _this$unsubscribeFrom2;
        this.isDestroyed = true;
        // Surface the destruction to the provider before tearing down so the
        // chat layer can react (e.g. drop the agent id from `selectedAgentIds`).
        // This is the lowest-level deletion signal — fires for backspace,
        // select-and-delete, programmatic doc replaces, and editor unmount.
        try {
            var _this$subscribedProvi, _this$subscribedProvi2;
            (_this$subscribedProvi = this.subscribedProvider) === null || _this$subscribedProvi === void 0 || (_this$subscribedProvi2 = _this$subscribedProvi.notifyMentionDestroyed) === null || _this$subscribedProvi2 === void 0 || _this$subscribedProvi2.call(_this$subscribedProvi, {
                id: this.node.attrs.id
            });
        } catch (_error) {
        // Defensive: never let consumer-side notification errors prevent
        // the NodeView from cleaning up its own resources below.
        }
        (_this$cleanup = this.cleanup) === null || _this$cleanup === void 0 || _this$cleanup.call(this);
        (_this$cleanupRovoChat2 = this.cleanupRovoChatStyles) === null || _this$cleanupRovoChat2 === void 0 || _this$cleanupRovoChat2.call(this);
        this.cleanupRovoChatStyles = undefined;
        (_this$destroyProfileC = this.destroyProfileCard) === null || _this$destroyProfileC === void 0 || _this$destroyProfileC.call(this);
        (_this$mentionAvatar2 = this.mentionAvatar) === null || _this$mentionAvatar2 === void 0 || _this$mentionAvatar2.destroy();
        this.mentionAvatar = undefined;
        (_this$disabledTooltip = this.disabledTooltip) === null || _this$disabledTooltip === void 0 || _this$disabledTooltip.destroy();
        this.disabledTooltip = undefined;
        if ((0, $3y2s4.isExperimentEnabled)('platform_editor_use_vanilla_components')) {
            var _this$vanillaDisabled2;
            (_this$vanillaDisabled2 = this.vanillaDisabledTooltip) === null || _this$vanillaDisabled2 === void 0 || _this$vanillaDisabled2.destroy();
            this.vanillaDisabledTooltip = undefined;
            this.vanillaDisabledTooltipText = undefined;
        }
        (_this$unsubscribeFrom2 = this.unsubscribeFromDisabledStateChanges) === null || _this$unsubscribeFrom2 === void 0 || _this$unsubscribeFrom2.call(this);
        this.unsubscribeFromDisabledStateChanges = undefined;
        this.subscribedProvider = undefined;
    }
    deselectNode() {
        var _this$removeProfileCa;
        (_this$removeProfileCa = this.removeProfileCard) === null || _this$removeProfileCa === void 0 || _this$removeProfileCa.call(this);
    }
}

});
parcelRegister("8yfId", function(module, exports) {
$parcel$export(module.exports, "disabledTooltipRenderer", () => $a98527e606bb161f$export$7aebbaf65ecffc01);
/* disabledTooltipRenderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $7RHfd = parcelRequire("7RHfd");

var $lavtv = parcelRequire("lavtv");
const $a98527e606bb161f$var$styles = {
    hiddenTrigger: "_1e0cglyw"
};
/**
 * ADS `<Tooltip>` hands us a ref via its render-prop child. That ref may be
 * either a callback ref or a mutable ref object — React supports both shapes
 * and ADS's typing keeps both possible. This helper assigns the supplied
 * element to whichever ref shape was provided so the tooltip ends up using
 * the chip's bounding box for positioning and its DOM for trigger events.
 */ const $a98527e606bb161f$var$assignRef = (ref, element)=>{
    if (typeof ref === 'function') ref(element);
    else if (ref) ref.current = element;
};
/**
 * Maps each React-style trigger-prop handler ADS `<Tooltip>` hands us in its
 * render-prop callback to the DOM event name we attach to the chip via
 * `bind-event-listener`. The chip lives in the ProseMirror document and is
 * not a React child of the tooltip, so we have to bridge React handlers to
 * native event listeners ourselves.
 *
 * Names are listed in the same order ADS internally registers them.
 */ const $a98527e606bb161f$var$TRIGGER_EVENT_MAP = [
    [
        'onMouseOver',
        'mouseover'
    ],
    [
        'onMouseOut',
        'mouseout'
    ],
    [
        'onMouseMove',
        'mousemove'
    ],
    [
        'onMouseDown',
        'mousedown'
    ],
    [
        'onFocus',
        'focusin'
    ],
    [
        'onBlur',
        'focusout'
    ]
];
/**
 * Hook that mirrors ADS Tooltip's React trigger props onto a DOM element
 * which is not a React child of the tooltip. Re-attaches whenever ADS hands
 * us a fresh set of props (which happens on every render of the render-prop
 * child) and cleans up on unmount.
 *
 * We use `bind-event-listener`'s `bindAll` rather than raw
 * `addEventListener` / `removeEventListener` calls so the lifetime of every
 * subscription is paired with a single `UnbindFn` — the AFM-mandated pattern
 * for keeping listener bookkeeping leak-free.
 */ const $a98527e606bb161f$var$useBridgedTriggerListeners = (chip, triggerProps)=>{
    (0, $bSJIT.useEffect)(()=>{
        // Build the bindAll bindings array out of only the handlers ADS actually
        // supplied. Each React handler is wrapped in a thin adapter so the
        // listener signature matches the native `EventListener` shape; ADS
        // handlers ignore the synthetic-event-only fields they don't use
        // (target, currentTarget), so passing the raw DOM event through
        // `unknown` is safe in practice.
        const bindings = $a98527e606bb161f$var$TRIGGER_EVENT_MAP.flatMap(([propName, eventName])=>{
            const handler = triggerProps[propName];
            if (!handler) return [];
            return [
                {
                    type: eventName,
                    listener: (event)=>{
                        handler(event);
                    }
                }
            ];
        });
        if (bindings.length === 0) return;
        const unbind = (0, $bAB3U.bindAll)(chip, bindings);
        return unbind;
    }, [
        chip,
        triggerProps
    ]);
};
const $a98527e606bb161f$var$AnchoredTooltip = ({ subscribe: subscribe, getInitialTooltip: getInitialTooltip, referenceElement: referenceElement })=>{
    const [tooltip, setTooltipState] = (0, $bSJIT.useState)(getInitialTooltip);
    (0, $bSJIT.useEffect)(()=>subscribe(setTooltipState), [
        subscribe
    ]);
    if (!tooltip) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lavtv.default), {
        content: tooltip,
        position: "top",
        children: (tooltipProps)=>/*#__PURE__*/ (0, $dc70d.jsx)($a98527e606bb161f$var$TriggerBridge, {
                referenceElement: referenceElement,
                tooltipProps: tooltipProps
            })
    });
};
/**
 * Render-prop child for ADS `<Tooltip>`. The element it returns is a
 * `display: none` placeholder that satisfies the render-prop API; the
 * real trigger surface is the chip in the PM document, which receives
 * both the ADS ref and the bridged event listeners via the side-effects
 * declared on this component.
 */ const $a98527e606bb161f$var$TriggerBridge = ({ referenceElement: referenceElement, tooltipProps: tooltipProps })=>{
    $a98527e606bb161f$var$useBridgedTriggerListeners(referenceElement, tooltipProps);
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        ref: ()=>$a98527e606bb161f$var$assignRef(tooltipProps.ref, referenceElement),
        "aria-hidden": "true",
        className: (0, $9fU1q.default)([
            $a98527e606bb161f$var$styles.hiddenTrigger
        ])
    });
};
const $a98527e606bb161f$export$7aebbaf65ecffc01 = ({ chipElement: chipElement, portalProviderAPI: portalProviderAPI })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- mirror existing renderer pattern
    const key = (0, $7RHfd.default)();
    let currentTooltip;
    const listeners = new Set();
    const broadcast = ()=>{
        listeners.forEach((listener)=>listener(currentTooltip));
    };
    const getInitialTooltip = ()=>currentTooltip;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>{
            listeners.delete(listener);
        };
    };
    const renderElement = ()=>/*#__PURE__*/ (0, $dc70d.jsx)($a98527e606bb161f$var$AnchoredTooltip, {
            referenceElement: chipElement,
            getInitialTooltip: getInitialTooltip,
            subscribe: subscribe
        });
    portalProviderAPI.render(renderElement, chipElement, key);
    return {
        setTooltip (text) {
            currentTooltip = text;
            broadcast();
        },
        destroy () {
            portalProviderAPI.remove(key);
            listeners.clear();
        }
    };
};

});

parcelRegister("ekgpG", function(module, exports) {
$parcel$export(module.exports, "mentionAvatarRenderer", () => $2f0fcffe88a9adb9$export$739c6d6f69c3e18a);

var $bAB3U = parcelRequire("bAB3U");

var $3y2s4 = parcelRequire("3y2s4");
const $2f0fcffe88a9adb9$var$avatarImageClassName = 'editor-mention-avatar-image';
const $2f0fcffe88a9adb9$var$agentAvatarClassName = 'editor-mention-avatar-agent';
const $2f0fcffe88a9adb9$var$fixedAgentAvatarClassName = 'editor-mention-avatar-agent-hexagon-ui-fix';
const $2f0fcffe88a9adb9$var$fallbackAvatarClassName = 'editor-mention-avatar-fallback';
const $2f0fcffe88a9adb9$var$avatarSize = 16;
const $2f0fcffe88a9adb9$export$739c6d6f69c3e18a = ({ container: container, onFailure: onFailure })=>{
    let image;
    let fallback;
    let failureReported = false;
    let currentUrl;
    const reportFailure = ()=>{
        if (!failureReported) {
            failureReported = true;
            onFailure === null || onFailure === void 0 || onFailure();
        }
    };
    let unbindImageError;
    const removeImage = ()=>{
        var _unbindImageError, _image;
        (_unbindImageError = unbindImageError) === null || _unbindImageError === void 0 || _unbindImageError();
        unbindImageError = undefined;
        (_image = image) === null || _image === void 0 || _image.remove();
        image = undefined;
    };
    const removeFallback = ()=>{
        var _fallback;
        (_fallback = fallback) === null || _fallback === void 0 || _fallback.remove();
        fallback = undefined;
        container.classList.remove($2f0fcffe88a9adb9$var$fallbackAvatarClassName);
    };
    const showFallback = ()=>{
        reportFailure();
        removeImage();
        removeFallback();
        fallback = container.ownerDocument.createTextNode('@');
        container.appendChild(fallback);
        container.classList.add($2f0fcffe88a9adb9$var$fallbackAvatarClassName);
    };
    const destroy = ()=>{
        removeImage();
        removeFallback();
    };
    return {
        destroy: destroy,
        render: ({ appType: appType, avatarUrl: avatarUrl, isAvatarImagePreShaped: isAvatarImagePreShaped })=>{
            const shouldApplyAgentClip = !isAvatarImagePreShaped && appType === 'agent';
            const shouldApplyFixedAgentClip = shouldApplyAgentClip && (0, $3y2s4.isExperimentEnabled)('platform_editor_agent_hexagon_ui_fix');
            container.classList.toggle($2f0fcffe88a9adb9$var$agentAvatarClassName, shouldApplyAgentClip);
            container.classList.toggle($2f0fcffe88a9adb9$var$fixedAgentAvatarClassName, shouldApplyFixedAgentClip);
            removeFallback();
            if (!avatarUrl) {
                removeImage();
                return;
            }
            if (!image || currentUrl !== avatarUrl) {
                failureReported = false;
                currentUrl = avatarUrl;
            }
            if (!image) {
                image = container.ownerDocument.createElement('img');
                image.alt = '';
                image.className = $2f0fcffe88a9adb9$var$avatarImageClassName;
                image.decoding = 'async';
                image.draggable = false;
                image.height = $2f0fcffe88a9adb9$var$avatarSize;
                image.loading = 'lazy';
                image.width = $2f0fcffe88a9adb9$var$avatarSize;
                unbindImageError = (0, $bAB3U.bind)(image, {
                    type: 'error',
                    listener: showFallback
                });
                container.appendChild(image);
            }
            image.src = avatarUrl;
        }
    };
};

});

parcelRegister("fpEWT", function(module, exports) {
$parcel$export(module.exports, "profileCardRenderer", () => $30e7a1cbb3cf7c2a$export$6adf928fbc333163);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $7RHfd = parcelRequire("7RHfd");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $3qSID = parcelRequire("3qSID");

var $ixBwV = parcelRequire("ixBwV");

var $bPpGY = parcelRequire("bPpGY");

var $iV8Uh = parcelRequire("iV8Uh");
const $30e7a1cbb3cf7c2a$export$6adf928fbc333163 = ({ dom: dom, options: options, portalProviderAPI: portalProviderAPI, node: node, api: api, editorView: editorView })=>{
    // Keep a mutable reference to the latest node so the click handler always
    // reads up-to-date attrs
    let currentNode = node;
    let renderingProfileCard = false;
    let navigatingToProfile = false;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = (0, $7RHfd.default)();
    let cleanupSelection;
    const removeProfileCard = ()=>{
        var _cleanupSelection;
        if (dom instanceof HTMLElement) dom.setAttribute('aria-expanded', 'false');
        portalProviderAPI.remove(key);
        renderingProfileCard = false;
        (_cleanupSelection = cleanupSelection) === null || _cleanupSelection === void 0 || _cleanupSelection();
    };
    const renderProfileCardPopup = (renderProfileCard)=>{
        var _api$selection;
        if (!(dom instanceof HTMLElement) || renderingProfileCard) return;
        const referenceElement = dom;
        referenceElement.setAttribute('aria-expanded', 'true');
        renderingProfileCard = true;
        portalProviderAPI.render(()=>renderProfileCard(referenceElement), referenceElement, key);
        cleanupSelection = api === null || api === void 0 || (_api$selection = api.selection) === null || _api$selection === void 0 ? void 0 : _api$selection.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            const selection = nextSharedState === null || nextSharedState === void 0 ? void 0 : nextSharedState.selection;
            if (selection instanceof (0, $cw0wu.NodeSelection) ? selection.node.sameMarkup(currentNode) : false) return;
            removeProfileCard === null || removeProfileCard === void 0 || removeProfileCard();
        });
    };
    const renderEditorProfileCard = ()=>{
        const clickedNode = currentNode;
        const activeMention = ((_ref, _currentNode, _currentNode2, _currentNode3)=>{
            // Avatar mentions keep their resolved display name in the nested text span.
            // Control mentions preserve the legacy attrs-first fallback.
            const mentionTextElement = dom instanceof HTMLElement ? dom.querySelector('.editor-mention-text') : undefined;
            const primitiveText = (_ref = mentionTextElement ?? (dom instanceof HTMLElement ? dom.querySelector('.editor-mention-primitive') : undefined)) === null || _ref === void 0 || (_ref = _ref.textContent) === null || _ref === void 0 ? void 0 : _ref.trim();
            const resolvedText = primitiveText && !primitiveText.startsWith('@') ? `@${primitiveText}` : primitiveText;
            return {
                attrs: {
                    ...(_currentNode = currentNode) === null || _currentNode === void 0 ? void 0 : _currentNode.attrs,
                    text: mentionTextElement ? resolvedText || ((_currentNode2 = currentNode) === null || _currentNode2 === void 0 || (_currentNode2 = _currentNode2.attrs) === null || _currentNode2 === void 0 ? void 0 : _currentNode2.text) || undefined : ((_currentNode3 = currentNode) === null || _currentNode3 === void 0 || (_currentNode3 = _currentNode3.attrs) === null || _currentNode3 === void 0 ? void 0 : _currentNode3.text) || primitiveText || undefined
                }
            };
        })();
        // Build agent mention context at click time by finding the parent block of this mention
        // in the live document.
        let agentMentionContext;
        if (options !== null && options !== void 0 && options.onAgentMentionChatClick && editorView && (0, $gdUUy.fg)('platform_editor_agent_mentions_drop_one_fixes')) {
            var _clickedNode$attrs;
            const localId = (_clickedNode$attrs = clickedNode.attrs) === null || _clickedNode$attrs === void 0 ? void 0 : _clickedNode$attrs.localId;
            if (localId) {
                const found = (0, $gab48.findChildrenByAttr)(editorView.state.doc, (attrs)=>(attrs === null || attrs === void 0 ? void 0 : attrs.localId) === localId)[0];
                if (found) {
                    const parentBlock = editorView.state.doc.resolve(found.pos).parent;
                    agentMentionContext = (0, $bPpGY.getAgentMentionParentContext)(parentBlock, localId);
                }
            }
        }
        renderProfileCardPopup((referenceElement)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $iV8Uh.ProfileCardComponent), {
                activeMention: activeMention,
                profilecardProvider: options === null || options === void 0 ? void 0 : options.profilecardProvider,
                onAgentMentionChatClick: options !== null && options !== void 0 && options.onAgentMentionChatClick && (0, $gdUUy.fg)('platform_editor_agent_mentions_drop_one_fixes') ? (agentId)=>{
                    var _options$onAgentMenti;
                    (_options$onAgentMenti = options.onAgentMentionChatClick) === null || _options$onAgentMenti === void 0 || _options$onAgentMenti.call(options, agentId, agentMentionContext);
                    // The mention stays node-selected after the chat opens; collapse the
                    // selection to a cursor just after it so it is no longer left selected.
                    // Selection-only change, so it does not move focus (EDITOR-8257).
                    if (editorView) {
                        const { state: state } = editorView;
                        editorView.dispatch(state.tr.setSelection((0, $cw0wu.TextSelection).create(state.doc, state.selection.to)));
                    }
                } : undefined,
                dom: referenceElement,
                closeComponent: removeProfileCard
            }));
    };
    const renderUserProfileCard = ({ userId: userId, cloudId: cloudId, renderUserMentionCard: renderUserMentionCard })=>{
        if (!renderUserMentionCard) return false;
        renderProfileCardPopup((referenceElement)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
                children: renderUserMentionCard({
                    userId: userId,
                    cloudId: cloudId,
                    children: null,
                    referenceElement: referenceElement
                })
            }));
        return true;
    };
    const navigateToProfile = (userId, cloudId)=>{
        if (navigatingToProfile) return;
        navigatingToProfile = true;
        const { href: href, target: target } = (0, $3qSID.navigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: userId
            },
            cloudId: cloudId
        });
        window.open(href, target, 'noopener,noreferrer');
    };
    const renderDefaultProfileCard = (userId, provider)=>{
        if (renderUserProfileCard({
            userId: userId,
            cloudId: provider.cloudId,
            renderUserMentionCard: provider.renderUserMentionCard
        })) return;
        navigateToProfile(userId, provider.cloudId);
    };
    const listenerCleanup = (0, $bAB3U.bind)(dom, {
        type: 'click',
        listener: ()=>{
            if ((0, $gdUUy.fg)('people-teams_migrate-user-profile-card') || (0, $3y2s4.isExperimentEnabled)('pt_user_profile_card_migration_exp')) {
                var _currentNode$attrs, _options$profilecardP;
                const userId = (_currentNode$attrs = currentNode.attrs) === null || _currentNode$attrs === void 0 ? void 0 : _currentNode$attrs.id;
                if (!userId) return;
                navigatingToProfile = false;
                options === null || options === void 0 || (_options$profilecardP = options.profilecardProvider) === null || _options$profilecardP === void 0 || _options$profilecardP.then((provider)=>{
                    var _currentNode$attrs2;
                    if (!(0, $ixBwV.expVal)('platform_editor_agent_mentions', 'isEnabled', false)) {
                        renderDefaultProfileCard(userId, provider);
                        return;
                    }
                    if ((0, $iV8Uh.isAgentMentionType)((_currentNode$attrs2 = currentNode.attrs) === null || _currentNode$attrs2 === void 0 ? void 0 : _currentNode$attrs2.userType)) renderEditorProfileCard();
                    else renderDefaultProfileCard(userId, provider);
                });
                return;
            }
            if (options !== null && options !== void 0 && options.profilecardProvider) renderEditorProfileCard();
        }
    });
    return {
        destroyProfileCard: ()=>{
            listenerCleanup();
            removeProfileCard === null || removeProfileCard === void 0 || removeProfileCard();
        },
        removeProfileCard: removeProfileCard,
        updateNode: (nextNode)=>{
            currentNode = nextNode;
        }
    };
};

});
parcelRegister("iV8Uh", function(module, exports) {
$parcel$export(module.exports, "isAgentMentionType", () => $a72b0892739b5c24$export$eab6bc3eb8597f0);
$parcel$export(module.exports, "ProfileCardComponent", () => $a72b0892739b5c24$export$cbc1b955d6cce80d);
/* ProfileCardComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $bAB3U = parcelRequire("bAB3U");

var $deAR2 = parcelRequire("deAR2");

var $cJJTb = parcelRequire("cJJTb");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $8wbIC = parcelRequire("8wbIC");

var $5N1Y4 = parcelRequire("5N1Y4");

var $ixBwV = parcelRequire("ixBwV");

var $84REj = parcelRequire("84REj");
// eslint-disable-next-line require-unicode-regexp
const $a72b0892739b5c24$var$LEADING_AT_SIGN_RE = /^@/;

const $a72b0892739b5c24$var$loadAgentProfileCardResourced = ()=>(parcelRequire("lAOOd")).then(({ AgentProfileCardResourced: AgentProfileCardResourced })=>AgentProfileCardResourced);

const $a72b0892739b5c24$var$AgentProfileCardResourcedLazy = (0, $cJJTb.lazyForPaint)(()=>(parcelRequire("lAOOd")).then(({ AgentProfileCardResourced: AgentProfileCardResourced })=>AgentProfileCardResourced), {
    moduleId: "../platform/packages/people-and-teams/profilecard/src/components/Agent/AgentProfileCardResourced.tsx"
});
const $a72b0892739b5c24$var$AgentProfileCardResourcedLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $a72b0892739b5c24$var$loadAgentProfileCardResourced,
    loading: ()=>null
});
const $a72b0892739b5c24$var$AgentProfileCardResourced = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($a72b0892739b5c24$var$AgentProfileCardResourcedLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- forward the loader props to the profile card
    /*#__PURE__*/ (0, $dc70d.jsx)($a72b0892739b5c24$var$AgentProfileCardResourcedLoadable, {
        ...props
    });
const $a72b0892739b5c24$var$styles = {
    loadingStyles: "_2rko12b0 _16qs130s"
};
const $a72b0892739b5c24$var$LoadingWrapper = ({ children: children, isLoading: isLoading })=>isLoading ? /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: (0, $9fU1q.default)([
            $a72b0892739b5c24$var$styles.loadingStyles
        ]),
        children: children
    }) : children;
const $a72b0892739b5c24$export$eab6bc3eb8597f0 = (userType)=>userType === 'APP' || userType === 'AGENT';
const $a72b0892739b5c24$export$2776629671584a76 = ({ id: id, provider: provider })=>{
    const [data, setData] = (0, $bSJIT.useState)();
    const [reportingLinesData, setReportingLinesData] = (0, $bSJIT.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $bSJIT.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $bSJIT.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $bSJIT.useState)(false);
    const [hasError, setHasError] = (0, $bSJIT.useState)(false);
    // From: packages/people-and-teams/profilecard/src/components/User/ProfileCardTrigger.tsx
    (0, $bSJIT.useEffect)(()=>{
        const fetchData = async ()=>{
            if (!id || !provider) return;
            setIsLoading(true);
            try {
                const [data, reportingLines, shouldGiveKudos, teamCentralBaseUrl] = await Promise.all([
                    provider === null || provider === void 0 ? void 0 : provider.resourceClient.getProfile((provider === null || provider === void 0 ? void 0 : provider.cloudId) || '', id, ()=>{}),
                    provider === null || provider === void 0 ? void 0 : provider.resourceClient.getReportingLines(id),
                    provider === null || provider === void 0 ? void 0 : provider.resourceClient.shouldShowGiveKudos(),
                    provider === null || provider === void 0 ? void 0 : provider.resourceClient.getTeamCentralBaseUrl({
                        withOrgContext: true,
                        withSiteContext: true
                    })
                ]);
                setData(data);
                setReportingLinesData(reportingLines);
                setShouldShowGiveKudos(shouldGiveKudos ?? false);
                setTeamCentralBaseUrl(teamCentralBaseUrl);
                setHasError(false);
            } catch  {
                setHasError(true);
            } finally{
                setIsLoading(false);
            }
        };
        fetchData();
    }, [
        id,
        provider
    ]);
    return {
        data: data,
        reportingLinesData: reportingLinesData,
        shouldShowGiveKudos: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        isLoading: isLoading,
        hasError: hasError
    };
};
function $a72b0892739b5c24$export$cbc1b955d6cce80d({ profilecardProvider: profilecardProvider, activeMention: activeMention, dom: dom, closeComponent: closeComponent, onAgentMentionChatClick: onAgentMentionChatClick, placement: placement, offset: offset, disableFocusTrap: disableFocusTrap, hideActions: hideActions }) {
    const [provider, setProvider] = (0, $bSJIT.useState)(undefined);
    (0, $bSJIT.useEffect)(()=>{
        profilecardProvider === null || profilecardProvider === void 0 || profilecardProvider.then((p)=>{
            setProvider(p);
        });
    }, [
        profilecardProvider
    ]);
    const { id: id, text: text, accessLevel: accessLevel, userType: userType } = activeMention.attrs ?? {};
    (0, $bSJIT.useEffect)(()=>{
        return (0, $bAB3U.bind)(window, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') closeComponent();
            }
        });
    });
    if (!(0, $ixBwV.expVal)('platform_editor_agent_mentions', 'isEnabled', false) && !(0, $gdUUy.fg)('platform_editor_agent_card_fixes')) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $84REj.Popup), {
        referenceElement: dom,
        placement: placement,
        offset: offset,
        disableFocusTrap: disableFocusTrap,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($a72b0892739b5c24$var$UserProfileCardContent, {
            accessLevel: accessLevel,
            id: id,
            provider: provider,
            text: text,
            hideActions: hideActions
        })
    });
    const isAgentMention = $a72b0892739b5c24$export$eab6bc3eb8597f0(userType);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $84REj.Popup), {
        referenceElement: dom,
        placement: placement,
        offset: offset,
        disableFocusTrap: disableFocusTrap,
        children: isAgentMention && provider && id ? /*#__PURE__*/ (0, $dc70d.jsx)($a72b0892739b5c24$var$AgentProfileCardContent, {
            accountId: id,
            provider: provider,
            hideActions: hideActions,
            text: text,
            onChatClick: onAgentMentionChatClick && (0, $gdUUy.fg)('platform_editor_agent_mentions_drop_one_fixes') ? (event, agentStudioId)=>{
                // agentMentionContext is already captured in the onAgentMentionChatClick
                // closure built by profileCardRenderer at chip-click time via doc.descendants()
                onAgentMentionChatClick(agentStudioId ?? id);
                // Dismiss the profile card once the Rovo chat panel opens (EDITOR-8257).
                closeComponent();
            } : undefined
        }) : /*#__PURE__*/ (0, $dc70d.jsx)($a72b0892739b5c24$var$UserProfileCardContent, {
            accessLevel: accessLevel,
            id: id,
            provider: provider,
            text: text,
            hideActions: hideActions
        })
    });
}
const $a72b0892739b5c24$var$UserProfileCardContent = ({ accessLevel: accessLevel, id: id, provider: provider, text: text, hideActions: hideActions })=>{
    const actions = (0, $bSJIT.useMemo)(()=>hideActions ? [] : provider === null || provider === void 0 ? void 0 : provider.getActions(id, text ?? '', accessLevel), [
        hideActions,
        accessLevel,
        id,
        provider,
        text
    ]);
    const { data: data, reportingLinesData: reportingLinesData, shouldShowGiveKudos: shouldShowGiveKudos, teamCentralBaseUrl: teamCentralBaseUrl, isLoading: isLoading, hasError: hasError } = $a72b0892739b5c24$export$2776629671584a76({
        id: id,
        provider: provider
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)($a72b0892739b5c24$var$LoadingWrapper, {
        isLoading: isLoading,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8wbIC.ProfileCardLazy), {
            avatarUrl: data === null || data === void 0 ? void 0 : data.avatarUrl,
            accountType: data === null || data === void 0 ? void 0 : data.accountType,
            status: data === null || data === void 0 ? void 0 : data.status,
            statusModifiedDate: data === null || data === void 0 ? void 0 : data.statusModifiedDate,
            timestring: data === null || data === void 0 ? void 0 : data.timestring,
            isCurrentUser: data === null || data === void 0 ? void 0 : data.isCurrentUser,
            isBot: data === null || data === void 0 ? void 0 : data.isBot,
            fullName: data === null || data === void 0 ? void 0 : data.fullName,
            userId: id,
            cloudId: provider === null || provider === void 0 ? void 0 : provider.cloudId,
            actions: actions,
            isLoading: isLoading,
            location: data === null || data === void 0 ? void 0 : data.location,
            companyName: data === null || data === void 0 ? void 0 : data.companyName,
            customLozenges: data === null || data === void 0 ? void 0 : data.customLozenges,
            nickname: data === null || data === void 0 ? void 0 : data.nickname,
            email: data === null || data === void 0 ? void 0 : data.email,
            hasError: hasError,
            reportingLines: reportingLinesData,
            isKudosEnabled: shouldShowGiveKudos,
            teamCentralBaseUrl: teamCentralBaseUrl,
            isRenderedInPortal: (0, $5N1Y4.expValEquals)('editor_a11y_7152_profile_card_tab_order', 'isEnabled', true)
        })
    });
};
const $a72b0892739b5c24$var$AgentProfileCardContent = ({ accountId: accountId, provider: provider, text: text, onChatClick: onChatClick, hideActions: hideActions })=>{
    const agentName = (text ?? '').replace($a72b0892739b5c24$var$LEADING_AT_SIGN_RE, '');
    if (provider.renderAgentMentionCard) return provider.renderAgentMentionCard({
        accountId: accountId,
        cloudId: provider.cloudId,
        isReadOnly: hideActions,
        onChatClick: onChatClick
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)($a72b0892739b5c24$var$AgentProfileCardResourced, {
        accountId: accountId,
        cloudId: provider.cloudId,
        resourceClient: provider.resourceClient,
        agentName: agentName,
        onChatClick: onChatClick,
        hideAgentActions: hideActions,
        hideConversationStarters: hideActions,
        hideStarButton: hideActions,
        hideAiDisclaimer: hideActions,
        showCreatorNameWithoutLink: hideActions
    });
};

});
parcelRegister("84REj", function(module, exports) {
$parcel$export(module.exports, "Popup", () => $31b1ebdc6853a831$export$129a32eedafa97c5);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $ffwxl = parcelRequire("ffwxl");

var $cglph = parcelRequire("cglph");

var $juI4y = parcelRequire("juI4y");

var $ixBwV = parcelRequire("ixBwV");

var $4j28M = parcelRequire("4j28M");
const $31b1ebdc6853a831$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $bSJIT.useRef)(true);
    (0, $bSJIT.useEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update,
        children
    ]);
    return children;
};
/**
 * Hook that attaches a ResizeObserver to the popup container div and calls
 * forceUpdate whenever the popup's size changes. This handles the case where
 * the popup content changes size due to internal state changes (e.g. the agent
 * profile card transitioning from loading → loaded), which cannot be detected
 * via the `children` prop dependency alone.
 */ function $31b1ebdc6853a831$var$useResizeAwarePopper({ popupRef: popupRef, forceUpdate: forceUpdate }) {
    const forceUpdateRef = (0, $bSJIT.useRef)(forceUpdate);
    (0, $bSJIT.useLayoutEffect)(()=>{
        forceUpdateRef.current = forceUpdate;
    }, [
        forceUpdate
    ]);
    (0, $bSJIT.useEffect)(()=>{
        // No-op when forceUpdate is not provided (e.g. when the gate is off).
        // This ensures the ResizeObserver is not created unnecessarily.
        if (typeof forceUpdateRef.current !== 'function' && (0, $gdUUy.fg)('platform_editor_agent_mentions_drop_one_fixes')) return;
        if (!popupRef || typeof ResizeObserver === 'undefined') return;
        const observer = new ResizeObserver(()=>{
            // forceUpdate is synchronous unlike update() which is debounced.
            // This ensures Popper recalculates position (and flips if needed)
            // immediately when the popup content grows, before the browser repaints.
            if (typeof forceUpdateRef.current === 'function') forceUpdateRef.current();
        });
        observer.observe(popupRef);
        return ()=>observer.disconnect();
    }, [
        popupRef
    ]);
}
function $31b1ebdc6853a831$export$129a32eedafa97c5({ referenceElement: referenceElement, children: children, placement: placement = 'bottom-end', offset: offset = [
    0,
    8
], disableFocusTrap: disableFocusTrap = false }) {
    const [targetRef, setPopupRef] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(null);
    (0, $4j28M.useFocusTrap)({
        targetRef: targetRef,
        enabled: !disableFocusTrap
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Suspense), {
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cglph.default), {
            zIndex: (0, $juI4y.layers).modal(),
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $ffwxl.Popper), {
                referenceElement: referenceElement,
                offset: offset,
                placement: placement,
                strategy: "fixed",
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                modifiers: (0, $ixBwV.expVal)('platform_editor_agent_mentions', 'isEnabled', false) || (0, $gdUUy.fg)('platform_editor_agent_card_fixes') ? [
                    {
                        name: 'flip',
                        options: {
                            rootBoundary: 'viewport',
                            padding: 5
                        }
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            rootBoundary: 'viewport',
                            padding: 5
                        }
                    }
                ] : [],
                children: ({ ref: ref, style: style, update: update, forceUpdate: forceUpdate })=>/*#__PURE__*/ (0, $dc70d.jsx)($31b1ebdc6853a831$var$PopupInner, {
                        ref: ref,
                        style: style,
                        update: update,
                        forceUpdate: (0, $ixBwV.expVal)('platform_editor_agent_mentions', 'isEnabled', false) || (0, $gdUUy.fg)('platform_editor_agent_card_fixes') ? forceUpdate : undefined,
                        setPopupRef: setPopupRef,
                        children: children
                    })
            })
        })
    });
}
const $31b1ebdc6853a831$var$PopupInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(({ style: style, update: update, forceUpdate: forceUpdate, setPopupRef: setPopupRef, children: children }, ref)=>{
    const [popupDiv, setPopupDiv] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(null);
    $31b1ebdc6853a831$var$useResizeAwarePopper({
        popupRef: popupDiv,
        forceUpdate: forceUpdate
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ref: (node)=>{
            if (node) {
                if (typeof ref === 'function') ref(node);
                else if (ref) ref.current = node;
                setPopupRef(node);
                setPopupDiv(node);
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($31b1ebdc6853a831$export$51eddd7655ca235a, {
            update: update,
            children: children
        })
    });
});

});
parcelRegister("4j28M", function(module, exports) {
$parcel$export(module.exports, "useFocusTrap", () => $3e8035a9c5088048$export$5562a1f223a0d314);
/**
 * Custom hook to add focus trap
 * used for focus trap in ReactionPicker
 * copied from useFocusManager in @atlaskit/popup
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $iOdDG = parcelRequire("iOdDG");
const $3e8035a9c5088048$export$5562a1f223a0d314 = ({ targetRef: targetRef, enabled: enabled = true })=>{
    (0, $bSJIT.useEffect)(()=>{
        if (!targetRef || !enabled) return;
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: targetRef,
            fallbackFocus: targetRef,
            returnFocusOnDeactivate: true
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($iOdDG)))(targetRef, trapConfig);
        // wait for the popup to reposition itself before we focus
        let frameId = requestAnimationFrame(()=>{
            frameId = null;
            focusTrap.activate();
        });
        return ()=>{
            if (frameId !== null) {
                cancelAnimationFrame(frameId);
                frameId = null;
            }
            focusTrap.deactivate();
        };
    }, [
        targetRef,
        enabled
    ]);
};

});


parcelRegister("lAOOd", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("04tGK").then(()=>parcelRequire('48WmJ'));

});
parcelRegister("kOunM", function(module, exports) {
"use strict";

function $f2700b8349aa6afb$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("gBxz7")).resolve(id));
}
module.exports = $f2700b8349aa6afb$var$load;

});
parcelRegister("gBxz7", function(module, exports) {
$parcel$export(module.exports, "register", () => $c16a23763a54f59d$export$6503ec6e8aabbaf, (v) => $c16a23763a54f59d$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $c16a23763a54f59d$export$f7ad0328861e2f03, (v) => $c16a23763a54f59d$export$f7ad0328861e2f03 = v);
var $c16a23763a54f59d$export$6503ec6e8aabbaf;
var $c16a23763a54f59d$export$f7ad0328861e2f03;
"use strict";
var $c16a23763a54f59d$var$mapping = new Map();
function $c16a23763a54f59d$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$c16a23763a54f59d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $c16a23763a54f59d$var$resolve(id) {
    var resolved = $c16a23763a54f59d$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$c16a23763a54f59d$export$6503ec6e8aabbaf = $c16a23763a54f59d$var$register;
$c16a23763a54f59d$export$f7ad0328861e2f03 = $c16a23763a54f59d$var$resolve;

});






parcelRegister("cb7To", function(module, exports) {
$parcel$export(module.exports, "MENTION_PROVIDER_REJECTED", () => $a662c519c8380ec8$export$7d0bcf8324b20190);
$parcel$export(module.exports, "MENTION_PROVIDER_UNDEFINED", () => $a662c519c8380ec8$export$eceeecffdf63fc89);
const $a662c519c8380ec8$export$7d0bcf8324b20190 = 'REJECTED';
const $a662c519c8380ec8$export$eceeecffdf63fc89 = 'UNDEFINED';

});

parcelRegister("a04WG", function(module, exports) {
$parcel$export(module.exports, "getMentionPluginState", () => $4161eb6e12495a50$export$1e2b0e72eff65e51);
$parcel$export(module.exports, "canMentionBeCreatedInRange", () => $4161eb6e12495a50$export$bdc4118452fb5868);

var $gab48 = parcelRequire("gab48");

var $cx9k0 = parcelRequire("cx9k0");
function $4161eb6e12495a50$export$1e2b0e72eff65e51(state) {
    return (0, $cx9k0.mentionPluginKey).getState(state);
}
const $4161eb6e12495a50$export$bdc4118452fb5868 = (from, to)=>(state)=>{
        const $from = state.doc.resolve(from);
        const $to = state.doc.resolve(to);
        const mention = state.schema.nodes.mention.createChecked();
        if ($from.parent === $to.parent && (0, $gab48.canInsert)($from, mention)) return true;
        return false;
    };

});



parcelRegister("cCaRC", function(module, exports) {
$parcel$export(module.exports, "InlineInvitePopupContainer", () => $f4de196bc43cb41a$export$d06d4c9c8497c433);
/* InlineInvitePopupContainer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
const $f4de196bc43cb41a$var$findMentionRange = (doc, localId)=>{
    let range = null;
    doc.descendants((node, pos)=>{
        if (range) return false;
        if (node.type.name === 'mention' && node.attrs.localId === localId) {
            range = {
                from: pos,
                to: pos + node.nodeSize
            };
            return false;
        }
        return true;
    });
    return range;
};
const $f4de196bc43cb41a$export$d06d4c9c8497c433 = ({ mentionProvider: mentionProvider, api: api, editorView: editorView })=>{
    var _api$mention2, _api$core3;
    const [provider, setProvider] = (0, $bSJIT.useState)(null);
    const [anchorElement, setAnchorElement] = (0, $bSJIT.useState)(null);
    const pendingMentionRef = (0, $bSJIT.useRef)(null);
    (0, $bSJIT.useEffect)(()=>{
        if (!mentionProvider) return;
        let isMounted = true;
        let cleanupProvider;
        mentionProvider.then((resolvedProvider)=>{
            var _providerWithPopup$ge;
            if (!isMounted) return;
            const providerWithPopup = resolvedProvider;
            const originalGetMentionDisabledState = (_providerWithPopup$ge = providerWithPopup.getMentionDisabledState) === null || _providerWithPopup$ge === void 0 ? void 0 : _providerWithPopup$ge.bind(providerWithPopup);
            providerWithPopup.getMentionDisabledState = (mention)=>{
                var _pendingMentionRef$cu;
                if (((_pendingMentionRef$cu = pendingMentionRef.current) === null || _pendingMentionRef$cu === void 0 ? void 0 : _pendingMentionRef$cu.localId) === mention.id) return {
                    disabled: true
                };
                return originalGetMentionDisabledState === null || originalGetMentionDisabledState === void 0 ? void 0 : originalGetMentionDisabledState(mention);
            };
            cleanupProvider = ()=>{
                if (originalGetMentionDisabledState) providerWithPopup.getMentionDisabledState = originalGetMentionDisabledState;
                else delete providerWithPopup.getMentionDisabledState;
            };
            setProvider(providerWithPopup);
        }).catch(()=>{});
        return ()=>{
            var _cleanupProvider;
            isMounted = false;
            (_cleanupProvider = cleanupProvider) === null || _cleanupProvider === void 0 || _cleanupProvider();
            setProvider(null);
        };
    }, [
        mentionProvider
    ]);
    const removePendingMention = (0, $bSJIT.useCallback)(()=>{
        var _api$core;
        const pending = pendingMentionRef.current;
        if (pending && api !== null && api !== void 0 && (_api$core = api.core) !== null && _api$core !== void 0 && (_api$core = _api$core.actions) !== null && _api$core !== void 0 && _api$core.execute) api.core.actions.execute(({ tr: tr })=>{
            const range = $f4de196bc43cb41a$var$findMentionRange(tr.doc, pending.localId);
            return range ? tr.delete(range.from, range.to) : null;
        });
        pendingMentionRef.current = null;
        setAnchorElement(null);
    }, [
        api
    ]);
    const handleDismiss = (0, $bSJIT.useCallback)(()=>{
        removePendingMention();
    }, [
        removePendingMention
    ]);
    const handleInviteComplete = (0, $bSJIT.useCallback)((result)=>{
        var _api$core2, _api$mention;
        const pending = pendingMentionRef.current;
        if (!pending) return;
        const invitedUser = result.invited[0] ?? result.requested[0];
        if (!invitedUser || !(api !== null && api !== void 0 && (_api$core2 = api.core) !== null && _api$core2 !== void 0 && (_api$core2 = _api$core2.actions) !== null && _api$core2 !== void 0 && _api$core2.execute) || !(api !== null && api !== void 0 && (_api$mention = api.mention) !== null && _api$mention !== void 0 && (_api$mention = _api$mention.commands) !== null && _api$mention !== void 0 && _api$mention.insertMention)) return;
        const { id: userId, email: email } = invitedUser;
        api.core.actions.execute(({ tr: tr })=>{
            const range = $f4de196bc43cb41a$var$findMentionRange(tr.doc, pending.localId);
            return range ? tr.delete(range.from, range.to) : null;
        });
        api.core.actions.execute(api.mention.commands.insertMention({
            id: userId,
            name: email,
            userType: 'DEFAULT',
            accessLevel: 'CONTAINER'
        }));
        pendingMentionRef.current = null;
        setAnchorElement(null);
    }, [
        api
    ]);
    const handleReady = (0, $bSJIT.useCallback)((show)=>{
        if (!provider) return;
        if (show) provider.showInlineInvitePopup = (email, localId)=>{
            pendingMentionRef.current = {
                email: email,
                localId: localId
            };
            setTimeout(()=>{
                const range = $f4de196bc43cb41a$var$findMentionRange(editorView.state.doc, localId);
                const dom = range ? editorView.nodeDOM(range.from) : null;
                setAnchorElement(dom instanceof HTMLElement ? dom : null);
                show(email);
            }, 0);
        };
        else delete provider.showInlineInvitePopup;
    }, [
        provider,
        editorView
    ]);
    if (!(provider !== null && provider !== void 0 && provider.InlineInvitePopup) || !(api !== null && api !== void 0 && (_api$mention2 = api.mention) !== null && _api$mention2 !== void 0 && (_api$mention2 = _api$mention2.commands) !== null && _api$mention2 !== void 0 && _api$mention2.insertMention) || !(api !== null && api !== void 0 && (_api$core3 = api.core) !== null && _api$core3 !== void 0 && (_api$core3 = _api$core3.actions) !== null && _api$core3 !== void 0 && _api$core3.execute)) return null;
    const PopupComponent = provider.InlineInvitePopup;
    return /*#__PURE__*/ (0, $dc70d.jsx)(PopupComponent, {
        anchorElement: anchorElement,
        onInviteComplete: handleInviteComplete,
        onDismiss: handleDismiss,
        onReady: handleReady
    });
};

});

parcelRegister("8KGPF", function(module, exports) {
$parcel$export(module.exports, "getMentionQuickInsertComponents", () => $6efd449167e17f34$export$1c771a1f42b005c2);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $cW1gB = parcelRequire("cW1gB");

var $b8Hvx = parcelRequire("b8Hvx");

var $9woaI = parcelRequire("9woaI");

var $am2Qg = parcelRequire("am2Qg");

var $gmngl = parcelRequire("gmngl");
const $6efd449167e17f34$var$previewImageUrls = {
    light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLB.png',
    dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHL.png'
};
const $6efd449167e17f34$export$1c771a1f42b005c2 = ({ api: api, canOpenMentionTypeAhead: canOpenMentionTypeAhead, typeAhead: typeAhead })=>[
        {
            key: (0, $9woaI.MENTION_MENU_ITEM).key,
            type: (0, $9woaI.MENTION_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $9woaI.STRUCTURE_SECTION).key,
                    type: (0, $9woaI.STRUCTURE_SECTION).type,
                    rank: (0, $am2Qg.STRUCTURE_SECTION_RANK)[(0, $9woaI.MENTION_MENU_ITEM).key]
                }
            ],
            isHidden: ()=>{
                var _api$mention$sharedSt;
                return (canOpenMentionTypeAhead === null || canOpenMentionTypeAhead === void 0 ? void 0 : canOpenMentionTypeAhead()) === false || (api === null || api === void 0 || (_api$mention$sharedSt = api.mention.sharedState.currentState()) === null || _api$mention$sharedSt === void 0 ? void 0 : _api$mention$sharedSt.canInsertMention) === false;
            },
            match: (0, $b8Hvx.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).mentionDescription),
                    keywords: [
                        'team',
                        'user'
                    ],
                    shortcut: '@',
                    title: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).mention)
                })),
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $gmngl.MentionQuickInsertMenuItem), {
                    api: api,
                    previewImageUrls: $6efd449167e17f34$var$previewImageUrls,
                    typeAhead: typeAhead
                })
        }
    ];

});
parcelRegister("gmngl", function(module, exports) {
$parcel$export(module.exports, "MentionQuickInsertMenuItem", () => $ab94f7af6f8b30bf$export$b5ce5c44bc35a327);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $cW1gB = parcelRequire("cW1gB");

var $fT9mF = parcelRequire("fT9mF");

var $64eKJ = parcelRequire("64eKJ");

var $73atK = parcelRequire("73atK");

var $cx9k0 = parcelRequire("cx9k0");
const $ab94f7af6f8b30bf$export$b5ce5c44bc35a327 = ({ api: api, previewImageUrls: previewImageUrls, typeAhead: typeAhead })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const preview = (0, $bSJIT.useMemo)(()=>previewImageUrls ? {
            image: previewImageUrls,
            attribution: {
                name: formatMessage((0, $64eKJ.messages).previewAttributionAtlassian)
            }
        } : undefined, [
        formatMessage,
        previewImageUrls
    ]);
    const onSelect = (0, $bSJIT.useCallback)(({ editorView: editorView, insert: insert })=>{
        var _mentionPluginKey$get, _api$typeAhead;
        if (((_mentionPluginKey$get = (0, $cx9k0.mentionPluginKey).getState(editorView.state)) === null || _mentionPluginKey$get === void 0 ? void 0 : _mentionPluginKey$get.canInsertMention) === false) return false;
        const tr = insert(undefined);
        const didOpen = api === null || api === void 0 || (_api$typeAhead = api.typeAhead) === null || _api$typeAhead === void 0 ? void 0 : _api$typeAhead.actions.openAtTransaction({
            triggerHandler: typeAhead,
            inputMethod: (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT
        })(tr);
        if (didOpen === false) return false;
        return tr;
    }, [
        api,
        typeAhead
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fT9mF.QuickInsertMenuItem), {
        description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).mentionDescription),
        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($73atK))), {
            label: ""
        }),
        onSelect: onSelect,
        preview: preview,
        shortcut: "@",
        title: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).mention)
    });
};

});


parcelRegister("dWgOU", function(module, exports) {
$parcel$export(module.exports, "SecondaryToolbarComponent", () => $d7b7a984e2da8573$export$124ea4367cf7d1fc);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5beht = parcelRequire("5beht");

var $6zGtP = parcelRequire("6zGtP");
const $d7b7a984e2da8573$var$selector = (states)=>{
    var _states$mentionState;
    return {
        mentionProvider: (_states$mentionState = states.mentionState) === null || _states$mentionState === void 0 ? void 0 : _states$mentionState.mentionProvider
    };
};
function $d7b7a984e2da8573$export$124ea4367cf7d1fc({ editorView: editorView, api: api, typeAhead: typeAhead, disabled: disabled }) {
    var _api$typeAhead2;
    const { mentionProvider: mentionProvider } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'mention'
    ], $d7b7a984e2da8573$var$selector);
    const openMentionTypeAhead = (0, $bSJIT.useCallback)(()=>{
        var _api$typeAhead;
        api === null || api === void 0 || (_api$typeAhead = api.typeAhead) === null || _api$typeAhead === void 0 || (_api$typeAhead = _api$typeAhead.actions) === null || _api$typeAhead === void 0 || _api$typeAhead.open({
            triggerHandler: typeAhead,
            inputMethod: (0, $g6Qq4.INPUT_METHOD).INSERT_MENU
        });
    }, [
        api,
        typeAhead
    ]);
    return !mentionProvider ? null : /*#__PURE__*/ (0, $dc70d.jsx)((0, $6zGtP.default), {
        editorView: editorView,
        onInsertMention: openMentionTypeAhead,
        isDisabled: disabled || (api === null || api === void 0 || (_api$typeAhead2 = api.typeAhead) === null || _api$typeAhead2 === void 0 ? void 0 : _api$typeAhead2.actions.isAllowed(editorView.state))
    });
}

});
parcelRegister("6zGtP", function(module, exports) {
$parcel$export(module.exports, "default", () => $840439df1f2d1732$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $bnf0l = parcelRequire("bnf0l");

var $6ny6f = parcelRequire("6ny6f");

var $8zO6u = parcelRequire("8zO6u");

var $73atK = parcelRequire("73atK");
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $840439df1f2d1732$var$ToolbarMention extends (0, $bSJIT.PureComponent) {
    render() {
        const mentionStringTranslated = this.props.intl.formatMessage((0, $6ny6f.mentionMessages).mentionsIconLabel);
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $8zO6u.default), {
            testId: this.props.testId,
            buttonId: (0, $bnf0l.TOOLBAR_ACTION_SUBJECT_ID).MENTION,
            spacing: "none",
            onClick: this.handleInsertMention,
            disabled: this.props.isDisabled,
            title: mentionStringTranslated + '@',
            iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($73atK))), {
                label: mentionStringTranslated
            })
        });
    }
    constructor(...args){
        super(...args), this.handleInsertMention = ()=>{
            if (!this.props.editorView) return false;
            this.props.onInsertMention();
            return true;
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $840439df1f2d1732$var$_default_1 = (0, $fK3tS.default)($840439df1f2d1732$var$ToolbarMention);
var $840439df1f2d1732$export$2e2bcd8739ae039 = $840439df1f2d1732$var$_default_1;

});


parcelRegister("2kTDz", function(module, exports) {
$parcel$export(module.exports, "createTypeAheadConfig", () => $1996d99741b48a42$export$90e81ee10e57772b);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $7RHfd = parcelRequire("7RHfd");

var $g6Qq4 = parcelRequire("g6Qq4");

var $dVt29 = parcelRequire("dVt29");

var $6ny6f = parcelRequire("6ny6f");

var $aaLLt = parcelRequire("aaLLt");

var $kW8qW = parcelRequire("kW8qW");

var $gab48 = parcelRequire("gab48");

var $1emO3 = parcelRequire("1emO3");

var $lyKnc = parcelRequire("lyKnc");

var $3OYlc = parcelRequire("3OYlc");

var $a06wU = parcelRequire("a06wU");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $ixBwV = parcelRequire("ixBwV");

var $5FBx9 = parcelRequire("5FBx9");

var $cx9k0 = parcelRequire("cx9k0");

var $bSKle = parcelRequire("bSKle");

var $a04WG = parcelRequire("a04WG");

var $6lU7m = parcelRequire("6lU7m");

var $dhEUP = parcelRequire("dhEUP");

var $3P2uE = parcelRequire("3P2uE");

var $16I1l = parcelRequire("16I1l");

var $3isrH = parcelRequire("3isrH");

var $dE7wH = parcelRequire("dE7wH");
const $1996d99741b48a42$var$isAgentTypeAheadItem = (item)=>item.mention ? (0, $dE7wH.isAgentMention)(item.mention) : false;
const $1996d99741b48a42$var$isAgentMentionLoadErrorEnabled = (mention)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_agent_mentions_rovo_query_timeout') && (0, $dE7wH.isAgentMentionLoadError)(mention);
const $1996d99741b48a42$var$isSearchOrderedAgentTypeAheadItem = (item)=>!!item.mention && (0, $dE7wH.isExplicitAgentMention)(item.mention);
const $1996d99741b48a42$var$isSearchOrderedPersonTypeAheadItem = (item)=>!!item.mention && !(0, $dE7wH.isInviteItem)(item.mention) && !(0, $dE7wH.isExplicitAgentMention)(item.mention) && !(0, $dE7wH.isBotOrTeamMention)(item.mention);
const $1996d99741b48a42$var$shouldApplyMentionSearchOrder = (query)=>query.trim().length > 0;
// A non-selectable loading placeholder injected by the provider (e.g.
// `RovoChatMentionResource`) while the slower agent source resolves. It
// renders as a skeleton row via `@atlaskit/mention`'s `MentionItem` and
// must never be inserted or counted in rendered-mention analytics.
const $1996d99741b48a42$var$isMentionPlaceholder = (mention)=>!!(mention !== null && mention !== void 0 && mention.isPlaceholder);
const $1996d99741b48a42$var$isLoadingPlaceholder = (mention)=>$1996d99741b48a42$var$isMentionPlaceholder(mention) && !$1996d99741b48a42$var$isAgentMentionLoadErrorEnabled(mention);
const $1996d99741b48a42$var$createInviteItem = ({ mentionProvider: mentionProvider, onInviteItemMount: onInviteItemMount, query: query, emailDomain: emailDomain })=>({
        title: (0, $6lU7m.INVITE_ITEM_DESCRIPTION).id,
        render: ({ isSelected: isSelected, onClick: onClick, onHover: onHover })=>{
            var _mentionProvider$getS;
            return emailDomain && (_mentionProvider$getS = mentionProvider.getShouldEnableInlineInvite) !== null && _mentionProvider$getS !== void 0 && _mentionProvider$getS.call(mentionProvider) && (0, $gdUUy.fg)('inline_invite_from_mentions_kill_switch') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $dhEUP.default), {
                productName: mentionProvider ? mentionProvider.productName : undefined,
                selected: isSelected,
                onMount: onInviteItemMount,
                onMouseEnter: onHover,
                onSelection: onClick,
                userRole: mentionProvider.userRole,
                query: query,
                emailDomain: emailDomain
            }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $6lU7m.default), {
                productName: mentionProvider ? mentionProvider.productName : undefined,
                selected: isSelected,
                onMount: onInviteItemMount,
                onMouseEnter: onHover,
                onSelection: onClick,
                userRole: mentionProvider.userRole
            });
        },
        mention: (0, $6lU7m.INVITE_ITEM_DESCRIPTION)
    });
const $1996d99741b48a42$var$withInviteItem = ({ mentionProvider: mentionProvider, firstQueryWithoutResults: firstQueryWithoutResults, currentQuery: currentQuery, onInviteItemMount: onInviteItemMount, emailDomain: emailDomain })=>(mentionItems)=>{
        const inviteItem = $1996d99741b48a42$var$createInviteItem({
            mentionProvider: mentionProvider,
            onInviteItemMount: onInviteItemMount,
            query: currentQuery,
            emailDomain: emailDomain
        });
        const keepInviteItem = (0, $dE7wH.shouldKeepInviteItem)(currentQuery, firstQueryWithoutResults);
        if (mentionItems.length === 0) return keepInviteItem ? [
            inviteItem
        ] : [];
        return [
            ...mentionItems,
            // invite item should be shown at the bottom
            inviteItem
        ];
    };
const $1996d99741b48a42$var$makeMentionToTypeaheadItem = ({ useRefreshedItemHeight: useRefreshedItemHeight, profilecardProvider: profilecardProvider })=>(mention)=>{
        const itemHeight = useRefreshedItemHeight ? (0, $a06wU.MENTION_ITEM_HEIGHT_REFRESHED) : (0, $a06wU.MENTION_ITEM_HEIGHT);
        if ($1996d99741b48a42$var$isAgentMentionLoadErrorEnabled(mention)) return {
            title: mention.id,
            render: ({ onClick: onClick })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $3P2uE.AgentMentionLoadErrorItem), {
                    onRetry: onClick
                }),
            getCustomComponentHeight: ()=>{
                return itemHeight;
            },
            mention: mention
        };
        if ($1996d99741b48a42$var$isLoadingPlaceholder(mention)) return {
            title: mention.id,
            isNonInteractive: true,
            render: ({ isSelected: isSelected, onClick: onClick })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $3isrH.MentionItemWithProfileCard), {
                    mention: mention,
                    selected: isSelected,
                    onSelection: onClick,
                    height: itemHeight,
                    profilecardProvider: profilecardProvider
                }),
            getCustomComponentHeight: ()=>{
                return itemHeight;
            },
            mention: mention
        };
        return {
            title: mention.id,
            render: ({ isSelected: isSelected, onClick: onClick, onHover: onHover })=>(0, $ixBwV.expVal)('platform_editor_agent_mentions', 'isEnabled', false) && (0, $gdUUy.fg)('platform_editor_mention_typeahead_profilecard') || (0, $gdUUy.fg)('platform_editor_agent_card_fixes') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $3isrH.MentionItemWithProfileCard), {
                    mention: mention,
                    selected: isSelected,
                    onSelection: onClick,
                    height: itemHeight,
                    profilecardProvider: profilecardProvider
                }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $3OYlc.default), {
                    mention: mention,
                    selected: isSelected,
                    onMouseEnter: onHover,
                    onSelection: onClick,
                    height: itemHeight
                }),
            getCustomComponentHeight: ()=>{
                return itemHeight;
            },
            mention: mention
        };
    };
const $1996d99741b48a42$export$f476360102d72b2 = (mention)=>$1996d99741b48a42$var$makeMentionToTypeaheadItem({
        useRefreshedItemHeight: (0, $ixBwV.expVal)('platform_editor_agent_mentions', 'isEnabled', false)
    })(mention);
function $1996d99741b48a42$export$fc10aeed3a532e2a(fn) {
    // Cache results here
    const seen = new Map();
    function memoized(mention) {
        // Check cache for hits
        const hit = seen.get(mention.id);
        if (hit) return hit;
        // Generate new result and cache it
        const result = fn(mention);
        seen.set(mention.id, result);
        return result;
    }
    return {
        call: memoized,
        clear: seen.clear.bind(seen)
    };
}
const $1996d99741b48a42$var$buildAndSendElementsTypeAheadAnalytics = (fireEvent)=>({ query: query, mentions: mentions, stats: stats, mentionTypeaheadSessionId: mentionTypeaheadSessionId, agentAnalytics: agentAnalytics })=>{
        let duration = 0;
        let userOrTeamIds = null;
        let teams = null;
        let xProductMentionsLength = 0;
        if (!(0, $dE7wH.isTeamStats)(stats)) {
            // is from primary mention endpoint which could be just user mentions or user/team mentions
            duration = stats && stats.duration;
            teams = null;
            userOrTeamIds = mentions.map((mention)=>mention.id);
            xProductMentionsLength = mentions.filter((mention)=>mention.isXProductUser).length;
        } else {
            // is from dedicated team-only mention endpoint
            duration = stats && stats.teamMentionDuration;
            userOrTeamIds = null;
            teams = mentions.map((mention)=>(0, $dE7wH.isTeamType)(mention.userType) ? {
                    teamId: mention.id,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    includesYou: mention.context.includesYou,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    memberCount: mention.context.memberCount
                } : null).filter((m)=>!!m);
        }
        const payload = (0, $16I1l.buildTypeAheadRenderedPayload)(duration, userOrTeamIds, query, teams, xProductMentionsLength, mentionTypeaheadSessionId, agentAnalytics);
        fireEvent(payload, 'fabric-elements');
    };
/**
 * When a team mention is selected, we render a team link and list of member/user mentions
 * in editor content
 */ const $1996d99741b48a42$var$buildNodesForTeamMention = (schema, selectedMention, mentionProvider, sanitizePrivateContent)=>{
    const { nodes: nodes, marks: marks } = schema;
    const { name: name, id: teamId, accessLevel: accessLevel, context: context } = selectedMention;
    // build team link
    const defaultTeamLink = `${window.location.origin}/people/team/${teamId}`;
    const teamLink = context && context.teamLink ? context.teamLink : defaultTeamLink;
    const teamLinkNode = (0, $gdUUy.fg)('team-mention-inline-smartlink') ? schema.nodes.inlineCard.create({
        url: teamLink
    }) : // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    schema.text(name, [
        marks.link.create({
            href: teamLink
        })
    ]);
    const openBracketText = schema.text('(');
    const closeBracketText = schema.text(')');
    const emptySpaceText = schema.text(' ');
    const inlineNodes = [
        teamLinkNode,
        emptySpaceText,
        openBracketText
    ];
    const members = context && context.members ? context.members : [];
    members.forEach((member, index)=>{
        const { name: name, id: id } = member;
        const mentionName = `@${name}`;
        const text = sanitizePrivateContent ? '' : mentionName;
        if (sanitizePrivateContent && (0, $lyKnc.isResolvingMentionProvider)(mentionProvider)) mentionProvider.cacheMentionName(id, name);
        const userMentionNode = nodes.mention.createChecked({
            text: text,
            id: member.id,
            accessLevel: accessLevel,
            userType: 'DEFAULT',
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            localId: (0, $7RHfd.default)()
        });
        inlineNodes.push(userMentionNode);
        // should not add empty space after the last user mention.
        if (index !== members.length - 1) inlineNodes.push(emptySpaceText);
    });
    inlineNodes.push(closeBracketText);
    return (0, $kW8qW.Fragment).fromArray(inlineNodes);
};
/**
 * Shared mentions → typeahead-items transformer used by both the
 * single-shot `getItems` Promise path and the multi-emit
 * `subscribeToItemsUpdates` path. Factoring this out avoids any
 * chance the two paths drift in subtle item-shape behaviour (invite
 * item injection, analytics emission, no-results bookkeeping).
 *
 * NOTE: `firstQueryWithoutResults` is captured by closure in
 * `createTypeAheadConfig` and intentionally mutated here as a
 * side-effect — preserves the existing single-shot semantics.
 */ const $1996d99741b48a42$var$makeTransformMentionsToTypeAheadItems = ({ fireEvent: fireEvent, getFirstQueryWithoutResults: getFirstQueryWithoutResults, setFirstQueryWithoutResults: setFirstQueryWithoutResults, hasFiredInviteItemViewed: hasFiredInviteItemViewed, markInviteItemViewed: markInviteItemViewed, toItem: toItem, enableAgentSectioning: enableAgentSectioning })=>{
    return ({ mentions: mentions, query: query, stats: stats, mentionProvider: mentionProvider, contextIdentifierProvider: contextIdentifierProvider, sessionId: sessionId })=>{
        const displayMentions = $1996d99741b48a42$var$shouldApplyMentionSearchOrder(query) ? (0, $dE7wH.orderMentionsForDisplay)(mentions) : mentions;
        const mentionItems = displayMentions.map((mention)=>toItem(mention));
        // Provider placeholders stay in `mentionItems` so loading/error rows render,
        // but they are not real mention results for analytics or agent counts.
        const realMentions = displayMentions.filter((mention)=>!$1996d99741b48a42$var$isMentionPlaceholder(mention));
        const agentCount = realMentions.filter((0, $dE7wH.isAgentMention)).length;
        const agentAnalytics = {
            agentCount: agentCount,
            agentSectioningEnabled: enableAgentSectioning
        };
        $1996d99741b48a42$var$buildAndSendElementsTypeAheadAnalytics(fireEvent)({
            query: query,
            mentions: realMentions,
            stats: stats,
            mentionTypeaheadSessionId: sessionId,
            agentAnalytics: agentAnalytics
        });
        // While a loading placeholder is present the result set isn't settled yet
        // (e.g. agents still resolving) — don't record this query as "no results",
        // or a later emission that arrives with results would be ignored.
        if (realMentions.length === 0 && !mentions.some($1996d99741b48a42$var$isLoadingPlaceholder) && getFirstQueryWithoutResults() === null) setFirstQueryWithoutResults(query);
        if (!mentionProvider.shouldEnableInvite || mentionItems.length > 2) return mentionItems;
        const emailDomain = mentionProvider.userEmailDomain;
        return $1996d99741b48a42$var$withInviteItem({
            mentionProvider: mentionProvider,
            firstQueryWithoutResults: getFirstQueryWithoutResults() || '',
            currentQuery: query,
            onInviteItemMount: ()=>{
                var _mentionProvider$getS2;
                if ((0, $gdUUy.fg)('inline_invite_from_mentions_kill_switch')) {
                    if (hasFiredInviteItemViewed()) return;
                    markInviteItemViewed();
                }
                fireEvent((0, $16I1l.buildTypeAheadInviteItemViewedPayload)(sessionId, contextIdentifierProvider, mentionProvider.userRole, (0, $gdUUy.fg)('inline_invite_from_mentions_kill_switch') ? {
                    isInlineInviteMentionsEnabled: (_mentionProvider$getS2 = mentionProvider.getShouldEnableInlineInvite) === null || _mentionProvider$getS2 === void 0 ? void 0 : _mentionProvider$getS2.call(mentionProvider)
                } : {}));
            },
            emailDomain: emailDomain
        })(mentionItems);
    };
};
const $1996d99741b48a42$export$90e81ee10e57772b = ({ canOpenTypeAhead: canOpenTypeAhead, sanitizePrivateContent: sanitizePrivateContent, mentionInsertDisplayName: mentionInsertDisplayName, fireEvent: fireEvent, HighlightComponent: HighlightComponent, api: api, handleMentionsChanged: handleMentionsChanged, enableAgentSectioning: enableAgentSectioning = false, showAgentMentionsLabsLozenge: showAgentMentionsLabsLozenge = false, profilecardProvider: profilecardProvider })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    let sessionId = (0, $7RHfd.default)();
    let firstQueryWithoutResults = null;
    let lastTypeAheadQuery = '';
    let hasFiredInviteItemViewed = false;
    const subscriptionKeys = new Set();
    const transformMentionsToTypeAheadItems = $1996d99741b48a42$var$makeTransformMentionsToTypeAheadItems({
        enableAgentSectioning: enableAgentSectioning,
        fireEvent: fireEvent,
        getFirstQueryWithoutResults: ()=>firstQueryWithoutResults,
        setFirstQueryWithoutResults: (query)=>{
            firstQueryWithoutResults = query;
        },
        hasFiredInviteItemViewed: ()=>hasFiredInviteItemViewed,
        markInviteItemViewed: ()=>{
            hasFiredInviteItemViewed = true;
        },
        toItem: $1996d99741b48a42$export$fc10aeed3a532e2a($1996d99741b48a42$var$makeMentionToTypeaheadItem({
            useRefreshedItemHeight: enableAgentSectioning,
            profilecardProvider: profilecardProvider
        })).call
    });
    const typeAhead = {
        canOpen: canOpenTypeAhead,
        id: (0, $aaLLt.TypeAheadAvailableNodes).MENTION,
        trigger: '@',
        // Custom regex must have a capture group around trigger
        // so it's possible to use it without needing to scan through all triggers again
        customRegex: '\\(?(@)',
        getHighlight: (_state)=>{
            const CustomHighlightComponent = HighlightComponent;
            if (CustomHighlightComponent) return /*#__PURE__*/ (0, $dc70d.jsx)(CustomHighlightComponent, {});
            return null;
        },
        getItems ({ query: query, editorState: editorState }) {
            var _api$contextIdentifie;
            lastTypeAheadQuery = query || '';
            const pluginState = (0, $a04WG.getMentionPluginState)(editorState);
            if (!(pluginState !== null && pluginState !== void 0 && pluginState.mentionProvider)) return Promise.resolve([]);
            const { mentionProvider: mentionProvider } = pluginState;
            const { contextIdentifierProvider: contextIdentifierProvider } = (api === null || api === void 0 || (_api$contextIdentifie = api.contextIdentifier) === null || _api$contextIdentifie === void 0 ? void 0 : _api$contextIdentifie.sharedState.currentState()) ?? {};
            return new Promise((resolve, reject)=>{
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                const key = `loadingMentionsForTypeAhead_${(0, $7RHfd.default)()}`;
                const mentionsSubscribeCallback = (mentions, resultQuery = '', stats)=>{
                    if (query !== resultQuery) return;
                    mentionProvider.unsubscribe(key);
                    subscriptionKeys.delete(key);
                    const items = transformMentionsToTypeAheadItems({
                        mentions: mentions,
                        query: query,
                        stats: stats,
                        mentionProvider: mentionProvider,
                        contextIdentifierProvider: contextIdentifierProvider,
                        sessionId: sessionId
                    });
                    resolve(items);
                };
                subscriptionKeys.add(key);
                mentionProvider.subscribe(key, mentionsSubscribeCallback, ()=>{
                    mentionProvider.unsubscribe(key);
                    subscriptionKeys.delete(key);
                    reject('FETCH_ERROR');
                });
                mentionProvider.filter(query || '', {
                    ...contextIdentifierProvider,
                    sessionId: sessionId
                });
            });
        },
        getSections ({ intl: intl }) {
            if (!enableAgentSectioning) return [];
            const applySearchOrder = $1996d99741b48a42$var$shouldApplyMentionSearchOrder(lastTypeAheadQuery);
            return [
                {
                    id: 'people',
                    title: intl.formatMessage((0, $6ny6f.mentionMessages).typeAheadSectionPeople),
                    filter: applySearchOrder ? $1996d99741b48a42$var$isSearchOrderedPersonTypeAheadItem : (item)=>{
                        if ($1996d99741b48a42$var$isAgentTypeAheadItem(item)) return false;
                        // Keep the invite ("Add teammate") row out of the people section so no
                        // section claims it. `buildSectionedResult` then appends it after every
                        // section, placing it below the agent results instead of above them, so the
                        // first highlighted option is an agent you can pick with Enter.
                        if (item.mention && (0, $dE7wH.isInviteItem)(item.mention) && (0, $gdUUy.fg)('platform_editor_agent_mentions_invite_order')) return false;
                        return true;
                    },
                    limit: 5,
                    sectionTitleDisplay: {
                        showWhenQueryPresent: false,
                        showWhenOnlySection: true
                    }
                },
                {
                    id: 'agents',
                    title: intl.formatMessage((0, $6ny6f.mentionMessages).typeAheadSectionAgents),
                    filter: applySearchOrder ? $1996d99741b48a42$var$isSearchOrderedAgentTypeAheadItem : $1996d99741b48a42$var$isAgentTypeAheadItem,
                    limit: 5,
                    sectionTitleDisplay: {
                        showWhenQueryPresent: false,
                        showWhenOnlySection: true
                    },
                    lozenge: !(0, $gdUUy.fg)('platform_editor_agent_mentions_hide_labs_lozenge') && (!(0, $gdUUy.fg)('platform_editor_agent_mentions_drop_one_fixes') || showAgentMentionsLabsLozenge) ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $1emO3.default), {
                        appearance: "discovery",
                        children: intl.formatMessage((0, $6ny6f.mentionMessages).typeAheadSectionAgentsLabsLozengeLabel)
                    }) : null
                }
            ];
        },
        onOpen: ()=>{
            firstQueryWithoutResults = null;
            lastTypeAheadQuery = '';
            hasFiredInviteItemViewed = false;
        },
        selectItem (state, item, insert, { mode: mode, stats: stats, query: query, sourceListItem: sourceListItem }) {
            var _api$contextIdentifie2;
            const { schema: schema } = state;
            // Placeholder isn't selectable. Return `false` (not a transaction) so
            // the runtime keeps the dropdown open; a transaction would close it.
            if ($1996d99741b48a42$var$isLoadingPlaceholder(item.mention)) return false;
            const pluginState = (0, $a04WG.getMentionPluginState)(state);
            const { mentionProvider: mentionProvider } = pluginState;
            const { contextIdentifierProvider: contextIdentifierProvider } = (api === null || api === void 0 || (_api$contextIdentifie2 = api.contextIdentifier) === null || _api$contextIdentifie2 === void 0 ? void 0 : _api$contextIdentifie2.sharedState.currentState()) ?? {};
            const mentionContext = {
                ...contextIdentifierProvider,
                sessionId: sessionId
            };
            if ($1996d99741b48a42$var$isAgentMentionLoadErrorEnabled(item.mention)) {
                mentionProvider === null || mentionProvider === void 0 || mentionProvider.filter(query || '', mentionContext);
                return false;
            }
            const { id: id, name: name, nickname: nickname, accessLevel: accessLevel, userType: userType, isXProductUser: isXProductUser } = item.mention;
            const isAgentMentionSelection = (0, $dE7wH.isAgentMention)(item.mention);
            const isAgentMentionInsertion = isAgentMentionSelection && (0, $ixBwV.expVal)('platform_editor_agent_mentions', 'isEnabled', false);
            // userType can be missing for provider-only agent mentions. Copy/paste cannot
            // see appType, so persist APP only when there is no explicit userType.
            const persistedUserType = isAgentMentionInsertion && userType == null ? 'APP' : userType;
            if (mentionProvider && !(0, $dE7wH.isInviteItem)(item.mention)) mentionProvider.recordMentionSelection(item.mention, mentionContext);
            // use same timer as StatsModifier
            const pickerElapsedTime = stats.startedAt ? performance.now() - stats.startedAt : 0;
            if (mentionProvider && mentionProvider.shouldEnableInvite && (0, $dE7wH.isInviteItem)(item.mention)) {
                // Don't fire event and the callback with selection by space press
                if (mode !== 'space') {
                    var _mentionProvider$getS3, _mentionProvider$getS4;
                    fireEvent((0, $16I1l.buildTypeAheadInviteItemClickedPayload)(pickerElapsedTime, stats.keyCount.arrowUp, stats.keyCount.arrowDown, sessionId, mode, query, contextIdentifierProvider, mentionProvider.userRole, (0, $gdUUy.fg)('inline_invite_from_mentions_kill_switch') ? {
                        isInlineInviteMentionsEnabled: (_mentionProvider$getS3 = mentionProvider.getShouldEnableInlineInvite) === null || _mentionProvider$getS3 === void 0 ? void 0 : _mentionProvider$getS3.call(mentionProvider)
                    } : {}));
                    if ((_mentionProvider$getS4 = mentionProvider.getShouldEnableInlineInvite) !== null && _mentionProvider$getS4 !== void 0 && _mentionProvider$getS4.call(mentionProvider) && (0, $gdUUy.fg)('inline_invite_from_mentions_kill_switch')) {
                        // Get the email from query, using the same logic as InviteItemWithEmailDomain
                        const emailDomain = mentionProvider.userEmailDomain;
                        let email = query || '';
                        // If query doesn't include @ and we have an email domain, append it
                        if (email && !email.includes('@') && emailDomain) email = `${email.toLowerCase()}@${emailDomain}`;
                        // If query already includes @, use it as is
                        if (email && mentionProvider.showInlineInvitePopup) {
                            const pendingLocalId = crypto.randomUUID();
                            const tr = insert((0, $5FBx9.createSingleMentionFragment)({
                                mentionProvider: mentionProvider,
                                mentionInsertDisplayName: mentionInsertDisplayName,
                                tr: state.tr,
                                sanitizePrivateContent: sanitizePrivateContent
                            })({
                                name: email,
                                id: pendingLocalId,
                                userType: 'DEFAULT',
                                localId: pendingLocalId,
                                accessLevel: 'CONTAINER'
                            }));
                            mentionProvider.showInlineInvitePopup(email, pendingLocalId);
                            return tr;
                        }
                    } else if (mentionProvider.onInviteItemClick) // Fallback to old behavior for backward compatibility
                    mentionProvider.onInviteItemClick('mention');
                }
                return state.tr;
            }
            let taskListId, taskItemId;
            const taskList = (0, $gab48.findParentNodeOfType)(state.schema.nodes.taskList)(state.selection);
            if (taskList) {
                taskListId = taskList.node.attrs.localId;
                const taskItem = (0, $gab48.findParentNodeOfType)(state.schema.nodes.taskItem)(state.selection);
                if (taskItem) taskItemId = taskItem.node.attrs.localId;
            }
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const mentionLocalId = (0, $7RHfd.default)();
            if (handleMentionsChanged) {
                const mentionChange = {
                    id: id,
                    localId: mentionLocalId,
                    method: 'typed',
                    type: 'added',
                    ...isAgentMentionInsertion ? {
                        shouldSuppressMentionNotification: true
                    } : {}
                };
                if (taskItemId) handleMentionsChanged([
                    {
                        ...mentionChange,
                        taskLocalId: taskItemId
                    }
                ]);
                else handleMentionsChanged([
                    mentionChange
                ]);
            }
            fireEvent((0, $16I1l.buildTypeAheadInsertedPayload)(pickerElapsedTime, stats.keyCount.arrowUp, stats.keyCount.arrowDown, sessionId, mode, item.mention, mentionLocalId, sourceListItem.map((x)=>x.mention), query, contextIdentifierProvider, taskListId, taskItemId, isAgentMentionSelection, enableAgentSectioning));
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            sessionId = (0, $7RHfd.default)();
            if (mentionProvider && (0, $dE7wH.isTeamType)(userType)) {
                const teamMentionTr = insert($1996d99741b48a42$var$buildNodesForTeamMention(schema, item.mention, mentionProvider, sanitizePrivateContent));
                if ((0, $gdUUy.fg)('platform_editor_team_mention_link_analytics')) return (0, $dVt29.addLinkMetadata)(state.selection, teamMentionTr, {
                    action: (0, $g6Qq4.ACTION).INSERTED,
                    inputMethod: (0, $g6Qq4.INPUT_METHOD).MENTION_TYPEAHEAD
                });
                return teamMentionTr;
            }
            if (!isAgentMentionInsertion && isXProductUser && mentionProvider && mentionProvider.inviteXProductUser) mentionProvider.inviteXProductUser(id, name);
            const tr = insert((0, $5FBx9.createSingleMentionFragment)({
                mentionProvider: mentionProvider,
                mentionInsertDisplayName: mentionInsertDisplayName,
                tr: state.tr,
                sanitizePrivateContent: sanitizePrivateContent,
                suppressInviteXProductUser: isAgentMentionInsertion
            })({
                name: name,
                id: id,
                userType: persistedUserType,
                nickname: nickname,
                localId: mentionLocalId,
                accessLevel: accessLevel,
                isXProductUser: isXProductUser
            }));
            if (isAgentMentionInsertion) {
                tr.setMeta((0, $cx9k0.mentionPluginKey), {
                    action: (0, $bSKle.ACTIONS).SET_PENDING_TYPED_AGENT_MENTION,
                    params: {
                        localId: mentionLocalId,
                        name: name
                    }
                });
                // Cache the agent name so pasted mentions (where attrs.text is stripped)
                // can recover it synchronously via resolveMentionName() cache hit.
                if (name && mentionProvider && (0, $lyKnc.isResolvingMentionProvider)(mentionProvider) && (0, $gdUUy.fg)('platform_editor_agent_mentions_drop_one_fixes')) mentionProvider.cacheMentionName(id, name);
            }
            return tr;
        },
        dismiss ({ editorState: editorState, query: query, stats: stats, wasItemInserted: wasItemInserted }) {
            firstQueryWithoutResults = null;
            hasFiredInviteItemViewed = false;
            const pickerElapsedTime = stats.startedAt ? performance.now() - stats.startedAt : 0;
            if (!wasItemInserted) fireEvent((0, $16I1l.buildTypeAheadCancelPayload)(pickerElapsedTime, stats.keyCount.arrowUp, stats.keyCount.arrowDown, sessionId, query || ''), 'fabric-elements');
            const pluginState = (0, $a04WG.getMentionPluginState)(editorState);
            if (pluginState !== null && pluginState !== void 0 && pluginState.mentionProvider) {
                const mentionProvider = pluginState.mentionProvider;
                for (const key of subscriptionKeys)mentionProvider.unsubscribe(key);
            }
            subscriptionKeys.clear();
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            sessionId = (0, $7RHfd.default)();
        }
    };
    /**
   * Opt-in multi-emit path. Subscribes to the provider's stream of
   * results for the lifetime of the type-ahead session — does NOT
   * unsubscribe after the first emission. Lets providers like
   * `RovoChatMentionResource` deliver people-first then merged
   * people + agents to the dropdown without the typeahead dropping
   * the second emission on the floor.
   *
   * Gated behind the `rovo_chat_mention_agents` experiment (the same control
   * that drives
   * agent mentions in the Rovo chat input). The generic type-ahead hook
   * opts a handler into streaming purely by the presence of this method,
   * so we only attach it when the gate is on — otherwise the proven
   * single-shot `getItems` path continues to drive every consumer.
   */ const subscribeToItemsUpdates = ({ query: query, editorState: editorState })=>{
        var _api$contextIdentifie3;
        lastTypeAheadQuery = query || '';
        const pluginState = (0, $a04WG.getMentionPluginState)(editorState);
        if (!(pluginState !== null && pluginState !== void 0 && pluginState.mentionProvider)) return {
            initial: Promise.resolve([]),
            subscribe: ()=>()=>{}
        };
        const { mentionProvider: mentionProvider } = pluginState;
        const { contextIdentifierProvider: contextIdentifierProvider } = (api === null || api === void 0 || (_api$contextIdentifie3 = api.contextIdentifier) === null || _api$contextIdentifie3 === void 0 ? void 0 : _api$contextIdentifie3.sharedState.currentState()) ?? {};
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const key = `loadingMentionsForTypeAhead_${(0, $7RHfd.default)()}`;
        let initialResolve = null;
        let initialReject = null;
        let initialResolved = false;
        let updateCallback = null;
        let pendingUpdate = null;
        let unsubscribed = false;
        const initial = new Promise((resolve, reject)=>{
            initialResolve = resolve;
            initialReject = reject;
        });
        const mentionsSubscribeCallback = (mentions, resultQuery = '', stats)=>{
            // Drop emissions tagged with a query that has moved on.
            // Mirrors the same guard in the single-shot `getItems`.
            if (query !== resultQuery) return;
            if (unsubscribed) return;
            const items = transformMentionsToTypeAheadItems({
                mentions: mentions,
                query: query,
                stats: stats,
                mentionProvider: mentionProvider,
                contextIdentifierProvider: contextIdentifierProvider,
                sessionId: sessionId
            });
            if (!initialResolved) {
                var _initialResolve;
                initialResolved = true;
                (_initialResolve = initialResolve) === null || _initialResolve === void 0 || _initialResolve(items);
            } else if (enableAgentSectioning && !updateCallback) // Agent Studio can resolve before the typeahead installs its update subscriber.
            pendingUpdate = items;
            else {
                var _updateCallback;
                (_updateCallback = updateCallback) === null || _updateCallback === void 0 || _updateCallback(items);
            }
        };
        subscriptionKeys.add(key);
        mentionProvider.subscribe(key, mentionsSubscribeCallback, ()=>{
            mentionProvider.unsubscribe(key);
            subscriptionKeys.delete(key);
            if (!initialResolved) {
                var _initialReject;
                initialResolved = true;
                (_initialReject = initialReject) === null || _initialReject === void 0 || _initialReject('FETCH_ERROR');
            }
        });
        mentionProvider.filter(query || '', {
            ...contextIdentifierProvider,
            sessionId: sessionId
        });
        return {
            initial: initial,
            subscribe: (update)=>{
                if (updateCallback) throw new Error('TypeAhead mention updates support only one subscriber');
                updateCallback = update;
                if (enableAgentSectioning && pendingUpdate) {
                    updateCallback(pendingUpdate);
                    pendingUpdate = null;
                }
                return ()=>{
                    unsubscribed = true;
                    updateCallback = null;
                    pendingUpdate = null;
                    mentionProvider.unsubscribe(key);
                    subscriptionKeys.delete(key);
                    // If cleanup runs before the first emission, settle the initial
                    // promise so its `.then` chain (and the closures it holds) is
                    // released instead of pending forever.
                    if (!initialResolved) {
                        var _initialResolve2;
                        initialResolved = true;
                        (_initialResolve2 = initialResolve) === null || _initialResolve2 === void 0 || _initialResolve2([]);
                    }
                };
            }
        };
    };
    if (enableAgentSectioning) typeAhead.subscribeToItemsUpdates = subscribeToItemsUpdates;
    // Presence of `subscribeToItemsUpdates` is how the type-ahead hook
    // opts a handler into the multi-emit path, so only expose it when the
    // agent-mentions experiment is enabled.
    if ((0, $3y2s4.isExperimentEnabled)('rovo_chat_mention_agents')) typeAhead.subscribeToItemsUpdates = subscribeToItemsUpdates;
    return typeAhead;
};

});
parcelRegister("3OYlc", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb45f03b56405d15$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $68E0O = parcelRequire("68E0O");

var $1emO3 = parcelRequire("1emO3");

var $gdUUy = parcelRequire("gdUUy");

var $h3R7U = parcelRequire("h3R7U");

var $5N1Y4 = parcelRequire("5N1Y4");

var $jzgg8 = parcelRequire("jzgg8");

var $4codo = parcelRequire("4codo");

var $a6LHe = parcelRequire("a6LHe");

var $2GnIo = parcelRequire("2GnIo");

var $e8IHj = parcelRequire("e8IHj");

var $1JAAW = parcelRequire("1JAAW");

var $7RWOe = parcelRequire("7RWOe");

var $5Xh9u = parcelRequire("5Xh9u");

var $cER38 = parcelRequire("cER38");

var $4jP1c = parcelRequire("4jP1c");

var $a06wU = parcelRequire("a06wU");

// Lazy-loaded so `@atlaskit/skeleton` (only needed for the loading
// placeholder) doesn't enter the bundle for every `@atlaskit/mention`
// consumer — only when an `isPlaceholder` mention is actually rendered.
const $cb45f03b56405d15$var$MentionItemPlaceholder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).lazy(()=>(parcelRequire("2VwLB")));
const $cb45f03b56405d15$var$lozengeAppearanceToTagColor = {
    default: 'standard',
    success: 'lime',
    removed: 'red',
    inprogress: 'blue',
    new: 'purple',
    moved: 'orange'
};
function $cb45f03b56405d15$var$renderTag(lozenge) {
    if (typeof lozenge === 'string') return /*#__PURE__*/ (0, $dc70d.jsx)((0, $h3R7U.default), {
        text: lozenge,
        color: "standard",
        isRemovable: false,
        migration_fallback: "lozenge"
    });
    if (typeof lozenge === 'object') {
        const { appearance: appearance, text: text } = lozenge;
        const color = appearance ? $cb45f03b56405d15$var$lozengeAppearanceToTagColor[appearance] : 'standard';
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $h3R7U.default), {
            text: text,
            color: color,
            isRemovable: false,
            migration_fallback: "lozenge"
        });
    }
    return null;
}
function $cb45f03b56405d15$var$renderLozenge(lozenge) {
    if (typeof lozenge === 'string') return /*#__PURE__*/ (0, $dc70d.jsx)((0, $1emO3.default), {
        children: lozenge
    });
    if (typeof lozenge === 'object') {
        const { appearance: appearance, text: text } = lozenge;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $1emO3.default), {
            appearance: appearance,
            children: text
        });
    }
    return null;
}
function $cb45f03b56405d15$var$renderTime(time) {
    if (time) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $a06wU.TimeStyle), {
        children: time
    });
    return null;
}
class $cb45f03b56405d15$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    render() {
        const { mention: mention, selected: selected, forwardedRef: forwardedRef, height: height } = this.props;
        const { id: id, highlight: highlight, presence: presence, name: name, mentionName: mentionName, lozenge: lozenge, accessLevel: accessLevel, isXProductUser: isXProductUser } = mention;
        if (mention.isPlaceholder) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5Xh9u.default), {
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Suspense, {
                fallback: /*#__PURE__*/ (0, $dc70d.jsx)((0, $a06wU.MentionItemStyle), {
                    height: height,
                    "aria-hidden": true
                }),
                children: /*#__PURE__*/ (0, $dc70d.jsx)($cb45f03b56405d15$var$MentionItemPlaceholder, {
                    height: height,
                    forwardedRef: forwardedRef,
                    id: id
                })
            })
        });
        const { time: time } = presence || {};
        const restricted = (0, $4codo.isRestricted)(accessLevel);
        const nameHighlights = highlight && highlight.name;
        const xProductUserInfoIconColor = selected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)";
        let RowStyle = (0, $a06wU.RowStyle);
        let isAgent = false;
        if ((0, $5N1Y4.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $gdUUy.fg)('platform_editor_agent_mentions_drop_one_fixes')) {
            RowStyle = (0, $a06wU.RowStyleNext);
            isAgent = (0, $jzgg8.isAgentMention)(mention);
        }
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5Xh9u.default), {
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $a06wU.MentionItemStyle), {
                selected: selected,
                height: height,
                onMouseDown: this.onMentionSelected,
                onMouseMove: this.onMentionMenuItemMouseMove,
                onMouseEnter: this.onMentionMenuItemMouseEnter,
                "data-mention-item": true,
                "data-testid": `mention-item-${id}`,
                "data-mention-id": id,
                "data-mention-name": mentionName,
                "data-mention-is-agent": isAgent ? 'true' : undefined,
                "data-selected": selected,
                ref: forwardedRef,
                children: /*#__PURE__*/ (0, $dc70d.jsxs)(RowStyle, {
                    children: [
                        /*#__PURE__*/ (0, $dc70d.jsx)((0, $a06wU.AvatarStyle), {
                            restricted: restricted,
                            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $1JAAW.MentionAvatar), {
                                selected: selected,
                                mention: mention
                            })
                        }),
                        /*#__PURE__*/ (0, $dc70d.jsxs)((0, $a06wU.NameSectionStyle), {
                            restricted: restricted,
                            children: [
                                (0, $4jP1c.renderHighlight)((0, $a06wU.FullNameStyle), name, nameHighlights),
                                /*#__PURE__*/ (0, $dc70d.jsx)((0, $7RWOe.default), {
                                    mention: mention
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $dc70d.jsxs)((0, $a06wU.InfoSectionStyle), {
                            restricted: restricted,
                            children: [
                                (0, $gdUUy.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? $cb45f03b56405d15$var$renderTag(lozenge) : $cb45f03b56405d15$var$renderLozenge(lozenge),
                                $cb45f03b56405d15$var$renderTime(time)
                            ]
                        }),
                        restricted ? /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Suspense, {
                            fallback: null,
                            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cER38.default), {
                                name: name,
                                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $a06wU.AccessSectionStyle), {
                                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $a6LHe.NoAccessLabel), {
                                        children: (text)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $e8IHj.default), {
                                                label: text
                                            })
                                    })
                                })
                            })
                        }) : null,
                        isXProductUser && /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($68E0O))), {
                            color: xProductUserInfoIconColor,
                            label: ''
                        })
                    ]
                })
            })
        });
    }
    constructor(...args){
        super(...args), // internal, used for callbacks
        this.onMentionSelected = (event)=>{
            if ((0, $2GnIo.leftClick)(event) && this.props.onSelection) {
                event.preventDefault();
                this.props.onSelection(this.props.mention, event);
            }
        }, this.onMentionMenuItemMouseMove = (event)=>{
            if (this.props.onMouseMove) this.props.onMouseMove(this.props.mention, event);
        }, this.onMentionMenuItemMouseEnter = (event)=>{
            if (this.props.onMouseEnter) this.props.onMouseEnter(this.props.mention, event);
        };
    }
}
const $cb45f03b56405d15$export$604dabd552e94336 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)($cb45f03b56405d15$export$2e2bcd8739ae039, {
        ...props,
        forwardedRef: ref
    });
});

});
parcelRegister("jzgg8", function(module, exports) {
$parcel$export(module.exports, "isAgentMention", () => $f10aecf99653f5a4$export$374d169f8869a22b);

var $eBfRL = parcelRequire("eBfRL");
function $f10aecf99653f5a4$export$374d169f8869a22b(mention) {
    // Like `isAgentTypeAheadItem` in `editor-plugin-mentions/src/ui/type-ahead/index.tsx`
    // and `isAgentUserType` in `editor-plugin-mentions/src/pm-plugins/agent.ts`
    return mention.userType === (0, $eBfRL.UserType)[(0, $eBfRL.UserType).APP] || mention.userType === 'AGENT' || mention.appType === 'agent';
}

});

parcelRegister("2GnIo", function(module, exports) {
$parcel$export(module.exports, "leftClick", () => $b441fcbeb7f118b3$export$34ebdaf2c517ae75);
function $b441fcbeb7f118b3$export$34ebdaf2c517ae75(event) {
    return event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
}

});

parcelRegister("e8IHj", function(module, exports) {
$parcel$export(module.exports, "default", () => $e27c3a7e50e02da7$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

const $e27c3a7e50e02da7$var$AsyncLockCircleIcon = /*#__PURE__*/ (0, $bSJIT.lazy)(()=>Promise.resolve((parcelRequire("5FomD"))).then((module)=>({
            default: module.default
        })));
var $e27c3a7e50e02da7$export$2e2bcd8739ae039 = $e27c3a7e50e02da7$var$AsyncLockCircleIcon;

});

parcelRegister("1JAAW", function(module, exports) {
$parcel$export(module.exports, "MentionAvatar", () => $0f80d1a8d6abb645$export$35f495c0dc0a1015);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $JD7lD = parcelRequire("JD7lD");

var $7pibM = parcelRequire("7pibM");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $h9peu = parcelRequire("h9peu");

var $8oXJq = parcelRequire("8oXJq");

var $fSgGg = parcelRequire("fSgGg");
const $0f80d1a8d6abb645$export$35f495c0dc0a1015 = ({ mention: mention, selected: selected })=>{
    const { appType: appType, avatarUrl: avatarUrl, presence: presence } = mention;
    const borderColor = selected ? "var(--ds-border, #0B120E24)" : undefined;
    const { status: status } = presence || {};
    if ((0, $fSgGg.isTeamMention)(mention)) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $h9peu.default), {
        src: avatarUrl,
        size: "medium",
        borderColor: borderColor
    });
    // Agent providers can request GraphQL `identityAccount { picture }` and pass it as
    // `avatarUrl`; this component only applies the hexagon agent shape.
    const shouldRenderAgentMentionAvatar = (0, $8oXJq.isAppMention)(mention) && mention.appType === 'agent' && (0, $3y2s4.isExperimentEnabled)('rovo_chat_mention_agents');
    const avatarAppearance = shouldRenderAgentMentionAvatar ? 'hexagon' : (0, $gdUUy.fg)('jira_ai_agent_avatar_issue_view_comment_mentions') ? (0, $7pibM.default)(appType) : undefined;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $JD7lD.default), {
        src: avatarUrl,
        size: "medium",
        presence: status,
        borderColor: borderColor,
        appearance: avatarAppearance
    });
};

});
parcelRegister("8oXJq", function(module, exports) {
$parcel$export(module.exports, "isAppMention", () => $eb3e3913486b816e$export$eb590c844d13454c);

var $eBfRL = parcelRequire("eBfRL");
function $eb3e3913486b816e$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === (0, $eBfRL.UserType)[(0, $eBfRL.UserType).APP];
}

});

parcelRegister("fSgGg", function(module, exports) {
$parcel$export(module.exports, "isTeamMention", () => $767412c7c5c82d68$export$803b1379348dbfd5);

var $eBfRL = parcelRequire("eBfRL");
function $767412c7c5c82d68$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === (0, $eBfRL.UserType)[(0, $eBfRL.UserType).TEAM];
}

});


parcelRegister("7RWOe", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d6b78456589356c$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $eBfRL = parcelRequire("eBfRL");

var $4lLOO = parcelRequire("4lLOO");

var $lUYjg = parcelRequire("lUYjg");

var $32EpV = parcelRequire("32EpV");

var $4fDub = parcelRequire("4fDub");
class $0d6b78456589356c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    render() {
        const { userType: userType, isXProductUser: isXProductUser } = this.props.mention;
        if (isXProductUser) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lUYjg.DescriptionBylineStyle), {
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5cKiX.default), {
                ...(0, $4lLOO.messages).xProductMentionDescription
            })
        });
        switch(userType){
            case (0, $eBfRL.UserType)[(0, $eBfRL.UserType).TEAM]:
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $32EpV.default), {
                    mention: this.props.mention
                });
            default:
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4fDub.default), {
                    mention: this.props.mention
                });
        }
    }
}

});
parcelRegister("lUYjg", function(module, exports) {
$parcel$export(module.exports, "DescriptionBylineStyle", () => $c98c441e87f011e4$export$607100a5f9cc9977);

var $9KQKC = parcelRequire("9KQKC");
function $c98c441e87f011e4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c98c441e87f011e4$export$607100a5f9cc9977 = /*#__PURE__*/ (0, $9KQKC.default)("span", {
    target: "e1bkpfff0"
})({
    name: "mffxab",
    styles: "color:var(--ds-text-subtlest, #6B6E76);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin-top:var(--ds-space-025, 2px);display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
});

});

parcelRegister("32EpV", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a2ee4b4d9934523$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $4lLOO = parcelRequire("4lLOO");

var $lUYjg = parcelRequire("lUYjg");
class $5a2ee4b4d9934523$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    render() {
        const { context: context } = this.props.mention;
        if (!context) return null;
        const includesYou = context.includesYou;
        const memberCount = context.memberCount;
        return this.renderByline(memberCount, includesYou);
    }
    constructor(...args){
        super(...args), this.renderByline = (memberCount, includesYou)=>{
            if (includesYou) {
                if (memberCount > 50) return this.getBylineComponent(/*#__PURE__*/ (0, $dc70d.jsx)((0, $5cKiX.default), {
                    ...(0, $4lLOO.messages).plus50MembersWithYou
                }));
                return this.getBylineComponent(/*#__PURE__*/ (0, $dc70d.jsx)((0, $5cKiX.default), {
                    ...(0, $4lLOO.messages).memberCountWithYou,
                    values: {
                        0: memberCount
                    }
                }));
            } else {
                if (memberCount > 50) return this.getBylineComponent(/*#__PURE__*/ (0, $dc70d.jsx)((0, $5cKiX.default), {
                    ...(0, $4lLOO.messages).plus50MembersWithoutYou
                }));
                return this.getBylineComponent(/*#__PURE__*/ (0, $dc70d.jsx)((0, $5cKiX.default), {
                    ...(0, $4lLOO.messages).memberCountWithoutYou,
                    values: {
                        0: memberCount
                    }
                }));
            }
        }, this.getBylineComponent = (message)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $lUYjg.DescriptionBylineStyle), {
                children: message
            });
    }
}

});

parcelRegister("4fDub", function(module, exports) {
$parcel$export(module.exports, "default", () => $6362bf636071c360$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $3y2s4 = parcelRequire("3y2s4");

var $4jP1c = parcelRequire("4jP1c");

var $lUYjg = parcelRequire("lUYjg");
class $6362bf636071c360$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    render() {
        const { email: email, highlight: highlight, name: name, nickname: nickname } = this.props.mention;
        const nicknameHighlights = highlight && highlight.nickname;
        if (email && (!nickname || name === nickname) && (0, $3y2s4.isExperimentEnabled)('platform_editor_mentions_email_search')) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lUYjg.DescriptionBylineStyle), {
            children: email
        });
        if (name === nickname) return null;
        return (0, $4jP1c.renderHighlight)((0, $lUYjg.DescriptionBylineStyle), nickname, nicknameHighlights, '@');
    }
}

});
parcelRegister("4jP1c", function(module, exports) {
$parcel$export(module.exports, "renderHighlight", () => $63c7d419d378dd60$export$2bcf43b01d5314f5);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
function $63c7d419d378dd60$export$2bcf43b01d5314f5(ReactComponent, value, highlights, prefix) {
    if (!value) return null;
    const parts = [];
    const prefixText = prefix || '';
    let lastIndex = 0;
    if (highlights) {
        for(let i = 0; i < highlights.length; i++){
            const h = highlights[i];
            const start = h.start;
            const end = h.end;
            if (start > lastIndex) parts.push({
                value: value.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: value.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        }
        if (lastIndex < value.length) parts.push({
            value: value.substring(lastIndex, value.length),
            matches: false
        });
    } else parts.push({
        value: value,
        matches: false
    });
    return /*#__PURE__*/ (0, $dc70d.jsxs)(ReactComponent, {
        children: [
            prefixText,
            parts.map((part, index)=>{
                if (part.matches) return /*#__PURE__*/ (0, $dc70d.jsx)("b", {
                    children: part.value
                }, index);
                return part.value;
            })
        ]
    });
}

});



parcelRegister("a06wU", function(module, exports) {
$parcel$export(module.exports, "RowStyle", () => $0dc76a6464160d34$export$be24b091af3609e7);
$parcel$export(module.exports, "RowStyleNext", () => $0dc76a6464160d34$export$7bc887464090036);
$parcel$export(module.exports, "AvatarStyle", () => $0dc76a6464160d34$export$141d6bfd196b561);
$parcel$export(module.exports, "AvatarSkeletonWrapper", () => $0dc76a6464160d34$export$3644aa125e4d2449);
$parcel$export(module.exports, "NameSectionStyle", () => $0dc76a6464160d34$export$159b59de9966d2d3);
$parcel$export(module.exports, "FullNameStyle", () => $0dc76a6464160d34$export$d1c198a7fd873fad);
$parcel$export(module.exports, "InfoSectionStyle", () => $0dc76a6464160d34$export$50ad5d386685fccb);
$parcel$export(module.exports, "TimeStyle", () => $0dc76a6464160d34$export$cf4c6e54e715dfd9);
$parcel$export(module.exports, "MENTION_ITEM_HEIGHT", () => $0dc76a6464160d34$export$934cc98367d9ca68);
$parcel$export(module.exports, "MENTION_ITEM_HEIGHT_REFRESHED", () => $0dc76a6464160d34$export$e924bd8329057f42);
$parcel$export(module.exports, "MentionItemStyle", () => $0dc76a6464160d34$export$cf80dda9d7a88a01);
$parcel$export(module.exports, "AccessSectionStyle", () => $0dc76a6464160d34$export$7bf9a8fa7c04527a);

var $gdUUy = parcelRequire("gdUUy");

var $9KQKC = parcelRequire("9KQKC");
function $0dc76a6464160d34$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0dc76a6464160d34$export$be24b091af3609e7 = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e1b3haxs9"
})({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflow: 'hidden',
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'middle'
});
const $0dc76a6464160d34$export$7bc887464090036 = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e1b3haxs8"
})({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflow: 'hidden',
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'middle'
});
const $0dc76a6464160d34$export$141d6bfd196b561 = /*#__PURE__*/ (0, $9KQKC.default)("span", {
    target: "e1b3haxs7"
})((props)=>({
        position: 'relative',
        flex: 'initial',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit'
    }));
const $0dc76a6464160d34$export$3644aa125e4d2449 = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e1b3haxs6"
})({
    name: "5w7vad",
    styles: "display:flex;align-items:center;justify-content:center;width:36px;height:36px"
});
const $0dc76a6464160d34$export$159b59de9966d2d3 = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e1b3haxs5"
})((props)=>({
        flex: 1,
        minWidth: 0,
        marginLeft: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit'
    }));
const $0dc76a6464160d34$export$d1c198a7fd873fad = /*#__PURE__*/ (0, $9KQKC.default)("span", {
    target: "e1b3haxs4"
})({
    name: "a6q67k",
    styles: "display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:var(--ds-text, #292A2E)"
});
const $0dc76a6464160d34$export$50ad5d386685fccb = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e1b3haxs3"
})((props)=>({
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'right',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '& > span': (0, $gdUUy.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? {
                marginRight: "var(--ds-space-negative-025, -2px)",
                marginBottom: "var(--ds-space-025, 2px)",
                marginTop: "var(--ds-space-025, 2px)"
            } : {
                marginBottom: "var(--ds-space-025, 2px)"
            }
        }
    }));
const $0dc76a6464160d34$export$cf4c6e54e715dfd9 = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e1b3haxs2"
})({
    name: "1w8issl",
    styles: "margin-left:var(--ds-space-250, 20px);flex:none;color:var(--ds-text-subtlest, #6B6E76);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $0dc76a6464160d34$export$934cc98367d9ca68 = 48;
const $0dc76a6464160d34$export$e924bd8329057f42 = 44;
const $0dc76a6464160d34$export$cf80dda9d7a88a01 = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e1b3haxs1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.selected ? "var(--ds-background-selected, #E9F2FE)" : 'transparent',
        display: 'block',
        overflow: 'hidden',
        listStyleType: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${props.height ?? $0dc76a6464160d34$export$934cc98367d9ca68}px`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.2,
        cursor: 'pointer'
    }));
const $0dc76a6464160d34$export$7bf9a8fa7c04527a = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e1b3haxs0"
})({
    name: "8l7ck6",
    styles: "padding-left:var(--ds-space-050, 4px);color:var(--ds-text-subtle, #505258)"
});

});

parcelRegister("2VwLB", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("44z4R").then(()=>parcelRequire('aHhhM'));

});


parcelRegister("6lU7m", function(module, exports) {
$parcel$export(module.exports, "INVITE_ITEM_DESCRIPTION", () => $62a5791ae86aeaee$export$75621ed4176efc9e);
$parcel$export(module.exports, "default", () => $62a5791ae86aeaee$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");
var $fK3tS = parcelRequire("fK3tS");

var $6ny6f = parcelRequire("6ny6f");

var $kFWau = parcelRequire("kFWau");
const $62a5791ae86aeaee$var$mentionItemStyle = null;
const $62a5791ae86aeaee$var$mentionItemSelectedStyle = null;
const $62a5791ae86aeaee$var$rowStyle = null;
const $62a5791ae86aeaee$var$avatarStyle = null;
const $62a5791ae86aeaee$var$nameSectionStyle = null;
const $62a5791ae86aeaee$var$capitalizedStyle = null;
const $62a5791ae86aeaee$export$75621ed4176efc9e = {
    id: 'invite-teammate'
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $62a5791ae86aeaee$var$leftClick = (event)=>{
    return event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
};
const $62a5791ae86aeaee$var$InviteItem = ({ productName: productName, onMount: onMount, onMouseEnter: onMouseEnter, onSelection: onSelection, selected: selected, userRole: userRole, intl: intl })=>{
    const onSelected = (0, $bSJIT.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (onSelection) {
            // For mouse events, only handle left click
            if ('button' in event && !$62a5791ae86aeaee$var$leftClick(event)) return;
            // For keyboard events, only handle Enter and Space
            if ('key' in event && event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            onSelection($62a5791ae86aeaee$export$75621ed4176efc9e, event);
        }
    }, [
        onSelection
    ]);
    const onItemMouseEnter = (0, $bSJIT.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (onMouseEnter) onMouseEnter($62a5791ae86aeaee$export$75621ed4176efc9e, event);
    }, [
        onMouseEnter
    ]);
    const onItemFocus = (0, $bSJIT.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (onMouseEnter) onMouseEnter($62a5791ae86aeaee$export$75621ed4176efc9e, event);
    }, [
        onMouseEnter
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (onMount) onMount();
    }, [
        onMount
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        role: "button",
        tabIndex: 0,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        onMouseDown: onSelected,
        onKeyDown: onSelected,
        onMouseEnter: onItemMouseEnter,
        onFocus: onItemFocus,
        "data-id": $62a5791ae86aeaee$export$75621ed4176efc9e.id,
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _bfhk1j28 _1e0c1ule _2mzuglyw _80omtlke",
            selected && "_bfhk1dpa"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
            className: (0, $9fU1q.default)([
                "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _2lx2vrvc _1n261g80 _ca0q12x7 _n3td12x7 _19bvdlk8 _u5f3dlk8 _1bto1l2s _s7n4nkob"
            ]),
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                    className: (0, $9fU1q.default)([
                        "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _1bsb14no _4t3i14no"
                    ]),
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kFWau))), {
                        label: intl.formatMessage((0, $6ny6f.mentionMessages).mentionsAddLabel),
                        color: "var(--ds-icon-subtle, #505258)"
                    })
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    "data-testid": "name-section",
                    className: (0, $9fU1q.default)([
                        "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _18u0dlk8 _syazazsu"
                    ]),
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5cKiX.default), {
                        ...(0, $6ny6f.mentionMessages).inviteItemTitle,
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        values: {
                            userRole: userRole || 'basic',
                            productName: /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                                "data-testid": "capitalized-message",
                                className: (0, $9fU1q.default)([
                                    "_1p1d1dk0"
                                ]),
                                children: productName
                            })
                        }
                    })
                })
            ]
        })
    });
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $62a5791ae86aeaee$var$_default_1 = (0, $fK3tS.default)($62a5791ae86aeaee$var$InviteItem);
var $62a5791ae86aeaee$export$2e2bcd8739ae039 = $62a5791ae86aeaee$var$_default_1;

});

parcelRegister("dhEUP", function(module, exports) {
$parcel$export(module.exports, "default", () => $3eb4e544f5e4e0b6$export$2e2bcd8739ae039);
/* InviteItemWithEmailDomain.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");
var $fK3tS = parcelRequire("fK3tS");

var $6ny6f = parcelRequire("6ny6f");

var $hLX8u = parcelRequire("hLX8u");

var $hkLEY = parcelRequire("hkLEY");

var $lABnJ = parcelRequire("lABnJ");
const $3eb4e544f5e4e0b6$var$mentionItemStyle = null;
const $3eb4e544f5e4e0b6$var$mentionItemSelectedStyle = null;
const $3eb4e544f5e4e0b6$var$displayNameStyles = {
    localPart: "_1i4q1hna",
    domainPart: "_1e0c1o8l _p12f1osq _1i4q1hna"
};
const $3eb4e544f5e4e0b6$var$DisplayName = ({ name: name })=>{
    const atIndex = name.indexOf('@');
    if (atIndex === -1) return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        className: (0, $9fU1q.default)([
            $3eb4e544f5e4e0b6$var$displayNameStyles.localPart
        ]),
        children: name
    });
    const localPart = name.slice(0, atIndex);
    const domainPart = name.slice(atIndex); // includes the @
    return /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                className: (0, $9fU1q.default)([
                    $3eb4e544f5e4e0b6$var$displayNameStyles.localPart
                ]),
                children: localPart
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                className: (0, $9fU1q.default)([
                    $3eb4e544f5e4e0b6$var$displayNameStyles.domainPart
                ]),
                children: domainPart
            })
        ]
    });
};
const $3eb4e544f5e4e0b6$var$style = {
    byline: "_19pkv77o",
    rowStyle: "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _2lx2vrvc _1n261g80 _ca0q12x7 _n3td12x7 _19bvutpp _u5f3utpp _1bto1l2s _s7n4nkob",
    avatar: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _1bsb14no _4t3i14no",
    nameSection: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _18u0utpp _2hwxu2gc _syazazsu",
    capitalize: "_1p1d1dk0"
};
const $3eb4e544f5e4e0b6$var$VALID_OPTION = 'VALID';
const $3eb4e544f5e4e0b6$var$POTENTIAL_OPTION = 'POTENTIAL';
// eslint-disable-next-line require-unicode-regexp
const $3eb4e544f5e4e0b6$var$COMPLETE_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $3eb4e544f5e4e0b6$var$ERROR_DELAY_MS = 750;
const $3eb4e544f5e4e0b6$export$e6502b0a7f7ab4ba = (value, maxLength = 34)=>{
    if (value.length <= maxLength) return value;
    const atIndex = value.lastIndexOf('@');
    if (atIndex === -1) {
        // No @ — truncate to maxLength and append ellipsis
        const ellipsis = '\u2026';
        return `${value.slice(0, maxLength - 1)}${ellipsis}`;
    }
    const domain = value.slice(atIndex); // includes @
    const local = value.slice(0, atIndex);
    const ellipsis = '\u2026';
    const available = maxLength - domain.length - ellipsis.length;
    if (available <= 0) // Domain alone exceeds budget — show as much as we can
    return `${ellipsis}${domain.slice(-(maxLength - ellipsis.length))}`;
    const leading = Math.ceil(available / 2);
    const trailing = Math.floor(available / 2);
    const truncatedLocal = trailing > 0 ? `${local.slice(0, leading)}${ellipsis}${local.slice(local.length - trailing)}` : `${local.slice(0, leading)}${ellipsis}`;
    return `${truncatedLocal}${domain}`;
};
const $3eb4e544f5e4e0b6$var$getInviteOption = (inputValue, suggestedEmailDomain)=>{
    if (inputValue.includes(' ') && inputValue.includes('@')) return $3eb4e544f5e4e0b6$export$e6502b0a7f7ab4ba(inputValue);
    const isEmail = inputValue && [
        $3eb4e544f5e4e0b6$var$VALID_OPTION,
        $3eb4e544f5e4e0b6$var$POTENTIAL_OPTION
    ].includes((0, $lABnJ.isValidEmail)(inputValue));
    if (isEmail || !suggestedEmailDomain) return $3eb4e544f5e4e0b6$export$e6502b0a7f7ab4ba(inputValue);
    return $3eb4e544f5e4e0b6$export$e6502b0a7f7ab4ba(`${inputValue.toLocaleLowerCase()}@${suggestedEmailDomain}`);
};
const $3eb4e544f5e4e0b6$var$getIsEmailValid = (inputValue)=>{
    if (!inputValue || inputValue.length === 0) return false;
    if (inputValue.includes(' ')) return false;
    if (inputValue.includes('@') && !$3eb4e544f5e4e0b6$var$COMPLETE_EMAIL_REGEX.test(inputValue)) return false;
    return true;
};
const $3eb4e544f5e4e0b6$export$75621ed4176efc9e = {
    id: 'invite-teammate'
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3eb4e544f5e4e0b6$var$leftClick = (event)=>{
    return event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
};
const $3eb4e544f5e4e0b6$var$InviteItemWithEmailDomain = ({ productName: productName, onMount: onMount, onMouseEnter: onMouseEnter, onSelection: onSelection, selected: selected, userRole: userRole, query: query = '', emailDomain: emailDomain, intl: intl })=>{
    const [showErrorIcon, setShowErrorIcon] = (0, $bSJIT.useState)(query.length !== 0 && !$3eb4e544f5e4e0b6$var$getIsEmailValid(query));
    const timeoutRef = (0, $bSJIT.useRef)();
    const possibleEmail = $3eb4e544f5e4e0b6$var$getInviteOption(query, emailDomain);
    const isEmailValid = $3eb4e544f5e4e0b6$var$getIsEmailValid(query);
    const getByline = ()=>{
        if (showErrorIcon) return intl.formatMessage((0, $6ny6f.mentionMessages).inviteTeammateInvalidEmail);
        if (userRole === 'admin') return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5cKiX.default), {
            ...(0, $6ny6f.mentionMessages).inviteItemTitle,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            values: {
                userRole: userRole || 'basic',
                productName: /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                    "data-testid": "capitalized-message",
                    className: (0, $9fU1q.default)([
                        $3eb4e544f5e4e0b6$var$style.capitalize
                    ]),
                    children: productName
                })
            }
        });
        return intl.formatMessage((0, $6ny6f.mentionMessages).sendInvite);
    };
    const onSelected = (0, $bSJIT.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (showErrorIcon) return;
        if (onSelection) {
            // For mouse events, only handle left click
            if ('button' in event && !$3eb4e544f5e4e0b6$var$leftClick(event)) return;
            // For keyboard events, only handle Enter and Space
            if ('key' in event && event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            onSelection($3eb4e544f5e4e0b6$export$75621ed4176efc9e, event);
        }
    }, [
        onSelection,
        showErrorIcon
    ]);
    const onItemMouseEnter = (0, $bSJIT.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (onMouseEnter) onMouseEnter($3eb4e544f5e4e0b6$export$75621ed4176efc9e, event);
    }, [
        onMouseEnter
    ]);
    const onItemFocus = (0, $bSJIT.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (onMouseEnter) onMouseEnter($3eb4e544f5e4e0b6$export$75621ed4176efc9e, event);
    }, [
        onMouseEnter
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (onMount) onMount();
    }, [
        onMount
    ]);
    // Debounce error icon display: only show error after user stops typing invalid input
    (0, $bSJIT.useEffect)(()=>{
        // Clear existing timeout
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = undefined;
        }
        // Reset error icon immediately if input becomes valid or empty
        if (isEmailValid || query.length === 0) setShowErrorIcon(false);
        else // Debounce: only show error icon after delay if input remains invalid
        timeoutRef.current = setTimeout(()=>{
            setShowErrorIcon(true);
        }, $3eb4e544f5e4e0b6$var$ERROR_DELAY_MS);
        // Cleanup timeout on unmount or when query changes
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [
        query,
        isEmailValid
    ]);
    const displayName = query && emailDomain ? possibleEmail : undefined;
    return displayName && /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        role: "button",
        tabIndex: 0,
        onMouseDown: onSelected,
        onKeyDown: onSelected,
        onMouseEnter: onItemMouseEnter,
        onFocus: onItemFocus,
        "data-id": $3eb4e544f5e4e0b6$export$75621ed4176efc9e.id,
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _bfhk1j28 _1e0c1ule _2mzuglyw _80omtlke",
            selected && "_bfhk1dpa"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
            className: (0, $9fU1q.default)([
                $3eb4e544f5e4e0b6$var$style.rowStyle
            ]),
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                    className: (0, $9fU1q.default)([
                        $3eb4e544f5e4e0b6$var$style.avatar
                    ]),
                    children: showErrorIcon ? /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
                        label: "Error",
                        color: "var(--ds-icon-danger, #C9372C)"
                    }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hLX8u))), {
                        label: "Email",
                        color: "var(--ds-icon-subtle, #505258)"
                    })
                }),
                /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
                    "data-testid": "name-section",
                    className: (0, $9fU1q.default)([
                        $3eb4e544f5e4e0b6$var$style.nameSection
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $dc70d.jsx)($3eb4e544f5e4e0b6$var$DisplayName, {
                            name: displayName
                        }),
                        /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                            className: (0, $9fU1q.default)([
                                $3eb4e544f5e4e0b6$var$style.byline
                            ]),
                            children: getByline()
                        })
                    ]
                })
            ]
        })
    });
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $3eb4e544f5e4e0b6$var$_default_1 = (0, $fK3tS.default)($3eb4e544f5e4e0b6$var$InviteItemWithEmailDomain);
var $3eb4e544f5e4e0b6$export$2e2bcd8739ae039 = $3eb4e544f5e4e0b6$var$_default_1;

});

parcelRegister("3P2uE", function(module, exports) {
$parcel$export(module.exports, "AgentMentionLoadErrorItem", () => $07d316d4050825c6$export$a278b0f8123e796b);
/* AgentMentionLoadErrorItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4vLTk = parcelRequire("4vLTk");

var $6ny6f = parcelRequire("6ny6f");

var $hkLEY = parcelRequire("hkLEY");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $8aT4G = parcelRequire("8aT4G");
const $07d316d4050825c6$var$styles = {
    retryRow: "_11c8fhey _189eidpf _1rjcu2gc _18zrutpp _4cvr1h6o _bfhk1j28 _vchhusvi _syazazsu _80omtlke _1e0c1txw _1tke1ylp _y3gn1e5h _1bsb1osq",
    retryText: "_11c8fhey _syaz13af"
};
const $07d316d4050825c6$export$a278b0f8123e796b = ({ onRetry: onRetry })=>{
    const intl = (0, $4vLTk.default)();
    const handleMouseDown = (0, $bSJIT.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const handleClick = (0, $bSJIT.useCallback)((event)=>{
        event.preventDefault();
        onRetry();
    }, [
        onRetry
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("button", {
        type: "button",
        tabIndex: -1,
        onMouseDown: handleMouseDown,
        onClick: handleClick,
        "data-testid": "agent-mention-load-error-item",
        className: (0, $9fU1q.default)([
            $07d316d4050825c6$var$styles.retryRow
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $fZ0ZI.Inline), {
            alignBlock: "center",
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
                    label: "",
                    color: "var(--ds-icon-danger, #C9372C)"
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                    as: "span",
                    color: "color.text.subtle",
                    children: intl.formatMessage((0, $6ny6f.mentionMessages).typeAheadSectionAgentsLoadError)
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                    className: (0, $9fU1q.default)([
                        $07d316d4050825c6$var$styles.retryText
                    ]),
                    children: intl.formatMessage((0, $6ny6f.mentionMessages).typeAheadSectionAgentsRetry)
                })
            ]
        })
    });
};

});

parcelRegister("16I1l", function(module, exports) {
$parcel$export(module.exports, "buildTypeAheadCancelPayload", () => $2b88fababf331d43$export$e1d5d51810b7e165);
$parcel$export(module.exports, "buildTypeAheadInviteItemViewedPayload", () => $2b88fababf331d43$export$c102b710f5c857c4);
$parcel$export(module.exports, "buildTypeAheadInviteItemClickedPayload", () => $2b88fababf331d43$export$e4c4d872dcfe2b15);
$parcel$export(module.exports, "buildTypeAheadInsertedPayload", () => $2b88fababf331d43$export$84030a552533cdf8);
$parcel$export(module.exports, "buildTypeAheadRenderedPayload", () => $2b88fababf331d43$export$901fb6651fc13b0e);

var $g6Qq4 = parcelRequire("g6Qq4");

var $3vu77 = parcelRequire("3vu77");

var $dE7wH = parcelRequire("dE7wH");
const $2b88fababf331d43$var$componentName = 'mention';
const $2b88fababf331d43$export$867a43da6e470584 = 'mentionInEditor';
const $2b88fababf331d43$var$emptyQueryResponse = {
    queryLength: 0,
    spaceInQuery: false
};
const $2b88fababf331d43$var$extractAttributesFromQuery = (query)=>{
    if (query) return {
        queryLength: query.length,
        spaceInQuery: query.indexOf(' ') !== -1
    };
    return $2b88fababf331d43$var$emptyQueryResponse;
};
const $2b88fababf331d43$export$e1d5d51810b7e165 = (duration, upKeyCount, downKeyCount, sessionId, query)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $2b88fababf331d43$var$extractAttributesFromQuery(query);
    return {
        action: (0, $g6Qq4.ACTION).CANCELLED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MENTION_TYPEAHEAD,
        eventType: (0, $g6Qq4.EVENT_TYPE).UI,
        attributes: {
            componentName: $2b88fababf331d43$var$componentName,
            duration: duration,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            upKeyCount: upKeyCount,
            downKeyCount: downKeyCount,
            sessionId: sessionId
        }
    };
};
const $2b88fababf331d43$var$getPosition = (mentionList, selectedMention)=>{
    if (mentionList) {
        const index = mentionList.findIndex((mention)=>mention.id === selectedMention.id);
        return index === -1 ? undefined : index;
    }
    return;
};
const $2b88fababf331d43$var$isClicked = (insertType)=>insertType === 'selected';
const $2b88fababf331d43$export$c102b710f5c857c4 = (sessionId, contextIdentifierProvider, userRole, additionalAttributes)=>{
    const { containerId: containerId, objectId: objectId, childObjectId: childObjectId } = contextIdentifierProvider || {};
    return {
        action: (0, $g6Qq4.ACTION).RENDERED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).INVITE_ITEM,
        eventType: (0, $g6Qq4.EVENT_TYPE).UI,
        attributes: {
            componentName: $2b88fababf331d43$var$componentName,
            containerId: containerId,
            objectId: objectId,
            childObjectId: childObjectId,
            userRole: userRole,
            sessionId: sessionId,
            source: $2b88fababf331d43$export$867a43da6e470584,
            ...additionalAttributes
        }
    };
};
const $2b88fababf331d43$export$e4c4d872dcfe2b15 = (duration, upKeyCount, downKeyCount, sessionId, insertType, query, contextIdentifierProvider, userRole, additionalAttributes)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $2b88fababf331d43$var$extractAttributesFromQuery(query);
    const { containerId: containerId, objectId: objectId, childObjectId: childObjectId } = contextIdentifierProvider || {};
    return {
        action: $2b88fababf331d43$var$isClicked(insertType) ? (0, $g6Qq4.ACTION).CLICKED : (0, $g6Qq4.ACTION).PRESSED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).INVITE_ITEM,
        eventType: (0, $g6Qq4.EVENT_TYPE).UI,
        attributes: {
            componentName: $2b88fababf331d43$var$componentName,
            duration: duration,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            upKeyCount: upKeyCount,
            downKeyCount: downKeyCount,
            containerId: containerId,
            objectId: objectId,
            childObjectId: childObjectId,
            userRole: userRole,
            sessionId: sessionId,
            keyboardKey: $2b88fababf331d43$var$isClicked(insertType) ? undefined : insertType,
            ...additionalAttributes
        }
    };
};
const $2b88fababf331d43$export$84030a552533cdf8 = (duration, upKeyCount, downKeyCount, sessionId, insertType, mention, mentionLocalId, mentionList, query, contextIdentifierProvider, taskListId, taskItemId, isAgent, agentSectioningEnabled)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $2b88fababf331d43$var$extractAttributesFromQuery(query);
    let containerId;
    let objectId;
    let childObjectId;
    if (contextIdentifierProvider) {
        containerId = contextIdentifierProvider.containerId || undefined;
        objectId = contextIdentifierProvider.objectId || undefined;
        childObjectId = contextIdentifierProvider.childObjectId || undefined;
    }
    return {
        action: $2b88fababf331d43$var$isClicked(insertType) ? (0, $g6Qq4.ACTION).CLICKED : (0, $g6Qq4.ACTION).PRESSED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MENTION_TYPEAHEAD,
        eventType: (0, $g6Qq4.EVENT_TYPE).UI,
        containerId: containerId,
        objectId: objectId,
        childObjectId: childObjectId,
        attributes: {
            sessionId: sessionId,
            duration: duration,
            position: $2b88fababf331d43$var$getPosition(mentionList, mention),
            keyboardKey: $2b88fababf331d43$var$isClicked(insertType) ? undefined : insertType,
            source: mention.source,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            isSpecial: (0, $3vu77.isSpecialMention)(mention),
            accessLevel: mention.accessLevel || '',
            userType: mention.userType,
            userId: mention.id,
            upKeyCount: upKeyCount,
            downKeyCount: downKeyCount,
            memberCount: (0, $dE7wH.isTeamType)(mention.userType) && mention.context ? mention.context.memberCount : null,
            includesYou: (0, $dE7wH.isTeamType)(mention.userType) && mention.context ? mention.context.includesYou : null,
            ...isAgent ? {
                isAgent: isAgent,
                agentSectioningEnabled: agentSectioningEnabled
            } : {},
            taskListId: taskListId,
            taskItemId: taskItemId,
            localId: mentionLocalId,
            containerId: containerId,
            objectId: objectId,
            childObjectId: childObjectId
        }
    };
};
const $2b88fababf331d43$export$901fb6651fc13b0e = (duration, userIds, query, teams, xProductMentionsLength, mentionTypeaheadSessionId, agentAnalytics)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $2b88fababf331d43$var$extractAttributesFromQuery(query);
    const actionSubject = userIds ? (0, $g6Qq4.ACTION_SUBJECT).MENTION_TYPEAHEAD : (0, $g6Qq4.ACTION_SUBJECT).TEAM_MENTION_TYPEAHEAD;
    const agentAnalyticsAttributes = agentAnalytics ? {
        agentCount: agentAnalytics.agentCount,
        agentsShown: agentAnalytics.agentCount > 0,
        agentSectioningEnabled: agentAnalytics.agentSectioningEnabled
    } : {};
    return {
        action: (0, $g6Qq4.ACTION).RENDERED,
        actionSubject: actionSubject,
        eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
        attributes: {
            componentName: $2b88fababf331d43$var$componentName,
            duration: duration,
            mentionTypeaheadSessionId: mentionTypeaheadSessionId,
            userIds: userIds,
            teams: teams,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            xProductMentionsLength: xProductMentionsLength,
            ...agentAnalyticsAttributes
        }
    };
};

});
parcelRegister("3vu77", function(module, exports) {
$parcel$export(module.exports, "isSpecialMention", () => $789ca5d0942218ce$export$37b8dcac6198c514);

var $eBfRL = parcelRequire("eBfRL");
function $789ca5d0942218ce$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === (0, $eBfRL.UserType)[(0, $eBfRL.UserType).SPECIAL];
}

});

parcelRegister("dE7wH", function(module, exports) {
$parcel$export(module.exports, "isTeamType", () => $70d4b05e2d203b7f$export$6ddb6ef001273170);
$parcel$export(module.exports, "isTeamStats", () => $70d4b05e2d203b7f$export$c427182c53a1ba5);
$parcel$export(module.exports, "isInviteItem", () => $70d4b05e2d203b7f$export$f5a334b5a28d1e01);
$parcel$export(module.exports, "isAgentMention", () => $70d4b05e2d203b7f$export$374d169f8869a22b);
$parcel$export(module.exports, "isExplicitAgentMention", () => $70d4b05e2d203b7f$export$4e779261bd11597d);
$parcel$export(module.exports, "isAgentMentionLoadError", () => $70d4b05e2d203b7f$export$45ab6fb7a17aa681);
$parcel$export(module.exports, "isBotOrTeamMention", () => $70d4b05e2d203b7f$export$16056f1c3fdebfc3);
$parcel$export(module.exports, "orderMentionsForDisplay", () => $70d4b05e2d203b7f$export$eaffed3f4ab552c7);
$parcel$export(module.exports, "shouldKeepInviteItem", () => $70d4b05e2d203b7f$export$16a134d4e1b461dc);

var $eBfRL = parcelRequire("eBfRL");

var $6lU7m = parcelRequire("6lU7m");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $70d4b05e2d203b7f$var$SUFFIX_WITH_EXTRA_WORDS_REGEX = /\s[^\s]+\s/;
const $70d4b05e2d203b7f$export$6ddb6ef001273170 = (userType)=>userType === 'TEAM';
const $70d4b05e2d203b7f$export$c427182c53a1ba5 = (stat)=>stat && !isNaN(stat.teamMentionDuration);
const $70d4b05e2d203b7f$export$f5a334b5a28d1e01 = (mention)=>mention && mention.id === (0, $6lU7m.INVITE_ITEM_DESCRIPTION).id;
const $70d4b05e2d203b7f$export$b930f0bb68cf663d = (userType)=>userType === 'APP' || userType === 'AGENT';
const $70d4b05e2d203b7f$export$374d169f8869a22b = (mention)=>$70d4b05e2d203b7f$export$b930f0bb68cf663d(mention.userType) || mention.appType === 'agent';
const $70d4b05e2d203b7f$export$4e779261bd11597d = (mention)=>mention.appType === 'agent' || mention.userType === 'AGENT';
const $70d4b05e2d203b7f$export$45ab6fb7a17aa681 = (mention)=>(mention === null || mention === void 0 ? void 0 : mention.id) === (0, $eBfRL.AGENT_MENTION_LOAD_ERROR_ID) && mention.isPlaceholder === true && mention.placeholderType === 'error' && mention.appType === 'agent';
const $70d4b05e2d203b7f$export$16056f1c3fdebfc3 = (mention)=>{
    if ($70d4b05e2d203b7f$export$4e779261bd11597d(mention)) return false;
    return mention.userType === 'TEAM' || mention.userType === 'APP';
};
const $70d4b05e2d203b7f$export$6701a398c40f2b14 = (mention)=>{
    if ($70d4b05e2d203b7f$export$4e779261bd11597d(mention)) return 'agents';
    if ($70d4b05e2d203b7f$export$16056f1c3fdebfc3(mention)) return 'bots-teams';
    return 'people';
};
const $70d4b05e2d203b7f$export$eaffed3f4ab552c7 = (mentions)=>{
    const people = [];
    const agents = [];
    const botsAndTeams = [];
    for (const mention of mentions){
        const group = $70d4b05e2d203b7f$export$6701a398c40f2b14(mention);
        if (group === 'agents') agents.push(mention);
        else if (group === 'bots-teams') botsAndTeams.push(mention);
        else people.push(mention);
    }
    return [
        ...people,
        ...agents,
        ...botsAndTeams
    ];
};
const $70d4b05e2d203b7f$export$16a134d4e1b461dc = (query, firstQueryWithoutResults)=>{
    if (!firstQueryWithoutResults) return true;
    const lastIndexWithResults = firstQueryWithoutResults.length - 1;
    let suffix = query.slice(lastIndexWithResults);
    if (query[lastIndexWithResults - 1] === ' ') suffix = ' ' + suffix;
    const depletedExtraWords = $70d4b05e2d203b7f$var$SUFFIX_WITH_EXTRA_WORDS_REGEX.test(suffix);
    return !depletedExtraWords;
};

});


parcelRegister("3isrH", function(module, exports) {
$parcel$export(module.exports, "MentionItemWithProfileCard", () => $843bb3ceb20450ff$export$d9d86330b3a84299);
/* MentionItemWithProfileCard.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $3OYlc = parcelRequire("3OYlc");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $iV8Uh = parcelRequire("iV8Uh");

var $dE7wH = parcelRequire("dE7wH");
// Delay before mounting the card and fetching the profile data
const $843bb3ceb20450ff$var$SHOW_DELAY_MS = 600;
const $843bb3ceb20450ff$var$HIDE_DELAY_MS = 200;
// Gap between the typeahead row and the profile card
const $843bb3ceb20450ff$var$CARD_GAP_PX = 8;
const $843bb3ceb20450ff$var$styles = {
    placeholderContainer: "_80om73ad",
    placeholderContent: "_lcxvglyw"
};
function $843bb3ceb20450ff$var$getScrollbarWidth(row) {
    let node = row;
    while(node){
        const style = getComputedStyle(node);
        if ((style.overflowY === 'auto' || style.overflowY === 'scroll') && node.scrollHeight > node.clientHeight) return Math.max(0, node.offsetWidth - node.clientWidth);
        node = node.parentElement;
    }
    return 0;
}
/**
 * Renders the new (relay) user profile card for a mention typeahead row, anchored to the row and
 * flipped left when there's no room on the right
 */ function $843bb3ceb20450ff$var$UserTypeaheadProfileCard({ profilecardProvider: profilecardProvider, userId: userId, referenceElement: referenceElement }) {
    const [provider, setProvider] = (0, $bSJIT.useState)(undefined);
    (0, $bSJIT.useEffect)(()=>{
        let active = true;
        profilecardProvider.then((resolved)=>{
            if (active) setProvider(resolved);
        }).catch(()=>{
        // provider failed to resolve, card stays hidden
        });
        return ()=>{
            active = false;
        };
    }, [
        profilecardProvider
    ]);
    if (!userId || !(provider !== null && provider !== void 0 && provider.renderUserMentionCard)) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: provider.renderUserMentionCard({
            userId: userId,
            cloudId: provider.cloudId,
            children: null,
            referenceElement: referenceElement,
            placement: 'right',
            isReduced: true
        })
    });
}
function $843bb3ceb20450ff$export$d9d86330b3a84299({ mention: mention, selected: selected, onSelection: onSelection, height: height, profilecardProvider: profilecardProvider }) {
    const [referenceElement, setReferenceElement] = (0, $bSJIT.useState)(null);
    const showTimerRef = (0, $bSJIT.useRef)();
    const hideTimerRef = (0, $bSJIT.useRef)();
    const clearTimers = (0, $bSJIT.useCallback)(()=>{
        clearTimeout(showTimerRef.current);
        clearTimeout(hideTimerRef.current);
    }, []);
    (0, $bSJIT.useEffect)(()=>clearTimers, [
        clearTimers
    ]);
    const isAgent = (0, $dE7wH.isAgentMention)(mention);
    const handleMouseEnter = (0, $bSJIT.useCallback)((_mention, event)=>{
        if (mention.isPlaceholder || !mention.id || !profilecardProvider) return;
        if (!isAgent && !(0, $3y2s4.isExperimentEnabled)('platform_editor_mention_typeahead_user_profilecard')) return;
        const rowElement = event === null || event === void 0 ? void 0 : event.currentTarget;
        if (!(rowElement instanceof HTMLElement)) return;
        clearTimers();
        showTimerRef.current = setTimeout(()=>{
            setReferenceElement(rowElement);
        }, $843bb3ceb20450ff$var$SHOW_DELAY_MS);
    }, [
        mention.isPlaceholder,
        mention.id,
        isAgent,
        profilecardProvider,
        clearTimers
    ]);
    const scheduleHide = (0, $bSJIT.useCallback)(()=>{
        clearTimeout(hideTimerRef.current);
        hideTimerRef.current = setTimeout(()=>{
            setReferenceElement(null);
        }, $843bb3ceb20450ff$var$HIDE_DELAY_MS);
    }, []);
    const cancelHide = (0, $bSJIT.useCallback)(()=>{
        clearTimeout(hideTimerRef.current);
    }, []);
    const handleMouseLeave = (0, $bSJIT.useCallback)(()=>{
        clearTimeout(showTimerRef.current);
        scheduleHide();
    }, [
        scheduleHide
    ]);
    const closeCard = (0, $bSJIT.useCallback)(()=>{
        clearTimers();
        setReferenceElement(null);
    }, [
        clearTimers
    ]);
    const userType = isAgent ? 'APP' : undefined;
    const activeMention = (0, $bSJIT.useMemo)(()=>({
            attrs: {
                id: mention.id,
                text: mention.name,
                userType: userType,
                accessLevel: mention.accessLevel
            }
        }), [
        mention.id,
        mention.name,
        mention.accessLevel,
        userType
    ]);
    // If there's a scrollbar, position the card with a gap to it
    const offset = (0, $bSJIT.useMemo)(()=>{
        if (!referenceElement || !(0, $gdUUy.fg)('platform_editor_typeahead_profilecard_scrollbar')) return undefined;
        return [
            0,
            $843bb3ceb20450ff$var$CARD_GAP_PX + $843bb3ceb20450ff$var$getScrollbarWidth(referenceElement)
        ];
    }, [
        referenceElement
    ]);
    if (mention.isPlaceholder) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        testId: "mention-item-with-profile-card",
        xcss: $843bb3ceb20450ff$var$styles.placeholderContainer,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
            xcss: $843bb3ceb20450ff$var$styles.placeholderContent,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $3OYlc.default), {
                mention: mention,
                selected: selected,
                onMouseEnter: handleMouseEnter,
                onSelection: onSelection,
                height: height
            })
        })
    });
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9PwDt.Box), {
        testId: "mention-item-with-profile-card",
        onMouseOver: cancelHide,
        onMouseOut: scheduleHide,
        onMouseLeave: handleMouseLeave,
        onBlur: handleMouseLeave,
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $3OYlc.default), {
                mention: mention,
                selected: selected,
                onMouseEnter: handleMouseEnter,
                onSelection: onSelection,
                height: height
            }),
            referenceElement && profilecardProvider && (isAgent ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $iV8Uh.ProfileCardComponent), {
                activeMention: activeMention,
                profilecardProvider: profilecardProvider,
                dom: referenceElement,
                closeComponent: closeCard,
                placement: "right",
                offset: offset,
                disableFocusTrap: true,
                hideActions: true
            }) : /*#__PURE__*/ (0, $dc70d.jsx)($843bb3ceb20450ff$var$UserTypeaheadProfileCard, {
                profilecardProvider: profilecardProvider,
                userId: mention.id,
                referenceElement: referenceElement
            }))
        ]
    });
}

});



parcelRegister("ibifS", function(module, exports) {
$parcel$export(module.exports, "saveOnEnterPlugin", () => $78caad500f642a88$export$8ba1e5775ae443a6);

var $g6Qq4 = parcelRequire("g6Qq4");

var $lrWkt = parcelRequire("lrWkt");

var $ejrfk = parcelRequire("ejrfk");
const $78caad500f642a88$export$ae829ec7b2625219 = (eventDispatch, onSave)=>{
    if (!onSave) return;
    return (0, $ejrfk.keymap)({
        Enter (state, _dispatch, editorView) {
            if (editorView && $78caad500f642a88$var$canSaveOnEnter(editorView)) {
                eventDispatch((0, $lrWkt.analyticsEventKey), $78caad500f642a88$var$analyticsPayload(state));
                onSave(editorView);
                return true;
            }
            return false;
        }
    });
};
function $78caad500f642a88$var$canSaveOnEnter(editorView) {
    const { $cursor: $cursor } = editorView.state.selection;
    const { decisionItem: decisionItem, paragraph: paragraph, taskItem: taskItem } = editorView.state.schema.nodes;
    return !$cursor || $cursor.parent.type === paragraph && $cursor.depth === 1 || $cursor.parent.type === decisionItem && !$78caad500f642a88$var$isEmptyAtCursor($cursor) || $cursor.parent.type === taskItem && !$78caad500f642a88$var$isEmptyAtCursor($cursor);
}
function $78caad500f642a88$var$isEmptyAtCursor($cursor) {
    const { content: content } = $cursor.parent;
    return !(content && content.size);
}
const $78caad500f642a88$var$analyticsPayload = (state)=>({
        payload: {
            action: (0, $g6Qq4.ACTION).STOPPED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SAVE,
            attributes: {
                inputMethod: (0, $g6Qq4.INPUT_METHOD).SHORTCUT,
                documentSize: state.doc.nodeSize
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).UI
        }
    });
const $78caad500f642a88$export$8ba1e5775ae443a6 = ({ config: onSave })=>({
        name: 'saveOnEnter',
        pmPlugins () {
            return [
                {
                    name: 'saveOnEnter',
                    plugin: ({ dispatch: dispatch })=>$78caad500f642a88$export$ae829ec7b2625219(dispatch, onSave)
                }
            ];
        }
    });

});

parcelRegister("4qdNU", function(module, exports) {
$parcel$export(module.exports, "syncedBlockPlugin", () => $dfa8f7c72556ac3c$export$4567b5886e253c5a);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $3kxb2 = parcelRequire("3kxb2");

var $5vK1d = parcelRequire("5vK1d");

var $5beht = parcelRequire("5beht");

var $eBzkt = parcelRequire("eBzkt");

var $3y2s4 = parcelRequire("3y2s4");

var $9sTsq = parcelRequire("9sTsq");

var $8hQqt = parcelRequire("8hQqt");

var $cG0Fu = parcelRequire("cG0Fu");

var $gvqC8 = parcelRequire("gvqC8");

var $ksf75 = parcelRequire("ksf75");

var $fNUvY = parcelRequire("fNUvY");

var $3BkSH = parcelRequire("3BkSH");

var $deVl0 = parcelRequire("deVl0");

var $92Ghi = parcelRequire("92Ghi");

var $aZBxC = parcelRequire("aZBxC");

var $aXxXZ = parcelRequire("aXxXZ");

var $dEpXg = parcelRequire("dEpXg");

var $2QOlj = parcelRequire("2QOlj");
/**
 * EDITOR-6929 / PR-G: Guard contentComponent rendering.
 * When `hasSyncedBlocks` is false return null
 * to avoid mounting SyncBlockRefresher, DeleteConfirmationModal, and Flag —
 * their hooks (useSharedPluginStateWithSelector) would execute selectors on
 * every transaction for no benefit on the ~99.98% of pages with zero synced
 * blocks.
 */ const $dfa8f7c72556ac3c$var$LazySyncedBlockUI = ({ syncBlockStore: syncBlockStoreManager, api: api, editorView: editorView, onFeedbackPromptShown: onFeedbackPromptShown, onGiveFeedback: onGiveFeedback })=>{
    const hasSyncBlocks = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'syncedBlock'
    ], (states)=>{
        var _states$syncedBlockSt;
        return (_states$syncedBlockSt = states.syncedBlockState) === null || _states$syncedBlockSt === void 0 ? void 0 : _states$syncedBlockSt.hasSyncedBlocks;
    });
    if (!hasSyncBlocks) return null;
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $dEpXg.SyncBlockRefresher), {
                syncBlockStoreManager: syncBlockStoreManager,
                api: api
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $fNUvY.DeleteConfirmationModal), {
                syncBlockStoreManager: syncBlockStoreManager,
                api: api,
                editorView: editorView
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $3BkSH.Flag), {
                api: api,
                onFeedbackPromptShown: onFeedbackPromptShown,
                onGiveFeedback: onGiveFeedback
            })
        ]
    });
};
const $dfa8f7c72556ac3c$export$4567b5886e253c5a = ({ config: config, api: api })=>{
    var _api$editorViewMode, _api$analytics, _api$blockMenu, _api$toolbar;
    const refs = {};
    const viewMode = api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode;
    const syncBlockStore = new (0, $eBzkt.SyncBlockStoreManager)(config === null || config === void 0 ? void 0 : config.syncBlockDataProvider, viewMode, config === null || config === void 0 ? void 0 : config.__livePage);
    syncBlockStore.setFireAnalyticsEvent(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 ? void 0 : _api$analytics.fireAnalyticsEvent);
    // --- Memoized getSharedState (EDITOR-6929 / PR-F) ---
    // Cache the last returned shared state object. On each call, perform a
    // shallow comparison of all fields against the cached value. If nothing
    // changed, return the cached reference so SharedStateAPI subscribers
    // (React components) skip re-rendering.
    let cachedSharedState;
    api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 || _api$blockMenu.actions.registerBlockMenuComponents((0, $ksf75.getBlockMenuComponents)(api, (config === null || config === void 0 ? void 0 : config.enableSourceCreation) ?? false));
    api === null || api === void 0 || (_api$toolbar = api.toolbar) === null || _api$toolbar === void 0 || _api$toolbar.actions.registerComponents((0, $2QOlj.getToolbarComponents)(api, (config === null || config === void 0 ? void 0 : config.enableSourceCreation) ?? false));
    const isRegisteredSlashCommandEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command');
    if (isRegisteredSlashCommandEnabled && config !== null && config !== void 0 && config.enableSourceCreation) {
        var _api$uiControlRegistr;
        api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register((0, $aZBxC.getSyncedBlockQuickInsertComponents)({
            api: api,
            syncBlockStore: syncBlockStore
        }));
    }
    return {
        name: 'syncedBlock',
        nodes () {
            return [
                {
                    name: 'syncBlock',
                    node: (0, $5vK1d.syncBlock)
                },
                {
                    name: 'bodiedSyncBlock',
                    node: (0, $3kxb2.bodiedSyncBlock)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'syncedBlockPlugin',
                    plugin: (params)=>(0, $cG0Fu.createPlugin)(config, params, syncBlockStore, api)
                },
                {
                    name: 'menuAndToolbarExperiencesPlugin',
                    plugin: ()=>(0, $gvqC8.getMenuAndToolbarExperiencesPlugin)({
                            refs: refs,
                            dispatchAnalyticsEvent: (payload)=>{
                                var _api$analytics2;
                                return api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 || (_api$analytics2 = _api$analytics2.actions) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.fireAnalyticsEvent(payload);
                            }
                        })
                }
            ];
        },
        commands: {
            copySyncedBlockReferenceToClipboard: (inputMethod)=>(0, $8hQqt.copySyncedBlockReferenceToClipboardEditorCommand)(syncBlockStore, inputMethod, api, config === null || config === void 0 ? void 0 : config.__livePage),
            insertSyncedBlock: (inputMethod)=>({ tr: tr })=>{
                    var _api$analytics3;
                    if (!(config !== null && config !== void 0 && config.enableSourceCreation)) return null;
                    return (0, $8hQqt.createSyncedBlock)({
                        tr: tr,
                        syncBlockStore: syncBlockStore,
                        fireAnalyticsEvent: api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions.fireAnalyticsEvent,
                        inputMethod: inputMethod
                    }) || null;
                }
        },
        actions: {
            flushBodiedSyncBlocks: ()=>{
                return (0, $9sTsq.flushBodiedSyncBlocks)(syncBlockStore);
            },
            flushSyncedBlocks: ()=>{
                return (0, $9sTsq.flushSyncBlocks)(syncBlockStore);
            },
            discardUnpublishedSyncBlocks: ()=>{
                return (0, $9sTsq.discardUnpublishedSyncBlocks)(syncBlockStore);
            }
        },
        pluginsOptions: {
            ...!isRegisteredSlashCommandEnabled && {
                quickInsert: (0, $92Ghi.getQuickInsertConfig)(config, api, syncBlockStore)
            },
            floatingToolbar: (state, intl)=>{
                var _syncedBlockPluginKey;
                // When registered slash-command support is on and the document has no synced blocks,
                // skip the toolbar config entirely to avoid the per-selection-change
                // cost of findSyncBlockOrBodiedSyncBlock (EDITOR-6931).
                if (!((_syncedBlockPluginKey = (0, $cG0Fu.syncedBlockPluginKey).getState(state)) !== null && _syncedBlockPluginKey !== void 0 && _syncedBlockPluginKey.hasSyncedBlocks)) return undefined;
                return (0, $deVl0.getToolbarConfig)(state, intl, api, syncBlockStore, config === null || config === void 0 ? void 0 : config.__livePage, config === null || config === void 0 ? void 0 : config.onGiveFeedback);
            }
        },
        contentComponent: ({ containerElement: containerElement, wrapperElement: wrapperElement, popupsMountPoint: popupsMountPoint, editorView: editorView })=>{
            refs.containerElement = containerElement || undefined;
            refs.popupsMountPoint = popupsMountPoint || undefined;
            refs.wrapperElement = wrapperElement || undefined;
            return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $aXxXZ.SourceSyncBlockPlaceholder), {}),
                    /*#__PURE__*/ (0, $dc70d.jsx)($dfa8f7c72556ac3c$var$LazySyncedBlockUI, {
                        syncBlockStore: syncBlockStore,
                        api: api,
                        editorView: editorView,
                        onFeedbackPromptShown: config === null || config === void 0 ? void 0 : config.onFeedbackPromptShown,
                        onGiveFeedback: config === null || config === void 0 ? void 0 : config.onGiveFeedback
                    })
                ]
            });
        },
        getSharedState: (editorState)=>{
            if (!editorState) return;
            const pluginState = (0, $cG0Fu.syncedBlockPluginKey).getState(editorState);
            const { activeFlag: activeFlag, syncBlockStore: currentSyncBlockStore, bodiedSyncBlockDeletionStatus: bodiedSyncBlockDeletionStatus, retryCreationPosMap: retryCreationPosMap, hasSyncedBlocks: hasSyncedBlocks, hasUnsavedBodiedSyncBlockChanges: hasUnsavedBodiedSyncBlockChanges } = pluginState;
            // --- EDITOR-6929 / PR-F: return a stable reference when all
            // fields are unchanged to prevent unnecessary React re-renders. ---
            if (cachedSharedState !== undefined && cachedSharedState.activeFlag === activeFlag && cachedSharedState.syncBlockStore === currentSyncBlockStore && cachedSharedState.bodiedSyncBlockDeletionStatus === bodiedSyncBlockDeletionStatus && cachedSharedState.retryCreationPosMap === retryCreationPosMap && cachedSharedState.hasSyncedBlocks === hasSyncedBlocks && cachedSharedState.hasUnsavedBodiedSyncBlockChanges === hasUnsavedBodiedSyncBlockChanges) return cachedSharedState;
            const nextSharedState = {
                activeFlag: activeFlag,
                syncBlockStore: currentSyncBlockStore,
                bodiedSyncBlockDeletionStatus: bodiedSyncBlockDeletionStatus,
                retryCreationPosMap: retryCreationPosMap,
                hasSyncedBlocks: hasSyncedBlocks,
                hasUnsavedBodiedSyncBlockChanges: hasUnsavedBodiedSyncBlockChanges
            };
            cachedSharedState = nextSharedState;
            return nextSharedState;
        },
        // Destroy the SyncBlockStoreManager on editor unmount to cancel
        // pending timers, subscriptions, and in-flight fetches.
        destroy () {
            syncBlockStore.destroy();
        }
    };
};

});
parcelRegister("eBzkt", function(module, exports) {
$parcel$export(module.exports, "SyncBlockStoreManager", () => $c623ebaf7a731c1f$export$d353efb45bc662f4);

var $bSJIT = parcelRequire("bSJIT");

var $j2Y9J = parcelRequire("j2Y9J");

var $3y2s4 = parcelRequire("3y2s4");

var $4VwxS = parcelRequire("4VwxS");

var $cSue1 = parcelRequire("cSue1");

var $hYuzB = parcelRequire("hYuzB");

var $8KNyr = parcelRequire("8KNyr");

var $iYvEr = parcelRequire("iYvEr");

var $iKeFR = parcelRequire("iKeFR");

var $aEgRx = parcelRequire("aEgRx");
class $c623ebaf7a731c1f$export$d353efb45bc662f4 {
    constructor(dataProvider, viewMode, isLivePage, options){
        this.sourceSyncBlockStoreManager = new (0, $aEgRx.SourceSyncBlockStoreManager)(dataProvider, viewMode, isLivePage);
        this.referenceSyncBlockStoreManager = new (0, $iKeFR.ReferenceSyncBlockStoreManager)(dataProvider, viewMode, this.sourceSyncBlockStoreManager);
        this.dataProvider = dataProvider;
        // Set in the constructor rather than from an effect on the consumer side:
        // reference nodes subscribe as they mount, so any later toggle would open
        // (and immediately tear down) subscriptions the surface never wanted.
        this.referenceSyncBlockStoreManager.setRealTimeSubscriptionsEnabled((options === null || options === void 0 ? void 0 : options.enableRealTimeSubscriptions) ?? true);
    }
    isSyncBlock(node) {
        return this.sourceSyncBlockStoreManager.isSourceBlock(node) || this.referenceSyncBlockStoreManager.isReferenceBlock(node);
    }
    getDocumentReferenceIds(resourceId, doc) {
        if (!doc) return undefined;
        const localIds = new Set();
        doc.descendants((node)=>{
            if (this.referenceManager.isReferenceBlock(node) && node.attrs.resourceId === resourceId && node.attrs.localId) localIds.add(node.attrs.localId);
        });
        return localIds;
    }
    async fetchReferencesSourceInfo(resourceId, blockInstanceId, isSourceSyncBlock, doc) {
        try {
            var _this$fetchReferences, _this$fetchReferences4;
            if (!this.dataProvider) throw new Error('Data provider not set');
            (_this$fetchReferences = this.fetchReferencesExperience) === null || _this$fetchReferences === void 0 || _this$fetchReferences.start();
            const response = await this.dataProvider.fetchReferences(resourceId, isSourceSyncBlock);
            if (response.error) {
                var _this$fetchReferences2;
                (_this$fetchReferences2 = this.fetchReferencesExperience) === null || _this$fetchReferences2 === void 0 || _this$fetchReferences2.failure({
                    reason: response.error
                });
                return {
                    error: response.error
                };
            }
            const patchEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_blocks_patch_12');
            const referenceResourceId = patchEnabled && isSourceSyncBlock ? this.referenceSyncBlockStoreManager.generateResourceIdForReference(resourceId) : resourceId;
            const documentIds = patchEnabled ? this.getDocumentReferenceIds(referenceResourceId, doc) : undefined;
            const localIds = patchEnabled ? documentIds ? [
                ...documentIds
            ] : this.referenceSyncBlockStoreManager.getSubscribedLocalIds(referenceResourceId) : [];
            // Saved references on this document can already have been removed in the editor.
            const references = (response.references ?? []).filter((reference)=>documentIds === undefined || !reference.onSameDocument || Boolean(reference.blockInstanceId && documentIds.has(reference.blockInstanceId)));
            if (references.length === 0 && localIds.length === 0) {
                if (documentIds !== undefined) {
                    var _this$fetchReferences3;
                    (_this$fetchReferences3 = this.fetchReferencesExperience) === null || _this$fetchReferences3 === void 0 || _this$fetchReferences3.success();
                    return {
                        references: []
                    };
                }
                return this.getUnregisteredReferences(resourceId, blockInstanceId, isSourceSyncBlock);
            }
            (_this$fetchReferences4 = this.fetchReferencesExperience) === null || _this$fetchReferences4 === void 0 || _this$fetchReferences4.success();
            const sourceInfoPromises = references.map(async (reference)=>{
                var _this$fetchSourceInfo, _this$dataProvider, _this$fetchSourceInfo3;
                if (!reference.hasAccess && (0, $3y2s4.isExperimentEnabled)('platform_editor_blocks_patch_11')) return this.fetchRestrictedReferenceInfo(reference.documentAri);
                (_this$fetchSourceInfo = this.fetchSourceInfoExperience) === null || _this$fetchSourceInfo === void 0 || _this$fetchSourceInfo.start();
                const sourceInfo = await ((_this$dataProvider = this.dataProvider) === null || _this$dataProvider === void 0 ? void 0 : _this$dataProvider.fetchSyncBlockSourceInfo(reference.blockInstanceId || '', reference.documentAri, (0, $4VwxS.getProductFromSourceAri)(reference.documentAri), reference.hasAccess));
                if (!sourceInfo) {
                    var _this$fetchSourceInfo2;
                    (_this$fetchSourceInfo2 = this.fetchSourceInfoExperience) === null || _this$fetchSourceInfo2 === void 0 || _this$fetchSourceInfo2.failure({
                        reason: `no source info returned for ari: ${reference.documentAri}`
                    });
                    return undefined;
                }
                (_this$fetchSourceInfo3 = this.fetchSourceInfoExperience) === null || _this$fetchSourceInfo3 === void 0 || _this$fetchSourceInfo3.success();
                return {
                    ...sourceInfo,
                    onSameDocument: reference.onSameDocument,
                    ...reference.locationScope !== undefined && {
                        locationScope: reference.locationScope
                    },
                    hasAccess: reference.hasAccess,
                    productType: sourceInfo.productType
                };
            });
            const sourceInfos = await Promise.all(sourceInfoPromises);
            const sourceSyncBlockData = await (isSourceSyncBlock ? this.sourceSyncBlockStoreManager.getSyncBlockSourceInfo(blockInstanceId) : this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfo(resourceId));
            if (sourceSyncBlockData) sourceInfos.push({
                ...sourceSyncBlockData,
                onSameDocument: Boolean(sourceSyncBlockData === null || sourceSyncBlockData === void 0 ? void 0 : sourceSyncBlockData.onSameDocument),
                hasAccess: true,
                isSource: true,
                productType: sourceSyncBlockData === null || sourceSyncBlockData === void 0 ? void 0 : sourceSyncBlockData.productType
            });
            // Only instances in this editor belong to its unsaved document. A matching
            // local ID on another document must not hide an unsaved copy here.
            const registeredLocalIds = new Set();
            for (const reference of references)if (reference.onSameDocument && reference.blockInstanceId) registeredLocalIds.add(reference.blockInstanceId);
            const localSourceInfos = await Promise.all(localIds.filter((localId)=>!registeredLocalIds.has(localId)).map(async (localId)=>{
                const sourceInfo = await this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfoByLocalId(localId);
                return sourceInfo ? {
                    ...sourceInfo,
                    onSameDocument: true,
                    hasAccess: true,
                    isSource: false
                } : undefined;
            }));
            sourceInfos.push(...localSourceInfos);
            return {
                references: sourceInfos
            };
        } catch (error) {
            var _this$fireAnalyticsEv;
            (0, $j2Y9J.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockStoreManager'
            });
            (_this$fireAnalyticsEv = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv === void 0 || _this$fireAnalyticsEv.call(this, (0, $hYuzB.fetchReferencesErrorPayload)(error.message, resourceId, (0, $iYvEr.getSourceProductFromResourceIdSafe)(resourceId)));
            return {
                error: (0, $cSue1.SyncBlockError).Errored
            };
        }
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.referenceSyncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
        this.sourceSyncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
        this.fetchReferencesExperience = (0, $8KNyr.getFetchReferencesExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $8KNyr.getFetchSourceInfoExperience)(fireAnalyticsEvent);
    }
    get referenceManager() {
        return this.referenceSyncBlockStoreManager;
    }
    get sourceManager() {
        return this.sourceSyncBlockStoreManager;
    }
    destroy() {
        var _this$fetchReferences5, _this$fetchSourceInfo4;
        this.referenceSyncBlockStoreManager.destroy();
        this.sourceSyncBlockStoreManager.destroy();
        (_this$fetchReferences5 = this.fetchReferencesExperience) === null || _this$fetchReferences5 === void 0 || _this$fetchReferences5.abort({
            reason: 'editorDestroyed'
        });
        (_this$fetchSourceInfo4 = this.fetchSourceInfoExperience) === null || _this$fetchSourceInfo4 === void 0 || _this$fetchSourceInfo4.abort({
            reason: 'editorDestroyed'
        });
    }
    /**
   * Keeps only the link of a location the user cannot read, so its title never reaches the UI.
   * The location still counts when the link cannot be resolved or there is no document to link to.
   */ async fetchRestrictedReferenceInfo(documentAri) {
        var _this$fetchSourceInfo5;
        if (!documentAri) return {
            sourceAri: '',
            hasAccess: false,
            onSameDocument: false
        };
        const productType = (0, $4VwxS.getProductFromSourceAri)(documentAri);
        let url;
        (_this$fetchSourceInfo5 = this.fetchSourceInfoExperience) === null || _this$fetchSourceInfo5 === void 0 || _this$fetchSourceInfo5.start();
        try {
            var _this$dataProvider2, _this$fetchSourceInfo6;
            const sourceInfo = await ((_this$dataProvider2 = this.dataProvider) === null || _this$dataProvider2 === void 0 ? void 0 : _this$dataProvider2.fetchSyncBlockSourceInfo(undefined, documentAri, productType, false));
            url = sourceInfo === null || sourceInfo === void 0 ? void 0 : sourceInfo.url;
            (_this$fetchSourceInfo6 = this.fetchSourceInfoExperience) === null || _this$fetchSourceInfo6 === void 0 || _this$fetchSourceInfo6.success();
        } catch (error) {
            var _this$fetchSourceInfo7;
            (_this$fetchSourceInfo7 = this.fetchSourceInfoExperience) === null || _this$fetchSourceInfo7 === void 0 || _this$fetchSourceInfo7.failure({
                reason: error.message
            });
        }
        return {
            sourceAri: documentAri,
            productType: productType,
            url: url,
            hasAccess: false,
            onSameDocument: false
        };
    }
    async getUnregisteredReferences(resourceId, blockInstanceId, isSourceSyncBlock) {
        var _this$fetchReferences9;
        // No reference found
        if (isSourceSyncBlock) {
            var _this$fetchReferences7;
            // Verify that a reference sync block for this specific source actually
            // exists on the current page by checking if the reference manager has
            // an active subscription for the derived reference resourceId.
            const referenceResourceId = this.referenceSyncBlockStoreManager.generateResourceIdForReference(resourceId);
            const hasUnregisteredReferenceOnPage = this.referenceSyncBlockStoreManager.getSubscribedResourceIds().includes(referenceResourceId);
            if (hasUnregisteredReferenceOnPage) {
                var _this$fetchReferences6;
                // This is current page data. It is the same for data for source and reference
                const sourceSyncBlockData = await this.sourceSyncBlockStoreManager.getSyncBlockSourceInfo(blockInstanceId);
                const references = [];
                if (sourceSyncBlockData) {
                    const sourceSyncBlockReference = {
                        ...sourceSyncBlockData,
                        onSameDocument: true,
                        hasAccess: true,
                        isSource: true
                    };
                    const referenceSyncBlockReference = {
                        ...sourceSyncBlockData,
                        onSameDocument: true,
                        hasAccess: true,
                        isSource: false
                    };
                    references.push(sourceSyncBlockReference, referenceSyncBlockReference);
                }
                (_this$fetchReferences6 = this.fetchReferencesExperience) === null || _this$fetchReferences6 === void 0 || _this$fetchReferences6.success();
                return {
                    references: references
                };
            }
            // No remote or local reference exists — show info text with link to doco on how to use Synced Blocks
            (_this$fetchReferences7 = this.fetchReferencesExperience) === null || _this$fetchReferences7 === void 0 || _this$fetchReferences7.success();
            return {
                references: []
            };
        }
        // Though no references registered yet for this reference sync block,
        // still show the source and the current page itself since they are known
        // but not saved yet.
        const references = [];
        const sourceSyncBlockData = await this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfo(resourceId);
        if (sourceSyncBlockData) references.push({
            ...sourceSyncBlockData,
            onSameDocument: Boolean(sourceSyncBlockData === null || sourceSyncBlockData === void 0 ? void 0 : sourceSyncBlockData.onSameDocument),
            hasAccess: true,
            isSource: true
        });
        const currentPageData = await this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfoByLocalId(blockInstanceId);
        if (currentPageData) references.push({
            ...currentPageData,
            onSameDocument: true,
            hasAccess: true,
            isSource: false
        });
        if (references.length === 0) {
            var _this$fetchReferences8;
            (_this$fetchReferences8 = this.fetchReferencesExperience) === null || _this$fetchReferences8 === void 0 || _this$fetchReferences8.failure({
                reason: 'No references found for reference synced block'
            });
            return {
                error: (0, $cSue1.SyncBlockError).Errored
            };
        }
        (_this$fetchReferences9 = this.fetchReferencesExperience) === null || _this$fetchReferences9 === void 0 || _this$fetchReferences9.success();
        return {
            references: references
        };
    }
}
const $c623ebaf7a731c1f$var$createSyncBlockStoreManager = (dataProvider, options)=>{
    return new $c623ebaf7a731c1f$export$d353efb45bc662f4(dataProvider, undefined, undefined, options);
};
const $c623ebaf7a731c1f$export$d95b04bc16414394 = (dataProvider, fireAnalyticsEvent, options)=>{
    // Destructured so the memo depends on the value, not on the identity of an
    // options object that callers commonly build inline.
    const enableRealTimeSubscriptions = options === null || options === void 0 ? void 0 : options.enableRealTimeSubscriptions;
    const syncBlockStoreManager = (0, $bSJIT.useMemo)(()=>{
        return $c623ebaf7a731c1f$var$createSyncBlockStoreManager(dataProvider, {
            enableRealTimeSubscriptions: enableRealTimeSubscriptions
        });
    }, [
        dataProvider,
        enableRealTimeSubscriptions
    ]);
    const prevFireAnalyticsEventRef = (0, $bSJIT.useRef)(undefined);
    if (fireAnalyticsEvent !== prevFireAnalyticsEventRef.current) {
        prevFireAnalyticsEventRef.current = fireAnalyticsEvent;
        syncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
    }
    // Destroy the SyncBlockStoreManager when:
    //   (a) the component unmounts — manager is fully cleaned up, or
    //   (b) dataProvider changes — the old manager (now orphaned by the
    //       useMemo recalculation) is destroyed before the new one takes over.
    //
    // Without this, orphaned managers leak timers, GQL subscriptions, and
    // in-flight fetches indefinitely. The effect dep is `syncBlockStoreManager`
    // (the useMemo result) — it changes identity precisely when dataProvider
    // changes, triggering the cleanup for the old instance.
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            syncBlockStoreManager.destroy();
        };
    }, [
        syncBlockStoreManager
    ]);
    return syncBlockStoreManager;
};

});
parcelRegister("4VwxS", function(module, exports) {
$parcel$export(module.exports, "getLocationScope", () => $9be55514152f47cf$export$36d45714d1e88dec);
$parcel$export(module.exports, "getProductFromSourceAri", () => $9be55514152f47cf$export$c10656f449ea0fb5);
/* eslint-disable require-unicode-regexp */ 
var $3y2s4 = parcelRequire("3y2s4");

var $2Kv7r = parcelRequire("2Kv7r");
const $9be55514152f47cf$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX = /ari:cloud:blocks:[^:]+:synced-block\/([a-zA-Z0-9-]+)/;
const $9be55514152f47cf$var$JIRA_SOURCE_ARI_REGEX = /ari:cloud:jira:.*/;
const $9be55514152f47cf$var$CONFLUENCE_SOURCE_ARI_REGEX = /ari:cloud:confluence:.*/;
const $9be55514152f47cf$export$e79189cdb9940bc5 = ({ cloudId: cloudId, parentId: parentId, product: product, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${product}/${parentId}/${resourceId}`;
};
const $9be55514152f47cf$export$92a2331f8a9ed841 = ({ cloudId: cloudId, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${resourceId}`;
};
const $9be55514152f47cf$export$3f0878b0afe5a2c0 = (ari)=>{
    const match = ari.match($9be55514152f47cf$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX);
    if (match !== null && match !== void 0 && match[1]) return match[1];
    throw new Error(`Invalid block ARI: ${ari}`);
};
const $9be55514152f47cf$export$36d45714d1e88dec = ({ documentAri: documentAri, hostAri: hostAri })=>{
    if (documentAri === hostAri) return 'same-document';
    const location = (0, $2Kv7r.parseJiraFieldLocation)({
        ari: documentAri
    });
    const hostLocation = (0, $2Kv7r.parseJiraFieldLocation)({
        ari: hostAri
    });
    if (!location || !hostLocation || location.issueAri !== hostLocation.issueAri) return 'elsewhere';
    return location.fieldId === hostLocation.fieldId ? 'same-document' : 'same-parent-document';
};
const $9be55514152f47cf$export$c10656f449ea0fb5 = (ari)=>{
    if (!ari && (0, $3y2s4.isExperimentEnabled)('platform_editor_blocks_patch_11')) return undefined;
    const jiraMatch = ari === null || ari === void 0 ? void 0 : ari.search($9be55514152f47cf$var$JIRA_SOURCE_ARI_REGEX);
    if (jiraMatch !== -1) return 'jira-work-item';
    const confluenceMatch = ari === null || ari === void 0 ? void 0 : ari.search($9be55514152f47cf$var$CONFLUENCE_SOURCE_ARI_REGEX);
    if (confluenceMatch !== -1) return 'confluence-page';
    return undefined;
};

});
parcelRegister("2Kv7r", function(module, exports) {
$parcel$export(module.exports, "JIRA_DESCRIPTION_FIELD_ID", () => $6ebcf7b066f77e3e$export$335defc86b234ea0);
$parcel$export(module.exports, "parseJiraFieldLocation", () => $6ebcf7b066f77e3e$export$decd92eb8dd00bf5);
/* eslint-disable require-unicode-regexp  */ const $6ebcf7b066f77e3e$var$JIRA_WORK_ITEM_ARI_REGEX = /ari:cloud:jira:([^:]+):issue\/(\d+)/;
const $6ebcf7b066f77e3e$var$JIRA_ISSUE_FIELD_VALUE_ARI_REGEX = /ari:cloud:jira:([^:]+):issuefieldvalue\/([^/]+)\/([^/]+)/;
const $6ebcf7b066f77e3e$export$e7d6f26185793d4f = ({ cloudId: cloudId, workItemId: workItemId })=>{
    return `ari:cloud:jira:${cloudId}:issue/${workItemId}`;
};
const $6ebcf7b066f77e3e$var$getFieldValueAriParts = (ari)=>{
    const match = ari.match($6ebcf7b066f77e3e$var$JIRA_ISSUE_FIELD_VALUE_ARI_REGEX);
    if (match !== null && match !== void 0 && match[1] && match[2] && match[3]) return {
        cloudId: match[1],
        issueId: match[2],
        fieldId: match[3]
    };
    return undefined;
};
const $6ebcf7b066f77e3e$export$3ee1e41ffca0b1ff = ({ ari: ari })=>{
    const match = ari.match($6ebcf7b066f77e3e$var$JIRA_WORK_ITEM_ARI_REGEX);
    if (match !== null && match !== void 0 && match[2]) return match[2];
    const fieldValueParts = $6ebcf7b066f77e3e$var$getFieldValueAriParts(ari);
    if (fieldValueParts) return fieldValueParts.issueId;
    throw new Error(`Invalid Jira work item ARI: ${ari}`);
};
const $6ebcf7b066f77e3e$export$9d29a8e91440be5c = ({ ari: ari })=>{
    const fieldValueParts = $6ebcf7b066f77e3e$var$getFieldValueAriParts(ari);
    if (fieldValueParts) return $6ebcf7b066f77e3e$export$e7d6f26185793d4f({
        cloudId: fieldValueParts.cloudId,
        workItemId: fieldValueParts.issueId
    });
    return ari;
};
const $6ebcf7b066f77e3e$export$335defc86b234ea0 = 'description';
const $6ebcf7b066f77e3e$var$toJiraFieldLocation = ({ cloudId: cloudId, fieldId: fieldId, issueId: issueId })=>({
        fieldId: fieldId,
        issueAri: $6ebcf7b066f77e3e$export$e7d6f26185793d4f({
            cloudId: cloudId,
            workItemId: issueId
        })
    });
const $6ebcf7b066f77e3e$export$decd92eb8dd00bf5 = ({ ari: ari })=>{
    const workItemMatch = ari.match($6ebcf7b066f77e3e$var$JIRA_WORK_ITEM_ARI_REGEX);
    if (workItemMatch !== null && workItemMatch !== void 0 && workItemMatch[1] && workItemMatch[2]) return $6ebcf7b066f77e3e$var$toJiraFieldLocation({
        cloudId: workItemMatch[1],
        fieldId: $6ebcf7b066f77e3e$export$335defc86b234ea0,
        issueId: workItemMatch[2]
    });
    const fieldValueParts = $6ebcf7b066f77e3e$var$getFieldValueAriParts(ari);
    return fieldValueParts && $6ebcf7b066f77e3e$var$toJiraFieldLocation(fieldValueParts);
};

});


parcelRegister("cSue1", function(module, exports) {
$parcel$export(module.exports, "SyncBlockError", () => $e40fc681dd185106$export$686dd843fdf311d4);
$parcel$export(module.exports, "ProviderNotReadyError", () => $e40fc681dd185106$export$ca0858d4f5eeeac);
$parcel$export(module.exports, "isProviderNotReadyError", () => $e40fc681dd185106$export$7ba508051f94701f);
var $e40fc681dd185106$export$686dd843fdf311d4 = /*#__PURE__*/ function(SyncBlockError) {
    SyncBlockError["Errored"] = "errored";
    SyncBlockError["NotFound"] = "not_found";
    SyncBlockError["Forbidden"] = "forbidden";
    SyncBlockError["InvalidRequest"] = "invalid_request";
    SyncBlockError["RateLimited"] = "rate_limited";
    SyncBlockError["Conflict"] = "conflict";
    // attempt to create block that already exists
    SyncBlockError["ServerError"] = "server_error";
    SyncBlockError["InvalidContent"] = "invalid_content";
    // content is not a valid JSON
    SyncBlockError["Offline"] = "offline";
    SyncBlockError["Unpublished"] = "unpublished";
    // request was aborted, typically due to client timeout
    SyncBlockError["Aborted"] = "aborted";
    // block does not exist on this site (e.g. cross-site reference or hard deleted)
    SyncBlockError["EntityNotFound"] = "entity_not_found";
    return SyncBlockError;
}({});
const $e40fc681dd185106$export$7486a7adf8b0d591 = 'Data provider not set';
class $e40fc681dd185106$export$ca0858d4f5eeeac extends Error {
    constructor(message = $e40fc681dd185106$export$7486a7adf8b0d591){
        super(message), this.isProviderNotReadyError = true;
        this.name = 'ProviderNotReadyError';
        // Restore prototype chain so instanceof works after transpilation.
        Object.setPrototypeOf(this, $e40fc681dd185106$export$ca0858d4f5eeeac.prototype);
    }
}
const $e40fc681dd185106$export$7ba508051f94701f = (error)=>{
    if (error instanceof $e40fc681dd185106$export$ca0858d4f5eeeac) return true;
    if (typeof error === 'object' && error !== null && error.isProviderNotReadyError === true) return true;
    return error instanceof Error && error.message === $e40fc681dd185106$export$7486a7adf8b0d591;
};

});

parcelRegister("hYuzB", function(module, exports) {
$parcel$export(module.exports, "getPiiSafeOriginalError", () => $5ff8c1dc7fbe29b7$export$74ce7fda6da1109);
$parcel$export(module.exports, "buildErrorAttribution", () => $5ff8c1dc7fbe29b7$export$78792f4ddc3998e8);
$parcel$export(module.exports, "buildFetchErrorAttribution", () => $5ff8c1dc7fbe29b7$export$4ae89cef01c11c46);
$parcel$export(module.exports, "fetchErrorPayload", () => $5ff8c1dc7fbe29b7$export$94dcd08406353dba);
$parcel$export(module.exports, "getSourceInfoErrorPayload", () => $5ff8c1dc7fbe29b7$export$c5131f589148b9d3);
$parcel$export(module.exports, "updateErrorPayload", () => $5ff8c1dc7fbe29b7$export$adc2363832f8735d);
$parcel$export(module.exports, "updateReferenceErrorPayload", () => $5ff8c1dc7fbe29b7$export$154595d209a77913);
$parcel$export(module.exports, "createErrorPayload", () => $5ff8c1dc7fbe29b7$export$5d2f0c264cf49280);
$parcel$export(module.exports, "deleteErrorPayload", () => $5ff8c1dc7fbe29b7$export$cd0aaab38ff32ec2);
$parcel$export(module.exports, "updateCacheErrorPayload", () => $5ff8c1dc7fbe29b7$export$e40ed1768baf5d1e);
$parcel$export(module.exports, "sourceInfoOrphanedPayload", () => $5ff8c1dc7fbe29b7$export$5665a31a69693485);
$parcel$export(module.exports, "cacheDeletionForcedPayload", () => $5ff8c1dc7fbe29b7$export$82f9608c8438ecb2);
$parcel$export(module.exports, "fetchReferencesErrorPayload", () => $5ff8c1dc7fbe29b7$export$ebf3ba305f3f0e1a);
$parcel$export(module.exports, "fetchSuccessPayload", () => $5ff8c1dc7fbe29b7$export$b20c56c32ea6ad76);
$parcel$export(module.exports, "createSuccessPayload", () => $5ff8c1dc7fbe29b7$export$5b8e0915870366d0);
$parcel$export(module.exports, "createSuccessOperationalPayload", () => $5ff8c1dc7fbe29b7$export$23e42fbf8039414c);
$parcel$export(module.exports, "addContentSuccessPayload", () => $5ff8c1dc7fbe29b7$export$c76f6dd50db89cda);
$parcel$export(module.exports, "updateSuccessPayload", () => $5ff8c1dc7fbe29b7$export$f2b4214fae56af83);
$parcel$export(module.exports, "deleteSuccessPayload", () => $5ff8c1dc7fbe29b7$export$2283f5d682476cde);

var $g6Qq4 = parcelRequire("g6Qq4");

var $cSue1 = parcelRequire("cSue1");
const $5ff8c1dc7fbe29b7$export$7fc2c997455452c8 = (error)=>{
    try {
        return JSON.stringify(error);
    } catch  {
        return undefined;
    }
};
const $5ff8c1dc7fbe29b7$export$74ce7fda6da1109 = (error)=>{
    if (error instanceof Error) return {
        ...error.message && {
            originalMessage: error.message
        },
        ...error.name && {
            originalName: error.name
        }
    };
    return {};
};
const $5ff8c1dc7fbe29b7$var$SYNC_BLOCK_ERROR_REASONS = new Set(Object.values((0, $cSue1.SyncBlockError)));
const $5ff8c1dc7fbe29b7$export$3bf11deac13e0617 = (error)=>{
    if (error && $5ff8c1dc7fbe29b7$var$SYNC_BLOCK_ERROR_REASONS.has(error)) return error;
    return 'unknown';
};
const $5ff8c1dc7fbe29b7$export$78792f4ddc3998e8 = (error, statusCode)=>{
    return {
        reason: $5ff8c1dc7fbe29b7$export$3bf11deac13e0617(error),
        ...statusCode !== undefined && {
            statusCode: statusCode
        }
    };
};
const $5ff8c1dc7fbe29b7$export$9bd766f5cc31fe3b = new Set([
    'source_deleted',
    'source_unpublished',
    'source_unsynced',
    'source_not_found',
    'permission_denied',
    'unauthenticated',
    // Mirror the benign write-path enum equivalents so already-classified errors are
    // treated consistently.
    'not_found',
    'forbidden',
    'unpublished',
    // `offline` is an expected client connectivity state, not a read-path system failure:
    // the error component is rendered for the offline experience, so it should not inflate
    // the true error rate. It still emits `reason` (so its volume can be inspected) but is
    // excluded from true-error counts.
    'offline'
]);
/**
 * Ordered list of substring matchers mapping known free-text fetch/subscribe error
 * strings to a categorical {@link SyncBlockFetchErrorReason}. Each entry is a list of
 * lowercase needles; if ANY needle is found (case-insensitively) in the raw `error`
 * string, the entry's reason is used. Order matters: more specific entries must precede
 * more general ones.
 *
 * Plain `String.includes` substring matching is used deliberately instead of `RegExp`:
 * it sidesteps the `require-unicode-regexp` lint rule AND the declaration build's lower
 * compile target (which rejects the regex `u` flag with TS1501), while being faster and
 * easier to read. Doing this classification in code (rather than in dashboard SQL) keeps
 * the buckets versioned with the source strings that produce them (EDITOR-7862).
 */ const $5ff8c1dc7fbe29b7$var$FETCH_REASON_MATCHERS = [
    // Benign: source-state transitions (deletionReason values + free text).
    [
        [
            'source-document-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-unpublished'
        ],
        'source_unpublished'
    ],
    [
        [
            'source-block-unsynced'
        ],
        'source_unsynced'
    ],
    [
        [
            'does not exist'
        ],
        'source_not_found'
    ],
    [
        [
            'unpublished'
        ],
        'source_unpublished'
    ],
    // Working-as-designed permission outcomes.
    [
        [
            'unauthenticated'
        ],
        'unauthenticated'
    ],
    [
        [
            'not permitted to read synced block'
        ],
        'permission_denied'
    ],
    [
        [
            'bulk permission check failed'
        ],
        'permission_denied'
    ],
    [
        [
            'permission denied'
        ],
        'permission_denied'
    ],
    // Genuine system failures.
    [
        [
            'reconnection failed after'
        ],
        'websocket_exhausted'
    ],
    // `reconnect to the subscription` (not a bare `reconnect`) avoids false positives on
    // unrelated DB/GraphQL "reconnect" messages while still matching the WS-drop string.
    [
        [
            'websocket',
            'reconnect to the subscription',
            'subscription terminated'
        ],
        'websocket_drop'
    ],
    [
        [
            '429',
            'rate limit',
            'rate-limit',
            'ratelimit'
        ],
        'rate_limited'
    ],
    // `econnrefused`/`econnreset` (not a bare `econn`, which would also match `reconnect`).
    [
        [
            'network',
            'failed to fetch',
            'econnrefused',
            'econnreset',
            'timed out',
            'timeout'
        ],
        'network'
    ],
    [
        [
            'data provider not set'
        ],
        'data_provider_not_ready'
    ]
];
const $5ff8c1dc7fbe29b7$export$b7fb09a58aa76c55 = (error)=>{
    const enumReason = $5ff8c1dc7fbe29b7$export$3bf11deac13e0617(error);
    if (enumReason !== 'unknown') return enumReason;
    if (error) {
        const haystack = error.toLowerCase();
        for (const [needles, reason] of $5ff8c1dc7fbe29b7$var$FETCH_REASON_MATCHERS){
            if (needles.some((needle)=>haystack.includes(needle))) return reason;
        }
    }
    return 'unknown';
};
const $5ff8c1dc7fbe29b7$export$4ae89cef01c11c46 = (error, statusCode, deferred)=>{
    const reason = $5ff8c1dc7fbe29b7$export$b7fb09a58aa76c55(error);
    return {
        reason: reason,
        // A deferred (tab-hidden) exhaustion is benign regardless of reason bucket.
        benign: deferred === true || $5ff8c1dc7fbe29b7$export$9bd766f5cc31fe3b.has(reason),
        ...statusCode !== undefined && {
            statusCode: statusCode
        },
        ...deferred === true && {
            deferred: true
        }
    };
};
function $5ff8c1dc7fbe29b7$export$999ed1af1b20ac2d(actionSubjectId, error, resourceId, sourceProduct, attribution, sourceLocation) {
    return {
        action: (0, $g6Qq4.ACTION).ERROR,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: actionSubjectId,
        eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
        attributes: {
            error: error,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...sourceLocation && {
                sourceLocation: sourceLocation
            },
            ...(attribution === null || attribution === void 0 ? void 0 : attribution.reason) && {
                reason: attribution.reason
            },
            ...(attribution === null || attribution === void 0 ? void 0 : attribution.statusCode) !== undefined && {
                statusCode: attribution.statusCode
            },
            // `benign` is only present on fetch/subscribe attribution (EDITOR-7862). It is a
            // boolean (never UGC); the `'benign' in attribution` check both guards the
            // write-path attribution (which has no `benign`) and narrows the union so
            // `attribution.benign` is accessible.
            ...attribution && 'benign' in attribution && {
                benign: attribution.benign
            },
            // `deferred` is only present on fetch/subscribe attribution, and only when a
            // tab-hidden exhaustion was deferred rather than surfaced. Boolean, never UGC.
            ...attribution && 'deferred' in attribution && attribution.deferred === true && {
                deferred: true
            }
        }
    };
}
const $5ff8c1dc7fbe29b7$export$94dcd08406353dba = (error, resourceId, sourceProduct, attribution)=>// Branch on attribution presence so each call resolves to a concrete overload: with
    // attribution it hits the fetch overload (wider `reason`); without it, the
    // no-attribution overload. Both produce a fetch event regardless.
    attribution ? $5ff8c1dc7fbe29b7$export$999ed1af1b20ac2d((0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct, attribution) : $5ff8c1dc7fbe29b7$export$999ed1af1b20ac2d((0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct);
const $5ff8c1dc7fbe29b7$export$c5131f589148b9d3 = (error, resourceId, sourceProduct, sourceLocation)=>$5ff8c1dc7fbe29b7$export$999ed1af1b20ac2d((0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_GET_SOURCE_INFO, error, resourceId, sourceProduct, undefined, sourceLocation);
const $5ff8c1dc7fbe29b7$export$adc2363832f8735d = (error, resourceId, sourceProduct, attribution)=>$5ff8c1dc7fbe29b7$export$999ed1af1b20ac2d((0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $5ff8c1dc7fbe29b7$export$154595d209a77913 = (error, resourceId, sourceProduct, attribution)=>$5ff8c1dc7fbe29b7$export$999ed1af1b20ac2d((0, $g6Qq4.ACTION_SUBJECT_ID).REFERENCE_SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $5ff8c1dc7fbe29b7$export$5d2f0c264cf49280 = (error, resourceId, sourceProduct, attribution, sourceLocation)=>$5ff8c1dc7fbe29b7$export$999ed1af1b20ac2d((0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE, error, resourceId, sourceProduct, attribution, sourceLocation);
const $5ff8c1dc7fbe29b7$export$cd0aaab38ff32ec2 = (error, resourceId, sourceProduct, attribution)=>$5ff8c1dc7fbe29b7$export$999ed1af1b20ac2d((0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE, error, resourceId, sourceProduct, attribution);
const $5ff8c1dc7fbe29b7$export$e40ed1768baf5d1e = (error, resourceId, sourceProduct)=>$5ff8c1dc7fbe29b7$export$999ed1af1b20ac2d((0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE_CACHE, error, resourceId, sourceProduct);
const $5ff8c1dc7fbe29b7$export$5665a31a69693485 = (resourceId, sourceProduct, context)=>({
        action: (0, $g6Qq4.ACTION).ERROR,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_SOURCE_INFO_ORPHANED,
        eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
        attributes: {
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...(context === null || context === void 0 ? void 0 : context.hasPendingDeletion) !== undefined && {
                hasPendingDeletion: context.hasPendingDeletion
            },
            ...(context === null || context === void 0 ? void 0 : context.hasSubscribers) !== undefined && {
                hasSubscribers: context.hasSubscribers
            }
        }
    });
const $5ff8c1dc7fbe29b7$export$82f9608c8438ecb2 = (rescheduleCount, resourceId, sourceProduct)=>({
        action: (0, $g6Qq4.ACTION).ERROR,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_CACHE_DELETION_FORCED,
        eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
        attributes: {
            rescheduleCount: rescheduleCount,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5ff8c1dc7fbe29b7$export$ebf3ba305f3f0e1a = (error, resourceId, sourceProduct)=>$5ff8c1dc7fbe29b7$export$999ed1af1b20ac2d((0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH_REFERENCES, error, resourceId, sourceProduct);
const $5ff8c1dc7fbe29b7$export$b20c56c32ea6ad76 = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $g6Qq4.ACTION).FETCHED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH,
        eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            blockInstanceId: blockInstanceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5ff8c1dc7fbe29b7$export$5b8e0915870366d0 = (resourceId, sourceProduct, sourceLocation)=>{
    return {
        action: (0, $g6Qq4.ACTION).INSERTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).BODIED_SYNCED_BLOCK,
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...sourceLocation && {
                sourceLocation: sourceLocation
            }
        }
    };
};
const $5ff8c1dc7fbe29b7$export$23e42fbf8039414c = (resourceId, blockInstanceId, sourceProduct, enrichment, sourceLocation)=>{
    var _enrichment$nodeTypes;
    return {
        action: (0, $g6Qq4.ACTION).INSERTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
        eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...(enrichment === null || enrichment === void 0 ? void 0 : enrichment.inputMethod) && {
                inputMethod: enrichment.inputMethod
            },
            ...(enrichment === null || enrichment === void 0 ? void 0 : enrichment.createdEmpty) !== undefined && {
                createdEmpty: enrichment.createdEmpty
            },
            ...(enrichment === null || enrichment === void 0 || (_enrichment$nodeTypes = enrichment.nodeTypes) === null || _enrichment$nodeTypes === void 0 ? void 0 : _enrichment$nodeTypes.length) && {
                nodeTypes: enrichment.nodeTypes
            },
            ...sourceLocation && {
                sourceLocation: sourceLocation
            }
        }
    };
};
const $5ff8c1dc7fbe29b7$export$c76f6dd50db89cda = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $g6Qq4.ACTION).ADDED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_ADD_CONTENT,
        eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5ff8c1dc7fbe29b7$export$f2b4214fae56af83 = (resourceId, hasReference, sourceProduct)=>({
        action: (0, $g6Qq4.ACTION).UPDATED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE,
        eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...hasReference !== undefined && {
                hasReference: hasReference
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5ff8c1dc7fbe29b7$export$2283f5d682476cde = (resourceId, sourceProduct, enrichment)=>({
        action: (0, $g6Qq4.ACTION).DELETED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE,
        eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...(enrichment === null || enrichment === void 0 ? void 0 : enrichment.blockInstanceId) && {
                blockInstanceId: enrichment.blockInstanceId
            },
            ...(enrichment === null || enrichment === void 0 ? void 0 : enrichment.deletionReason) && {
                deletionReason: enrichment.deletionReason
            },
            ...(enrichment === null || enrichment === void 0 ? void 0 : enrichment.mechanism) && {
                mechanism: enrichment.mechanism
            }
        }
    });

});

parcelRegister("8KNyr", function(module, exports) {
$parcel$export(module.exports, "getSaveSourceExperience", () => $382a9430c959872f$export$553df56755696c09);
$parcel$export(module.exports, "getSaveReferenceExperience", () => $382a9430c959872f$export$188e7890e84f55e4);
$parcel$export(module.exports, "getFetchExperience", () => $382a9430c959872f$export$bbbbcdec37b3c0c0);
$parcel$export(module.exports, "getFetchSourceInfoExperience", () => $382a9430c959872f$export$cf32ad2bf7484097);
$parcel$export(module.exports, "getDeleteSourceExperience", () => $382a9430c959872f$export$666920a07aaa7d43);
$parcel$export(module.exports, "getCreateSourceExperience", () => $382a9430c959872f$export$bf943e4a2bda18f6);
$parcel$export(module.exports, "getFetchReferencesExperience", () => $382a9430c959872f$export$3ba8782eb93c9adf);

var $g6Qq4 = parcelRequire("g6Qq4");

var $bApp6 = parcelRequire("bApp6");

var $b8RGE = parcelRequire("b8RGE");

var $9skTL = parcelRequire("9skTL");
const $382a9430c959872f$var$TIMEOUT_DURATION = 30000;
const $382a9430c959872f$export$b335cfa3334e49e6 = (fireAnalyticsEvent)=>{
    return (payload)=>{
        // Runtime type guard - only forward experience events
        if (payload.action === (0, $g6Qq4.ACTION).EXPERIENCE_MEASURED || payload.action === (0, $g6Qq4.ACTION).EXPERIENCE_SAMPLED) fireAnalyticsEvent === null || fireAnalyticsEvent === void 0 || fireAnalyticsEvent(payload);
    };
};
const $382a9430c959872f$export$553df56755696c09 = (fireAnalyticsEvent)=>{
    return new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $g6Qq4.ACTION).SYNCED_BLOCK_UPDATE,
        dispatchAnalyticsEvent: $382a9430c959872f$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $382a9430c959872f$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $382a9430c959872f$export$188e7890e84f55e4 = (fireAnalyticsEvent)=>{
    return new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $g6Qq4.ACTION).REFERENCE_SYNCED_BLOCK_UPDATE,
        dispatchAnalyticsEvent: $382a9430c959872f$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $382a9430c959872f$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $382a9430c959872f$export$bbbbcdec37b3c0c0 = (fireAnalyticsEvent)=>{
    return new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $g6Qq4.ACTION).SYNCED_BLOCK_FETCH,
        dispatchAnalyticsEvent: $382a9430c959872f$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $382a9430c959872f$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $382a9430c959872f$export$cf32ad2bf7484097 = (fireAnalyticsEvent)=>{
    return new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $g6Qq4.ACTION).SYNCED_BLOCK_GET_SOURCE_INFO,
        dispatchAnalyticsEvent: $382a9430c959872f$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $382a9430c959872f$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $382a9430c959872f$export$666920a07aaa7d43 = (fireAnalyticsEvent)=>{
    return new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $g6Qq4.ACTION).SYNCED_BLOCK_DELETE,
        dispatchAnalyticsEvent: $382a9430c959872f$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $382a9430c959872f$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $382a9430c959872f$export$bf943e4a2bda18f6 = (fireAnalyticsEvent)=>{
    return new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $g6Qq4.ACTION).SYNCED_BLOCK_CREATE,
        dispatchAnalyticsEvent: $382a9430c959872f$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $382a9430c959872f$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $382a9430c959872f$export$3ba8782eb93c9adf = (fireAnalyticsEvent)=>{
    return new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $g6Qq4.ACTION).SYNCED_BLOCK_FETCH_REFERENCES,
        dispatchAnalyticsEvent: $382a9430c959872f$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $382a9430c959872f$var$TIMEOUT_DURATION
            })
        ]
    });
};

});

parcelRegister("iYvEr", function(module, exports) {
$parcel$export(module.exports, "normalizeSyncBlockJSONContent", () => $520fee8544724304$export$b223a7607ed061dc);
$parcel$export(module.exports, "convertSyncBlockPMNodeToSyncBlockData", () => $520fee8544724304$export$aafb32b192c8228c);
$parcel$export(module.exports, "createSyncBlockNode", () => $520fee8544724304$export$c5b34fb9069ebb1d);
$parcel$export(module.exports, "convertPMNodesToSyncBlockNodes", () => $520fee8544724304$export$18b85168a73dad03);
$parcel$export(module.exports, "getSourceProductFromResourceIdSafe", () => $520fee8544724304$export$31cbe0bed21e05b1);
/* eslint-disable require-unicode-regexp  */ const $520fee8544724304$var$GET_CONTENT_ID_AND_PRODUCT_REGEX = /^(confluence-page|jira-work-item)\/([^/]+)/;
const $520fee8544724304$var$normalizeSyncBlockJSONContentInternal = (content, options)=>{
    let normalizedContent;
    content.forEach((contentNode, index)=>{
        var _contentNode$marks;
        if (!contentNode) {
            var _normalizedContent;
            (_normalizedContent = normalizedContent) === null || _normalizedContent === void 0 || _normalizedContent.push(contentNode);
            return;
        }
        const hasAnnotationMark = (_contentNode$marks = contentNode.marks) === null || _contentNode$marks === void 0 ? void 0 : _contentNode$marks.some((mark)=>mark.type === 'annotation');
        const shouldConvertPanelC1 = options.convertPanelC1ToPanel && contentNode.type === 'panel_c1';
        const childContent = contentNode.content ? $520fee8544724304$var$normalizeSyncBlockJSONContentInternal(contentNode.content, options) : undefined;
        const hasContentChanged = childContent !== undefined && childContent !== contentNode.content;
        if (!hasAnnotationMark && !shouldConvertPanelC1 && !hasContentChanged) {
            var _normalizedContent2;
            (_normalizedContent2 = normalizedContent) === null || _normalizedContent2 === void 0 || _normalizedContent2.push(contentNode);
            return;
        }
        if (!normalizedContent) normalizedContent = content.slice(0, index);
        const normalizedNode = {
            ...contentNode
        };
        if (shouldConvertPanelC1) normalizedNode.type = 'panel';
        if (hasAnnotationMark) {
            var _contentNode$marks2;
            const marks = (_contentNode$marks2 = contentNode.marks) === null || _contentNode$marks2 === void 0 ? void 0 : _contentNode$marks2.filter((mark)=>mark.type !== 'annotation');
            if (marks && marks.length > 0) normalizedNode.marks = marks;
            else delete normalizedNode.marks;
        }
        if (hasContentChanged && childContent) normalizedNode.content = childContent;
        normalizedContent.push(normalizedNode);
    });
    return normalizedContent ?? content;
};
const $520fee8544724304$export$19bb1d88f473b9c5 = (content)=>{
    return $520fee8544724304$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: false
    });
};
const $520fee8544724304$export$b223a7607ed061dc = (content)=>{
    return $520fee8544724304$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: true
    });
};
const $520fee8544724304$export$aafb32b192c8228c = (node)=>{
    const content = node.content.toJSON();
    return {
        blockInstanceId: node.attrs.localId,
        content: content ? $520fee8544724304$export$b223a7607ed061dc(content) : content,
        resourceId: node.attrs.resourceId
    };
};
const $520fee8544724304$export$c5b34fb9069ebb1d = (localId, resourceId)=>{
    return {
        type: 'syncBlock',
        attrs: {
            localId: localId,
            resourceId: resourceId
        }
    };
};
const $520fee8544724304$export$cd9b0caaea319019 = (node)=>{
    if (node.type !== 'syncBlock' || !node.attrs || !('localId' in node.attrs) || !('resourceId' in node.attrs) || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $520fee8544724304$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $520fee8544724304$export$648ff8dd259e0d9c = (node)=>{
    var _node$attrs, _node$attrs2;
    if (node.type.name !== 'syncBlock' || !((_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.localId) || !((_node$attrs2 = node.attrs) !== null && _node$attrs2 !== void 0 && _node$attrs2.resourceId) || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $520fee8544724304$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $520fee8544724304$export$18b85168a73dad03 = (nodes)=>{
    return nodes.map((node)=>$520fee8544724304$export$648ff8dd259e0d9c(node)).filter((node)=>node !== undefined);
};
const $520fee8544724304$export$2cf4a74c3e18f31a = (resourceId)=>{
    const match = resourceId.match($520fee8544724304$var$GET_CONTENT_ID_AND_PRODUCT_REGEX);
    if (match !== null && match !== void 0 && match[2]) return {
        sourceProduct: match[1],
        sourceContentId: match[2]
    };
    throw new Error(`Invalid resourceId: ${resourceId}`);
};
const $520fee8544724304$export$31cbe0bed21e05b1 = (resourceId)=>{
    if (!resourceId) return undefined;
    try {
        return $520fee8544724304$export$2cf4a74c3e18f31a(resourceId).sourceProduct;
    } catch  {
        return undefined;
    }
};
const $520fee8544724304$export$4c6687d128f55da5 = (contentUpdatedAt)=>{
    if (typeof contentUpdatedAt === 'number') try {
        return new Date(contentUpdatedAt).toISOString();
    } catch  {
        return undefined;
    }
    return undefined;
};

});

parcelRegister("iKeFR", function(module, exports) {
$parcel$export(module.exports, "ReferenceSyncBlockStoreManager", () => $de344b577f3b06fb$export$fb04276dca31302e);

var $dMMwa = parcelRequire("dMMwa");

var $j2Y9J = parcelRequire("j2Y9J");

var $3y2s4 = parcelRequire("3y2s4");

var $cSue1 = parcelRequire("cSue1");

var $hYuzB = parcelRequire("hYuzB");

var $8KNyr = parcelRequire("8KNyr");

var $idDos = parcelRequire("idDos");

var $h5k7t = parcelRequire("h5k7t");

var $kQGqU = parcelRequire("kQGqU");

var $iYvEr = parcelRequire("iYvEr");

var $2cmK7 = parcelRequire("2cmK7");

var $3PQZm = parcelRequire("3PQZm");

var $7gkMl = parcelRequire("7gkMl");

var $fuqSN = parcelRequire("fuqSN");
const $de344b577f3b06fb$var$CACHE_KEY_PREFIX = 'sync-block-data-';
const $de344b577f3b06fb$var$ENTITY_NOT_FOUND_MAX_RETRIES = 3;
const $de344b577f3b06fb$var$ENTITY_NOT_FOUND_INITIAL_DELAY_MS = 2000;
// Grace period before a cache entry is removed after the last subscriber
// unsubscribes. Guards are
// re-checked at fire time; if any are positive, the timer is rescheduled.
const $de344b577f3b06fb$var$CACHE_DELETION_GRACE_PERIOD_MS = 30000;
// Max reschedules before force-deleting with an analytics event (~5 min).
const $de344b577f3b06fb$var$CACHE_DELETION_MAX_RESCHEDULES = 10;
class $de344b577f3b06fb$export$fb04276dca31302e {
    constructor(dataProvider, viewMode, sourceManager){
        // Keeps track of addition and deletion of reference synced blocks on the document
        // This starts as true to always flush the cache when document is saved for the first time
        // to cater the case when a editor session is closed without document being updated right after reference block is deleted
        this.isCacheDirty = true;
        // Keep track of the last flushed subscriptions to optimize cache flushing on document save
        this.lastFlushedSyncedBlocks = {};
        this.subscribedSinceLastFlush = false;
        // Track if a flush operation is currently in progress
        this.isFlushInProgress = false;
        // Track if another flush is needed after the current one completes
        this.flushNeededAfterCurrent = false;
        // Track retry attempts for EntityNotFound errors (block may be in the process of being created)
        this.entityNotFoundRetryCount = new Map();
        this.entityNotFoundRetryTimers = new Map();
        // Pending cache deletion timers keyed by resourceId. Cancelled when a subscriber re-attaches.
        this.pendingCacheDeletions = new Map();
        // Reschedule counter per resource — reset on actual deletion or re-subscribe.
        this.cacheDeletionRescheduleCounts = new Map();
        // Set by destroy() so in-flight timer callbacks can early-return.
        this.isDestroyed = false;
        var _this$dataProvider;
        this.dataProvider = dataProvider;
        this.viewMode = viewMode;
        this.sourceManager = sourceManager;
        this.syncBlockFetchDataRequests = new Map();
        this.syncBlockSourceInfoRequests = new Map();
        this.newlyAddedSyncBlocks = new Set();
        this._subscriptionManager = new (0, $fuqSN.SyncBlockSubscriptionManager)({
            getDataProvider: ()=>this.dataProvider,
            getFromCache: (rid)=>this.getFromCache(rid),
            updateCache: (inst)=>this.updateCache(inst),
            debouncedBatchedFetchSyncBlocks: (rid)=>this.debouncedBatchedFetchSyncBlocks(rid),
            fetchSyncBlockSourceInfo: (rid)=>this.fetchSyncBlockSourceInfo(rid),
            getFireAnalyticsEvent: ()=>this.fireAnalyticsEvent,
            markCacheDirty: ()=>{
                this.isCacheDirty = true;
            },
            // Delegate cache lifecycle to the store manager so guards can be
            // checked atomically.
            scheduleCacheDeletion: (rid)=>this.scheduleCacheDeletion(rid),
            cancelPendingCacheDeletion: (rid)=>this.cancelPendingCacheDeletion(rid)
        });
        this._providerFactoryManager = new (0, $7gkMl.SyncBlockProviderFactoryManager)({
            getDataProvider: ()=>this.dataProvider,
            getFromCache: (rid)=>this.getFromCache(rid),
            getFireAnalyticsEvent: ()=>this.fireAnalyticsEvent
        });
        this._batchFetcher = new (0, $2cmK7.SyncBlockBatchFetcher)({
            getSubscriptions: ()=>this._subscriptionManager.getSubscriptions(),
            fetchSyncBlocksData: (nodes)=>this.fetchSyncBlocksData(nodes),
            getFireAnalyticsEvent: ()=>this.fireAnalyticsEvent,
            // EDITOR-7860: skip + re-queue fetches while not ready / torn down.
            isProviderReady: ()=>this.hasDataProvider()
        });
        // The provider might have SSR data cache already set, so we need to update the cache in session memory storage
        this.setSSRDataInSessionCache((_this$dataProvider = this.dataProvider) === null || _this$dataProvider === void 0 ? void 0 : _this$dataProvider.getNodeDataCacheKeys());
    }
    isReferenceBlock(node) {
        return node.type.name === 'syncBlock';
    }
    /**
   * Whether the async data provider is wired and the manager is not torn down.
   * Consumers gate fetch/subscribe on this to avoid a false `Data provider not
   * set` fetch error (EDITOR-7860). The `isDestroyed` check covers managers
   * orphaned mid-flight during an async provider swap, where `dataProvider`
   * alone is insufficient.
   */ hasDataProvider() {
        return !this.isDestroyed && !!this.dataProvider;
    }
    /**
   * Enables or disables real-time GraphQL subscriptions for block updates.
   * When enabled, the store manager will subscribe to real-time updates
   * instead of relying on polling.
   * @param enabled - Whether to enable real-time subscriptions
   */ setRealTimeSubscriptionsEnabled(enabled) {
        this._subscriptionManager.setRealTimeSubscriptionsEnabled(enabled);
    }
    /**
   * Checks if real-time subscriptions are currently enabled.
   */ isRealTimeSubscriptionsEnabled() {
        return this._subscriptionManager.isRealTimeSubscriptionsEnabled();
    }
    /**
   * Returns all resource IDs that are currently subscribed to.
   * Used by React components to render subscription components.
   */ getSubscribedResourceIds() {
        return this._subscriptionManager.getSubscribedResourceIds();
    }
    getSubscribedLocalIds(resourceId) {
        return Object.keys(this._subscriptionManager.getSubscriptions().get(resourceId) ?? {});
    }
    /**
   * Registers a listener that will be called when subscriptions change.
   * @param listener - Callback function to invoke when subscriptions change
   * @returns Unsubscribe function to remove the listener
   */ onSubscriptionsChanged(listener) {
        return this._subscriptionManager.onSubscriptionsChanged(listener);
    }
    /**
   * Handles incoming data from a GraphQL subscription.
   * Called by React subscription components when they receive updates.
   * @param syncBlockInstance - The updated sync block instance
   */ handleSubscriptionUpdate(syncBlockInstance) {
        this._subscriptionManager.handleSubscriptionUpdate(syncBlockInstance);
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.fetchExperience = (0, $8KNyr.getFetchExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $8KNyr.getFetchSourceInfoExperience)(fireAnalyticsEvent);
        this.saveExperience = (0, $8KNyr.getSaveReferenceExperience)(fireAnalyticsEvent);
    }
    setOnUnpublishedSyncBlockDetected(callback) {
        this.onUnpublishedSyncBlockDetected = callback;
    }
    /**
   * Mark a sync block as newly added to the document.
   * This should be called when a sync block node is added via a transaction.
   * @param resourceId - The resource ID of the newly added sync block
   */ markAsNewlyAdded(resourceId) {
        this.newlyAddedSyncBlocks.add(resourceId);
    }
    generateResourceIdForReference(sourceId) {
        if (!this.dataProvider) throw new Error('Data provider not set');
        return this.dataProvider.generateResourceIdForReference(sourceId);
    }
    updateFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
    }
    getInitialSyncBlockData(resourceId) {
        var _this$dataProvider2;
        const localReference = this.getLocalReference(resourceId);
        if (localReference) return localReference;
        const syncBlockNode = (0, $iYvEr.createSyncBlockNode)('', resourceId);
        const providerData = (_this$dataProvider2 = this.dataProvider) === null || _this$dataProvider2 === void 0 || (_this$dataProvider2 = _this$dataProvider2.getNodeDataFromCache(syncBlockNode)) === null || _this$dataProvider2 === void 0 ? void 0 : _this$dataProvider2.data;
        if (providerData) // Initial provider cache data can come from SSR/prefetch and bypass updateCache(),
        // so normalize legacy reference payloads here before rendering.
        return this.normalizeReferenceData(providerData);
        return this.getFromSessionCache(resourceId);
    }
    getSameDocumentReferenceParts(resourceId) {
        const parsed = (0, $kQGqU.parseResourceId)(resourceId);
        if (!parsed || !this.dataProvider || this.dataProvider.generateResourceIdForReference(parsed.uuid) !== resourceId) return undefined;
        return parsed;
    }
    getLocalReference(resourceId) {
        var _this$sourceManager;
        if (!(0, $3y2s4.isExperimentEnabled)('editor-synced-block-same-page-sync')) return undefined;
        const parsed = this.getSameDocumentReferenceParts(resourceId);
        if (!parsed) return undefined;
        const snapshot = (_this$sourceManager = this.sourceManager) === null || _this$sourceManager === void 0 ? void 0 : _this$sourceManager.getLocalSourceSnapshot(parsed.uuid);
        if (!snapshot) return undefined;
        return {
            resourceId: resourceId,
            data: {
                ...snapshot,
                content: [
                    ...snapshot.content
                ]
            },
            localSameDocumentSource: {
                sourceBlockInstanceId: snapshot.blockInstanceId,
                sourceProduct: parsed.product
            }
        };
    }
    normalizeReferenceData(syncBlock) {
        var _syncBlock$data;
        if (!((_syncBlock$data = syncBlock.data) !== null && _syncBlock$data !== void 0 && (_syncBlock$data = _syncBlock$data.content) !== null && _syncBlock$data !== void 0 && _syncBlock$data.length)) return syncBlock;
        const content = (0, $iYvEr.normalizeSyncBlockJSONContent)(syncBlock.data.content);
        if (content === syncBlock.data.content) return syncBlock;
        return {
            ...syncBlock,
            data: {
                ...syncBlock.data,
                content: content
            }
        };
    }
    updateSessionCache(resourceId) {
        const latestData = this.getFromCache(resourceId);
        if (latestData) (0, $3PQZm.syncBlockInMemorySessionCache).setItem(`${$de344b577f3b06fb$var$CACHE_KEY_PREFIX}${resourceId}`, JSON.stringify(latestData));
    }
    getFromSessionCache(resourceId) {
        try {
            const raw = (0, $3PQZm.syncBlockInMemorySessionCache).getItem(`${$de344b577f3b06fb$var$CACHE_KEY_PREFIX}${resourceId}`);
            if (!raw) return undefined;
            // Session cache entries written before this sanitizer existed may still include
            // annotation marks or panel_c1 nodes, so keep this read-time safety net for legacy data.
            return this.normalizeReferenceData(JSON.parse(raw));
        } catch (error) {
            (0, $j2Y9J.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/getFromSessionCache'
            });
            return undefined;
        }
    }
    fetchSyncBlockSourceInfoBySourceAri(sourceAri, hasAccess = true) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            const sourceInfo = this.dataProvider.fetchSyncBlockSourceInfo(undefined, sourceAri, undefined, hasAccess);
            return sourceInfo;
        } catch (error) {
            var _this$fireAnalyticsEv;
            (0, $j2Y9J.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/fetchSyncBlockSourceInfoBySourceAri'
            });
            (_this$fireAnalyticsEv = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv === void 0 || _this$fireAnalyticsEv.call(this, (0, $hYuzB.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchSyncBlockSourceInfoByLocalId(localId, hasAccess = true) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            return this.dataProvider.fetchSyncBlockSourceInfo(localId, undefined, undefined, hasAccess);
        } catch (error) {
            var _this$fireAnalyticsEv2;
            (0, $j2Y9J.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/fetchSyncBlockSourceInfoByLocalId'
            });
            (_this$fireAnalyticsEv2 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv2 === void 0 || _this$fireAnalyticsEv2.call(this, (0, $hYuzB.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchSyncBlockSourceInfo(resourceId) {
        try {
            var _this$fetchSourceInfo;
            if (!resourceId || !this.dataProvider) throw new Error('Data provider or resourceId not set');
            const existingRequest = this.syncBlockSourceInfoRequests.get(resourceId);
            if (existingRequest) return existingRequest;
            const existingSyncBlock = this.getFromCache(resourceId);
            if (!existingSyncBlock) throw new Error('No existing sync block to fetch source info for');
            const { sourceAri: sourceAri, product: product, blockInstanceId: blockInstanceId, sourceURL: sourceURL, sourceTitle: sourceTitle, onSameDocument: onSameDocument, fieldName: fieldName, locationScope: locationScope, sourceSubType: sourceSubType, issueType: issueType } = existingSyncBlock.data || {};
            // skip if source URL and title are already present
            if (sourceURL && sourceTitle) return Promise.resolve({
                title: sourceTitle,
                url: sourceURL,
                subType: sourceSubType,
                sourceAri: sourceAri || '',
                onSameDocument: onSameDocument,
                ...fieldName !== undefined && {
                    fieldName: fieldName
                },
                ...locationScope !== undefined && {
                    locationScope: locationScope
                },
                productType: product,
                issueType: issueType
            });
            // Derive once per call so we don't re-parse on every analytics event below.
            // `product` from cached data is preferred when available; fall back to parsing
            // the resourceId.
            const sourceProduct = product ?? (0, $iYvEr.getSourceProductFromResourceIdSafe)(resourceId);
            if (!sourceAri || !product || !blockInstanceId) {
                var _this$fireAnalyticsEv3;
                (_this$fireAnalyticsEv3 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv3 === void 0 || _this$fireAnalyticsEv3.call(this, (0, $hYuzB.getSourceInfoErrorPayload)('SourceAri, product or blockInstanceId missing', resourceId, sourceProduct));
                return Promise.resolve(undefined);
            }
            const sourceLocation = (0, $idDos.getSourceLocation)(sourceAri);
            // Undefined with `platform_editor_blocks_patch_13` off, so experience calls below keep
            // exactly their previous arguments (no `metadata` key, `success()` without arguments).
            const experienceMetadata = sourceLocation && {
                sourceLocation: sourceLocation
            };
            const withExperienceMetadata = (options)=>experienceMetadata ? {
                    ...options,
                    metadata: experienceMetadata
                } : options;
            (_this$fetchSourceInfo = this.fetchSourceInfoExperience) === null || _this$fetchSourceInfo === void 0 || _this$fetchSourceInfo.start({});
            const sourceInfoPromise = this.dataProvider.fetchSyncBlockSourceInfo(blockInstanceId, sourceAri, product, true // hasAccess
            ).then((sourceInfo)=>{
                if (!sourceInfo) {
                    var _this$fetchSourceInfo2, _this$fireAnalyticsEv4;
                    (_this$fetchSourceInfo2 = this.fetchSourceInfoExperience) === null || _this$fetchSourceInfo2 === void 0 || _this$fetchSourceInfo2.failure(withExperienceMetadata({
                        reason: 'No source info returned'
                    }));
                    (_this$fireAnalyticsEv4 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv4 === void 0 || _this$fireAnalyticsEv4.call(this, (0, $hYuzB.getSourceInfoErrorPayload)('No source info returned', resourceId, sourceProduct, sourceLocation));
                    return undefined;
                }
                this.updateCacheWithSourceInfo(resourceId, sourceInfo);
                if (sourceInfo.title) this._subscriptionManager.updateSourceTitleSubscriptions(resourceId, sourceInfo.title);
                if (sourceInfo.title && sourceInfo.url) {
                    if (experienceMetadata) {
                        var _this$fetchSourceInfo3;
                        (_this$fetchSourceInfo3 = this.fetchSourceInfoExperience) === null || _this$fetchSourceInfo3 === void 0 || _this$fetchSourceInfo3.success({
                            metadata: experienceMetadata
                        });
                    } else {
                        var _this$fetchSourceInfo4;
                        (_this$fetchSourceInfo4 = this.fetchSourceInfoExperience) === null || _this$fetchSourceInfo4 === void 0 || _this$fetchSourceInfo4.success();
                    }
                } else {
                    var _this$fetchSourceInfo5, _this$fireAnalyticsEv5;
                    (_this$fetchSourceInfo5 = this.fetchSourceInfoExperience) === null || _this$fetchSourceInfo5 === void 0 || _this$fetchSourceInfo5.failure(withExperienceMetadata({
                        reason: 'Missing title or url'
                    }));
                    (_this$fireAnalyticsEv5 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv5 === void 0 || _this$fireAnalyticsEv5.call(this, (0, $hYuzB.getSourceInfoErrorPayload)('Missing title or url', resourceId, sourceProduct, sourceLocation));
                }
                return sourceInfo;
            }).catch((error)=>{
                var _this$fetchSourceInfo6, _this$fireAnalyticsEv6;
                (_this$fetchSourceInfo6 = this.fetchSourceInfoExperience) === null || _this$fetchSourceInfo6 === void 0 || _this$fetchSourceInfo6.failure(withExperienceMetadata({
                    reason: error.message
                }));
                (_this$fireAnalyticsEv6 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv6 === void 0 || _this$fireAnalyticsEv6.call(this, (0, $hYuzB.getSourceInfoErrorPayload)(error.message, resourceId, sourceProduct, sourceLocation));
                return undefined;
            }).finally(()=>{
                this.syncBlockSourceInfoRequests.delete(resourceId);
            });
            this.syncBlockSourceInfoRequests.set(resourceId, sourceInfoPromise);
            return sourceInfoPromise;
        } catch (error) {
            var _this$fireAnalyticsEv7;
            (0, $j2Y9J.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            (_this$fireAnalyticsEv7 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv7 === void 0 || _this$fireAnalyticsEv7.call(this, (0, $hYuzB.getSourceInfoErrorPayload)(error.message, resourceId, (0, $iYvEr.getSourceProductFromResourceIdSafe)(resourceId)));
        }
        return Promise.resolve(undefined);
    }
    /**
   * Processes prefetched data and updates the cache.
   * @param prefetchedData - The prefetched data to process
   * @returns {Promise<void>}
   */ async processPrefetchedData(prefetchedData) {
        var _this$fetchExperience;
        if (!prefetchedData) return;
        // start the fetch experience (this should be started much earlier to properly track performance, but better late than never)
        (_this$fetchExperience = this.fetchExperience) === null || _this$fetchExperience === void 0 || _this$fetchExperience.start({});
        // mark the sync block requests as in fly
        prefetchedData.resourceIds.forEach((resourceId)=>{
            this.syncBlockFetchDataRequests.set(resourceId, true);
        });
        try {
            const prefetchedResolvedData = await prefetchedData.prefetchPromise;
            const { hasUnexpectedError: hasUnexpectedError, hasExpectedError: hasExpectedError } = this.processFetchedData(prefetchedResolvedData);
            if (hasUnexpectedError) {
                var _this$fetchExperience2;
                (_this$fetchExperience2 = this.fetchExperience) === null || _this$fetchExperience2 === void 0 || _this$fetchExperience2.failure({
                    reason: 'Unexpected error during prefetch'
                });
            } else if (hasExpectedError) {
                var _this$fetchExperience3;
                (_this$fetchExperience3 = this.fetchExperience) === null || _this$fetchExperience3 === void 0 || _this$fetchExperience3.abort({
                    reason: 'Expected error: NotFound or PermissionDenied during prefetch'
                });
            } else {
                var _this$fetchExperience4;
                (_this$fetchExperience4 = this.fetchExperience) === null || _this$fetchExperience4 === void 0 || _this$fetchExperience4.success();
            }
        } catch (error) {
            var _this$fetchExperience5;
            (_this$fetchExperience5 = this.fetchExperience) === null || _this$fetchExperience5 === void 0 || _this$fetchExperience5.failure({
                reason: `Prefetch promise rejected: ${error.message}`
            });
        } finally{
            // Clean up in-flight markers so subsequent fetches are not blocked
            prefetchedData.resourceIds.forEach((resourceId)=>{
                this.syncBlockFetchDataRequests.delete(resourceId);
            });
        }
    }
    /**
   * Fetch sync block data for a given array of sync block nodes.
   * @param syncBlockNodes - The array of sync block nodes to fetch data for
   * @returns The fetched sync block data results
   */ async fetchSyncBlocksData(syncBlockNodes) {
        var _this$fetchExperience6;
        if (syncBlockNodes.length === 0) return;
        // Don't fetch for not_found error since the source is already deleted
        const nodesToFetch = [];
        syncBlockNodes.forEach((node)=>{
            var _existingSyncBlock$er;
            if (this.syncBlockFetchDataRequests.get(node.attrs.resourceId)) return;
            const existingSyncBlock = this.getFromCache(node.attrs.resourceId);
            if ((existingSyncBlock === null || existingSyncBlock === void 0 || (_existingSyncBlock$er = existingSyncBlock.error) === null || _existingSyncBlock$er === void 0 ? void 0 : _existingSyncBlock$er.type) === (0, $cSue1.SyncBlockError).NotFound) return;
            nodesToFetch.push(node);
        });
        if (nodesToFetch.length === 0) return;
        if (!this.dataProvider) // EDITOR-7860: tag the throw so catch sites can suppress the benign
        // not-ready/torn-down case.
        throw new (0, $cSue1.ProviderNotReadyError)();
        nodesToFetch.forEach((node)=>{
            this.syncBlockFetchDataRequests.set(node.attrs.resourceId, true);
        });
        (_this$fetchExperience6 = this.fetchExperience) === null || _this$fetchExperience6 === void 0 || _this$fetchExperience6.start({});
        const data = await this.dataProvider.fetchNodesData(nodesToFetch).finally(()=>{
            nodesToFetch.forEach((node)=>{
                this.syncBlockFetchDataRequests.delete(node.attrs.resourceId);
            });
        });
        const { hasUnexpectedError: hasUnexpectedError, hasExpectedError: hasExpectedError } = this.processFetchedData(data);
        if (hasUnexpectedError) {
            var _this$fetchExperience7;
            (_this$fetchExperience7 = this.fetchExperience) === null || _this$fetchExperience7 === void 0 || _this$fetchExperience7.failure({
                reason: 'Unexpected error during fetch'
            });
        } else if (hasExpectedError) {
            var _this$fetchExperience8;
            (_this$fetchExperience8 = this.fetchExperience) === null || _this$fetchExperience8 === void 0 || _this$fetchExperience8.abort({
                reason: 'Expected error: NotFound or PermissionDenied'
            });
        } else {
            var _this$fetchExperience9;
            (_this$fetchExperience9 = this.fetchExperience) === null || _this$fetchExperience9 === void 0 || _this$fetchExperience9.success();
        }
    }
    processFetchedData(data) {
        if (!data) return {
            hasUnexpectedError: false,
            hasExpectedError: false
        };
        let hasUnexpectedError = false;
        let hasExpectedError = false;
        data.forEach((syncBlockInstance)=>{
            var _resolvedSyncBlockIns;
            if (!syncBlockInstance.resourceId) {
                var _syncBlockInstance$er, _syncBlockInstance$er2, _this$fireAnalyticsEv8, _syncBlockInstance$er3, _syncBlockInstance$er4, _syncBlockInstance$er5;
                const payload = ((_syncBlockInstance$er = syncBlockInstance.error) === null || _syncBlockInstance$er === void 0 ? void 0 : _syncBlockInstance$er.reason) || ((_syncBlockInstance$er2 = syncBlockInstance.error) === null || _syncBlockInstance$er2 === void 0 ? void 0 : _syncBlockInstance$er2.type) || 'Returned sync block instance does not have resource id';
                // No resourceId means we cannot derive a sourceProduct here; intentionally omit.
                // Classify on the structured `type` first, falling back to the free-text
                // `reason`/payload (EDITOR-7862).
                (_this$fireAnalyticsEv8 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv8 === void 0 || _this$fireAnalyticsEv8.call(this, (0, $hYuzB.fetchErrorPayload)(payload, undefined, undefined, (0, $hYuzB.buildFetchErrorAttribution)(((_syncBlockInstance$er3 = syncBlockInstance.error) === null || _syncBlockInstance$er3 === void 0 ? void 0 : _syncBlockInstance$er3.type) || ((_syncBlockInstance$er4 = syncBlockInstance.error) === null || _syncBlockInstance$er4 === void 0 ? void 0 : _syncBlockInstance$er4.reason) || payload, (_syncBlockInstance$er5 = syncBlockInstance.error) === null || _syncBlockInstance$er5 === void 0 ? void 0 : _syncBlockInstance$er5.statusCode)));
                return;
            }
            const existingSyncBlock = this.getFromCache(syncBlockInstance.resourceId);
            const resolvedSyncBlockInstance = existingSyncBlock ? (0, $h5k7t.resolveSyncBlockInstance)(existingSyncBlock, syncBlockInstance) : syncBlockInstance;
            this.updateCache(resolvedSyncBlockInstance);
            // Check if this is a newly added unpublished sync block and notify
            // Only trigger for sync blocks that were just added (not refreshed or loaded on page init)
            if (!syncBlockInstance.error && ((_resolvedSyncBlockIns = resolvedSyncBlockInstance.data) === null || _resolvedSyncBlockIns === void 0 ? void 0 : _resolvedSyncBlockIns.status) === 'unpublished' && this.newlyAddedSyncBlocks.has(syncBlockInstance.resourceId) && this.onUnpublishedSyncBlockDetected) {
                // Remove from newly added set after checking to prevent duplicate flags
                this.newlyAddedSyncBlocks.delete(syncBlockInstance.resourceId);
                this.onUnpublishedSyncBlockDetected(resolvedSyncBlockInstance.resourceId);
            } else if (this.newlyAddedSyncBlocks.has(syncBlockInstance.resourceId)) // Remove from newly added set even if not unpublished (to clean up)
            this.newlyAddedSyncBlocks.delete(syncBlockInstance.resourceId);
            // Clear retry tracking on successful fetch — block has been created
            if (!syncBlockInstance.error && this.entityNotFoundRetryCount.has(syncBlockInstance.resourceId)) {
                const timer = this.entityNotFoundRetryTimers.get(syncBlockInstance.resourceId);
                if (timer) {
                    clearTimeout(timer);
                    this.entityNotFoundRetryTimers.delete(syncBlockInstance.resourceId);
                }
                this.entityNotFoundRetryCount.delete(syncBlockInstance.resourceId);
            }
            if (syncBlockInstance.error) {
                // Skip error analytics when EntityNotFound will be retried, to avoid
                // inflating error-rate metrics with expected transient failures
                const isRetryingEntityNotFound = syncBlockInstance.error.type === (0, $cSue1.SyncBlockError).EntityNotFound && (this.entityNotFoundRetryCount.get(syncBlockInstance.resourceId) ?? 0) < $de344b577f3b06fb$var$ENTITY_NOT_FOUND_MAX_RETRIES;
                if (!isRetryingEntityNotFound) {
                    var _this$fireAnalyticsEv9, _syncBlockInstance$da;
                    // Classify on the structured `type` (a `SyncBlockError` enum value) first,
                    // falling back to the free-text `reason` so source-state/permission strings
                    // are still bucketed (EDITOR-7862). The emitted `error` attribute is unchanged.
                    (_this$fireAnalyticsEv9 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv9 === void 0 || _this$fireAnalyticsEv9.call(this, (0, $hYuzB.fetchErrorPayload)(syncBlockInstance.error.reason || syncBlockInstance.error.type, syncBlockInstance.resourceId, ((_syncBlockInstance$da = syncBlockInstance.data) === null || _syncBlockInstance$da === void 0 ? void 0 : _syncBlockInstance$da.product) ?? (0, $iYvEr.getSourceProductFromResourceIdSafe)(syncBlockInstance.resourceId), (0, $hYuzB.buildFetchErrorAttribution)(syncBlockInstance.error.type || syncBlockInstance.error.reason, syncBlockInstance.error.statusCode)));
                }
                if (syncBlockInstance.error.type === (0, $cSue1.SyncBlockError).NotFound || syncBlockInstance.error.type === (0, $cSue1.SyncBlockError).Forbidden) hasExpectedError = true;
                else if (syncBlockInstance.error.type === (0, $cSue1.SyncBlockError).EntityNotFound) {
                    // Schedule a retry for EntityNotFound — the source block may be in
                    // the process of being created by a collaborator (race condition
                    // between NCS propagation and Block Service createBlock call).
                    this.scheduleEntityNotFoundRetry(syncBlockInstance.resourceId);
                    if (!isRetryingEntityNotFound) hasUnexpectedError = true;
                } else if (syncBlockInstance.error) hasUnexpectedError = true;
                return;
            }
            const callbacks = this._subscriptionManager.getSubscriptions().get(syncBlockInstance.resourceId);
            const localIds = callbacks ? Object.keys(callbacks) : [];
            localIds.forEach((localId)=>{
                var _this$fireAnalyticsEv0, _syncBlockInstance$da2;
                (_this$fireAnalyticsEv0 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv0 === void 0 || _this$fireAnalyticsEv0.call(this, (0, $hYuzB.fetchSuccessPayload)(syncBlockInstance.resourceId, localId, ((_syncBlockInstance$da2 = syncBlockInstance.data) === null || _syncBlockInstance$da2 === void 0 ? void 0 : _syncBlockInstance$da2.product) ?? (0, $iYvEr.getSourceProductFromResourceIdSafe)(syncBlockInstance.resourceId)));
            });
            this.fetchSyncBlockSourceInfo(resolvedSyncBlockInstance.resourceId);
        });
        return {
            hasUnexpectedError: hasUnexpectedError,
            hasExpectedError: hasExpectedError
        };
    }
    updateCacheWithSourceInfo(resourceId, sourceInfo) {
        const existingSyncBlock = this.getFromCache(resourceId);
        // If the cache entry was deleted while the source-info request was
        // in flight, fire an analytics event so the race is observable.
        if (!existingSyncBlock) {
            var _this$fireAnalyticsEv1;
            (_this$fireAnalyticsEv1 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv1 === void 0 || _this$fireAnalyticsEv1.call(this, (0, $hYuzB.sourceInfoOrphanedPayload)(resourceId, (0, $iYvEr.getSourceProductFromResourceIdSafe)(resourceId), {
                hasPendingDeletion: this.pendingCacheDeletions.has(resourceId),
                hasSubscribers: this._subscriptionManager.getSubscriptions().has(resourceId)
            }));
            (0, $j2Y9J.logException)(new Error('updateCacheWithSourceInfo: cache entry missing for resource'), {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/orphaned-source-info'
            });
            return;
        }
        if (existingSyncBlock && existingSyncBlock.data) {
            existingSyncBlock.data.sourceURL = sourceInfo === null || sourceInfo === void 0 ? void 0 : sourceInfo.url;
            existingSyncBlock.data = {
                ...existingSyncBlock.data,
                sourceURL: sourceInfo === null || sourceInfo === void 0 ? void 0 : sourceInfo.url,
                sourceTitle: sourceInfo === null || sourceInfo === void 0 ? void 0 : sourceInfo.title,
                onSameDocument: sourceInfo === null || sourceInfo === void 0 ? void 0 : sourceInfo.onSameDocument,
                ...(sourceInfo === null || sourceInfo === void 0 ? void 0 : sourceInfo.fieldName) !== undefined && {
                    fieldName: sourceInfo.fieldName
                },
                ...(sourceInfo === null || sourceInfo === void 0 ? void 0 : sourceInfo.locationScope) !== undefined && {
                    locationScope: sourceInfo.locationScope
                },
                sourceSubType: sourceInfo === null || sourceInfo === void 0 ? void 0 : sourceInfo.subType,
                issueType: sourceInfo === null || sourceInfo === void 0 ? void 0 : sourceInfo.issueType
            };
            this.updateCache(existingSyncBlock);
        }
    }
    updateCache(syncBlock) {
        const sanitizedSyncBlock = this.normalizeReferenceData(syncBlock);
        const { resourceId: resourceId } = sanitizedSyncBlock;
        if (resourceId) {
            var _this$dataProvider3;
            (_this$dataProvider3 = this.dataProvider) === null || _this$dataProvider3 === void 0 || _this$dataProvider3.updateCache({
                [resourceId]: sanitizedSyncBlock
            }, {
                strategy: 'merge',
                source: 'network'
            });
            this._subscriptionManager.notifySubscriptionCallbacks(resourceId, sanitizedSyncBlock);
            this.updateSessionCache(resourceId);
        }
    }
    getFromCache(resourceId) {
        var _this$dataProvider4;
        const syncBlockNode = (0, $iYvEr.createSyncBlockNode)('', resourceId);
        return (_this$dataProvider4 = this.dataProvider) === null || _this$dataProvider4 === void 0 || (_this$dataProvider4 = _this$dataProvider4.getNodeDataFromCache(syncBlockNode)) === null || _this$dataProvider4 === void 0 ? void 0 : _this$dataProvider4.data;
    }
    deleteFromCache(resourceId) {
        var _this$dataProvider5;
        (_this$dataProvider5 = this.dataProvider) === null || _this$dataProvider5 === void 0 || _this$dataProvider5.removeFromCache([
            resourceId
        ]);
        this._providerFactoryManager.deleteFactory(resourceId);
        // Evict in-flight source-info promise and reset reschedule counter
        // so a stale resolution can't silently merge into a re-fetched entry.
        this.syncBlockSourceInfoRequests.delete(resourceId);
        this.cacheDeletionRescheduleCounts.delete(resourceId);
    }
    /**
   * Returns true if the cache entry for `resourceId` is safe to delete:
   * no active subscribers, no in-flight source-info request, and no
   * queued/in-flight batch fetch.
   */ canDeleteCache(resourceId) {
        if (this._subscriptionManager.getSubscriptions().has(resourceId)) return false;
        if (this.syncBlockSourceInfoRequests.has(resourceId)) return false;
        if (this._batchFetcher.hasPendingFetch(resourceId)) return false;
        return true;
    }
    /**
   * Schedules cache deletion for `resourceId` after the grace period
   * Called when the last
   * subscriber unsubscribes. Guards are re-checked at fire time; if any
   * are positive the timer is rescheduled up to MAX_RESCHEDULES times.
   */ scheduleCacheDeletion(resourceId) {
        if (this.isDestroyed) return;
        // Cancel any existing timer \u2014 restart the grace period \u2014 but DO NOT
        // reset the reschedule counter. The counter is reset only by
        // `cancelPendingCacheDeletion` (called when a real subscriber returns)
        // or when the cache is actually deleted.
        const existing = this.pendingCacheDeletions.get(resourceId);
        if (existing) {
            clearTimeout(existing);
            this.pendingCacheDeletions.delete(resourceId);
        }
        const timer = setTimeout(()=>{
            // Guard against timer callback running after destroy. clearTimeout
            // is synchronous so this should be unreachable in practice, but
            // belt-and-braces.
            if (this.isDestroyed) return;
            this.pendingCacheDeletions.delete(resourceId);
            this.onCacheDeletionTimerFire(resourceId);
        }, $de344b577f3b06fb$var$CACHE_DELETION_GRACE_PERIOD_MS);
        this.pendingCacheDeletions.set(resourceId, timer);
    }
    /**
   * Cancels any pending cache deletion timer for `resourceId` and resets the
   * reschedule counter. Called
   * when a new subscriber arrives.
   */ cancelPendingCacheDeletion(resourceId) {
        const existing = this.pendingCacheDeletions.get(resourceId);
        if (existing) {
            clearTimeout(existing);
            this.pendingCacheDeletions.delete(resourceId);
        }
        // Subscribers returning resets the reschedule counter \u2014 the resource is
        // active again.
        this.cacheDeletionRescheduleCounts.delete(resourceId);
    }
    /** Returns whether a cache deletion timer is pending for `resourceId`. */ hasPendingCacheDeletion(resourceId) {
        return this.pendingCacheDeletions.has(resourceId);
    }
    onCacheDeletionTimerFire(resourceId) {
        if (this.canDeleteCache(resourceId)) {
            // `deleteFromCache` resets the reschedule counter.
            this.deleteFromCache(resourceId);
            return;
        }
        const currentCount = this.cacheDeletionRescheduleCounts.get(resourceId) ?? 0;
        if (currentCount >= $de344b577f3b06fb$var$CACHE_DELETION_MAX_RESCHEDULES) {
            var _this$fireAnalyticsEv10;
            // Stuck guard — force deletion to prevent unbounded memory growth and
            // fire analytics so the stuck state is visible in production telemetry.
            //
            // NOTE: If active React subscribers still exist at force-delete time
            // (e.g. an in-flight batch fetch never settled), the cache entry is
            // removed without notifying subscribers. Those components will
            // continue to render with stale data until their next re-render
            // triggers a new batch fetch — typically within ~1 frame. We accept
            // this brief stale window in exchange for bounded memory growth.
            (_this$fireAnalyticsEv10 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv10 === void 0 || _this$fireAnalyticsEv10.call(this, (0, $hYuzB.cacheDeletionForcedPayload)(currentCount, resourceId, (0, $iYvEr.getSourceProductFromResourceIdSafe)(resourceId)));
            (0, $j2Y9J.logException)(new Error(`Cache deletion forced after ${currentCount} reschedules \u{2014} stuck in-flight guard`), {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/cache-deletion-forced'
            });
            // `deleteFromCache` resets the reschedule counter.
            this.deleteFromCache(resourceId);
            // If subscribers still exist, kick off a fresh fetch so they get
            // fresh data on the next batch tick instead of holding stale data
            // indefinitely.
            if (this._subscriptionManager.getSubscriptions().has(resourceId)) this.debouncedBatchedFetchSyncBlocks(resourceId);
            return;
        }
        this.cacheDeletionRescheduleCounts.set(resourceId, currentCount + 1);
        this.scheduleCacheDeletion(resourceId);
    }
    /**
   * Schedules a delayed retry for a block that returned EntityNotFound.
   * The block may be in the process of being created by a collaborator —
   * the NCS transaction propagates the bodiedSyncBlock ADF node before
   * the Block Service createBlock call completes.
   */ scheduleEntityNotFoundRetry(resourceId) {
        const currentRetries = this.entityNotFoundRetryCount.get(resourceId) ?? 0;
        if (currentRetries >= $de344b577f3b06fb$var$ENTITY_NOT_FOUND_MAX_RETRIES) // Max retries exceeded — keep count at max so future calls immediately exit
        // (don't delete — that would reset the counter and allow unbounded retry waves)
        return;
        // If a timer is already pending, don't schedule another one — let the
        // existing timer fire. This prevents rapid EntityNotFound responses from
        // exhausting the retry budget through cancellations without any actual
        // fetch completing.
        if (this.entityNotFoundRetryTimers.has(resourceId)) return;
        const delay = $de344b577f3b06fb$var$ENTITY_NOT_FOUND_INITIAL_DELAY_MS * Math.pow(2, currentRetries);
        const timer = setTimeout(()=>{
            var _cached$error;
            this.entityNotFoundRetryTimers.delete(resourceId);
            // If no active subscriptions remain for this block, clean up and skip
            const subscriptions = this._subscriptionManager.getSubscriptions().get(resourceId);
            if (!subscriptions || Object.keys(subscriptions).length === 0) {
                this.entityNotFoundRetryCount.delete(resourceId);
                return;
            }
            // Increment count only when the timer fires, not when scheduled
            this.entityNotFoundRetryCount.set(resourceId, currentRetries + 1);
            // Clear the error from cache so fetchSyncBlocksData doesn't skip it
            const cached = this.getFromCache(resourceId);
            if ((cached === null || cached === void 0 || (_cached$error = cached.error) === null || _cached$error === void 0 ? void 0 : _cached$error.type) === (0, $cSue1.SyncBlockError).EntityNotFound) this.deleteFromCache(resourceId);
            // Trigger a re-fetch via the batch fetcher
            this.debouncedBatchedFetchSyncBlocks(resourceId);
        }, delay);
        this.entityNotFoundRetryTimers.set(resourceId, timer);
    }
    debouncedBatchedFetchSyncBlocks(resourceId) {
        this._batchFetcher.queueFetch(resourceId);
    }
    setSSRDataInSessionCache(resourceIds) {
        if (!resourceIds || resourceIds.length === 0) return;
        resourceIds.forEach((resourceId)=>{
            this.updateSessionCache(resourceId);
        });
    }
    subscribeToSyncBlock(resourceId, localId, callback) {
        var _this$sourceManager2;
        if ((0, $3y2s4.isExperimentEnabled)('platform_editor_blocks_patch_11')) this.subscribedSinceLastFlush = true;
        const isSamePageSyncEnabled = (0, $3y2s4.isExperimentEnabled)('editor-synced-block-same-page-sync');
        const sameDocumentParts = isSamePageSyncEnabled ? this.getSameDocumentReferenceParts(resourceId) : undefined;
        let localReference = isSamePageSyncEnabled ? this.getLocalReference(resourceId) : undefined;
        const unsubscribeRemote = this._subscriptionManager.subscribeToSyncBlock(resourceId, localId, (instance)=>{
            if (!localReference) callback(instance);
        });
        const unsubscribeLocal = sameDocumentParts ? (_this$sourceManager2 = this.sourceManager) === null || _this$sourceManager2 === void 0 ? void 0 : _this$sourceManager2.subscribeToLocalSource(sameDocumentParts.uuid, ()=>{
            const hadLocalReference = Boolean(localReference);
            localReference = this.getLocalReference(resourceId);
            if (localReference) {
                callback(localReference);
                return;
            }
            if (!hadLocalReference) return;
            // Source left the document: keep the last local instance on screen
            // and fetch the current backend value. Do not replay a remote
            // value captured while the local source was authoritative.
            this.debouncedBatchedFetchSyncBlocks(resourceId);
        }) : undefined;
        return ()=>{
            unsubscribeLocal === null || unsubscribeLocal === void 0 || unsubscribeLocal();
            unsubscribeRemote();
        };
    }
    subscribeToSourceTitle(node, callback) {
        return this._subscriptionManager.subscribeToSourceTitle(node, callback);
    }
    subscribe(node, callback) {
        try {
            // check node is a sync block, as we only support sync block subscriptions
            if (node.type.name !== 'syncBlock') throw new Error('Only sync block node subscriptions are supported');
            const { resourceId: resourceId, localId: localId } = node.attrs;
            if (!localId || !resourceId) throw new Error('Missing local id or resource id');
            return this.subscribeToSyncBlock(resourceId, localId, callback);
        } catch (error) {
            var _this$fireAnalyticsEv11;
            // EDITOR-7860: benign not-ready/torn-down case — suppress both the
            // exception-tracker log and the analytics event (checked first so the
            // benign case stays fully silent).
            if ((0, $cSue1.isProviderNotReadyError)(error)) return ()=>{};
            (0, $j2Y9J.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            (_this$fireAnalyticsEv11 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv11 === void 0 || _this$fireAnalyticsEv11.call(this, (0, $hYuzB.fetchErrorPayload)(error.message, undefined, undefined, (0, $hYuzB.buildFetchErrorAttribution)(error.message)));
            return ()=>{};
        }
    }
    /**
   * Get the URL for a sync block.
   * @param resourceId - The resource ID of the sync block
   * @returns
   */ getSyncBlockURL(resourceId) {
        var _this$getFromCache;
        return (_this$getFromCache = this.getFromCache(resourceId)) === null || _this$getFromCache === void 0 || (_this$getFromCache = _this$getFromCache.data) === null || _this$getFromCache === void 0 ? void 0 : _this$getFromCache.sourceURL;
    }
    getProviderFactory(resourceId) {
        return this._providerFactoryManager.getProviderFactory(resourceId);
    }
    /**
   * The provider options currently supplied by the host. Safe to read during
   * render - it notifies nobody.
   */ getProviderOptions() {
        return this._providerFactoryManager.getProviderOptions();
    }
    /**
   * Applies the latest providers to the cached factory. Notifies subscribers, so
   * call from an effect rather than during render.
   */ syncProviders(resourceId) {
        this._providerFactoryManager.syncProviders(resourceId);
    }
    getSSRProviders(resourceId) {
        return this._providerFactoryManager.getSSRProviders(resourceId);
    }
    /**
   * Update reference synced blocks on the document with the BE
   *
   * @returns true if the reference synced blocks are updated successfully, false otherwise
   */ async flush() {
        if (this.viewMode === 'view') // Reference flushes are only meaningful while editing. Treat view-mode flush attempts as
        // gated no-op successes so lifecycle/teardown calls do not report false save failures.
        return true;
        if (!this.isCacheDirty) // we use the isCacheDirty flag as a quick check.
        return true;
        // Prevent concurrent flushes to avoid race conditions with lastFlushedSyncedBlocks
        if (this.isFlushInProgress) {
            // Mark that another flush is needed after the current one completes
            this.flushNeededAfterCurrent = true;
            // We return true here because we know the pending flush will handle the dirty cache
            return true;
        } else this.isFlushInProgress = true;
        const subscribedSinceLastFlushToFlush = (0, $3y2s4.isExperimentEnabled)('platform_editor_blocks_patch_11') && this.subscribedSinceLastFlush;
        this.subscribedSinceLastFlush = false;
        let success = true;
        // a copy of the subscriptions STRUCTURE (without the callbacks)
        // To be saved as the last flushed structure if the flush is successful
        const syncedBlocksToFlush = {};
        try {
            var _this$saveExperience;
            if (!this.dataProvider) throw new Error('Data provider not set');
            const blocks = [];
            // First, build the complete subscription structure
            for (const [resourceId, callbacks] of this._subscriptionManager.getSubscriptions().entries()){
                syncedBlocksToFlush[resourceId] = {};
                Object.keys(callbacks).forEach((localId)=>{
                    blocks.push({
                        resourceId: resourceId,
                        localId: localId
                    });
                    syncedBlocksToFlush[resourceId][localId] = true;
                });
            }
            // Then, compare with the last flushed structure to detect changes
            // We check against the last flushed structure to prevent unnecessary flushes
            // A reference can subscribe and disappear before the first flush, leaving both structures empty.
            if (!subscribedSinceLastFlushToFlush && (0, (/*@__PURE__*/$parcel$interopDefault($dMMwa)))(syncedBlocksToFlush, this.lastFlushedSyncedBlocks)) {
                this.isCacheDirty = false; // Reset since we're considering this a successful no-op flush
                return true;
            }
            // reset isCacheDirty early to prevent race condition
            // There is a race condition where if a user makes changes (create/delete) to a reference sync block
            // on a live page and the reference sync block is being saved while the user
            // is still making changes, the new changes might not be saved if they all happen
            // exactly at a time when the updateReferenceData is being executed asynchronously.
            this.isCacheDirty = false;
            (_this$saveExperience = this.saveExperience) === null || _this$saveExperience === void 0 || _this$saveExperience.start();
            const updateResult = await this.dataProvider.updateReferenceData(blocks);
            if (!updateResult.success) {
                var _this$saveExperience2, _this$fireAnalyticsEv12;
                success = false;
                (_this$saveExperience2 = this.saveExperience) === null || _this$saveExperience2 === void 0 || _this$saveExperience2.failure({
                    reason: updateResult.error || 'Failed to update reference synced blocks on the document'
                });
                (_this$fireAnalyticsEv12 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv12 === void 0 || _this$fireAnalyticsEv12.call(this, (0, $hYuzB.updateReferenceErrorPayload)(updateResult.error || 'Failed to update reference synced blocks on the document', undefined, undefined, (0, $hYuzB.buildErrorAttribution)(updateResult.error, updateResult.statusCode)));
            }
        } catch (error) {
            var _this$saveExperience3, _this$fireAnalyticsEv13;
            success = false;
            (0, $j2Y9J.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            (_this$saveExperience3 = this.saveExperience) === null || _this$saveExperience3 === void 0 || _this$saveExperience3.failure({
                reason: error.message
            });
            // No `resourceId` available in this catch — sourceProduct is intentionally omitted.
            // No structured SyncBlockError/status here, so the attribution `reason` falls back
            // to `unknown`.
            (_this$fireAnalyticsEv13 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv13 === void 0 || _this$fireAnalyticsEv13.call(this, (0, $hYuzB.updateReferenceErrorPayload)(error.message, undefined, undefined, (0, $hYuzB.buildErrorAttribution)()));
        } finally{
            if (!success) {
                // set isCacheDirty back to true for cases where it failed to update the reference synced blocks on the BE
                this.isCacheDirty = true;
                this.subscribedSinceLastFlush || (this.subscribedSinceLastFlush = subscribedSinceLastFlushToFlush);
            } else {
                var _this$saveExperience4;
                this.lastFlushedSyncedBlocks = syncedBlocksToFlush;
                (_this$saveExperience4 = this.saveExperience) === null || _this$saveExperience4 === void 0 || _this$saveExperience4.success();
            }
            // Always reset isFlushInProgress
            this.isFlushInProgress = false;
            // If another flush was requested while this one was in progress, execute it now
            if (this.flushNeededAfterCurrent) {
                this.flushNeededAfterCurrent = false;
                // Use setTimeout to avoid deep recursion and run queued flush asynchronously
                // Note: flush() handles all exceptions internally and never rejects
                this.queuedFlushTimeout = setTimeout(()=>{
                    this.queuedFlushTimeout = undefined;
                    this.flush();
                }, 0);
            }
        }
        return success;
    }
    destroy() {
        var _this$dataProvider6, _this$saveExperience5, _this$fetchExperience0, _this$fetchSourceInfo7;
        // Mark destroyed first so in-flight timer callbacks can early-return.
        this.isDestroyed = true;
        // Cancel any queued flush to prevent it from running after destroy
        if (this.queuedFlushTimeout) {
            clearTimeout(this.queuedFlushTimeout);
            this.queuedFlushTimeout = undefined;
        }
        // Cancel any pending EntityNotFound retry timers
        this.entityNotFoundRetryTimers.forEach((timer)=>clearTimeout(timer));
        this.entityNotFoundRetryTimers.clear();
        this.entityNotFoundRetryCount.clear();
        // Cancel pending cache deletion timers.
        this.pendingCacheDeletions.forEach((timer)=>clearTimeout(timer));
        this.pendingCacheDeletions.clear();
        this.cacheDeletionRescheduleCounts.clear();
        this._subscriptionManager.destroy();
        this._providerFactoryManager.destroy();
        this._batchFetcher.destroy();
        (_this$dataProvider6 = this.dataProvider) === null || _this$dataProvider6 === void 0 || _this$dataProvider6.resetCache();
        this.dataProvider = undefined;
        this.syncBlockFetchDataRequests.clear();
        this.syncBlockSourceInfoRequests.clear();
        (_this$saveExperience5 = this.saveExperience) === null || _this$saveExperience5 === void 0 || _this$saveExperience5.abort({
            reason: 'editorDestroyed'
        });
        (_this$fetchExperience0 = this.fetchExperience) === null || _this$fetchExperience0 === void 0 || _this$fetchExperience0.abort({
            reason: 'editorDestroyed'
        });
        (_this$fetchSourceInfo7 = this.fetchSourceInfoExperience) === null || _this$fetchSourceInfo7 === void 0 || _this$fetchSourceInfo7.abort({
            reason: 'editorDestroyed'
        });
        this.fireAnalyticsEvent = undefined;
    // `destroy()` is wired to React component unmount via
    // `useMemoizedSyncBlockStoreManager`. Let the in-memory session cache age
    // out naturally instead of clearing it during a view-mode transition.
    }
}

});
parcelRegister("idDos", function(module, exports) {
$parcel$export(module.exports, "getSourceLocation", () => $e0994e58e651f000$export$406c316e26a555c);

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $4VwxS = parcelRequire("4VwxS");

var $2Kv7r = parcelRequire("2Kv7r");
const $e0994e58e651f000$export$63fea0488f1f3b79 = (productType)=>productType === 'jira-work-item' && (0, $3y2s4.isExperimentEnabled)('editor_synced_blocks_jira_custom_rich_text');
const $e0994e58e651f000$export$6f2c88a8b48b006f = ({ documentAri: documentAri, hostAri: hostAri, productType: productType })=>hostAri !== undefined && $e0994e58e651f000$export$63fea0488f1f3b79(productType) ? {
        locationScope: (0, $4VwxS.getLocationScope)({
            documentAri: documentAri,
            hostAri: hostAri
        })
    } : undefined;
const $e0994e58e651f000$export$406c316e26a555c = (sourceAri)=>{
    if (!(0, $gdUUy.fg)('platform_editor_blocks_patch_13')) return undefined;
    if (!sourceAri || !$e0994e58e651f000$export$63fea0488f1f3b79((0, $4VwxS.getProductFromSourceAri)(sourceAri))) return undefined;
    const location = (0, $2Kv7r.parseJiraFieldLocation)({
        ari: sourceAri
    });
    if (!location) return undefined;
    return location.fieldId === (0, $2Kv7r.JIRA_DESCRIPTION_FIELD_ID) ? 'description' : 'custom-field';
};

});

parcelRegister("h5k7t", function(module, exports) {
$parcel$export(module.exports, "resolveSyncBlockInstance", () => $e3356dfe4cd83b33$export$dcc459f28c1cd2fd);

var $7Qiv5 = parcelRequire("7Qiv5");

var $cSue1 = parcelRequire("cSue1");
const $e3356dfe4cd83b33$export$dcc459f28c1cd2fd = (oldResult, newResult)=>{
    var _newResult$data, _oldResult$data, _newResult$data2, _oldResult$data2, _newResult$data3, _oldResult$data3, _newResult$data4, _oldResult$data4;
    // if the old result has no data, we simply return the new result
    if (!oldResult.data) return newResult;
    else if (!newResult.data) {
        var _newResult$error, _newResult$error2;
        // return the old result if there was an error, e.g. network error, but not if not found or forbidden
        if (((_newResult$error = newResult.error) === null || _newResult$error === void 0 ? void 0 : _newResult$error.type) === (0, $cSue1.SyncBlockError).NotFound || ((_newResult$error2 = newResult.error) === null || _newResult$error2 === void 0 ? void 0 : _newResult$error2.type) === (0, $cSue1.SyncBlockError).Forbidden) return newResult;
        else return oldResult;
    }
    // otherwise, we merge the two results, preserving the sourceURL and sourceTitle from the old result if it exists
    const fieldName = newResult.data.fieldName ?? oldResult.data.fieldName;
    const locationScope = newResult.data.locationScope ?? oldResult.data.locationScope;
    return {
        ...newResult,
        data: {
            ...newResult.data,
            sourceURL: ((_newResult$data = newResult.data) === null || _newResult$data === void 0 ? void 0 : _newResult$data.sourceURL) || ((_oldResult$data = oldResult.data) === null || _oldResult$data === void 0 ? void 0 : _oldResult$data.sourceURL) || undefined,
            sourceTitle: ((_newResult$data2 = newResult.data) === null || _newResult$data2 === void 0 ? void 0 : _newResult$data2.sourceTitle) || ((_oldResult$data2 = oldResult.data) === null || _oldResult$data2 === void 0 ? void 0 : _oldResult$data2.sourceTitle) || undefined,
            sourceSubType: $e3356dfe4cd83b33$var$mergeSubType(oldResult, newResult),
            onSameDocument: ((_newResult$data3 = newResult.data) === null || _newResult$data3 === void 0 ? void 0 : _newResult$data3.onSameDocument) || ((_oldResult$data3 = oldResult.data) === null || _oldResult$data3 === void 0 ? void 0 : _oldResult$data3.onSameDocument) || undefined,
            issueType: ((_newResult$data4 = newResult.data) === null || _newResult$data4 === void 0 ? void 0 : _newResult$data4.issueType) || ((_oldResult$data4 = oldResult.data) === null || _oldResult$data4 === void 0 ? void 0 : _oldResult$data4.issueType) || undefined,
            ...fieldName !== undefined && {
                fieldName: fieldName
            },
            ...locationScope !== undefined && {
                locationScope: locationScope
            }
        }
    };
};
const $e3356dfe4cd83b33$var$mergeSubType = (oldResult, newResult)=>{
    var _newResult$data5, _newResult$data6, _oldResult$data5;
    // for classic pages, subType is 'null'
    if (((_newResult$data5 = newResult.data) === null || _newResult$data5 === void 0 ? void 0 : _newResult$data5.sourceSubType) !== undefined) return newResult.data.sourceSubType;
    if ((_newResult$data6 = newResult.data) !== null && _newResult$data6 !== void 0 && _newResult$data6.sourceAri) // for blogposts, subType is always undefined
    try {
        var _newResult$data7;
        const { type: pageType } = (0, $7Qiv5.getPageIdAndTypeFromConfluencePageAri)({
            ari: (_newResult$data7 = newResult.data) === null || _newResult$data7 === void 0 ? void 0 : _newResult$data7.sourceAri
        });
        if (pageType === 'blogpost') {
            var _newResult$data8;
            return (_newResult$data8 = newResult.data) === null || _newResult$data8 === void 0 ? void 0 : _newResult$data8.sourceSubType;
        }
    } catch  {}
    return (_oldResult$data5 = oldResult.data) === null || _oldResult$data5 === void 0 ? void 0 : _oldResult$data5.sourceSubType;
};

});
parcelRegister("7Qiv5", function(module, exports) {
$parcel$export(module.exports, "getPageIdAndTypeFromConfluencePageAri", () => $60de5bd02f83d8f3$export$2ee4e689bde04de2);
/* eslint-disable require-unicode-regexp  */ const $60de5bd02f83d8f3$var$CONFLUENCE_PAGE_ARI_REGEX = /ari:cloud:confluence:[^:]+:(page|blogpost)\/(\d+)/;
const $60de5bd02f83d8f3$export$3c54cf45dfed84ea = ({ pageId: pageId, cloudId: cloudId, pageType: pageType })=>{
    return `ari:cloud:confluence:${cloudId}:${pageType}/${pageId}`;
};
const $60de5bd02f83d8f3$export$2ee4e689bde04de2 = ({ ari: ari })=>{
    const match = ari.match($60de5bd02f83d8f3$var$CONFLUENCE_PAGE_ARI_REGEX);
    if (match !== null && match !== void 0 && match[2]) return {
        type: match[1],
        id: match[2]
    };
    throw new Error(`Invalid page ARI: ${ari}`);
};

});


parcelRegister("kQGqU", function(module, exports) {
$parcel$export(module.exports, "parseResourceId", () => $c9a9b8066d09bab3$export$8aafdd7901afa57f);

var $ksaKs = parcelRequire("ksaKs");
const $c9a9b8066d09bab3$var$isSyncBlockProduct = (product)=>{
    return (0, $ksaKs.SYNC_BLOCK_PRODUCTS).includes(product);
};
const $c9a9b8066d09bab3$export$8aafdd7901afa57f = (resourceId)=>{
    if (!resourceId) return undefined;
    const [product, contentId, uuid, ...rest] = resourceId.split('/');
    // invalid if any part is missing or there are extra parts
    if (!product || !contentId || !uuid || rest.length > 0) return undefined;
    // invalid if product is not recognized
    if (!$c9a9b8066d09bab3$var$isSyncBlockProduct(product)) return undefined;
    return {
        product: product,
        contentId: contentId,
        uuid: uuid
    };
};
const $c9a9b8066d09bab3$export$cf5895b3b46faf63 = (product, contentId, uuid)=>{
    return `${product}/${contentId}/${uuid}`;
};

});
parcelRegister("ksaKs", function(module, exports) {
$parcel$export(module.exports, "SYNC_BLOCK_PRODUCTS", () => $3b2d7eb27a1245ee$export$c05408ef703373ad);
const $3b2d7eb27a1245ee$export$c05408ef703373ad = [
    'confluence-page',
    'jira-work-item'
];

});


parcelRegister("2cmK7", function(module, exports) {
$parcel$export(module.exports, "SyncBlockBatchFetcher", () => $a7a8a4d901851de4$export$7d827e0357659116);

var $9wZWu = parcelRequire("9wZWu");

var $j2Y9J = parcelRequire("j2Y9J");

var $cSue1 = parcelRequire("cSue1");

var $hYuzB = parcelRequire("hYuzB");

var $iYvEr = parcelRequire("iYvEr");
class $a7a8a4d901851de4$export$7d827e0357659116 {
    constructor(deps){
        this.deps = deps;
        this.pendingFetchRequests = new Set();
        // Tracks resourceIds whose batched fetch is in flight (after RAF drains
        // pendingFetchRequests, before the promise settles). Ensures
        // `hasPendingFetch` remains true during the network window.
        this.inFlightFetches = new Set();
        this.isDestroyed = false;
        this.scheduledBatchFetch = (0, $9wZWu.default)(()=>{
            if (this.pendingFetchRequests.size === 0) return;
            // EDITOR-7860: not ready — skip and leave resourceIds queued for the
            // next batch once the provider resolves.
            if (this.deps.isProviderReady && !this.deps.isProviderReady()) return;
            const resourceIds = Array.from(this.pendingFetchRequests);
            const syncBlockNodes = resourceIds.map((resId)=>{
                const subscriptions = this.deps.getSubscriptions().get(resId) || {};
                const firstLocalId = Object.keys(subscriptions)[0] || '';
                return (0, $iYvEr.createSyncBlockNode)(firstLocalId, resId);
            });
            this.pendingFetchRequests.clear();
            // Track in-flight before the fetch so guards remain positive.
            resourceIds.forEach((resId)=>this.inFlightFetches.add(resId));
            this.deps.fetchSyncBlocksData(syncBlockNodes).catch((error)=>{
                // EDITOR-7860: benign not-ready throw — re-queue for retry and emit
                // nothing (no analytics, no exception-tracker noise). Checked before
                // `logException` so the benign case stays silent. Re-schedule so the
                // re-queued IDs are retried on the next frame even if no further
                // `queueFetch()` arrives.
                if ((0, $cSue1.isProviderNotReadyError)(error)) {
                    resourceIds.forEach((resId)=>this.pendingFetchRequests.add(resId));
                    if (!this.isDestroyed) this.scheduledBatchFetch();
                    return;
                }
                (0, $j2Y9J.logException)(error, {
                    location: 'editor-synced-block-provider/syncBlockBatchFetcher/batchedFetchSyncBlocks'
                });
                const attribution = (0, $hYuzB.buildFetchErrorAttribution)(error.message);
                resourceIds.forEach((resId)=>{
                    var _this$deps$getFireAna;
                    (_this$deps$getFireAna = this.deps.getFireAnalyticsEvent()) === null || _this$deps$getFireAna === void 0 || _this$deps$getFireAna((0, $hYuzB.fetchErrorPayload)(error.message, resId, (0, $iYvEr.getSourceProductFromResourceIdSafe)(resId), attribution));
                });
            }).finally(()=>{
                // If the fetcher was destroyed while the request was in flight,
                // skip cleanup — `destroy()` already cleared `inFlightFetches`
                // and there's nothing observable to update.
                if (this.isDestroyed) return;
                // Clear in-flight tracking once the fetch settles.
                resourceIds.forEach((resId)=>this.inFlightFetches.delete(resId));
            });
        });
    }
    queueFetch(resourceId) {
        const subscriptions = this.deps.getSubscriptions();
        if (subscriptions.has(resourceId) && Object.keys(subscriptions.get(resourceId) || {}).length > 0) {
            this.pendingFetchRequests.add(resourceId);
            this.scheduledBatchFetch();
        } else this.pendingFetchRequests.delete(resourceId);
    }
    /**
   * Returns true if a batched fetch is queued or in flight for `resourceId`.
   * Used by cache deletion guards to prevent deleting while a fetch is
   * about to populate the entry.
   */ hasPendingFetch(resourceId) {
        return this.pendingFetchRequests.has(resourceId) || this.inFlightFetches.has(resourceId);
    }
    cancel() {
        this.scheduledBatchFetch.cancel();
    }
    clearPending() {
        this.pendingFetchRequests.clear();
    }
    destroy() {
        this.isDestroyed = true;
        this.cancel();
        this.clearPending();
        // Clear in-flight tracking to prevent stale entries after teardown.
        this.inFlightFetches.clear();
    }
}

});

parcelRegister("3PQZm", function(module, exports) {
$parcel$export(module.exports, "syncBlockInMemorySessionCache", () => $e07822f98c143a5c$export$b811313deafee9ed);
/**
 * In-memory session cache for sync block data with size-based LRU eviction.
 *
 * Backed by a plain Map so that potentially private ADF content is never
 * written to any browser-persistent storage (sessionStorage, localStorage,
 * IndexedDB). The module-level singleton survives SPA transitions (no full
 * page reload) and is naturally cleared on hard navigation or tab close.
 *
 * Uses JavaScript Map's insertion-order guarantee to implement LRU:
 * on every read or write the accessed entry is moved to the end of the
 * iteration order; when total cached size exceeds `maxSize`, the oldest
 * (least-recently-used) entries are evicted first.
 */ class $e07822f98c143a5c$export$75f7f86498dcaabe {
    constructor(maxSize = 5242880){
        this.store = new Map();
        this.currentSize = 0;
        this.maxSize = maxSize;
    }
    /**
   * Retrieves a cached value by key.
   *
   * **Side-effect:** promotes the entry to the most-recently-used
   * position by re-inserting it at the end of the underlying Map's
   * iteration order.
   */ getItem(key) {
        const value = this.store.get(key);
        if (value === undefined) return null;
        this.store.delete(key);
        this.store.set(key, value);
        return value;
    }
    setItem(key, value) {
        const existing = this.store.get(key);
        if (existing !== undefined) {
            this.currentSize -= existing.length;
            this.store.delete(key);
        }
        this.store.set(key, value);
        this.currentSize += value.length;
        while(this.currentSize > this.maxSize && this.store.size > 1){
            const oldestKey = this.store.keys().next().value;
            if (oldestKey !== undefined) {
                const oldestValue = this.store.get(oldestKey);
                if (oldestValue !== undefined) this.currentSize -= oldestValue.length;
                this.store.delete(oldestKey);
            }
        }
    }
    removeItem(key) {
        const value = this.store.get(key);
        if (value !== undefined) {
            this.currentSize -= value.length;
            this.store.delete(key);
        }
    }
    /**
   * Removes all entries from the cache and resets the tracked size to zero.
   * Useful for cleaning up the singleton on SPA navigation boundaries.
   */ clear() {
        this.store.clear();
        this.currentSize = 0;
    }
}
const $e07822f98c143a5c$export$b811313deafee9ed = new $e07822f98c143a5c$export$75f7f86498dcaabe();

});

parcelRegister("7gkMl", function(module, exports) {
$parcel$export(module.exports, "SyncBlockProviderFactoryManager", () => $d7fdfe5d7d96f5c0$export$3bfff6c128de82c9);

var $7lseo = parcelRequire("7lseo");

var $j2Y9J = parcelRequire("j2Y9J");

var $5zxDU = parcelRequire("5zxDU");

var $hYuzB = parcelRequire("hYuzB");

var $kQGqU = parcelRequire("kQGqU");

var $iYvEr = parcelRequire("iYvEr");
class $d7fdfe5d7d96f5c0$export$3bfff6c128de82c9 {
    constructor(deps){
        this.deps = deps;
        this.providerFactories = new Map();
    }
    getProviderFactory(resourceId) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) {
            var _this$deps$getFireAna;
            const error = new Error('Data provider not set');
            (0, $j2Y9J.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockProviderFactoryManager'
            });
            (_this$deps$getFireAna = this.deps.getFireAnalyticsEvent()) === null || _this$deps$getFireAna === void 0 || _this$deps$getFireAna((0, $hYuzB.fetchErrorPayload)(error.message, resourceId, (0, $iYvEr.getSourceProductFromResourceIdSafe)(resourceId), (0, $hYuzB.buildFetchErrorAttribution)(error.message)));
            return undefined;
        }
        let providerFactory = this.providerFactories.get(resourceId);
        if (!providerFactory) {
            const { parentDataProviders: parentDataProviders } = dataProvider.getSyncedBlockRendererProviderOptions();
            providerFactory = (0, $5zxDU.default).create({
                mentionProvider: parentDataProviders === null || parentDataProviders === void 0 ? void 0 : parentDataProviders.mentionProvider,
                profilecardProvider: parentDataProviders === null || parentDataProviders === void 0 ? void 0 : parentDataProviders.profilecardProvider,
                taskDecisionProvider: parentDataProviders === null || parentDataProviders === void 0 ? void 0 : parentDataProviders.taskDecisionProvider
            });
            this.providerFactories.set(resourceId, providerFactory);
        }
        // Syncing providers notifies subscribers synchronously, so on the client it
        // cannot run during render - callers invoke `syncProviders` from an effect
        // instead. Effects never run while server rendering, and there are no mounted
        // subscribers to notify, so the server keeps applying them inline.
        if (!(0, $7lseo.isSSR)()) return providerFactory;
        this.syncProviders(resourceId, providerFactory);
        return providerFactory;
    }
    /**
   * The provider options currently supplied by the host. A pure read that does
   * not notify subscribers, so it is safe to call during render - callers use it
   * to detect when the host swaps a provider and the factory needs re-syncing.
   */ getProviderOptions() {
        var _this$deps$getDataPro;
        return (_this$deps$getDataPro = this.deps.getDataProvider()) === null || _this$deps$getDataPro === void 0 ? void 0 : _this$deps$getDataPro.getSyncedBlockRendererProviderOptions();
    }
    /**
   * Applies the latest parent and dynamic providers to the cached factory.
   * Notifies subscribers, so must be called from an effect, never during render.
   */ syncProviders(resourceId, factory) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) return;
        const providerFactory = factory ?? this.providerFactories.get(resourceId);
        if (!providerFactory) return;
        const { parentDataProviders: parentDataProviders, providerCreator: providerCreator } = dataProvider.getSyncedBlockRendererProviderOptions();
        if (parentDataProviders !== null && parentDataProviders !== void 0 && parentDataProviders.mentionProvider) providerFactory.setProvider('mentionProvider', parentDataProviders === null || parentDataProviders === void 0 ? void 0 : parentDataProviders.mentionProvider);
        if (parentDataProviders !== null && parentDataProviders !== void 0 && parentDataProviders.profilecardProvider) providerFactory.setProvider('profilecardProvider', parentDataProviders === null || parentDataProviders === void 0 ? void 0 : parentDataProviders.profilecardProvider);
        if (parentDataProviders !== null && parentDataProviders !== void 0 && parentDataProviders.taskDecisionProvider) providerFactory.setProvider('taskDecisionProvider', parentDataProviders === null || parentDataProviders === void 0 ? void 0 : parentDataProviders.taskDecisionProvider);
        if (!providerCreator) return;
        try {
            this.retrieveDynamicProviders(resourceId, providerFactory, providerCreator);
        } catch (error) {
            var _this$deps$getFireAna2;
            (0, $j2Y9J.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockProviderFactoryManager'
            });
            (_this$deps$getFireAna2 = this.deps.getFireAnalyticsEvent()) === null || _this$deps$getFireAna2 === void 0 || _this$deps$getFireAna2((0, $hYuzB.fetchErrorPayload)(error.message, resourceId, (0, $iYvEr.getSourceProductFromResourceIdSafe)(resourceId), (0, $hYuzB.buildFetchErrorAttribution)(error.message)));
        }
    }
    getSSRProviders(resourceId) {
        var _syncBlock$data, _syncBlock$data2;
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) return null;
        const { providerCreator: providerCreator } = dataProvider.getSyncedBlockRendererProviderOptions();
        if (!(providerCreator !== null && providerCreator !== void 0 && providerCreator.createSSRMediaProvider)) return null;
        const parsedResourceId = (0, $kQGqU.parseResourceId)(resourceId);
        if (!parsedResourceId) return null;
        let { contentId: contentId, product: contentProduct } = parsedResourceId;
        const syncBlock = this.deps.getFromCache(resourceId);
        let contentAri = (syncBlock === null || syncBlock === void 0 || (_syncBlock$data = syncBlock.data) === null || _syncBlock$data === void 0 ? void 0 : _syncBlock$data.sourceAri) || '';
        if (syncBlock !== null && syncBlock !== void 0 && (_syncBlock$data2 = syncBlock.data) !== null && _syncBlock$data2 !== void 0 && _syncBlock$data2.sourceAri && syncBlock.data.product) {
            const parentInfo = dataProvider.retrieveSyncBlockParentInfo(syncBlock.data.sourceAri, syncBlock.data.product);
            if (parentInfo) {
                contentId = parentInfo.contentId;
                contentProduct = parentInfo.contentProduct;
                contentAri = parentInfo.contentAri;
            }
        }
        try {
            const mediaProvider = providerCreator.createSSRMediaProvider({
                contentAri: contentAri,
                contentId: contentId,
                contentProduct: contentProduct
            });
            if (mediaProvider) return {
                media: mediaProvider
            };
        } catch (error) {
            (0, $j2Y9J.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockProviderFactoryManager'
            });
        }
        return null;
    }
    deleteFactory(resourceId) {
        this.providerFactories.delete(resourceId);
    }
    destroy() {
        this.providerFactories.forEach((pf)=>pf.destroy());
        this.providerFactories.clear();
    }
    retrieveDynamicProviders(resourceId, providerFactory, providerCreator) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) throw new Error('Data provider not set');
        const hasMediaProvider = providerFactory.hasProvider('mediaProvider');
        const hasEmojiProvider = providerFactory.hasProvider('emojiProvider');
        const hasCardProvider = providerFactory.hasProvider('cardProvider');
        if (hasMediaProvider && hasEmojiProvider && hasCardProvider) return;
        const syncBlock = this.deps.getFromCache(resourceId);
        if (!(syncBlock !== null && syncBlock !== void 0 && syncBlock.data)) return;
        if (!syncBlock.data.sourceAri || !syncBlock.data.product) {
            var _this$deps$getFireAna3;
            (_this$deps$getFireAna3 = this.deps.getFireAnalyticsEvent()) === null || _this$deps$getFireAna3 === void 0 || _this$deps$getFireAna3((0, $hYuzB.fetchErrorPayload)('Sync block source ari or product not found', resourceId, // Prefer cached product when available; fall back to parsing resourceId.
            syncBlock.data.product ?? (0, $iYvEr.getSourceProductFromResourceIdSafe)(resourceId), (0, $hYuzB.buildFetchErrorAttribution)('Sync block source ari or product not found')));
            return;
        }
        const parentInfo = dataProvider.retrieveSyncBlockParentInfo(syncBlock.data.sourceAri, syncBlock.data.product);
        if (!parentInfo) throw new Error('Unable to retrieve sync block parent info');
        const { contentAri: contentAri, contentId: contentId, contentProduct: contentProduct } = parentInfo;
        if (!hasMediaProvider && providerCreator.createMediaProvider && contentId && contentProduct) {
            const mediaProvider = providerCreator.createMediaProvider({
                contentAri: contentAri,
                contentProduct: contentProduct,
                contentId: contentId
            });
            if (mediaProvider) providerFactory.setProvider('mediaProvider', mediaProvider);
        }
        if (!hasEmojiProvider && providerCreator.createEmojiProvider && contentId && contentProduct) {
            const emojiProvider = providerCreator.createEmojiProvider({
                contentAri: contentAri,
                contentProduct: contentProduct,
                contentId: contentId
            });
            if (emojiProvider) providerFactory.setProvider('emojiProvider', emojiProvider);
        }
        if (!hasCardProvider && providerCreator.createSmartLinkProvider) {
            const smartLinkProvider = providerCreator.createSmartLinkProvider();
            if (smartLinkProvider) providerFactory.setProvider('cardProvider', smartLinkProvider);
        }
    }
}

});

parcelRegister("fuqSN", function(module, exports) {
$parcel$export(module.exports, "SyncBlockSubscriptionManager", () => $81d07ff700b912ff$export$200c87d47b3d6e17);

var $bAB3U = parcelRequire("bAB3U");

var $c9wRy = parcelRequire("c9wRy");

var $j2Y9J = parcelRequire("j2Y9J");

var $hYuzB = parcelRequire("hYuzB");

var $h5k7t = parcelRequire("h5k7t");

var $iYvEr = parcelRequire("iYvEr");
class $81d07ff700b912ff$export$200c87d47b3d6e17 {
    static #_ = // Reconnection with exponential backoff.
    this.INITIAL_RETRY_DELAY_MS = 1000;
    static #_2 = this.RETRY_BACKOFF_MULTIPLIER = 2;
    static #_3 = this.MAX_RETRY_ATTEMPTS_HARDENED = 8 // EDITOR-7861
    ;
    static #_4 = this.MAX_RETRY_DELAY_MS = 30000 // backoff cap
    ;
    static #_5 = // Coalesce wake-event bursts into one re-arm sweep to avoid a reconnection storm.
    this.WAKE_DEBOUNCE_MS = 1000;
    // EDITOR-7861: higher ceiling lets transient WS-gateway drops self-heal
    // before a terminal failure is surfaced.
    getMaxRetryAttempts() {
        return $81d07ff700b912ff$export$200c87d47b3d6e17.MAX_RETRY_ATTEMPTS_HARDENED;
    }
    // Backoff delay for the given attempt (EDITOR-7861): exponential capped at
    // MAX_RETRY_DELAY_MS with equal jitter (capped/2 + random*capped/2) —
    // de-synchronises simultaneous reconnects while guaranteeing a non-zero delay
    // (full jitter could hit 0).
    getReconnectionDelay(attempts) {
        const exponential = $81d07ff700b912ff$export$200c87d47b3d6e17.INITIAL_RETRY_DELAY_MS * Math.pow($81d07ff700b912ff$export$200c87d47b3d6e17.RETRY_BACKOFF_MULTIPLIER, attempts);
        const half = Math.min(exponential, $81d07ff700b912ff$export$200c87d47b3d6e17.MAX_RETRY_DELAY_MS) / 2;
        return Math.round(half + Math.random() * half);
    }
    constructor(deps){
        this.deps = deps;
        this.subscriptions = new Map();
        this.titleSubscriptions = new Map();
        this.graphqlSubscriptions = new Map();
        this.subscriptionChangeListeners = new Set();
        this.useRealTimeSubscriptions = false;
        this.retryAttempts = new Map();
        this.pendingRetries = new Map();
        // Resources whose reconnection exhausted while the tab was hidden: parked here and
        // re-armed on the next online / visibilitychange→visible instead of surfacing a
        // terminal error. Only a re-armed attempt that also exhausts while visible fails.
        this.deferredExhausted = new Set();
        this.wakeDebounceTimer = null;
        // `online` always sweeps (network is back regardless of tab visibility); a
        // `visibilitychange` only sweeps when the tab became visible.
        this.onOnline = ()=>this.scheduleWakeSweep();
        this.onVisibilityChange = ()=>{
            if (!this.isDocumentHidden()) this.scheduleWakeSweep();
        };
        // Cleanup fns returned by `bind` for the registered wake listeners; a non-empty
        // array means listeners are currently registered. Emptied on teardown.
        this.wakeListenerCleanups = [];
    }
    /**
   * Returns the subscriptions map. Used by external consumers (e.g. batch fetcher, flush)
   * that need to read the current subscription state.
   */ getSubscriptions() {
        return this.subscriptions;
    }
    setRealTimeSubscriptionsEnabled(enabled) {
        if (this.useRealTimeSubscriptions === enabled) return;
        this.useRealTimeSubscriptions = enabled;
        if (enabled) this.setupSubscriptionsForAllBlocks();
        else this.cleanupAll();
    }
    isRealTimeSubscriptionsEnabled() {
        return this.useRealTimeSubscriptions;
    }
    getSubscribedResourceIds() {
        return Array.from(this.subscriptions.keys());
    }
    onSubscriptionsChanged(listener) {
        this.subscriptionChangeListeners.add(listener);
        return ()=>{
            this.subscriptionChangeListeners.delete(listener);
        };
    }
    notifySubscriptionChangeListeners() {
        this.subscriptionChangeListeners.forEach((listener)=>{
            try {
                listener();
            } catch (error) {
                var _this$deps$getFireAna;
                (0, $j2Y9J.logException)(error, {
                    location: 'editor-synced-block-provider/syncBlockSubscriptionManager/notifySubscriptionChangeListeners'
                });
                (_this$deps$getFireAna = this.deps.getFireAnalyticsEvent()) === null || _this$deps$getFireAna === void 0 || _this$deps$getFireAna((0, $hYuzB.fetchErrorPayload)(error.message, undefined, undefined, (0, $hYuzB.buildFetchErrorAttribution)(error.message)));
            }
        });
    }
    handleSubscriptionUpdate(syncBlockInstance) {
        if (!syncBlockInstance.resourceId) return;
        const existing = this.deps.getFromCache(syncBlockInstance.resourceId);
        const resolved = existing ? (0, $h5k7t.resolveSyncBlockInstance)(existing, syncBlockInstance) : syncBlockInstance;
        this.deps.updateCache(resolved);
        if (!syncBlockInstance.error) this.deps.fetchSyncBlockSourceInfo(resolved.resourceId);
    }
    subscribeToSyncBlock(resourceId, localId, callback) {
        // Cancel any pending cache deletion for this resourceId.
        // This handles the case where a block is moved - the old component unmounts
        // (scheduling deletion) but the new component mounts and subscribes before
        // the deletion timeout fires.
        this.deps.cancelPendingCacheDeletion(resourceId);
        // add to subscriptions map
        const resourceSubscriptions = this.subscriptions.get(resourceId) || {};
        const isNewResourceSubscription = Object.keys(resourceSubscriptions).length === 0;
        this.subscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        // New subscription means new reference synced block is added to the document
        this.deps.markCacheDirty();
        // Notify listeners if this is a new resource subscription
        if (isNewResourceSubscription) this.notifySubscriptionChangeListeners();
        const cachedData = this.deps.getFromCache(resourceId);
        if (cachedData) callback(cachedData);
        else this.deps.debouncedBatchedFetchSyncBlocks(resourceId);
        // Set up GraphQL subscription if real-time subscriptions are enabled
        if (this.shouldUseRealTime()) this.setupSubscription(resourceId);
        return ()=>{
            const resourceSubscriptions = this.subscriptions.get(resourceId);
            if (resourceSubscriptions) {
                // Unsubscription means a reference synced block is removed from the document
                this.deps.markCacheDirty();
                delete resourceSubscriptions[localId];
                const remainingIds = Object.keys(resourceSubscriptions);
                if (remainingIds.length === 0) {
                    this.subscriptions.delete(resourceId);
                    // Clean up GraphQL subscription when no more local subscribers
                    this.cleanupSubscription(resourceId);
                    // Notify listeners that subscription was removed
                    this.notifySubscriptionChangeListeners();
                    // Delegate cache deletion to the store manager
                    // which uses a 30s grace period with guard re-checks.
                    this.deps.scheduleCacheDeletion(resourceId);
                } else this.subscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    subscribeToSourceTitle(node, callback) {
        var _cachedData$data;
        // check node is a sync block, as we only support sync block subscriptions
        if (node.type.name !== 'syncBlock') return ()=>{};
        const { resourceId: resourceId, localId: localId } = node.attrs;
        if (!localId || !resourceId) return ()=>{};
        const cachedData = this.deps.getFromCache(resourceId);
        if (cachedData !== null && cachedData !== void 0 && (_cachedData$data = cachedData.data) !== null && _cachedData$data !== void 0 && _cachedData$data.sourceTitle) callback(cachedData.data.sourceTitle);
        // add to subscriptions map
        const resourceSubscriptions = this.titleSubscriptions.get(resourceId) || {};
        this.titleSubscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        return ()=>{
            const resourceSubscriptions = this.titleSubscriptions.get(resourceId);
            if (resourceSubscriptions) {
                delete resourceSubscriptions[localId];
                if (Object.keys(resourceSubscriptions).length === 0) this.titleSubscriptions.delete(resourceId);
                else this.titleSubscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    updateSourceTitleSubscriptions(resourceId, title) {
        const callbacks = this.titleSubscriptions.get(resourceId);
        if (callbacks) Object.values(callbacks).forEach((callback)=>{
            callback(title);
        });
    }
    /**
   * Notifies all subscription callbacks for a given resource ID with the provided sync block instance.
   */ notifySubscriptionCallbacks(resourceId, syncBlock) {
        const callbacks = this.subscriptions.get(resourceId);
        if (callbacks) Object.values(callbacks).forEach((callback)=>{
            callback(syncBlock);
        });
    }
    setupSubscription(resourceId) {
        if (this.graphqlSubscriptions.has(resourceId)) return;
        const dataProvider = this.deps.getDataProvider();
        if (!(dataProvider !== null && dataProvider !== void 0 && dataProvider.subscribeToBlockUpdates)) return;
        const unsubscribe = dataProvider.subscribeToBlockUpdates(resourceId, (syncBlockInstance)=>{
            this.handleGraphQLUpdate(syncBlockInstance);
        }, (error)=>{
            (0, $j2Y9J.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockSubscriptionManager/graphql-subscription'
            });
            // EDITOR-7861: a single socket drop is usually transient and recovers
            // on reconnect, so we don't fire a user-facing error here — it's only
            // surfaced on exhaustion, where the structured attribution
            // (EDITOR-7862) is applied too. See scheduleReconnection.
            this.handleSubscriptionTerminated(resourceId);
        }, ()=>{
            this.handleSubscriptionTerminated(resourceId);
        });
        if (unsubscribe) this.graphqlSubscriptions.set(resourceId, unsubscribe);
    }
    /**
   * Handles subscription termination (complete or error) by cleaning up the
   * stale entry and scheduling a reconnection with exponential backoff.
   */ handleSubscriptionTerminated(resourceId) {
        // Remove the stale subscription entry so setupSubscription won't early-return
        this.graphqlSubscriptions.delete(resourceId);
        // Guard against duplicate calls (graphql-ws can fire both error and complete)
        if (this.pendingRetries.has(resourceId)) return;
        // Only reconnect if there are still active subscribers for this resource
        if (this.subscriptions.has(resourceId) && this.shouldUseRealTime()) this.scheduleReconnection(resourceId);
    }
    // Schedules a reconnection with backoff (see getMaxRetryAttempts /
    // getReconnectionDelay for the gated behaviour).
    scheduleReconnection(resourceId) {
        const attempts = this.retryAttempts.get(resourceId) ?? 0;
        const maxAttempts = this.getMaxRetryAttempts();
        if (attempts >= maxAttempts) {
            var _this$deps$getFireAna3;
            // Exhausted all attempts — the only place a WS drop surfaces as a
            // fetch error (EDITOR-7861).
            const errorMessage = `Subscription reconnection failed after ${attempts} attempts`;
            // Tab hidden at exhaustion: don't surface a terminal failure (user isn't
            // looking, and most exhaustions self-recover once foregrounded). Park + re-arm
            // on wake, emitting a benign `deferred` signal so suppression stays auditable.
            if (this.isDocumentHidden()) {
                var _this$deps$getFireAna2;
                this.deferredExhausted.add(resourceId);
                this.registerWakeListeners();
                (_this$deps$getFireAna2 = this.deps.getFireAnalyticsEvent()) === null || _this$deps$getFireAna2 === void 0 || _this$deps$getFireAna2((0, $hYuzB.fetchErrorPayload)(errorMessage, resourceId, (0, $iYvEr.getSourceProductFromResourceIdSafe)(resourceId), (0, $hYuzB.buildFetchErrorAttribution)(errorMessage, undefined, /* deferred */ true)));
                return;
            }
            (0, $j2Y9J.logException)(new Error(errorMessage), {
                location: 'editor-synced-block-provider/syncBlockSubscriptionManager/max-retries-exhausted'
            });
            (_this$deps$getFireAna3 = this.deps.getFireAnalyticsEvent()) === null || _this$deps$getFireAna3 === void 0 || _this$deps$getFireAna3((0, $hYuzB.fetchErrorPayload)(errorMessage, resourceId, (0, $iYvEr.getSourceProductFromResourceIdSafe)(resourceId), (0, $hYuzB.buildFetchErrorAttribution)(errorMessage)));
            return;
        }
        const delay = this.getReconnectionDelay(attempts);
        const timer = setTimeout(()=>{
            this.pendingRetries.delete(resourceId);
            // Only re-subscribe if still relevant
            if (this.subscriptions.has(resourceId) && this.shouldUseRealTime()) {
                this.setupSubscription(resourceId);
                // Only increment if the subscription was actually established
                // (setupSubscription may be a no-op if another code path already re-established it)
                if (this.graphqlSubscriptions.has(resourceId)) this.retryAttempts.set(resourceId, attempts + 1);
            } else // Conditions no longer met — clean up stale retry state
            this.retryAttempts.delete(resourceId);
        }, delay);
        this.pendingRetries.set(resourceId, timer);
    }
    /**
   * Resets the retry counter for a resource. Called when a successful
   * update is received, indicating the subscription is healthy.
   */ resetRetryCount(resourceId) {
        this.retryAttempts.delete(resourceId);
    }
    /**
   * Whether the tab is currently hidden. SSR/non-browser is treated as "not hidden" so
   * we never defer where wake events can't fire (realtime never subscribes there anyway).
   */ isDocumentHidden() {
        var _getDocument;
        return ((_getDocument = (0, $c9wRy.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.hidden) === true;
    }
    /**
   * Lazily register shared `online` / `visibilitychange` listeners on first deferral.
   * Torn down by `unregisterWakeListeners` (via `handleWake`). No-op in SSR / non-browser.
   */ registerWakeListeners() {
        if (this.wakeListenerCleanups.length > 0 || typeof window === 'undefined') return;
        this.wakeListenerCleanups.push((0, $bAB3U.bind)(window, {
            type: 'online',
            listener: this.onOnline
        }));
        const doc = (0, $c9wRy.getDocument)();
        if (doc) this.wakeListenerCleanups.push((0, $bAB3U.bind)(doc, {
            type: 'visibilitychange',
            listener: this.onVisibilityChange
        }));
    }
    unregisterWakeListeners() {
        if (this.wakeDebounceTimer !== null) {
            clearTimeout(this.wakeDebounceTimer);
            this.wakeDebounceTimer = null;
        }
        for (const cleanup of this.wakeListenerCleanups)cleanup();
        this.wakeListenerCleanups = [];
    }
    /**
   * Coalesce a burst of wake events into one debounced re-arm sweep. Callers decide
   * eligibility: `onOnline` always sweeps; `onVisibilityChange` only sweeps when visible.
   */ scheduleWakeSweep() {
        if (this.wakeDebounceTimer !== null) return;
        this.wakeDebounceTimer = setTimeout(()=>{
            this.wakeDebounceTimer = null;
            this.handleWake();
        }, $81d07ff700b912ff$export$200c87d47b3d6e17.WAKE_DEBOUNCE_MS);
    }
    /**
   * Re-arm every deferred resource: full reset (attempts→0) + immediate reconnect now
   * the tab is visible / online. Healthy subscriptions are untouched. A re-armed cycle
   * that later exhausts while visible fires the terminal error normally.
   */ handleWake() {
        if (this.deferredExhausted.size === 0) {
            this.unregisterWakeListeners();
            return;
        }
        const toRearm = Array.from(this.deferredExhausted);
        this.deferredExhausted.clear();
        for (const resourceId of toRearm){
            // Only re-arm resources that still have active subscribers and realtime on.
            if (!this.subscriptions.has(resourceId) || !this.shouldUseRealTime()) continue;
            this.resetRetryCount(resourceId);
            this.cancelPendingRetry(resourceId);
            this.setupSubscription(resourceId);
        }
        // No deferred resources remain until another hidden exhaustion re-adds one.
        this.unregisterWakeListeners();
    }
    cancelPendingRetry(resourceId) {
        const timer = this.pendingRetries.get(resourceId);
        if (timer) {
            clearTimeout(timer);
            this.pendingRetries.delete(resourceId);
        }
    }
    cancelAllPendingRetries() {
        for (const timer of this.pendingRetries.values())clearTimeout(timer);
        this.pendingRetries.clear();
        this.retryAttempts.clear();
        // Nothing left to re-arm: drop parked exhaustions and tear down wake listeners.
        this.deferredExhausted.clear();
        this.unregisterWakeListeners();
    }
    cleanupSubscription(resourceId) {
        const unsubscribe = this.graphqlSubscriptions.get(resourceId);
        if (unsubscribe) {
            unsubscribe();
            this.graphqlSubscriptions.delete(resourceId);
        }
        this.cancelPendingRetry(resourceId);
        this.retryAttempts.delete(resourceId);
        // No subscribers left, so this resource can't be re-armed.
        this.deferredExhausted.delete(resourceId);
        if (this.deferredExhausted.size === 0) this.unregisterWakeListeners();
    }
    setupSubscriptionsForAllBlocks() {
        for (const resourceId of this.subscriptions.keys())this.setupSubscription(resourceId);
    }
    cleanupAll() {
        for (const unsubscribe of this.graphqlSubscriptions.values())unsubscribe();
        this.graphqlSubscriptions.clear();
        this.cancelAllPendingRetries();
    }
    destroy() {
        this.cleanupAll();
        this.subscriptions.clear();
        this.titleSubscriptions.clear();
        this.subscriptionChangeListeners.clear();
        this.useRealTimeSubscriptions = false;
    }
    shouldUseRealTime() {
        return this.useRealTimeSubscriptions;
    }
    handleGraphQLUpdate(syncBlockInstance) {
        if (!syncBlockInstance.resourceId) return;
        const existing = this.deps.getFromCache(syncBlockInstance.resourceId);
        const resolved = existing ? (0, $h5k7t.resolveSyncBlockInstance)(existing, syncBlockInstance) : syncBlockInstance;
        this.deps.updateCache(resolved);
        if (!syncBlockInstance.error) {
            this.resetRetryCount(syncBlockInstance.resourceId);
            // A healthy update means a parked exhaustion recovered on its own before any
            // wake sweep — drop it and tear down listeners if nothing else is parked.
            if (this.deferredExhausted.delete(syncBlockInstance.resourceId)) {
                if (this.deferredExhausted.size === 0) this.unregisterWakeListeners();
            }
            const callbacks = this.subscriptions.get(syncBlockInstance.resourceId);
            const localIds = callbacks ? Object.keys(callbacks) : [];
            localIds.forEach((localId)=>{
                var _this$deps$getFireAna4, _syncBlockInstance$da;
                (_this$deps$getFireAna4 = this.deps.getFireAnalyticsEvent()) === null || _this$deps$getFireAna4 === void 0 || _this$deps$getFireAna4((0, $hYuzB.fetchSuccessPayload)(syncBlockInstance.resourceId, localId, ((_syncBlockInstance$da = syncBlockInstance.data) === null || _syncBlockInstance$da === void 0 ? void 0 : _syncBlockInstance$da.product) ?? (0, $iYvEr.getSourceProductFromResourceIdSafe)(syncBlockInstance.resourceId)));
            });
            this.deps.fetchSyncBlockSourceInfo(resolved.resourceId);
        } else {
            var _syncBlockInstance$er, _syncBlockInstance$er2, _this$deps$getFireAna5, _syncBlockInstance$da2, _syncBlockInstance$er3, _syncBlockInstance$er4, _syncBlockInstance$er5;
            const errorMessage = ((_syncBlockInstance$er = syncBlockInstance.error) === null || _syncBlockInstance$er === void 0 ? void 0 : _syncBlockInstance$er.reason) || ((_syncBlockInstance$er2 = syncBlockInstance.error) === null || _syncBlockInstance$er2 === void 0 ? void 0 : _syncBlockInstance$er2.type);
            // Prefer the structured `type` (a `SyncBlockError` enum value) for classification
            // and fall back to the free-text `reason` so source-state/permission strings are
            // still bucketed (EDITOR-7862). The emitted free-text `error` attribute is unchanged.
            (_this$deps$getFireAna5 = this.deps.getFireAnalyticsEvent()) === null || _this$deps$getFireAna5 === void 0 || _this$deps$getFireAna5((0, $hYuzB.fetchErrorPayload)(errorMessage, syncBlockInstance.resourceId, ((_syncBlockInstance$da2 = syncBlockInstance.data) === null || _syncBlockInstance$da2 === void 0 ? void 0 : _syncBlockInstance$da2.product) ?? (0, $iYvEr.getSourceProductFromResourceIdSafe)(syncBlockInstance.resourceId), (0, $hYuzB.buildFetchErrorAttribution)(((_syncBlockInstance$er3 = syncBlockInstance.error) === null || _syncBlockInstance$er3 === void 0 ? void 0 : _syncBlockInstance$er3.type) || ((_syncBlockInstance$er4 = syncBlockInstance.error) === null || _syncBlockInstance$er4 === void 0 ? void 0 : _syncBlockInstance$er4.reason), (_syncBlockInstance$er5 = syncBlockInstance.error) === null || _syncBlockInstance$er5 === void 0 ? void 0 : _syncBlockInstance$er5.statusCode)));
        }
    }
}

});


parcelRegister("aEgRx", function(module, exports) {
$parcel$export(module.exports, "SourceSyncBlockStoreManager", () => $8765f30adf7f98b9$export$9c6faa8962092f36);

var $j2Y9J = parcelRequire("j2Y9J");

var $3y2s4 = parcelRequire("3y2s4");

var $cSue1 = parcelRequire("cSue1");

var $hYuzB = parcelRequire("hYuzB");

var $8KNyr = parcelRequire("8KNyr");

var $idDos = parcelRequire("idDos");

var $iYvEr = parcelRequire("iYvEr");
/** Maximum time (ms) flush() will wait for in-flight block creations before proceeding. */ const $8765f30adf7f98b9$var$FLUSH_CREATION_AWAIT_TIMEOUT_MS = 1000;
/**
 * Window (ms) within which a repeated `syncedBlockDelete` emission for the same
 * resourceId is suppressed. The same logical removal can re-fire across
 * rebased/remote/redo transactions; a short window collapses those bursts to one
 * event while still allowing a genuine delete→recreate→delete later.
 */ const $8765f30adf7f98b9$var$DELETE_DEDUPE_WINDOW_MS = 5000;
class $8765f30adf7f98b9$export$9c6faa8962092f36 {
    constructor(dataProvider, viewMode, isLivePage){
        this.localSourceSubscribers = new Map();
        this.hasReceivedContentChange = false;
        /**
   * Promises for in-flight block creations, keyed by resourceId.
   * `flush()` awaits these so that blocks created from existing content are
   * persisted even if no further edits trigger a subsequent flush.
   * See EDITOR-7112.
   */ this.pendingCreationPromises = new Map();
        /**
   * Set of resource IDs whose creation was still in-flight when a `flush()`
   * timed out. Each completion (success or failure) is removed from this set;
   * the first successful completion of any of these IDs triggers
   * `postCreationFlushCallback` so the content is eventually persisted.
   * Tracking IDs (not just a boolean) avoids dropping late completions when
   * multiple blocks are created concurrently. See EDITOR-7112.
   */ this.creationsTimedOutDuringFlush = new Set();
        /**
   * Creation-type signals captured at `createBodiedSyncBlockNode` time and read
   * back in `commitPendingCreation` to enrich the `syncedBlockCreate` event.
   * Kept out of the flushed cache record so it never leaks into Block Service /
   * ADF; removed once consumed.
   */ this.creationEnrichment = new Map();
        /**
   * Source blocks created by the local insert command in this editor session that
   * have not yet been reconciled with authoritative reference data. This state is
   * intentionally kept out of ADF and the backend cache so reloaded, restored,
   * copied, and remotely inserted sources cannot inherit it.
   */ this.newSourceBlockResourceIds = new Set();
        /**
   * Resource IDs of blocks created empty this session that have not yet fired
   * the first-content-added event. Added on empty creation, removed when the
   * block first gains content (the event fires once). Blocks created with
   * content or not created this session are never tracked.
   */ this.awaitingFirstContent = new Set();
        /**
   * resourceId -> timestamp (ms) of the last `syncedBlockDelete` emission, used
   * to suppress duplicates within {@link DELETE_DEDUPE_WINDOW_MS}.
   */ this.recentDeleteEmissions = new Map();
        this.setPendingDeletion = (Ids, value)=>{
            if (this.viewMode === 'view') return;
            const syncBlock = this.syncBlockCache.get(Ids.resourceId);
            if (syncBlock) syncBlock.pendingDeletion = value;
        };
        this.dataProvider = dataProvider;
        this.viewMode = viewMode;
        this.isLivePage = isLivePage;
        this.syncBlockCache = new Map();
        this.creationCompletionCallbacks = new Map();
    }
    /**
   * Register a callback to be invoked after flush() completes.
   * Used by the pm-plugin to dispatch a transaction so that
   * hasUnsavedBodiedSyncBlockChanges is recalculated in plugin state.
   */ registerFlushCompletionCallback(callback) {
        this.flushCompletionCallback = callback;
    }
    /**
   * Register a callback to be invoked when flush() timed out waiting for a
   * pending block creation and that creation subsequently completes. The
   * callback should trigger a deferred flush to persist the content that
   * was skipped due to the timeout. See EDITOR-7112.
   */ registerPostCreationFlushCallback(callback) {
        this.postCreationFlushCallback = callback;
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.createExperience = (0, $8KNyr.getCreateSourceExperience)(fireAnalyticsEvent);
        this.saveExperience = (0, $8KNyr.getSaveSourceExperience)(fireAnalyticsEvent);
        this.deleteExperience = (0, $8KNyr.getDeleteSourceExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $8KNyr.getFetchSourceInfoExperience)(fireAnalyticsEvent);
    }
    isSourceBlock(node) {
        return node.type.name === 'bodiedSyncBlock';
    }
    isNewSourceBlock(resourceId) {
        return this.newSourceBlockResourceIds.has(resourceId);
    }
    clearNewSourceBlock(resourceId) {
        this.newSourceBlockResourceIds.delete(resourceId);
    }
    /**
   * Add/update a sync block node to/from the local cache
   * @param syncBlockNode - The sync block node to update
   */ updateSyncBlockData(syncBlockNode, isRemote) {
        try {
            var _cachedBlock$contentF;
            if (this.viewMode === 'view') return false;
            if (!this.isSourceBlock(syncBlockNode)) throw new Error('Invalid sync block node type provided for updateSyncBlockData');
            const { localId: localId, resourceId: resourceId } = syncBlockNode.attrs;
            if (!localId || !resourceId) // Identifiers not populated yet: benign timing case, skip as a no-op.
            return false;
            const cachedBlock = this.syncBlockCache.get(resourceId);
            // Fast path: if the PM content fragment hasn't changed, skip serialization entirely
            // Fragment.eq() leverages ProseMirror's structural sharing for O(1) comparison
            if (cachedBlock !== null && cachedBlock !== void 0 && (_cachedBlock$contentF = cachedBlock.contentFragment) !== null && _cachedBlock$contentF !== void 0 && _cachedBlock$contentF.eq(syncBlockNode.content)) return true;
            const syncBlockData = (0, $iYvEr.convertSyncBlockPMNodeToSyncBlockData)(syncBlockNode);
            if (cachedBlock && !isRemote) this.hasReceivedContentChange = true;
            const isDirty = !isRemote || !cachedBlock; // if the change is not remote, or the block is not in the cache yet, it's dirty
            this.syncBlockCache.set(resourceId, {
                ...syncBlockData,
                isDirty: isDirty,
                // if the change is from remote, it's not dirty
                contentFragment: syncBlockNode.content,
                status: cachedBlock === null || cachedBlock === void 0 ? void 0 : cachedBlock.status
            });
            this.notifyLocalSource(resourceId);
            return true;
        } catch (error) {
            var _this$fireAnalyticsEv, _syncBlockNode$attrs, _syncBlockNode$attrs2;
            (0, $j2Y9J.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            // We can derive the product from `syncBlockNode.attrs.resourceId` even though
            // the variable wasn't destructured (the destructuring step itself may have thrown).
            (_this$fireAnalyticsEv = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv === void 0 || _this$fireAnalyticsEv.call(this, (0, $hYuzB.updateCacheErrorPayload)(error.message, syncBlockNode === null || syncBlockNode === void 0 || (_syncBlockNode$attrs = syncBlockNode.attrs) === null || _syncBlockNode$attrs === void 0 ? void 0 : _syncBlockNode$attrs.resourceId, (0, $iYvEr.getSourceProductFromResourceIdSafe)(syncBlockNode === null || syncBlockNode === void 0 || (_syncBlockNode$attrs2 = syncBlockNode.attrs) === null || _syncBlockNode$attrs2 === void 0 ? void 0 : _syncBlockNode$attrs2.resourceId)));
            return false;
        }
    }
    /**
   * Save content of bodiedSyncBlock nodes in local cache to backend
   *
   * @returns true if saving all nodes successfully, false if fail to save some/all nodes
   */ async flush() {
        try {
            var _this$saveExperience;
            if (this.viewMode === 'view') return true;
            // Wait (up to FLUSH_CREATION_AWAIT_TIMEOUT_MS) for any in-flight
            // block creations to complete before iterating the cache. Without
            // this, blocks created from existing content are skipped
            // (isPendingCreation check below) and if no further edits are made,
            // no subsequent flush is triggered — causing references to show an
            // "unpublished" error.
            // If the timeout expires, any block whose creation is still
            // in-flight is recorded in `creationsTimedOutDuringFlush` so that
            // `commitPendingCreation()` can trigger a follow-up flush once that
            // specific creation completes.
            // See EDITOR-7112.
            if (this.pendingCreationPromises.size > 0) {
                let timedOut = false;
                let timeoutId;
                const timeout = new Promise((resolve)=>{
                    timeoutId = setTimeout(()=>{
                        timedOut = true;
                        resolve();
                    }, $8765f30adf7f98b9$var$FLUSH_CREATION_AWAIT_TIMEOUT_MS);
                });
                await Promise.race([
                    Promise.all(this.pendingCreationPromises.values()),
                    timeout
                ]);
                if (timeoutId !== undefined) clearTimeout(timeoutId);
                if (timedOut) // Record every still-in-flight creation so each late
                // completion is tracked independently.
                for (const resourceId of this.pendingCreationPromises.keys())this.creationsTimedOutDuringFlush.add(resourceId);
            }
            const bodiedSyncBlockNodes = [];
            const bodiedSyncBlockData = [];
            Array.from(this.syncBlockCache.values()).forEach((syncBlockData)=>{
                // Don't flush nodes that
                // - are waiting to be deleted to avoid nodes being re-created
                // - haven't been updated since we last flushed
                // - are still pending BE creation
                if (!syncBlockData.pendingDeletion && syncBlockData.isDirty && !this.isPendingCreation(syncBlockData.resourceId)) {
                    bodiedSyncBlockNodes.push({
                        type: 'bodiedSyncBlock',
                        attrs: {
                            localId: syncBlockData.blockInstanceId,
                            resourceId: syncBlockData.resourceId
                        }
                    });
                    // reset isDirty early to prevent race condition
                    // There is a race condition where if a user makes changes to a source sync block
                    // on a live page and the source sync block is being saved while the user
                    // is still making changes, the new changes might not be saved if they all happen
                    // exactly at a time when the writeNodesData is being executed asynchronously.
                    syncBlockData.isDirty = false;
                    // When flushing, set status to 'active' so the block is published
                    const dataToFlush = {
                        ...syncBlockData,
                        status: 'active'
                    };
                    bodiedSyncBlockData.push(dataToFlush);
                }
            });
            if (bodiedSyncBlockNodes.length === 0) return Promise.resolve(true);
            if (!this.dataProvider) throw new Error('Data provider not set');
            (_this$saveExperience = this.saveExperience) === null || _this$saveExperience === void 0 || _this$saveExperience.start({});
            const writeResults = await this.dataProvider.writeNodesData(bodiedSyncBlockNodes, bodiedSyncBlockData);
            writeResults.forEach((result)=>{
                // set isDirty to true for cases where it failed to save the sync block to the BE
                if (result.resourceId && result.error && result.error !== (0, $cSue1.SyncBlockError).NotFound) {
                    const cachedData = this.syncBlockCache.get(result.resourceId);
                    if (cachedData) {
                        cachedData.isDirty = true;
                        this.notifyLocalSource(result.resourceId);
                    }
                }
            });
            if (writeResults.every((result)=>result.resourceId && !result.error)) {
                var _this$saveExperience2;
                (_this$saveExperience2 = this.saveExperience) === null || _this$saveExperience2 === void 0 || _this$saveExperience2.success();
                writeResults.forEach((result)=>{
                    if (result.resourceId && !result.error) {
                        var _this$fireAnalyticsEv2;
                        // Update cache with the status returned from the backend
                        const cachedData = this.syncBlockCache.get(result.resourceId);
                        if (cachedData && result.status) {
                            cachedData.status = result.status;
                            this.notifyLocalSource(result.resourceId);
                        }
                        (_this$fireAnalyticsEv2 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv2 === void 0 || _this$fireAnalyticsEv2.call(this, (0, $hYuzB.updateSuccessPayload)(result.resourceId, false, (0, $iYvEr.getSourceProductFromResourceIdSafe)(result.resourceId)));
                    }
                });
                return true;
            } else {
                var _this$saveExperience3;
                (_this$saveExperience3 = this.saveExperience) === null || _this$saveExperience3 === void 0 || _this$saveExperience3.failure();
                writeResults.filter((result)=>!result.resourceId || result.error).forEach((result)=>{
                    var _this$fireAnalyticsEv3;
                    (_this$fireAnalyticsEv3 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv3 === void 0 || _this$fireAnalyticsEv3.call(this, (0, $hYuzB.updateErrorPayload)(result.error || 'Failed to write data', result.resourceId, (0, $iYvEr.getSourceProductFromResourceIdSafe)(result.resourceId), (0, $hYuzB.buildErrorAttribution)(result.error, result.statusCode)));
                });
                return false;
            }
        } catch (error) {
            var _this$fireAnalyticsEv4;
            (0, $j2Y9J.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            // Top-level flush failure is not tied to a single resourceId. There is no structured
            // SyncBlockError/status here, so the attribution `reason` falls back to `unknown`.
            (_this$fireAnalyticsEv4 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv4 === void 0 || _this$fireAnalyticsEv4.call(this, (0, $hYuzB.updateErrorPayload)(error.message, undefined, undefined, (0, $hYuzB.buildErrorAttribution)()));
            return false;
        } finally{
            var _this$flushCompletion;
            (_this$flushCompletion = this.flushCompletionCallback) === null || _this$flushCompletion === void 0 || _this$flushCompletion.call(this);
        }
    }
    hasUnsavedChanges() {
        if (this.viewMode === 'view') return false;
        // Only track unsaved changes in source synced block for live pages
        // classic pages's draft don't publish synced block content to block service and the content itself is saved as part of the draft
        // classic page's publish flow will trigger a flush which only uses the isDirty flag to determine if there are unsaved changes
        if (!this.isLivePage) return false;
        return this.hasReceivedContentChange && Array.from(this.syncBlockCache.values()).some((syncBlockData)=>syncBlockData.isDirty);
    }
    isPendingCreation(resourceId) {
        return this.creationCompletionCallbacks.has(resourceId);
    }
    /**
   * Returns `true` when at least one sync block is waiting for its backend
   * creation call to complete. Used as a cheap pre-check in the decoration
   * rebuild path to avoid a full `doc.descendants()` walk when no creations
   * are in flight (see EDITOR-6930).
   */ hasPendingCreations() {
        return this.creationCompletionCallbacks.size > 0;
    }
    /** Returns the source block's last known backend publication status. */ getStatus(resourceId) {
        var _this$syncBlockCache$;
        return (_this$syncBlockCache$ = this.syncBlockCache.get(resourceId)) === null || _this$syncBlockCache$ === void 0 ? void 0 : _this$syncBlockCache$.status;
    }
    getLocalSourceSnapshot(resourceId) {
        if (!(0, $3y2s4.isExperimentEnabled)('editor-synced-block-same-page-sync')) return undefined;
        const cached = this.syncBlockCache.get(resourceId);
        if (!cached || cached.status === 'deleted') return undefined;
        const { contentFragment: _contentFragment, isDirty: _isDirty, ...data } = cached;
        return {
            ...data,
            content: [
                ...data.content
            ]
        };
    }
    subscribeToLocalSource(resourceId, callback) {
        if (!(0, $3y2s4.isExperimentEnabled)('editor-synced-block-same-page-sync')) return ()=>{};
        let subscribers = this.localSourceSubscribers.get(resourceId);
        if (!subscribers) {
            subscribers = new Set();
            this.localSourceSubscribers.set(resourceId, subscribers);
        }
        subscribers.add(callback);
        callback(this.getLocalSourceSnapshot(resourceId));
        return ()=>{
            const currentSubscribers = this.localSourceSubscribers.get(resourceId);
            currentSubscribers === null || currentSubscribers === void 0 || currentSubscribers.delete(callback);
            if ((currentSubscribers === null || currentSubscribers === void 0 ? void 0 : currentSubscribers.size) === 0) this.localSourceSubscribers.delete(resourceId);
        };
    }
    notifyLocalSource(resourceId) {
        var _this$localSourceSubs;
        const snapshot = this.getLocalSourceSnapshot(resourceId);
        (_this$localSourceSubs = this.localSourceSubscribers.get(resourceId)) === null || _this$localSourceSubs === void 0 || _this$localSourceSubs.forEach((callback)=>callback(snapshot));
    }
    /**
   *  Fires callback to insert node (if creation is successful) and clears pending creation data
   * @param success
   */ commitPendingCreation(success, resourceId) {
        if (this.viewMode === 'view') return;
        const onCompletion = this.creationCompletionCallbacks.get(resourceId);
        if (onCompletion) {
            this.creationCompletionCallbacks.delete(resourceId);
            onCompletion(success);
            // If a previous flush() timed out waiting for this specific
            // creation, drop it from the tracking set regardless of outcome so
            // it does not leak. See EDITOR-7112.
            const wasTimedOut = this.creationsTimedOutDuringFlush.delete(resourceId);
            if (success) {
                // If creation is successful, set hasReceivedContentChange to true
                // to indicate that there are unsaved changes in the cache
                this.hasReceivedContentChange = true;
                // If flush() timed out waiting for this creation, notify the
                // plugin so it can trigger a deferred flush. See EDITOR-7112.
                if (wasTimedOut) {
                    var _this$postCreationFlu;
                    (_this$postCreationFlu = this.postCreationFlushCallback) === null || _this$postCreationFlu === void 0 || _this$postCreationFlu.call(this);
                }
            }
        } else {
            var _this$fireAnalyticsEv5;
            (_this$fireAnalyticsEv5 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv5 === void 0 || _this$fireAnalyticsEv5.call(this, (0, $hYuzB.createErrorPayload)('creation complete callback missing', resourceId, (0, $iYvEr.getSourceProductFromResourceIdSafe)(resourceId), undefined, this.getSourceLocation()));
        }
        if (success) {
            var _this$dataProvider, _this$fireAnalyticsEv6, _this$fireAnalyticsEv7, _this$syncBlockCache$2;
            const sourceProduct = (0, $iYvEr.getSourceProductFromResourceIdSafe)(resourceId);
            const sourceLocation = this.getSourceLocation();
            const documentInsertedResourceId = ((_this$dataProvider = this.dataProvider) === null || _this$dataProvider === void 0 ? void 0 : _this$dataProvider.generateResourceIdForReference(resourceId)) ?? resourceId;
            (_this$fireAnalyticsEv6 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv6 === void 0 || _this$fireAnalyticsEv6.call(this, (0, $hYuzB.createSuccessPayload)(documentInsertedResourceId || '', sourceProduct, sourceLocation));
            // Operational create-success event with the join key + creation-type
            // signals (inputMethod / createdEmpty / nodeTypes) captured at the command layer.
            (_this$fireAnalyticsEv7 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv7 === void 0 || _this$fireAnalyticsEv7.call(this, (0, $hYuzB.createSuccessOperationalPayload)(resourceId || '', (_this$syncBlockCache$2 = this.syncBlockCache.get(resourceId)) === null || _this$syncBlockCache$2 === void 0 ? void 0 : _this$syncBlockCache$2.blockInstanceId, sourceProduct, this.creationEnrichment.get(resourceId), sourceLocation));
        } else {
            var _this$fireAnalyticsEv8;
            // Delete the node from cache if fail to create so it's not flushed to BE
            this.syncBlockCache.delete(resourceId || '');
            this.notifyLocalSource(resourceId);
            this.newSourceBlockResourceIds.delete(resourceId || '');
            // Creation failed, so there is no block to add content to — drop the
            // first-content tracking entry so a later unrelated edit cannot fire it.
            this.awaitingFirstContent.delete(resourceId || '');
            (_this$fireAnalyticsEv8 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv8 === void 0 || _this$fireAnalyticsEv8.call(this, (0, $hYuzB.createErrorPayload)('Fail to create bodied sync block', resourceId, (0, $iYvEr.getSourceProductFromResourceIdSafe)(resourceId), undefined, this.getSourceLocation()));
        }
        // Enrichment is single-use — drop it once the create has resolved either way.
        this.creationEnrichment.delete(resourceId || '');
    }
    /**
   * Fire the first-content-added event once when a block created empty this
   * session first gains content. The caller detects the in-block edit; this owns
   * dedupe + emission (fires at most once per block, only for empty→content).
   */ maybeEmitFirstContentAdded(resourceId, blockInstanceId) {
        var _this$fireAnalyticsEv9;
        if (this.viewMode === 'view') return;
        // `delete` returns false when the id was not tracked (already emitted, or
        // the block was not created empty this session), so this both dedupes and
        // scopes emission to genuine first-content transitions in one check.
        if (!this.awaitingFirstContent.delete(resourceId)) return;
        (_this$fireAnalyticsEv9 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv9 === void 0 || _this$fireAnalyticsEv9.call(this, (0, $hYuzB.addContentSuccessPayload)(resourceId, blockInstanceId, (0, $iYvEr.getSourceProductFromResourceIdSafe)(resourceId)));
    }
    registerConfirmationCallback(callback) {
        this.confirmationCallback = callback;
        return ()=>{
            this.confirmationCallback = undefined;
        };
    }
    requireConfirmationBeforeDelete() {
        return !!this.confirmationCallback;
    }
    /**
   * @returns attributes for a new bodiedSyncBlock node
   */ generateBodiedSyncBlockAttrs() {
        if (!this.dataProvider) throw new Error('Data provider not set or source id not set');
        const { resourceId: resourceId, localId: localId } = this.dataProvider.generateResourceId();
        return {
            resourceId: resourceId,
            localId: localId
        };
    }
    /**
   * Create a bodiedSyncBlock node with empty content to backend
   * @param attrs attributes Ids of the node
   * @param node the ProseMirror node to cache
   * @param onCompletion callback invoked when creation completes
   * @param enrichment optional creation analytics signals stashed and attached to the
   *   `syncedBlockCreate` event when the async create resolves. When
   *   `createdEmpty` is true the block is also registered for the
   *   first-content-added event.
   */ createBodiedSyncBlockNode(attrs, node, onCompletion, enrichment) {
        if (this.viewMode === 'view') return;
        const { resourceId: resourceId, localId: blockInstanceId } = attrs;
        // Stash creation analytics signals for commitPendingCreation to read.
        if (enrichment) {
            this.creationEnrichment.set(resourceId, enrichment);
            // Only empty-created blocks can produce an empty→content transition.
            if (enrichment.createdEmpty) this.awaitingFirstContent.add(resourceId);
        }
        try {
            var _this$createExperienc;
            if (!this.dataProvider) throw new Error('Data provider not set');
            if (enrichment) this.newSourceBlockResourceIds.add(resourceId);
            // add the node to the cache
            this.updateSyncBlockData(node, false);
            // Mark the block as unpublished in the cache so it can be cleaned up on cancel
            const cached = this.syncBlockCache.get(resourceId);
            if (cached) {
                cached.status = 'unpublished';
                this.notifyLocalSource(resourceId);
            }
            this.creationCompletionCallbacks.set(resourceId, onCompletion);
            (_this$createExperienc = this.createExperience) === null || _this$createExperienc === void 0 || _this$createExperienc.start({});
            const creationPromise = this.dataProvider.createNodeData({
                content: [],
                blockInstanceId: blockInstanceId,
                resourceId: resourceId
            }).then((result)=>{
                const resourceId = result.resourceId || '';
                if (resourceId && !result.error) {
                    var _this$createExperienc2;
                    this.commitPendingCreation(true, resourceId);
                    (_this$createExperienc2 = this.createExperience) === null || _this$createExperienc2 === void 0 || _this$createExperienc2.success();
                } else {
                    var _this$createExperienc3, _this$fireAnalyticsEv0;
                    this.commitPendingCreation(false, resourceId);
                    (_this$createExperienc3 = this.createExperience) === null || _this$createExperienc3 === void 0 || _this$createExperienc3.failure({
                        reason: result.error || 'Failed to create bodied sync block'
                    });
                    (_this$fireAnalyticsEv0 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv0 === void 0 || _this$fireAnalyticsEv0.call(this, (0, $hYuzB.createErrorPayload)(result.error || 'Failed to create bodied sync block', resourceId, (0, $iYvEr.getSourceProductFromResourceIdSafe)(resourceId), (0, $hYuzB.buildErrorAttribution)(result.error, result.statusCode), this.getSourceLocation()));
                }
            }).catch((error)=>{
                var _this$createExperienc4, _this$fireAnalyticsEv1;
                this.commitPendingCreation(false, resourceId);
                (0, $j2Y9J.logException)(error, {
                    location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
                });
                (_this$createExperienc4 = this.createExperience) === null || _this$createExperienc4 === void 0 || _this$createExperienc4.failure({
                    reason: error.message
                });
                (_this$fireAnalyticsEv1 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv1 === void 0 || _this$fireAnalyticsEv1.call(this, (0, $hYuzB.createErrorPayload)(error.message, resourceId, (0, $iYvEr.getSourceProductFromResourceIdSafe)(resourceId), undefined, this.getSourceLocation()));
            }).finally(()=>{
                this.pendingCreationPromises.delete(resourceId);
            });
            this.pendingCreationPromises.set(resourceId, creationPromise);
        } catch (error) {
            var _this$fireAnalyticsEv10;
            this.newSourceBlockResourceIds.delete(resourceId);
            if (this.isPendingCreation(resourceId)) this.commitPendingCreation(false, resourceId);
            (0, $j2Y9J.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            (_this$fireAnalyticsEv10 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv10 === void 0 || _this$fireAnalyticsEv10.call(this, (0, $hYuzB.createErrorPayload)(error.message, resourceId, (0, $iYvEr.getSourceProductFromResourceIdSafe)(resourceId), undefined, this.getSourceLocation()));
        }
    }
    getSourceLocation() {
        var _this$dataProvider2, _this$dataProvider2$g;
        return (0, $idDos.getSourceLocation)((_this$dataProvider2 = this.dataProvider) === null || _this$dataProvider2 === void 0 || (_this$dataProvider2$g = _this$dataProvider2.getParentAri) === null || _this$dataProvider2$g === void 0 ? void 0 : _this$dataProvider2$g.call(_this$dataProvider2));
    }
    /**
   * Drop dedupe entries older than {@link DELETE_DEDUPE_WINDOW_MS} so
   * `recentDeleteEmissions` stays bounded by the number of recent deletes.
   */ pruneRecentDeleteEmissions(now) {
        for (const [resourceId, emittedAt] of this.recentDeleteEmissions)if (now - emittedAt >= $8765f30adf7f98b9$var$DELETE_DEDUPE_WINDOW_MS) this.recentDeleteEmissions.delete(resourceId);
    }
    /**
   * Emit the `syncedBlockDelete` success event. Attaches `deletionReason`,
   * `mechanism` and `blockInstanceId`, and suppresses repeat emissions within
   * {@link DELETE_DEDUPE_WINDOW_MS}. Must run while the cache entry still exists
   * so `blockInstanceId` is available.
   */ emitDeleteSuccess(resourceId, reason, mechanism) {
        var _this$syncBlockCache$3, _this$fireAnalyticsEv11;
        const sourceProduct = (0, $iYvEr.getSourceProductFromResourceIdSafe)(resourceId);
        const now = Date.now();
        const lastEmittedAt = this.recentDeleteEmissions.get(resourceId);
        if (lastEmittedAt !== undefined && now - lastEmittedAt < $8765f30adf7f98b9$var$DELETE_DEDUPE_WINDOW_MS) return; // duplicate emission for the same logical removal
        this.pruneRecentDeleteEmissions(now);
        this.recentDeleteEmissions.set(resourceId, now);
        const enrichment = {
            blockInstanceId: (_this$syncBlockCache$3 = this.syncBlockCache.get(resourceId)) === null || _this$syncBlockCache$3 === void 0 ? void 0 : _this$syncBlockCache$3.blockInstanceId,
            deletionReason: reason,
            mechanism: mechanism
        };
        (_this$fireAnalyticsEv11 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv11 === void 0 || _this$fireAnalyticsEv11.call(this, (0, $hYuzB.deleteSuccessPayload)(resourceId, sourceProduct, enrichment));
    }
    async delete(syncBlockIds, onDelete, onDeleteCompleted, reason, mechanism) {
        try {
            var _this$deleteExperienc;
            if (this.viewMode === 'view') return false;
            if (!this.dataProvider) throw new Error('Data provider not set');
            syncBlockIds.forEach((Ids)=>{
                this.setPendingDeletion(Ids, true);
            });
            (_this$deleteExperienc = this.deleteExperience) === null || _this$deleteExperienc === void 0 || _this$deleteExperienc.start({});
            const results = await this.dataProvider.deleteNodesData(syncBlockIds.map((attrs)=>attrs.resourceId), reason);
            let callback;
            const isDeleteSuccessful = results.every((result)=>result.success);
            onDeleteCompleted(isDeleteSuccessful);
            if (isDeleteSuccessful) {
                var _this$deleteExperienc2;
                onDelete();
                // Emit before the cache entry is deleted below, so blockInstanceId
                // is still available to emitDeleteSuccess.
                results.forEach((result)=>{
                    this.emitDeleteSuccess(result.resourceId, reason, mechanism);
                });
                callback = (Ids)=>{
                    this.syncBlockCache.delete(Ids.resourceId);
                    this.notifyLocalSource(Ids.resourceId);
                };
                this.clearPendingDeletion();
                (_this$deleteExperienc2 = this.deleteExperience) === null || _this$deleteExperienc2 === void 0 || _this$deleteExperienc2.success();
            } else {
                var _this$deleteExperienc3;
                callback = (Ids)=>{
                    this.setPendingDeletion(Ids, false);
                };
                (_this$deleteExperienc3 = this.deleteExperience) === null || _this$deleteExperienc3 === void 0 || _this$deleteExperienc3.failure();
                results.forEach((result)=>{
                    if (result.success) this.emitDeleteSuccess(result.resourceId, reason, mechanism);
                    else {
                        var _this$fireAnalyticsEv12;
                        (_this$fireAnalyticsEv12 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv12 === void 0 || _this$fireAnalyticsEv12.call(this, (0, $hYuzB.deleteErrorPayload)(result.error || 'Failed to delete synced block', result.resourceId, (0, $iYvEr.getSourceProductFromResourceIdSafe)(result.resourceId), (0, $hYuzB.buildErrorAttribution)(result.error, result.statusCode)));
                    }
                });
            }
            syncBlockIds.forEach(callback);
            return isDeleteSuccessful;
        } catch (error) {
            // Thrown (non-result) failure — no structured SyncBlockError/status is available,
            // so the attribution `reason` falls back to `unknown`.
            const attribution = (0, $hYuzB.buildErrorAttribution)();
            syncBlockIds.forEach((Ids)=>{
                var _this$fireAnalyticsEv13;
                this.setPendingDeletion(Ids, false);
                (_this$fireAnalyticsEv13 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv13 === void 0 || _this$fireAnalyticsEv13.call(this, (0, $hYuzB.deleteErrorPayload)(error.message, Ids.resourceId, (0, $iYvEr.getSourceProductFromResourceIdSafe)(Ids.resourceId), attribution));
            });
            (0, $j2Y9J.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            onDeleteCompleted(false);
            return false;
        }
    }
    isRetryingDeletion() {
        return !!this.deletionRetryInfo;
    }
    async retryDeletion() {
        if (this.viewMode === 'view') return Promise.resolve();
        if (!this.deletionRetryInfo) return Promise.resolve();
        const { syncBlockIds: syncBlockIds, onDelete: onDelete, onDeleteCompleted: onDeleteCompleted, deletionReason: deletionReason, mechanism: mechanism } = this.deletionRetryInfo;
        if (this.confirmationCallback) await this.delete(syncBlockIds, onDelete, onDeleteCompleted, deletionReason, mechanism);
    }
    clearPendingDeletion() {
        var _this$deletionRetryIn;
        (_this$deletionRetryIn = this.deletionRetryInfo) === null || _this$deletionRetryIn === void 0 || _this$deletionRetryIn.destroyCallback();
        this.deletionRetryInfo = undefined;
    }
    /**
   * Fetches the current status of all source sync blocks in the cache from the backend
   * and updates the cache entries with the fetched status.
   * This is called on editor init so we know which blocks are 'unpublished' vs 'active'.
   */ async fetchAndCacheStatuses() {
        if (!this.dataProvider || this.syncBlockCache.size === 0) return;
        // Source blocks have plain UUID resourceIds, but fetchNodesData internally uses
        // generateBlockAriFromReference which expects reference-format resourceIds
        // (e.g. "confluence-page/pageId/uuid"). We convert source resourceIds to reference
        // format before fetching, and maintain a mapping back to original resourceIds
        // so we can update the correct cache entries.
        const sourceToReferenceMap = new Map();
        const syncBlockNodes = Array.from(this.syncBlockCache.entries()).map(([resourceId, data])=>{
            var _this$dataProvider3;
            const referenceResourceId = ((_this$dataProvider3 = this.dataProvider) === null || _this$dataProvider3 === void 0 ? void 0 : _this$dataProvider3.generateResourceIdForReference(resourceId)) ?? resourceId;
            sourceToReferenceMap.set(referenceResourceId, resourceId);
            return {
                type: 'bodiedSyncBlock',
                attrs: {
                    localId: data.blockInstanceId,
                    resourceId: referenceResourceId
                }
            };
        });
        try {
            const results = await this.dataProvider.fetchNodesData(syncBlockNodes);
            for (const result of results){
                var _result$data;
                // Map the reference resourceId back to the source resourceId
                const sourceResourceId = sourceToReferenceMap.get(result.resourceId) ?? result.resourceId;
                const cached = this.syncBlockCache.get(sourceResourceId);
                if (cached && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.status) {
                    cached.status = result.data.status;
                    this.notifyLocalSource(sourceResourceId);
                }
            }
        } catch  {
        // If the fetch fails, statuses remain undefined.
        // This is acceptable — on cancel, blocks without a known status
        // will not be deleted (safe default).
        }
    }
    /**
   * Deletes all source sync blocks that have 'unpublished' status.
   * Used to clean up orphaned blocks when a user cancels editing without saving.
   * Blocks that were already saved (status 'active') are not affected.
   *
   * @returns true if all deletions succeeded, false otherwise
   */ discardUnpublishedBlocks() {
        const unpublishedBlockIds = Array.from(this.syncBlockCache.entries()).filter(([_, data])=>data.status === 'unpublished' && !data.pendingDeletion).map(([resourceId, data])=>({
                resourceId: resourceId,
                localId: data.blockInstanceId
            }));
        if (unpublishedBlockIds.length === 0) return Promise.resolve(true);
        return this.delete(unpublishedBlockIds, ()=>{}, // onDelete: no-op, document is being discarded
        ()=>{}, // onDeleteCompleted: no-op
        'source-block-unpublished', // Cancel/discard cleanup is code-initiated, not a direct user edit.
        'other');
    }
    /**
   * Deletes sync blocks with confirmation from the backend
   *
   * @param syncBlockIds - The sync block ids to delete
   * @param onDelete - The callback to delete sync block node from document
   * @param onDeleteCompleted - The callback for after the deletion is saved to BE (whether successful or not)
   * @param destroyCallback - The callback to clear any reference stored for deletion (regardless if deletion is completed or abort)
   */ async deleteSyncBlocksWithConfirmation(syncBlockIds, deletionReason, onDelete, onDeleteCompleted, destroyCallback, mechanism) {
        if (this.viewMode === 'view') return Promise.resolve();
        if (this.confirmationCallback) {
            const confirmed = await this.confirmationCallback(syncBlockIds, deletionReason);
            if (confirmed) {
                const isDeleteSuccessful = await this.delete(syncBlockIds, onDelete, onDeleteCompleted, deletionReason, mechanism);
                if (!isDeleteSuccessful) // If deletion failed, save deletion info for potential retry
                this.deletionRetryInfo = {
                    syncBlockIds: syncBlockIds,
                    onDelete: onDelete,
                    onDeleteCompleted: onDeleteCompleted,
                    destroyCallback: destroyCallback,
                    deletionReason: deletionReason,
                    mechanism: mechanism
                };
                else destroyCallback();
            } else destroyCallback();
        }
    }
    getSyncBlockSourceInfo(localId) {
        try {
            var _this$fetchSourceInfo;
            if (!this.dataProvider) throw new Error('Data provider not set');
            (_this$fetchSourceInfo = this.fetchSourceInfoExperience) === null || _this$fetchSourceInfo === void 0 || _this$fetchSourceInfo.start();
            return this.dataProvider.fetchSyncBlockSourceInfo(localId, undefined, undefined).then((sourceInfo)=>{
                if (!sourceInfo) {
                    var _this$fetchSourceInfo2;
                    (_this$fetchSourceInfo2 = this.fetchSourceInfoExperience) === null || _this$fetchSourceInfo2 === void 0 || _this$fetchSourceInfo2.failure({
                        reason: 'No source info returned'
                    });
                } else {
                    var _this$fetchSourceInfo3;
                    (_this$fetchSourceInfo3 = this.fetchSourceInfoExperience) === null || _this$fetchSourceInfo3 === void 0 || _this$fetchSourceInfo3.success();
                }
                return sourceInfo;
            });
        } catch (error) {
            var _this$fireAnalyticsEv14;
            (0, $j2Y9J.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            (_this$fireAnalyticsEv14 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv14 === void 0 || _this$fireAnalyticsEv14.call(this, (0, $hYuzB.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchReferences(resourceId) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            return this.dataProvider.fetchReferences(resourceId, true);
        } catch (error) {
            var _this$fireAnalyticsEv15;
            (0, $j2Y9J.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            (_this$fireAnalyticsEv15 = this.fireAnalyticsEvent) === null || _this$fireAnalyticsEv15 === void 0 || _this$fireAnalyticsEv15.call(this, (0, $hYuzB.fetchReferencesErrorPayload)(error.message, resourceId, (0, $iYvEr.getSourceProductFromResourceIdSafe)(resourceId)));
            return Promise.resolve({
                error: (0, $cSue1.SyncBlockError).Errored
            });
        }
    }
    destroy() {
        var _this$saveExperience4, _this$createExperienc5, _this$deleteExperienc4, _this$fetchSourceInfo4;
        const subscribedResourceIds = [
            ...this.localSourceSubscribers.keys()
        ];
        this.syncBlockCache.clear();
        subscribedResourceIds.forEach((resourceId)=>this.notifyLocalSource(resourceId));
        this.localSourceSubscribers.clear();
        this.confirmationCallback = undefined;
        this.creationCompletionCallbacks.clear();
        this.flushCompletionCallback = undefined;
        this.postCreationFlushCallback = undefined;
        this.pendingCreationPromises.clear();
        this.creationsTimedOutDuringFlush.clear();
        this.creationEnrichment.clear();
        this.newSourceBlockResourceIds.clear();
        this.awaitingFirstContent.clear();
        this.recentDeleteEmissions.clear();
        this.dataProvider = undefined;
        (_this$saveExperience4 = this.saveExperience) === null || _this$saveExperience4 === void 0 || _this$saveExperience4.abort({
            reason: 'editorDestroyed'
        });
        (_this$createExperienc5 = this.createExperience) === null || _this$createExperienc5 === void 0 || _this$createExperienc5.abort({
            reason: 'editorDestroyed'
        });
        (_this$deleteExperienc4 = this.deleteExperience) === null || _this$deleteExperienc4 === void 0 || _this$deleteExperienc4.abort({
            reason: 'editorDestroyed'
        });
        (_this$fetchSourceInfo4 = this.fetchSourceInfoExperience) === null || _this$fetchSourceInfo4 === void 0 || _this$fetchSourceInfo4.abort({
            reason: 'editorDestroyed'
        });
        this.clearPendingDeletion();
    }
}

});


parcelRegister("9sTsq", function(module, exports) {
$parcel$export(module.exports, "flushBodiedSyncBlocks", () => $b77acd22029730c2$export$809659ed37baae65);
$parcel$export(module.exports, "flushSyncBlocks", () => $b77acd22029730c2$export$42389f194734952a);
$parcel$export(module.exports, "discardUnpublishedSyncBlocks", () => $b77acd22029730c2$export$e79742b5511b2d66);
const $b77acd22029730c2$export$809659ed37baae65 = (syncBlockStore)=>{
    return syncBlockStore.sourceManager.flush();
};
const $b77acd22029730c2$export$42389f194734952a = (syncBlockStore)=>{
    return syncBlockStore.referenceManager.flush();
};
const $b77acd22029730c2$export$e79742b5511b2d66 = (syncBlockStore)=>{
    return syncBlockStore.sourceManager.discardUnpublishedBlocks();
};

});

parcelRegister("8hQqt", function(module, exports) {
$parcel$export(module.exports, "createSyncedBlock", () => $61dd52bac387d858$export$fbc30658d812c800);
$parcel$export(module.exports, "copySyncedBlockReferenceToClipboardEditorCommand", () => $61dd52bac387d858$export$c461f640005976aa);
$parcel$export(module.exports, "copySyncedBlockReferenceToClipboard", () => $61dd52bac387d858$export$cdf949b884fe546d);
$parcel$export(module.exports, "editSyncedBlockSource", () => $61dd52bac387d858$export$3a389eb361f43fd);
$parcel$export(module.exports, "removeSyncedBlock", () => $61dd52bac387d858$export$1c38da93cd68ba6d);
$parcel$export(module.exports, "removeSyncedBlockAtPos", () => $61dd52bac387d858$export$8d571a58cfd57507);
$parcel$export(module.exports, "unsync", () => $61dd52bac387d858$export$e44cd24c4e3ac750);

var $auxFA = parcelRequire("auxFA");

var $g6Qq4 = parcelRequire("g6Qq4");

var $j0iaN = parcelRequire("j0iaN");

var $6Cbfp = parcelRequire("6Cbfp");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $iYvEr = parcelRequire("iYvEr");

var $3y2s4 = parcelRequire("3y2s4");

var $cG0Fu = parcelRequire("cG0Fu");

var $QIBX2 = parcelRequire("QIBX2");

var $7II9i = parcelRequire("7II9i");

var $9218x = parcelRequire("9218x");
/**
 * Place the caret on the first editable position inside the newly created bodied
 * sync block, identified by its unique localId.
 *
 * - Empty selection: lands inside the block's empty paragraph.
 * - Converted content: lands at the start of the first editable child.
 *
 * `createSyncedBlock` builds the node but neither `safeInsert` (empty case) nor
 * `replaceWith` (convert case) leaves the selection inside the new block, so
 * without this the caret ends up outside/adjacent to the block after creation
 * from the block menu or toolbar (EDITOR-7949). The typeahead path avoids this
 * because `typeAheadInsert` positions the caret for us.
 *
 * Note: when created from the block menu, block-controls' selection preservation
 * is active and will restore a whole-node NodeSelection over this caret. The
 * caller (block-menu item) is responsible for calling `stopPreservingSelection`
 * in the same flow so the caret survives — mirroring the block-menu delete item.
 */ const $61dd52bac387d858$var$placeCaretInsideBodiedSyncBlock = (tr, localId)=>{
    const bodiedSyncBlockType = tr.doc.type.schema.nodes.bodiedSyncBlock;
    let blockPos;
    tr.doc.descendants((node, pos)=>{
        if (blockPos !== undefined) return false;
        if (node.type === bodiedSyncBlockType && node.attrs.localId === localId) {
            blockPos = pos;
            return false;
        }
        return true;
    });
    if (blockPos === undefined) return tr;
    // Find the first valid text position at or after the block's start. `findFrom`
    // with textOnly=true descends into the first editable child (empty paragraph or
    // start of the converted content), which is exactly what we want for both cases.
    const selection = (0, $cw0wu.Selection).findFrom(tr.doc.resolve(blockPos), 1, true);
    if (selection) tr.setSelection(selection).scrollIntoView();
    else // Fallback: `bodiedSyncBlock` is always created with a paragraph as its first
    // child, so a text position should always be found above. This guards against
    // future schema changes where the first child isn't immediately text-editable
    // — place the caret just inside the block rather than leaving it outside.
    // `blockPos + 1` is the position immediately after the block's opening token,
    // which is a node boundary rather than a valid text position, so use
    // `TextSelection.near` to snap forward to the nearest selectable cursor. It
    // also clamps to the document bounds internally, so no explicit end-of-doc
    // check is required.
    tr.setSelection((0, $cw0wu.TextSelection).near(tr.doc.resolve(blockPos + 1), 1)).scrollIntoView();
    return tr;
};
const $61dd52bac387d858$export$fbc30658d812c800 = ({ tr: tr, syncBlockStore: syncBlockStore, typeAheadInsert: typeAheadInsert, fireAnalyticsEvent: fireAnalyticsEvent, inputMethod: inputMethod })=>{
    const { schema: { nodes: { bodiedSyncBlock: bodiedSyncBlock, paragraph: paragraph } } } = tr.doc.type;
    // Capture createdEmpty before any insertion mutates the selection. The meta is
    // set on the final transaction before returning (see below), since the
    // typeahead path may reassign `tr` and drop meta set here.
    const createdEmpty = tr.selection.empty;
    let nodeTypes;
    // If the selection is empty, we want to insert the sync block on a new line
    if (tr.selection.empty) {
        const attrs = syncBlockStore.sourceManager.generateBodiedSyncBlockAttrs();
        const paragraphNode = paragraph.createAndFill({});
        const newBodiedSyncBlockNode = bodiedSyncBlock.createAndFill(attrs, paragraphNode ? [
            paragraphNode
        ] : []);
        if (!newBodiedSyncBlockNode) {
            fireAnalyticsEvent === null || fireAnalyticsEvent === void 0 || fireAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).ERROR,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
                attributes: {
                    error: 'Create and fill for empty content failed'
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
            });
            return false;
        }
        if (typeAheadInsert) tr = typeAheadInsert(newBodiedSyncBlockNode);
        else {
            tr = (0, $gab48.safeInsert)(newBodiedSyncBlockNode)(tr).scrollIntoView();
            // safeInsert does not move the selection into the new block, so place the
            // caret inside the block's empty paragraph so typing continues inside the
            // synced block (EDITOR-7949).
            tr = $61dd52bac387d858$var$placeCaretInsideBodiedSyncBlock(tr, newBodiedSyncBlockNode.attrs.localId);
        }
    } else {
        const conversionInfo = (0, $QIBX2.canBeConvertedToSyncBlock)(tr.selection);
        if (!conversionInfo) {
            fireAnalyticsEvent === null || fireAnalyticsEvent === void 0 || fireAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).ERROR,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
                attributes: {
                    error: 'Content cannot be converted to sync block'
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
            });
            return false;
        }
        if ((0, $3y2s4.isExperimentEnabled)('platform_editor_sync_block_node_types')) nodeTypes = [
            ...new Set((0, $6Cbfp.getSourceNodesFromSelectionRange)(tr, tr.selection).map((node)=>node.type.name))
        ].sort();
        const attrs = syncBlockStore.sourceManager.generateBodiedSyncBlockAttrs();
        const newBodiedSyncBlockNode = bodiedSyncBlock.createAndFill(attrs, conversionInfo.contentToInclude, conversionInfo.breakoutMark ? [
            conversionInfo.breakoutMark
        ] : undefined);
        if (!newBodiedSyncBlockNode) {
            fireAnalyticsEvent === null || fireAnalyticsEvent === void 0 || fireAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).ERROR,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
                attributes: {
                    error: 'Create and fill for content failed'
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
            });
            return false;
        }
        tr.replaceWith(conversionInfo.from, conversionInfo.to, newBodiedSyncBlockNode).scrollIntoView();
        // Place the caret on the first editable position inside the converted
        // content so typing continues inside the synced block (EDITOR-7949).
        tr = $61dd52bac387d858$var$placeCaretInsideBodiedSyncBlock(tr, newBodiedSyncBlockNode.attrs.localId);
    }
    // Stash creation-type signals on the final transaction after any typeahead
    // reassignment. nodeTypes is populated only for gated non-empty conversions.
    tr.setMeta((0, $cG0Fu.creationMetaKey), {
        createdEmpty: createdEmpty,
        inputMethod: inputMethod,
        nodeTypes: nodeTypes
    });
    return tr;
};
const $61dd52bac387d858$export$c461f640005976aa = (syncBlockStore, inputMethod, api, isLivePage)=>({ tr: tr })=>{
        if ($61dd52bac387d858$var$copySyncedBlockReferenceToClipboardInternal(tr.doc.type.schema, tr.selection, syncBlockStore, inputMethod, api, isLivePage)) return tr;
        return null;
    };
const $61dd52bac387d858$export$cdf949b884fe546d = (syncBlockStore, inputMethod, api, isLivePage)=>(state, _dispatch, _view)=>$61dd52bac387d858$var$copySyncedBlockReferenceToClipboardInternal(state.tr.doc.type.schema, state.tr.selection, syncBlockStore, inputMethod, api, isLivePage);
const $61dd52bac387d858$var$copySyncedBlockReferenceToClipboardInternal = (schema, selection, syncBlockStore, inputMethod, api, isLivePage)=>{
    var _syncBlockStore$refer;
    const syncBlockFindResult = (0, $QIBX2.findSyncBlockOrBodiedSyncBlock)(schema, selection);
    if (!syncBlockFindResult) {
        var _api$analytics;
        api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.fireAnalyticsEvent({
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
            action: (0, $g6Qq4.ACTION).ERROR,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_COPY,
            attributes: {
                error: 'No sync block found in selection',
                inputMethod: inputMethod
            }
        });
        return false;
    }
    const isBodiedSyncBlock = (0, $QIBX2.isBodiedSyncBlockNode)(syncBlockFindResult.node, schema.nodes.bodiedSyncBlock);
    let referenceSyncBlockNode = null;
    if (isBodiedSyncBlock) {
        const { nodes: { syncBlock: syncBlock } } = schema;
        // create sync block reference node
        referenceSyncBlockNode = syncBlock.createAndFill({
            resourceId: syncBlockStore.referenceManager.generateResourceIdForReference(syncBlockFindResult.node.attrs.resourceId)
        });
        if (!referenceSyncBlockNode) {
            var _api$analytics2;
            api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 || (_api$analytics2 = _api$analytics2.actions) === null || _api$analytics2 === void 0 || _api$analytics2.fireAnalyticsEvent({
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
                action: (0, $g6Qq4.ACTION).ERROR,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_COPY,
                attributes: {
                    error: 'Failed to create reference sync block node',
                    resourceId: syncBlockFindResult.node.attrs.resourceId,
                    inputMethod: inputMethod
                }
            });
            return false;
        }
    } else referenceSyncBlockNode = syncBlockFindResult.node;
    if (!referenceSyncBlockNode) {
        var _api$analytics3;
        api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 || (_api$analytics3 = _api$analytics3.actions) === null || _api$analytics3 === void 0 || _api$analytics3.fireAnalyticsEvent({
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
            action: (0, $g6Qq4.ACTION).ERROR,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_COPY,
            attributes: {
                error: 'No reference sync block node available',
                inputMethod: inputMethod
            }
        });
        return false;
    }
    const domNode = (0, $j0iaN.toDOM)(referenceSyncBlockNode, schema);
    // Bare-uuid join key shared with the create/delete events: for a source
    // bodiedSyncBlock its `localId` is the source uuid (copy was page-form only).
    const sourceJoinKey = isBodiedSyncBlock ? syncBlockFindResult.node.attrs.localId : undefined;
    const isSourceContentUnpublished = isBodiedSyncBlock ? syncBlockStore.sourceManager.getStatus(syncBlockFindResult.node.attrs.resourceId) !== 'active' : ((_syncBlockStore$refer = syncBlockStore.referenceManager.getFromCache(referenceSyncBlockNode.attrs.resourceId)) === null || _syncBlockStore$refer === void 0 || (_syncBlockStore$refer = _syncBlockStore$refer.data) === null || _syncBlockStore$refer === void 0 ? void 0 : _syncBlockStore$refer.status) === 'unpublished';
    const sourceProduct = (0, $iYvEr.getSourceProductFromResourceIdSafe)(referenceSyncBlockNode.attrs.resourceId);
    const copyResult = (0, $j0iaN.copyDomNodeWithResult)(domNode, referenceSyncBlockNode.type, selection);
    if (copyResult === false) {
        var _api$analytics4;
        api === null || api === void 0 || (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 || (_api$analytics4 = _api$analytics4.actions) === null || _api$analytics4 === void 0 || _api$analytics4.fireAnalyticsEvent({
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
            action: (0, $g6Qq4.ACTION).ERROR,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_COPY,
            attributes: {
                error: 'Failed to copy synced block to clipboard',
                resourceId: referenceSyncBlockNode.attrs.resourceId,
                inputMethod: inputMethod
            }
        });
        return false;
    }
    (0, $QIBX2.deferDispatch)(()=>{
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$analytics5;
            api === null || api === void 0 || (_api$analytics5 = api.analytics) === null || _api$analytics5 === void 0 || (_api$analytics5 = _api$analytics5.actions) === null || _api$analytics5 === void 0 || _api$analytics5.fireAnalyticsEvent({
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
                action: (0, $g6Qq4.ACTION).COPIED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_COPY,
                attributes: {
                    resourceId: referenceSyncBlockNode.attrs.resourceId,
                    inputMethod: inputMethod,
                    ...sourceJoinKey && {
                        blockInstanceId: sourceJoinKey
                    }
                }
            });
            return tr.setMeta((0, $cG0Fu.syncedBlockPluginKey), {
                activeFlag: {
                    id: (0, $7II9i.FLAG_ID).SYNC_BLOCK_COPIED,
                    isLivePage: isLivePage,
                    isSourceContentUnpublished: isSourceContentUnpublished,
                    sourceProduct: sourceProduct
                }
            });
        });
    });
    return true;
};
const $61dd52bac387d858$export$3a389eb361f43fd = (syncBlockStore, api)=>(state, dispatch, _view)=>{
        var _syncBlock$node, _syncBlockStore$refer2;
        const syncBlock = (0, $QIBX2.findSyncBlock)(state.schema, state.selection);
        const resourceId = syncBlock === null || syncBlock === void 0 || (_syncBlock$node = syncBlock.node) === null || _syncBlock$node === void 0 || (_syncBlock$node = _syncBlock$node.attrs) === null || _syncBlock$node === void 0 ? void 0 : _syncBlock$node.resourceId;
        if (!resourceId) return false;
        const syncBlockURL = syncBlockStore.referenceManager.getSyncBlockURL(resourceId);
        const syncBlockData = (_syncBlockStore$refer2 = syncBlockStore.referenceManager.getFromCache(resourceId)) === null || _syncBlockStore$refer2 === void 0 ? void 0 : _syncBlockStore$refer2.data;
        const isOnSameDocument = (syncBlockData === null || syncBlockData === void 0 ? void 0 : syncBlockData.onSameDocument) === true;
        const sourceBlock = isOnSameDocument && syncBlockData ? (0, $9218x.findBodiedSyncBlockByLocalId)(state, syncBlockData.blockInstanceId) : undefined;
        if (syncBlockURL) {
            var _api$analytics6;
            api === null || api === void 0 || (_api$analytics6 = api.analytics) === null || _api$analytics6 === void 0 || _api$analytics6.actions.fireAnalyticsEvent({
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
                action: (0, $g6Qq4.ACTION).SYNCED_BLOCK_EDIT_SOURCE,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_SOURCE_URL,
                attributes: {
                    resourceId: resourceId,
                    sameDocument: isOnSameDocument
                }
            });
            if (sourceBlock) {
                const tr = state.tr.setSelection((0, $cw0wu.NodeSelection).create(state.doc, sourceBlock.pos)).scrollIntoView();
                dispatch === null || dispatch === void 0 || dispatch(tr);
                return true;
            }
            window.open(syncBlockURL, '_blank');
        } else {
            var _api$analytics7;
            const { tr: tr } = state;
            api === null || api === void 0 || (_api$analytics7 = api.analytics) === null || _api$analytics7 === void 0 || (_api$analytics7 = _api$analytics7.actions) === null || _api$analytics7 === void 0 || _api$analytics7.attachAnalyticsEvent({
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
                action: (0, $g6Qq4.ACTION).ERROR,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_SOURCE_URL,
                attributes: {
                    error: 'No URL resolved for synced block'
                }
            })(tr);
            dispatch === null || dispatch === void 0 || dispatch(tr);
        }
        return true;
    };
const $61dd52bac387d858$export$1c38da93cd68ba6d = (api)=>(state, dispatch, _view)=>{
        const { schema: { nodes: nodes }, tr: tr } = state;
        if (!dispatch) return false;
        let removeTr = tr;
        if ((0, $gab48.findSelectedNodeOfType)(nodes.syncBlock)(tr.selection) || (0, $gab48.findSelectedNodeOfType)(nodes.bodiedSyncBlock)(tr.selection)) removeTr = (0, $gab48.removeSelectedNode)(tr);
        else removeTr = (0, $gab48.removeParentNodeOfType)(nodes.bodiedSyncBlock)(tr);
        if (!removeTr) return false;
        // Tag the transaction so analytics can report this as `deleteButton` rather
        // than a keyboard delete (both produce a plain ReplaceStep).
        removeTr.setMeta((0, $cG0Fu.deleteMechanismMetaKey), 'deleteButton');
        dispatch(removeTr);
        api === null || api === void 0 || api.core.actions.focus();
        return true;
    };
const $61dd52bac387d858$export$8d571a58cfd57507 = (api, pos)=>{
    api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
        const node = tr.doc.nodeAt(pos);
        if ((node === null || node === void 0 ? void 0 : node.type.name) === 'syncBlock') {
            const removeTr = tr.replace(pos, pos + ((node === null || node === void 0 ? void 0 : node.nodeSize) ?? 0));
            removeTr.setMeta((0, $cG0Fu.deleteMechanismMetaKey), 'deleteButton');
            return removeTr;
        }
        return tr;
    });
};
const $61dd52bac387d858$export$e44cd24c4e3ac750 = (storeManager, isBodiedSyncBlock, view)=>{
    var _storeManager$referen;
    if (!view) return false;
    const { state: state } = view;
    const syncBlock = (0, $QIBX2.findSyncBlockOrBodiedSyncBlock)(state.schema, state.selection);
    if (!syncBlock) return false;
    if (isBodiedSyncBlock) {
        // Signal the unsync intent. This transaction is intercepted by the plugin's
        // filterTransaction, which shows the deletion-confirmation modal and, on confirm,
        // recomputes the actual document change from the live document keyed off the
        // `deletionReason: 'source-block-unsynced'` meta (see handleBodiedSyncBlockRemoval /
        // recomputeUnsyncTransaction). The real unwrap-vs-delete decision therefore lives in the
        // confirm path, not here (EDITOR-8230).
        const content = syncBlock === null || syncBlock === void 0 ? void 0 : syncBlock.node.content;
        const { tr: tr } = state;
        tr.replaceWith(syncBlock.pos, syncBlock.pos + syncBlock.node.nodeSize, content).setMeta('deletionReason', 'source-block-unsynced');
        view.dispatch(tr);
        return true;
    }
    // handle syncBlock unsync
    const syncBlockContent = (_storeManager$referen = storeManager.referenceManager.getFromCache(syncBlock.node.attrs.resourceId)) === null || _storeManager$referen === void 0 || (_storeManager$referen = _storeManager$referen.data) === null || _storeManager$referen === void 0 ? void 0 : _storeManager$referen.content;
    if (!syncBlockContent) return false;
    // use defaultSchema for serialization so we can serialize any type of nodes and marks despite current editor's schema might not allow it
    const contentFragment = (0, $kW8qW.Fragment).fromJSON((0, $auxFA.defaultSchema), syncBlockContent);
    const contentDOM = (0, $kW8qW.DOMSerializer).fromSchema((0, $auxFA.defaultSchema)).serializeFragment(contentFragment);
    return (0, $9218x.pasteSyncBlockHTMLContent)(contentDOM, view);
};

});
parcelRegister("cG0Fu", function(module, exports) {
$parcel$export(module.exports, "syncedBlockPluginKey", () => $4782e5e4da443e26$export$cb5a03b39dafc9cc);
$parcel$export(module.exports, "deleteMechanismMetaKey", () => $4782e5e4da443e26$export$84cb2650bbe09e82);
$parcel$export(module.exports, "creationMetaKey", () => $4782e5e4da443e26$export$cde24468c2642688);
$parcel$export(module.exports, "createPlugin", () => $4782e5e4da443e26$export$ae829ec7b2625219);

var $g6Qq4 = parcelRequire("g6Qq4");

var $gZj5p = parcelRequire("gZj5p");

var $hVGJk = parcelRequire("hVGJk");

var $f7Kk4 = parcelRequire("f7Kk4");

var $8KAjj = parcelRequire("8KAjj");

var $7VlAB = parcelRequire("7VlAB");

var $56AB9 = parcelRequire("56AB9");

var $4ClnP = parcelRequire("4ClnP");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $3DNV7 = parcelRequire("3DNV7");

var $a3b9P = parcelRequire("a3b9P");

var $iYvEr = parcelRequire("iYvEr");

var $3y2s4 = parcelRequire("3y2s4");

var $1Xcsv = parcelRequire("1Xcsv");

var $gmKcT = parcelRequire("gmKcT");

var $7II9i = parcelRequire("7II9i");

var $04BiH = parcelRequire("04BiH");

var $1wTON = parcelRequire("1wTON");

var $iQxc5 = parcelRequire("iQxc5");

var $kTCCL = parcelRequire("kTCCL");

var $dZUKh = parcelRequire("dZUKh");

var $cAJxL = parcelRequire("cAJxL");

var $bzsc2 = parcelRequire("bzsc2");

var $j5HQh = parcelRequire("j5HQh");

var $QIBX2 = parcelRequire("QIBX2");
const $4782e5e4da443e26$export$cb5a03b39dafc9cc = new (0, $cw0wu.PluginKey)('syncedBlockPlugin');
const $4782e5e4da443e26$export$84cb2650bbe09e82 = new (0, $cw0wu.PluginKey)('syncedBlockDeleteMechanism');
const $4782e5e4da443e26$var$syncedBlockPromptedFeedbackMetaKey = new (0, $cw0wu.PluginKey)('syncedBlockPromptedFeedback');
const $4782e5e4da443e26$export$cde24468c2642688 = new (0, $cw0wu.PluginKey)('syncedBlockCreationMeta');
const $4782e5e4da443e26$var$mapRetryCreationPosMap = (oldMap, newRetryCreationPos, mapPos)=>{
    const resourceId = newRetryCreationPos === null || newRetryCreationPos === void 0 ? void 0 : newRetryCreationPos.resourceId;
    // Fast path: no new entry and nothing to remap — return the same reference.
    // This is critical for PR-E (EDITOR-6929) which relies on reference equality
    // to short-circuit SharedStateAPI deep-equality checks.
    if (!resourceId && oldMap.size === 0) return oldMap;
    const newMap = new Map(oldMap);
    if (resourceId) {
        const { pos: pos } = newRetryCreationPos;
        if (!pos) newMap.delete(resourceId);
        else newMap.set(resourceId, pos);
    }
    if (newMap.size === 0) return newMap;
    for (const [id, pos] of newMap.entries())newMap.set(id, {
        from: mapPos(pos.from),
        to: mapPos(pos.to)
    });
    return newMap;
};
const $4782e5e4da443e26$var$showCopiedFlag = (api, isLivePage, isSourceContentUnpublished, sourceProduct)=>{
    (0, $QIBX2.deferDispatch)(()=>{
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>tr.setMeta($4782e5e4da443e26$export$cb5a03b39dafc9cc, {
                activeFlag: {
                    id: (0, $7II9i.FLAG_ID).SYNC_BLOCK_COPIED,
                    isLivePage: isLivePage,
                    isSourceContentUnpublished: isSourceContentUnpublished,
                    sourceProduct: sourceProduct
                }
            }));
    });
};
const $4782e5e4da443e26$var$showExtensionInSyncBlockWarningIfNeeded = (tr, state, api, extensionFlagShown)=>{
    var _api$connectivity;
    if (!tr.docChanged || tr.getMeta('isRemote') || Boolean(tr.getMeta((0, $56AB9.pmHistoryPluginKey))) || (0, $hVGJk.isOfflineMode)(api === null || api === void 0 || (_api$connectivity = api.connectivity) === null || _api$connectivity === void 0 || (_api$connectivity = _api$connectivity.sharedState.currentState()) === null || _api$connectivity === void 0 ? void 0 : _api$connectivity.mode)) return;
    const resourceId = (0, $QIBX2.wasExtensionInsertedInBodiedSyncBlock)(tr, state);
    // Only show the flag on the first instance per sync block (same as UNPUBLISHED_SYNC_BLOCK_PASTED)
    if (resourceId && !extensionFlagShown.has(resourceId)) {
        extensionFlagShown.add(resourceId);
        (0, $QIBX2.deferDispatch)(()=>{
            api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>tr.setMeta($4782e5e4da443e26$export$cb5a03b39dafc9cc, {
                    activeFlag: {
                        id: (0, $7II9i.FLAG_ID).EXTENSION_IN_SYNC_BLOCK
                    }
                }));
        });
    }
};
const $4782e5e4da443e26$var$getDeleteReason = (tr)=>{
    const reason = tr.getMeta('deletionReason');
    if (!reason) return 'source-block-deleted';
    return reason;
};
/** Narrows the history plugin meta, matching the editor-plugin-card pattern. */ const $4782e5e4da443e26$var$isHistoryMeta = (meta)=>typeof meta === 'object' && meta !== null && 'redo' in meta && typeof meta.redo === 'boolean';
const $4782e5e4da443e26$export$d9923c7a8cbf31ed = (tr, state)=>{
    var _selection$node, _selection$node2;
    const historyMeta = tr.getMeta((0, $56AB9.pmHistoryPluginKey));
    if (historyMeta) {
        if (!$4782e5e4da443e26$var$isHistoryMeta(historyMeta)) return 'other';
        return $4782e5e4da443e26$var$isHistoryMeta(historyMeta) && historyMeta.redo ? 'redo' : 'undo';
    }
    // The toolbar Delete control tags its transaction so we can report it
    // distinctly from a keyboard delete (both produce a plain ReplaceStep).
    if (tr.getMeta($4782e5e4da443e26$export$84cb2650bbe09e82) === 'deleteButton') return 'deleteButton';
    const hasStructuralStep = tr.steps.some((step)=>step instanceof (0, $3DNV7.ReplaceAroundStep));
    const hasReplaceStep = tr.steps.some((step)=>step instanceof (0, $3DNV7.ReplaceStep));
    if (hasStructuralStep || !hasReplaceStep) return 'other';
    const { selection: selection } = state;
    const isNodeSelected = selection instanceof (0, $cw0wu.NodeSelection) && (((_selection$node = selection.node) === null || _selection$node === void 0 ? void 0 : _selection$node.type.name) === 'bodiedSyncBlock' || ((_selection$node2 = selection.node) === null || _selection$node2 === void 0 ? void 0 : _selection$node2.type.name) === 'syncBlock');
    return isNodeSelected ? 'selectionReplaced' : 'keyboardDelete';
};
const $4782e5e4da443e26$export$9feff71901283088 = (mechanism)=>{
    if (mechanism === 'undo') return 'prompted-undo';
    if (mechanism === 'deleteButton' || mechanism === 'keyboardDelete' || mechanism === 'selectionReplaced') return 'prompted-delete';
    return undefined;
};
/**
 * True when a source `bodiedSyncBlock` holds user content — i.e. not just the
 * single empty paragraph it is created with (used to detect empty→content).
 */ const $4782e5e4da443e26$var$bodiedSyncBlockHasContent = (node)=>{
    if (node.childCount === 0) return false;
    if (node.childCount === 1) {
        const child = node.firstChild;
        // A freshly-created block is a single empty paragraph; anything else
        // (non-empty paragraph, or a different/first block) counts as content.
        return !((child === null || child === void 0 ? void 0 : child.type.name) === 'paragraph' && child.content.size === 0);
    }
    return true;
};
/**
 * Ask the store manager to fire the one-shot first-content-added event for every
 * populated source block. The manager only emits for blocks it created empty
 * this session and dedupes per block, so iterating all populated blocks is safe
 * and self-limiting. Called only when `hasEditInSyncBlock` flagged an in-block
 * edit, so this walk runs rarely.
 */ const $4782e5e4da443e26$var$emitFirstContentAddedForEditedBlocks = (tr, state, syncBlockStore)=>{
    const { bodiedSyncBlock: bodiedSyncBlock } = state.schema.nodes;
    tr.doc.descendants((node)=>{
        if (node.type === bodiedSyncBlock) {
            if ($4782e5e4da443e26$var$bodiedSyncBlockHasContent(node)) syncBlockStore.sourceManager.maybeEmitFirstContentAdded(node.attrs.resourceId, node.attrs.localId);
            // bodiedSyncBlocks are top-level and not nested, so no need to descend.
            return false;
        }
        return true;
    });
};
const $4782e5e4da443e26$var$filterTransactionOnline = ({ tr: tr, state: state, syncBlockStore: syncBlockStore, api: api, confirmationTransactionRef: confirmationTransactionRef, ctx: ctx, bodiedSyncBlockRemoved: bodiedSyncBlockRemoved, bodiedSyncBlockAdded: bodiedSyncBlockAdded, extensionFlagShown: extensionFlagShown })=>{
    const { removed: syncBlockRemoved, added: syncBlockAdded } = (0, $bzsc2.trackSyncBlocks)(syncBlockStore.referenceManager.isReferenceBlock, tr, state);
    syncBlockRemoved.forEach((syncBlock)=>{
        var _api$analytics;
        api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.fireAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).DELETED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).REFERENCE_SYNCED_BLOCK_DELETE,
            attributes: {
                resourceId: syncBlock.attrs.resourceId,
                blockInstanceId: syncBlock.attrs.localId
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
        });
    });
    // Annotate every reference-block insertion with `sourceProduct`
    // (derived from the resourceId) and `isPaste` (when the originating transaction was a
    // paste). Together with the host product reported by the embedding product's pageview
    // events this lets us triangulate cross-product paste behaviour without standing up a
    // dedicated `cross_product_paste` event subject.
    const isPaste = Boolean(tr.getMeta('paste') ?? tr.getMeta('uiEvent') === 'paste');
    const isPasteOrDrop = isPaste || tr.getMeta('uiEvent') === 'drop';
    const hasRemovedSyncBlock = syncBlockRemoved.length > 0 || bodiedSyncBlockRemoved.length > 0;
    const isCutRemoval = hasRemovedSyncBlock && ctx.consumeCutRemoval();
    const canPromptForRemoval = Boolean(ctx.onGiveFeedback) && hasRemovedSyncBlock && !(0, $gZj5p.isDirtyTransaction)(tr) && !isCutRemoval && !isPasteOrDrop;
    const promptedFeedbackEntryPoint = canPromptForRemoval ? $4782e5e4da443e26$export$9feff71901283088($4782e5e4da443e26$export$d9923c7a8cbf31ed(tr, state)) : undefined;
    const entryPoint = promptedFeedbackEntryPoint;
    if (entryPoint && syncBlockRemoved.length > 0 && bodiedSyncBlockRemoved.length === 0) tr.setMeta($4782e5e4da443e26$var$syncedBlockPromptedFeedbackMetaKey, {
        context: {
            blockType: 'reference',
            entryPoint: entryPoint
        }
    });
    syncBlockAdded.forEach((syncBlock)=>{
        var _api$analytics2;
        api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 || (_api$analytics2 = _api$analytics2.actions) === null || _api$analytics2 === void 0 || _api$analytics2.fireAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).INSERTED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK,
            attributes: {
                resourceId: syncBlock.attrs.resourceId,
                blockInstanceId: syncBlock.attrs.localId,
                sourceProduct: (0, $iYvEr.getSourceProductFromResourceIdSafe)(syncBlock.attrs.resourceId),
                isPaste: isPaste
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
        });
    });
    if (bodiedSyncBlockRemoved.length > 0) {
        // Recompute the delete fresh from the live document on confirm
        // (see handleBodiedSyncBlockRemoval). See EDITOR-7889.
        const mechanism = $4782e5e4da443e26$export$d9923c7a8cbf31ed(tr, state);
        const feedbackContext = entryPoint && $4782e5e4da443e26$var$getDeleteReason(tr) !== 'source-block-unsynced' ? {
            blockType: 'source',
            entryPoint: entryPoint
        } : undefined;
        let feedbackCallbacks;
        if (feedbackContext) {
            const sourceAttempt = ctx.queueSourceFeedback(feedbackContext);
            feedbackCallbacks = {
                onDeleteCompleted: (success)=>ctx.completeSourceDeletion(sourceAttempt, success),
                onDeleteTransaction: (deleteTr)=>deleteTr.setMeta($4782e5e4da443e26$var$syncedBlockPromptedFeedbackMetaKey, {
                        context: feedbackContext,
                        sourceAttempt: sourceAttempt
                    }),
                onDestroy: ()=>ctx.clearSourceFeedback(sourceAttempt)
            };
        }
        return (0, $iQxc5.handleBodiedSyncBlockRemoval)({
            removed: bodiedSyncBlockRemoved,
            syncBlockStore: syncBlockStore,
            api: api,
            confirmationTransactionRef: confirmationTransactionRef,
            deletionReason: $4782e5e4da443e26$var$getDeleteReason(tr),
            mechanism: mechanism,
            feedbackCallbacks: feedbackCallbacks
        });
    }
    if (bodiedSyncBlockAdded.length > 0) {
        if (tr.getMeta((0, $56AB9.pmHistoryPluginKey))) // We don't allow bodiedSyncBlock creation via redo, however, we need to return true here to let transaction through so history can be updated properly.
        // If we simply returns false, creation from redo is blocked as desired, but this results in editor showing redo as possible even though it's not.
        // After true is returned here and the node is created, we delete the node in the filterTransaction immediately, which cancels out the creation
        return true;
        // Defense-in-depth: if a bodiedSyncBlock arrives via paste or drag-and-drop,
        // it may have bypassed transformCopied (e.g. cut, browser clipboard).
        // Do not call createBlock — it would use this page's parentId which may
        // be wrong. The bodiedSyncBlock content will still be inserted but will
        // not be registered as a source block in Block Service, which is safer
        // than creating a zombie block under the wrong ARI.
        if (isPasteOrDrop) return true;
        // Forward creation analytics signals captured by createSyncedBlock onto the async
        // `syncedBlockCreate` success event.
        const creationMeta = tr.getMeta($4782e5e4da443e26$export$cde24468c2642688);
        (0, $1wTON.handleBodiedSyncBlockCreation)(bodiedSyncBlockAdded, state, api, creationMeta);
        return true;
    }
    // On an in-block edit, let the store manager fire the one-shot first-content
    // event (dedupe + empty→content scoping live there). After the add/remove
    // branches so it never runs for the creation transaction itself.
    if ((0, $bzsc2.hasEditInSyncBlock)(tr, state)) $4782e5e4da443e26$var$emitFirstContentAddedForEditedBlocks(tr, state, syncBlockStore);
    $4782e5e4da443e26$var$showExtensionInSyncBlockWarningIfNeeded(tr, state, api, extensionFlagShown);
    return true;
};
const $4782e5e4da443e26$var$filterTransactionOffline = ({ tr: tr, state: state, syncBlockStore: syncBlockStore, api: api, isConfirmedSyncBlockDeletion: isConfirmedSyncBlockDeletion, bodiedSyncBlockRemoved: bodiedSyncBlockRemoved, bodiedSyncBlockAdded: bodiedSyncBlockAdded })=>{
    const { removed: syncBlockRemoved, added: syncBlockAdded } = (0, $bzsc2.trackSyncBlocks)(syncBlockStore.referenceManager.isReferenceBlock, tr, state);
    let errorFlag = false;
    if (isConfirmedSyncBlockDeletion || bodiedSyncBlockRemoved.length > 0 || syncBlockRemoved.length > 0) errorFlag = (0, $7II9i.FLAG_ID).CANNOT_DELETE_WHEN_OFFLINE;
    else if (bodiedSyncBlockAdded.length > 0 || syncBlockAdded.length > 0) errorFlag = (0, $7II9i.FLAG_ID).CANNOT_CREATE_WHEN_OFFLINE;
    else if ((0, $bzsc2.hasEditInSyncBlock)(tr, state)) errorFlag = (0, $7II9i.FLAG_ID).CANNOT_EDIT_WHEN_OFFLINE;
    if (errorFlag) {
        (0, $QIBX2.deferDispatch)(()=>{
            api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>tr.setMeta($4782e5e4da443e26$export$cb5a03b39dafc9cc, {
                    activeFlag: {
                        id: errorFlag
                    }
                }));
        });
        return false;
    }
    return true;
};
/**
 * Build the status decoration set for sync-block nodes. This performs a full
 * `doc.descendants()` walk so it must only be called when a status signal
 * actually changes (offline, view-mode, dragging, pending-creation). Between
 * status changes the caller should use `decorationSet.map(tr.mapping, tr.doc)`
 * instead (see EDITOR-6930).
 */ const $4782e5e4da443e26$var$buildStatusDecorations = (doc, syncBlockStore, isOffline, isViewMode, isDragging)=>{
    // Fast path: when all status flags are off and no creations are in flight,
    // no node can produce a decoration — skip the full doc traversal.
    if (!isOffline && !isViewMode && !isDragging && !syncBlockStore.sourceManager.hasPendingCreations()) return (0, $a3b9P.DecorationSet).empty;
    const offlineDecorations = [];
    const viewModeDecorations = [];
    const loadingDecorations = [];
    const dragDecorations = [];
    doc.descendants((node, pos)=>{
        if (node.type.name === 'bodiedSyncBlock' && isOffline) offlineDecorations.push((0, $a3b9P.Decoration).node(pos, pos + node.nodeSize, {
            class: (0, $7VlAB.SyncBlockStateCssClassName).disabledClassName
        }));
        if (syncBlockStore.isSyncBlock(node) && isViewMode) viewModeDecorations.push((0, $a3b9P.Decoration).node(pos, pos + node.nodeSize, {
            class: (0, $7VlAB.SyncBlockStateCssClassName).viewModeClassName
        }));
        if (node.type.name === 'bodiedSyncBlock' && syncBlockStore.sourceManager.isPendingCreation(node.attrs.resourceId)) loadingDecorations.push((0, $a3b9P.Decoration).node(pos, pos + node.nodeSize, {
            class: (0, $7VlAB.SyncBlockStateCssClassName).creationLoadingClassName
        }));
        if (isDragging && syncBlockStore.isSyncBlock(node)) dragDecorations.push((0, $a3b9P.Decoration).node(pos, pos + node.nodeSize, {
            class: (0, $7VlAB.SyncBlockStateCssClassName).draggingClassName
        }));
        // only traverse the top-level node of the document, as syncBlock and bodiedSyncBlock are top-level nodes
        return false;
    });
    return (0, $a3b9P.DecorationSet).create(doc, [
        ...offlineDecorations,
        ...viewModeDecorations,
        ...loadingDecorations,
        ...dragDecorations
    ]);
};
/**
 * Encapsulates mutable state that persists across transactions in the
 * synced block plugin. Replaces module-level closure variables so state
 * is explicitly scoped to a single plugin instance.
 */ class $4782e5e4da443e26$var$SyncedBlockPluginContext {
    constructor(onGiveFeedback, shouldShowFeedbackPrompt, api){
        this.onGiveFeedback = onGiveFeedback;
        this.shouldShowFeedbackPrompt = shouldShowFeedbackPrompt;
        this.api = api;
        this.confirmationTransactionRef = {
            current: undefined
        };
        this._cutRemovalPending = false;
        this.cutRemovalGeneration = 0;
        this._isCopyEvent = false;
        this._isCutEvent = false;
        this.feedbackPromptConsumed = false;
        this.unpublishedFlagShown = new Set();
        this.extensionFlagShown = new Set();
    }
    get isCopyEvent() {
        return this._isCopyEvent;
    }
    markCopyEvent() {
        this._isCopyEvent = true;
    }
    markCutEvent() {
        this._isCutEvent = true;
    }
    consumeCopyEvent() {
        const was = this._isCopyEvent;
        this._isCopyEvent = false;
        return was;
    }
    consumeCutEvent() {
        const was = this._isCutEvent;
        this._isCutEvent = false;
        return was;
    }
    markCutRemovalPending() {
        this._cutRemovalPending = true;
        const generation = ++this.cutRemovalGeneration;
        queueMicrotask(()=>{
            if (this.cutRemovalGeneration === generation) this._cutRemovalPending = false;
        });
    }
    consumeCutRemoval() {
        const wasPending = this._cutRemovalPending;
        this._cutRemovalPending = false;
        this.cutRemovalGeneration += 1;
        return wasPending;
    }
    queueSourceFeedback(context) {
        const sourceAttempt = Symbol('syncedBlockSourceFeedbackAttempt');
        this.pendingSourceFeedback = {
            context: context,
            deletionSucceeded: false,
            sourceAttempt: sourceAttempt,
            transactionApplied: false
        };
        return sourceAttempt;
    }
    completeSourceDeletion(sourceAttempt, success) {
        var _this$pendingSourceFe;
        if (((_this$pendingSourceFe = this.pendingSourceFeedback) === null || _this$pendingSourceFe === void 0 ? void 0 : _this$pendingSourceFe.sourceAttempt) !== sourceAttempt) return;
        if (!success) // Keep the attempt pending because retryDeletion reuses these callbacks.
        // Dismissal or cancellation clears it through the destroy callback.
        return;
        this.pendingSourceFeedback.deletionSucceeded = true;
        this.flushSourceFeedback(sourceAttempt);
    }
    clearSourceFeedback(sourceAttempt) {
        var _this$pendingSourceFe2;
        if (((_this$pendingSourceFe2 = this.pendingSourceFeedback) === null || _this$pendingSourceFe2 === void 0 ? void 0 : _this$pendingSourceFe2.sourceAttempt) === sourceAttempt) this.pendingSourceFeedback = undefined;
    }
    handleAppliedFeedback({ context: context, sourceAttempt: sourceAttempt }) {
        var _this$pendingSourceFe3;
        if (context.blockType === 'source' && sourceAttempt && ((_this$pendingSourceFe3 = this.pendingSourceFeedback) === null || _this$pendingSourceFe3 === void 0 ? void 0 : _this$pendingSourceFe3.sourceAttempt) === sourceAttempt) {
            this.pendingSourceFeedback.transactionApplied = true;
            this.flushSourceFeedback(sourceAttempt);
            return;
        }
        if (context.blockType === 'reference') this.requestFeedbackPrompt(context);
    }
    flushSourceFeedback(sourceAttempt) {
        var _this$pendingSourceFe4, _this$pendingSourceFe5;
        if (((_this$pendingSourceFe4 = this.pendingSourceFeedback) === null || _this$pendingSourceFe4 === void 0 ? void 0 : _this$pendingSourceFe4.sourceAttempt) === sourceAttempt && (_this$pendingSourceFe5 = this.pendingSourceFeedback) !== null && _this$pendingSourceFe5 !== void 0 && _this$pendingSourceFe5.deletionSucceeded && this.pendingSourceFeedback.transactionApplied) {
            const { context: context } = this.pendingSourceFeedback;
            this.pendingSourceFeedback = undefined;
            this.requestFeedbackPrompt(context);
        }
    }
    requestFeedbackPrompt(context) {
        if (this.feedbackPromptConsumed) return;
        this.feedbackPromptConsumed = true;
        (0, $QIBX2.deferDispatch)(()=>{
            try {
                var _this$shouldShowFeedb;
                const shouldShow = ((_this$shouldShowFeedb = this.shouldShowFeedbackPrompt) === null || _this$shouldShowFeedb === void 0 ? void 0 : _this$shouldShowFeedb.call(this)) ?? true;
                Promise.resolve(shouldShow).then((isEligible)=>{
                    var _this$api;
                    if (!isEligible) return;
                    (_this$api = this.api) === null || _this$api === void 0 || _this$api.core.actions.execute(({ tr: tr })=>tr.setMeta($4782e5e4da443e26$export$cb5a03b39dafc9cc, {
                            activeFlag: {
                                id: (0, $7II9i.FLAG_ID).SYNC_BLOCK_FEEDBACK_PROMPT,
                                feedbackContext: context
                            }
                        }));
                }).catch(()=>{});
            } catch  {
            // Persisted feedback eligibility is optional product UI.
            }
        });
    }
}
const $4782e5e4da443e26$export$ae829ec7b2625219 = (options, pmPluginFactoryParams, syncBlockStore, api)=>{
    const { useLongPressSelection: useLongPressSelection = false } = options || {};
    const ctx = new $4782e5e4da443e26$var$SyncedBlockPluginContext(options === null || options === void 0 ? void 0 : options.onGiveFeedback, options === null || options === void 0 ? void 0 : options.shouldShowFeedbackPrompt, api);
    const confirmationTransactionRef = ctx.confirmationTransactionRef;
    const unpublishedFlagShown = ctx.unpublishedFlagShown;
    const extensionFlagShown = ctx.extensionFlagShown;
    // Update plugin state post-flush to sync hasUnsavedBodiedSyncBlockChanges.
    // It prevents false "Changes may not be saved" warnings when publishing
    // Classic pages with sync blocks.
    syncBlockStore.sourceManager.registerFlushCompletionCallback(()=>{
        (0, $QIBX2.deferDispatch)(()=>{
            api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>tr);
        });
    });
    // Trigger a deferred flush when block creation completes after the initial
    // flush timed out waiting for it. This ensures content created from
    // existing text is eventually persisted even if no further edits are made.
    // See EDITOR-7112.
    syncBlockStore.sourceManager.registerPostCreationFlushCallback(()=>{
        (0, $QIBX2.deferDispatch)(()=>{
            syncBlockStore.sourceManager.flush();
        });
    });
    // Set up callback to detect unpublished sync blocks when they're fetched
    syncBlockStore.referenceManager.setOnUnpublishedSyncBlockDetected((resourceId)=>{
        // Only show the flag once per sync block
        if (!unpublishedFlagShown.has(resourceId)) {
            unpublishedFlagShown.add(resourceId);
            // Surface the source product so the flag's copy can be tailored — Jira work
            // items get "Pasted from unsaved item" / "...when the item's description is
            // saved" rather than the Confluence page-flavoured default. Falls back to
            // undefined when the resourceId can't be parsed (legacy shapes), in which
            // case the Confluence default is used.
            const sourceProduct = (0, $iYvEr.getSourceProductFromResourceIdSafe)(resourceId);
            (0, $QIBX2.deferDispatch)(()=>{
                api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>tr.setMeta($4782e5e4da443e26$export$cb5a03b39dafc9cc, {
                        activeFlag: {
                            id: (0, $7II9i.FLAG_ID).UNPUBLISHED_SYNC_BLOCK_PASTED,
                            sourceProduct: sourceProduct,
                            resourceId: resourceId
                        }
                    }));
            });
        }
    });
    return new (0, $f7Kk4.SafePlugin)({
        key: $4782e5e4da443e26$export$cb5a03b39dafc9cc,
        state: {
            init (_, instance) {
                var _api$connectivity2, _api$editorViewMode, _api$userIntent;
                // When the document has no synced blocks, we skip the eager fetch +
                // cache walks. They will be re-run lazily by `apply` the first time a
                // synced block enters the document (paste, collab insert, or
                // programmatic insert).
                const docHasSyncedBlocks = (0, $kTCCL.hasSyncedBlocks)(instance.doc);
                if (docHasSyncedBlocks) {
                    const syncBlockNodes = instance.doc.children.filter(syncBlockStore.referenceManager.isReferenceBlock);
                    syncBlockStore.referenceManager.fetchSyncBlocksData((0, $iYvEr.convertPMNodesToSyncBlockNodes)(syncBlockNodes));
                    // Populate source sync block cache from initial document.
                    // This replaces the constructor call in the nodeview.
                    instance.doc.forEach((node)=>{
                        if (syncBlockStore.sourceManager.isSourceBlock(node)) syncBlockStore.sourceManager.updateSyncBlockData(node, false);
                    });
                    // Fetch statuses from the backend so we can identify unpublished blocks on cancel
                    syncBlockStore.sourceManager.fetchAndCacheStatuses();
                }
                // Read initial shared-state signals for status decorations
                const initIsOffline = (0, $hVGJk.isOfflineMode)(api === null || api === void 0 || (_api$connectivity2 = api.connectivity) === null || _api$connectivity2 === void 0 || (_api$connectivity2 = _api$connectivity2.sharedState.currentState()) === null || _api$connectivity2 === void 0 ? void 0 : _api$connectivity2.mode);
                const initIsViewMode = (api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode) === 'view';
                const initIsDragging = (api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 || (_api$userIntent = _api$userIntent.sharedState.currentState()) === null || _api$userIntent === void 0 ? void 0 : _api$userIntent.currentUserIntent) === 'dragging';
                // Build initial status decoration set (EDITOR-6930).
                // When the perf gate is ON and the doc has synced blocks we do a
                // single traversal here; afterwards `apply()` will map or rebuild
                // only when a status signal changes.
                const initStatusDecorationSet = docHasSyncedBlocks ? $4782e5e4da443e26$var$buildStatusDecorations(instance.doc, syncBlockStore, initIsOffline, initIsViewMode, initIsDragging) : (0, $a3b9P.DecorationSet).empty;
                return {
                    selectionDecorationSet: (0, $cAJxL.calculateDecorations)(instance.doc, instance.selection, instance.schema),
                    activeFlag: false,
                    syncBlockStore: syncBlockStore,
                    retryCreationPosMap: new Map(),
                    hasSyncedBlocks: docHasSyncedBlocks,
                    hasUnsavedBodiedSyncBlockChanges: syncBlockStore.sourceManager.hasUnsavedChanges(),
                    statusDecorationSet: initStatusDecorationSet,
                    prevIsOffline: initIsOffline,
                    prevIsViewMode: initIsViewMode,
                    prevIsDragging: initIsDragging
                };
            },
            apply: (tr, currentPluginState, oldEditorState)=>{
                var _api$userIntent2, _api$connectivity3, _api$editorViewMode2;
                const meta = tr.getMeta($4782e5e4da443e26$export$cb5a03b39dafc9cc);
                const { activeFlag: activeFlag, selectionDecorationSet: selectionDecorationSet, bodiedSyncBlockDeletionStatus: bodiedSyncBlockDeletionStatus, retryCreationPosMap: retryCreationPosMap, hasSyncedBlocks: prevHasSyncedBlocks, statusDecorationSet: prevStatusDecorationSet, prevIsOffline: prevOffline, prevIsViewMode: prevViewMode, prevIsDragging: prevDragging } = currentPluginState;
                // Pre-compute once so the fast-path probe and the bottom ref-equality
                // short-circuit share the same source-manager snapshot. Track C will make this O(1).
                const nextHasUnsavedBodiedSyncBlockChanges = syncBlockStore.sourceManager.hasUnsavedChanges();
                // --- Fast path (EDITOR-6934 follow-up, see Confluence 7050540723 §9.3 / §9.9):
                // when no plugin meta is set, and neither the document nor selection changed,
                // most synced-block plugin state cannot change. The source manager is mutable
                // outside ProseMirror transactions, though, so preserve existing empty-transaction
                // sync semantics by checking that snapshot first.
                //
                // Note: selection-only transactions intentionally fall through to the normal
                // apply path because calculateDecorations depends on drag/view-mode state
                // that is not captured here.
                //
                // We also need to ensure shared-state signals (drag, offline, view-mode)
                // haven't changed — these are propagated via empty transactions and drive
                // status decoration rebuilds (e.g. drag border). Without this check the
                // fast path would swallow drag-start transactions and the synced block
                // border would never appear (see VR test: synced-block-drag-selection).
                if (!meta && !tr.docChanged && tr.selection.eq(oldEditorState.selection) && nextHasUnsavedBodiedSyncBlockChanges === currentPluginState.hasUnsavedBodiedSyncBlockChanges && (api === null || api === void 0 || (_api$userIntent2 = api.userIntent) === null || _api$userIntent2 === void 0 || (_api$userIntent2 = _api$userIntent2.sharedState.currentState()) === null || _api$userIntent2 === void 0 ? void 0 : _api$userIntent2.currentUserIntent) === 'dragging' === prevDragging && (0, $hVGJk.isOfflineMode)(api === null || api === void 0 || (_api$connectivity3 = api.connectivity) === null || _api$connectivity3 === void 0 || (_api$connectivity3 = _api$connectivity3.sharedState.currentState()) === null || _api$connectivity3 === void 0 ? void 0 : _api$connectivity3.mode) === prevOffline && (api === null || api === void 0 || (_api$editorViewMode2 = api.editorViewMode) === null || _api$editorViewMode2 === void 0 || (_api$editorViewMode2 = _api$editorViewMode2.sharedState.currentState()) === null || _api$editorViewMode2 === void 0 ? void 0 : _api$editorViewMode2.mode) === 'view' === prevViewMode) return currentPluginState;
                // Lazy-init bookkeeping: once a synced block enters the document we
                // flip `hasSyncedBlocks` to `true` for the lifetime of this editor
                let nextHasSyncedBlocks = prevHasSyncedBlocks;
                if (!prevHasSyncedBlocks && tr.docChanged) {
                    if ((0, $j5HQh.transactionInsertsSyncedBlock)(tr)) nextHasSyncedBlocks = true;
                }
                let newDecorationSet = tr.docChanged ? selectionDecorationSet.map(tr.mapping, tr.doc) // only map if document changed
                 : selectionDecorationSet;
                if (!tr.selection.eq(oldEditorState.selection)) newDecorationSet = (0, $cAJxL.calculateDecorations)(tr.doc, tr.selection, tr.doc.type.schema);
                else if (tr.docChanged) {
                    const existingDecorationsLength = selectionDecorationSet.find().length;
                    const newDecorationsLength = newDecorationSet.find().length;
                    // Edge case: When document nodes are replaced, the mapping can lose decorations
                    // We rebuild decorations when the document changes but the selection hasn't.
                    // We can do this check because we only expect 1 decoration for the selection
                    if (existingDecorationsLength !== newDecorationsLength) newDecorationSet = (0, $cAJxL.calculateDecorations)(tr.doc, tr.selection, tr.doc.type.schema);
                }
                // --- Status decoration set (EDITOR-6930) ---
                // When the perf gate is ON we maintain `statusDecorationSet` in
                // plugin state so the `decorations` prop becomes an O(1) lookup.
                let nextStatusDecorationSet = prevStatusDecorationSet;
                let nextIsOffline = prevOffline;
                let nextIsViewMode = prevViewMode;
                let nextIsDragging = prevDragging;
                if (!nextHasSyncedBlocks) // No synced blocks → keep empty status decorations
                nextStatusDecorationSet = (0, $a3b9P.DecorationSet).empty;
                else {
                    var _api$connectivity4, _api$editorViewMode3, _api$userIntent3;
                    // Read current shared-state signals
                    nextIsOffline = (0, $hVGJk.isOfflineMode)(api === null || api === void 0 || (_api$connectivity4 = api.connectivity) === null || _api$connectivity4 === void 0 || (_api$connectivity4 = _api$connectivity4.sharedState.currentState()) === null || _api$connectivity4 === void 0 ? void 0 : _api$connectivity4.mode);
                    nextIsViewMode = (api === null || api === void 0 || (_api$editorViewMode3 = api.editorViewMode) === null || _api$editorViewMode3 === void 0 || (_api$editorViewMode3 = _api$editorViewMode3.sharedState.currentState()) === null || _api$editorViewMode3 === void 0 ? void 0 : _api$editorViewMode3.mode) === 'view';
                    nextIsDragging = (api === null || api === void 0 || (_api$userIntent3 = api.userIntent) === null || _api$userIntent3 === void 0 || (_api$userIntent3 = _api$userIntent3.sharedState.currentState()) === null || _api$userIntent3 === void 0 ? void 0 : _api$userIntent3.currentUserIntent) === 'dragging';
                    // Determine whether we need a full rebuild or a cheap map
                    const hasSyncedBlocksJustFlipped = nextHasSyncedBlocks && !prevHasSyncedBlocks;
                    const statusSignalChanged = nextIsOffline !== prevOffline || nextIsViewMode !== prevViewMode || nextIsDragging !== prevDragging;
                    // Meta-driven status changes (e.g. pending creation
                    // completed, retry creation pos updated)
                    const hasMetaStatusChange = !!(meta !== null && meta !== void 0 && meta.retryCreationPos) || !!(meta !== null && meta !== void 0 && meta.activeFlag);
                    if (hasSyncedBlocksJustFlipped || statusSignalChanged || hasMetaStatusChange) // Full rebuild — a status signal changed
                    nextStatusDecorationSet = $4782e5e4da443e26$var$buildStatusDecorations(tr.doc, syncBlockStore, nextIsOffline, nextIsViewMode, nextIsDragging);
                    else if (tr.docChanged) // Cheap map — positions shifted but status unchanged
                    nextStatusDecorationSet = prevStatusDecorationSet.map(tr.mapping, tr.doc);
                // else: nothing changed, keep same reference
                }
                const newPosEntry = meta === null || meta === void 0 ? void 0 : meta.retryCreationPos;
                const newRetryCreationPosMap = $4782e5e4da443e26$var$mapRetryCreationPosMap(retryCreationPosMap, newPosEntry, tr.mapping.map.bind(tr.mapping));
                const nextActiveFlag = (meta === null || meta === void 0 ? void 0 : meta.activeFlag) ?? activeFlag;
                const nextBodiedSyncBlockDeletionStatus = (meta === null || meta === void 0 ? void 0 : meta.bodiedSyncBlockDeletionStatus) ?? bodiedSyncBlockDeletionStatus;
                // --- Reference equality (EDITOR-6929): return the same object
                // when ALL fields are reference-equal to avoid SharedStateAPI
                // notifying subscribers and triggering React re-renders. ---
                if (nextActiveFlag === activeFlag && newDecorationSet === selectionDecorationSet && newRetryCreationPosMap === retryCreationPosMap && nextHasSyncedBlocks === prevHasSyncedBlocks && nextBodiedSyncBlockDeletionStatus === bodiedSyncBlockDeletionStatus && nextHasUnsavedBodiedSyncBlockChanges === currentPluginState.hasUnsavedBodiedSyncBlockChanges && nextStatusDecorationSet === prevStatusDecorationSet && nextIsOffline === prevOffline && nextIsViewMode === prevViewMode && nextIsDragging === prevDragging) return currentPluginState;
                return {
                    activeFlag: nextActiveFlag,
                    selectionDecorationSet: newDecorationSet,
                    syncBlockStore: syncBlockStore,
                    retryCreationPosMap: newRetryCreationPosMap,
                    hasSyncedBlocks: nextHasSyncedBlocks,
                    bodiedSyncBlockDeletionStatus: nextBodiedSyncBlockDeletionStatus,
                    hasUnsavedBodiedSyncBlockChanges: nextHasUnsavedBodiedSyncBlockChanges,
                    statusDecorationSet: nextStatusDecorationSet,
                    prevIsOffline: nextIsOffline,
                    prevIsViewMode: nextIsViewMode,
                    prevIsDragging: nextIsDragging
                };
            }
        },
        props: {
            nodeViews: {
                syncBlock: (node, view, getPos, _decorations)=>// To support SSR, pass `syncBlockStore` here
                    // and do not use lazy loading.
                    // We cannot start rendering and then load `syncBlockStore` asynchronously,
                    // because obtaining it is asynchronous (sharedPluginState.currentState() is delayed).
                    new (0, $gmKcT.SyncBlock)({
                        api: api,
                        options: options,
                        node: node,
                        view: view,
                        getPos: getPos,
                        portalProviderAPI: pmPluginFactoryParams.portalProviderAPI,
                        eventDispatcher: pmPluginFactoryParams.eventDispatcher,
                        syncBlockStore: syncBlockStore,
                        intl: pmPluginFactoryParams.getIntl()
                    }).init(),
                bodiedSyncBlock: (0, $1Xcsv.bodiedSyncBlockNodeView)({
                    pluginOptions: options,
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    api: api,
                    syncBlockStore: syncBlockStore
                })
            },
            decorations: (state)=>{
                var _api$focus;
                const currentPluginState = $4782e5e4da443e26$export$cb5a03b39dafc9cc.getState(state);
                if (!currentPluginState) return (0, $a3b9P.DecorationSet).empty;
                const { selectionDecorationSet: selectionDecorationSet, statusDecorationSet: statusDecorationSet, hasSyncedBlocks: docHasSyncedBlocks } = currentPluginState;
                // When the perf gate is ON, both `selectionDecorationSet` and
                // `statusDecorationSet` are maintained in plugin state by
                // `apply()`. The `decorations` prop is now an O(1) merge of
                // the two cached sets — no `doc.descendants()` walk, no
                // shared-state reads.
                if (!docHasSyncedBlocks) return selectionDecorationSet;
                // Focus state is read live here (single cheap read) because
                // it only gates whether selection decorations are included —
                // it does not affect the status decoration set and can change
                // within the same transaction cycle.
                const hasFocus = (api === null || api === void 0 || (_api$focus = api.focus) === null || _api$focus === void 0 || (_api$focus = _api$focus.sharedState) === null || _api$focus === void 0 || (_api$focus = _api$focus.currentState()) === null || _api$focus === void 0 ? void 0 : _api$focus.hasFocus) ?? true;
                // Merge selection + status decorations.
                // When the editor is unfocused,
                // omit selection decorations (matches old behaviour).
                const statusDecorations = statusDecorationSet.find();
                if (statusDecorations.length === 0) return hasFocus ? selectionDecorationSet : (0, $a3b9P.DecorationSet).empty;
                else return hasFocus ? selectionDecorationSet.add(state.doc, statusDecorations) : statusDecorationSet;
            },
            handleClickOn: (0, $8KAjj.createSelectionClickHandler)([
                'bodiedSyncBlock'
            ], (target)=>!!target.closest(`.${(0, $7VlAB.BodiedSyncBlockSharedCssClassName).prefix}`), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDOMEvents: {
                mouseover (view, event) {
                    return (0, $dZUKh.shouldIgnoreDomEvent)(view, event, api);
                },
                mousedown (view, event) {
                    return (0, $dZUKh.shouldIgnoreDomEvent)(view, event, api);
                },
                copy: ()=>{
                    ctx.markCopyEvent();
                    return false;
                },
                cut: ()=>{
                    ctx.consumeCutEvent();
                    ctx.markCutEvent();
                    return false;
                }
            },
            transformPasted: (slice, _view)=>{
                // Defense against bodiedSyncBlock nodes arriving via paste
                // (e.g. drag-and-drop, cut-paste, or browser-level clipboard
                // operations that bypass the transformCopied handler).
                // We cannot convert to a syncBlock reference here because we don't
                // know the source page's parentId (generateResourceIdForReference
                // would use the current page's parentId which is wrong).
                // Instead, strip the bodiedSyncBlock wrapper and keep only the
                // inner content to prevent createBlock being called with the
                // wrong parentId.
                return (0, $4ClnP.mapSlice)(slice, (node)=>{
                    if (node.type.name === 'bodiedSyncBlock' && node.attrs.resourceId) // Return the inner content without the sync block wrapper.
                    // This is the same behavior as when a partial selection of
                    // a bodiedSyncBlock is copied (see transformCopied line 937).
                    return node.content;
                    return node;
                });
            },
            transformCopied: (slice, { state: state })=>{
                const pluginState = $4782e5e4da443e26$export$cb5a03b39dafc9cc.getState(state);
                const syncBlockStore = pluginState === null || pluginState === void 0 ? void 0 : pluginState.syncBlockStore;
                const { schema: schema } = state;
                const isCopy = ctx.consumeCopyEvent();
                const isCut = ctx.consumeCutEvent();
                // A prompted feedback cut is always a cut, so the two never need combining.
                const isPromptedFeedbackCut = Boolean(syncBlockStore && (options === null || options === void 0 ? void 0 : options.onGiveFeedback) && isCut);
                if (!syncBlockStore || !isCopy && !isCut) return slice;
                let containsCutSyncBlock = false;
                const transformedSlice = (0, $4ClnP.mapSlice)(slice, (node)=>{
                    if (syncBlockStore.referenceManager.isReferenceBlock(node)) {
                        var _syncBlockStore$refer;
                        if (isCut) {
                            containsCutSyncBlock = isPromptedFeedbackCut;
                            return node;
                        }
                        $4782e5e4da443e26$var$showCopiedFlag(api, options === null || options === void 0 ? void 0 : options.__livePage, ((_syncBlockStore$refer = syncBlockStore.referenceManager.getFromCache(node.attrs.resourceId)) === null || _syncBlockStore$refer === void 0 || (_syncBlockStore$refer = _syncBlockStore$refer.data) === null || _syncBlockStore$refer === void 0 ? void 0 : _syncBlockStore$refer.status) === 'unpublished', (0, $iYvEr.getSourceProductFromResourceIdSafe)(node.attrs.resourceId));
                        return node;
                    }
                    if (node.type.name === 'bodiedSyncBlock' && node.attrs.resourceId) {
                        if (isPromptedFeedbackCut && (0, $QIBX2.sliceFullyContainsNode)(slice, node)) containsCutSyncBlock = true;
                        // if we only selected part of the bodied sync block content,
                        // remove the sync block node and only keep the content
                        if (!(0, $QIBX2.sliceFullyContainsNode)(slice, node)) return node.content;
                        if (isCut) return node;
                        const newResourceId = syncBlockStore.referenceManager.generateResourceIdForReference(node.attrs.resourceId);
                        $4782e5e4da443e26$var$showCopiedFlag(api, options === null || options === void 0 ? void 0 : options.__livePage, syncBlockStore.sourceManager.getStatus(node.attrs.resourceId) !== 'active', (0, $iYvEr.getSourceProductFromResourceIdSafe)(newResourceId));
                        // Convert bodiedSyncBlock to syncBlock
                        // The paste transformation will regenrate the localId
                        const newAttrs = {
                            ...node.attrs,
                            resourceId: newResourceId
                        };
                        const newMarks = schema.nodes.syncBlock.markSet ? node.marks.filter((mark)=>{
                            var _schema$nodes$syncBlo;
                            return (_schema$nodes$syncBlo = schema.nodes.syncBlock.markSet) === null || _schema$nodes$syncBlo === void 0 ? void 0 : _schema$nodes$syncBlo.includes(mark.type);
                        }) : node.marks;
                        return schema.nodes.syncBlock.create(newAttrs, null, newMarks);
                    }
                    return node;
                });
                if (containsCutSyncBlock) ctx.markCutRemovalPending();
                return transformedSlice;
            }
        },
        view: (view)=>{
            if (!(0, $3y2s4.isExperimentEnabled)('platform_editor_blocks_patch_11')) return {};
            return (0, $04BiH.createReferenceSelectionView)(view);
        },
        filterTransaction: (tr, state)=>{
            var _api$editorViewMode4, _api$connectivity5;
            // Lazy-init: when no synced block currently exists in the doc and the
            // transaction does not insert one, all downstream filter logic is a
            // no-op. Avoid both the shared-state reads and the `trackSyncBlocks`
            // walks for the ~99.97% of pages that have no synced blocks.
            const pluginState = $4782e5e4da443e26$export$cb5a03b39dafc9cc.getState(state);
            if (pluginState && !pluginState.hasSyncedBlocks && !(0, $j5HQh.transactionInsertsSyncedBlock)(tr)) return true;
            const viewMode = api === null || api === void 0 || (_api$editorViewMode4 = api.editorViewMode) === null || _api$editorViewMode4 === void 0 || (_api$editorViewMode4 = _api$editorViewMode4.sharedState.currentState()) === null || _api$editorViewMode4 === void 0 ? void 0 : _api$editorViewMode4.mode;
            if (viewMode === 'view') return true;
            const isOffline = (0, $hVGJk.isOfflineMode)(api === null || api === void 0 || (_api$connectivity5 = api.connectivity) === null || _api$connectivity5 === void 0 || (_api$connectivity5 = _api$connectivity5.sharedState.currentState()) === null || _api$connectivity5 === void 0 ? void 0 : _api$connectivity5.mode);
            const isConfirmedSyncBlockDeletion = Boolean(tr.getMeta('isConfirmedSyncBlockDeletion'));
            // Track newly added reference sync blocks before processing the transaction
            if (tr.docChanged && !tr.getMeta('isRemote')) {
                const { added: added } = (0, $bzsc2.trackSyncBlocks)(syncBlockStore.referenceManager.isReferenceBlock, tr, state);
                added.forEach((nodeInfo)=>{
                    var _nodeInfo$attrs;
                    if ((_nodeInfo$attrs = nodeInfo.attrs) !== null && _nodeInfo$attrs !== void 0 && _nodeInfo$attrs.resourceId) syncBlockStore.referenceManager.markAsNewlyAdded(nodeInfo.attrs.resourceId);
                });
            }
            // if doc changed and it's a remote transaction, check if any synced block were added,
            // and if so, for source synced blocks, ensure we update the cache with them
            // and for reference synced blocks, ensure we fetch the data from the server
            if (tr.docChanged && tr.getMeta('isRemote')) {
                const { added: added } = (0, $bzsc2.trackSyncBlocks)((node)=>syncBlockStore.isSyncBlock(node), tr, state);
                const sourceSyncBlockNodes = added.filter((nodeInfo)=>nodeInfo.node && syncBlockStore.sourceManager.isSourceBlock(nodeInfo.node));
                const referenceSyncBlockNodes = added.filter((nodeInfo)=>nodeInfo.node && syncBlockStore.referenceManager.isReferenceBlock(nodeInfo.node));
                sourceSyncBlockNodes.forEach((nodeInfo)=>{
                    var _nodeInfo$attrs2;
                    if ((_nodeInfo$attrs2 = nodeInfo.attrs) !== null && _nodeInfo$attrs2 !== void 0 && _nodeInfo$attrs2.resourceId && nodeInfo.node) syncBlockStore.sourceManager.updateSyncBlockData(nodeInfo.node, tr.getMeta('isRemote'));
                });
                // Fetch statuses for remotely-added source sync blocks
                // so we can identify unpublished blocks on cancel
                if (sourceSyncBlockNodes.length > 0) syncBlockStore.sourceManager.fetchAndCacheStatuses();
                const syncBlockNodes = referenceSyncBlockNodes.map((nodeInfo)=>nodeInfo.node).filter((node)=>node !== undefined);
                syncBlockStore.referenceManager.fetchSyncBlocksData((0, $iYvEr.convertPMNodesToSyncBlockNodes)(syncBlockNodes));
            }
            if (!tr.docChanged || Boolean(tr.getMeta('isRemote')) || !isOffline && isConfirmedSyncBlockDeletion) return true;
            const { removed: bodiedSyncBlockRemoved, added: bodiedSyncBlockAdded } = (0, $bzsc2.trackSyncBlocks)(syncBlockStore.sourceManager.isSourceBlock, tr, state);
            return isOffline ? $4782e5e4da443e26$var$filterTransactionOffline({
                tr: tr,
                state: state,
                syncBlockStore: syncBlockStore,
                api: api,
                isConfirmedSyncBlockDeletion: isConfirmedSyncBlockDeletion,
                bodiedSyncBlockRemoved: bodiedSyncBlockRemoved,
                bodiedSyncBlockAdded: bodiedSyncBlockAdded
            }) : $4782e5e4da443e26$var$filterTransactionOnline({
                tr: tr,
                state: state,
                syncBlockStore: syncBlockStore,
                api: api,
                confirmationTransactionRef: confirmationTransactionRef,
                ctx: ctx,
                bodiedSyncBlockRemoved: bodiedSyncBlockRemoved,
                bodiedSyncBlockAdded: bodiedSyncBlockAdded,
                extensionFlagShown: extensionFlagShown
            });
        },
        appendTransaction: (trs, oldState, newState)=>{
            var _api$editorViewMode5;
            // Lazy-init: when neither the previous nor the new state contains a
            // synced block (and none of the dispatched transactions inserts one),
            // skip all downstream work. This is the hot path on the ~99.97% of
            // pages that don't use synced blocks (see EDITOR-6586).
            const oldPluginState = $4782e5e4da443e26$export$cb5a03b39dafc9cc.getState(oldState);
            const newPluginState = $4782e5e4da443e26$export$cb5a03b39dafc9cc.getState(newState);
            const hadOrHasSyncedBlocks = !!(oldPluginState !== null && oldPluginState !== void 0 && oldPluginState.hasSyncedBlocks) || !!(newPluginState !== null && newPluginState !== void 0 && newPluginState.hasSyncedBlocks);
            if (!hadOrHasSyncedBlocks) return null;
            const viewMode = api === null || api === void 0 || (_api$editorViewMode5 = api.editorViewMode) === null || _api$editorViewMode5 === void 0 || (_api$editorViewMode5 = _api$editorViewMode5.sharedState.currentState()) === null || _api$editorViewMode5 === void 0 ? void 0 : _api$editorViewMode5.mode;
            if (viewMode === 'view') return null;
            if (options !== null && options !== void 0 && options.onGiveFeedback) {
                const feedbackContexts = trs.flatMap((tr)=>{
                    const feedbackContext = tr.getMeta($4782e5e4da443e26$var$syncedBlockPromptedFeedbackMetaKey);
                    return feedbackContext ? [
                        feedbackContext
                    ] : [];
                });
                if (feedbackContexts.length > 0) feedbackContexts.forEach((feedbackContext)=>{
                    ctx.handleAppliedFeedback(feedbackContext);
                });
            }
            // Update source sync block cache for user-initiated changes only.
            // Cache updates are handled here instead of in the nodeview update() so we
            // can filter out non-user changes (remote collab, dirty programmatic txns).
            const isUserChange = (tr)=>tr.docChanged && !(0, $gZj5p.isDirtyTransaction)(tr) && !tr.getMeta('isRemote');
            const hasSourceBlockEdit = trs.some((tr)=>isUserChange(tr) && (0, $bzsc2.hasEditInSyncBlock)(tr, oldState));
            if (hasSourceBlockEdit) newState.doc.forEach((node)=>{
                if (syncBlockStore.sourceManager.isSourceBlock(node)) syncBlockStore.sourceManager.updateSyncBlockData(node, false);
            });
            for (const tr of trs)if (tr.getMeta((0, $56AB9.pmHistoryPluginKey))) {
                const { added: added } = (0, $bzsc2.trackSyncBlocks)(syncBlockStore.sourceManager.isSourceBlock, tr, oldState);
                if (added.length > 0) {
                    // A bodiedSyncBlock must not be (re)created from history, i.e. redo of a
                    // creation (see filterTransaction above). Unwrap it instead of deleting it:
                    // deleting the whole node also dropped the content the block was converted
                    // from (e.g. a table), and undoing that delete re-added the block and hit
                    // this guard again, so the content was unrecoverable (EDITOR-8863).
                    const { tr: tr } = newState;
                    if ((0, $3y2s4.isExperimentEnabled)('platform_editor_blocks_exp_patch_10')) // Unwrap in reverse document order so earlier replacements keep later
                    // positions valid.
                    [
                        ...added
                    ].sort((a, b)=>(b.from ?? 0) - (a.from ?? 0)).forEach(({ node: node, from: from, to: to })=>{
                        if (node && from !== undefined && to !== undefined) // This is ProseMirror's Transaction.replace (a document edit), not String.replace.
                        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace
                        tr.replace(from, to, new (0, $kW8qW.Slice)(node.content, 0, 0));
                    });
                    else added.forEach((node)=>{
                        if (node.from !== undefined && node.to !== undefined) tr.delete(node.from, node.to);
                    });
                    return tr;
                }
            }
            // Detect and remove duplicate bodiedSyncBlock resourceIds.
            // When a block template containing a source sync block is inserted into the
            // same document, it creates a duplicate with the same resourceId. We keep the
            // first occurrence and delete subsequent duplicates entirely (including their
            // contents), since a document must not contain two source sync blocks with the
            // same resourceId.
            if (trs.some((tr)=>tr.docChanged && !tr.getMeta('isRemote'))) {
                // Quick check: only walk the full document when at least one
                // transaction inserted a source synced block. This avoids an
                // expensive descendants() traversal on every local edit.
                const hasInsertedSourceBlock = trs.some((tr)=>{
                    if (!tr.docChanged || tr.getMeta('isRemote')) return false;
                    return tr.steps.some((step)=>{
                        if (!(step instanceof (0, $3DNV7.ReplaceStep) || step instanceof (0, $3DNV7.ReplaceAroundStep)) || !('slice' in step)) return false;
                        const { slice: slice } = step;
                        let found = false;
                        slice.content.descendants((node)=>{
                            if (syncBlockStore.sourceManager.isSourceBlock(node) && node.attrs.resourceId) found = true;
                            return false;
                        });
                        return found;
                    });
                });
                if (!hasInsertedSourceBlock) return null;
                const seenResourceIds = new Set();
                const duplicates = [];
                newState.doc.descendants((node, pos)=>{
                    if (syncBlockStore.sourceManager.isSourceBlock(node) && node.attrs.resourceId) {
                        if (seenResourceIds.has(node.attrs.resourceId)) duplicates.push({
                            pos: pos,
                            nodeSize: node.nodeSize
                        });
                        else seenResourceIds.add(node.attrs.resourceId);
                        return false;
                    }
                });
                if (duplicates.length > 0) {
                    const { tr: tr } = newState;
                    // Delete in reverse document order so positions remain valid
                    for(let i = duplicates.length - 1; i >= 0; i--){
                        const dup = duplicates[i];
                        tr.delete(dup.pos, dup.pos + dup.nodeSize);
                    }
                    tr.setMeta('addToHistory', false);
                    (0, $QIBX2.deferDispatch)(()=>{
                        var _api$core;
                        api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(({ tr: tr })=>tr.setMeta($4782e5e4da443e26$export$cb5a03b39dafc9cc, {
                                activeFlag: {
                                    id: (0, $7II9i.FLAG_ID).DUPLICATE_SOURCE_SYNC_BLOCK
                                }
                            }));
                    });
                    return tr;
                }
            }
            return null;
        }
    });
};

});
parcelRegister("1Xcsv", function(module, exports) {
$parcel$export(module.exports, "bodiedSyncBlockNodeView", () => $f82e97b965cd680f$export$89bdce39123f4223);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $hVGJk = parcelRequire("hVGJk");

var $iUiGU = parcelRequire("iUiGU");

var $7VlAB = parcelRequire("7VlAB");

var $kW8qW = parcelRequire("kW8qW");

var $3y2s4 = parcelRequire("3y2s4");

var $ceB3S = parcelRequire("ceB3S");

var $b3tcA = parcelRequire("b3tcA");

var $8rMkM = parcelRequire("8rMkM");
const $f82e97b965cd680f$var$toDOM = (node)=>[
        'div',
        {
            class: `${(0, $7VlAB.BodiedSyncBlockSharedCssClassName).prefix} bodiedSyncBlockView-content-wrap`,
            localid: node.attrs.localId,
            resourceid: node.attrs.resourceId
        },
        [
            'div',
            {
                class: (0, $7VlAB.BodiedSyncBlockSharedCssClassName).content,
                contenteditable: 'true'
            },
            0
        ]
    ];
const $f82e97b965cd680f$export$520fa575be2f7d06 = ({ localId: localId, resourceId: resourceId, sourceManager: sourceManager })=>{
    const isSamePageSyncEnabled = (0, $3y2s4.isExperimentEnabled)('editor-synced-block-same-page-sync');
    const [isUnpublished, setIsUnpublished] = (0, $bSJIT.useState)(()=>{
        var _sourceManager$getLoc;
        return isSamePageSyncEnabled && (sourceManager === null || sourceManager === void 0 || (_sourceManager$getLoc = sourceManager.getLocalSourceSnapshot(resourceId)) === null || _sourceManager$getLoc === void 0 ? void 0 : _sourceManager$getLoc.status) === 'unpublished';
    });
    const [sourceInfo, setSourceInfo] = (0, $bSJIT.useState)();
    (0, $bSJIT.useEffect)(()=>{
        if (!isSamePageSyncEnabled) return;
        let isMounted = true;
        sourceManager === null || sourceManager === void 0 || sourceManager.getSyncBlockSourceInfo(localId).then((nextSourceInfo)=>{
            if (isMounted) setSourceInfo(nextSourceInfo);
        });
        const unsubscribe = sourceManager === null || sourceManager === void 0 ? void 0 : sourceManager.subscribeToLocalSource(resourceId, (snapshot)=>setIsUnpublished((snapshot === null || snapshot === void 0 ? void 0 : snapshot.status) === 'unpublished'));
        return ()=>{
            isMounted = false;
            unsubscribe === null || unsubscribe === void 0 || unsubscribe();
        };
    }, [
        isSamePageSyncEnabled,
        localId,
        resourceId,
        sourceManager
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $b3tcA.SyncBlockLabel), {
        isSource: true,
        localId: localId,
        unpublishedInfo: isSamePageSyncEnabled && isUnpublished ? {
            sourceType: (0, $ceB3S.getUnpublishedSourceType)({
                sourceAri: sourceInfo === null || sourceInfo === void 0 ? void 0 : sourceInfo.sourceAri,
                sourceProduct: sourceInfo === null || sourceInfo === void 0 ? void 0 : sourceInfo.productType
            }),
            variant: 'source'
        } : undefined
    });
};
class $f82e97b965cd680f$export$e287a7d211075664 {
    constructor(node, view, getPos, api, nodeViewPortalProviderAPI, sourceManager){
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.api = api;
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- NodeView serialization must target active runtime document
        const { dom: dom, contentDOM: contentDOM } = (0, $kW8qW.DOMSerializer).renderSpec(document, $f82e97b965cd680f$var$toDOM(this.node));
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = dom;
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        // Render the label into a separate container so portal implementations that
        // write directly into the target do not clobber contentDOM. This also covers
        // SSR, where the portal's renderToStaticMarkup + innerHTML would clobber it.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- NodeView DOM must be created against active runtime document
        const labelContainer = document.createElement('div');
        this.dom.appendChild(labelContainer);
        this.labelKey = crypto.randomUUID();
        this.nodeViewPortalProviderAPI.render(()=>{
            var _this$api;
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $iUiGU.ErrorBoundary), {
                component: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
                componentId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_LABEL,
                dispatchAnalyticsEvent: (_this$api = this.api) === null || _this$api === void 0 || (_this$api = _this$api.analytics) === null || _this$api === void 0 ? void 0 : _this$api.actions.fireAnalyticsEvent,
                fallbackComponent: null,
                children: /*#__PURE__*/ (0, $dc70d.jsx)($f82e97b965cd680f$export$520fa575be2f7d06, {
                    localId: node.attrs.localId,
                    resourceId: node.attrs.resourceId,
                    sourceManager: sourceManager
                })
            });
        }, labelContainer, this.labelKey);
        this.updateContentEditable({});
        this.updateEmptyClass();
        this.handleConnectivityModeChange();
        this.handleViewModeChange();
    // Cache is populated in state.init() and updated in appendTransaction,
    // so no additional updateSyncBlockData call is needed here.
    }
    updateContentEditable({ nextConnectivityMode: nextConnectivityMode, nextViewMode: nextViewMode }) {
        var _this$api2, _this$api3;
        const connectivityMode = nextConnectivityMode ?? ((_this$api2 = this.api) === null || _this$api2 === void 0 || (_this$api2 = _this$api2.connectivity) === null || _this$api2 === void 0 || (_this$api2 = _this$api2.sharedState) === null || _this$api2 === void 0 || (_this$api2 = _this$api2.currentState()) === null || _this$api2 === void 0 ? void 0 : _this$api2.mode);
        const viewMode = nextViewMode ?? ((_this$api3 = this.api) === null || _this$api3 === void 0 || (_this$api3 = _this$api3.editorViewMode) === null || _this$api3 === void 0 || (_this$api3 = _this$api3.sharedState) === null || _this$api3 === void 0 || (_this$api3 = _this$api3.currentState()) === null || _this$api3 === void 0 ? void 0 : _this$api3.mode);
        const isOnline = !(0, $hVGJk.isOfflineMode)(connectivityMode);
        const isEditMode = viewMode !== 'view';
        const shouldBeEditable = isOnline && isEditMode;
        this.contentDOM.setAttribute('contenteditable', shouldBeEditable ? 'true' : 'false');
    }
    handleConnectivityModeChange() {
        var _this$api4;
        if ((_this$api4 = this.api) !== null && _this$api4 !== void 0 && _this$api4.connectivity) this.cleanupConnectivityModeListener = this.api.connectivity.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            this.updateContentEditable({
                nextConnectivityMode: nextSharedState.mode
            });
        });
    }
    handleViewModeChange() {
        var _this$api5;
        if ((_this$api5 = this.api) !== null && _this$api5 !== void 0 && _this$api5.editorViewMode) this.cleanupViewModeListener = this.api.editorViewMode.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            this.updateContentEditable({
                nextViewMode: nextSharedState === null || nextSharedState === void 0 ? void 0 : nextSharedState.mode
            });
        });
    }
    /**
   * Marks the block as empty so the source placeholder can be shown purely from document state.
   * See `isEmptySourceSyncBlock` for why the DOM is not used to decide this.
   */ updateEmptyClass() {
        this.dom.classList.toggle((0, $7VlAB.BodiedSyncBlockSharedCssClassName).empty, (0, $8rMkM.isEmptySourceSyncBlock)(this.node));
    }
    update(node) {
        if (this.node.type !== node.type) return false;
        // Cache updates are handled in appendTransaction where we can
        // filter out non-user changes (remote collab, table auto-scale, etc.)
        this.node = node;
        this.updateEmptyClass();
        return true;
    }
    ignoreMutation(mutation) {
        if (mutation.type === 'selection') return false;
        return true;
    }
    destroy() {
        var _this$cleanupConnecti, _this$cleanupViewMode;
        (_this$cleanupConnecti = this.cleanupConnectivityModeListener) === null || _this$cleanupConnecti === void 0 || _this$cleanupConnecti.call(this);
        (_this$cleanupViewMode = this.cleanupViewModeListener) === null || _this$cleanupViewMode === void 0 || _this$cleanupViewMode.call(this);
        this.nodeViewPortalProviderAPI.remove(this.labelKey);
    }
}
const $f82e97b965cd680f$export$89bdce39123f4223 = (props)=>{
    const { api: api, pmPluginFactoryParams: { nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }, syncBlockStore: syncBlockStore } = props;
    return (node, view, getPos)=>{
        return new $f82e97b965cd680f$export$e287a7d211075664(node, view, getPos, api, nodeViewPortalProviderAPI, syncBlockStore === null || syncBlockStore === void 0 ? void 0 : syncBlockStore.sourceManager);
    };
};

});
parcelRegister("ceB3S", function(module, exports) {
$parcel$export(module.exports, "getUnpublishedSourceType", () => $6845d77f55d19643$export$214d9e923056baaa);
const $6845d77f55d19643$export$214d9e923056baaa = ({ sourceAri: sourceAri, sourceProduct: sourceProduct })=>{
    if (sourceProduct === 'jira-work-item' || sourceAri !== null && sourceAri !== void 0 && sourceAri.startsWith('ari:cloud:jira:')) return 'jiraWorkItem';
    if (sourceAri !== null && sourceAri !== void 0 && sourceAri.includes(':blogpost/')) return 'blog';
    return 'page';
};

});

parcelRegister("b3tcA", function(module, exports) {
$parcel$export(module.exports, "SyncBlockLabel", () => $daf7ef2d76f0f05e$export$af6d83e4f9d69ba5);
/* SyncBlockLabel.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $9dhQr = parcelRequire("9dhQr");

var $7VlAB = parcelRequire("7VlAB");

var $539NH = parcelRequire("539NH");

var $9PwDt = parcelRequire("9PwDt");

var $8aT4G = parcelRequire("8aT4G");

var $lavtv = parcelRequire("lavtv");

var $9Abbn = parcelRequire("9Abbn");

var $kymC5 = parcelRequire("kymC5");
const $daf7ef2d76f0f05e$var$SyncBlockLabelDataId = 'sync-block-label';
const $daf7ef2d76f0f05e$var$styles = {
    truncatedLabelText: "_11c8wadc _1reo15vq _18m915vq _syazazsu _1ul9idpf _1bto1l2s _o5721q9c",
    unpublishedSuffix: "_11c8wadc _syazazsu _1o9zidpf _o5721q9c"
};
const $daf7ef2d76f0f05e$var$SyncBlockLabelComponent = ({ contentUpdatedAt: contentUpdatedAt, isSource: isSource, localId: localId, title: title, isUnsyncedBlock: isUnsyncedBlock, unpublishedInfo: unpublishedInfo })=>{
    const intl = (0, $4vLTk.default)();
    const { formatMessage: formatMessage } = intl;
    const [tooltipContent, setTooltipContent] = (0, $bSJIT.useState)(formatMessage((0, $9dhQr.syncBlockMessages).defaultSyncBlockTooltip));
    let tooltipMessage = formatMessage((0, $9dhQr.syncBlockMessages).defaultSyncBlockTooltip);
    if (title) tooltipMessage = formatMessage((0, $9dhQr.syncBlockMessages).referenceSyncBlockTooltip, {
        title: title
    });
    const updateTooltipContent = (0, $bSJIT.useCallback)(()=>{
        let tooltipContent = tooltipMessage;
        if (contentUpdatedAt) {
            const elapsedTime = (0, $kymC5.formatElapsedTime)(contentUpdatedAt, intl);
            tooltipContent = /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
                children: [
                    title ? /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                                size: "small",
                                color: "color.text.inverse",
                                weight: "bold",
                                children: formatMessage((0, $9dhQr.syncBlockMessages).referenceSyncBlockSyncedFrom)
                            }),
                            /*#__PURE__*/ (0, $dc70d.jsxs)((0, $8aT4G.Text), {
                                size: "small",
                                color: "color.text.inverse",
                                children: [
                                    ' ',
                                    title
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                        size: "small",
                        color: "color.text.inverse",
                        children: tooltipMessage
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)("br", {}),
                    /*#__PURE__*/ (0, $dc70d.jsx)("br", {}),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                        size: "small",
                        color: "color.text.inverse",
                        weight: "bold",
                        children: formatMessage((0, $9dhQr.syncBlockMessages).referenceSyncBlockLastEdited)
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsxs)((0, $8aT4G.Text), {
                        size: "small",
                        color: "color.text.inverse",
                        children: [
                            ' ',
                            elapsedTime
                        ]
                    })
                ]
            });
        }
        setTooltipContent(tooltipContent);
    }, [
        contentUpdatedAt,
        formatMessage,
        intl,
        title,
        tooltipMessage
    ]);
    const ariaDescribedById = `sync-block-label-description-${localId}`;
    const unpublishedParenthetical = unpublishedInfo ? formatMessage((0, $9dhQr.syncBlockMessages).unpublishedInParentheses) : undefined;
    const getLabelContent = (0, $bSJIT.useMemo)(()=>{
        // The parenthetical carries a leading space so the accessible name and copied text read as
        // "… (unpublished)". Flex trims it visually, and the label's own gap provides the spacing.
        const renderUnpublishedLabel = (label)=>/*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                        as: "span",
                        xcss: $daf7ef2d76f0f05e$var$styles.truncatedLabelText,
                        children: label
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                        as: "span",
                        xcss: $daf7ef2d76f0f05e$var$styles.unpublishedSuffix,
                        children: ` ${unpublishedParenthetical}`
                    })
                ]
            });
        const renderPlainLabel = (label)=>unpublishedParenthetical ? renderUnpublishedLabel(label) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                size: "small",
                color: "color.text.subtle",
                children: label
            });
        const renderTruncatingTitle = (label)=>unpublishedParenthetical ? renderUnpublishedLabel(label) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                maxLines: 1,
                size: "small",
                color: "color.text.subtle",
                children: label
            });
        if (isUnsyncedBlock) return renderPlainLabel(formatMessage((0, $9dhQr.syncBlockMessages).unsyncedBlockLabel));
        if (isSource) return renderPlainLabel(formatMessage((0, $9dhQr.syncBlockMessages).sourceSyncedBlockLabel));
        if (!title) return renderPlainLabel(formatMessage((0, $9dhQr.syncBlockMessages).syncedBlockLabel));
        return renderTruncatingTitle(title);
    }, [
        formatMessage,
        isSource,
        isUnsyncedBlock,
        title,
        unpublishedParenthetical
    ]);
    const unpublishedTooltipLabel = unpublishedInfo ? formatMessage(unpublishedInfo.variant === 'source' ? (0, $9dhQr.syncBlockMessages).unpublishedSourceAvailabilityTooltip : (0, $9dhQr.syncBlockMessages).unpublishedLocalReferenceAvailabilityTooltip, {
        sourceType: unpublishedInfo.sourceType
    }) : undefined;
    const primaryLabel = /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
        "data-testid": $daf7ef2d76f0f05e$var$SyncBlockLabelDataId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $7VlAB.SyncBlockLabelSharedCssClassName).labelClassName,
        "aria-describedby": isSource || isUnsyncedBlock ? undefined : ariaDescribedById,
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($539NH))), {
                color: "var(--ds-icon-subtle, #505258)",
                size: "small",
                label: ""
            }),
            getLabelContent
        ]
    });
    const referenceDescription = !isSource && !isUnsyncedBlock && /*#__PURE__*/ (0, $dc70d.jsx)((0, $9Abbn.default), {
        id: ariaDescribedById,
        children: tooltipMessage
    });
    if (unpublishedTooltipLabel) return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $lavtv.default), {
        position: "top",
        content: unpublishedTooltipLabel,
        children: [
            primaryLabel,
            referenceDescription
        ]
    });
    if (isSource || isUnsyncedBlock) return primaryLabel;
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $lavtv.default), {
        position: "top",
        content: tooltipContent,
        // workaround because tooltip adds aria-describedby with a new id every time the tooltip is opened
        // this causes an infinite rerender loop because of the forwardRef from the node view we are inside in bodiedSyncBlock
        // tooltip content is available for screen readers in visually hidden content after the label
        isScreenReaderAnnouncementDisabled: true,
        // using this to ensure that the 'last edited' time is updated when the tooltip is opened
        onShow: updateTooltipContent,
        children: [
            primaryLabel,
            referenceDescription
        ]
    });
};
const $daf7ef2d76f0f05e$export$af6d83e4f9d69ba5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo($daf7ef2d76f0f05e$var$SyncBlockLabelComponent);

});
parcelRegister("9dhQr", function(module, exports) {
$parcel$export(module.exports, "syncBlockMessages", () => $c95af0cbfd330dd7$export$254768729b492c8b);

var $f0Pt4 = parcelRequire("f0Pt4");
const $c95af0cbfd330dd7$export$254768729b492c8b = (0, $f0Pt4.defineMessages)({
    copySyncBlockLabel: {
        id: 'fabric.editor.copySyncBlock',
        defaultMessage: 'Copy',
        description: 'Button label for copying the reference of sync block element to your clipboard'
    },
    copySyncedBlockTooltip: {
        id: 'fabric.editor.copySyncedBlockTooltip',
        defaultMessage: 'Copy synced block',
        description: 'Tooltip for the button to copy synced block element '
    },
    copyToSyncLabel: {
        id: 'fabric.editor.copyToSyncLabel',
        defaultMessage: 'Copy to sync',
        description: 'Button label for the primary action that copies a synced block reference to your clipboard so it can be reused (synced) somewhere else'
    },
    editSourceLabel: {
        id: 'fabric.editor.editSourceLabel',
        defaultMessage: 'Edit source',
        description: 'Button label for editing the source of sync block element'
    },
    editSourceTooltip: {
        id: 'fabric.editor.editSourceTooltipEnabled',
        defaultMessage: 'Edit synced content at source location',
        description: 'Tooltip for the button to navigate to the source page of the sync block element'
    },
    editSourceTooltipDisabled: {
        id: 'fabric.editor.editSourceTooltipDisabled',
        defaultMessage: 'Source link is not currently available',
        description: 'Tooltip for the button to navigate to the source page, when URL is not available'
    },
    syncBlockGroup: {
        id: 'fabric.editor.syncBlockGroup',
        defaultMessage: 'Sync Block Types',
        description: 'aria-label for group of sync block the floating toolbar'
    },
    syncedBlockLabel: {
        id: 'fabric.editor.syncedBlock.label.text',
        defaultMessage: 'Synced block',
        description: 'Label which appears above the synced block when it is selected'
    },
    sourceSyncedBlockLabel: {
        id: 'fabric.editor.sourceSyncedBlock.label.text',
        defaultMessage: 'Source synced block',
        description: 'Label which identifies the editable source synced block when it is selected'
    },
    unsyncedBlockLabel: {
        id: 'fabric.editor.unsyncedBlock.label.text',
        defaultMessage: 'Unsynced block',
        description: 'Label which appears above the unsynced block when it is selected'
    },
    permissionDeniedHeading: {
        id: 'fabric.editor.syncedBlockPermissionDeniedHeading',
        defaultMessage: 'Request access to view synced block',
        description: 'Heading for error state where the user does not have permission to view the synced block'
    },
    permissionDeniedDescription: {
        id: 'fabric.editor.syncedBlockPermissionDeniedDescription',
        defaultMessage: "You don't have access to view the source content of this synced block.",
        description: 'Description for error state where the user does not have permission to view the synced block'
    },
    contentUnavailableHeading: {
        id: 'editor-common.messages.syncBlock.contentUnavailableHeading',
        defaultMessage: 'This synced content is unavailable.',
        description: 'Heading shown when synced content is unavailable due to deletion or permissions'
    },
    contentUnavailableDescription: {
        id: 'editor-common.messages.syncBlock.contentUnavailableDescription',
        defaultMessage: 'The source might be deleted, or you may not have permission to view it.',
        description: 'Explains that synced source content may be deleted or inaccessible to the current user'
    },
    permissionDeniedAltText: {
        id: 'fabric.editor.syncedBlockPermissionDeniedIconAltText',
        defaultMessage: 'Permission denied.',
        description: 'Alt text for icon on error state where the user does not have permission to view the synced block'
    },
    requestAccessButton: {
        id: 'fabric.editor.requestAccessToSyncedBlock',
        defaultMessage: 'Request access',
        description: 'Label for button which requests access to view the source page of the sync block'
    },
    accessRequested: {
        id: 'fabric.editor.accessToSyncedBlockRequested',
        defaultMessage: 'Access requested',
        description: 'Text which displays after the request to view the source page of the sync block has been sent and is still pending'
    },
    requestAccessError: {
        id: 'fabric.editor.requestAccessToSyncedBlockError',
        defaultMessage: 'Something went wrong. Click to try again',
        description: 'Text which displays next to the request access button after something went wrong after clicking the button.'
    },
    sourceSyncBlockTooltip: {
        id: 'fabric.editor.sourceSyncBlockTooltip',
        defaultMessage: 'When you edit this source block it will update across synced locations.',
        description: 'Description in tooltip which appears when you hover over the synced block label'
    },
    defaultSyncBlockTooltip: {
        id: 'fabric.editor.sourceSyncBlockTooltip',
        defaultMessage: 'Synced block',
        description: "Description in tooltip which appears when we haven't been able to fetch other information about the sync block"
    },
    referenceSyncBlockTooltip: {
        id: 'fabric.editor.referenceSyncBlockTooltip',
        defaultMessage: 'Synced from: {title}',
        description: 'Tooltip that shows the source page title of the synced block'
    },
    unpublishedLocalReferenceAvailabilityTooltip: {
        id: 'editor-common.messages.syncBlock.unpublishedLocalReferenceAvailabilityTooltip',
        defaultMessage: '{sourceType, select, page {Publish the page to make the source synced block content available in other locations.} blog {Publish the blog to make the source synced block content available in other locations.} jiraWorkItem {Publish the work item to make the source synced block content available in other locations.} other {Publish to make the source synced block content available in other locations.}}',
        description: 'Tooltip explaining that a local unpublished reference is only available in its source document. sourceType selects page, blog, or Jira work item copy.'
    },
    unpublishedSourceAvailabilityTooltip: {
        id: 'editor-common.messages.syncBlock.unpublishedSourceAvailabilityTooltip',
        defaultMessage: '{sourceType, select, page {Publish the page to make the content available in other locations.} blog {Publish the blog to make the content available in other locations.} jiraWorkItem {Publish the work item to make the content available in other locations.} other {Publish to make the content available in other locations.}}',
        description: 'Tooltip explaining that an unpublished source synced block is only available in its source document. sourceType selects page, blog, or Jira work item copy.'
    },
    referenceSyncBlockLastEdited: {
        id: 'fabric.editor.referenceSyncBlockLastEdited',
        defaultMessage: 'Last edited:',
        description: 'Tooltip that shows the last edited time of the synced block'
    },
    referenceSyncBlockSyncedFrom: {
        id: 'fabric.editor.referenceSyncBlockSyncedFrom',
        defaultMessage: 'Synced from:',
        description: 'Bold heading label in the tooltip showing the source page of the synced block'
    },
    taskInDestinationSyncedBlockTooltip: {
        id: 'fabric.editor.taskInDestinationSyncedBlockTooltip',
        defaultMessage: 'This content is synced. Edit it at the source.',
        description: 'Tooltip that shows when you hover over a task in the destination synced block'
    },
    deletionConfirmationModalTitleSingle: {
        id: 'fabric.editor.deletionConfirmationModalTitleSingle',
        defaultMessage: 'Delete synced content?',
        description: 'Title of delete confirmation modal that appears when user tries to delete source synced block that has no reference'
    },
    deleteConfirmationModalTitleMultiple: {
        id: 'fabric.editor.deleteConfirmationModalTitleMultiple',
        defaultMessage: 'Delete content in {count, plural, one {1 location} other {# locations}}?',
        description: 'Title of delete confirmation modal that appears when user tries to delete source synced block that has references'
    },
    deleteConfirmationModalCancelButton: {
        id: 'fabric.editor.deleteConfirmationModalCancelButton',
        defaultMessage: 'Cancel',
        description: 'Text on button which cancels deleting when user was trying to delete source synced block'
    },
    deleteConfirmationModalDeleteButton: {
        id: 'fabric.editor.deleteConfirmationModalDeleteButton',
        defaultMessage: 'Delete',
        description: 'Text on button which confirms deleting the sync block when user was trying to delete source synced block'
    },
    deleteRetryButton: {
        id: 'fabric.editor.deleteConfirmationModalRetryButton',
        defaultMessage: 'Try again',
        description: 'Text on button which retries deleting the sync block when the previous deletion failed'
    },
    deletionConfirmationModalDescription: {
        id: 'fabric.editor.deletionConfirmationModalDescription',
        defaultMessage: "If you delete this synced block, it will become an \u201CUnsynced block\u201D in other locations. This action is permanent and cannot be undone.",
        description: 'Description of delete confirmation modal that appears when user tries to delete source synced block'
    },
    deletionConfirmationModalDescriptionNew: {
        id: 'fabric.editor.deletionConfirmationModalDescriptionNew',
        defaultMessage: 'If you delete this synced block, it will appear as an empty "Unsynced block" in {syncBlockCount, plural, one {1 other synced location} other {# locations}}. This action is permanent and cannot be undone.',
        description: 'Description of delete confirmation modal that appears when user tries to delete source synced block with multiple references'
    },
    deletionConfirmationModalDescriptionReferenceCount: {
        id: 'fabric.editor.deletionConfirmationModalDescriptionReferenceCount',
        defaultMessage: 'If you delete this source synced block, it will appear as an empty "Unsynced block" in {syncBlockCount, plural, one {1 other synced location} other {# other synced locations}}. This action is permanent and cannot be undone.',
        description: 'Description of delete confirmation modal that explains how many references remain after deleting the source synced block'
    },
    deletionConfirmationModalDescriptionNoRef: {
        id: 'fabric.editor.deletionConfirmationModalDescriptionNoRef',
        defaultMessage: 'Your content will no longer appear, and the synced block will be deleted. This action is permanent and cannot be undone.',
        description: 'Description of delete confirmation modal that appears when user tries to delete source synced block'
    },
    createSyncBlockLabel: {
        id: 'fabric.editor.createSyncBlockLabel',
        defaultMessage: 'Create synced block',
        description: 'Label for button which creates a new synced block'
    },
    syncBlockLabel: {
        id: 'fabric.editor.syncBlockLabel',
        defaultMessage: 'Sync block',
        description: 'Short label for button which creates a new synced block'
    },
    newLozenge: {
        id: 'fabric.editor.syncBlock.toolbar.newLozenge',
        defaultMessage: 'New',
        description: 'Text in lozenge that appears next to the create synced block button in the toolbar dropdown menu to show that it is a new feature'
    },
    failToDeleteTitle: {
        id: 'fabric.editor.error.title.failToDelete',
        defaultMessage: 'Failed to delete',
        description: 'Title in flag which appears when a sync block cannot be deleted'
    },
    failToDeleteWhenOfflineDescription: {
        id: 'fabric.editor.error.description.failToDeleteWhenOffline',
        defaultMessage: 'You appear to be offline. Please connect to the internet to delete synced content.',
        description: 'Description in flag which appears when a sync block cannot be deleted in offline mode'
    },
    cannotDeleteTitle: {
        id: 'fabric.editor.error.flag.title.cannotDelete',
        defaultMessage: 'Failed to delete synced block',
        description: 'Title in flag which appears when a sync block cannot be deleted'
    },
    cannotDeleteDescription: {
        id: 'fabric.editor.error.description.cannotDelete',
        defaultMessage: 'An error occurred while trying to delete this synced block. ',
        description: 'Description in flag which appears when a sync block fails to be deleted'
    },
    failToEditTitle: {
        id: 'fabric.editor.error.title.failToEdit',
        defaultMessage: 'Cannot edit synced content offline',
        description: 'Title in flag which appears when a sync block cannot be edited'
    },
    failToEditWhenOfflineDescription: {
        id: 'fabric.editor.error.description.failToEditWhenOffline',
        defaultMessage: 'You appear to be offline. Please connect to the internet to edit synced content.',
        description: 'Description in flag which appears when a sync block cannot be edited in offline mode'
    },
    failToCreateTitle: {
        id: 'fabric.editor.error.title.failToCreate',
        defaultMessage: 'Cannot create synced content offline',
        description: 'Title in flag which appears when a sync block cannot be created'
    },
    failToCreateWhenOfflineDescription: {
        id: 'fabric.editor.error.description.failToCreateWhenOffline',
        defaultMessage: 'You appear to be offline. Please connect to the internet to create synced content.',
        description: 'Description in flag which appears when a sync block cannot be created in offline mode'
    },
    feedbackFlagTitle: {
        id: 'editor-common.messages.syncBlock.feedbackFlagTitle',
        defaultMessage: 'Help us improve Synced blocks',
        description: 'Title of the flag inviting users to give feedback about synced blocks'
    },
    feedbackFlagDescription: {
        id: 'editor-common.messages.syncBlock.feedbackFlagDescription',
        defaultMessage: "We\u2019d love your feedback. This quick survey should take less than a minute.",
        description: 'Description of the flag inviting users to give feedback about synced blocks'
    },
    feedbackFlagGiveFeedback: {
        id: 'editor-common.messages.syncBlock.feedbackFlagGiveFeedback',
        defaultMessage: 'Give feedback',
        description: 'Action that opens the synced blocks feedback collector'
    },
    feedbackFlagNoThanks: {
        id: 'editor-common.messages.syncBlock.feedbackFlagNoThanks',
        defaultMessage: 'No thanks',
        description: 'Action that dismisses the synced blocks feedback invitation'
    },
    loadingSyncedContent: {
        id: 'fabric.editor.syncedBlockLoadingSyncedContent',
        defaultMessage: 'Loading synced content',
        description: 'Accessible label for the loading spinner shown while synced block content is being fetched'
    },
    generalErrorDescription: {
        id: 'fabric.editor.syncedBlockGeneralErrorDescription',
        defaultMessage: `We're unable to display this content at the moment.`,
        description: 'Description for general error state of the synced block'
    },
    notFoundAltText: {
        id: 'fabric.editor.syncedBlockNotFoundIconAltText',
        defaultMessage: 'Synced block not found.',
        description: 'Alt text for icon on error state where the synced block cannot be found or no longer exists'
    },
    notFoundDescription: {
        id: 'fabric.editor.syncedBlockNotFoundDescription.non-final',
        defaultMessage: "We're unable to display this content as its source has been deleted or archived.",
        description: 'Description for error state where the synced block cannot be found'
    },
    sourceUnsyncedDescription: {
        id: 'fabric.editor.syncedBlockSourceUnsyncedDescription',
        defaultMessage: "We're unable to display this content as it's been unsynced from <a>{title}</a>.",
        description: 'Description for error state where the synced block has its source unsynced'
    },
    sourceDeletedDescription: {
        id: 'fabric.editor.syncedBlockSourceDeletedDescription',
        defaultMessage: "We're unable to display this content as it's been deleted from <a>{title}</a>.",
        description: 'Description for error state where the synced block has its source unsynced'
    },
    entityNotFoundDescription: {
        id: 'fabric.editor.syncedBlockEntityNotFoundDescription',
        defaultMessage: "We're unable to display this synced block as it's not available on this site. <link>Learn more</link>",
        description: 'Description for error state where the synced block does not exist on this site (e.g. cross-site reference or hard deleted)'
    },
    genericNotFoundDescription: {
        id: 'fabric.editor.syncedBlockGenericNotFoundDescription',
        defaultMessage: "We're unable to display this synced content as it's been deleted or unsynced.",
        description: 'Description for error state where the synced block has its source unsynced or deleted'
    },
    retryButton: {
        id: 'fabric.editor.retrySyncedBlock',
        defaultMessage: 'Try again',
        description: 'Label for button which retries loading the synced block'
    },
    offlineError: {
        id: 'fabric.editor.error.description.reference.offline',
        defaultMessage: `We're unable to display synced blocks when you're offline`,
        description: 'Error message which is shown over sync block when the editor is offline'
    },
    unpublishedError: {
        id: 'fabric.editor.error.description.reference.unpublished',
        defaultMessage: 'Synced content will display <link>when the page is published</link>',
        description: 'Error message which is shown over sync block when the source page is unpublished.'
    },
    unpublishedInParentheses: {
        id: 'editor-common.messages.syncBlock.unpublishedInParentheses',
        defaultMessage: '(unpublished)',
        description: 'Parenthetical appended to a synced-block label when the source document is unpublished'
    },
    unpublishedErrorJiraWorkItem: {
        id: 'fabric.editor.error.description.reference.unpublished.jiraWorkItem',
        defaultMessage: "Synced content will display <link>when the item's description is saved</link>",
        description: 'Error message which is shown over sync block when the source Jira work item description has not yet been saved.'
    },
    syncBlockCopiedTitle: {
        id: 'fabric.editor.syncBlockCopiedTitle',
        defaultMessage: 'Synced block copied to clipboard',
        description: 'Title in flag which appears when a sync block is copied'
    },
    syncBlockCopiedDescription: {
        id: 'fabric.editor.syncBlockCopiedDescription',
        defaultMessage: 'Paste your synced block to keep content auto-updated. Permissions are the same.',
        description: 'Description in flag which appears when a sync block is copied'
    },
    syncBlockCopiedJiraUnsavedFieldDescription: {
        id: 'editor-common.messages.syncBlock.syncBlockCopiedJiraUnsavedFieldDescription.ai-non-final',
        defaultMessage: 'To reuse this content, save this field and paste this synced block in another location.',
        description: 'Instruction in a confirmation flag after a synced block is copied from an unsaved Jira work item field.'
    },
    syncBlockCopiedLivePageDescription: {
        id: 'editor-common.messages.syncBlock.syncBlockCopiedLivePageDescription',
        defaultMessage: 'Paste this synced block content in another location to reuse its content.',
        description: 'Instruction in a confirmation flag after a synced block with published content is copied from a live page.'
    },
    syncBlockCopiedUnpublishedDescription: {
        id: 'editor-common.messages.syncBlock.syncBlockCopiedUnpublishedDescription',
        defaultMessage: 'To reuse this content, publish this page and paste this synced block in another location.',
        description: 'Instruction in a confirmation flag after a synced block with unpublished content is copied from a classic page.'
    },
    syncBlockCopiedAction: {
        id: 'fabric.editor.syncBlockCopiedAction',
        defaultMessage: 'Learn more',
        description: 'Action in flag which appears when a sync block is copied to learn more'
    },
    syncedLocationDropdownTitle: {
        id: 'fabric.editor.syncedLocationDropdownTitle',
        defaultMessage: 'Synced locations',
        description: 'Title for the dropdown menu that shows the synced (referenced) locations of the source sync block'
    },
    syncedLocationDropdownTitleWithCount: {
        id: 'fabric.editor.syncedLocationDropdownTitleWithCount.ai-non-final',
        defaultMessage: 'Synced locations ({count})',
        description: 'Toolbar button label that shows the number of references to the selected synced block.'
    },
    syncedLocationDropdownLoading: {
        id: 'fabric.editor.syncedLocationDropdownLoading.ai-non-final',
        defaultMessage: 'Loading synced locations',
        description: 'Accessible label for the spinner while synced locations are loading.'
    },
    syncedLocationDropdownNoReferencesTooltip: {
        id: 'editor-common.messages.syncBlock.syncedLocationDropdownNoReferencesTooltip.ai-non-final',
        defaultMessage: 'Not yet synced to any other locations',
        description: 'Tooltip for the synced locations toolbar button when the selected synced block has no references.'
    },
    syncedLocationDropdownHeading: {
        id: 'fabric.editor.syncedLocationDropdownHeading',
        defaultMessage: '{count} locations:',
        description: 'Heading for the dropdown menu that shows the synced (referenced) locations of the source sync block'
    },
    syncedLocationDropdownError: {
        id: 'fabric.editor.syncedLocationDropdownError',
        defaultMessage: "We can't load locations right now. Please wait a few minutes and refresh your browser.",
        description: 'Error message shown in the synced location dropdown menu when fail to fetch the synced (referenced) locations of the source sync block'
    },
    syncedLocationDropdownNoResults: {
        id: 'fabric.editor.syncedLocationDropdownNoResults',
        defaultMessage: 'Copy and paste synced blocks to reuse in other locations.',
        description: 'Message shown in the synced location dropdown menu when no shared locations are found'
    },
    syncedLocationDropdownActivationNoResults: {
        id: 'editor-common.messages.syncBlock.syncedLocationDropdownActivationNoResults',
        defaultMessage: 'To reuse content, copy and paste this block to sync to other locations',
        description: 'Instruction shown in the activation synced locations dropdown when a synced block has no references. It explains how to create the first reference.'
    },
    syncedLocationDropdownLearnMoreLink: {
        id: 'fabric.editor.syncedLocationDropdownLearnMoreLink',
        defaultMessage: 'Learn more about synced blocks',
        description: 'Link shown in the synced location dropdown menu to learn more about synced blocks'
    },
    syncedLocationDropdownSamePage: {
        id: 'fabric.editor.syncedLocationDropdownSamePage',
        defaultMessage: 'This page',
        description: 'Message shown in the synced location dropdown option when the reference sync block is on the same page'
    },
    syncedLocationDropdownTitleBlockIndex: {
        id: 'fabric.editor.syncedLocationDropdownTitleNote',
        defaultMessage: 'block {index}',
        description: 'Suffix for page title shown in synced location dropdown option when there are multiple references to the same page'
    },
    syncedLocationDropdownTitleNoteForConfluencePage: {
        id: 'fabric.editor.syncedLocationDropdownTitleNoteForConfluencePage',
        defaultMessage: 'This page',
        description: 'Note shown next to the page title in the synced location dropdown option when the sync block is on the current page'
    },
    syncedLocationDropdownTitleNoteForJiraWorkItem: {
        id: 'fabric.editor.syncedLocationDropdownTitleNoteForJiraWorkItem',
        defaultMessage: 'This work item',
        description: 'Note shown next to the work item title in the synced location dropdown option when the sync block is on the current work item'
    },
    syncedLocationDropdownTitleNoteForJiraWorkItemField: {
        id: 'fabric.editor.syncedLocationDropdownTitleNoteForJiraWorkItemField',
        defaultMessage: 'This work item field',
        description: 'Note shown next to the work item title in the synced location dropdown option when the sync block is in the same field of the current work item'
    },
    syncedLocationDropdownTooltipFieldName: {
        id: 'fabric.editor.syncedLocationDropdownTooltipFieldName',
        defaultMessage: 'Field: {fieldName}',
        description: 'Second line of the tooltip on a synced location dropdown option, naming the Jira work item field that holds the sync block'
    },
    syncedLocationDropdownSourceLozenge: {
        id: 'fabric.editor.syncedLocationDropdownSourceLozenge',
        defaultMessage: 'Source',
        description: 'Lozenge label shown in the synced location dropdown option when the sync block is source'
    },
    syncedLocationDropdownRequestAccess: {
        id: 'fabric.editor.syncedLocationDropdownRequestAccess',
        defaultMessage: 'Request access',
        description: 'Label shown in the synced location dropdown option when the sync block is not accessible to the user'
    },
    syncedLocationDropdownRestrictedContent: {
        id: 'fabric.editor.syncedLocationDropdownRestrictedContent',
        defaultMessage: 'Restricted content',
        description: 'Title shown in the synced location dropdown in place of a page or work item the user does not have permission to view'
    },
    syncedLocationDropdownUntitledPage: {
        id: 'fabric.editor.syncedLocationDropdownUntitledPage',
        defaultMessage: 'Untitled',
        description: 'Placeholder title shown in the synced location dropdown when a page has no title yet'
    },
    // Accessible labels for the Jira issue-type icons rendered in the synced location
    // dropdown. Used as the `IconTile` `label` prop so screen readers announce the type.
    syncedLocationDropdownIssueTypeTask: {
        id: 'fabric.editor.syncedLocationDropdownIssueTypeTask',
        defaultMessage: 'Task',
        description: 'Accessible label for the Jira Task issue-type icon in the location dropdown'
    },
    syncedLocationDropdownIssueTypeBug: {
        id: 'fabric.editor.syncedLocationDropdownIssueTypeBug',
        defaultMessage: 'Bug',
        description: 'Accessible label for the Jira Bug issue-type icon in the location dropdown'
    },
    syncedLocationDropdownIssueTypeStory: {
        id: 'fabric.editor.syncedLocationDropdownIssueTypeStory',
        defaultMessage: 'Story',
        description: 'Accessible label for the Jira Story issue-type icon in the location dropdown'
    },
    syncedLocationDropdownIssueTypeEpic: {
        id: 'fabric.editor.syncedLocationDropdownIssueTypeEpic',
        defaultMessage: 'Epic',
        description: 'Accessible label for the Jira Epic issue-type icon in the location dropdown'
    },
    syncedLocationDropdownIssueTypeSubtask: {
        id: 'fabric.editor.syncedLocationDropdownIssueTypeSubtask',
        defaultMessage: 'Subtask',
        description: 'Accessible label for the Jira Subtask issue-type icon in the location dropdown'
    },
    syncedLocationDropdownIssueTypeGeneric: {
        id: 'fabric.editor.syncedLocationDropdownIssueTypeGeneric',
        defaultMessage: 'Jira work item',
        description: 'Accessible label for the generic Jira issue-type icon when the specific type is unknown'
    },
    unpublishedSyncBlockPastedTitle: {
        id: 'fabric.editor.unpublishedSyncBlockPastedTitle',
        defaultMessage: 'Pasted from unpublished page',
        description: 'Title in flag which appears when a reference to an unpublished sync block is pasted'
    },
    unpublishedSyncBlockPastedTitleJiraWorkItem: {
        id: 'fabric.editor.unpublishedSyncBlockPastedTitle.jiraWorkItem',
        defaultMessage: 'Pasted from unsaved item',
        description: 'Title in flag which appears when a reference to a sync block whose source is a Jira work item with an unsaved description is pasted'
    },
    unpublishedSyncBlockPastedDescription: {
        id: 'fabric.editor.unpublishedSyncBlockPastedDescription',
        defaultMessage: 'When the page is published, the content will be displayed.',
        description: 'Description in flag which appears when a reference to an unpublished sync block is pasted'
    },
    unpublishedSyncBlockPastedDescriptionJiraWorkItem: {
        id: 'fabric.editor.unpublishedSyncBlockPastedDescription.jiraWorkItem',
        defaultMessage: "<link>When the item's description is saved</link>, the content will be displayed.",
        description: 'Description in flag which appears when a reference to a sync block whose source is a Jira work item with an unsaved description is pasted. The first clause links to the source work item when its URL is known.'
    },
    unsyncButton: {
        id: 'fabric.editor.syncedBlock.unsync',
        defaultMessage: 'Unsync',
        description: 'Text on the button which unsyncs the sync block'
    },
    deleteConfirmationModalUnsyncButton: {
        id: 'fabric.editor.deleteConfirmationModalUnsyncButton',
        defaultMessage: 'Unsync',
        description: 'Text on button which confirms unsyncing the sync block when user was trying to unsync source synced block'
    },
    unsyncConfirmationModalTitle: {
        id: 'fabric.editor.unsyncConfirmationModalTitle',
        defaultMessage: 'Unsync this content?',
        description: 'Title of unsync confirmation modal that appears when user tries to unsync source synced block'
    },
    unsyncConfirmModalDescriptionSingle: {
        id: 'fabric.editor.unsyncConfirmModalDescriptionSingle',
        defaultMessage: 'Your content will stay here. It will no longer be a synced block. This action is permanent and cannot be undone.',
        description: 'Description of unsync confirmation modal that appears when user tries to unsync source synced block with no reference'
    },
    unsyncConfirmModalDescriptionMultiple: {
        id: 'fabric.editor.unsyncConfirmModalDescriptionMultiple',
        defaultMessage: 'Your content will stay here. In {syncBlockCount, plural, one {1 other synced location} other {# other synced locations}} it will appear as an "Unsynced block". This action is permanent and cannot be undone.',
        description: 'Description of unsync confirmation modal that appears when user tries to unsync source synced block with multiple references'
    },
    unsyncConfirmModalDescriptionMultipleNew: {
        id: 'fabric.editor.unsyncConfirmModalDescriptionMultipleNew',
        defaultMessage: 'Your content will stay here. In {syncBlockCount, plural, one {1 other synced location} other {# other synced locations}} it will appear as an empty "Unsynced block". This action is permanent and cannot be undone.',
        description: 'Description of unsync confirmation modal that appears when user tries to unsync source synced block with multiple references'
    },
    cannotPasteSyncedBlockTitle: {
        id: 'fabric.editor.cannotPasteSyncedBlockTitle',
        defaultMessage: 'Unable to paste',
        description: 'Title in flag which appears when a synced block cannot be pasted'
    },
    cannotPasteSyncedBlockDescription: {
        id: 'fabric.editor.cannotPasteSyncedBlockDescription',
        defaultMessage: "We\u2019re still building this feature. Currently, you can only paste synced content once your work item has been created. ",
        description: 'Description in flag which appears when a synced block cannot be pasted'
    },
    cannotPasteSyncedBlockUnsupportedDescription: {
        id: 'fabric.editor.cannotPasteSyncedBlockUnsupportedDescription',
        defaultMessage: `Sync blocks aren't supported here yet. `,
        description: 'Description in flag which appears when a synced block cannot be pasted'
    },
    cannotPasteSyncedBlockAction: {
        id: 'fabric.editor.cannotPasteSyncedBlockAction',
        defaultMessage: 'Learn more',
        description: 'Action in flag which appears when a synced block cannot be pasted to learn more'
    },
    cannotCreateSyncBlockTitle: {
        id: 'fabric.editor.cannotCreateSyncBlockTitle',
        defaultMessage: 'Unable to create synced block',
        description: 'Title in flag which appears when a synced block cannot be created'
    },
    CannotCreateSyncBlockDescription: {
        id: 'fabric.editor.cannotCreateSyncBlockDescription',
        defaultMessage: 'An error occurred while trying to create this synced block. ',
        description: 'Description in flag which appears when a synced block cannot be created'
    },
    inlineExtensionInSyncBlockTitle: {
        id: 'fabric.editor.inlineExtensionInSyncBlockTitle',
        defaultMessage: 'Some macros may not work when adding synced blocks to new locations',
        description: 'Title in flag which appears when an inline extension is inserted into a synced block'
    },
    inlineExtensionInSyncBlockDescription: {
        id: 'fabric.editor.inlineExtensionInSyncBlockDescription',
        defaultMessage: "This may happen if your synced block is used in places that don't support certain macros.",
        description: 'Description in flag which appears when an inline extension is inserted into a synced block'
    },
    extensionInSyncBlockTitle: {
        id: 'fabric.editor.extensionInSyncBlockTitle',
        defaultMessage: 'Some macros may not work when adding synced blocks to new locations',
        description: 'Title in flag which appears when an extension is inserted into a synced block'
    },
    extensionInSyncBlockDescription: {
        id: 'fabric.editor.extensionInSyncBlockDescription',
        defaultMessage: "This may happen if your synced block is used in places that don't support certain macros.",
        description: 'Description in flag which appears when an extension is inserted into a synced block'
    },
    duplicateSourceSyncBlockTitle: {
        id: 'fabric.editor.duplicateSourceSyncBlockTitle',
        defaultMessage: 'Duplicate synced block removed',
        description: 'Title in flag which appears when a duplicate source synced block is removed from the document'
    },
    duplicateSourceSyncBlockDescription: {
        id: 'fabric.editor.duplicateSourceSyncBlockDescription',
        defaultMessage: 'Only one source synced block per source is allowed on a page. Use a reference synced block to reuse this content.',
        description: 'Description in flag which appears when a duplicate source synced block is removed from the document'
    }
});

});

parcelRegister("539NH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eff989a0e96597135beb3c6f87bba46d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3ad4d5c77f15181b$var$_react = $3ad4d5c77f15181b$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $3ad4d5c77f15181b$var$_iconNew = $3ad4d5c77f15181b$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $3ad4d5c77f15181b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BlockSynced".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/block-synced
 * Usage guidance:
 * Reserved for syncing content blocks in Editor experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3ad4d5c77f15181b$var$BlockSyncedIcon = (props)=>/*#__PURE__*/ $3ad4d5c77f15181b$var$_react.default.createElement($3ad4d5c77f15181b$var$_iconNew.default, Object.assign({
        name: "BlockSyncedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h3V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2h-1.5z"/><path fill="currentcolor" d="M14.9 8.71a3.75 3.75 0 0 1 0 5.303l-.024.026.439.146a.75.75 0 0 1-.13 1.454l-2.476.354a.75.75 0 0 1-.848-.849l.353-2.474.029-.125a.75.75 0 0 1 1.425-.006l.147.44.025-.026a2.25 2.25 0 0 0 0-3.183l-.707-.707 1.06-1.06zm-3.818-1.98a.75.75 0 0 1 .85.849l-.354 2.475a.75.75 0 0 1-1.454.13l-.147-.44-.025.026a2.25 2.25 0 0 0 0 3.183l.707.707-1.06 1.06-.708-.707a3.75 3.75 0 0 1 0-5.303l.026-.026-.44-.146a.75.75 0 0 1 .13-1.454z"/>`
    }, props));
$3ad4d5c77f15181b$var$BlockSyncedIcon.displayName = 'BlockSyncedIcon';
var $3ad4d5c77f15181b$var$_default = module.exports.default = $3ad4d5c77f15181b$var$BlockSyncedIcon;

});

parcelRegister("kymC5", function(module, exports) {
$parcel$export(module.exports, "formatElapsedTime", () => $22a7bae9ce9a5196$export$49475f5c6fb1131c);

var $Rm7pg = parcelRequire("Rm7pg");
const $22a7bae9ce9a5196$var$SECONDS_IN_MINUTE = 60;
const $22a7bae9ce9a5196$var$SECONDS_IN_HOUR = $22a7bae9ce9a5196$var$SECONDS_IN_MINUTE * 60;
const $22a7bae9ce9a5196$var$SECONDS_IN_DAY = $22a7bae9ce9a5196$var$SECONDS_IN_HOUR * 24;
const $22a7bae9ce9a5196$var$SECONDS_IN_WEEK = $22a7bae9ce9a5196$var$SECONDS_IN_DAY * 7;
const $22a7bae9ce9a5196$var$SECONDS_IN_MONTH = $22a7bae9ce9a5196$var$SECONDS_IN_DAY * 30;
const $22a7bae9ce9a5196$var$SECONDS_IN_YEAR = $22a7bae9ce9a5196$var$SECONDS_IN_DAY * 365;
const $22a7bae9ce9a5196$export$49475f5c6fb1131c = (isoDate, intl)=>{
    const now = Date.now();
    const date = new Date(isoDate).getTime();
    const diffInSeconds = Math.floor((now - date) / 1000);
    const dateObj = new Date(isoDate);
    // Show "yesterday" when timestamp is from the previous calendar day
    if ((0, $Rm7pg.default)(dateObj) && diffInSeconds >= $22a7bae9ce9a5196$var$SECONDS_IN_DAY) return intl.formatRelativeTime(-1, 'day', {
        numeric: 'auto',
        style: 'long'
    });
    if (diffInSeconds < $22a7bae9ce9a5196$var$SECONDS_IN_MINUTE) return intl.formatRelativeTime(-Math.max(diffInSeconds, 1), 'second', {
        style: 'long'
    });
    else if (diffInSeconds < $22a7bae9ce9a5196$var$SECONDS_IN_HOUR) {
        const minutes = Math.floor(diffInSeconds / $22a7bae9ce9a5196$var$SECONDS_IN_MINUTE);
        return intl.formatRelativeTime(-minutes, 'minute', {
            style: 'long'
        });
    } else if (diffInSeconds < $22a7bae9ce9a5196$var$SECONDS_IN_DAY) {
        const hours = Math.floor(diffInSeconds / $22a7bae9ce9a5196$var$SECONDS_IN_HOUR);
        return intl.formatRelativeTime(-hours, 'hour', {
            style: 'long'
        });
    } else if (diffInSeconds < $22a7bae9ce9a5196$var$SECONDS_IN_WEEK) {
        const days = Math.floor(diffInSeconds / $22a7bae9ce9a5196$var$SECONDS_IN_DAY);
        return intl.formatRelativeTime(-days, 'day', {
            style: 'long'
        });
    } else if (diffInSeconds < $22a7bae9ce9a5196$var$SECONDS_IN_MONTH) {
        const weeks = Math.floor(diffInSeconds / $22a7bae9ce9a5196$var$SECONDS_IN_WEEK);
        return intl.formatRelativeTime(-weeks, 'week', {
            style: 'long'
        });
    } else if (diffInSeconds < $22a7bae9ce9a5196$var$SECONDS_IN_YEAR) {
        const months = Math.floor(diffInSeconds / $22a7bae9ce9a5196$var$SECONDS_IN_MONTH);
        return intl.formatRelativeTime(-months, 'month', {
            style: 'long'
        });
    } else {
        const years = Math.floor(diffInSeconds / $22a7bae9ce9a5196$var$SECONDS_IN_YEAR);
        return intl.formatRelativeTime(-years, 'year', {
            style: 'long'
        });
    }
};

});


parcelRegister("8rMkM", function(module, exports) {
$parcel$export(module.exports, "isEmptySourceSyncBlock", () => $6acf1e84e6aa3c11$export$9eec9bbd6569d309);
const $6acf1e84e6aa3c11$export$9eec9bbd6569d309 = (node)=>{
    if (node.childCount !== 1) return false;
    const firstChild = node.firstChild;
    return (firstChild === null || firstChild === void 0 ? void 0 : firstChild.type.name) === 'paragraph' && firstChild.content.size === 0;
};

});


parcelRegister("gmKcT", function(module, exports) {
$parcel$export(module.exports, "SyncBlock", () => $61f7a4be718a4cd1$export$5dd7fae087dd8061);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $iUiGU = parcelRequire("iUiGU");

var $0Xboy = parcelRequire("0Xboy");

var $7VlAB = parcelRequire("7VlAB");

var $3Z8vq = parcelRequire("3Z8vq");

var $cw0wu = parcelRequire("cw0wu");

var $3y2s4 = parcelRequire("3y2s4");

var $8hQqt = parcelRequire("8hQqt");

var $aPXdU = parcelRequire("aPXdU");

var $5oQeT = parcelRequire("5oQeT");
// Event types that should be intercepted (returned as handled) when they
// originate inside the sync block content area, so ProseMirror does not
// convert them into node-level selections or drag operations and the browser
// can perform native text selection/cut instead.
const $61f7a4be718a4cd1$var$STOPPED_EVENT_TYPES = [
    'mousedown',
    'mousemove',
    'mouseup',
    'click',
    'dblclick',
    'selectstart'
];
class $61f7a4be718a4cd1$export$5dd7fae087dd8061 extends (0, $0Xboy.default) {
    constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props), // Stable callback references — defined as arrow properties so they keep a
        // fixed identity across render() calls, avoiding defeats of React.memo.
        // The experiment gate lives in render(); these are always available.
        this.removeSyncBlockStable = ()=>{
            const pos = this.getPos();
            if (pos !== undefined) (0, $8hQqt.removeSyncedBlockAtPos)(this.api, pos);
        }, this.fetchSyncBlockSourceInfoStable = (sourceAri)=>{
            var _this$api;
            // store is guaranteed non-null: render() guards on syncBlockStore
            // before these callbacks can be invoked.
            const store = ((_this$api = this.api) === null || _this$api === void 0 || (_this$api = _this$api.syncedBlock) === null || _this$api === void 0 || (_this$api = _this$api.sharedState.currentState()) === null || _this$api === void 0 ? void 0 : _this$api.syncBlockStore) ?? this.syncBlockStore;
            return store ? store.referenceManager.fetchSyncBlockSourceInfoBySourceAri(sourceAri) : Promise.resolve(undefined);
        };
        this.options = props.options;
        this.api = props.api;
        this.syncBlockStore = props.syncBlockStore;
        this.intl = props.intl;
    }
    createDomRef() {
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- NodeView DOM must be created against active runtime document
        const domRef = document.createElement('div');
        domRef.classList.add((0, $7VlAB.SyncBlockSharedCssClassName).prefix);
        // Prevent native browser drag on the contentEditable="false" wrapper.
        // Without this, clicking in empty space (outside the contentEditable
        // renderer but inside the domRef) initiates a native element drag.
        domRef.draggable = false;
        this.dragStartHandler = (e)=>{
            e.preventDefault();
        };
        // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop, @repo/internal/dom-events/no-unsafe-event-listeners
        domRef.addEventListener('dragstart', this.dragStartHandler);
        return domRef;
    }
    /**
   * Allow mouse and selection events inside the renderer content to pass
   * through to the browser so that users can select and copy text within a
   * reference sync block.
   *
   * With patch_11, native selection changes select the containing node without taking focus.
   * Without it, events inside the content area (but not the label) are stopped
   * and mousedown explicitly selects the node.
   * This includes the full click-drag cycle (mousedown, mousemove, mouseup),
   * click, dblclick, selectstart and cut. The `cut` event is stopped because
   * mousedown explicitly sets a NodeSelection on the sync block — without
   * stopping `cut`, a subsequent Ctrl+X would cause ProseMirror to delete the
   * entire sync block node instead of cutting the user's text selection.
   *
   * Copy events are conditionally stopped: when the user has an active native
   * text selection inside the renderer, `copy` is stopped so the browser handles
   * it natively (copying the selected text). When there is no text selection
   * (just a PM NodeSelection), `copy` is NOT stopped so ProseMirror's copy
   * handler runs and sets the "sync-block-copied" flag for the reference paste flow.
   *
   * Events on the SyncBlockLabel are left for ProseMirror to handle, preserving
   * label click interactions and the floating toolbar.
   *
   * The renderer wrapper sets contentEditable="true" to create a re-editable
   * island inside ProseMirror's contentEditable="false" nodeview, enabling
   * native text selection and preventing browser drag behaviour.
   */ stopEvent(event) {
        const target = event.target;
        if (!(target instanceof Element)) return false;
        // Stop events inside the sync block content area, but not on the
        // SyncBlockLabel (to preserve label click interactions).
        if (target.closest(`.${(0, $7VlAB.SyncBlockSharedCssClassName).prefix}`) && !target.closest(`.${(0, $7VlAB.SyncBlockLabelSharedCssClassName).labelClassName}`)) {
            const eventType = event.type;
            // Stop `copy` only when there is an active native text selection
            // inside the renderer. This lets the browser handle text copy
            // natively. When there is no text selection (just a PM
            // NodeSelection), we let PM handle the copy event so the
            // "sync-block-copied" flag is set for the reference paste flow.
            if (eventType === 'copy') {
                const selection = this.view.dom.ownerDocument.getSelection();
                if (!selection || selection.toString().length === 0) return false;
                if (!(0, $3y2s4.isExperimentEnabled)('platform_editor_blocks_patch_11')) return true;
                // A native whole-node selection also contains text; only delegate renderer highlights.
                const renderer = target.closest(`.${(0, $7VlAB.SyncBlockSharedCssClassName).renderer}`);
                return !!(renderer && renderer.contains(selection.anchorNode) && renderer.contains(selection.focusNode));
            }
            // For `cut`: when text is selected inside the renderer, stop the
            // event and prevent default to avoid the browser removing text from
            // the read-only content. When no text is selected (NodeSelection),
            // let PM handle it so cut deletes the sync block as expected.
            if (eventType === 'cut') {
                const selection = window.getSelection();
                if (selection && selection.toString().length > 0) {
                    event.preventDefault();
                    return true;
                }
                return false;
            }
            // Stop keyboard events that would cause PM to replace the
            // NodeSelection with typed text (deleting the sync block).
            // Allow modifier-key combos (Cmd+C, Cmd+A, etc.) through.
            // Allow Delete/Backspace through so PM's delete handler can
            // process them (e.g. show offline error flag).
            if ((eventType === 'keydown' || eventType === 'keypress') && event instanceof KeyboardEvent && !event.metaKey && !event.ctrlKey && event.key !== 'Delete' && event.key !== 'Backspace') return true;
            if ($61f7a4be718a4cd1$var$STOPPED_EVENT_TYPES.includes(eventType)) {
                if ((0, $3y2s4.isExperimentEnabled)('platform_editor_blocks_patch_11')) // Preserve renderer focus; the selection listener tracks the containing node.
                return true;
                // Ensure the syncBlock has a NodeSelection so the floating
                // toolbar is visible while the user interacts with the renderer.
                // stopEvent prevents PM from processing the mousedown, so we
                // need to explicitly set the selection ourselves.
                if (eventType === 'mousedown' && !(this.view.state.selection instanceof (0, $cw0wu.NodeSelection) && this.view.state.selection.node === this.node)) {
                    if (typeof this.getPos === 'function') {
                        const pos = this.getPos();
                        if (typeof pos === 'number') try {
                            const { tr: tr } = this.view.state;
                            this.view.dispatch(tr.setSelection((0, $cw0wu.NodeSelection).create(tr.doc, pos)));
                        } catch  {
                        // pos no longer valid — leave selection unchanged
                        }
                    }
                }
                return true;
            }
        }
        return false;
    }
    validUpdate(currentNode, newNode) {
        // Only consider as the valid update if the localId and resourceId are the same
        // This prevents PM reusing the same node view for different sync block node in live page transition
        return currentNode.attrs.localId === newNode.attrs.localId && currentNode.attrs.resourceId === newNode.attrs.resourceId;
    }
    update(node, decorations, innerDecorations) {
        return super.update(node, decorations, innerDecorations, this.validUpdate);
    }
    render({ getPos: getPos }) {
        var _this$options, _this$api2, _this$api3, _this$options2;
        if (!((_this$options = this.options) !== null && _this$options !== void 0 && _this$options.syncedBlockRenderer)) return null;
        const { resourceId: resourceId, localId: localId } = this.node.attrs;
        if (!resourceId || !localId) return null;
        const syncBlockStore = ((_this$api2 = this.api) === null || _this$api2 === void 0 || (_this$api2 = _this$api2.syncedBlock) === null || _this$api2 === void 0 || (_this$api2 = _this$api2.sharedState.currentState()) === null || _this$api2 === void 0 ? void 0 : _this$api2.syncBlockStore) ?? this.syncBlockStore;
        if (!syncBlockStore) return null;
        // get document node from data provider
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5oQeT.SyncBlockSSRReactContextsProvider), {
            intl: this.intl,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $iUiGU.ErrorBoundary), {
                component: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
                dispatchAnalyticsEvent: (_this$api3 = this.api) === null || _this$api3 === void 0 || (_this$api3 = _this$api3.analytics) === null || _this$api3 === void 0 ? void 0 : _this$api3.actions.fireAnalyticsEvent,
                fallbackComponent: null,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $3Z8vq.SyncBlockActionsProvider), {
                    removeSyncBlock: this.removeSyncBlockStable,
                    fetchSyncBlockSourceInfo: this.fetchSyncBlockSourceInfoStable,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $aPXdU.SyncBlockRendererWrapper), {
                        localId: localId,
                        resourceId: resourceId,
                        node: this.node,
                        syncBlockStore: syncBlockStore,
                        syncedBlockRenderer: (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.syncedBlockRenderer,
                        api: this.api
                    })
                })
            })
        });
    }
    destroy() {
        var _this$unsubscribe;
        (_this$unsubscribe = this.unsubscribe) === null || _this$unsubscribe === void 0 || _this$unsubscribe.call(this);
        if (this.dragStartHandler) {
            var _this$dom;
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop, @repo/internal/dom-events/no-unsafe-event-listeners
            (_this$dom = this.dom) === null || _this$dom === void 0 || _this$dom.removeEventListener('dragstart', this.dragStartHandler);
            this.dragStartHandler = undefined;
        }
        super.destroy();
    }
}
const $61f7a4be718a4cd1$export$72faffc4c399ec30 = ({ options: options, pmPluginFactoryParams: pmPluginFactoryParams, api: api })=>(node, view, getPos)=>{
        const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher } = pmPluginFactoryParams;
        return new $61f7a4be718a4cd1$export$5dd7fae087dd8061({
            api: api,
            options: options,
            node: node,
            view: view,
            getPos: getPos,
            portalProviderAPI: portalProviderAPI,
            eventDispatcher: eventDispatcher
        }).init();
    };

});
parcelRegister("3Z8vq", function(module, exports) {
$parcel$export(module.exports, "SyncBlockActionsProvider", () => $92255b4a362a60af$export$5f0b55764d1d819f);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
const $92255b4a362a60af$var$SyncBlockActionsContext = /*#__PURE__*/ (0, $bSJIT.createContext)(null);
const $92255b4a362a60af$export$1536d3aa2f6b9cd9 = ()=>{
    return (0, $bSJIT.useContext)($92255b4a362a60af$var$SyncBlockActionsContext);
};
const $92255b4a362a60af$export$5f0b55764d1d819f = ({ children: children, removeSyncBlock: removeSyncBlock, fetchSyncBlockSourceInfo: fetchSyncBlockSourceInfo })=>{
    const value = (0, $bSJIT.useMemo)(()=>({
            deleteSyncBlock: removeSyncBlock,
            fetchSourceInfo: fetchSyncBlockSourceInfo
        }), [
        removeSyncBlock,
        fetchSyncBlockSourceInfo
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)($92255b4a362a60af$var$SyncBlockActionsContext.Provider, {
        value: value,
        children: children
    });
};

});

parcelRegister("aPXdU", function(module, exports) {
$parcel$export(module.exports, "SyncBlockRendererWrapper", () => $90a8850946611da8$export$295fdde04ad91bbd);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $7VlAB = parcelRequire("7VlAB");

var $cSue1 = parcelRequire("cSue1");

var $9jpSj = parcelRequire("9jpSj");

var $9F8H3 = parcelRequire("9F8H3");

var $3y2s4 = parcelRequire("3y2s4");

var $ceB3S = parcelRequire("ceB3S");

var $b3tcA = parcelRequire("b3tcA");
const $90a8850946611da8$var$SyncBlockRendererWrapperDataId = 'sync-block-plugin-renderer-wrapper';
const $90a8850946611da8$var$SyncBlockRendererWrapperComponent = ({ syncedBlockRenderer: syncedBlockRenderer, syncBlockStore: syncBlockStore, node: node, resourceId: resourceId, localId: localId, api: api })=>{
    var _api$analytics, _syncBlockFetchResult, _syncBlockFetchResult2, _syncBlockFetchResult3, _syncBlockFetchResult4, _syncBlockFetchResult5;
    const isSamePageSyncEnabled = (0, $3y2s4.isExperimentEnabled)('editor-synced-block-same-page-sync');
    const syncBlockFetchResult = (0, $9jpSj.useFetchSyncBlockData)(syncBlockStore, resourceId, localId, api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 ? void 0 : _api$analytics.fireAnalyticsEvent);
    const title = (0, $9F8H3.useFetchSyncBlockTitle)(syncBlockStore, node);
    const contentUpdatedAt = syncBlockFetchResult === null || syncBlockFetchResult === void 0 || (_syncBlockFetchResult = syncBlockFetchResult.syncBlockInstance) === null || _syncBlockFetchResult === void 0 || (_syncBlockFetchResult = _syncBlockFetchResult.data) === null || _syncBlockFetchResult === void 0 ? void 0 : _syncBlockFetchResult.contentUpdatedAt;
    const isUnpublishedBlock = ((_syncBlockFetchResult2 = syncBlockFetchResult.syncBlockInstance) === null || _syncBlockFetchResult2 === void 0 || (_syncBlockFetchResult2 = _syncBlockFetchResult2.data) === null || _syncBlockFetchResult2 === void 0 ? void 0 : _syncBlockFetchResult2.status) === 'unpublished';
    const localSameDocumentSource = isSamePageSyncEnabled ? (_syncBlockFetchResult3 = syncBlockFetchResult.syncBlockInstance) === null || _syncBlockFetchResult3 === void 0 ? void 0 : _syncBlockFetchResult3.localSameDocumentSource : undefined;
    const localSourceBlockInstanceId = localSameDocumentSource === null || localSameDocumentSource === void 0 ? void 0 : localSameDocumentSource.sourceBlockInstanceId;
    const [localSourceInfo, setLocalSourceInfo] = (0, $bSJIT.useState)();
    (0, $bSJIT.useEffect)(()=>{
        var _syncBlockStore$sourc;
        let isMounted = true;
        if (!localSourceBlockInstanceId) {
            setLocalSourceInfo(undefined);
            return;
        }
        (_syncBlockStore$sourc = syncBlockStore.sourceManager) === null || _syncBlockStore$sourc === void 0 || _syncBlockStore$sourc.getSyncBlockSourceInfo(localSourceBlockInstanceId).then((sourceInfo)=>{
            if (isMounted) setLocalSourceInfo(sourceInfo);
        });
        return ()=>{
            isMounted = false;
        };
    }, [
        localSourceBlockInstanceId,
        syncBlockStore.sourceManager
    ]);
    const isUnsyncedBlock = isUnpublishedBlock && !localSameDocumentSource || (syncBlockFetchResult === null || syncBlockFetchResult === void 0 || (_syncBlockFetchResult4 = syncBlockFetchResult.syncBlockInstance) === null || _syncBlockFetchResult4 === void 0 || (_syncBlockFetchResult4 = _syncBlockFetchResult4.error) === null || _syncBlockFetchResult4 === void 0 ? void 0 : _syncBlockFetchResult4.type) === (0, $cSue1.SyncBlockError).NotFound;
    // Prevent editing in the contentEditable renderer wrapper. We set
    // contentEditable="true" to enable text selection (creating an editable
    // island inside ProseMirror's contentEditable="false" nodeview wrapper),
    // but users must not be able to type into or modify the renderer content.
    const preventInput = (0, $bSJIT.useCallback)((e)=>{
        e.preventDefault();
    }, []);
    // Browsers suppress link navigation on a plain click inside a
    // contentEditable region (they place the caret instead), which breaks links
    // rendered in the content — e.g. the "when the page is published" link in
    // the unpublished error card. Re-trigger navigation for _blank anchors
    // ourselves. A native listener (rather than an onClick on the div) is used
    // so we delegate link clicks without making the container itself interactive.
    const rendererRef = (0, $bSJIT.useRef)(null);
    const preventReferenceEditing = (0, $3y2s4.isExperimentEnabled)('platform_editor_blocks_patch_11');
    (0, $bSJIT.useEffect)(()=>{
        const container = rendererRef.current;
        if (!preventReferenceEditing || !container) return;
        return (0, $bAB3U.bind)(container, {
            // Block native edits without intercepting ProseMirror's node deletion.
            type: 'beforeinput',
            listener: (event)=>event.preventDefault()
        });
    }, [
        preventReferenceEditing
    ]);
    (0, $bSJIT.useEffect)(()=>{
        const containerEl = rendererRef.current;
        if (!containerEl) return;
        const unbind = (0, $bAB3U.bind)(containerEl, {
            type: 'click',
            listener: (e)=>{
                // Let the browser handle modified/non-primary clicks (open-in-new-tab,
                // etc.) natively so we don't open a second tab on top of it.
                if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
                const target = e.target instanceof Element ? e.target : null;
                const anchor = target === null || target === void 0 ? void 0 : target.closest('a[href]');
                if (!(anchor instanceof HTMLAnchorElement) || e.defaultPrevented || anchor.target !== '_blank') return;
                window.open(anchor.href, '_blank', 'noopener,noreferrer');
            }
        });
        return unbind;
    }, []);
    return /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                ref: rendererRef,
                "data-testid": $90a8850946611da8$var$SyncBlockRendererWrapperDataId,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $7VlAB.SyncBlockSharedCssClassName).renderer,
                contentEditable: true,
                suppressContentEditableWarning: true,
                // Prevent the contentEditable div from being keyboard-focusable.
                // It is only used to enable text selection, not as an input target.
                // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                tabIndex: -1,
                onBeforeInput: preventInput,
                onPaste: preventInput,
                // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
                onDrop: preventInput,
                children: syncedBlockRenderer({
                    syncBlockFetchResult: syncBlockFetchResult,
                    api: api,
                    localId: localId
                })
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $b3tcA.SyncBlockLabel), {
                isSource: false,
                title: title,
                contentUpdatedAt: contentUpdatedAt,
                localId: localId,
                isUnsyncedBlock: isUnsyncedBlock,
                unpublishedInfo: localSameDocumentSource && isUnpublishedBlock ? {
                    sourceType: (0, $ceB3S.getUnpublishedSourceType)({
                        sourceAri: (localSourceInfo === null || localSourceInfo === void 0 ? void 0 : localSourceInfo.sourceAri) ?? ((_syncBlockFetchResult5 = syncBlockFetchResult.syncBlockInstance) === null || _syncBlockFetchResult5 === void 0 || (_syncBlockFetchResult5 = _syncBlockFetchResult5.data) === null || _syncBlockFetchResult5 === void 0 ? void 0 : _syncBlockFetchResult5.sourceAri),
                        sourceProduct: (localSourceInfo === null || localSourceInfo === void 0 ? void 0 : localSourceInfo.productType) ?? localSameDocumentSource.sourceProduct
                    }),
                    variant: 'local-reference'
                } : undefined
            })
        ]
    });
};
const $90a8850946611da8$export$295fdde04ad91bbd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo($90a8850946611da8$var$SyncBlockRendererWrapperComponent);

});
parcelRegister("9jpSj", function(module, exports) {
$parcel$export(module.exports, "useFetchSyncBlockData", () => $510135f48e70b504$export$2b02427d5640395b);

var $bSJIT = parcelRequire("bSJIT");

var $7lseo = parcelRequire("7lseo");

var $j2Y9J = parcelRequire("j2Y9J");

var $cSue1 = parcelRequire("cSue1");

var $hYuzB = parcelRequire("hYuzB");

var $iYvEr = parcelRequire("iYvEr");
const $510135f48e70b504$export$2b02427d5640395b = (manager, resourceId, localId, fireAnalyticsEvent)=>{
    var _manager$referenceMan2, _manager$referenceMan3, _manager$referenceMan4, _manager$referenceMan5;
    // Initialize both states from a single cache lookup to avoid race conditions.
    // When a block is moved/remounted, the old component's cleanup may clear the cache
    // before or after the new component mounts. By doing a single lookup, we ensure
    // consistency between syncBlockInstance and isLoading initial values.
    const [{ syncBlockInstance: syncBlockInstance, isLoading: isLoading }, setFetchState] = (0, $bSJIT.useState)(()=>{
        if (resourceId) {
            var _manager$referenceMan;
            const initialData = manager === null || manager === void 0 || (_manager$referenceMan = manager.referenceManager) === null || _manager$referenceMan === void 0 ? void 0 : _manager$referenceMan.getInitialSyncBlockData(resourceId);
            return {
                syncBlockInstance: initialData ?? null,
                isLoading: initialData === undefined
            };
        }
        return {
            syncBlockInstance: null,
            isLoading: true
        };
    });
    // On Jira the data provider is wired asynchronously, so the manager can be
    // constructed with `dataProvider === undefined`. Fetching/subscribing in that
    // window throws `Data provider not set`, logged as a false fetch error
    // (EDITOR-7860). Check readiness; once the provider resolves a new manager
    // instance is created so `referenceManager` changes identity and the effect
    // below re-runs, subscribing exactly once.
    const isDataProviderReady = ((_manager$referenceMan2 = (_manager$referenceMan3 = manager.referenceManager).hasDataProvider) === null || _manager$referenceMan2 === void 0 ? void 0 : _manager$referenceMan2.call(_manager$referenceMan3)) ?? false;
    const reloadData = (0, $bSJIT.useCallback)(async ()=>{
        if (isLoading) return;
        // Not ready: skip fetch, emit no error (see readiness note above).
        if (!isDataProviderReady) return;
        try {
            const syncBlockNode = resourceId && localId ? (0, $iYvEr.createSyncBlockNode)(localId, resourceId) : null;
            if (!syncBlockNode) throw new Error('Failed to create sync block node from resourceid and localid');
            setFetchState((prev)=>({
                    ...prev,
                    isLoading: true
                }));
            // Fetch sync block data, the `subscribeToSyncBlock` will update the state once data is fetched
            await manager.referenceManager.fetchSyncBlocksData([
                syncBlockNode
            ]);
        } catch (error) {
            // EDITOR-7860: benign not-ready throw — emit no error and stay loading
            // so it resolves on retry once the provider is wired. Checked before
            // `logException` so the benign case produces no exception-tracker noise.
            if ((0, $cSue1.isProviderNotReadyError)(error)) {
                setFetchState((prev)=>({
                        ...prev,
                        isLoading: true
                    }));
                return;
            }
            (0, $j2Y9J.logException)(error, {
                location: 'editor-synced-block-provider/useFetchSyncBlockData'
            });
            fireAnalyticsEvent === null || fireAnalyticsEvent === void 0 || fireAnalyticsEvent((0, $hYuzB.fetchErrorPayload)(error.message, resourceId, (0, $iYvEr.getSourceProductFromResourceIdSafe)(resourceId), (0, $hYuzB.buildFetchErrorAttribution)(error.message)));
            // Thread the PII-safe original message/name so the renderer can de-opaque
            // this otherwise-bare `errored` failure. `originalMessage` carries the
            // Error.message and is preferred over `reason` by the renderer, so no
            // separate `reason` is set here.
            setFetchState({
                syncBlockInstance: {
                    resourceId: resourceId || '',
                    error: {
                        type: (0, $cSue1.SyncBlockError).Errored,
                        ...(0, $hYuzB.getPiiSafeOriginalError)(error)
                    }
                },
                isLoading: false
            });
            return;
        }
        setFetchState((prev)=>({
                ...prev,
                isLoading: false
            }));
    }, [
        isLoading,
        isDataProviderReady,
        localId,
        manager.referenceManager,
        resourceId,
        fireAnalyticsEvent
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if ((0, $7lseo.isSSR)()) // in SSR, we don't need to subscribe to updates,
        // instead we rely on pre-fetched data ONLY, see initialization of syncBlockInstance above
        return;
        // Not ready: skip subscribe (it would trigger a batched fetch and a false
        // error) and keep `isLoading: true`. `isDataProviderReady` is in the deps,
        // so the effect re-runs and subscribes once the provider resolves.
        if (!isDataProviderReady) return;
        const unsubscribe = manager.referenceManager.subscribeToSyncBlock(resourceId || '', localId || '', (data)=>{
            setFetchState({
                syncBlockInstance: data,
                isLoading: false
            });
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        isDataProviderReady,
        localId,
        manager.referenceManager,
        resourceId
    ]);
    // Pure read, safe during render. The individual provider references are effect
    // dependencies below so a provider swapped by the host is re-applied to the
    // cached factory, which would otherwise keep serving the previous one.
    const { parentDataProviders: parentDataProviders, providerCreator: providerCreator } = ((_manager$referenceMan4 = (_manager$referenceMan5 = manager.referenceManager).getProviderOptions) === null || _manager$referenceMan4 === void 0 ? void 0 : _manager$referenceMan4.call(_manager$referenceMan5)) ?? {};
    // Applying providers notifies subscribers synchronously, so it must not run during
    // render - that would setState on another component mid-render and remount the block.
    (0, $bSJIT.useEffect)(()=>{
        if (!resourceId || (0, $7lseo.isSSR)()) return;
        manager.referenceManager.syncProviders(resourceId);
    // `syncBlockInstance` is a dependency because the dynamic providers are derived
    // from the fetched block data, so they can only be created once it has arrived.
    }, [
        manager.referenceManager,
        resourceId,
        syncBlockInstance,
        parentDataProviders === null || parentDataProviders === void 0 ? void 0 : parentDataProviders.mentionProvider,
        parentDataProviders === null || parentDataProviders === void 0 ? void 0 : parentDataProviders.profilecardProvider,
        parentDataProviders === null || parentDataProviders === void 0 ? void 0 : parentDataProviders.taskDecisionProvider,
        providerCreator
    ]);
    const ssrProviders = (0, $bSJIT.useMemo)(()=>{
        return resourceId ? manager.referenceManager.getSSRProviders(resourceId) : null;
    }, [
        resourceId,
        manager.referenceManager
    ]);
    return {
        isLoading: isLoading,
        ssrProviders: ssrProviders,
        providerFactory: manager.referenceManager.getProviderFactory(resourceId || ''),
        reloadData: reloadData,
        syncBlockInstance: syncBlockInstance
    };
};

});

parcelRegister("9F8H3", function(module, exports) {
$parcel$export(module.exports, "useFetchSyncBlockTitle", () => $f7fb99ed73c5cc84$export$b5dcfcd5b90b41cc);

var $bSJIT = parcelRequire("bSJIT");
const $f7fb99ed73c5cc84$export$b5dcfcd5b90b41cc = (manager, syncBlockNode)=>{
    var _syncBlockNode$attrs, _syncBlockNode$attrs2;
    const nodeRef = (0, $bSJIT.useRef)(syncBlockNode);
    nodeRef.current = syncBlockNode;
    const nodeTypeName = syncBlockNode.type.name;
    const resourceId = (_syncBlockNode$attrs = syncBlockNode.attrs) === null || _syncBlockNode$attrs === void 0 ? void 0 : _syncBlockNode$attrs.resourceId;
    const localId = (_syncBlockNode$attrs2 = syncBlockNode.attrs) === null || _syncBlockNode$attrs2 === void 0 ? void 0 : _syncBlockNode$attrs2.localId;
    // Initialize state from cache to prevent flickering during re-renders
    const [sourceTitle, setSourceTitle] = (0, $bSJIT.useState)(()=>{
        var _cachedData$data;
        if (nodeTypeName !== 'syncBlock') return undefined;
        if (!resourceId) return undefined;
        const cachedData = manager.referenceManager.getFromCache(resourceId);
        return cachedData === null || cachedData === void 0 || (_cachedData$data = cachedData.data) === null || _cachedData$data === void 0 ? void 0 : _cachedData$data.sourceTitle;
    });
    (0, $bSJIT.useEffect)(()=>{
        const unsubscribe = manager.referenceManager.subscribeToSourceTitle(nodeRef.current, (title)=>{
            setSourceTitle(title);
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        manager,
        nodeTypeName,
        resourceId,
        localId
    ]);
    return sourceTitle;
};

});


parcelRegister("5oQeT", function(module, exports) {
$parcel$export(module.exports, "SyncBlockSSRReactContextsProvider", () => $d957cd49b6ca0461$export$491fe064d74662f9);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $7lseo = parcelRequire("7lseo");
function $d957cd49b6ca0461$export$491fe064d74662f9({ children: children, intl: intl }) {
    if (!(0, $7lseo.isSSR)()) return children;
    if (!intl) return children;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fK3tS.Provider), {
        value: intl,
        children: children
    });
}

});


parcelRegister("7II9i", function(module, exports) {
$parcel$export(module.exports, "FLAG_ID", () => $2a0ef0e97fe06bf2$export$5881677fb314e6d9);
$parcel$export(module.exports, "SYNCED_BLOCK_BUTTON_TEST_ID", () => $2a0ef0e97fe06bf2$export$ce5236bf4eef2662);
var $2a0ef0e97fe06bf2$export$5881677fb314e6d9 = /*#__PURE__*/ function(FLAG_ID) {
    FLAG_ID["CANNOT_DELETE_WHEN_OFFLINE"] = "cannot-delete-when-offline";
    FLAG_ID["CANNOT_EDIT_WHEN_OFFLINE"] = "cannot-edit-when-offline";
    FLAG_ID["CANNOT_CREATE_WHEN_OFFLINE"] = "cannot-create-when-offline";
    FLAG_ID["FAIL_TO_DELETE"] = "fail-to-delete";
    FLAG_ID["SYNC_BLOCK_COPIED"] = "sync-block-copied";
    FLAG_ID["UNPUBLISHED_SYNC_BLOCK_PASTED"] = "unpublished-sync-block-pasted";
    FLAG_ID["CANNOT_CREATE_SYNC_BLOCK"] = "cannot-create-sync-block";
    FLAG_ID["INLINE_EXTENSION_IN_SYNC_BLOCK"] = "inline-extension-in-sync-block";
    FLAG_ID["EXTENSION_IN_SYNC_BLOCK"] = "extension-in-sync-block";
    FLAG_ID["DUPLICATE_SOURCE_SYNC_BLOCK"] = "duplicate-source-sync-block";
    FLAG_ID["SYNC_BLOCK_FEEDBACK_PROMPT"] = "synced-block-feedback-prompt";
    return FLAG_ID;
}({});
const $2a0ef0e97fe06bf2$export$ce5236bf4eef2662 = {
    primaryToolbarCreate: 'create-synced-block-toolbar-btn',
    blockMenuCreate: 'create-synced-block-block-menu-btn',
    quickInsertCreate: 'create-synced-block-quick-insert-btn',
    syncedBlockToolbarCopy: 'synced-block-copy-btn',
    syncedBlockToolbarReferenceDelete: 'reference-synced-block-delete-btn',
    syncedBlockToolbarSourceDelete: 'source-synced-block-delete-btn',
    syncedBlockToolbarReferenceUnsync: 'reference-synced-block-unsync-btn',
    syncedBlockToolbarSourceUnsync: 'source-synced-block-unsync-btn',
    syncedBlockToolbarSyncedLocationsTrigger: 'synced-block-synced-locations-dropdown--trigger',
    syncedBlockToolbarReferenceOverflowTrigger: 'reference-synced-block-overflow-dropdown--trigger',
    syncedBlockToolbarSourceOverflowTrigger: 'source-synced-block-overflow-dropdown--trigger'
};

});

parcelRegister("04BiH", function(module, exports) {
$parcel$export(module.exports, "createReferenceSelectionView", () => $f6fd6f30e1c5d8ce$export$8fc77e9363d29357);

var $bAB3U = parcelRequire("bAB3U");

var $7VlAB = parcelRequire("7VlAB");

var $cw0wu = parcelRequire("cw0wu");
const $f6fd6f30e1c5d8ce$var$getSelectedReference = (view)=>{
    const selection = view.dom.ownerDocument.getSelection();
    const anchor = selection === null || selection === void 0 ? void 0 : selection.anchorNode;
    const anchorElement = anchor instanceof Element ? anchor : anchor === null || anchor === void 0 ? void 0 : anchor.parentElement;
    const renderer = anchorElement === null || anchorElement === void 0 ? void 0 : anchorElement.closest(`.${(0, $7VlAB.SyncBlockSharedCssClassName).renderer}`);
    if (!renderer || !(selection !== null && selection !== void 0 && selection.focusNode) || !renderer.contains(selection.focusNode)) return null;
    const reference = renderer.closest(`.${(0, $7VlAB.SyncBlockSharedCssClassName).prefix}`);
    return reference && view.dom.contains(reference) ? reference : null;
};
const $f6fd6f30e1c5d8ce$export$8fc77e9363d29357 = (view)=>{
    const syncReferenceSelection = (reference)=>{
        var _doc$nodeAt;
        if (!view.editable || !reference) return;
        const pos = view.posAtDOM(reference, 0);
        const { doc: doc, schema: schema, selection: selection } = view.state;
        if (((_doc$nodeAt = doc.nodeAt(pos)) === null || _doc$nodeAt === void 0 ? void 0 : _doc$nodeAt.type) !== schema.nodes.syncBlock || selection instanceof (0, $cw0wu.NodeSelection) && selection.from === pos) return;
        // The selectable renderer owns native focus, so PM's observer ignores its selection.
        // Track the containing atom without focusing the editor or clearing highlighted text.
        view.dispatch(view.state.tr.setSelection((0, $cw0wu.NodeSelection).create(doc, pos)));
    };
    const unbind = (0, $bAB3U.bindAll)(view.dom.ownerDocument, [
        {
            type: 'selectionchange',
            listener: ()=>syncReferenceSelection($f6fd6f30e1c5d8ce$var$getSelectedReference(view))
        },
        {
            type: 'click',
            listener: (event)=>{
                if (event.button !== 0 || !view.editable) return;
                const target = event.target instanceof Element ? event.target : null;
                const reference = target === null || target === void 0 ? void 0 : target.closest(`.${(0, $7VlAB.SyncBlockSharedCssClassName).prefix}`);
                if (!reference || !view.dom.contains(reference)) return;
                // Edge clicks never create a native selection inside the renderer.
                syncReferenceSelection(reference);
                if (!(target !== null && target !== void 0 && target.closest(`.${(0, $7VlAB.SyncBlockSharedCssClassName).renderer}`)) && !(target !== null && target !== void 0 && target.closest(`.${(0, $7VlAB.SyncBlockLabelSharedCssClassName).labelClassName}`))) view.focus();
            }
        }
    ]);
    return {
        destroy: unbind
    };
};

});

parcelRegister("1wTON", function(module, exports) {
$parcel$export(module.exports, "handleBodiedSyncBlockCreation", () => $acad06792ece53d8$export$4ef10a0a6b609715);

var $cw0wu = parcelRequire("cw0wu");

var $7II9i = parcelRequire("7II9i");

var $cG0Fu = parcelRequire("cG0Fu");

var $QIBX2 = parcelRequire("QIBX2");
const $acad06792ece53d8$var$onRetry = (api, resourceId, enrichment)=>{
    return ()=>{
        var _api$core, _api$core2;
        api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.focus();
        api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 || _api$core2.actions.execute(({ tr: tr })=>{
            var _api$syncedBlock, _api$syncedBlock2;
            const pos = api === null || api === void 0 || (_api$syncedBlock = api.syncedBlock) === null || _api$syncedBlock === void 0 || (_api$syncedBlock = _api$syncedBlock.sharedState.currentState()) === null || _api$syncedBlock === void 0 || (_api$syncedBlock = _api$syncedBlock.retryCreationPosMap) === null || _api$syncedBlock === void 0 ? void 0 : _api$syncedBlock.get(resourceId);
            const from = pos === null || pos === void 0 ? void 0 : pos.from;
            const to = pos === null || pos === void 0 ? void 0 : pos.to;
            if (from === undefined || to === undefined) return tr;
            tr.setSelection((0, $cw0wu.TextSelection).create(tr.doc, from, to)).setMeta((0, $cG0Fu.syncedBlockPluginKey), {
                activeFlag: false
            });
            api === null || api === void 0 || (_api$syncedBlock2 = api.syncedBlock) === null || _api$syncedBlock2 === void 0 || _api$syncedBlock2.commands.insertSyncedBlock(enrichment === null || enrichment === void 0 ? void 0 : enrichment.inputMethod)({
                tr: tr
            });
            return tr;
        });
    };
};
const $acad06792ece53d8$var$getRevertCreationPos = (api, doc, resourceId)=>{
    var _api$syncedBlock3;
    const retryCreationPos = api === null || api === void 0 || (_api$syncedBlock3 = api.syncedBlock) === null || _api$syncedBlock3 === void 0 || (_api$syncedBlock3 = _api$syncedBlock3.sharedState.currentState()) === null || _api$syncedBlock3 === void 0 || (_api$syncedBlock3 = _api$syncedBlock3.retryCreationPosMap) === null || _api$syncedBlock3 === void 0 ? void 0 : _api$syncedBlock3.get(resourceId);
    if (retryCreationPos) return retryCreationPos;
    // Fallback to find the positions in case BE call returns before plugin state becomes available
    // which is highly unlikely
    let currentPos;
    doc.descendants((node, pos)=>{
        if (currentPos) return false;
        if (node.type.name === 'bodiedSyncBlock' && resourceId === node.attrs.resourceId) {
            currentPos = {
                from: pos,
                to: pos + node.nodeSize
            };
            return false;
        }
    });
    return currentPos;
};
const $acad06792ece53d8$var$buildRevertCreationTr = (tr, pos)=>{
    var _tr$doc$nodeAt;
    const content = (_tr$doc$nodeAt = tr.doc.nodeAt(pos.from)) === null || _tr$doc$nodeAt === void 0 ? void 0 : _tr$doc$nodeAt.content;
    if (content) {
        tr.replaceWith(pos.from, pos.to, content);
        const contentFrom = tr.mapping.map(pos.from);
        tr.setSelection((0, $cw0wu.TextSelection).create(tr.doc, contentFrom, contentFrom + content.size));
    } else tr.delete(pos.from, pos.to);
    return tr;
};
const $acad06792ece53d8$export$4ef10a0a6b609715 = (bodiedSyncBlockAdded, editorState, api, enrichment)=>{
    const syncBlockStore = (0, $cG0Fu.syncedBlockPluginKey).getState(editorState).syncBlockStore;
    bodiedSyncBlockAdded.forEach((node)=>{
        if (node.from === undefined || node.to === undefined) return;
        const retryCreationPos = {
            from: node.from,
            to: node.to
        };
        const resourceId = node.attrs.resourceId;
        (0, $QIBX2.deferDispatch)(()=>{
            var _api$core3;
            api === null || api === void 0 || (_api$core3 = api.core) === null || _api$core3 === void 0 || _api$core3.actions.execute(({ tr: tr })=>{
                return tr.setMeta((0, $cG0Fu.syncedBlockPluginKey), {
                    retryCreationPos: {
                        resourceId: resourceId,
                        pos: retryCreationPos
                    }
                });
            });
        });
        syncBlockStore.sourceManager.createBodiedSyncBlockNode(node.attrs, node.node, (success)=>{
            if (success) {
                var _api$core4, _api$core5;
                api === null || api === void 0 || (_api$core4 = api.core) === null || _api$core4 === void 0 || _api$core4.actions.execute(({ tr: tr })=>{
                    return tr.setMeta((0, $cG0Fu.syncedBlockPluginKey), {
                        retryCreationPos: {
                            resourceId: resourceId,
                            pos: undefined
                        }
                    });
                });
                api === null || api === void 0 || (_api$core5 = api.core) === null || _api$core5 === void 0 || _api$core5.actions.focus();
            } else {
                var _api$core6;
                api === null || api === void 0 || (_api$core6 = api.core) === null || _api$core6 === void 0 || _api$core6.actions.execute(({ tr: tr })=>{
                    const revertCreationPos = $acad06792ece53d8$var$getRevertCreationPos(api, tr.doc, resourceId);
                    if (!revertCreationPos) return tr;
                    const revertTr = $acad06792ece53d8$var$buildRevertCreationTr(tr, revertCreationPos);
                    return revertTr.setMeta('isConfirmedSyncBlockDeletion', true).setMeta('addToHistory', false).setMeta((0, $cG0Fu.syncedBlockPluginKey), {
                        activeFlag: {
                            id: (0, $7II9i.FLAG_ID).CANNOT_CREATE_SYNC_BLOCK,
                            onRetry: $acad06792ece53d8$var$onRetry(api, resourceId, enrichment),
                            onDismissed: (tr)=>tr.setMeta((0, $cG0Fu.syncedBlockPluginKey), {
                                    ...tr.getMeta((0, $cG0Fu.syncedBlockPluginKey)),
                                    retryCreationPos: {
                                        resourceId: resourceId,
                                        pos: undefined
                                    }
                                })
                        }
                    });
                });
            }
        }, enrichment);
    });
};

});
parcelRegister("QIBX2", function(module, exports) {
$parcel$export(module.exports, "deferDispatch", () => $70d1c3fc3272c42e$export$fb2d0f31ec71c7e9);
$parcel$export(module.exports, "findSyncBlock", () => $70d1c3fc3272c42e$export$8e2da6078c69a0c6);
$parcel$export(module.exports, "findSyncBlockOrBodiedSyncBlock", () => $70d1c3fc3272c42e$export$72f89723ce6d6fa3);
$parcel$export(module.exports, "isBodiedSyncBlockNode", () => $70d1c3fc3272c42e$export$5f971aa95a01794c);
$parcel$export(module.exports, "canBeConvertedToSyncBlock", () => $70d1c3fc3272c42e$export$a912fa82dfd54783);
$parcel$export(module.exports, "sliceFullyContainsNode", () => $70d1c3fc3272c42e$export$384f6683328fd2fe);
$parcel$export(module.exports, "wasExtensionInsertedInBodiedSyncBlock", () => $70d1c3fc3272c42e$export$ecac802907d15d9a);

var $57l7A = parcelRequire("57l7A");

var $6Cbfp = parcelRequire("6Cbfp");

var $kW8qW = parcelRequire("kW8qW");

var $3DNV7 = parcelRequire("3DNV7");

var $gab48 = parcelRequire("gab48");

var $5N1Y4 = parcelRequire("5N1Y4");
const $70d1c3fc3272c42e$export$fb2d0f31ec71c7e9 = (fn)=>{
    queueMicrotask(fn);
};
const $70d1c3fc3272c42e$export$8e2da6078c69a0c6 = (schema, selection)=>{
    const { syncBlock: syncBlock } = schema.nodes;
    return (0, $gab48.findSelectedNodeOfType)(syncBlock)(selection);
};
const $70d1c3fc3272c42e$export$342c143cb64448d1 = (schema, selection)=>{
    return (0, $gab48.findSelectedNodeOfType)(schema.nodes.bodiedSyncBlock)(selection) || (0, $gab48.findParentNodeOfType)(schema.nodes.bodiedSyncBlock)(selection);
};
const $70d1c3fc3272c42e$export$72f89723ce6d6fa3 = (schema, selection)=>{
    return $70d1c3fc3272c42e$export$8e2da6078c69a0c6(schema, selection) || $70d1c3fc3272c42e$export$342c143cb64448d1(schema, selection);
};
const $70d1c3fc3272c42e$export$5f971aa95a01794c = (node, bodiedSyncBlock)=>node.type === bodiedSyncBlock;
const $70d1c3fc3272c42e$export$77fbebd359a90e90 = (0, $57l7A.default)(()=>new Set([
        'inlineExtension',
        'extension',
        'bodiedExtension',
        'syncBlock',
        'bodiedSyncBlock',
        ...(0, $5N1Y4.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true) ? [
            'multiBodiedExtension'
        ] : []
    ]));
const $70d1c3fc3272c42e$export$a912fa82dfd54783 = (selection)=>{
    var _selectedContent$firs;
    const { $from: $from, range: range } = (0, $6Cbfp.expandSelectionToBlockRange)(selection);
    if (!range) return false;
    const from = range.start;
    const to = range.end;
    const unsupportedNodeTypes = $70d1c3fc3272c42e$export$77fbebd359a90e90();
    let canBeConverted = true;
    $from.doc.nodesBetween(from, to, (node)=>{
        if (unsupportedNodeTypes.has(node.type.name)) {
            canBeConverted = false;
            return false;
        }
    });
    if (!canBeConverted) return false;
    const selectedContent = $from.doc.slice(from, to).content;
    // A single wrapper cannot preserve independent breakout widths for a multi-node selection.
    const breakoutMark = selectedContent.childCount === 1 ? (_selectedContent$firs = selectedContent.firstChild) === null || _selectedContent$firs === void 0 ? void 0 : _selectedContent$firs.marks.find((mark)=>mark.type.name === 'breakout') : undefined;
    const contentToInclude = $70d1c3fc3272c42e$var$removeBreakoutMarks(selectedContent);
    return {
        breakoutMark: breakoutMark,
        contentToInclude: contentToInclude,
        from: from,
        to: to
    };
};
const $70d1c3fc3272c42e$var$removeBreakoutMarks = (content)=>{
    const nodes = [];
    // we only need to recurse at the top level, because breakout has to be on a top level
    content.forEach((node)=>{
        const filteredMarks = node.marks.filter((mark)=>mark.type.name !== 'breakout');
        if (node.isText) nodes.push(node);
        else {
            const newNode = node.type.create(node.attrs, node.content, filteredMarks);
            nodes.push(newNode);
        }
    });
    return (0, $kW8qW.Fragment).from(nodes);
};
const $70d1c3fc3272c42e$export$384f6683328fd2fe = (slice, node)=>{
    var _slice$content$firstC, _slice$content$firstC2, _slice$content$lastCh, _slice$content$lastCh2;
    const isFirstChild = ((_slice$content$firstC = slice.content.firstChild) === null || _slice$content$firstC === void 0 ? void 0 : _slice$content$firstC.type) === node.type && ((_slice$content$firstC2 = slice.content.firstChild) === null || _slice$content$firstC2 === void 0 ? void 0 : _slice$content$firstC2.attrs.resourceId) === node.attrs.resourceId;
    const isLastChild = ((_slice$content$lastCh = slice.content.lastChild) === null || _slice$content$lastCh === void 0 ? void 0 : _slice$content$lastCh.type) === node.type && ((_slice$content$lastCh2 = slice.content.lastChild) === null || _slice$content$lastCh2 === void 0 ? void 0 : _slice$content$lastCh2.attrs.resourceId) === node.attrs.resourceId;
    const isOpenAtStart = isFirstChild && slice.openStart > 0;
    const isOpenAtEnd = isLastChild && slice.openEnd > 0;
    if (isOpenAtStart || isOpenAtEnd) return false;
    return true;
};
// even though extension and bodiedExtension are explicitly not allowed by the schema, they can still be inserted nested inside other nodes e.g. layouts
const $70d1c3fc3272c42e$var$EXTENSION_NODES = new Set([
    'inlineExtension',
    'extension',
    'bodiedExtension'
]);
const $70d1c3fc3272c42e$var$fragmentContainsExtension = (fragment)=>{
    let found = false;
    fragment.forEach((node)=>{
        if (found) return;
        if ($70d1c3fc3272c42e$var$EXTENSION_NODES.has(node.type.name)) found = true;
        else if (node.content.size) {
            if ($70d1c3fc3272c42e$var$fragmentContainsExtension(node.content)) found = true;
        }
    });
    return found;
};
const $70d1c3fc3272c42e$var$sliceContainsExtension = (slice)=>$70d1c3fc3272c42e$var$fragmentContainsExtension(slice.content);
const $70d1c3fc3272c42e$export$ecac802907d15d9a = (tr, state)=>{
    if (!tr.docChanged || tr.getMeta('isRemote')) return undefined;
    const { bodiedSyncBlock: bodiedSyncBlock } = state.schema.nodes;
    if (!bodiedSyncBlock) return undefined;
    const docs = tr.docs;
    // When docs is available (e.g. from history plugin), check each replace step
    if (docs && docs.length > 0) {
        for(let i = 0; i < tr.steps.length; i++){
            const step = tr.steps[i];
            const isReplaceStep = step instanceof (0, $3DNV7.ReplaceStep) || step instanceof (0, $3DNV7.ReplaceAroundStep);
            if (!isReplaceStep || !('slice' in step) || !('from' in step)) continue;
            const replaceStep = step;
            if (!$70d1c3fc3272c42e$var$sliceContainsExtension(replaceStep.slice)) continue;
            const docAfterStep = docs[i + 1] ?? tr.doc;
            try {
                const $pos = docAfterStep.resolve(replaceStep.from);
                const parent = (0, $gab48.findParentNodeOfTypeClosestToPos)($pos, bodiedSyncBlock);
                if (parent !== null && parent !== void 0 && parent.node.attrs.resourceId) return parent.node.attrs.resourceId;
            } catch  {
            // resolve() can throw if position is invalid
            }
        }
        return undefined;
    }
    // Fallback: scan final doc for inline extensions inside bodied sync block that were added
    let resourceId;
    tr.doc.descendants((node, pos)=>{
        if (resourceId !== undefined) return false;
        if ($70d1c3fc3272c42e$var$EXTENSION_NODES.has(node.type.name)) {
            const $pos = tr.doc.resolve(pos);
            const parent = (0, $gab48.findParentNodeOfTypeClosestToPos)($pos, bodiedSyncBlock);
            if (parent !== null && parent !== void 0 && parent.node.attrs.resourceId) {
                const mappedPos = tr.mapping.invert().map(pos);
                const nodeBefore = state.doc.nodeAt(mappedPos);
                if (!nodeBefore || $70d1c3fc3272c42e$var$EXTENSION_NODES.has(nodeBefore.type.name)) {
                    resourceId = parent.node.attrs.resourceId;
                    return false;
                }
            }
        }
        return true;
    });
    return resourceId;
};

});


parcelRegister("iQxc5", function(module, exports) {
$parcel$export(module.exports, "handleBodiedSyncBlockRemoval", () => $7361883d276dfb32$export$4d68be81d3ab4a0d);

var $56AB9 = parcelRequire("56AB9");

var $3y2s4 = parcelRequire("3y2s4");

var $7II9i = parcelRequire("7II9i");

var $cG0Fu = parcelRequire("cG0Fu");

var $3ZGpX = parcelRequire("3ZGpX");
const $7361883d276dfb32$var$onRetry = (api, syncBlockStore)=>()=>{
        var _api$core;
        api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(({ tr: tr })=>{
            return tr.setMeta((0, $cG0Fu.syncedBlockPluginKey), {
                bodiedSyncBlockDeletionStatus: 'processing',
                activeFlag: false
            });
        });
        syncBlockStore.sourceManager.retryDeletion();
    };
const $7361883d276dfb32$var$onDismissed = (syncBlockStore)=>(tr)=>{
        syncBlockStore.sourceManager.clearPendingDeletion();
        return tr.setMeta((0, $cG0Fu.syncedBlockPluginKey), {
            bodiedSyncBlockDeletionStatus: 'none'
        });
    };
const $7361883d276dfb32$var$topLevelSourceBlocks = (doc, isSourceBlock)=>{
    const blocks = [];
    doc.forEach((node)=>{
        if (isSourceBlock(node)) blocks.push(node);
    });
    return blocks;
};
/**
 * Whether `tr` removes every block in `wanted` from the document. Identity follows
 * `matchesRequestedBlock` (localId, falling back to resourceId) so this agrees with the
 * recompute helpers.
 */ const $7361883d276dfb32$var$removesRequestedBlocks = (tr, isSourceBlock, wanted)=>{
    const before = $7361883d276dfb32$var$topLevelSourceBlocks(tr.before, isSourceBlock);
    const after = $7361883d276dfb32$var$topLevelSourceBlocks(tr.doc, isSourceBlock);
    return wanted.every((block)=>before.some((node)=>(0, $3ZGpX.matchesRequestedBlock)(node, block)) && !after.some((node)=>(0, $3ZGpX.matchesRequestedBlock)(node, block)));
};
/**
 * Replay the undo that removed `wanted` once the source deletion has been confirmed and
 * persisted (EDITOR-8863).
 *
 * The original undo transaction was rejected by `filterTransaction` so the confirmation could
 * run, which leaves the history event on top of the undo stack. Building the undo again from
 * the live state (via the history plugin) restores whatever the block was converted from
 * (e.g. a table), unlike a recomputed whole-node delete which drops that content.
 *
 * Guard: only dispatch if that undo still removes the same source block(s). If the user
 * edited in the meantime the top of the stack is no longer that event, so return `false` and
 * let the caller fall back to the recomputed unwrap.
 */ const $7361883d276dfb32$var$replayConfirmedUndo = (api, isSourceBlock, wanted, onTransaction)=>{
    var _api$history;
    const undo = api === null || api === void 0 || (_api$history = api.history) === null || _api$history === void 0 ? void 0 : _api$history.commands.undo;
    if (!undo || !(api !== null && api !== void 0 && api.core)) return false;
    let applied = false;
    api.core.actions.execute(({ tr: tr })=>{
        const undoTr = undo({
            tr: tr
        });
        if (!undoTr || !$7361883d276dfb32$var$removesRequestedBlocks(undoTr, isSourceBlock, wanted)) return null;
        undoTr.setMeta('isConfirmedSyncBlockDeletion', true);
        onTransaction(undoTr);
        applied = true;
        return undoTr;
    });
    return applied;
};
const $7361883d276dfb32$export$4d68be81d3ab4a0d = ({ api: api, confirmationTransactionRef: confirmationTransactionRef, deletionReason: deletionReason, feedbackCallbacks: feedbackCallbacks, mechanism: mechanism, removed: removed, syncBlockStore: syncBlockStore })=>{
    const removedAttrs = removed.map((node)=>node.attrs);
    const { isSourceBlock: isSourceBlock } = syncBlockStore.sourceManager;
    // Clear potential old pending deletion to retreat the deletion as first attempt
    syncBlockStore.sourceManager.clearPendingDeletion();
    // If there are source sync blocks being removed, and we need to confirm with user before deleting,
    // we block the transaction here, and wait for user confirmation to proceed with deletion.
    // See editor-common/src/sync-block/sync-block-store-manager.ts for how we handle user confirmation and
    // proceed with deletion.
    syncBlockStore.sourceManager.deleteSyncBlocksWithConfirmation(removedAttrs, deletionReason, ()=>{
        var _api$core2;
        const closeBlockMenu = (confirmedTr)=>{
            if ((0, $3y2s4.isExperimentEnabled)('platform_editor_blocks_exp_patch_10')) {
                var _api$blockControls;
                // The original transaction's closeMenu meta was rejected along with it above,
                // so re-apply it here to close the block menu once the change actually lands.
                api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || (_api$blockControls = _api$blockControls.commands) === null || _api$blockControls === void 0 || _api$blockControls.toggleBlockMenu({
                    closeMenu: true
                })({
                    tr: confirmedTr
                });
            }
        };
        // Any undo that removes a source block (creation, paste, ...) must restore what was
        // there before. A recomputed whole-node delete drops the converted content and leaves
        // the event on the undo stack, so replay the undo instead (EDITOR-8863).
        const shouldReplayUndo = mechanism === 'undo' && (0, $3y2s4.isExperimentEnabled)('platform_editor_blocks_exp_patch_10');
        if (shouldReplayUndo && $7361883d276dfb32$var$replayConfirmedUndo(api, isSourceBlock, removedAttrs, (undoTr)=>{
            closeBlockMenu(undoTr);
            feedbackCallbacks === null || feedbackCallbacks === void 0 || feedbackCallbacks.onDeleteTransaction(undoTr);
        })) return;
        // Recompute the delete fresh from the live document instead of
        // replaying a stashed-and-rebased transaction. The stash/rebase
        // approach produced stale, schema-invalid transactions when the
        // document changed shape (local edits or remote collab) while the
        // confirmation modal was open — the dominant signature being
        // "Invalid content for node bodiedSyncBlock: <>". See EDITOR-7889.
        api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 || _api$core2.actions.execute(({ tr: tr })=>{
            // EDITOR-8230: unsync must remove only the sync wrapper and keep the block's
            // content inline, whereas delete removes the whole block. Before this branch,
            // the confirm path always recomputed a full delete, so unsyncing a source block
            // silently deleted its content. When the deletion was actually triggered by
            // unsync, recompute an unwrap (replaceWith content) instead of a delete.
            // The same applies when the undo could not be replayed (the undo stack changed
            // while the backend delete was in flight): the backend delete has already
            // succeeded, so drop the wrapper but keep the content (EDITOR-8863).
            const recomputedTr = deletionReason === 'source-block-unsynced' || shouldReplayUndo ? (0, $3ZGpX.recomputeUnsyncTransaction)(tr, isSourceBlock, removedAttrs) : (0, $3ZGpX.recomputeDeleteTransaction)(tr, isSourceBlock, removedAttrs);
            // The target node(s) no longer exist in the live document (e.g.
            // a remote collaborator already removed them). There is nothing
            // to delete locally, so return `null` to skip the dispatch
            // entirely — dispatching the untouched transaction would be a
            // no-op that still runs the plugin's filter/append hooks. The
            // backend deletion has already been issued by the store manager.
            if (!recomputedTr) return null;
            closeBlockMenu(recomputedTr);
            recomputedTr.setMeta('isConfirmedSyncBlockDeletion', true);
            feedbackCallbacks === null || feedbackCallbacks === void 0 || feedbackCallbacks.onDeleteTransaction(recomputedTr);
            if (!recomputedTr.getMeta((0, $56AB9.pmHistoryPluginKey))) // bodiedSyncBlock deletion is expected to be permanent (cannot undo)
            // For a normal deletion (not triggered by undo), remove it from history so that it cannot be undone
            recomputedTr.setMeta('addToHistory', false);
            return recomputedTr;
        });
    }, (success)=>{
        var _api$core3;
        feedbackCallbacks === null || feedbackCallbacks === void 0 || feedbackCallbacks.onDeleteCompleted(success);
        api === null || api === void 0 || (_api$core3 = api.core) === null || _api$core3 === void 0 || _api$core3.actions.execute(({ tr: tr })=>{
            let newState;
            if (!success) newState = {
                activeFlag: {
                    id: (0, $7II9i.FLAG_ID).FAIL_TO_DELETE,
                    onRetry: $7361883d276dfb32$var$onRetry(api, syncBlockStore),
                    onDismissed: $7361883d276dfb32$var$onDismissed(syncBlockStore)
                }
            };
            else newState = {
                activeFlag: false
            };
            newState = {
                ...newState,
                bodiedSyncBlockDeletionStatus: syncBlockStore.sourceManager.isRetryingDeletion() ? // For retry, reset to none directly to clean up the status
                'none' : // For the first attempt, set to completed for deletion modal can close the modal
                'completed'
            };
            return tr.setMeta((0, $cG0Fu.syncedBlockPluginKey), newState);
        });
    }, ()=>{
        confirmationTransactionRef.current = undefined;
        feedbackCallbacks === null || feedbackCallbacks === void 0 || feedbackCallbacks.onDestroy();
    }, mechanism);
    return false;
};

});
parcelRegister("3ZGpX", function(module, exports) {
$parcel$export(module.exports, "matchesRequestedBlock", () => $12638866c4908321$export$23b09359622c8dde);
$parcel$export(module.exports, "recomputeDeleteTransaction", () => $12638866c4908321$export$71458047dba8e515);
$parcel$export(module.exports, "recomputeUnsyncTransaction", () => $12638866c4908321$export$43dcf6cfb7f47f27);

var $kW8qW = parcelRequire("kW8qW");
const $12638866c4908321$export$23b09359622c8dde = (node, wanted)=>{
    const { localId: localId, resourceId: resourceId } = node.attrs;
    if (wanted.localId && localId && wanted.localId === localId) return true;
    return Boolean(wanted.resourceId && resourceId && wanted.resourceId === resourceId);
};
/**
 * Locate the live positions of the source `bodiedSyncBlock` nodes identified by
 * `syncBlockIds`, matching first on `localId` and falling back to `resourceId`.
 *
 * This walks the *current* document (`tr.doc`) rather than relying on positions
 * captured when the delete was first triggered, so it is robust to intervening
 * local edits and remote collab changes that occur while the confirmation modal
 * is open.
 */ const $12638866c4908321$var$findSourceBlocks = (tr, isSourceBlock, syncBlockIds)=>{
    const matches = [];
    tr.doc.descendants((node, pos)=>{
        if (!isSourceBlock(node)) // bodiedSyncBlock is always a top-level node, so there is no need to
        // descend into other branches looking for one.
        return false;
        if (syncBlockIds.some((wanted)=>$12638866c4908321$export$23b09359622c8dde(node, wanted))) matches.push({
            node: node,
            pos: pos
        });
        // Never recurse into a source block's body.
        return false;
    });
    return matches;
};
const $12638866c4908321$export$71458047dba8e515 = (tr, isSourceBlock, syncBlockIds)=>{
    const matches = $12638866c4908321$var$findSourceBlocks(tr, isSourceBlock, syncBlockIds);
    if (matches.length === 0) return undefined;
    // Delete in reverse document order so positions remain valid across deletes.
    matches.sort((a, b)=>b.pos - a.pos).forEach(({ node: node, pos: pos })=>{
        tr.delete(pos, pos + node.nodeSize);
    });
    return tr;
};
const $12638866c4908321$export$43dcf6cfb7f47f27 = (tr, isSourceBlock, syncBlockIds)=>{
    const matches = $12638866c4908321$var$findSourceBlocks(tr, isSourceBlock, syncBlockIds);
    if (matches.length === 0) return undefined;
    // Unwrap in reverse document order so positions remain valid across edits.
    // Use a raw zero-open Slice replace (not `replaceWith`) so the block's content
    // is inserted verbatim as top-level nodes without ProseMirror's replaceRange
    // heuristics collapsing a trailing block (EDITOR-8230).
    const orderedMatches = matches.sort((a, b)=>b.pos - a.pos);
    for (const { node: node, pos: pos } of orderedMatches)// This is ProseMirror's Transaction.replace (a document edit), not String.replace — the
    // perf rule misfires on the method name, and there is nothing to hoist.
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace
    tr.replace(pos, pos + node.nodeSize, new (0, $kW8qW.Slice)(node.content, 0, 0));
    return tr;
};

});


parcelRegister("kTCCL", function(module, exports) {
$parcel$export(module.exports, "hasSyncedBlocks", () => $873c98d34415f096$export$cf93eddb8b14708a);
const $873c98d34415f096$export$cf93eddb8b14708a = (doc)=>{
    for(let i = 0; i < doc.childCount; i++){
        const node = doc.child(i);
        if (node.type.name === 'syncBlock' || node.type.name === 'bodiedSyncBlock') return true;
    }
    return false;
};

});

parcelRegister("dZUKh", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreDomEvent", () => $2661cca994b4e0e8$export$6b191088ef76a6be);

var $gab48 = parcelRequire("gab48");
const $2661cca994b4e0e8$export$6b191088ef76a6be = (view, event, api)=>{
    var _api$connectivity, _view$posAtCoords;
    if ((api === null || api === void 0 || (_api$connectivity = api.connectivity) === null || _api$connectivity === void 0 || (_api$connectivity = _api$connectivity.sharedState.currentState()) === null || _api$connectivity === void 0 ? void 0 : _api$connectivity.mode) !== 'offline') return;
    const { bodiedSyncBlock: bodiedSyncBlock } = view.state.schema.nodes;
    const pos = (_view$posAtCoords = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    })) === null || _view$posAtCoords === void 0 ? void 0 : _view$posAtCoords.pos;
    if (pos === undefined) return;
    const $pos = view.state.doc.resolve(pos);
    const maybeNode = (0, $gab48.findParentNodeOfTypeClosestToPos)($pos, bodiedSyncBlock);
    if (maybeNode) return true;
};

});

parcelRegister("cAJxL", function(module, exports) {
$parcel$export(module.exports, "calculateDecorations", () => $c16d01c5cc0d9f39$export$aee83dbd972779dd);

var $7VlAB = parcelRequire("7VlAB");

var $gab48 = parcelRequire("gab48");

var $a3b9P = parcelRequire("a3b9P");
const $c16d01c5cc0d9f39$export$aee83dbd972779dd = (doc, selection, schema)=>{
    const { bodiedSyncBlock: bodiedSyncBlock } = schema.nodes;
    const syncBlockParent = (0, $gab48.findParentNodeOfType)(bodiedSyncBlock)(selection);
    if (syncBlockParent) {
        const { node: node, pos: pos } = syncBlockParent;
        const decoration = (0, $a3b9P.Decoration).node(pos, pos + node.nodeSize, {
            class: `${(0, $7VlAB.BodiedSyncBlockSharedCssClassName).selectionInside}`
        });
        return (0, $a3b9P.DecorationSet).create(doc, [
            decoration
        ]);
    }
    return (0, $a3b9P.DecorationSet).empty;
};

});

parcelRegister("bzsc2", function(module, exports) {
$parcel$export(module.exports, "trackSyncBlocks", () => $985841d861df9624$export$a1196481035d4d42);
$parcel$export(module.exports, "hasEditInSyncBlock", () => $985841d861df9624$export$7531459b60818a32);

var $3DNV7 = parcelRequire("3DNV7");

var $gab48 = parcelRequire("gab48");
const $985841d861df9624$export$a1196481035d4d42 = (predicate, tr, state)=>{
    const removed = {};
    const added = {};
    if (!tr.docChanged) return {
        removed: [],
        added: []
    };
    // and cast to specific step types
    const replaceSteps = tr.steps.filter((step)=>step instanceof (0, $3DNV7.ReplaceStep) || step instanceof (0, $3DNV7.ReplaceAroundStep));
    // this is a quick check to see if any insertion/deletion of sync block happened
    const hasSyncBlockChanges = replaceSteps.some((step)=>{
        const { from: from, to: to } = step;
        const docAtStep = tr.docs[tr.steps.indexOf(step)];
        let hasChange = false;
        if (from !== to) step.getMap().forEach((oldStart, oldEnd)=>{
            if (oldStart !== oldEnd && !hasChange) {
                const deletedSlice = docAtStep.slice(Math.max(0, oldStart), Math.min(docAtStep.content.size, oldEnd));
                deletedSlice.content.forEach((node)=>{
                    if (hasChange) return;
                    // for top level nodes
                    if (predicate(node)) hasChange = true;
                });
            }
        });
        // no need to check insertions if we already found deletions
        if (step.slice.content.size > 0 && !hasChange) step.slice.content.forEach((node)=>{
            if (predicate(node) && !hasChange) hasChange = true;
        });
        return hasChange;
    });
    if (hasSyncBlockChanges) {
        const oldDoc = state.doc;
        const newDoc = tr.doc;
        const syncBlockMapOld = {};
        const syncBlockMapNew = {};
        oldDoc.content.forEach((node)=>{
            if (predicate(node)) {
                const syncBlockAttr = node.attrs;
                syncBlockMapOld[syncBlockAttr.localId] = {
                    attrs: syncBlockAttr
                };
            }
        });
        newDoc.content.forEach((node, offset)=>{
            if (predicate(node)) {
                const syncBlockAttr = node.attrs;
                syncBlockMapNew[syncBlockAttr.localId] = {
                    attrs: syncBlockAttr,
                    node: node,
                    from: offset,
                    to: offset + node.nodeSize
                };
            }
        });
        // Find removed sync blocks
        for(const localId in syncBlockMapOld)if (!syncBlockMapNew[localId]) removed[localId] = syncBlockMapOld[localId];
        // Find added sync blocks
        for(const localId in syncBlockMapNew)if (!syncBlockMapOld[localId]) added[localId] = syncBlockMapNew[localId];
    }
    return {
        removed: Object.values(removed),
        added: Object.values(added)
    };
};
const $985841d861df9624$export$7531459b60818a32 = (tr, state)=>{
    const { bodiedSyncBlock: bodiedSyncBlock } = state.schema.nodes;
    for(let i = 0; i < tr.steps.length; i++){
        const step = tr.steps[i];
        const map = step.getMap();
        const docAfterStep = tr.docs[i + 1] ?? tr.doc;
        const positions = [];
        // Extract positions from steps dynamically based on applicable properties
        if ('from' in step && typeof step.from === 'number' && 'to' in step && typeof step.to === 'number') {
            const { from: from, to: to } = step;
            positions.push(from, to);
        } else if ('pos' in step && typeof step.pos === 'number') {
            const { pos: pos } = step;
            positions.push(pos);
        }
        for (const pos of positions){
            const newPos = map.map(pos);
            if (newPos >= 0 && newPos <= docAfterStep.content.size) {
                if ((0, $gab48.findParentNodeOfTypeClosestToPos)(docAfterStep.resolve(newPos), bodiedSyncBlock)) return true;
            }
        }
    }
    return false;
};

});

parcelRegister("j5HQh", function(module, exports) {
$parcel$export(module.exports, "transactionInsertsSyncedBlock", () => $b1d2b2bcedb38528$export$d7a680e133c792af);

var $3DNV7 = parcelRequire("3DNV7");
const $b1d2b2bcedb38528$export$d7a680e133c792af = (tr)=>{
    if (!tr.docChanged) return false;
    for (const step of tr.steps){
        if (!(step instanceof (0, $3DNV7.ReplaceStep) || step instanceof (0, $3DNV7.ReplaceAroundStep))) continue;
        const childCount = step.slice.content.childCount;
        for(let i = 0; i < childCount; i++){
            const child = step.slice.content.child(i);
            if (child.type.name === 'syncBlock' || child.type.name === 'bodiedSyncBlock') return true;
        }
    }
    return false;
};

});


parcelRegister("9218x", function(module, exports) {
$parcel$export(module.exports, "findBodiedSyncBlockByLocalId", () => $8ad6de1572ad1b41$export$ce51166f6717ba9c);
$parcel$export(module.exports, "pasteSyncBlockHTMLContent", () => $8ad6de1572ad1b41$export$a97704a00c7e213a);
const $8ad6de1572ad1b41$export$ce51166f6717ba9c = (state, localId)=>{
    let result;
    state.doc.descendants((node, pos)=>{
        if (result) return false;
        if (node.type === state.schema.nodes.bodiedSyncBlock && node.attrs.localId === localId) {
            result = {
                node: node,
                pos: pos
            };
            return false;
        }
        return true;
    });
    return result;
};
const $8ad6de1572ad1b41$export$a97704a00c7e213a = (contentDOM, view)=>{
    const tmpDiv = document.createElement('div');
    tmpDiv.appendChild(contentDOM);
    // This is required so that prosemirror can read the fragment context and slice properly
    if (tmpDiv.firstChild instanceof HTMLElement) {
        tmpDiv.firstChild.setAttribute('data-pm-slice', '0 0 []');
        // As per requirement - when unsync reference block, it should render its content as copy&paste behaviour
        // Hence here we call pasteHTML to evoke editor paste logic that handles any unsupported nodes/marks
        return view.pasteHTML(tmpDiv.innerHTML);
    }
    return false;
};

});


parcelRegister("gvqC8", function(module, exports) {
$parcel$export(module.exports, "getMenuAndToolbarExperiencesPlugin", () => $9c7bcd3771814e8f$export$8e0a561331eb68ce);

var $bAB3U = parcelRequire("bAB3U");

var $g6Qq4 = parcelRequire("g6Qq4");

var $8JGzY = parcelRequire("8JGzY");
var $2KDOT = parcelRequire("2KDOT");
var $faLOc = parcelRequire("faLOc");
var $6kZ0x = parcelRequire("6kZ0x");

var $bApp6 = parcelRequire("bApp6");

var $b8RGE = parcelRequire("b8RGE");

var $73iZo = parcelRequire("73iZo");

var $9skTL = parcelRequire("9skTL");

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $7II9i = parcelRequire("7II9i");

var $cG0Fu = parcelRequire("cG0Fu");
const $9c7bcd3771814e8f$var$TIMEOUT_DURATION = 30000;
const $9c7bcd3771814e8f$var$pluginKey = new (0, $cw0wu.PluginKey)('syncedBlockMenuAndToolbarExperience');
const $9c7bcd3771814e8f$var$SYNCED_BLOCK_BUTTON_TEST_IDS = Object.values((0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID));
const $9c7bcd3771814e8f$var$syncedBlockButtonIds = new Set($9c7bcd3771814e8f$var$SYNCED_BLOCK_BUTTON_TEST_IDS);
const $9c7bcd3771814e8f$export$8e0a561331eb68ce = ({ refs: refs, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    let popupsTargetEl;
    const editorViewRef = {
        current: undefined
    };
    const getPopupsTarget = ()=>{
        if (!popupsTargetEl) {
            var _editorViewRef$curren;
            popupsTargetEl = refs.popupsMountPoint || refs.wrapperElement || (0, $2KDOT.getPopupContainerFromEditorView)(editorViewRef === null || editorViewRef === void 0 || (_editorViewRef$curren = editorViewRef.current) === null || _editorViewRef$curren === void 0 ? void 0 : _editorViewRef$curren.dom);
        }
        return popupsTargetEl;
    };
    const createSourcePrimaryToolbarExperience = new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).TOOLBAR_ACTION, {
        action: (0, $g6Qq4.ACTION).SYNCED_BLOCK_CREATE,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).PRIMARY_TOOLBAR,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $9c7bcd3771814e8f$var$TIMEOUT_DURATION
            }),
            $9c7bcd3771814e8f$var$syncedBlockAddedToDomCheck(refs, editorViewRef)
        ]
    });
    const createSourceBlockMenuExperience = new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).MENU_ACTION, {
        action: (0, $g6Qq4.ACTION).SYNCED_BLOCK_CREATE,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).BLOCK_MENU,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $9c7bcd3771814e8f$var$TIMEOUT_DURATION
            }),
            $9c7bcd3771814e8f$var$syncedBlockAddedToDomCheck(refs, editorViewRef)
        ]
    });
    const createSourceQuickInsertMenuExperience = new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).MENU_ACTION, {
        action: (0, $g6Qq4.ACTION).SYNCED_BLOCK_CREATE,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).QUICK_INSERT,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $9c7bcd3771814e8f$var$TIMEOUT_DURATION
            }),
            $9c7bcd3771814e8f$var$syncedBlockAddedToDomCheck(refs, editorViewRef)
        ]
    });
    const deleteReferenceSyncedBlockExperience = new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).TOOLBAR_ACTION, {
        action: (0, $g6Qq4.ACTION).REFERENCE_SYNCED_BLOCK_DELETE,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_TOOLBAR,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $9c7bcd3771814e8f$var$TIMEOUT_DURATION
            }),
            $9c7bcd3771814e8f$var$referenceSyncBlockRemovedFromDomCheck(refs, editorViewRef)
        ]
    });
    const unsyncReferenceSyncedBlockExperience = new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).TOOLBAR_ACTION, {
        action: (0, $g6Qq4.ACTION).REFERENCE_SYNCED_BLOCK_UNSYNC,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_TOOLBAR,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $9c7bcd3771814e8f$var$TIMEOUT_DURATION
            }),
            $9c7bcd3771814e8f$var$referenceSyncBlockRemovedFromDomCheck(refs, editorViewRef)
        ]
    });
    const unsyncSourceSyncedBlockExperience = new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).TOOLBAR_ACTION, {
        action: (0, $g6Qq4.ACTION).SYNCED_BLOCK_UNSYNC,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_TOOLBAR,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $9c7bcd3771814e8f$var$TIMEOUT_DURATION
            }),
            $9c7bcd3771814e8f$var$syncBlockDeleteConfirmationModalAddedCheck()
        ]
    });
    const deleteSourceSyncedBlockExperience = new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).TOOLBAR_ACTION, {
        action: (0, $g6Qq4.ACTION).SYNCED_BLOCK_DELETE,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_TOOLBAR,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $9c7bcd3771814e8f$var$TIMEOUT_DURATION
            }),
            $9c7bcd3771814e8f$var$syncBlockDeleteConfirmationModalAddedCheck()
        ]
    });
    const syncedLocationsExperience = new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).TOOLBAR_ACTION, {
        action: (0, $g6Qq4.ACTION).SYNCED_BLOCK_VIEW_SYNCED_LOCATIONS,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_TOOLBAR,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $9c7bcd3771814e8f$var$TIMEOUT_DURATION
            }),
            $9c7bcd3771814e8f$var$syncedLocationsDropdownOpenedCheck()
        ]
    });
    const bindListeners = ()=>{
        const unbindClickListener = (0, $bAB3U.bind)(document, {
            type: 'click',
            listener: (event)=>{
                const target = event.target;
                if (!target) return;
                const button = target.closest('button[data-testid]');
                if (!button || !(button instanceof HTMLButtonElement)) return;
                const testId = button.dataset.testid;
                if (!$9c7bcd3771814e8f$var$isSyncedBlockButtonId(testId)) return;
                if (button.disabled) return;
                $9c7bcd3771814e8f$var$handleButtonClick({
                    testId: testId,
                    button: button,
                    createSourcePrimaryToolbarExperience: createSourcePrimaryToolbarExperience,
                    createSourceBlockMenuExperience: createSourceBlockMenuExperience,
                    createSourceQuickInsertMenuExperience: createSourceQuickInsertMenuExperience,
                    deleteReferenceSyncedBlockExperience: deleteReferenceSyncedBlockExperience,
                    unsyncReferenceSyncedBlockExperience: unsyncReferenceSyncedBlockExperience,
                    unsyncSourceSyncedBlockExperience: unsyncSourceSyncedBlockExperience,
                    deleteSourceSyncedBlockExperience: deleteSourceSyncedBlockExperience,
                    syncedLocationsExperience: syncedLocationsExperience
                });
            },
            options: {
                capture: true
            }
        });
        const unbindKeydownListener = (0, $bAB3U.bind)(document, {
            type: 'keydown',
            listener: (event)=>{
                if ($9c7bcd3771814e8f$var$isEnterKey(event.key)) {
                    const typeaheadPopup = (0, $6kZ0x.popupWithNestedElement)(getPopupsTarget(), '.fabric-editor-typeahead');
                    if (!typeaheadPopup || !(typeaheadPopup instanceof HTMLElement)) return;
                    const targetElement = typeaheadPopup.querySelector('[role="option"][aria-selected="true"]');
                    if (!targetElement || !(targetElement instanceof HTMLElement)) return;
                    const testId = targetElement.dataset.testid;
                    if (testId === (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).quickInsertCreate) createSourceQuickInsertMenuExperience.start();
                }
            },
            options: {
                capture: true
            }
        });
        return {
            unbindClickListener: unbindClickListener,
            unbindKeydownListener: unbindKeydownListener
        };
    };
    return new (0, $f7Kk4.SafePlugin)({
        key: $9c7bcd3771814e8f$var$pluginKey,
        view: (view)=>{
            var _syncedBlockPluginKey;
            editorViewRef.current = view;
            // Track whether listeners have been bound. When the experiment is
            // ON and the document initially has no synced blocks, we defer
            // binding until `update()` detects that `hasSyncedBlocks` has
            // flipped to `true` (e.g. via paste or collab insert). This avoids
            // the ~2-5 ms TBT cost of capture-phase click/keydown handlers on
            // the ~99.97 % of pages that never use synced blocks (EDITOR-6931).
            let listenersBound = false;
            let unbindClickListener;
            let unbindKeydownListener;
            const ensureListenersBound = ()=>{
                if (listenersBound) return;
                listenersBound = true;
                const unbinders = bindListeners();
                unbindClickListener = unbinders.unbindClickListener;
                unbindKeydownListener = unbinders.unbindKeydownListener;
            };
            if ((_syncedBlockPluginKey = (0, $cG0Fu.syncedBlockPluginKey).getState(view.state)) !== null && _syncedBlockPluginKey !== void 0 && _syncedBlockPluginKey.hasSyncedBlocks) ensureListenersBound();
            return {
                update: (view, prevState)=>{
                    var _syncedBlockPluginKey2;
                    if (!listenersBound && view.state.doc !== prevState.doc && (_syncedBlockPluginKey2 = (0, $cG0Fu.syncedBlockPluginKey).getState(view.state)) !== null && _syncedBlockPluginKey2 !== void 0 && _syncedBlockPluginKey2.hasSyncedBlocks) // Bind listeners now that synced blocks are present.
                    ensureListenersBound();
                },
                destroy: ()=>{
                    var _unbindClickListener, _unbindKeydownListene;
                    createSourcePrimaryToolbarExperience.abort({
                        reason: 'editorDestroyed'
                    });
                    createSourceBlockMenuExperience.abort({
                        reason: 'editorDestroyed'
                    });
                    createSourceQuickInsertMenuExperience.abort({
                        reason: 'editorDestroyed'
                    });
                    deleteReferenceSyncedBlockExperience.abort({
                        reason: 'editorDestroyed'
                    });
                    deleteSourceSyncedBlockExperience === null || deleteSourceSyncedBlockExperience === void 0 || deleteSourceSyncedBlockExperience.abort({
                        reason: 'editorDestroyed'
                    });
                    unsyncReferenceSyncedBlockExperience === null || unsyncReferenceSyncedBlockExperience === void 0 || unsyncReferenceSyncedBlockExperience.abort({
                        reason: 'editorDestroyed'
                    });
                    unsyncSourceSyncedBlockExperience === null || unsyncSourceSyncedBlockExperience === void 0 || unsyncSourceSyncedBlockExperience.abort({
                        reason: 'editorDestroyed'
                    });
                    syncedLocationsExperience === null || syncedLocationsExperience === void 0 || syncedLocationsExperience.abort({
                        reason: 'editorDestroyed'
                    });
                    (_unbindClickListener = unbindClickListener) === null || _unbindClickListener === void 0 || _unbindClickListener();
                    (_unbindKeydownListene = unbindKeydownListener) === null || _unbindKeydownListene === void 0 || _unbindKeydownListene();
                }
            };
        }
    });
};
const $9c7bcd3771814e8f$var$isSyncedBlockButtonId = (value)=>{
    return !!value && $9c7bcd3771814e8f$var$syncedBlockButtonIds.has(value);
};
const $9c7bcd3771814e8f$var$handleButtonClick = ({ testId: testId, button: button, createSourcePrimaryToolbarExperience: createSourcePrimaryToolbarExperience, createSourceBlockMenuExperience: createSourceBlockMenuExperience, createSourceQuickInsertMenuExperience: createSourceQuickInsertMenuExperience, deleteReferenceSyncedBlockExperience: deleteReferenceSyncedBlockExperience, unsyncReferenceSyncedBlockExperience: unsyncReferenceSyncedBlockExperience, unsyncSourceSyncedBlockExperience: unsyncSourceSyncedBlockExperience, deleteSourceSyncedBlockExperience: deleteSourceSyncedBlockExperience, syncedLocationsExperience: syncedLocationsExperience })=>{
    switch(testId){
        case (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).primaryToolbarCreate:
            createSourcePrimaryToolbarExperience.start({
                forceRestart: true
            });
            break;
        case (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).blockMenuCreate:
            createSourceBlockMenuExperience.start({
                forceRestart: true
            });
            break;
        case (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).quickInsertCreate:
            createSourceQuickInsertMenuExperience.start({
                forceRestart: true
            });
            break;
        case (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarReferenceDelete:
            deleteReferenceSyncedBlockExperience.start({
                forceRestart: true
            });
            break;
        case (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarReferenceUnsync:
            unsyncReferenceSyncedBlockExperience === null || unsyncReferenceSyncedBlockExperience === void 0 || unsyncReferenceSyncedBlockExperience.start({
                forceRestart: true
            });
            break;
        case (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarSourceUnsync:
            unsyncSourceSyncedBlockExperience === null || unsyncSourceSyncedBlockExperience === void 0 || unsyncSourceSyncedBlockExperience.start({
                forceRestart: true
            });
            break;
        case (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarSourceDelete:
            deleteSourceSyncedBlockExperience === null || deleteSourceSyncedBlockExperience === void 0 || deleteSourceSyncedBlockExperience.start({
                forceRestart: true
            });
            break;
        case (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarSyncedLocationsTrigger:
            // Only track when opening the dropdown
            if (button.getAttribute('aria-pressed') === 'false') syncedLocationsExperience === null || syncedLocationsExperience === void 0 || syncedLocationsExperience.start({
                forceRestart: true
            });
            break;
        case (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarSourceOverflowTrigger:
        case (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarReferenceOverflowTrigger:
        case (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarCopy:
            break;
        default:
            {
                // Exhaustiveness check: if a new SyncedBlockToolbarButtonId is added
                // but not handled above, TypeScript will error here.
                const _exhaustiveCheck = testId;
                return _exhaustiveCheck;
            }
    }
};
const $9c7bcd3771814e8f$var$isEnterKey = (key)=>{
    return key === 'Enter';
};
const $9c7bcd3771814e8f$var$syncedBlockAddedToDomCheck = (refs, editorViewRef)=>new (0, $73iZo.ExperienceCheckDomMutation)({
        onDomMutation: ({ mutations: mutations })=>{
            if (mutations.some($9c7bcd3771814e8f$var$isBodiedSyncBlockAddedInMutation)) return {
                status: 'success'
            };
            return undefined;
        },
        observeConfig: ()=>{
            var _editorViewRef$curren2;
            return [
                {
                    target: editorViewRef === null || editorViewRef === void 0 || (_editorViewRef$curren2 = editorViewRef.current) === null || _editorViewRef$curren2 === void 0 ? void 0 : _editorViewRef$curren2.dom,
                    options: {
                        childList: true
                    }
                },
                // When wrapping a node with breakout mark with sync block, breakout dom is reused
                // hence we need to observe subtree to catch sync block mutation
                {
                    target: (0, $faLOc.getSelectionAncestorDOM)(editorViewRef === null || editorViewRef === void 0 ? void 0 : editorViewRef.current),
                    options: {
                        childList: true,
                        subtree: true
                    }
                }
            ];
        }
    });
const $9c7bcd3771814e8f$var$isBodiedSyncBlockAddedInMutation = ({ type: type, addedNodes: addedNodes })=>{
    return type === 'childList' && [
        ...addedNodes
    ].some($9c7bcd3771814e8f$var$isBodiedSyncBlockWithinNode);
};
const $9c7bcd3771814e8f$var$isBodiedSyncBlockWithinNode = (node)=>(0, $8JGzY.getNodeQuery)('[data-prosemirror-node-name="bodiedSyncBlock"]')(node);
const $9c7bcd3771814e8f$var$referenceSyncBlockRemovedFromDomCheck = (refs, editorViewRef)=>new (0, $73iZo.ExperienceCheckDomMutation)({
        onDomMutation: ({ mutations: mutations })=>{
            if (mutations.some($9c7bcd3771814e8f$var$isSyncBlockRemovedInMutation)) return {
                status: 'success'
            };
            return undefined;
        },
        observeConfig: ()=>{
            var _editorViewRef$curren3;
            return [
                {
                    target: editorViewRef === null || editorViewRef === void 0 || (_editorViewRef$curren3 = editorViewRef.current) === null || _editorViewRef$curren3 === void 0 ? void 0 : _editorViewRef$curren3.dom,
                    options: {
                        childList: true
                    }
                },
                {
                    target: (0, $faLOc.getSelectionAncestorDOM)(editorViewRef === null || editorViewRef === void 0 ? void 0 : editorViewRef.current),
                    options: {
                        childList: true,
                        subtree: true
                    }
                }
            ];
        }
    });
const $9c7bcd3771814e8f$var$isSyncBlockRemovedInMutation = ({ type: type, removedNodes: removedNodes })=>{
    return type === 'childList' && [
        ...removedNodes
    ].some($9c7bcd3771814e8f$var$isSyncBlockWithinNode);
};
const $9c7bcd3771814e8f$var$isSyncBlockWithinNode = (node)=>(0, $8JGzY.getNodeQuery)('[data-prosemirror-node-name="syncBlock"]')(node);
const $9c7bcd3771814e8f$var$syncBlockDeleteConfirmationModalAddedCheck = ()=>new (0, $73iZo.ExperienceCheckDomMutation)({
        onDomMutation: ({ mutations: mutations })=>{
            if (mutations.some($9c7bcd3771814e8f$var$isDeleteConfirmationModalAddedInMutation)) return {
                status: 'success'
            };
            return undefined;
        },
        observeConfig: ()=>{
            return {
                target: document.body,
                options: {
                    childList: true,
                    subtree: true
                }
            };
        }
    });
const $9c7bcd3771814e8f$var$isDeleteConfirmationModalAddedInMutation = ({ type: type, addedNodes: addedNodes })=>{
    return type === 'childList' && [
        ...addedNodes
    ].some($9c7bcd3771814e8f$var$isDeleteConfirmationModalWithinNode);
};
const $9c7bcd3771814e8f$var$isDeleteConfirmationModalWithinNode = (node)=>(0, $8JGzY.getNodeQuery)('[data-testid="sync-block-delete-confirmation"]')(node);
const $9c7bcd3771814e8f$var$syncedLocationsDropdownOpenedCheck = ()=>new (0, $73iZo.ExperienceCheckDomMutation)({
        onDomMutation: ({ mutations: mutations })=>{
            if (mutations.some($9c7bcd3771814e8f$var$isSyncedLocationsDropdownErrorInMutation)) return {
                status: 'failure'
            };
            if (mutations.some($9c7bcd3771814e8f$var$isSyncedLocationsDropdownAddedInMutation)) return {
                status: 'success'
            };
            return undefined;
        },
        observeConfig: ()=>{
            return {
                target: document.body,
                options: {
                    childList: true,
                    subtree: true
                }
            };
        }
    });
const $9c7bcd3771814e8f$var$isSyncedLocationsDropdownAddedInMutation = ({ type: type, addedNodes: addedNodes })=>{
    return type === 'childList' && [
        ...addedNodes
    ].some($9c7bcd3771814e8f$var$isSyncedLocationsDropdownWithinNode);
};
const $9c7bcd3771814e8f$var$isSyncedLocationsDropdownErrorInMutation = ({ type: type, addedNodes: addedNodes })=>{
    return type === 'childList' && [
        ...addedNodes
    ].some($9c7bcd3771814e8f$var$isSyncedLocationsDropdownErrorWithinNode);
};
const $9c7bcd3771814e8f$var$isSyncedLocationsDropdownWithinNode = (node)=>{
    return !!((0, $8JGzY.getNodeQuery)('[data-testid="synced-locations-dropdown-content"]')(node) || (0, $8JGzY.getNodeQuery)('[data-testid="synced-locations-dropdown-content-no-results"]')(node));
};
const $9c7bcd3771814e8f$var$isSyncedLocationsDropdownErrorWithinNode = (node)=>{
    return !!(0, $8JGzY.getNodeQuery)('[data-testid="synced-locations-dropdown-content-error"]')(node);
};

});
parcelRegister("8JGzY", function(module, exports) {
$parcel$export(module.exports, "getNodeQuery", () => $d6e3c96cbc45fec0$export$a3814e00999abbb7);
/**
 * Checks if a node matches or contains the node given by the provided query css selector
 *
 * @param query - CSS selector string
 * @returns true if node matches or contains query or false otherwise
 */ const $d6e3c96cbc45fec0$export$a3814e00999abbb7 = (query)=>(node)=>{
        if (!node || !(node instanceof Element)) return false;
        return node.matches(query) || node.querySelector(query) !== null;
    };

});


parcelRegister("ksf75", function(module, exports) {
$parcel$export(module.exports, "getBlockMenuComponents", () => $5695aa7ecd29af6a$export$b1be7b75e24fc24b);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $30Yan = parcelRequire("30Yan");

var $fY4jW = parcelRequire("fY4jW");

var $h3NT6 = parcelRequire("h3NT6");
const $5695aa7ecd29af6a$export$b1be7b75e24fc24b = (api, enableSourceSyncedBlockCreation)=>{
    return [
        {
            type: 'block-menu-item',
            key: (0, $30Yan.BLOCK_ACTIONS_CREATE_SYNCED_BLOCK_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $30Yan.TRANSFORM_MENU_SECTION).key,
                rank: (0, $fY4jW.TRANSFORM_MENU_SECTION_RANK)[(0, $30Yan.BLOCK_ACTIONS_CREATE_SYNCED_BLOCK_MENU_ITEM).key]
            },
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $h3NT6.CreateOrCopySyncedBlockDropdownItem), {
                    api: api,
                    enableSourceSyncedBlockCreation: enableSourceSyncedBlockCreation
                })
        }
    ];
};

});
parcelRegister("h3NT6", function(module, exports) {
$parcel$export(module.exports, "CreateOrCopySyncedBlockDropdownItem", () => $05ffe6c231970de8$export$3699afce8ee13fa8);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $hVGJk = parcelRequire("hVGJk");

var $hETL4 = parcelRequire("hETL4");

var $9dhQr = parcelRequire("9dhQr");

var $5beht = parcelRequire("5beht");

var $539NH = parcelRequire("539NH");

var $dbuPt = parcelRequire("dbuPt");

var $1emO3 = parcelRequire("1emO3");

var $gdUUy = parcelRequire("gdUUy");

var $QIBX2 = parcelRequire("QIBX2");

var $7II9i = parcelRequire("7II9i");
const $05ffe6c231970de8$var$SyncedBlockNewLozenge = ({ label: label })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $1emO3.default), {
        appearance: (0, $gdUUy.fg)('confluence_fronend_labels_categorization_migration') ? 'discovery' : 'new',
        children: label
    });
const $05ffe6c231970de8$var$CreateSyncedBlockDropdownItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { selection: selection, menuTriggerByNode: menuTriggerByNode, mode: mode } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'selection',
        'blockControls',
        'connectivity'
    ], (states)=>{
        var _states$selectionStat, _states$blockControls, _states$connectivityS;
        return {
            selection: (_states$selectionStat = states.selectionState) === null || _states$selectionStat === void 0 ? void 0 : _states$selectionStat.selection,
            menuTriggerByNode: ((_states$blockControls = states.blockControlsState) === null || _states$blockControls === void 0 ? void 0 : _states$blockControls.menuTriggerByNode) ?? undefined,
            mode: (_states$connectivityS = states.connectivityState) === null || _states$connectivityS === void 0 ? void 0 : _states$connectivityS.mode
        };
    });
    const isNested = menuTriggerByNode && menuTriggerByNode.rootPos !== menuTriggerByNode.pos;
    const canBeConverted = (0, $bSJIT.useMemo)(()=>selection && (0, $QIBX2.canBeConvertedToSyncBlock)(selection), [
        selection
    ]);
    if (isNested || !canBeConverted) return null;
    const onClick = ()=>{
        var _api$core;
        // Insert the synced block, close the block menu, and stop preserving the
        // selection — all in a single transaction, mirroring the block-menu delete
        // item. Stopping preservation is required so the caret that
        // insertSyncedBlock places inside the new block survives; otherwise
        // block-controls restores a whole-node NodeSelection over it, hiding the
        // caret (EDITOR-7949). Then re-focus the editor so the caret is active,
        // but only when the transaction was actually dispatched — otherwise a
        // failed insertion would still steal DOM focus into the editor.
        const dispatched = api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 ? void 0 : _api$core.actions.execute(({ tr: tr })=>{
            var _api$blockControls, _api$blockControls2;
            // If the insertion fails, bail out without closing the menu or
            // stopping selection preservation — otherwise we would dispatch an
            // effectively-empty transaction and close the menu despite nothing
            // having been inserted.
            const result = api === null || api === void 0 ? void 0 : api.syncedBlock.commands.insertSyncedBlock((0, $g6Qq4.INPUT_METHOD).BLOCK_MENU)({
                tr: tr
            });
            if (!result) return null;
            api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || (_api$blockControls = _api$blockControls.commands) === null || _api$blockControls === void 0 || _api$blockControls.toggleBlockMenu({
                closeMenu: true
            })({
                tr: tr
            });
            api === null || api === void 0 || (_api$blockControls2 = api.blockControls) === null || _api$blockControls2 === void 0 || (_api$blockControls2 = _api$blockControls2.commands) === null || _api$blockControls2 === void 0 || _api$blockControls2.stopPreservingSelection()({
                tr: tr
            });
            return tr;
        });
        if (dispatched) {
            var _api$core2;
            api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 || _api$core2.actions.focus();
        }
    };
    const isOffline = (0, $hVGJk.isOfflineMode)(mode);
    const lozenge = /*#__PURE__*/ (0, $dc70d.jsx)($05ffe6c231970de8$var$SyncedBlockNewLozenge, {
        label: formatMessage((0, $hETL4.messages).newLozenge)
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($539NH))), {
            label: "",
            size: "small"
        }),
        onClick: onClick,
        isDisabled: isOffline,
        testId: (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).blockMenuCreate,
        elemAfterText: lozenge,
        children: formatMessage((0, $hETL4.messages).syncBlock)
    });
};
const $05ffe6c231970de8$var$CopySyncedBlockDropdownItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { mode: mode } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'connectivity'
    ], (states)=>{
        var _states$connectivityS2;
        return {
            mode: (_states$connectivityS2 = states.connectivityState) === null || _states$connectivityS2 === void 0 ? void 0 : _states$connectivityS2.mode
        };
    });
    const onClick = ()=>{
        var _api$core3, _api$core4, _api$blockControls3;
        api === null || api === void 0 || (_api$core3 = api.core) === null || _api$core3 === void 0 || _api$core3.actions.execute(api === null || api === void 0 ? void 0 : api.syncedBlock.commands.copySyncedBlockReferenceToClipboard((0, $g6Qq4.INPUT_METHOD).BLOCK_MENU));
        api === null || api === void 0 || (_api$core4 = api.core) === null || _api$core4 === void 0 || _api$core4.actions.execute(api === null || api === void 0 || (_api$blockControls3 = api.blockControls) === null || _api$blockControls3 === void 0 || (_api$blockControls3 = _api$blockControls3.commands) === null || _api$blockControls3 === void 0 ? void 0 : _api$blockControls3.toggleBlockMenu({
            closeMenu: true
        }));
    };
    const lozenge = /*#__PURE__*/ (0, $dc70d.jsx)($05ffe6c231970de8$var$SyncedBlockNewLozenge, {
        label: formatMessage((0, $hETL4.messages).newLozenge)
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($539NH))), {
            label: "",
            size: "small"
        }),
        onClick: onClick,
        isDisabled: (0, $hVGJk.isOfflineMode)(mode),
        elemAfterText: lozenge,
        children: formatMessage((0, $9dhQr.syncBlockMessages).copyToSyncLabel)
    });
};
const $05ffe6c231970de8$export$3699afce8ee13fa8 = ({ api: api, enableSourceSyncedBlockCreation: enableSourceSyncedBlockCreation })=>{
    const { menuTriggerByNode: menuTriggerByNode } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], (states)=>{
        var _states$blockControls2;
        return {
            menuTriggerByNode: ((_states$blockControls2 = states.blockControlsState) === null || _states$blockControls2 === void 0 ? void 0 : _states$blockControls2.menuTriggerByNode) ?? undefined
        };
    });
    if ((menuTriggerByNode === null || menuTriggerByNode === void 0 ? void 0 : menuTriggerByNode.nodeType) === 'syncBlock' || (menuTriggerByNode === null || menuTriggerByNode === void 0 ? void 0 : menuTriggerByNode.nodeType) === 'bodiedSyncBlock') return /*#__PURE__*/ (0, $dc70d.jsx)($05ffe6c231970de8$var$CopySyncedBlockDropdownItem, {
        api: api
    });
    else if (enableSourceSyncedBlockCreation) return /*#__PURE__*/ (0, $dc70d.jsx)($05ffe6c231970de8$var$CreateSyncedBlockDropdownItem, {
        api: api
    });
    else return null;
};

});


parcelRegister("fNUvY", function(module, exports) {
$parcel$export(module.exports, "DeleteConfirmationModal", () => $fbba31859af7f49e$export$d973532b09e0f2cc);
/* DeleteConfirmationModal.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $jNJGJ = parcelRequire("jNJGJ");

var $hVGJk = parcelRequire("hVGJk");

var $9dhQr = parcelRequire("9dhQr");

var $5beht = parcelRequire("5beht");

var $2w1u7 = parcelRequire("2w1u7");

var $c9mVs = parcelRequire("c9mVs");

var $7HzAO = parcelRequire("7HzAO");

var $j4mCC = parcelRequire("j4mCC");

var $4TlNm = parcelRequire("4TlNm");

var $lFaAn = parcelRequire("lFaAn");

var $9PwDt = parcelRequire("9PwDt");

var $8aT4G = parcelRequire("8aT4G");

var $hDkm2 = parcelRequire("hDkm2");

var $cG0Fu = parcelRequire("cG0Fu");
const $fbba31859af7f49e$var$modalContentMap = {
    'source-block-deleted': {
        titleMultiple: (0, $9dhQr.syncBlockMessages).deleteConfirmationModalTitleMultiple,
        titleSingle: (0, $9dhQr.syncBlockMessages).deletionConfirmationModalTitleSingle,
        descriptionSingle: (0, $9dhQr.syncBlockMessages).deletionConfirmationModalDescriptionNoRef,
        descriptionMultiple: (0, $9dhQr.syncBlockMessages).deletionConfirmationModalDescriptionNew,
        confirmButtonLabel: (0, $9dhQr.syncBlockMessages).deleteConfirmationModalDeleteButton
    },
    'source-block-unpublished': {
        titleMultiple: (0, $9dhQr.syncBlockMessages).deleteConfirmationModalTitleMultiple,
        titleSingle: (0, $9dhQr.syncBlockMessages).deletionConfirmationModalTitleSingle,
        descriptionSingle: (0, $9dhQr.syncBlockMessages).deletionConfirmationModalDescriptionNoRef,
        descriptionMultiple: (0, $9dhQr.syncBlockMessages).deletionConfirmationModalDescriptionNew,
        confirmButtonLabel: (0, $9dhQr.syncBlockMessages).deleteConfirmationModalDeleteButton
    },
    'source-block-unsynced': {
        titleMultiple: (0, $9dhQr.syncBlockMessages).unsyncConfirmationModalTitle,
        titleSingle: (0, $9dhQr.syncBlockMessages).unsyncConfirmationModalTitle,
        descriptionSingle: (0, $9dhQr.syncBlockMessages).unsyncConfirmModalDescriptionSingle,
        descriptionMultiple: (0, $9dhQr.syncBlockMessages).unsyncConfirmModalDescriptionMultipleNew,
        confirmButtonLabel: (0, $9dhQr.syncBlockMessages).deleteConfirmationModalUnsyncButton
    }
};
const $fbba31859af7f49e$var$styles = {
    spinner: "_1mou1wug _195g1wug"
};
const $fbba31859af7f49e$export$d973532b09e0f2cc = ({ syncBlockStoreManager: syncBlockStoreManager, api: api, editorView: editorView })=>{
    var _api$core2, _api$decorations2, _api$core5, _api$core8;
    const [isOpen, setIsOpen] = (0, $bSJIT.useState)(false);
    const [syncBlockIds, setSyncBlockIds] = (0, $bSJIT.useState)(undefined);
    const [referenceCount, setReferenceCount] = (0, $bSJIT.useState)(undefined);
    const [deleteReason, setDeleteReason] = (0, $bSJIT.useState)('source-block-deleted');
    const { mode: mode, bodiedSyncBlockDeletionStatus: bodiedSyncBlockDeletionStatus, activeFlag: activeFlag } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'connectivity',
        'syncedBlock'
    ], (states)=>{
        var _states$connectivityS, _states$syncedBlockSt, _states$syncedBlockSt2;
        return {
            mode: (_states$connectivityS = states.connectivityState) === null || _states$connectivityS === void 0 ? void 0 : _states$connectivityS.mode,
            bodiedSyncBlockDeletionStatus: (_states$syncedBlockSt = states.syncedBlockState) === null || _states$syncedBlockSt === void 0 ? void 0 : _states$syncedBlockSt.bodiedSyncBlockDeletionStatus,
            activeFlag: (_states$syncedBlockSt2 = states.syncedBlockState) === null || _states$syncedBlockSt2 === void 0 ? void 0 : _states$syncedBlockSt2.activeFlag
        };
    });
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const resolverRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(undefined);
    // When a source block with no references is deleted, the modal is never shown but
    // onDeleteCompleted still sets bodiedSyncBlockDeletionStatus to 'completed'. This ref signals
    // the useEffect to silently reset the status without trying to close the modal (which was never open).
    const skipModalOnCompletedRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(false);
    const handleClick = (0, $bSJIT.useCallback)((confirm)=>()=>{
            var _api$core;
            if (resolverRef.current) {
                resolverRef.current(confirm);
                resolverRef.current = undefined;
            }
            if (!confirm) {
                setIsOpen(false);
                setReferenceCount(undefined);
            }
            api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(({ tr: tr })=>{
                return tr.setMeta((0, $cG0Fu.syncedBlockPluginKey), {
                    bodiedSyncBlockDeletionStatus: confirm ? 'processing' : 'none',
                    activeFlag: false
                });
            });
            // The delete menu adds a `danger` decoration that it only clears on mouse leave, which
            // never fires because clicking Delete closes the menu. It stays for the lifetime of this
            // modal so the block being deleted remains highlighted, and confirming drops it along
            // with the node, but cancelling has to clear it or the red highlight is left behind.
            if (!confirm && editorView) {
                var _api$decorations;
                api === null || api === void 0 || (_api$decorations = api.decorations) === null || _api$decorations === void 0 || _api$decorations.actions.removeDecoration(editorView.state, editorView.dispatch);
            }
        }, [
        api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 ? void 0 : _api$core2.actions,
        api === null || api === void 0 || (_api$decorations2 = api.decorations) === null || _api$decorations2 === void 0 ? void 0 : _api$decorations2.actions,
        editorView
    ]);
    // Store activeFlag in a ref so confirmationCallback always reads the latest value
    // even if it changes during the await fetchReferenceCountRef call.
    const activeFlagRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(activeFlag);
    activeFlagRef.current = activeFlag;
    // Use a ref so fetchReferenceCount can be called from confirmationCallback without
    // being added to its dependency array — preventing confirmationCallback from being
    // recreated mid-flight during an await (which would break the promise chain).
    // The assignment during render is intentional — this is a standard React ref-as-latest-value
    // pattern. The reduce over syncBlockIds (typically 1-2 items) is not actually expensive.
    const fetchReferenceCountRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(()=>Promise.resolve(0));
    fetchReferenceCountRef.current = async (syncBlockIds)=>{
        const references = await Promise.all(syncBlockIds.map(async (syncBlockId)=>{
            var _result$references;
            const result = await syncBlockStoreManager.sourceManager.fetchReferences(syncBlockId.resourceId);
            if (result !== null && result !== void 0 && result.error) // Consider fetch fails as soon as one of the fetches fails
            throw new Error();
            return ((_result$references = result.references) === null || _result$references === void 0 ? void 0 : _result$references.length) ?? 0;
        }));
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render
        return references.reduce((sum, count)=>sum + count, 0);
    };
    const confirmationCallback = (0, $bSJIT.useCallback)(async (syncBlockIds, deleteReason)=>{
        // Fetch references before opening the modal. If none exist, skip the modal
        // entirely and auto-confirm the deletion. On fetch error, default to showing
        // the modal to avoid accidental data loss.
        let count;
        try {
            count = await fetchReferenceCountRef.current(syncBlockIds);
        } catch  {
            count = 1;
        }
        if (count === 0) {
            var _api$core3;
            // No references — auto-confirm without showing the modal.
            // Clear activeFlag to avoid issues with subsequent deletion attempts.
            // We do NOT reset bodiedSyncBlockDeletionStatus here because onDeleteCompleted
            // will set it to 'completed' after the delete call returns. Instead we use a
            // ref to signal that the next 'completed' status should be silently reset
            // without trying to close the modal.
            skipModalOnCompletedRef.current = true;
            api === null || api === void 0 || (_api$core3 = api.core) === null || _api$core3 === void 0 || _api$core3.actions.execute(({ tr: tr })=>{
                return tr.setMeta((0, $cG0Fu.syncedBlockPluginKey), {
                    ...activeFlagRef.current ? {
                        activeFlag: false
                    } : {}
                });
            });
            return true;
        }
        setReferenceCount(count);
        setIsOpen(true);
        setSyncBlockIds(syncBlockIds);
        if (deleteReason) setDeleteReason(deleteReason);
        const confirmedPromise = new Promise((resolve)=>{
            resolverRef.current = resolve;
        });
        if (activeFlagRef.current) {
            var _api$core4;
            api === null || api === void 0 || (_api$core4 = api.core) === null || _api$core4 === void 0 || _api$core4.actions.execute(({ tr: tr })=>{
                return tr.setMeta((0, $cG0Fu.syncedBlockPluginKey), {
                    // Clear flag to avoid potential retry deletion of different blocks
                    activeFlag: false
                });
            });
        }
        return confirmedPromise;
    }, // fetchReferenceCountRef and activeFlagRef are intentionally omitted — they are refs
    // and never change identity, ensuring confirmationCallback is never recreated mid-flight
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        api === null || api === void 0 || (_api$core5 = api.core) === null || _api$core5 === void 0 ? void 0 : _api$core5.actions
    ]);
    (0, $bSJIT.useEffect)(()=>{
        const unregister = syncBlockStoreManager.sourceManager.registerConfirmationCallback(confirmationCallback);
        return ()=>{
            unregister();
        };
    }, [
        syncBlockStoreManager,
        confirmationCallback
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (skipModalOnCompletedRef.current) {
            if (bodiedSyncBlockDeletionStatus === 'completed') {
                var _api$core6;
                // Deletion was auto-confirmed without showing the modal (no references).
                // Reset the status to 'none' — keep skipModalOnCompletedRef true until
                // we confirm the status has landed as 'none' to guard against the race where
                // the next deletion opens the modal before this transaction is processed.
                api === null || api === void 0 || (_api$core6 = api.core) === null || _api$core6 === void 0 || _api$core6.actions.execute(({ tr: tr })=>{
                    return tr.setMeta((0, $cG0Fu.syncedBlockPluginKey), {
                        bodiedSyncBlockDeletionStatus: 'none'
                    });
                });
            } else if (bodiedSyncBlockDeletionStatus === 'none') skipModalOnCompletedRef.current = false;
            else if (bodiedSyncBlockDeletionStatus === 'processing' && isOpen) // Reset on deletion failure (e.g. network error) to avoid modal stuck in opened state.
            skipModalOnCompletedRef.current = false;
            return;
        }
        if (bodiedSyncBlockDeletionStatus === 'completed' && isOpen) {
            var _api$core7;
            // auto close modal once deletion is successful
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            setIsOpen(false);
            api === null || api === void 0 || (_api$core7 = api.core) === null || _api$core7 === void 0 || _api$core7.actions.execute(({ tr: tr })=>{
                return tr.setMeta((0, $cG0Fu.syncedBlockPluginKey), {
                    // Reset deletion status to have a clean state for next deletion
                    bodiedSyncBlockDeletionStatus: 'none'
                });
            });
        }
    }, [
        api === null || api === void 0 || (_api$core8 = api.core) === null || _api$core8 === void 0 ? void 0 : _api$core8.actions,
        bodiedSyncBlockDeletionStatus,
        isOpen
    ]);
    // References are fetched and set before the modal opens in
    // confirmationCallback, so no additional fetch is needed here.
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lFaAn.default), {
        children: isOpen && /*#__PURE__*/ (0, $dc70d.jsx)((0, $c9mVs.default), {
            onClose: handleClick(false),
            testId: "sync-block-delete-confirmation",
            height: 184,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
                children: referenceCount === undefined ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                    xcss: $fbba31859af7f49e$var$styles.spinner,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hDkm2.default), {
                        size: "large"
                    })
                }) : /*#__PURE__*/ (0, $dc70d.jsx)($fbba31859af7f49e$var$ModalContent, {
                    content: $fbba31859af7f49e$var$modalContentMap[deleteReason],
                    referenceCount: referenceCount,
                    handleClick: handleClick,
                    formatMessage: formatMessage,
                    isDeleting: bodiedSyncBlockDeletionStatus === 'processing',
                    isDisabled: (0, $hVGJk.isOfflineMode)(mode),
                    deleteReason: deleteReason,
                    sourceCount: (syncBlockIds === null || syncBlockIds === void 0 ? void 0 : syncBlockIds.length) || 0
                })
            })
        })
    });
};
const $fbba31859af7f49e$var$ModalContent = ({ content: content, referenceCount: referenceCount, handleClick: handleClick, formatMessage: formatMessage, isDeleting: isDeleting, isDisabled: isDisabled, deleteReason: deleteReason, sourceCount: sourceCount })=>{
    const { titleMultiple: titleMultiple, titleSingle: titleSingle, descriptionSingle: descriptionSingle, descriptionMultiple: descriptionMultiple, confirmButtonLabel: confirmButtonLabel } = content;
    const hasNoReferenceOrFailToFetch = referenceCount === 0;
    const totalLocationCount = deleteReason === 'source-block-deleted' ? referenceCount + sourceCount : referenceCount;
    const isReferenceCountDescriptionEnabled = deleteReason === 'source-block-deleted';
    const descriptionLocationCount = isReferenceCountDescriptionEnabled ? referenceCount : totalLocationCount;
    const descriptionMultipleMessage = isReferenceCountDescriptionEnabled ? (0, $9dhQr.syncBlockMessages).deletionConfirmationModalDescriptionReferenceCount : descriptionMultiple;
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $j4mCC.default), {
                hasCloseButton: true,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4TlNm.default), {
                    appearance: "warning",
                    children: hasNoReferenceOrFailToFetch ? formatMessage(titleSingle) : formatMessage(titleMultiple, {
                        count: totalLocationCount
                    })
                })
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $2w1u7.default), {
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                    children: hasNoReferenceOrFailToFetch ? formatMessage(descriptionSingle) : formatMessage(descriptionMultipleMessage, {
                        syncBlockCount: descriptionLocationCount
                    })
                })
            }),
            /*#__PURE__*/ (0, $dc70d.jsxs)((0, $7HzAO.default), {
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
                        appearance: "subtle",
                        onClick: handleClick(false),
                        children: formatMessage((0, $9dhQr.syncBlockMessages).deleteConfirmationModalCancelButton)
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
                        appearance: "warning",
                        onClick: handleClick(true),
                        autoFocus: true,
                        isDisabled: isDisabled,
                        isLoading: isDeleting,
                        testId: `synced-block-delete-confirmation-modal-${deleteReason}-button`,
                        children: formatMessage(confirmButtonLabel)
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("3BkSH", function(module, exports) {
$parcel$export(module.exports, "Flag", () => $af1e779ed441548e$export$48ea269755562084);
/* Flag.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $hVGJk = parcelRequire("hVGJk");

var $9dhQr = parcelRequire("9dhQr");

var $bUkfH = parcelRequire("bUkfH");

var $5beht = parcelRequire("5beht");

var $eJ0Uu = parcelRequire("eJ0Uu");

var $2bmUD = parcelRequire("2bmUD");

var $lJzMO = parcelRequire("lJzMO");

var $jE5M0 = parcelRequire("jE5M0");

var $lP6sB = parcelRequire("lP6sB");

var $dsw4B = parcelRequire("dsw4B");

var $3y2s4 = parcelRequire("3y2s4");

var $bLXMw = parcelRequire("bLXMw");

var $cG0Fu = parcelRequire("cG0Fu");

var $7II9i = parcelRequire("7II9i");
const $af1e779ed441548e$var$feedbackFlagStyles = null;
const $af1e779ed441548e$var$flagMap = {
    [(0, $7II9i.FLAG_ID).CANNOT_DELETE_WHEN_OFFLINE]: {
        title: (0, $9dhQr.syncBlockMessages).failToDeleteTitle,
        description: (0, $9dhQr.syncBlockMessages).failToDeleteWhenOfflineDescription,
        type: 'error'
    },
    [(0, $7II9i.FLAG_ID).CANNOT_EDIT_WHEN_OFFLINE]: {
        title: (0, $9dhQr.syncBlockMessages).failToEditTitle,
        description: (0, $9dhQr.syncBlockMessages).failToEditWhenOfflineDescription,
        type: 'error'
    },
    [(0, $7II9i.FLAG_ID).CANNOT_CREATE_WHEN_OFFLINE]: {
        title: (0, $9dhQr.syncBlockMessages).failToCreateTitle,
        description: (0, $9dhQr.syncBlockMessages).failToCreateWhenOfflineDescription,
        type: 'error'
    },
    [(0, $7II9i.FLAG_ID).FAIL_TO_DELETE]: {
        title: (0, $9dhQr.syncBlockMessages).cannotDeleteTitle,
        description: (0, $9dhQr.syncBlockMessages).cannotDeleteDescription,
        type: 'error'
    },
    [(0, $7II9i.FLAG_ID).SYNC_BLOCK_COPIED]: {
        title: (0, $9dhQr.syncBlockMessages).syncBlockCopiedTitle,
        type: 'info'
    },
    [(0, $7II9i.FLAG_ID).UNPUBLISHED_SYNC_BLOCK_PASTED]: {
        title: (0, $9dhQr.syncBlockMessages).unpublishedSyncBlockPastedTitle,
        description: (0, $9dhQr.syncBlockMessages).unpublishedSyncBlockPastedDescription,
        type: 'info'
    },
    [(0, $7II9i.FLAG_ID).CANNOT_CREATE_SYNC_BLOCK]: {
        title: (0, $9dhQr.syncBlockMessages).cannotCreateSyncBlockTitle,
        description: (0, $9dhQr.syncBlockMessages).CannotCreateSyncBlockDescription,
        type: 'error'
    },
    [(0, $7II9i.FLAG_ID).EXTENSION_IN_SYNC_BLOCK]: {
        title: (0, $9dhQr.syncBlockMessages).extensionInSyncBlockTitle,
        description: (0, $9dhQr.syncBlockMessages).extensionInSyncBlockDescription,
        type: 'error'
    },
    [(0, $7II9i.FLAG_ID).INLINE_EXTENSION_IN_SYNC_BLOCK]: {
        title: (0, $9dhQr.syncBlockMessages).inlineExtensionInSyncBlockTitle,
        description: (0, $9dhQr.syncBlockMessages).inlineExtensionInSyncBlockDescription,
        type: 'error'
    },
    [(0, $7II9i.FLAG_ID).DUPLICATE_SOURCE_SYNC_BLOCK]: {
        title: (0, $9dhQr.syncBlockMessages).duplicateSourceSyncBlockTitle,
        description: (0, $9dhQr.syncBlockMessages).duplicateSourceSyncBlockDescription,
        type: 'error'
    },
    [(0, $7II9i.FLAG_ID).SYNC_BLOCK_FEEDBACK_PROMPT]: {
        title: (0, $9dhQr.syncBlockMessages).feedbackFlagTitle,
        description: (0, $9dhQr.syncBlockMessages).feedbackFlagDescription,
        type: 'feedback'
    }
};
const $af1e779ed441548e$export$ff27f1a30a9d5c47 = (activeFlag, isCopiedDescriptionEnabled)=>{
    if (!activeFlag || activeFlag.id !== (0, $7II9i.FLAG_ID).SYNC_BLOCK_COPIED || !isCopiedDescriptionEnabled) return undefined;
    if (activeFlag.sourceProduct === 'jira-work-item') return activeFlag.isSourceContentUnpublished ? (0, $9dhQr.syncBlockMessages).syncBlockCopiedJiraUnsavedFieldDescription : (0, $9dhQr.syncBlockMessages).syncBlockCopiedLivePageDescription;
    if (activeFlag.sourceProduct !== 'confluence-page') return undefined;
    return activeFlag.isLivePage || !activeFlag.isSourceContentUnpublished ? (0, $9dhQr.syncBlockMessages).syncBlockCopiedLivePageDescription : (0, $9dhQr.syncBlockMessages).syncBlockCopiedUnpublishedDescription;
};
const $af1e779ed441548e$var$useSyncBlockSourceUrl = (syncBlockStore, resourceId)=>{
    const [sourceUrl, setSourceUrl] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState();
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        setSourceUrl(undefined);
        if (!syncBlockStore || !resourceId) return;
        const { referenceManager: referenceManager } = syncBlockStore;
        const cachedSourceUrl = referenceManager.getSyncBlockURL(resourceId);
        if (cachedSourceUrl) {
            setSourceUrl(cachedSourceUrl);
            return;
        }
        let isCancelled = false;
        referenceManager.fetchSyncBlockSourceInfo(resourceId).then((sourceInfo)=>{
            if (!isCancelled) setSourceUrl(sourceInfo === null || sourceInfo === void 0 ? void 0 : sourceInfo.url);
        });
        return ()=>{
            isCancelled = true;
        };
    }, [
        syncBlockStore,
        resourceId
    ]);
    return sourceUrl;
};
const $af1e779ed441548e$export$48ea269755562084 = ({ api: api, onFeedbackPromptShown: onFeedbackPromptShown, onGiveFeedback: onGiveFeedback })=>{
    const { activeFlag: activeFlag, mode: mode, syncBlockStore: syncBlockStore } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'syncedBlock',
        'connectivity'
    ], (states)=>{
        var _states$syncedBlockSt, _states$connectivityS, _states$syncedBlockSt2;
        return {
            activeFlag: (_states$syncedBlockSt = states.syncedBlockState) === null || _states$syncedBlockSt === void 0 ? void 0 : _states$syncedBlockSt.activeFlag,
            mode: (_states$connectivityS = states.connectivityState) === null || _states$connectivityS === void 0 ? void 0 : _states$connectivityS.mode,
            syncBlockStore: (_states$syncedBlockSt2 = states.syncedBlockState) === null || _states$syncedBlockSt2 === void 0 ? void 0 : _states$syncedBlockSt2.syncBlockStore
        };
    });
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const isFeedbackPromptVisible = activeFlag && activeFlag.id === (0, $7II9i.FLAG_ID).SYNC_BLOCK_FEEDBACK_PROMPT;
    const isJiraUnpublishedPaste = !!activeFlag && activeFlag.id === (0, $7II9i.FLAG_ID).UNPUBLISHED_SYNC_BLOCK_PASTED && activeFlag.sourceProduct === 'jira-work-item';
    const sourceUrl = $af1e779ed441548e$var$useSyncBlockSourceUrl(syncBlockStore, activeFlag && isJiraUnpublishedPaste && (0, $3y2s4.isExperimentEnabled)('editor_synced_blocks_jira_custom_rich_text') ? activeFlag.resourceId : undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        if (!isFeedbackPromptVisible || !onFeedbackPromptShown) return;
        try {
            const promptShownResult = onFeedbackPromptShown();
            Promise.resolve(promptShownResult).catch(()=>{});
        } catch  {
        // Prompt persistence is optional product UI.
        }
    }, [
        isFeedbackPromptVisible,
        onFeedbackPromptShown
    ]);
    if (!activeFlag) return;
    const { title: defaultTitle, description: defaultDescription, action: action, type: type } = $af1e779ed441548e$var$flagMap[activeFlag.id];
    const { onRetry: onRetry, onDismissed: onDismissedCallback } = activeFlag;
    const isCopiedFlag = activeFlag.id === (0, $7II9i.FLAG_ID).SYNC_BLOCK_COPIED;
    const isCopiedDescriptionEnabled = isCopiedFlag && ((0, $3y2s4.isExperimentEnabled)('platform_editor_blocks_patch_11') || activeFlag.sourceProduct === 'confluence-page');
    const copiedDescription = $af1e779ed441548e$export$ff27f1a30a9d5c47(activeFlag, isCopiedDescriptionEnabled);
    const title = isJiraUnpublishedPaste ? (0, $9dhQr.syncBlockMessages).unpublishedSyncBlockPastedTitleJiraWorkItem : defaultTitle;
    const description = copiedDescription ?? (isJiraUnpublishedPaste ? (0, $9dhQr.syncBlockMessages).unpublishedSyncBlockPastedDescriptionJiraWorkItem : defaultDescription);
    const descriptionContent = description ? formatMessage(description, {
        link: (chunks)=>sourceUrl ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $bLXMw.Anchor), {
                href: sourceUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                children: chunks
            }) : chunks
    }) : undefined;
    // Retry button often involves network request, hence we dismiss the flag in offline mode to avoid retry
    if ((0, $hVGJk.isOfflineMode)(mode) && !!onRetry) {
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $cG0Fu.syncedBlockPluginKey), {
                activeFlag: false
            });
            return tr;
        });
        return;
    }
    const dismissFlag = (shouldFocusEditor)=>{
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            onDismissedCallback === null || onDismissedCallback === void 0 || onDismissedCallback(tr);
            const oldMeta = tr.getMeta((0, $cG0Fu.syncedBlockPluginKey));
            tr.setMeta((0, $cG0Fu.syncedBlockPluginKey), {
                ...oldMeta,
                activeFlag: false
            });
            return tr;
        });
        if (shouldFocusEditor) api === null || api === void 0 || api.core.actions.focus();
    };
    const onDismissed = ()=>dismissFlag(true);
    const typeToActions = ()=>{
        if (type === 'error') {
            if (onRetry) return [
                {
                    content: formatMessage((0, $9dhQr.syncBlockMessages).deleteRetryButton),
                    onClick: onRetry
                }
            ];
        } else if (type === 'info' && action) return [
            {
                content: formatMessage(action),
                href: (0, $bUkfH.SYNCED_BLOCKS_DOCUMENTATION_URL),
                target: '_blank',
                rel: 'noopener noreferrer'
            }
        ];
        else if (type === 'feedback' && activeFlag.id === (0, $7II9i.FLAG_ID).SYNC_BLOCK_FEEDBACK_PROMPT && activeFlag.feedbackContext) {
            const feedbackContext = activeFlag.feedbackContext;
            return [
                {
                    content: formatMessage((0, $9dhQr.syncBlockMessages).feedbackFlagGiveFeedback),
                    onClick: ()=>{
                        dismissFlag(false);
                        try {
                            const feedbackResult = onGiveFeedback === null || onGiveFeedback === void 0 ? void 0 : onGiveFeedback(feedbackContext);
                            Promise.resolve(feedbackResult).catch(()=>{});
                        } catch  {
                        // Feedback collectors are optional product UI.
                        }
                    }
                },
                {
                    content: formatMessage((0, $9dhQr.syncBlockMessages).feedbackFlagNoThanks),
                    onClick: onDismissed
                }
            ];
        }
        return undefined;
    };
    const FlagComponent = type === 'info' ? (0, $eJ0Uu.default) : (0, $2bmUD.default);
    const flag = /*#__PURE__*/ (0, $dc70d.jsx)(FlagComponent, {
        onDismissed: onDismissed,
        title: formatMessage(title),
        description: descriptionContent,
        id: activeFlag.id,
        testId: activeFlag.id,
        icon: $af1e779ed441548e$var$typeToIcon(type),
        actions: typeToActions()
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lJzMO.FlagGroup), {
        children: type === 'feedback' ? /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            id: activeFlag.id,
            className: (0, $9fU1q.default)([
                "_btc7grf3"
            ]),
            children: flag
        }) : flag
    });
};
const $af1e779ed441548e$var$typeToIcon = (type)=>{
    if (type === 'error') return /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dsw4B))), {
        label: "",
        color: "var(--ds-icon-warning, #E06C00)"
    });
    if (type === 'feedback') return /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jE5M0))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #292A2E)"
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lP6sB))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    });
};

});
parcelRegister("bUkfH", function(module, exports) {
$parcel$export(module.exports, "SYNCED_BLOCKS_DOCUMENTATION_URL", () => $75f7fe934f450c96$export$81b3a92cdfa3191b);
/**
 * URL to the Atlassian support documentation for synced blocks in Confluence Cloud.
 */ const $75f7fe934f450c96$export$81b3a92cdfa3191b = 'https://support.atlassian.com/confluence-cloud/docs/reuse-content-with-synced-blocks';

});


parcelRegister("deVl0", function(module, exports) {
$parcel$export(module.exports, "getToolbarConfig", () => $d2ba045f3234ca9b$export$86ce8f8241c20a3);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $7HjEm = parcelRequire("7HjEm");

var $fNLdd = parcelRequire("fNLdd");

var $cW1gB = parcelRequire("cW1gB");

var $9dhQr = parcelRequire("9dhQr");

var $8t2a4 = parcelRequire("8t2a4");

var $j7pt0 = parcelRequire("j7pt0");

var $gab48 = parcelRequire("gab48");

var $5bbjm = parcelRequire("5bbjm");

var $cSue1 = parcelRequire("cSue1");

var $c81bI = parcelRequire("c81bI");

var $gV64P = parcelRequire("gV64P");

var $5Uddy = parcelRequire("5Uddy");

var $1c4Ad = parcelRequire("1c4Ad");

var $jE5M0 = parcelRequire("jE5M0");

var $8hQqt = parcelRequire("8hQqt");

var $QIBX2 = parcelRequire("QIBX2");

var $7II9i = parcelRequire("7II9i");

var $9kGQX = parcelRequire("9kGQX");
const $d2ba045f3234ca9b$export$86ce8f8241c20a3 = (state, intl, api, syncBlockStore, isLivePage, onGiveFeedback)=>{
    var _syncBlockInstance$er, _api$decorations, _api$connectivity;
    const syncBlockObject = (0, $QIBX2.findSyncBlockOrBodiedSyncBlock)(state.schema, state.selection);
    if (!syncBlockObject) return;
    if (syncBlockStore.sourceManager.isPendingCreation(syncBlockObject.node.attrs.resourceId)) return;
    const syncBlockInstance = syncBlockStore.referenceManager.getFromCache(syncBlockObject.node.attrs.resourceId);
    const isUnsyncedBlock = (syncBlockInstance === null || syncBlockInstance === void 0 || (_syncBlockInstance$er = syncBlockInstance.error) === null || _syncBlockInstance$er === void 0 ? void 0 : _syncBlockInstance$er.type) === (0, $cSue1.SyncBlockError).NotFound;
    const isErroredBlock = syncBlockInstance === null || syncBlockInstance === void 0 ? void 0 : syncBlockInstance.error;
    const { schema: { nodes: { bodiedSyncBlock: bodiedSyncBlock } } } = state;
    const isBodiedSyncBlock = (0, $QIBX2.isBodiedSyncBlockNode)(syncBlockObject.node, bodiedSyncBlock);
    const { resourceId: resourceId, localId: localId } = syncBlockObject.node.attrs;
    const { formatMessage: formatMessage } = intl;
    const nodeType = syncBlockObject.node.type;
    const hoverDecoration = api === null || api === void 0 || (_api$decorations = api.decorations) === null || _api$decorations === void 0 ? void 0 : _api$decorations.actions.hoverDecoration;
    const hoverDecorationProps = (nodeType, className)=>({
            onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, true, className),
            onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, false, className),
            onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, true, className),
            onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, false, className)
        });
    const items = [];
    if (isUnsyncedBlock) {
        const deleteButton = {
            type: 'button',
            title: formatMessage((0, $fNLdd.default).delete),
            onClick: (0, $8hQqt.removeSyncedBlock)(api),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gV64P))),
            testId: (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarReferenceDelete,
            ...hoverDecorationProps(nodeType, (0, $5bbjm.akEditorSelectedNodeClassName))
        };
        items.push(deleteButton);
    } else {
        const copyButton = {
            id: 'editor.syncedBlock.copy',
            type: 'button',
            appearance: 'subtle',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($c81bI))),
            title: formatMessage((0, $9dhQr.syncBlockMessages).copyToSyncLabel),
            showTitle: true,
            testId: (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarCopy,
            onClick: (0, $8hQqt.copySyncedBlockReferenceToClipboard)(syncBlockStore, (0, $g6Qq4.INPUT_METHOD).SYNCED_BLOCK_TB, api, isLivePage),
            ...hoverDecorationProps(nodeType, (0, $5bbjm.akEditorSelectedNodeClassName))
        };
        items.push(copyButton);
        if (!isErroredBlock) {
            const syncedLocation = {
                type: 'custom',
                fallback: [],
                render: (_view, _idx, _dispatchAnalyticsEvent, floatingToolbarRenderContext)=>{
                    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9kGQX.SyncedLocationDropdownWithCount), {
                        syncBlockStore: syncBlockStore,
                        doc: state.doc,
                        resourceId: resourceId,
                        localId: localId,
                        intl: intl,
                        isSource: isBodiedSyncBlock,
                        api: api,
                        floatingToolbarRenderContext: floatingToolbarRenderContext
                    }, `${resourceId}:${localId}:${isBodiedSyncBlock}`);
                }
            };
            const unsyncButton = {
                type: 'custom',
                fallback: [],
                render: (view)=>{
                    var _syncBlockInstance$da;
                    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $7HjEm.default), {
                        areAnyNewToolbarFlagsEnabled: true,
                        disabled: (syncBlockInstance === null || syncBlockInstance === void 0 || (_syncBlockInstance$da = syncBlockInstance.data) === null || _syncBlockInstance$da === void 0 ? void 0 : _syncBlockInstance$da.status) === 'unpublished',
                        icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1c4Ad))), {
                            label: ""
                        }),
                        title: formatMessage((0, $9dhQr.syncBlockMessages).unsyncButton),
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onClick: ()=>(0, $8hQqt.unsync)(syncBlockStore, isBodiedSyncBlock, view),
                        testId: isBodiedSyncBlock ? (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarSourceUnsync : (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarReferenceUnsync
                    });
                }
            };
            items.push(syncedLocation, unsyncButton);
        }
        const disabled = !syncBlockStore.referenceManager.getSyncBlockURL(syncBlockObject.node.attrs.resourceId);
        if (!isBodiedSyncBlock) {
            const editSourceButton = {
                id: 'editor.syncedBlock.editSource',
                type: 'button',
                disabled: disabled,
                appearance: 'subtle',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($5Uddy))),
                title: formatMessage((0, $9dhQr.syncBlockMessages).editSourceLabel),
                showTitle: false,
                tooltipContent: disabled ? formatMessage((0, $9dhQr.syncBlockMessages).editSourceTooltipDisabled) : formatMessage((0, $9dhQr.syncBlockMessages).editSourceTooltip),
                onClick: (0, $8hQqt.editSyncedBlockSource)(syncBlockStore, api),
                ...hoverDecorationProps(nodeType, (0, $5bbjm.akEditorSelectedNodeClassName))
            };
            items.push(editSourceButton);
        }
        // testId is required to show focus on trigger button on ESC key press
        // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
        const testId = isBodiedSyncBlock ? (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarSourceOverflowTrigger : (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarReferenceOverflowTrigger;
        const overflowMenuConfig = [
            {
                type: 'overflow-dropdown',
                testId: testId,
                options: [
                    ...onGiveFeedback ? [
                        {
                            title: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).feedbackDialog),
                            icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jE5M0))), {
                                label: ""
                            }),
                            onClick: ()=>{
                                api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>tr.setSelection(new (0, $j7pt0.GapCursorSelection)(tr.doc.resolve(syncBlockObject.pos + syncBlockObject.node.nodeSize), (0, $8t2a4.Side).RIGHT)));
                                onGiveFeedback({
                                    blockType: isBodiedSyncBlock ? 'source' : 'reference',
                                    entryPoint: 'overflow-menu'
                                });
                                return true;
                            }
                        }
                    ] : [],
                    {
                        title: formatMessage((0, $fNLdd.default).delete),
                        onClick: (0, $8hQqt.removeSyncedBlock)(api),
                        icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gV64P))), {
                            label: ""
                        }),
                        testId: isBodiedSyncBlock ? (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarSourceDelete : (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarReferenceDelete,
                        ...hoverDecorationProps(nodeType)
                    }
                ]
            }
        ];
        items.push(...overflowMenuConfig);
    }
    const getDomRef = (editorView)=>{
        const domAtPos = editorView.domAtPos.bind(editorView);
        const element = (0, $gab48.findDomRefAtPos)(syncBlockObject.pos, domAtPos);
        return element;
    };
    return {
        title: 'Synced Block floating controls',
        getDomRef: getDomRef,
        nodeType: nodeType,
        items: items,
        scrollable: true,
        groupLabel: formatMessage((0, $9dhQr.syncBlockMessages).syncBlockGroup),
        visible: (api === null || api === void 0 || (_api$connectivity = api.connectivity) === null || _api$connectivity === void 0 || (_api$connectivity = _api$connectivity.sharedState.currentState()) === null || _api$connectivity === void 0 ? void 0 : _api$connectivity.mode) !== 'offline'
    };
};

});
parcelRegister("9kGQX", function(module, exports) {
$parcel$export(module.exports, "SyncedLocationDropdownWithCount", () => $16c16b43c4da4354$export$127208b0973f9135);
/* SyncedLocationDropdown.tsx generated by @compiled/babel-plugin v3.0.2 */ /* SyncedLocationDropdown.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $14TCm = parcelRequire("14TCm");

var $ag7mU = parcelRequire("ag7mU");

var $ljPIj = parcelRequire("ljPIj");

var $g6Qq4 = parcelRequire("g6Qq4");

var $7HjEm = parcelRequire("7HjEm");

var $9dhQr = parcelRequire("9dhQr");

var $bUkfH = parcelRequire("bUkfH");

var $imBU3 = parcelRequire("imBU3");

var $6bWVw = parcelRequire("6bWVw");

var $7Qiv5 = parcelRequire("7Qiv5");

var $cM0zk = parcelRequire("cM0zk");

var $ccTIL = parcelRequire("ccTIL");

var $4GWyU = parcelRequire("4GWyU");

var $h6YPS = parcelRequire("h6YPS");

var $5FomD = parcelRequire("5FomD");

var $emsU2 = parcelRequire("emsU2");

var $jHVBL = parcelRequire("jHVBL");

var $hkLEY = parcelRequire("hkLEY");

var $3C6hN = parcelRequire("3C6hN");

var $7j6fq = parcelRequire("7j6fq");

var $4ujxi = parcelRequire("4ujxi");

var $67YKA = parcelRequire("67YKA");

var $iajVF = parcelRequire("iajVF");

var $4eIWR = parcelRequire("4eIWR");

var $jSH6l = parcelRequire("jSH6l");

var $1emO3 = parcelRequire("1emO3");

var $3y2s4 = parcelRequire("3y2s4");

var $bLXMw = parcelRequire("bLXMw");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $dDEhr = parcelRequire("dDEhr");

var $8aT4G = parcelRequire("8aT4G");

var $hDkm2 = parcelRequire("hDkm2");

var $lavtv = parcelRequire("lavtv");

var $7II9i = parcelRequire("7II9i");

var $cfdfI = parcelRequire("cfdfI");
const $16c16b43c4da4354$var$fadeIn = null;
const $16c16b43c4da4354$var$headingStyles = null;
const $16c16b43c4da4354$var$dropdownItemStyles = null;
// logo icon does not fit in ADS IconTile, hence we need custom styles to match with other icons
const $16c16b43c4da4354$var$logoTileStyles = null;
// Breadcrumbs and smart links draw the work item avatar without a tile. The 20px box keeps
// Jira rows aligned with the tiled Confluence rows.
const $16c16b43c4da4354$var$issueTypeAvatarStyles = null;
const $16c16b43c4da4354$var$SYNCED_LOCATIONS_DROPDOWN_TEST_ID = 'synced-block-synced-locations-dropdown';
// Match the existing vertical gap in editor-common's DropList.
const $16c16b43c4da4354$var$SYNCED_LOCATIONS_DROPDOWN_VERTICAL_GAP = 8;
const $16c16b43c4da4354$var$styles = {
    title: "_1reo15vq _18m915vq _syazazsu _1bto1l2s _o5721q9c",
    note: "_syaz1rpy _o5721q9c",
    lozenge: "_ahbq12x7 _1ul91wqb",
    activationDropdownContent: "_1rjcze3t _1bsb1kdj",
    activationNoResultsContainer: "_vchhusvi _1bsb1kdj _ca0q1ejb _n3td1ejb",
    activationNoResultsContent: "_195g1wug _1bsb12aa _y3gn1h6o",
    fieldAwareDropdownContent: "_1bsb1kdj",
    fieldSecondLine: "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
    dropdownContent: "_1rjcv77o _1bsbsmdz _c71lko4j _1e0c1txw _1bah1h6o _4cvr1h6o",
    containerWithMinHeight: "_1tkeqkoa",
    contentContainer: "_y44vfmxe _1bsb1osq _1wpz1fhb _18m91wug",
    errorContainer: "_1bsbo8uj _1e0c1txw",
    errorIcon: "_1mour5cr",
    learnMoreLink: "_4bfu1r31 _1hmsglyw _ajmmnqa1",
    requestAccess: "_1bsb19n7 _o5721q9c _ahbq12x7 _syaz1rpy",
    restrictedIcon: "_1e0c1txw _4cvr1h6o _1wpz1h6o _ahbq1b66"
};
const $16c16b43c4da4354$var$isRestrictedLocation = (reference)=>!reference.hasAccess && (0, $3y2s4.isExperimentEnabled)('platform_editor_blocks_patch_11');
/** The user requests access on the location itself, so a restricted row only shows a lock. */ const $16c16b43c4da4354$var$NoAccessIndicator = ({ formatMessage: formatMessage })=>(0, $3y2s4.isExperimentEnabled)('platform_editor_blocks_patch_11') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        as: "span",
        xcss: $16c16b43c4da4354$var$styles.restrictedIcon,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5FomD))), {
            label: "",
            size: "small",
            color: "var(--ds-icon-danger, #C9372C)"
        })
    }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        as: "span",
        xcss: $16c16b43c4da4354$var$styles.requestAccess,
        children: formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownRequestAccess)
    });
const $16c16b43c4da4354$var$EMPTY_LOCATIONS = {
    kind: 'control',
    references: []
};
const $16c16b43c4da4354$var$countLocations = (locations)=>locations.kind === 'control' ? locations.references.length : locations.items.length;
const $16c16b43c4da4354$var$shouldApplyMinHeight = (fetchStatus, itemCount)=>{
    // When there are 1/2 items, dropdown height is less than minHeight 144px
    return !(fetchStatus === 'success' && itemCount > 0);
};
const $16c16b43c4da4354$var$ItemTitle = ({ title: title, formatMessage: formatMessage, onSameDocument: onSameDocument, isSource: isSource, hasAccess: hasAccess, productType: productType })=>{
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $fZ0ZI.Inline), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                as: "span",
                xcss: $16c16b43c4da4354$var$styles.title,
                children: title
            }),
            onSameDocument && /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9PwDt.Box), {
                as: "span",
                xcss: $16c16b43c4da4354$var$styles.note,
                children: [
                    "\xa0-",
                    ' ',
                    formatMessage(productType === 'confluence-page' ? (0, $9dhQr.syncBlockMessages).syncedLocationDropdownTitleNoteForConfluencePage : (0, $9dhQr.syncBlockMessages).syncedLocationDropdownTitleNoteForJiraWorkItem)
                ]
            }),
            isSource && /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                as: "span",
                xcss: $16c16b43c4da4354$var$styles.lozenge,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $1emO3.default), {
                    children: formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownSourceLozenge)
                })
            }),
            !hasAccess && /*#__PURE__*/ (0, $dc70d.jsx)($16c16b43c4da4354$var$NoAccessIndicator, {
                formatMessage: formatMessage
            })
        ]
    });
};
const $16c16b43c4da4354$var$productIconMap = {
    'confluence-page': (0, $4eIWR.ConfluenceIcon),
    'jira-work-item': (0, $jSH6l.JiraIcon)
};
const $16c16b43c4da4354$var$subTypeIconMap = {
    live: (0, (/*@__PURE__*/$parcel$interopDefault($cM0zk))),
    page: (0, (/*@__PURE__*/$parcel$interopDefault($emsU2)))
};
const $16c16b43c4da4354$var$getConfluenceSubTypeIcon = (sourceAri, subType)=>{
    try {
        const { type: pageType } = (0, $7Qiv5.getPageIdAndTypeFromConfluencePageAri)({
            ari: sourceAri
        });
        if (pageType === 'blogpost') return 0, (/*@__PURE__*/$parcel$interopDefault($jHVBL));
        else return subType && subType in $16c16b43c4da4354$var$subTypeIconMap ? $16c16b43c4da4354$var$subTypeIconMap[subType] : (0, (/*@__PURE__*/$parcel$interopDefault($emsU2)));
    } catch  {
        return 0, (/*@__PURE__*/$parcel$interopDefault($emsU2));
    }
};
const $16c16b43c4da4354$var$ProductIcon = ({ product: product })=>{
    const ProductIcon = product ? $16c16b43c4da4354$var$productIconMap[product] ?? (0, $iajVF.AtlassianIcon) : (0, $iajVF.AtlassianIcon);
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        className: (0, $9fU1q.default)([
            "_2rkol0p1 _bfhki8nm _1bsbgktf _4t3igktf _1e0c1txw _4cvr1h6o _1bah1h6o"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)(ProductIcon, {
            size: "xxsmall",
            appearance: "neutral"
        })
    });
};
const $16c16b43c4da4354$var$jiraIssueTypeIconMap = {
    Task: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4ujxi))),
        messageKey: 'syncedLocationDropdownIssueTypeTask'
    },
    Bug: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ccTIL))),
        messageKey: 'syncedLocationDropdownIssueTypeBug'
    },
    Story: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3C6hN))),
        messageKey: 'syncedLocationDropdownIssueTypeStory'
    },
    Epic: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($h6YPS))),
        messageKey: 'syncedLocationDropdownIssueTypeEpic'
    },
    Subtask: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7j6fq))),
        messageKey: 'syncedLocationDropdownIssueTypeSubtask'
    },
    'Sub-task': {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7j6fq))),
        messageKey: 'syncedLocationDropdownIssueTypeSubtask'
    }
};
/**
 * Creates an icon component from a custom Jira issue-type `iconUrl` that conforms to the
 * ADS icon component contract expected by `IconTile`. This lets us reuse `IconTile` for
 * custom issue types — ensuring consistent sizing, background, and border-radius with the
 * standard ADS icons used for known issue types (Bug, Story, etc.).
 *
 * The returned component ignores ADS icon props (color, spacing, etc.) because the image
 * is an external raster/SVG asset that doesn't respond to design tokens.
 */ const $16c16b43c4da4354$var$customIconCache = new Map();
const $16c16b43c4da4354$var$createCustomIssueTypeIcon = (iconUrl)=>{
    const cached = $16c16b43c4da4354$var$customIconCache.get(iconUrl);
    if (cached) return cached;
    const CustomIssueTypeIcon = ()=>/*#__PURE__*/ (0, $dc70d.jsx)("img", {
            src: iconUrl,
            alt: "",
            width: "12",
            height: "12"
        });
    CustomIssueTypeIcon.displayName = 'CustomIssueTypeIcon';
    $16c16b43c4da4354$var$customIconCache.set(iconUrl, CustomIssueTypeIcon);
    return CustomIssueTypeIcon;
};
/**
 * Returns the icon to render for a Jira issue type, or `null` when neither an ADS icon
 * mapping nor an AGG-provided `iconUrl` is available so the caller can fall back to a
 * generic product icon.
 *
 * Implemented as a plain function (not a React component) so the `null` check actually
 * narrows — a JSX expression always evaluates to a truthy `ReactElement` object,
 * meaning callers cannot distinguish a "would render nothing" component from one that
 * renders an icon.
 */ const $16c16b43c4da4354$var$renderJiraIssueTypeIcon = (issueType, intl)=>{
    const mapped = $16c16b43c4da4354$var$jiraIssueTypeIconMap[issueType.name];
    const label = intl.formatMessage(mapped ? (0, $9dhQr.syncBlockMessages)[mapped.messageKey] : (0, $9dhQr.syncBlockMessages).syncedLocationDropdownIssueTypeGeneric);
    if (issueType.iconUrl && (0, $3y2s4.isExperimentEnabled)('platform_editor_blocks_patch_11')) return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        className: (0, $9fU1q.default)([
            "_1bsbgktf _4t3igktf _1e0c1txw _1o9zidpf _4cvr1h6o _1bah1h6o"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)("img", {
            src: issueType.iconUrl,
            alt: label,
            width: "16",
            height: "16"
        })
    });
    if (mapped) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $67YKA.default), {
        icon: mapped.icon,
        label: label,
        appearance: 'gray',
        size: "xsmall"
    });
    // Custom Jira issue types — render inside `IconTile` using a wrapper component so the
    // icon gets the same tile background, border-radius, and sizing as known issue types.
    if (issueType.iconUrl) {
        const CustomIcon = $16c16b43c4da4354$var$createCustomIssueTypeIcon(issueType.iconUrl);
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $67YKA.default), {
            icon: CustomIcon,
            label: label,
            appearance: 'gray',
            size: "xsmall"
        });
    }
    return null;
};
const $16c16b43c4da4354$var$ItemIcon = ({ reference: reference, intl: intl })=>{
    const { hasAccess: hasAccess, subType: subType, productType: productType, sourceAri: sourceAri, issueType: issueType } = reference;
    if (productType === 'confluence-page' && hasAccess) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $67YKA.default), {
        icon: $16c16b43c4da4354$var$getConfluenceSubTypeIcon(sourceAri, subType),
        label: "",
        appearance: 'gray',
        size: "xsmall"
    });
    // Render a Jira issue-type icon when we have one.
    // Falls through to the generic product icon when:
    //   - we don't have access (issueType is not surfaced for no-access references),
    //   - AGG returned no `issueType` (partial index, deleted, etc.), or
    //   - the issue type is unrecognised AND has no `iconUrl`.
    if (productType === 'jira-work-item' && hasAccess && issueType) {
        const icon = $16c16b43c4da4354$var$renderJiraIssueTypeIcon(issueType, intl);
        if (icon !== null) return icon;
    }
    // Generic product fallback for `jira-work-item` (and any future product).
    return /*#__PURE__*/ (0, $dc70d.jsx)($16c16b43c4da4354$var$ProductIcon, {
        product: productType
    });
};
const $16c16b43c4da4354$export$7233d77a72ff78ae = (referenceData, intl)=>{
    const { formatMessage: formatMessage } = intl;
    const sourceInfoMap = new Map();
    referenceData === null || referenceData === void 0 || referenceData.forEach((reference)=>{
        if (!reference) return;
        if (sourceInfoMap.has(reference.sourceAri)) {
            var _sourceInfoMap$get;
            (_sourceInfoMap$get = sourceInfoMap.get(reference.sourceAri)) === null || _sourceInfoMap$get === void 0 || _sourceInfoMap$get.push(reference);
        } else sourceInfoMap.set(reference.sourceAri, [
            reference
        ]);
    });
    for (const references of sourceInfoMap.values())if (references.length > 1) references.forEach((reference, index)=>reference.title = `${reference.title === '' && reference.hasAccess ? formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownUntitledPage) : reference.title}: ${formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownTitleBlockIndex, {
            index: index + 1
        })}`);
    const sortedReferences = Array.from(sourceInfoMap.values()).flat().sort((a, b)=>{
        if (a.isSource !== b.isSource) return b.isSource ? 1 : -1;
        if (a.hasAccess !== b.hasAccess) return a.hasAccess ? -1 : 1;
        return (a.title || '').localeCompare(b.title || '');
    });
    return sortedReferences;
};
const $16c16b43c4da4354$var$isFieldAwareLocationList = (references)=>((references === null || references === void 0 ? void 0 : references.some((reference)=>(reference === null || reference === void 0 ? void 0 : reference.productType) === 'jira-work-item')) ?? false) && (0, $3y2s4.isExperimentEnabled)('editor_synced_blocks_jira_custom_rich_text');
const $16c16b43c4da4354$var$groupBySourceAri = (referenceData)=>{
    const groups = new Map();
    referenceData === null || referenceData === void 0 || referenceData.forEach((reference)=>{
        if (!reference) return;
        const group = groups.get(reference.sourceAri);
        if (group) group.push(reference);
        else groups.set(reference.sourceAri, [
            reference
        ]);
    });
    return groups;
};
/** Sources first, then accessible locations. `0` leaves the title order to the caller. */ const $16c16b43c4da4354$var$compareLocationOrder = (a, b)=>{
    if (a.isSource !== b.isSource) return b.isSource ? 1 : -1;
    if (a.hasAccess !== b.hasAccess) return a.hasAccess ? -1 : 1;
    return 0;
};
/** The title alone. The field name is placed by the row and the tooltip, not baked in here. */ const $16c16b43c4da4354$var$getBaseTitle = ({ blockIndex: blockIndex, formatMessage: formatMessage, reference: reference })=>{
    if ($16c16b43c4da4354$var$isRestrictedLocation(reference)) return formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownRestrictedContent);
    const title = reference.title === '' && reference.hasAccess ? formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownUntitledPage) : reference.title || reference.url || '';
    return blockIndex === undefined ? title : `${title}: ${formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownTitleBlockIndex, {
        index: blockIndex
    })}`;
};
/** Jira rows are noted from `locationScope`; other rows keep the pre-experiment `onSameDocument` note. */ const $16c16b43c4da4354$var$getFieldAwareNote = (reference, formatMessage)=>{
    if (reference.productType !== 'jira-work-item') {
        if (!reference.onSameDocument) return undefined;
        return formatMessage(reference.productType === 'confluence-page' ? (0, $9dhQr.syncBlockMessages).syncedLocationDropdownTitleNoteForConfluencePage : (0, $9dhQr.syncBlockMessages).syncedLocationDropdownTitleNoteForJiraWorkItem);
    }
    // A provider that computes no scope still reports `onSameDocument`. It is the same host
    // comparison `getLocationScope` starts with, and in Jira the host document is one field.
    const locationScope = reference.locationScope ?? (reference.onSameDocument ? 'same-document' : undefined);
    switch(locationScope){
        case 'same-document':
            return formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownTitleNoteForJiraWorkItemField);
        case 'same-parent-document':
            return formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownTitleNoteForJiraWorkItem);
        default:
            return undefined;
    }
};
const $16c16b43c4da4354$export$1d1f651780f0caab = (referenceData, formatMessage)=>Array.from($16c16b43c4da4354$var$groupBySourceAri(referenceData).values()).flatMap((group)=>group.map((reference, index)=>{
            const fieldName = reference.productType === 'jira-work-item' ? reference.fieldName : undefined;
            const note = $16c16b43c4da4354$var$getFieldAwareNote(reference, formatMessage);
            return {
                baseTitle: $16c16b43c4da4354$var$getBaseTitle({
                    blockIndex: group.length > 1 ? index + 1 : undefined,
                    formatMessage: formatMessage,
                    reference: reference
                }),
                ...fieldName !== undefined && {
                    fieldName: fieldName
                },
                key: `${reference.sourceAri}#${index}`,
                ...note !== undefined && {
                    note: note
                },
                reference: reference
            };
        })).sort((a, b)=>$16c16b43c4da4354$var$compareLocationOrder(a.reference, b.reference) || a.baseTitle.localeCompare(b.baseTitle));
const $16c16b43c4da4354$var$toSyncedLocations = (references, intl)=>$16c16b43c4da4354$var$isFieldAwareLocationList(references) ? {
        kind: 'field-aware',
        items: $16c16b43c4da4354$export$1d1f651780f0caab(references, intl.formatMessage)
    } : {
        kind: 'control',
        references: $16c16b43c4da4354$export$7233d77a72ff78ae(references, intl)
    };
const $16c16b43c4da4354$var$MeasuredDropdownContent = ({ children: children, onHeightChange: onHeightChange })=>{
    const contentRef = (0, $bSJIT.useRef)(null);
    const measured = (0, $bSJIT.useRef)(false);
    (0, $bSJIT.useLayoutEffect)(()=>{
        var _contentRef$current;
        // This wrapper is rendered directly inside the DropList menu.
        const menu = (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.parentElement;
        if (menu && !measured.current) {
            measured.current = true;
            // Include the DropList padding and its existing gap from the toolbar.
            onHeightChange(menu.getBoundingClientRect().height + $16c16b43c4da4354$var$SYNCED_LOCATIONS_DROPDOWN_VERTICAL_GAP);
        }
    }, [
        onHeightChange
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ref: contentRef,
        children: children
    });
};
const $16c16b43c4da4354$export$1bd57d4057e7f613 = ({ syncBlockStore: syncBlockStore, resourceId: resourceId, intl: intl, isSource: isSource, localId: localId, api: api, floatingToolbarRenderContext: floatingToolbarRenderContext })=>{
    const triggerTitle = intl.formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownTitle);
    const [isOpen, setIsOpen] = (0, $bSJIT.useState)(false);
    const [fitHeight, setFitHeight] = (0, $bSJIT.useState)();
    const content = isOpen ? /*#__PURE__*/ (0, $dc70d.jsx)($16c16b43c4da4354$var$DropdownContent, {
        syncBlockStore: syncBlockStore,
        resourceId: resourceId,
        intl: intl,
        isSource: isSource,
        localId: localId,
        api: api
    }) : null;
    const toggleOpen = (0, $bSJIT.useCallback)(()=>{
        setFitHeight(undefined);
        setIsOpen((currentIsOpen)=>!currentIsOpen);
    }, []);
    const closeDropdown = (0, $bSJIT.useCallback)(()=>{
        setFitHeight(undefined);
        setIsOpen(false);
    }, []);
    const setDisableParentScroll = floatingToolbarRenderContext === null || floatingToolbarRenderContext === void 0 ? void 0 : floatingToolbarRenderContext.setDisableParentScroll;
    (0, $bSJIT.useEffect)(()=>{
        if (!isOpen) return;
        setDisableParentScroll === null || setDisableParentScroll === void 0 || setDisableParentScroll(true);
        return ()=>{
            setDisableParentScroll === null || setDisableParentScroll === void 0 || setDisableParentScroll(false);
        };
    }, [
        isOpen,
        setDisableParentScroll
    ]);
    const trigger = (0, $bSJIT.useMemo)(()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $7HjEm.default), {
            areAnyNewToolbarFlagsEnabled: true,
            testId: (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarSyncedLocationsTrigger,
            selected: isOpen,
            iconAfter: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
                color: "currentColor",
                spacing: "spacious",
                label: "",
                size: "small"
            }),
            onClick: toggleOpen,
            ariaHasPopup: true,
            children: triggerTitle
        }), [
        isOpen,
        toggleOpen,
        triggerTitle
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6bWVw.DropdownContainer), {
        testId: $16c16b43c4da4354$var$SYNCED_LOCATIONS_DROPDOWN_TEST_ID,
        isOpen: isOpen,
        fitHeight: fitHeight,
        trigger: trigger,
        handleClickOutside: closeDropdown,
        handleEscapeKeydown: closeDropdown,
        mountTo: floatingToolbarRenderContext === null || floatingToolbarRenderContext === void 0 ? void 0 : floatingToolbarRenderContext.popupsMountPoint,
        boundariesElement: floatingToolbarRenderContext === null || floatingToolbarRenderContext === void 0 ? void 0 : floatingToolbarRenderContext.popupsBoundariesElement,
        scrollableElement: floatingToolbarRenderContext === null || floatingToolbarRenderContext === void 0 ? void 0 : floatingToolbarRenderContext.popupsScrollableElement,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        arrowKeyNavigationProviderOptions: {
            type: (0, $imBU3.ArrowKeyNavigationType).MENU
        },
        children: (0, $3y2s4.isExperimentEnabled)('platform_editor_blocks_patch_12') ? /*#__PURE__*/ (0, $dc70d.jsx)($16c16b43c4da4354$var$MeasuredDropdownContent, {
            onHeightChange: setFitHeight,
            children: content
        }) : content
    });
};
const $16c16b43c4da4354$export$127208b0973f9135 = ({ syncBlockStore: syncBlockStore, doc: doc, resourceId: resourceId, intl: intl, isSource: isSource, localId: localId, api: api, floatingToolbarRenderContext: floatingToolbarRenderContext })=>{
    const [isOpen, setIsOpen] = (0, $bSJIT.useState)(false);
    const [fitHeight, setFitHeight] = (0, $bSJIT.useState)();
    const { fetchStatus: fetchStatus, locations: locations } = $16c16b43c4da4354$var$useReferenceData({
        intl: intl,
        isSource: isSource,
        localId: localId,
        resourceId: resourceId,
        syncBlockStore: syncBlockStore,
        doc: doc
    });
    const referenceCount = (0, $bSJIT.useMemo)(()=>{
        switch(locations.kind){
            case 'control':
                return locations.references.filter(({ isSource: isSourceItem })=>!isSourceItem).length;
            case 'field-aware':
                return locations.items.filter(({ reference: reference })=>!reference.isSource).length;
        }
    }, [
        locations
    ]);
    const tooltipContent = !isOpen && fetchStatus === 'success' && referenceCount === 0 ? intl.formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownNoReferencesTooltip) : null;
    const content = isOpen ? /*#__PURE__*/ (0, $dc70d.jsx)($16c16b43c4da4354$var$DropdownContentWithReferenceData, {
        resourceId: resourceId,
        intl: intl,
        api: api,
        fetchStatus: fetchStatus,
        locations: locations
    }) : null;
    const toggleOpen = (0, $bSJIT.useCallback)(()=>{
        setFitHeight(undefined);
        setIsOpen((currentIsOpen)=>!currentIsOpen);
    }, []);
    const closeDropdown = (0, $bSJIT.useCallback)(()=>{
        setFitHeight(undefined);
        setIsOpen(false);
    }, []);
    const setDisableParentScroll = floatingToolbarRenderContext === null || floatingToolbarRenderContext === void 0 ? void 0 : floatingToolbarRenderContext.setDisableParentScroll;
    (0, $bSJIT.useEffect)(()=>{
        if (!isOpen) return;
        setDisableParentScroll === null || setDisableParentScroll === void 0 || setDisableParentScroll(true);
        return ()=>{
            setDisableParentScroll === null || setDisableParentScroll === void 0 || setDisableParentScroll(false);
        };
    }, [
        isOpen,
        setDisableParentScroll
    ]);
    const trigger = (0, $bSJIT.useMemo)(()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $7HjEm.default), {
            areAnyNewToolbarFlagsEnabled: true,
            testId: (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).syncedBlockToolbarSyncedLocationsTrigger,
            selected: isOpen,
            iconAfter: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
                color: "currentColor",
                spacing: "spacious",
                label: "",
                size: "small"
            }),
            onClick: toggleOpen,
            ariaHasPopup: true,
            tooltipContent: tooltipContent ?? undefined,
            children: /*#__PURE__*/ (0, $dc70d.jsx)($16c16b43c4da4354$var$SyncedLocationTriggerContent, {
                intl: intl,
                fetchStatus: fetchStatus,
                referenceCount: referenceCount
            })
        }), [
        fetchStatus,
        intl,
        isOpen,
        referenceCount,
        toggleOpen,
        tooltipContent
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6bWVw.DropdownContainer), {
        alignDropdownWithParentElement: true,
        alignX: "left",
        testId: $16c16b43c4da4354$var$SYNCED_LOCATIONS_DROPDOWN_TEST_ID,
        isOpen: isOpen,
        fitHeight: fitHeight,
        trigger: trigger,
        handleClickOutside: closeDropdown,
        handleEscapeKeydown: closeDropdown,
        mountTo: floatingToolbarRenderContext === null || floatingToolbarRenderContext === void 0 ? void 0 : floatingToolbarRenderContext.popupsMountPoint,
        boundariesElement: floatingToolbarRenderContext === null || floatingToolbarRenderContext === void 0 ? void 0 : floatingToolbarRenderContext.popupsBoundariesElement,
        scrollableElement: floatingToolbarRenderContext === null || floatingToolbarRenderContext === void 0 ? void 0 : floatingToolbarRenderContext.popupsScrollableElement,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        arrowKeyNavigationProviderOptions: {
            type: (0, $imBU3.ArrowKeyNavigationType).MENU
        },
        children: (0, $3y2s4.isExperimentEnabled)('platform_editor_blocks_patch_12') ? /*#__PURE__*/ (0, $dc70d.jsx)($16c16b43c4da4354$var$MeasuredDropdownContent, {
            onHeightChange: setFitHeight,
            children: content
        }) : content
    });
};
const $16c16b43c4da4354$var$DropdownContent = ({ syncBlockStore: syncBlockStore, resourceId: resourceId, intl: intl, isSource: isSource, localId: localId, api: api })=>{
    const [fetchStatus, setFetchStatus] = (0, $bSJIT.useState)(()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_blocks_patch_12') ? 'loading' : 'none');
    const [locations, setLocations] = (0, $bSJIT.useState)($16c16b43c4da4354$var$EMPTY_LOCATIONS);
    (0, $bSJIT.useEffect)(()=>{
        setFetchStatus('loading');
        const getReferenceData = async ()=>{
            const response = await syncBlockStore.fetchReferencesSourceInfo(resourceId, localId, isSource);
            if (response.error) {
                setFetchStatus('error');
                return;
            }
            setLocations($16c16b43c4da4354$var$toSyncedLocations(response.references, intl));
            setFetchStatus('success');
        };
        getReferenceData();
    }, [
        syncBlockStore,
        intl,
        isSource,
        localId,
        resourceId
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)($16c16b43c4da4354$var$DropdownContentWithReferenceData, {
        resourceId: resourceId,
        intl: intl,
        api: api,
        fetchStatus: fetchStatus,
        locations: locations
    });
};
const $16c16b43c4da4354$var$useReferenceData = ({ syncBlockStore: syncBlockStore, doc: doc, resourceId: resourceId, intl: intl, isSource: isSource, localId: localId })=>{
    // Refresh locations when the toolbar opens, rather than on every document edit.
    const [docAtMount] = (0, $bSJIT.useState)(doc);
    const [isNewSourceBlock] = (0, $bSJIT.useState)(()=>isSource && syncBlockStore.sourceManager.isNewSourceBlock(resourceId));
    const [state, setState] = (0, $bSJIT.useState)(()=>({
            fetchStatus: isNewSourceBlock ? 'success' : 'loading',
            locations: $16c16b43c4da4354$var$EMPTY_LOCATIONS
        }));
    (0, $bSJIT.useEffect)(()=>{
        let isCurrentRequest = true;
        setState({
            fetchStatus: isNewSourceBlock ? 'success' : 'loading',
            locations: $16c16b43c4da4354$var$EMPTY_LOCATIONS
        });
        const getReferenceData = async ()=>{
            const response = await syncBlockStore.fetchReferencesSourceInfo(resourceId, localId, isSource, docAtMount);
            if (!isCurrentRequest) return;
            if (isNewSourceBlock) syncBlockStore.sourceManager.clearNewSourceBlock(resourceId);
            if (response.error) {
                setState({
                    fetchStatus: 'error',
                    locations: $16c16b43c4da4354$var$EMPTY_LOCATIONS
                });
                return;
            }
            setState({
                fetchStatus: 'success',
                locations: $16c16b43c4da4354$var$toSyncedLocations(response.references, intl)
            });
        };
        getReferenceData();
        return ()=>{
            isCurrentRequest = false;
        };
    }, [
        syncBlockStore,
        resourceId,
        intl,
        isSource,
        localId,
        isNewSourceBlock,
        docAtMount
    ]);
    return {
        fetchStatus: state.fetchStatus,
        locations: state.locations
    };
};
const $16c16b43c4da4354$var$SyncedLocationTriggerContent = ({ intl: intl, fetchStatus: fetchStatus, referenceCount: referenceCount })=>{
    const { formatMessage: formatMessage } = intl;
    const triggerTitle = formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownTitle);
    const syncedLocationCount = referenceCount === 0 ? 0 : referenceCount + 1;
    switch(fetchStatus){
        case 'loading':
            return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $fZ0ZI.Inline), {
                alignBlock: "center",
                space: "space.050",
                children: [
                    triggerTitle,
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $hDkm2.default), {
                        size: "small",
                        label: formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownLoading)
                    })
                ]
            });
        case 'success':
            {
                const count = syncedLocationCount > 99 ? '99+' : intl.formatNumber(syncedLocationCount);
                return formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownTitleWithCount, {
                    count: count
                });
            }
        case 'none':
        case 'error':
            return triggerTitle;
    }
};
const $16c16b43c4da4354$var$DropdownContentWithReferenceData = ({ resourceId: resourceId, intl: intl, api: api, fetchStatus: fetchStatus, locations: locations })=>{
    const { formatMessage: formatMessage } = intl;
    const locationCount = $16c16b43c4da4354$var$countLocations(locations);
    const handleLocationClick = ()=>{
        var _api$analytics;
        api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.fireAnalyticsEvent({
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
            action: (0, $g6Qq4.ACTION).CLICKED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYNCED_BLOCK_CLICK_SYNCED_LOCATION,
            attributes: {
                resourceId: resourceId
            }
        });
    };
    const content = ()=>{
        switch(fetchStatus){
            case 'loading':
                return /*#__PURE__*/ (0, $dc70d.jsx)($16c16b43c4da4354$var$LoadingScreen, {
                    formatMessage: formatMessage
                });
            case 'error':
                return /*#__PURE__*/ (0, $dc70d.jsx)($16c16b43c4da4354$var$ErrorScreen, {
                    formatMessage: formatMessage
                });
            case 'success':
                if (locationCount > 0) return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    "data-testid": "synced-locations-dropdown-content",
                    className: (0, $9fU1q.default)([
                        $16c16b43c4da4354$var$styles.contentContainer,
                        "_ku9g126e _18bk1rpy"
                    ]),
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $ljPIj.default), {
                        title: formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownHeading, {
                            count: `${locationCount > 99 ? '99+' : locationCount}`
                        }),
                        children: locations.kind === 'field-aware' ? /*#__PURE__*/ (0, $dc70d.jsx)($16c16b43c4da4354$var$FieldAwareLocationRows, {
                            items: locations.items,
                            intl: intl,
                            handleLocationClick: handleLocationClick
                        }) : /*#__PURE__*/ (0, $dc70d.jsx)($16c16b43c4da4354$var$ControlLocationRows, {
                            referenceData: locations.references,
                            intl: intl,
                            handleLocationClick: handleLocationClick
                        })
                    })
                });
                else return /*#__PURE__*/ (0, $dc70d.jsx)($16c16b43c4da4354$var$NoResultScreen, {
                    formatMessage: formatMessage
                });
        }
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        xcss: (0, $14TCm.cx)($16c16b43c4da4354$var$styles.dropdownContent, locations.kind === 'field-aware' && $16c16b43c4da4354$var$styles.fieldAwareDropdownContent, fetchStatus === 'success' && locationCount === 0 && $16c16b43c4da4354$var$styles.activationDropdownContent, $16c16b43c4da4354$var$shouldApplyMinHeight(fetchStatus, locationCount) && $16c16b43c4da4354$var$styles.containerWithMinHeight),
        children: content()
    });
};
// The pre-experiment rows. This block is master's, moved into a component; remove with the experiment.
const $16c16b43c4da4354$var$ControlLocationRows = ({ referenceData: referenceData, intl: intl, handleLocationClick: handleLocationClick })=>{
    const { formatMessage: formatMessage } = intl;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Fragment), {
        children: referenceData.map((reference, index)=>{
            const title = $16c16b43c4da4354$var$isRestrictedLocation(reference) ? formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownRestrictedContent) : reference.title === '' && reference.hasAccess ? formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownUntitledPage) : reference.title || reference.url || '';
            return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                className: (0, $9fU1q.default)([
                    "_2ll012x7"
                ]),
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $lavtv.default), {
                    content: title,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $ag7mU.default), {
                        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)($16c16b43c4da4354$var$ItemIcon, {
                            reference: reference,
                            intl: intl
                        }),
                        href: reference.url,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onClick: ()=>handleLocationClick(),
                        children: /*#__PURE__*/ (0, $dc70d.jsx)($16c16b43c4da4354$var$ItemTitle, {
                            title: title,
                            formatMessage: formatMessage,
                            onSameDocument: reference.onSameDocument,
                            isSource: reference.isSource,
                            hasAccess: reference.hasAccess,
                            productType: reference.productType
                        })
                    }, reference.title)
                })
            }, (0, $3y2s4.isExperimentEnabled)('platform_editor_blocks_patch_11') ? `${reference.sourceAri}#${index}` : reference.title);
        })
    });
};
const $16c16b43c4da4354$var$FieldAwareItemTitle = ({ item: { baseTitle: baseTitle, fieldName: fieldName, note: note, reference: reference }, formatMessage: formatMessage })=>{
    const titleLine = /*#__PURE__*/ (0, $dc70d.jsxs)((0, $fZ0ZI.Inline), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                as: "span",
                xcss: $16c16b43c4da4354$var$styles.title,
                children: baseTitle
            }),
            note && /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9PwDt.Box), {
                as: "span",
                xcss: $16c16b43c4da4354$var$styles.note,
                children: [
                    "\xa0- ",
                    note
                ]
            }),
            reference.isSource && /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                as: "span",
                xcss: $16c16b43c4da4354$var$styles.lozenge,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $1emO3.default), {
                    children: formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownSourceLozenge)
                })
            }),
            !reference.hasAccess && /*#__PURE__*/ (0, $dc70d.jsx)($16c16b43c4da4354$var$NoAccessIndicator, {
                formatMessage: formatMessage
            })
        ]
    });
    if (fieldName === undefined) return titleLine;
    // AGG localises the field name, so it is shown as given rather than wrapped in a message.
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dDEhr.Stack), {
        children: [
            titleLine,
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                as: "span",
                xcss: $16c16b43c4da4354$var$styles.fieldSecondLine,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                    size: "small",
                    color: "color.text.subtlest",
                    children: fieldName
                })
            })
        ]
    });
};
const $16c16b43c4da4354$var$FieldAwareLocationRows = ({ items: items, intl: intl, handleLocationClick: handleLocationClick })=>{
    const { formatMessage: formatMessage } = intl;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Fragment), {
        children: items.map((item)=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
                className: (0, $9fU1q.default)([
                    "_2ll012x7"
                ]),
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $lavtv.default), {
                    content: item.fieldName ? // Two lines in the tooltip's own text flow. Wrapping them in `Text` would
                    // default to `font.body` and override the container's `font.body.small`,
                    // so the field-aware tooltip would not match every other one.
                    /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
                        children: [
                            item.baseTitle,
                            /*#__PURE__*/ (0, $dc70d.jsx)("br", {}),
                            formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownTooltipFieldName, {
                                fieldName: item.fieldName
                            })
                        ]
                    }) : item.baseTitle,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $ag7mU.default), {
                        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)($16c16b43c4da4354$var$ItemIcon, {
                            reference: item.reference,
                            intl: intl
                        }),
                        href: item.reference.url,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onClick: ()=>handleLocationClick(),
                        children: /*#__PURE__*/ (0, $dc70d.jsx)($16c16b43c4da4354$var$FieldAwareItemTitle, {
                            item: item,
                            formatMessage: formatMessage
                        })
                    })
                })
            }, item.key))
    });
};
const $16c16b43c4da4354$var$LoadingScreen = ({ formatMessage: formatMessage })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hDkm2.default), {
            label: formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownLoading)
        })
    });
};
const $16c16b43c4da4354$var$ErrorScreen = ({ formatMessage: formatMessage })=>{
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9PwDt.Box), {
        xcss: $16c16b43c4da4354$var$styles.errorContainer,
        testId: "synced-locations-dropdown-content-error",
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                xcss: $16c16b43c4da4354$var$styles.errorIcon,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
                    color: "var(--ds-icon-danger, #C9372C)",
                    spacing: "spacious",
                    label: "",
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                as: "p",
                size: "medium",
                children: formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownError)
            })
        ]
    });
};
const $16c16b43c4da4354$var$NoResultScreen = ({ formatMessage: formatMessage })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        xcss: $16c16b43c4da4354$var$styles.activationNoResultsContainer,
        testId: "synced-locations-dropdown-content-no-results",
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dDEhr.Stack), {
            alignInline: "center",
            xcss: $16c16b43c4da4354$var$styles.activationNoResultsContent,
            space: "space.150",
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $cfdfI.SyncedLocationsEmptyStateIllustration), {}),
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                    as: "p",
                    children: formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownActivationNoResults)
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                    as: "p",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $bLXMw.Anchor), {
                        href: (0, $bUkfH.SYNCED_BLOCKS_DOCUMENTATION_URL),
                        target: "_blank",
                        rel: "noopener noreferrer",
                        xcss: $16c16b43c4da4354$var$styles.learnMoreLink,
                        children: formatMessage((0, $9dhQr.syncBlockMessages).syncedLocationDropdownLearnMoreLink)
                    })
                })
            ]
        })
    });
};

});
parcelRegister("cfdfI", function(module, exports) {
$parcel$export(module.exports, "SyncedLocationsEmptyStateIllustration", () => $135a66150a7eabf1$export$bc90f0a575a3d90f);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $ceb9s = parcelRequire("ceb9s");
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Figma specifies this fixed illustration color, which has no semantic token equivalent across themes.
const $135a66150a7eabf1$var$arrowFill = '#8C8F97';
const $135a66150a7eabf1$export$bc90f0a575a3d90f = ()=>{
    const { colorMode: colorMode } = (0, $ceb9s.useThemeObserver)();
    const placeholderFill = colorMode === 'dark' ? "var(--ds-surface-overlay-pressed, #DDDEE1)" : "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
    return /*#__PURE__*/ (0, $dc70d.jsxs)("svg", {
        width: "274",
        height: "92",
        viewBox: "0 0 274 92",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false",
        "data-testid": "synced-locations-empty-state-illustration",
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                x: "0.41416",
                y: "0.41416",
                width: "115.965",
                height: "90.2868",
                rx: "2.89912",
                stroke: "var(--ds-border, #0B120E24)",
                strokeWidth: "0.82832"
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                x: "10.7681",
                y: "38.1016",
                width: "30.0956",
                height: "21.0056",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                x: "43.3486",
                y: "38.1016",
                width: "30.0956",
                height: "21.0056",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                x: "75.9292",
                y: "38.1016",
                width: "30.0956",
                height: "21.0056",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                d: "M10.8154 26.5352H77.1144V29.1609H10.8154V26.5352Z",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                d: "M7.45483 69.5781H110.166V72.0631H7.45483V69.5781Z",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                d: "M7.45483 75.3789H110.166V77.8639H7.45483V75.3789Z",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                d: "M7.45483 81.1719H82.0036V83.6568H7.45483V81.1719Z",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                x: "10.8154",
                y: "31.7891",
                width: "17.7235",
                height: "2.6257",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                x: "6.95492",
                y: "22.6954",
                width: "102.884",
                height: "40.7596",
                rx: "0.984638",
                stroke: "var(--ds-border-focused, #4688EC)",
                strokeWidth: "0.656425"
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                x: "81.5023",
                y: "20.707",
                width: "22.5506",
                height: "4.96992",
                rx: "0.82832",
                fill: "var(--ds-surface-overlay, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                d: "M85.2556 22.4161C85.2556 22.3732 85.2208 22.3384 85.1779 22.3384H83.6248C83.5819 22.3384 83.5472 22.3732 83.5472 22.4161V23.9692C83.5472 24.0121 83.5819 24.0468 83.6248 24.0468H84.0908V24.2798H83.6248C83.4533 24.2798 83.3142 24.1407 83.3142 23.9692V22.4161C83.3142 22.2445 83.4533 22.1055 83.6248 22.1055H85.1779C85.3495 22.1055 85.4885 22.2445 85.4885 22.4161V22.7267H85.2556V22.4161Z",
                fill: "var(--ds-icon-subtle, #505258)"
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                d: "M85.4732 23.3029C85.7006 23.5303 85.7006 23.8991 85.4732 24.1266L85.4692 24.1305L85.5375 24.1533C85.5887 24.1704 85.6215 24.2205 85.6166 24.2743C85.6118 24.3281 85.5706 24.3715 85.5171 24.3791L85.1328 24.434C85.0965 24.4392 85.0598 24.427 85.0339 24.4011C85.008 24.3752 84.9958 24.3385 85.001 24.3022L85.0559 23.9179L85.0603 23.8985C85.0745 23.8547 85.1136 23.8226 85.1607 23.8184C85.2145 23.8135 85.2647 23.8463 85.2818 23.8976L85.3045 23.9658L85.3084 23.9619C85.4449 23.8254 85.4449 23.604 85.3084 23.4676L85.1986 23.3578L85.3633 23.1931L85.4732 23.3029ZM84.8801 22.9954C84.9164 22.9902 84.9531 23.0024 84.979 23.0283C85.0049 23.0543 85.0171 23.0909 85.0119 23.1272L84.957 23.5116C84.9494 23.565 84.906 23.6062 84.8522 23.6111C84.7984 23.6159 84.7483 23.5831 84.7312 23.5319L84.7084 23.4636L84.7045 23.4676C84.568 23.604 84.568 23.8254 84.7045 23.9619L84.8143 24.0717L84.6496 24.2364L84.5398 24.1266C84.3123 23.8991 84.3123 23.5303 84.5398 23.3029L84.5437 23.2989L84.4755 23.2762C84.4242 23.2591 84.3914 23.2089 84.3963 23.1551C84.4012 23.1013 84.4423 23.058 84.4958 23.0503L84.8801 22.9954Z",
                fill: "var(--ds-icon-subtle, #505258)"
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                x: "86.4723",
                y: "22.1289",
                width: "15.9241",
                height: "2.12321",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                x: "7.53369",
                y: "5.53516",
                width: "47.2626",
                height: "3.93855",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                x: "24.8138",
                y: "14.1758",
                width: "14.4003",
                height: "1.92004",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("circle", {
                cx: "10.8929",
                cy: "14.654",
                r: "2.23595",
                fill: placeholderFill,
                stroke: "var(--ds-surface-overlay, #FFFFFF)",
                strokeWidth: "0.328213"
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("circle", {
                cx: "14.7333",
                cy: "14.654",
                r: "2.23595",
                fill: placeholderFill,
                stroke: "var(--ds-surface-overlay, #FFFFFF)",
                strokeWidth: "0.328213"
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("circle", {
                cx: "18.5736",
                cy: "14.654",
                r: "2.23595",
                fill: placeholderFill,
                stroke: "var(--ds-surface-overlay, #FFFFFF)",
                strokeWidth: "0.328213"
            }),
            /*#__PURE__*/ (0, $dc70d.jsxs)("g", {
                clipPath: "url(#synced-locations-arrow-clip)",
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                        d: "M153.151 39.5728C153.137 39.1517 151.895 38.7634 151.646 39.1155C151.294 39.6114 151.022 40.1671 150.803 40.9126C150.623 41.7746 150.828 42.0572 150.641 42.6134C150.509 43.089 150.24 43.7061 149.966 44.1967C149.692 44.691 149.411 45.0135 149.31 45.0811C149.281 45.1129 149.261 45.1394 149.246 45.1633C149.238 45.1894 149.22 45.2245 149.202 45.2719C149.184 45.291 149.164 45.3581 149.148 45.3734C149.109 45.4351 149.127 45.4725 148.993 45.5143C148.863 45.5572 148.58 45.5552 148.251 45.4788C147.924 45.4073 147.563 45.2853 147.215 45.1309C146.212 44.7559 145.565 44.449 145.235 44.3075C144.446 43.9591 143.8 43.8021 143.114 43.7547C142.737 43.7292 142.255 44.7498 142.515 45.0242C142.993 45.5205 143.531 45.9211 144.335 46.2984C144.655 46.4366 145.166 47.0275 146.147 47.4648C146.309 47.5326 146.478 47.578 146.665 47.5883C147.458 47.6306 148.351 47.8436 149.302 47.7055C149.781 47.6314 150.2 47.4182 150.458 47.2428C150.575 47.1475 150.67 47.0703 150.733 47.02C150.798 46.9661 150.823 46.9369 150.823 46.9369C150.823 46.9369 150.865 46.8886 150.938 46.8048C151.02 46.7195 151.104 46.5984 151.209 46.4471C151.407 46.1448 151.612 45.7354 151.767 45.3155C152.088 44.4704 152.337 43.5357 152.495 42.983C152.722 42.1549 152.83 41.7576 152.899 41.5105C153.099 40.7718 153.164 40.1758 153.145 39.5792L153.151 39.5728Z",
                        fill: $135a66150a7eabf1$var$arrowFill
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                        d: "M122.093 51.2051C122.362 52.3321 123.634 52.0495 123.655 51.0274C123.691 49.5646 123.763 48.06 124.288 46.2549C124.363 46.0014 124.43 45.7703 124.493 45.5579C124.524 45.4498 124.546 45.347 124.571 45.249C124.599 45.152 124.638 45.0621 124.668 44.9738C124.789 44.6166 124.892 44.319 124.99 44.0401C125.239 43.5099 125.419 43.0202 125.904 42.4543C126 42.3327 126.1 42.2 126.203 42.0684C126.323 41.9497 126.445 41.8236 126.572 41.6948C126.698 41.5697 126.829 41.4383 126.961 41.3069C127.092 41.1754 127.253 41.0688 127.399 40.9454C127.7 40.7058 127.999 40.4576 128.34 40.262C128.668 40.0545 128.989 39.8412 129.331 39.6824C129.99 39.3251 130.654 39.0906 131.194 38.8926C131.752 38.7406 132.176 38.5935 132.43 38.5547C132.577 38.5248 132.721 38.4863 132.865 38.4392C132.991 38.3953 133.171 38.3346 133.395 38.2588C133.627 38.2011 133.906 38.1331 134.224 38.0563C134.539 37.9624 134.906 37.9244 135.302 37.8582C135.697 37.7798 136.127 37.7641 136.581 37.7314C136.697 37.7247 136.808 37.7169 136.928 37.7076C137.045 37.7095 137.162 37.7113 137.283 37.7143C137.52 37.7191 137.765 37.7261 138.011 37.7294C138.259 37.7375 138.502 37.7802 138.755 37.8017C139.004 37.8343 139.264 37.8457 139.513 37.9066C139.765 37.9601 140.017 38.0098 140.269 38.0633C140.522 38.1093 140.764 38.2086 141.01 38.2807C141.509 38.4148 141.971 38.635 142.431 38.8345C142.76 38.9675 143.038 39.1502 143.325 39.2909C143.613 39.4278 143.855 39.6082 144.092 39.7667C144.58 40.0635 144.95 40.4149 145.293 40.6974C145.943 41.3089 146.377 41.8043 146.636 42.1759C147.917 43.8828 148.559 45.4067 149.143 46.9622C149.466 47.8095 150.591 47.6859 150.514 46.676C150.477 46.2238 150.46 45.7574 150.339 45.3009C150.285 45.0706 150.233 44.8328 150.18 44.5987C150.128 44.361 150.066 44.1162 149.966 43.8802C149.623 42.9218 149.158 41.8867 148.375 40.8682C148.217 40.6762 148.066 40.3892 147.825 40.0957C147.579 39.8011 147.315 39.4322 146.969 39.0516C146.788 38.8689 146.593 38.6782 146.389 38.4767C146.284 38.3773 146.177 38.2731 146.066 38.1678C145.95 38.0688 145.827 37.9762 145.702 37.8788C145.45 37.6877 145.182 37.4836 144.897 37.2827C144.601 37.1067 144.285 36.9253 143.958 36.7444C143.748 36.6181 143.52 36.5269 143.293 36.4443C143.066 36.3616 142.834 36.2853 142.604 36.2139C140.599 35.6384 138.269 35.4412 136.47 35.5293C135.569 35.5525 134.8 35.6753 134.253 35.7335C133.709 35.8333 133.392 35.8941 133.392 35.8941C133.392 35.8941 133.271 35.9194 133.06 35.9628C132.844 35.9965 132.543 36.0985 132.168 36.2032C131.982 36.258 131.774 36.3185 131.558 36.3805C131.344 36.4596 131.113 36.5455 130.875 36.6378C130.637 36.7338 130.378 36.8158 130.128 36.9368C129.874 37.0568 129.614 37.183 129.351 37.3082C129.081 37.4275 128.822 37.5821 128.557 37.7393C128.296 37.8976 128.022 38.044 127.766 38.2157C127.265 38.5831 126.738 38.9183 126.3 39.3363C126.075 39.5375 125.843 39.7205 125.642 39.9246C125.443 40.1334 125.254 40.337 125.068 40.5294C124.882 40.7218 124.709 40.9101 124.57 41.1081C124.425 41.3003 124.287 41.4824 124.157 41.6469C123.956 41.8915 123.806 42.1428 123.667 42.3814C123.525 42.619 123.391 42.8389 123.266 43.0451C123.041 43.4688 122.884 43.8519 122.73 44.171C122.568 44.4878 122.501 44.784 122.41 45.0283C122.33 45.2721 122.261 45.4787 122.201 45.6554C121.577 47.8403 121.729 49.6415 122.093 51.2051Z",
                        fill: $135a66150a7eabf1$var$arrowFill
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                x: "157.621",
                y: "0.41416",
                width: "115.965",
                height: "90.2868",
                rx: "2.89912",
                stroke: "var(--ds-border, #0B120E24)",
                strokeWidth: "0.82832"
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                x: "167.975",
                y: "51.3594",
                width: "30.0956",
                height: "21.0056",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                x: "200.556",
                y: "51.3594",
                width: "30.0956",
                height: "21.0056",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                x: "233.136",
                y: "51.3594",
                width: "30.0956",
                height: "21.0056",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                d: "M168.022 39.7891H234.321V42.4148H168.022V39.7891Z",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                d: "M164.661 19.8789H267.373V22.3639H164.661V19.8789Z",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                d: "M164.661 25.6719H267.373V28.1568H164.661V25.6719Z",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                x: "168.022",
                y: "45.0391",
                width: "17.7235",
                height: "2.6257",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                x: "164.161",
                y: "35.9454",
                width: "102.884",
                height: "40.7596",
                rx: "0.984638",
                stroke: "var(--ds-border-focused, #4688EC)",
                strokeWidth: "0.656425"
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                x: "238.709",
                y: "33.9648",
                width: "22.5506",
                height: "4.96992",
                rx: "0.82832",
                fill: "var(--ds-surface-overlay, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                d: "M242.463 35.6739C242.463 35.631 242.428 35.5962 242.385 35.5962H240.832C240.789 35.5962 240.754 35.631 240.754 35.6739V37.227C240.754 37.2699 240.789 37.3047 240.832 37.3047H241.298V37.5376H240.832C240.66 37.5376 240.521 37.3986 240.521 37.227V35.6739C240.521 35.5024 240.66 35.3633 240.832 35.3633H242.385C242.557 35.3633 242.696 35.5024 242.696 35.6739V35.9845H242.463V35.6739Z",
                fill: "var(--ds-icon-subtle, #505258)"
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                d: "M242.68 36.5607C242.908 36.7881 242.908 37.1569 242.68 37.3844L242.676 37.3883L242.745 37.4111C242.796 37.4282 242.829 37.4783 242.824 37.5321C242.819 37.5859 242.778 37.6293 242.724 37.6369L242.34 37.6918C242.304 37.697 242.267 37.6848 242.241 37.6589C242.215 37.633 242.203 37.5963 242.208 37.56L242.263 37.1757L242.267 37.1563C242.282 37.1125 242.321 37.0805 242.368 37.0762C242.422 37.0714 242.472 37.1041 242.489 37.1554L242.512 37.2236L242.516 37.2197C242.652 37.0832 242.652 36.8619 242.516 36.7254L242.406 36.6156L242.571 36.4509L242.68 36.5607ZM242.087 36.2532C242.124 36.2481 242.16 36.2602 242.186 36.2862C242.212 36.3121 242.224 36.3487 242.219 36.385L242.164 36.7694C242.157 36.8228 242.113 36.864 242.059 36.8689C242.006 36.8737 241.955 36.8409 241.938 36.7897L241.916 36.7214L241.912 36.7254C241.775 36.8619 241.775 37.0832 241.912 37.2197L242.021 37.3295L241.857 37.4942L241.747 37.3844C241.519 37.1569 241.519 36.7881 241.747 36.5607L241.751 36.5567L241.683 36.534C241.631 36.5169 241.599 36.4668 241.603 36.4129C241.608 36.3592 241.649 36.3158 241.703 36.3081L242.087 36.2532Z",
                fill: "var(--ds-icon-subtle, #505258)"
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                x: "243.679",
                y: "35.3867",
                width: "15.9241",
                height: "2.12321",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                x: "164.74",
                y: "11.332",
                width: "47.2626",
                height: "3.93855",
                fill: placeholderFill
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dc70d.jsx)("clipPath", {
                    id: "synced-locations-arrow-clip",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                        width: "20.9549",
                        height: "28.3348",
                        transform: "translate(120.479 51.5039) rotate(-73.6651)"
                    })
                })
            })
        ]
    });
};

});



parcelRegister("92Ghi", function(module, exports) {
$parcel$export(module.exports, "getQuickInsertConfig", () => $16c3d57187b02110$export$69e699948916d30c);
/* quick-insert.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5BUNL = parcelRequire("5BUNL");

var $8iYGb = parcelRequire("8iYGb");

var $1emO3 = parcelRequire("1emO3");

var $gdUUy = parcelRequire("gdUUy");

var $8hQqt = parcelRequire("8hQqt");

var $7II9i = parcelRequire("7II9i");
const $16c3d57187b02110$var$lozengeWrapperStyles = null;
const $16c3d57187b02110$export$69e699948916d30c = (config, api, syncBlockStore)=>{
    return ({ formatMessage: formatMessage })=>{
        if (!(config !== null && config !== void 0 && config.enableSourceCreation)) return [];
        return [
            {
                id: 'syncBlock',
                title: formatMessage((0, $8iYGb.messages).syncedBlockQuickInsertTitle),
                description: formatMessage((0, $8iYGb.messages).syncedBlockDescription),
                priority: 400,
                keywords: [
                    'synced',
                    'block',
                    'synced-block',
                    'sync',
                    'sync-block',
                    'auto',
                    'update',
                    'excerpt',
                    'connect',
                    'create'
                ],
                isDisabledOffline: true,
                keyshortcut: '',
                lozenge: /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                    className: (0, $9fU1q.default)([
                        "_1o9zidpf _16jlidpf _1e0c116y"
                    ]),
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $1emO3.default), {
                        appearance: (0, $gdUUy.fg)('confluence_fronend_labels_categorization_migration') ? 'discovery' : 'new',
                        children: formatMessage((0, $8iYGb.messages).newLozenge)
                    })
                }),
                icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5BUNL.IconSyncBlock), {
                        label: formatMessage((0, $8iYGb.messages).syncedBlockQuickInsertTitle)
                    }),
                action: (insert, state)=>{
                    var _api$analytics;
                    return (0, $8hQqt.createSyncedBlock)({
                        tr: state.tr,
                        syncBlockStore: syncBlockStore,
                        typeAheadInsert: insert,
                        fireAnalyticsEvent: api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions.fireAnalyticsEvent,
                        inputMethod: (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT
                    });
                },
                testId: (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).quickInsertCreate
            }
        ];
    };
};

});

parcelRegister("aZBxC", function(module, exports) {
$parcel$export(module.exports, "getSyncedBlockQuickInsertComponents", () => $3fadec2449e9b8eb$export$90150d61f16ca941);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $8iYGb = parcelRequire("8iYGb");

var $b8Hvx = parcelRequire("b8Hvx");

var $9woaI = parcelRequire("9woaI");

var $am2Qg = parcelRequire("am2Qg");

var $gB3IU = parcelRequire("gB3IU");
const $3fadec2449e9b8eb$var$previewImageUrls = {
    light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKD.png',
    dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVH3.png'
};
const $3fadec2449e9b8eb$export$90150d61f16ca941 = ({ api: api, syncBlockStore: syncBlockStore })=>[
        {
            key: (0, $9woaI.SYNCED_BLOCK_MENU_ITEM).key,
            type: (0, $9woaI.SYNCED_BLOCK_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $9woaI.STRUCTURE_SECTION).key,
                    type: (0, $9woaI.STRUCTURE_SECTION).type,
                    rank: (0, $am2Qg.STRUCTURE_SECTION_RANK)[(0, $9woaI.SYNCED_BLOCK_MENU_ITEM).key]
                }
            ],
            match: (0, $b8Hvx.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $8iYGb.messages).syncedBlockDescription),
                    keywords: [
                        'synced',
                        'block',
                        'synced-block',
                        'sync',
                        'sync-block',
                        'auto',
                        'update',
                        'excerpt',
                        'connect',
                        'create'
                    ],
                    shortcut: '',
                    title: formatMessage((0, $8iYGb.messages).syncedBlockQuickInsertTitle)
                })),
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $gB3IU.SyncedBlockQuickInsertMenuItem), {
                    api: api,
                    previewImageUrls: $3fadec2449e9b8eb$var$previewImageUrls,
                    syncBlockStore: syncBlockStore
                })
        }
    ];

});
parcelRegister("gB3IU", function(module, exports) {
$parcel$export(module.exports, "SyncedBlockQuickInsertMenuItem", () => $3504c5252fdf7f82$export$eab12d03f28497e4);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $8iYGb = parcelRequire("8iYGb");

var $fT9mF = parcelRequire("fT9mF");

var $64eKJ = parcelRequire("64eKJ");

var $5beht = parcelRequire("5beht");

var $539NH = parcelRequire("539NH");

var $1emO3 = parcelRequire("1emO3");

var $8hQqt = parcelRequire("8hQqt");
const $3504c5252fdf7f82$export$eab12d03f28497e4 = ({ api: api, previewImageUrls: previewImageUrls, syncBlockStore: syncBlockStore })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const preview = (0, $bSJIT.useMemo)(()=>previewImageUrls ? {
            image: previewImageUrls,
            attribution: {
                name: formatMessage((0, $64eKJ.messages).previewAttributionAtlassian)
            }
        } : undefined, [
        formatMessage,
        previewImageUrls
    ]);
    const { editorDisabled: editorDisabled } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'editorDisabled'
    ], (states)=>{
        var _states$editorDisable;
        return {
            editorDisabled: (_states$editorDisable = states.editorDisabledState) === null || _states$editorDisable === void 0 ? void 0 : _states$editorDisable.editorDisabled
        };
    });
    const onSelect = (0, $bSJIT.useCallback)(({ editorView: editorView, insert: insert, source: source })=>{
        var _api$analytics;
        return (0, $8hQqt.createSyncedBlock)({
            tr: editorView.state.tr,
            syncBlockStore: syncBlockStore,
            typeAheadInsert: insert,
            fireAnalyticsEvent: api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions.fireAnalyticsEvent,
            inputMethod: source ?? (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT
        });
    }, [
        api,
        syncBlockStore
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fT9mF.QuickInsertMenuItem), {
        description: formatMessage((0, $8iYGb.messages).syncedBlockDescription),
        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($539NH))), {
            label: ""
        }),
        isDisabled: editorDisabled,
        lozenge: /*#__PURE__*/ (0, $dc70d.jsx)((0, $1emO3.default), {
            appearance: "new",
            children: formatMessage((0, $8iYGb.messages).newLozenge)
        }),
        onSelect: onSelect,
        preview: preview,
        title: formatMessage((0, $8iYGb.messages).syncedBlockQuickInsertTitle)
    });
};

});


parcelRegister("aXxXZ", function(module, exports) {
$parcel$export(module.exports, "SourceSyncBlockPlaceholder", () => $493aa5390c7913b2$export$286cc38c7d222ebf);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $4vLTk = parcelRequire("4vLTk");

var $4fPJw = parcelRequire("4fPJw");

var $7VlAB = parcelRequire("7VlAB");
const $493aa5390c7913b2$var$getSourceSyncBlockPlaceholderStyles = (placeholderText)=>/*#__PURE__*/ (0, $9dQre.css)({
        // Emptiness is signalled by the node view via the `empty` class, which is derived from the
        // ProseMirror document. Keeping this visual state in CSS means typing, deletion, undo/redo,
        // and remote changes update it without decorations.
        //
        // This deliberately does NOT inspect the rendered DOM shape. The paragraph inside an empty
        // block routinely gains extra children that are not user content — the selection marker's
        // cursor widget (`.ProseMirror-widget`), ProseMirror's `.ProseMirror-separator` hack node,
        // and the `.ProseMirror-trailingBreak`. An earlier `:has(.ProseMirror-trailingBreak:only-child)`
        // form treated those decorations as content and hid the placeholder whenever the user placed
        // a cursor in the block and then blurred the editor. See EDITOR-8327.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`.ProseMirror .${(0, $7VlAB.BodiedSyncBlockSharedCssClassName).prefix}.${(0, $7VlAB.BodiedSyncBlockSharedCssClassName).empty} .${(0, $7VlAB.BodiedSyncBlockSharedCssClassName).content}[contenteditable="true"] > p:only-child`]: {
            position: 'relative',
            '&::before': {
                // JSON.stringify produces a quoted and escaped CSS string.
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                content: placeholderText,
                position: 'absolute',
                boxSizing: 'border-box',
                color: "var(--ds-text-subtlest, #6B6E76)",
                font: 'inherit',
                insetInlineStart: 0,
                width: '100%',
                overflow: 'hidden',
                pointerEvents: 'none',
                textOverflow: 'ellipsis',
                userSelect: 'none',
                whiteSpace: 'nowrap'
            }
        }
    });
const $493aa5390c7913b2$export$286cc38c7d222ebf = ()=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const placeholderStyles = (0, $bSJIT.useMemo)(()=>$493aa5390c7913b2$var$getSourceSyncBlockPlaceholderStyles(JSON.stringify(formatMessage((0, $4fPJw.placeholderTextMessages).sourceSyncBlockPlaceholderText))), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $9dQre.Global), {
        styles: placeholderStyles
    });
};

});

parcelRegister("dEpXg", function(module, exports) {
$parcel$export(module.exports, "SyncBlockRefresher", () => $ff623dacbc63e7da$export$f8d6f80345184030);

var $bSJIT = parcelRequire("bSJIT");

var $hVGJk = parcelRequire("hVGJk");

var $5beht = parcelRequire("5beht");
const $ff623dacbc63e7da$export$f8d6f80345184030 = ({ syncBlockStoreManager: syncBlockStoreManager, api: api })=>{
    const { mode: mode } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'connectivity'
    ], (states)=>{
        var _states$connectivityS;
        return {
            mode: (_states$connectivityS = states.connectivityState) === null || _states$connectivityS === void 0 ? void 0 : _states$connectivityS.mode
        };
    });
    const isOnline = !(0, $hVGJk.isOfflineMode)(mode);
    (0, $bSJIT.useEffect)(()=>{
        const useRealTimeSubscriptions = isOnline;
        syncBlockStoreManager.referenceManager.setRealTimeSubscriptionsEnabled(useRealTimeSubscriptions);
    }, [
        syncBlockStoreManager,
        isOnline
    ]);
    return null;
};

});

parcelRegister("2QOlj", function(module, exports) {
$parcel$export(module.exports, "getToolbarComponents", () => $2da338877b58328e$export$a758406ca53b86a5);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $f6IUb = parcelRequire("f6IUb");

var $5gDEv = parcelRequire("5gDEv");

var $9FIyo = parcelRequire("9FIyo");
const $2da338877b58328e$var$SYNCED_BLOCK_PRIMARY_TOOLBAR_GROUP = {
    type: (0, $4rzOL.SYNCED_BLOCK_GROUP).type,
    key: (0, $4rzOL.SYNCED_BLOCK_GROUP).key,
    component: ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $f6IUb.Show), {
            above: "md",
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5gDEv.ToolbarButtonGroup), {
                children: children
            })
        }),
    parents: [
        {
            type: (0, $4rzOL.INSERT_BLOCK_SECTION).type,
            key: (0, $4rzOL.INSERT_BLOCK_SECTION).key,
            rank: (0, $fiku8.INSERT_BLOCK_SECTION_RANK)[(0, $4rzOL.SYNCED_BLOCK_GROUP).key]
        }
    ]
};
const $2da338877b58328e$export$a758406ca53b86a5 = (api, enableSourceSyncedBlockCreation)=>{
    if (!enableSourceSyncedBlockCreation) return [];
    return [
        $2da338877b58328e$var$SYNCED_BLOCK_PRIMARY_TOOLBAR_GROUP,
        {
            type: (0, $4rzOL.SYNCED_BLOCK_BUTTON).type,
            key: (0, $4rzOL.SYNCED_BLOCK_BUTTON).key,
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $9FIyo.CreateSyncedBlockButton), {
                    api: api
                }),
            parents: [
                {
                    type: (0, $4rzOL.SYNCED_BLOCK_GROUP).type,
                    key: (0, $4rzOL.SYNCED_BLOCK_GROUP).key,
                    rank: (0, $fiku8.SYNCED_BLOCK_SECTION_RANK)[(0, $4rzOL.SYNCED_BLOCK_BUTTON).key]
                }
            ]
        }
    ];
};

});
parcelRegister("9FIyo", function(module, exports) {
$parcel$export(module.exports, "CreateSyncedBlockButton", () => $d1ac41d2ba769044$export$954568e298a26ab0);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $hVGJk = parcelRequire("hVGJk");

var $9dhQr = parcelRequire("9dhQr");

var $5beht = parcelRequire("5beht");

var $7cgYb = parcelRequire("7cgYb");

var $eHnl8 = parcelRequire("eHnl8");

var $539NH = parcelRequire("539NH");

var $QIBX2 = parcelRequire("QIBX2");

var $7II9i = parcelRequire("7II9i");
const $d1ac41d2ba769044$export$954568e298a26ab0 = ({ api: api })=>{
    const intl = (0, $4vLTk.default)();
    const { selection: selection, mode: mode } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'selection',
        'connectivity'
    ], (states)=>{
        var _states$selectionStat, _states$connectivityS;
        return {
            selection: (_states$selectionStat = states.selectionState) === null || _states$selectionStat === void 0 ? void 0 : _states$selectionStat.selection,
            mode: (_states$connectivityS = states.connectivityState) === null || _states$connectivityS === void 0 ? void 0 : _states$connectivityS.mode
        };
    });
    // for toolbar button, we allow both creating a new synced block
    // and converting existing block to synced block
    const canBeConverted = Boolean(selection && (0, $QIBX2.canBeConvertedToSyncBlock)(selection));
    const canInsertEmptyBlock = Boolean(selection === null || selection === void 0 ? void 0 : selection.empty);
    const isDisabled = Boolean((0, $hVGJk.isOfflineMode)(mode) || !canBeConverted && !canInsertEmptyBlock);
    const onClick = (0, $bSJIT.useCallback)(()=>{
        var _api$core;
        // Insert the synced block and stop preserving the selection in a single
        // transaction so the caret that insertSyncedBlock places inside the new
        // block survives (EDITOR-7949). The toolbar is not normally opened via the
        // block menu, but stopping preservation is defensive and keeps behaviour
        // consistent with the block-menu create item should preservation ever be
        // active (e.g. a block is selected via block-controls). Then re-focus so
        // the caret is active, but only when the transaction was actually
        // dispatched — otherwise a failed insertion would still steal DOM focus
        // into the editor (mirrors CreateSyncedBlockDropdownItem).
        const dispatched = api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 ? void 0 : _api$core.actions.execute(({ tr: tr })=>{
            var _api$blockControls;
            const result = api === null || api === void 0 ? void 0 : api.syncedBlock.commands.insertSyncedBlock((0, $g6Qq4.INPUT_METHOD).SYNCED_BLOCK_TB)({
                tr: tr
            });
            if (!result) return null;
            api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || (_api$blockControls = _api$blockControls.commands) === null || _api$blockControls === void 0 || _api$blockControls.stopPreservingSelection()({
                tr: tr
            });
            return tr;
        });
        if (dispatched) {
            var _api$core2;
            api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 || _api$core2.actions.focus();
        }
    }, [
        api
    ]);
    const message = intl.formatMessage((0, $9dhQr.syncBlockMessages).syncBlockLabel);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
        content: message,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
            label: message,
            iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($539NH))), {
                size: "small",
                label: ""
            }),
            isDisabled: isDisabled,
            testId: (0, $7II9i.SYNCED_BLOCK_BUTTON_TEST_ID).primaryToolbarCreate,
            onClick: onClick
        })
    });
};

});





parcelRegister("l7wiA", function(module, exports) {
$parcel$export(module.exports, "shouldRecreatePreset", () => $7397ce833b51ff7b$export$79c7ce3012e5b8c8);
function $7397ce833b51ff7b$export$79c7ce3012e5b8c8(props, nextProps) {
    const properties = [
        'appearance',
        'persistScrollGutter',
        'allowUndoRedoButtons',
        'placeholder',
        'sanitizePrivateContent'
    ];
    return properties.reduce((acc, curr)=>acc || props[curr] !== nextProps[curr], false);
}

});



//# sourceMappingURL=shared.c80378a1.js.map
